const countryData = [{"id":1,"name":"Afghanistan","code":"AF","dial_code":"+93","currency_name":"Afghan afghani","currency_symbol":"\u060b","currency_code":"AFN","created_at":null,"updated_at":null,"name_with_symbole":"Afghan afghani - \u060b"},{"id":2,"name":"Aland Islands","code":"AX","dial_code":"+358","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:09.000000Z","name_with_symbole":" - "},{"id":3,"name":"Albania","code":"AL","dial_code":"+355","currency_name":"Albanian lek","currency_symbol":"L","currency_code":"ALL","created_at":null,"updated_at":null,"name_with_symbole":"Albanian lek - L"},{"id":4,"name":"Algeria","code":"DZ","dial_code":"+213","currency_name":"Algerian dinar","currency_symbol":"\u062f.\u062c","currency_code":"DZD","created_at":null,"updated_at":null,"name_with_symbole":"Algerian dinar - \u062f.\u062c"},{"id":5,"name":"AmericanSamoa","code":"AS","dial_code":"+1684","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":6,"name":"Andorra","code":"AD","dial_code":"+376","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":7,"name":"Angola","code":"AO","dial_code":"+244","currency_name":"Angolan kwanza","currency_symbol":"Kz","currency_code":"AOA","created_at":null,"updated_at":null,"name_with_symbole":"Angolan kwanza - Kz"},{"id":8,"name":"Anguilla","code":"AI","dial_code":"+1264","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":9,"name":"Antarctica","code":"AQ","dial_code":"+672","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":10,"name":"Antigua and Barbuda","code":"AG","dial_code":"+1268","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":11,"name":"Argentina","code":"AR","dial_code":"+54","currency_name":"Argentine peso","currency_symbol":"$","currency_code":"ARS","created_at":null,"updated_at":null,"name_with_symbole":"Argentine peso - $"},{"id":12,"name":"Armenia","code":"AM","dial_code":"+374","currency_name":"Armenian dram","currency_symbol":"","currency_code":"AMD","created_at":null,"updated_at":null,"name_with_symbole":"Armenian dram - "},{"id":13,"name":"Aruba","code":"AW","dial_code":"+297","currency_name":"Aruban florin","currency_symbol":"\u0192","currency_code":"AWG","created_at":null,"updated_at":null,"name_with_symbole":"Aruban florin - \u0192"},{"id":14,"name":"Australia","code":"AU","dial_code":"+61","currency_name":"Australian dollar","currency_symbol":"$","currency_code":"AUD","created_at":null,"updated_at":null,"name_with_symbole":"Australian dollar - $"},{"id":15,"name":"Austria","code":"AT","dial_code":"+43","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":16,"name":"Azerbaijan","code":"AZ","dial_code":"+994","currency_name":"Azerbaijani manat","currency_symbol":"","currency_code":"AZN","created_at":null,"updated_at":null,"name_with_symbole":"Azerbaijani manat - "},{"id":17,"name":"Bahamas","code":"BS","dial_code":"+1242","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":18,"name":"Bahrain","code":"BH","dial_code":"+973","currency_name":"Bahraini dinar","currency_symbol":".\u062f.\u0628","currency_code":"BHD","created_at":null,"updated_at":null,"name_with_symbole":"Bahraini dinar - .\u062f.\u0628"},{"id":19,"name":"Bangladesh","code":"BD","dial_code":"+880","currency_name":"Bangladeshi taka","currency_symbol":"\u09f3","currency_code":"BDT","created_at":null,"updated_at":null,"name_with_symbole":"Bangladeshi taka - \u09f3"},{"id":20,"name":"Barbados","code":"BB","dial_code":"+1246","currency_name":"Barbadian dollar","currency_symbol":"$","currency_code":"BBD","created_at":null,"updated_at":null,"name_with_symbole":"Barbadian dollar - $"},{"id":21,"name":"Belarus","code":"BY","dial_code":"+375","currency_name":"Belarusian ruble","currency_symbol":"Br","currency_code":"BYR","created_at":null,"updated_at":null,"name_with_symbole":"Belarusian ruble - Br"},{"id":22,"name":"Belgium","code":"BE","dial_code":"+32","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":23,"name":"Belize","code":"BZ","dial_code":"+501","currency_name":"Belize dollar","currency_symbol":"$","currency_code":"BZD","created_at":null,"updated_at":null,"name_with_symbole":"Belize dollar - $"},{"id":24,"name":"Benin","code":"BJ","dial_code":"+229","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":25,"name":"Bermuda","code":"BM","dial_code":"+1441","currency_name":"Bermudian dollar","currency_symbol":"$","currency_code":"BMD","created_at":null,"updated_at":null,"name_with_symbole":"Bermudian dollar - $"},{"id":26,"name":"Bhutan","code":"BT","dial_code":"+975","currency_name":"Bhutanese ngultrum","currency_symbol":"Nu.","currency_code":"BTN","created_at":null,"updated_at":null,"name_with_symbole":"Bhutanese ngultrum - Nu."},{"id":27,"name":"Bolivia, Plurination","code":"BO","dial_code":"+591","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":28,"name":"Bosnia and Herzegovi","code":"BA","dial_code":"+387","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":29,"name":"Botswana","code":"BW","dial_code":"+267","currency_name":"Botswana pula","currency_symbol":"P","currency_code":"BWP","created_at":null,"updated_at":null,"name_with_symbole":"Botswana pula - P"},{"id":30,"name":"Brazil","code":"BR","dial_code":"+55","currency_name":"Brazilian real","currency_symbol":"R$","currency_code":"BRL","created_at":null,"updated_at":null,"name_with_symbole":"Brazilian real - R$"},{"id":31,"name":"British Indian Ocean","code":"IO","dial_code":"+246","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":32,"name":"Brunei Darussalam","code":"BN","dial_code":"+673","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":33,"name":"Bulgaria","code":"BG","dial_code":"+359","currency_name":"Bulgarian lev","currency_symbol":"\u043b\u0432","currency_code":"BGN","created_at":null,"updated_at":null,"name_with_symbole":"Bulgarian lev - \u043b\u0432"},{"id":34,"name":"Burkina Faso","code":"BF","dial_code":"+226","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":35,"name":"Burundi","code":"BI","dial_code":"+257","currency_name":"Burundian franc","currency_symbol":"Fr","currency_code":"BIF","created_at":null,"updated_at":null,"name_with_symbole":"Burundian franc - Fr"},{"id":36,"name":"Cambodia","code":"KH","dial_code":"+855","currency_name":"Cambodian riel","currency_symbol":"\u17db","currency_code":"KHR","created_at":null,"updated_at":null,"name_with_symbole":"Cambodian riel - \u17db"},{"id":37,"name":"Cameroon","code":"CM","dial_code":"+237","currency_name":"Central African CFA ","currency_symbol":"Fr","currency_code":"XAF","created_at":null,"updated_at":null,"name_with_symbole":"Central African CFA  - Fr"},{"id":38,"name":"Canada","code":"CA","dial_code":"+1","currency_name":"Canadian dollar","currency_symbol":"$","currency_code":"CAD","created_at":null,"updated_at":null,"name_with_symbole":"Canadian dollar - $"},{"id":39,"name":"Cape Verde","code":"CV","dial_code":"+238","currency_name":"Cape Verdean escudo","currency_symbol":"Esc or $","currency_code":"CVE","created_at":null,"updated_at":null,"name_with_symbole":"Cape Verdean escudo - Esc or $"},{"id":40,"name":"Cayman Islands","code":"KY","dial_code":"+ 345","currency_name":"Cayman Islands dolla","currency_symbol":"$","currency_code":"KYD","created_at":null,"updated_at":null,"name_with_symbole":"Cayman Islands dolla - $"},{"id":41,"name":"Central African Repu","code":"CF","dial_code":"+236","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":42,"name":"Chad","code":"TD","dial_code":"+235","currency_name":"Central African CFA ","currency_symbol":"Fr","currency_code":"XAF","created_at":null,"updated_at":null,"name_with_symbole":"Central African CFA  - Fr"},{"id":43,"name":"Chile","code":"CL","dial_code":"+56","currency_name":"Chilean peso","currency_symbol":"$","currency_code":"CLP","created_at":null,"updated_at":null,"name_with_symbole":"Chilean peso - $"},{"id":44,"name":"China","code":"CN","dial_code":"+86","currency_name":"Chinese yuan","currency_symbol":"\u00a5","currency_code":"CNY","created_at":null,"updated_at":null,"name_with_symbole":"Chinese yuan - \u00a5"},{"id":45,"name":"Christmas Island","code":"CX","dial_code":"+61","currency_name":"","currency_symbol":"","currency_code":"AUD","created_at":null,"updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":46,"name":"Cocos (Keeling) Isla","code":"CC","dial_code":"+61","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":47,"name":"Colombia","code":"CO","dial_code":"+57","currency_name":"Colombian peso","currency_symbol":"$","currency_code":"COP","created_at":null,"updated_at":null,"name_with_symbole":"Colombian peso - $"},{"id":48,"name":"Comoros","code":"KM","dial_code":"+269","currency_name":"Comorian franc","currency_symbol":"Fr","currency_code":"KMF","created_at":null,"updated_at":null,"name_with_symbole":"Comorian franc - Fr"},{"id":49,"name":"Congo","code":"CG","dial_code":"+242","currency_name":"","currency_symbol":"","currency_code":"XAF","created_at":null,"updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":50,"name":"Congo, The Democrati","code":"CD","dial_code":"+243","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":51,"name":"Cook Islands","code":"CK","dial_code":"+682","currency_name":"New Zealand dollar","currency_symbol":"$","currency_code":"NZD","created_at":null,"updated_at":null,"name_with_symbole":"New Zealand dollar - $"},{"id":52,"name":"Costa Rica","code":"CR","dial_code":"+506","currency_name":"Costa Rican col\u00f3n","currency_symbol":"\u20a1","currency_code":"CRC","created_at":null,"updated_at":null,"name_with_symbole":"Costa Rican col\u00f3n - \u20a1"},{"id":53,"name":"Cote d'Ivoire","code":"CI","dial_code":"+225","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":54,"name":"Croatia","code":"HR","dial_code":"+385","currency_name":"Croatian kuna","currency_symbol":"kn","currency_code":"HRK","created_at":null,"updated_at":null,"name_with_symbole":"Croatian kuna - kn"},{"id":55,"name":"Cuba","code":"CU","dial_code":"+53","currency_name":"Cuban convertible pe","currency_symbol":"$","currency_code":"CUP","created_at":null,"updated_at":"2020-08-26T03:11:14.000000Z","name_with_symbole":"Cuban convertible pe - $"},{"id":56,"name":"Cyprus","code":"CY","dial_code":"+357","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":57,"name":"Czech Republic","code":"CZ","dial_code":"+420","currency_name":"Czech koruna","currency_symbol":"K\u010d","currency_code":"CZK","created_at":null,"updated_at":null,"name_with_symbole":"Czech koruna - K\u010d"},{"id":58,"name":"Denmark","code":"DK","dial_code":"+45","currency_name":"Danish krone","currency_symbol":"kr","currency_code":"DKK","created_at":null,"updated_at":null,"name_with_symbole":"Danish krone - kr"},{"id":59,"name":"Djibouti","code":"DJ","dial_code":"+253","currency_name":"Djiboutian franc","currency_symbol":"Fr","currency_code":"DJF","created_at":null,"updated_at":null,"name_with_symbole":"Djiboutian franc - Fr"},{"id":60,"name":"Dominica","code":"DM","dial_code":"+1767","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":61,"name":"Dominican Republic","code":"DO","dial_code":"+1849","currency_name":"Dominican peso","currency_symbol":"$","currency_code":"DOP","created_at":null,"updated_at":null,"name_with_symbole":"Dominican peso - $"},{"id":62,"name":"Ecuador","code":"EC","dial_code":"+593","currency_name":"United States dollar","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-19T20:32:46.000000Z","name_with_symbole":"United States dollar - $"},{"id":63,"name":"Egypt","code":"EG","dial_code":"+20","currency_name":"Egyptian pound","currency_symbol":"\u00a3 or \u062c.\u0645","currency_code":"EGP","created_at":null,"updated_at":null,"name_with_symbole":"Egyptian pound - \u00a3 or \u062c.\u0645"},{"id":64,"name":"El Salvador","code":"SV","dial_code":"+503","currency_name":"United States dollar","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-19T20:32:46.000000Z","name_with_symbole":"United States dollar - $"},{"id":65,"name":"Equatorial Guinea","code":"GQ","dial_code":"+240","currency_name":"Central African CFA ","currency_symbol":"Fr","currency_code":"XAF","created_at":null,"updated_at":null,"name_with_symbole":"Central African CFA  - Fr"},{"id":66,"name":"Eritrea","code":"ER","dial_code":"+291","currency_name":"Eritrean nakfa","currency_symbol":"Nfk","currency_code":"ERN","created_at":null,"updated_at":null,"name_with_symbole":"Eritrean nakfa - Nfk"},{"id":67,"name":"Estonia","code":"EE","dial_code":"+372","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":68,"name":"Ethiopia","code":"ET","dial_code":"+251","currency_name":"Ethiopian birr","currency_symbol":"Br","currency_code":"ETB","created_at":null,"updated_at":null,"name_with_symbole":"Ethiopian birr - Br"},{"id":69,"name":"Falkland Islands (Ma","code":"FK","dial_code":"+500","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":70,"name":"Faroe Islands","code":"FO","dial_code":"+298","currency_name":"Danish krone","currency_symbol":"kr","currency_code":"DKK","created_at":null,"updated_at":null,"name_with_symbole":"Danish krone - kr"},{"id":71,"name":"Fiji","code":"FJ","dial_code":"+679","currency_name":"Fijian dollar","currency_symbol":"$","currency_code":"FJD","created_at":null,"updated_at":null,"name_with_symbole":"Fijian dollar - $"},{"id":72,"name":"Finland","code":"FI","dial_code":"+358","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":73,"name":"France","code":"FR","dial_code":"+33","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":74,"name":"French Guiana","code":"GF","dial_code":"+594","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:16.000000Z","name_with_symbole":" - "},{"id":75,"name":"French Polynesia","code":"PF","dial_code":"+689","currency_name":"CFP franc","currency_symbol":"Fr","currency_code":"XPF","created_at":null,"updated_at":null,"name_with_symbole":"CFP franc - Fr"},{"id":76,"name":"Gabon","code":"GA","dial_code":"+241","currency_name":"Central African CFA ","currency_symbol":"Fr","currency_code":"XAF","created_at":null,"updated_at":null,"name_with_symbole":"Central African CFA  - Fr"},{"id":77,"name":"Gambia","code":"GM","dial_code":"+220","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":78,"name":"Georgia","code":"GE","dial_code":"+995","currency_name":"Georgian lari","currency_symbol":"\u10da","currency_code":"GEL","created_at":null,"updated_at":null,"name_with_symbole":"Georgian lari - \u10da"},{"id":79,"name":"Germany","code":"DE","dial_code":"+49","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":80,"name":"Ghana","code":"GH","dial_code":"+233","currency_name":"Ghana cedi","currency_symbol":"\u20b5","currency_code":"GHS","created_at":null,"updated_at":null,"name_with_symbole":"Ghana cedi - \u20b5"},{"id":81,"name":"Gibraltar","code":"GI","dial_code":"+350","currency_name":"Gibraltar pound","currency_symbol":"\u00a3","currency_code":"GIP","created_at":null,"updated_at":null,"name_with_symbole":"Gibraltar pound - \u00a3"},{"id":82,"name":"Greece","code":"GR","dial_code":"+30","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":83,"name":"Greenland","code":"GL","dial_code":"+299","currency_name":"","currency_symbol":"","currency_code":"DKK","created_at":null,"updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - "},{"id":84,"name":"Grenada","code":"GD","dial_code":"+1473","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":85,"name":"Guadeloupe","code":"GP","dial_code":"+590","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - "},{"id":86,"name":"Guam","code":"GU","dial_code":"+1671","currency_name":"","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - $"},{"id":87,"name":"Guatemala","code":"GT","dial_code":"+502","currency_name":"Guatemalan quetzal","currency_symbol":"Q","currency_code":"GTQ","created_at":null,"updated_at":null,"name_with_symbole":"Guatemalan quetzal - Q"},{"id":88,"name":"Guernsey","code":"GG","dial_code":"+44","currency_name":"British pound","currency_symbol":"\u00a3","currency_code":"GBP","created_at":null,"updated_at":null,"name_with_symbole":"British pound - \u00a3"},{"id":89,"name":"Guinea","code":"GN","dial_code":"+224","currency_name":"Guinean franc","currency_symbol":"Fr","currency_code":"GNF","created_at":null,"updated_at":null,"name_with_symbole":"Guinean franc - Fr"},{"id":90,"name":"Guinea-Bissau","code":"GW","dial_code":"+245","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":91,"name":"Guyana","code":"GY","dial_code":"+595","currency_name":"Guyanese dollar","currency_symbol":"$","currency_code":"GYD","created_at":null,"updated_at":null,"name_with_symbole":"Guyanese dollar - $"},{"id":92,"name":"Haiti","code":"HT","dial_code":"+509","currency_name":"Haitian gourde","currency_symbol":"G","currency_code":"HTG","created_at":null,"updated_at":null,"name_with_symbole":"Haitian gourde - G"},{"id":93,"name":"Holy See (Vatican Ci","code":"VA","dial_code":"+379","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":94,"name":"Honduras","code":"HN","dial_code":"+504","currency_name":"Honduran lempira","currency_symbol":"L","currency_code":"HNL","created_at":null,"updated_at":null,"name_with_symbole":"Honduran lempira - L"},{"id":95,"name":"Hong Kong","code":"HK","dial_code":"+852","currency_name":"Hong Kong dollar","currency_symbol":"$","currency_code":"HKD","created_at":null,"updated_at":null,"name_with_symbole":"Hong Kong dollar - $"},{"id":96,"name":"Hungary","code":"HU","dial_code":"+36","currency_name":"Hungarian forint","currency_symbol":"Ft","currency_code":"HUF","created_at":null,"updated_at":null,"name_with_symbole":"Hungarian forint - Ft"},{"id":97,"name":"Iceland","code":"IS","dial_code":"+354","currency_name":"Icelandic kr\u00f3na","currency_symbol":"kr","currency_code":"ISK","created_at":null,"updated_at":null,"name_with_symbole":"Icelandic kr\u00f3na - kr"},{"id":98,"name":"India","code":"IN","dial_code":"+91","currency_name":"Indian rupee","currency_symbol":"Rs.","currency_code":"INR","created_at":null,"updated_at":"2020-08-19T20:32:46.000000Z","name_with_symbole":"Indian rupee - Rs."},{"id":99,"name":"Indonesia","code":"ID","dial_code":"+62","currency_name":"Indonesian rupiah","currency_symbol":"Rp","currency_code":"IDR","created_at":null,"updated_at":null,"name_with_symbole":"Indonesian rupiah - Rp"},{"id":100,"name":"Iran, Islamic Republ","code":"IR","dial_code":"+98","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":101,"name":"Iraq","code":"IQ","dial_code":"+964","currency_name":"Iraqi dinar","currency_symbol":"\u0639.\u062f","currency_code":"IQD","created_at":null,"updated_at":null,"name_with_symbole":"Iraqi dinar - \u0639.\u062f"},{"id":102,"name":"Ireland","code":"IE","dial_code":"+353","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":103,"name":"Isle of Man","code":"IM","dial_code":"+44","currency_name":"British pound","currency_symbol":"\u00a3","currency_code":"GBP","created_at":null,"updated_at":null,"name_with_symbole":"British pound - \u00a3"},{"id":104,"name":"Israel","code":"IL","dial_code":"+972","currency_name":"Israeli new shekel","currency_symbol":"\u20aa","currency_code":"ILS","created_at":null,"updated_at":null,"name_with_symbole":"Israeli new shekel - \u20aa"},{"id":105,"name":"Italy","code":"IT","dial_code":"+39","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":106,"name":"Jamaica","code":"JM","dial_code":"+1876","currency_name":"Jamaican dollar","currency_symbol":"$","currency_code":"JMD","created_at":null,"updated_at":null,"name_with_symbole":"Jamaican dollar - $"},{"id":107,"name":"Japan","code":"JP","dial_code":"+81","currency_name":"Japanese yen","currency_symbol":"\u00a5","currency_code":"JPY","created_at":null,"updated_at":null,"name_with_symbole":"Japanese yen - \u00a5"},{"id":108,"name":"Jersey","code":"JE","dial_code":"+44","currency_name":"British pound","currency_symbol":"\u00a3","currency_code":"GBP","created_at":null,"updated_at":null,"name_with_symbole":"British pound - \u00a3"},{"id":109,"name":"Jordan","code":"JO","dial_code":"+962","currency_name":"Jordanian dinar","currency_symbol":"\u062f.\u0627","currency_code":"JOD","created_at":null,"updated_at":null,"name_with_symbole":"Jordanian dinar - \u062f.\u0627"},{"id":110,"name":"Kazakhstan","code":"KZ","dial_code":"+7 7","currency_name":"Kazakhstani tenge","currency_symbol":"","currency_code":"KZT","created_at":null,"updated_at":null,"name_with_symbole":"Kazakhstani tenge - "},{"id":111,"name":"Kenya","code":"KE","dial_code":"+254","currency_name":"Kenyan shilling","currency_symbol":"Sh","currency_code":"KES","created_at":null,"updated_at":null,"name_with_symbole":"Kenyan shilling - Sh"},{"id":112,"name":"Kiribati","code":"KI","dial_code":"+686","currency_name":"Australian dollar","currency_symbol":"$","currency_code":"AUD","created_at":null,"updated_at":null,"name_with_symbole":"Australian dollar - $"},{"id":113,"name":"Korea, Democratic Pe","code":"KP","dial_code":"+850","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":114,"name":"Korea, Republic of S","code":"KR","dial_code":"+82","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":115,"name":"Kuwait","code":"KW","dial_code":"+965","currency_name":"Kuwaiti dinar","currency_symbol":"\u062f.\u0643","currency_code":"KWD","created_at":null,"updated_at":null,"name_with_symbole":"Kuwaiti dinar - \u062f.\u0643"},{"id":116,"name":"Kyrgyzstan","code":"KG","dial_code":"+996","currency_name":"Kyrgyzstani som","currency_symbol":"\u043b\u0432","currency_code":"KGS","created_at":null,"updated_at":null,"name_with_symbole":"Kyrgyzstani som - \u043b\u0432"},{"id":117,"name":"Laos","code":"LA","dial_code":"+856","currency_name":"Lao kip","currency_symbol":"\u20ad","currency_code":"LAK","created_at":null,"updated_at":null,"name_with_symbole":"Lao kip - \u20ad"},{"id":118,"name":"Latvia","code":"LV","dial_code":"+371","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":119,"name":"Lebanon","code":"LB","dial_code":"+961","currency_name":"Lebanese pound","currency_symbol":"\u0644.\u0644","currency_code":"LBP","created_at":null,"updated_at":null,"name_with_symbole":"Lebanese pound - \u0644.\u0644"},{"id":120,"name":"Lesotho","code":"LS","dial_code":"+266","currency_name":"Lesotho loti","currency_symbol":"L","currency_code":"LSL","created_at":null,"updated_at":null,"name_with_symbole":"Lesotho loti - L"},{"id":121,"name":"Liberia","code":"LR","dial_code":"+231","currency_name":"Liberian dollar","currency_symbol":"$","currency_code":"LRD","created_at":null,"updated_at":null,"name_with_symbole":"Liberian dollar - $"},{"id":122,"name":"Libyan Arab Jamahiri","code":"LY","dial_code":"+218","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":123,"name":"Liechtenstein","code":"LI","dial_code":"+423","currency_name":"Swiss franc","currency_symbol":"Fr","currency_code":"CHF","created_at":null,"updated_at":null,"name_with_symbole":"Swiss franc - Fr"},{"id":124,"name":"Lithuania","code":"LT","dial_code":"+370","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"LTL","created_at":null,"updated_at":"2020-08-26T03:11:22.000000Z","name_with_symbole":"Euro - \u20ac"},{"id":125,"name":"Luxembourg","code":"LU","dial_code":"+352","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":126,"name":"Macao","code":"MO","dial_code":"+853","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":127,"name":"Macedonia","code":"MK","dial_code":"+389","currency_name":"","currency_symbol":"","currency_code":"MKD","created_at":null,"updated_at":"2020-08-26T03:11:23.000000Z","name_with_symbole":" - "},{"id":128,"name":"Madagascar","code":"MG","dial_code":"+261","currency_name":"Malagasy ariary","currency_symbol":"Ar","currency_code":"MGA","created_at":null,"updated_at":null,"name_with_symbole":"Malagasy ariary - Ar"},{"id":129,"name":"Malawi","code":"MW","dial_code":"+265","currency_name":"Malawian kwacha","currency_symbol":"MK","currency_code":"MWK","created_at":null,"updated_at":null,"name_with_symbole":"Malawian kwacha - MK"},{"id":130,"name":"Malaysia","code":"MY","dial_code":"+60","currency_name":"Malaysian ringgit","currency_symbol":"RM","currency_code":"MYR","created_at":null,"updated_at":null,"name_with_symbole":"Malaysian ringgit - RM"},{"id":131,"name":"Maldives","code":"MV","dial_code":"+960","currency_name":"Maldivian rufiyaa","currency_symbol":".\u0783","currency_code":"MVR","created_at":null,"updated_at":null,"name_with_symbole":"Maldivian rufiyaa - .\u0783"},{"id":132,"name":"Mali","code":"ML","dial_code":"+223","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":133,"name":"Malta","code":"MT","dial_code":"+356","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":134,"name":"Marshall Islands","code":"MH","dial_code":"+692","currency_name":"United States dollar","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-19T20:32:46.000000Z","name_with_symbole":"United States dollar - $"},{"id":135,"name":"Martinique","code":"MQ","dial_code":"+596","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:25.000000Z","name_with_symbole":" - "},{"id":136,"name":"Mauritania","code":"MR","dial_code":"+222","currency_name":"Mauritanian ouguiya","currency_symbol":"UM","currency_code":"MRO","created_at":null,"updated_at":null,"name_with_symbole":"Mauritanian ouguiya - UM"},{"id":137,"name":"Mauritius","code":"MU","dial_code":"+230","currency_name":"Mauritian rupee","currency_symbol":"\u20a8","currency_code":"MUR","created_at":null,"updated_at":null,"name_with_symbole":"Mauritian rupee - \u20a8"},{"id":138,"name":"Mayotte","code":"YT","dial_code":"+262","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:25.000000Z","name_with_symbole":" - "},{"id":139,"name":"Mexico","code":"MX","dial_code":"+52","currency_name":"Mexican peso","currency_symbol":"$","currency_code":"MXN","created_at":null,"updated_at":null,"name_with_symbole":"Mexican peso - $"},{"id":140,"name":"Micronesia, Federate","code":"FM","dial_code":"+691","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":141,"name":"Moldova","code":"MD","dial_code":"+373","currency_name":"Moldovan leu","currency_symbol":"L","currency_code":"MDL","created_at":null,"updated_at":null,"name_with_symbole":"Moldovan leu - L"},{"id":142,"name":"Monaco","code":"MC","dial_code":"+377","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":143,"name":"Mongolia","code":"MN","dial_code":"+976","currency_name":"Mongolian t\u00f6gr\u00f6g","currency_symbol":"\u20ae","currency_code":"MNT","created_at":null,"updated_at":null,"name_with_symbole":"Mongolian t\u00f6gr\u00f6g - \u20ae"},{"id":144,"name":"Montenegro","code":"ME","dial_code":"+382","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":145,"name":"Montserrat","code":"MS","dial_code":"+1664","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":146,"name":"Morocco","code":"MA","dial_code":"+212","currency_name":"Moroccan dirham","currency_symbol":"\u062f.\u0645.","currency_code":"MAD","created_at":null,"updated_at":null,"name_with_symbole":"Moroccan dirham - \u062f.\u0645."},{"id":147,"name":"Mozambique","code":"MZ","dial_code":"+258","currency_name":"Mozambican metical","currency_symbol":"MT","currency_code":"MZN","created_at":null,"updated_at":null,"name_with_symbole":"Mozambican metical - MT"},{"id":148,"name":"Myanmar","code":"MM","dial_code":"+95","currency_name":"Burmese kyat","currency_symbol":"Ks","currency_code":"MMK","created_at":null,"updated_at":null,"name_with_symbole":"Burmese kyat - Ks"},{"id":149,"name":"Namibia","code":"NA","dial_code":"+264","currency_name":"Namibian dollar","currency_symbol":"$","currency_code":"NAD","created_at":null,"updated_at":null,"name_with_symbole":"Namibian dollar - $"},{"id":150,"name":"Nauru","code":"NR","dial_code":"+674","currency_name":"Australian dollar","currency_symbol":"$","currency_code":"AUD","created_at":null,"updated_at":null,"name_with_symbole":"Australian dollar - $"},{"id":151,"name":"Nepal","code":"NP","dial_code":"+977","currency_name":"Nepalese rupee","currency_symbol":"\u20a8","currency_code":"NPR","created_at":null,"updated_at":null,"name_with_symbole":"Nepalese rupee - \u20a8"},{"id":152,"name":"Netherlands","code":"NL","dial_code":"+31","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":153,"name":"Netherlands Antilles","code":"AN","dial_code":"+599","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":154,"name":"New Caledonia","code":"NC","dial_code":"+687","currency_name":"CFP franc","currency_symbol":"Fr","currency_code":"XPF","created_at":null,"updated_at":null,"name_with_symbole":"CFP franc - Fr"},{"id":155,"name":"New Zealand","code":"NZ","dial_code":"+64","currency_name":"New Zealand dollar","currency_symbol":"$","currency_code":"NZD","created_at":null,"updated_at":null,"name_with_symbole":"New Zealand dollar - $"},{"id":156,"name":"Nicaragua","code":"NI","dial_code":"+505","currency_name":"Nicaraguan c\u00f3rdoba","currency_symbol":"C$","currency_code":"NIO","created_at":null,"updated_at":null,"name_with_symbole":"Nicaraguan c\u00f3rdoba - C$"},{"id":157,"name":"Niger","code":"NE","dial_code":"+227","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":158,"name":"Nigeria","code":"NG","dial_code":"+234","currency_name":"Nigerian naira","currency_symbol":"\u20a6","currency_code":"NGN","created_at":null,"updated_at":null,"name_with_symbole":"Nigerian naira - \u20a6"},{"id":159,"name":"Niue","code":"NU","dial_code":"+683","currency_name":"New Zealand dollar","currency_symbol":"$","currency_code":"NZD","created_at":null,"updated_at":null,"name_with_symbole":"New Zealand dollar - $"},{"id":160,"name":"Norfolk Island","code":"NF","dial_code":"+672","currency_name":"","currency_symbol":"","currency_code":"AUD","created_at":null,"updated_at":"2020-08-26T03:11:29.000000Z","name_with_symbole":" - "},{"id":161,"name":"Northern Mariana Isl","code":"MP","dial_code":"+1670","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":162,"name":"Norway","code":"NO","dial_code":"+47","currency_name":"Norwegian krone","currency_symbol":"kr","currency_code":"NOK","created_at":null,"updated_at":null,"name_with_symbole":"Norwegian krone - kr"},{"id":163,"name":"Oman","code":"OM","dial_code":"+968","currency_name":"Omani rial","currency_symbol":"\u0631.\u0639.","currency_code":"OMR","created_at":null,"updated_at":null,"name_with_symbole":"Omani rial - \u0631.\u0639."},{"id":164,"name":"Pakistan","code":"PK","dial_code":"+92","currency_name":"Pakistani rupee","currency_symbol":"Rs.","currency_code":"PKR","created_at":null,"updated_at":null,"name_with_symbole":"Pakistani rupee - Rs."},{"id":165,"name":"Palau","code":"PW","dial_code":"+680","currency_name":"Palauan dollar","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-26T03:11:29.000000Z","name_with_symbole":"Palauan dollar - $"},{"id":166,"name":"Palestinian Territor","code":"PS","dial_code":"+970","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":167,"name":"Panama","code":"PA","dial_code":"+507","currency_name":"Panamanian balboa","currency_symbol":"B\/.","currency_code":"PAB","created_at":null,"updated_at":null,"name_with_symbole":"Panamanian balboa - B\/."},{"id":168,"name":"Papua New Guinea","code":"PG","dial_code":"+675","currency_name":"Papua New Guinean ki","currency_symbol":"K","currency_code":"PGK","created_at":null,"updated_at":null,"name_with_symbole":"Papua New Guinean ki - K"},{"id":169,"name":"Paraguay","code":"PY","dial_code":"+595","currency_name":"Paraguayan guaran\u00ed","currency_symbol":"\u20b2","currency_code":"PYG","created_at":null,"updated_at":null,"name_with_symbole":"Paraguayan guaran\u00ed - \u20b2"},{"id":170,"name":"Peru","code":"PE","dial_code":"+51","currency_name":"Peruvian nuevo sol","currency_symbol":"S\/.","currency_code":"PEN","created_at":null,"updated_at":null,"name_with_symbole":"Peruvian nuevo sol - S\/."},{"id":171,"name":"Philippines","code":"PH","dial_code":"+63","currency_name":"Philippine peso","currency_symbol":"\u20b1","currency_code":"PHP","created_at":null,"updated_at":null,"name_with_symbole":"Philippine peso - \u20b1"},{"id":172,"name":"Pitcairn","code":"PN","dial_code":"+872","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":173,"name":"Poland","code":"PL","dial_code":"+48","currency_name":"Polish z?oty","currency_symbol":"z\u0142","currency_code":"PLN","created_at":null,"updated_at":null,"name_with_symbole":"Polish z?oty - z\u0142"},{"id":174,"name":"Portugal","code":"PT","dial_code":"+351","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":175,"name":"Puerto Rico","code":"PR","dial_code":"+1939","currency_name":"","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-26T03:11:31.000000Z","name_with_symbole":" - $"},{"id":176,"name":"Qatar","code":"QA","dial_code":"+974","currency_name":"Qatari riyal","currency_symbol":"\u0631.\u0642","currency_code":"QAR","created_at":null,"updated_at":null,"name_with_symbole":"Qatari riyal - \u0631.\u0642"},{"id":177,"name":"Romania","code":"RO","dial_code":"+40","currency_name":"Romanian leu","currency_symbol":"lei","currency_code":"RON","created_at":null,"updated_at":null,"name_with_symbole":"Romanian leu - lei"},{"id":178,"name":"Russia","code":"RU","dial_code":"+7","currency_name":"Russian ruble","currency_symbol":"","currency_code":"RUB","created_at":null,"updated_at":null,"name_with_symbole":"Russian ruble - "},{"id":179,"name":"Rwanda","code":"RW","dial_code":"+250","currency_name":"Rwandan franc","currency_symbol":"Fr","currency_code":"RWF","created_at":null,"updated_at":null,"name_with_symbole":"Rwandan franc - Fr"},{"id":180,"name":"Reunion","code":"RE","dial_code":"+262","currency_name":"","currency_symbol":"","currency_code":"EUR","created_at":null,"updated_at":"2020-08-26T03:11:31.000000Z","name_with_symbole":" - "},{"id":181,"name":"Saint Barthelemy","code":"BL","dial_code":"+590","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":182,"name":"Saint Helena, Ascens","code":"SH","dial_code":"+290","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":183,"name":"Saint Kitts and Nevi","code":"KN","dial_code":"+1869","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":184,"name":"Saint Lucia","code":"LC","dial_code":"+1758","currency_name":"East Caribbean dolla","currency_symbol":"$","currency_code":"XCD","created_at":null,"updated_at":null,"name_with_symbole":"East Caribbean dolla - $"},{"id":185,"name":"Saint Martin","code":"MF","dial_code":"+590","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":186,"name":"Saint Pierre and Miq","code":"PM","dial_code":"+508","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":187,"name":"Saint Vincent and th","code":"VC","dial_code":"+1784","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":188,"name":"Samoa","code":"WS","dial_code":"+685","currency_name":"Samoan t?l?","currency_symbol":"T","currency_code":"WST","created_at":null,"updated_at":null,"name_with_symbole":"Samoan t?l? - T"},{"id":189,"name":"San Marino","code":"SM","dial_code":"+378","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":190,"name":"Sao Tome and Princip","code":"ST","dial_code":"+239","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":191,"name":"Saudi Arabia","code":"SA","dial_code":"+966","currency_name":"Saudi riyal","currency_symbol":"\u0631.\u0633","currency_code":"SAR","created_at":null,"updated_at":null,"name_with_symbole":"Saudi riyal - \u0631.\u0633"},{"id":192,"name":"Senegal","code":"SN","dial_code":"+221","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":193,"name":"Serbia","code":"RS","dial_code":"+381","currency_name":"Serbian dinar","currency_symbol":"\u0434\u0438\u043d. or din.","currency_code":"RSD","created_at":null,"updated_at":null,"name_with_symbole":"Serbian dinar - \u0434\u0438\u043d. or din."},{"id":194,"name":"Seychelles","code":"SC","dial_code":"+248","currency_name":"Seychellois rupee","currency_symbol":"\u20a8","currency_code":"SCR","created_at":null,"updated_at":null,"name_with_symbole":"Seychellois rupee - \u20a8"},{"id":195,"name":"Sierra Leone","code":"SL","dial_code":"+232","currency_name":"Sierra Leonean leone","currency_symbol":"Le","currency_code":"SLL","created_at":null,"updated_at":null,"name_with_symbole":"Sierra Leonean leone - Le"},{"id":196,"name":"Singapore","code":"SG","dial_code":"+65","currency_name":"Brunei dollar","currency_symbol":"$","currency_code":"SGD","created_at":null,"updated_at":"2020-08-26T03:11:34.000000Z","name_with_symbole":"Brunei dollar - $"},{"id":197,"name":"Slovakia","code":"SK","dial_code":"+421","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":198,"name":"Slovenia","code":"SI","dial_code":"+386","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":199,"name":"Solomon Islands","code":"SB","dial_code":"+677","currency_name":"Solomon Islands doll","currency_symbol":"$","currency_code":"SBD","created_at":null,"updated_at":null,"name_with_symbole":"Solomon Islands doll - $"},{"id":200,"name":"Somalia","code":"SO","dial_code":"+252","currency_name":"Somali shilling","currency_symbol":"Sh","currency_code":"SOS","created_at":null,"updated_at":null,"name_with_symbole":"Somali shilling - Sh"},{"id":201,"name":"South Africa","code":"ZA","dial_code":"+27","currency_name":"South African rand","currency_symbol":"R","currency_code":"ZAR","created_at":null,"updated_at":null,"name_with_symbole":"South African rand - R"},{"id":202,"name":"South Georgia and th","code":"GS","dial_code":"+500","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":203,"name":"Spain","code":"ES","dial_code":"+34","currency_name":"Euro","currency_symbol":"\u20ac","currency_code":"EUR","created_at":null,"updated_at":null,"name_with_symbole":"Euro - \u20ac"},{"id":204,"name":"Sri Lanka","code":"LK","dial_code":"+94","currency_name":"Sri Lankan rupee","currency_symbol":"Rs or \u0dbb\u0dd4","currency_code":"LKR","created_at":null,"updated_at":null,"name_with_symbole":"Sri Lankan rupee - Rs or \u0dbb\u0dd4"},{"id":205,"name":"Sudan","code":"SD","dial_code":"+249","currency_name":"Sudanese pound","currency_symbol":"\u062c.\u0633.","currency_code":"SDG","created_at":null,"updated_at":null,"name_with_symbole":"Sudanese pound - \u062c.\u0633."},{"id":206,"name":"Suriname","code":"SR","dial_code":"+597","currency_name":"Surinamese dollar","currency_symbol":"$","currency_code":"SRD","created_at":null,"updated_at":null,"name_with_symbole":"Surinamese dollar - $"},{"id":207,"name":"Svalbard and Jan May","code":"SJ","dial_code":"+47","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":208,"name":"Swaziland","code":"SZ","dial_code":"+268","currency_name":"Swazi lilangeni","currency_symbol":"L","currency_code":"SZL","created_at":null,"updated_at":null,"name_with_symbole":"Swazi lilangeni - L"},{"id":209,"name":"Sweden","code":"SE","dial_code":"+46","currency_name":"Swedish krona","currency_symbol":"kr","currency_code":"SEK","created_at":null,"updated_at":null,"name_with_symbole":"Swedish krona - kr"},{"id":210,"name":"Switzerland","code":"CH","dial_code":"+41","currency_name":"Swiss franc","currency_symbol":"Fr","currency_code":"CHF","created_at":null,"updated_at":null,"name_with_symbole":"Swiss franc - Fr"},{"id":211,"name":"Syrian Arab Republic","code":"SY","dial_code":"+963","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":212,"name":"Taiwan","code":"TW","dial_code":"+886","currency_name":"New Taiwan dollar","currency_symbol":"$","currency_code":"TWD","created_at":null,"updated_at":null,"name_with_symbole":"New Taiwan dollar - $"},{"id":213,"name":"Tajikistan","code":"TJ","dial_code":"+992","currency_name":"Tajikistani somoni","currency_symbol":"\u0405\u041c","currency_code":"TJS","created_at":null,"updated_at":null,"name_with_symbole":"Tajikistani somoni - \u0405\u041c"},{"id":214,"name":"Tanzania, United Rep","code":"TZ","dial_code":"+255","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":215,"name":"Thailand","code":"TH","dial_code":"+66","currency_name":"Thai baht","currency_symbol":"\u0e3f","currency_code":"THB","created_at":null,"updated_at":null,"name_with_symbole":"Thai baht - \u0e3f"},{"id":216,"name":"Timor-Leste","code":"TL","dial_code":"+670","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":217,"name":"Togo","code":"TG","dial_code":"+228","currency_name":"West African CFA fra","currency_symbol":"Fr","currency_code":"XOF","created_at":null,"updated_at":null,"name_with_symbole":"West African CFA fra - Fr"},{"id":218,"name":"Tokelau","code":"TK","dial_code":"+690","currency_name":"","currency_symbol":"","currency_code":"NZD","created_at":null,"updated_at":"2020-08-26T03:11:41.000000Z","name_with_symbole":" - "},{"id":219,"name":"Tonga","code":"TO","dial_code":"+676","currency_name":"Tongan pa?anga","currency_symbol":"T$","currency_code":"TOP","created_at":null,"updated_at":null,"name_with_symbole":"Tongan pa?anga - T$"},{"id":220,"name":"Trinidad and Tobago","code":"TT","dial_code":"+1868","currency_name":"Trinidad and Tobago ","currency_symbol":"$","currency_code":"TTD","created_at":null,"updated_at":null,"name_with_symbole":"Trinidad and Tobago  - $"},{"id":221,"name":"Tunisia","code":"TN","dial_code":"+216","currency_name":"Tunisian dinar","currency_symbol":"\u062f.\u062a","currency_code":"TND","created_at":null,"updated_at":null,"name_with_symbole":"Tunisian dinar - \u062f.\u062a"},{"id":222,"name":"Turkey","code":"TR","dial_code":"+90","currency_name":"Turkish lira","currency_symbol":"","currency_code":"TRY","created_at":null,"updated_at":null,"name_with_symbole":"Turkish lira - "},{"id":223,"name":"Turkmenistan","code":"TM","dial_code":"+993","currency_name":"Turkmenistan manat","currency_symbol":"m","currency_code":"TMT","created_at":null,"updated_at":null,"name_with_symbole":"Turkmenistan manat - m"},{"id":224,"name":"Turks and Caicos Isl","code":"TC","dial_code":"+1649","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":225,"name":"Tuvalu","code":"TV","dial_code":"+688","currency_name":"Australian dollar","currency_symbol":"$","currency_code":"AUD","created_at":null,"updated_at":null,"name_with_symbole":"Australian dollar - $"},{"id":226,"name":"Uganda","code":"UG","dial_code":"+256","currency_name":"Ugandan shilling","currency_symbol":"Sh","currency_code":"UGX","created_at":null,"updated_at":null,"name_with_symbole":"Ugandan shilling - Sh"},{"id":227,"name":"Ukraine","code":"UA","dial_code":"+380","currency_name":"Ukrainian hryvnia","currency_symbol":"\u20b4","currency_code":"UAH","created_at":null,"updated_at":null,"name_with_symbole":"Ukrainian hryvnia - \u20b4"},{"id":228,"name":"United Arab Emirates","code":"AE","dial_code":"+971","currency_name":"United Arab Emirates","currency_symbol":"\u062f.\u0625","currency_code":"AED","created_at":null,"updated_at":null,"name_with_symbole":"United Arab Emirates - \u062f.\u0625"},{"id":229,"name":"United Kingdom","code":"GB","dial_code":"+44","currency_name":"British pound","currency_symbol":"\u00a3","currency_code":"GBP","created_at":null,"updated_at":null,"name_with_symbole":"British pound - \u00a3"},{"id":230,"name":"United States","code":"US","dial_code":"+1","currency_name":"United States dollar","currency_symbol":"$","currency_code":"USD","created_at":null,"updated_at":"2020-08-19T20:32:46.000000Z","name_with_symbole":"United States dollar - $"},{"id":231,"name":"Uruguay","code":"UY","dial_code":"+598","currency_name":"Uruguayan peso","currency_symbol":"$","currency_code":"UYU","created_at":null,"updated_at":null,"name_with_symbole":"Uruguayan peso - $"},{"id":232,"name":"Uzbekistan","code":"UZ","dial_code":"+998","currency_name":"Uzbekistani som","currency_symbol":"","currency_code":"UZS","created_at":null,"updated_at":null,"name_with_symbole":"Uzbekistani som - "},{"id":233,"name":"Vanuatu","code":"VU","dial_code":"+678","currency_name":"Vanuatu vatu","currency_symbol":"Vt","currency_code":"VUV","created_at":null,"updated_at":null,"name_with_symbole":"Vanuatu vatu - Vt"},{"id":234,"name":"Venezuela, Bolivaria","code":"VE","dial_code":"+58","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":235,"name":"Vietnam","code":"VN","dial_code":"+84","currency_name":"Vietnamese ??ng","currency_symbol":"\u20ab","currency_code":"VND","created_at":null,"updated_at":null,"name_with_symbole":"Vietnamese ??ng - \u20ab"},{"id":236,"name":"Virgin Islands, Brit","code":"VG","dial_code":"+1284","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":237,"name":"Virgin Islands, U.S.","code":"VI","dial_code":"+1340","currency_name":"","currency_symbol":"","currency_code":"","created_at":null,"updated_at":null,"name_with_symbole":" - "},{"id":238,"name":"Wallis and Futuna","code":"WF","dial_code":"+681","currency_name":"CFP franc","currency_symbol":"Fr","currency_code":"XPF","created_at":null,"updated_at":null,"name_with_symbole":"CFP franc - Fr"},{"id":239,"name":"Yemen","code":"YE","dial_code":"+967","currency_name":"Yemeni rial","currency_symbol":"\ufdfc","currency_code":"YER","created_at":null,"updated_at":null,"name_with_symbole":"Yemeni rial - \ufdfc"},{"id":240,"name":"Zambia","code":"ZM","dial_code":"+260","currency_name":"Zambian kwacha","currency_symbol":"ZK","currency_code":"ZMK","created_at":null,"updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":"Zambian kwacha - ZK"},{"id":241,"name":"Zimbabwe","code":"ZW","dial_code":"+263","currency_name":"Botswana pula","currency_symbol":"P","currency_code":"ZWL","created_at":null,"updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":"Botswana pula - P"},{"id":242,"name":"American Samoa","code":"AS","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:10.000000Z","updated_at":"2020-08-26T03:11:10.000000Z","name_with_symbole":" - $"},{"id":243,"name":"Bahamas The","code":"BS","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"BSD","created_at":"2020-08-26T03:11:10.000000Z","updated_at":"2020-08-26T03:11:10.000000Z","name_with_symbole":" - "},{"id":244,"name":"Bolivia","code":"BO","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"BOB","created_at":"2020-08-26T03:11:11.000000Z","updated_at":"2020-08-26T03:11:11.000000Z","name_with_symbole":" - "},{"id":245,"name":"Bosnia and Herzegovina","code":"BA","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"BAM","created_at":"2020-08-26T03:11:11.000000Z","updated_at":"2020-08-26T03:11:11.000000Z","name_with_symbole":" - "},{"id":246,"name":"Bouvet Island","code":"BV","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"NOK","created_at":"2020-08-26T03:11:11.000000Z","updated_at":"2020-08-26T03:11:11.000000Z","name_with_symbole":" - "},{"id":247,"name":"British Indian Ocean Territory","code":"IO","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:11.000000Z","updated_at":"2020-08-26T03:11:11.000000Z","name_with_symbole":" - $"},{"id":248,"name":"Brunei","code":"BN","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"BND","created_at":"2020-08-26T03:11:11.000000Z","updated_at":"2020-08-26T03:11:11.000000Z","name_with_symbole":" - "},{"id":249,"name":"Central African Republic","code":"CF","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"XAF","created_at":"2020-08-26T03:11:12.000000Z","updated_at":"2020-08-26T03:11:12.000000Z","name_with_symbole":" - "},{"id":250,"name":"Cocos (Keeling) Islands","code":"CC","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"AUD","created_at":"2020-08-26T03:11:13.000000Z","updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":251,"name":"Congo The Democratic Republic Of The","code":"CD","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"CDF","created_at":"2020-08-26T03:11:13.000000Z","updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":252,"name":"Cote D'Ivoire (Ivory Coast)","code":"CI","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"XOF","created_at":"2020-08-26T03:11:13.000000Z","updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":253,"name":"Croatia (Hrvatska)","code":"HR","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"HRK","created_at":"2020-08-26T03:11:13.000000Z","updated_at":"2020-08-26T03:11:13.000000Z","name_with_symbole":" - "},{"id":254,"name":"East Timor","code":"TL","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:14.000000Z","updated_at":"2020-08-26T03:11:14.000000Z","name_with_symbole":" - $"},{"id":255,"name":"Falkland Islands","code":"FK","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"FKP","created_at":"2020-08-26T03:11:15.000000Z","updated_at":"2020-08-26T03:11:15.000000Z","name_with_symbole":" - "},{"id":256,"name":"Fiji Islands","code":"FJ","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"FJD","created_at":"2020-08-26T03:11:15.000000Z","updated_at":"2020-08-26T03:11:15.000000Z","name_with_symbole":" - "},{"id":257,"name":"French Southern Territories","code":"TF","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:16.000000Z","updated_at":"2020-08-26T03:11:16.000000Z","name_with_symbole":" - "},{"id":258,"name":"Gambia The","code":"GM","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"GMD","created_at":"2020-08-26T03:11:16.000000Z","updated_at":"2020-08-26T03:11:16.000000Z","name_with_symbole":" - "},{"id":259,"name":"Guernsey and Alderney","code":"GG","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"GBP","created_at":"2020-08-26T03:11:17.000000Z","updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - "},{"id":260,"name":"Heard and McDonald Islands","code":"HM","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"AUD","created_at":"2020-08-26T03:11:17.000000Z","updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - "},{"id":261,"name":"Hong Kong S.A.R.","code":"HK","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"HKD","created_at":"2020-08-26T03:11:17.000000Z","updated_at":"2020-08-26T03:11:17.000000Z","name_with_symbole":" - "},{"id":262,"name":"Iran","code":"IR","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"IRR","created_at":"2020-08-26T03:11:18.000000Z","updated_at":"2020-08-26T03:11:18.000000Z","name_with_symbole":" - "},{"id":263,"name":"Korea North","code":"KP","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"KPW","created_at":"2020-08-26T03:11:21.000000Z","updated_at":"2020-08-26T03:11:21.000000Z","name_with_symbole":" - "},{"id":264,"name":"Korea South","code":"KR","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"KRW","created_at":"2020-08-26T03:11:21.000000Z","updated_at":"2020-08-26T03:11:21.000000Z","name_with_symbole":" - "},{"id":265,"name":"Libya","code":"LY","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"LYD","created_at":"2020-08-26T03:11:22.000000Z","updated_at":"2020-08-26T03:11:22.000000Z","name_with_symbole":" - "},{"id":266,"name":"Macau S.A.R.","code":"MO","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"MOP","created_at":"2020-08-26T03:11:23.000000Z","updated_at":"2020-08-26T03:11:23.000000Z","name_with_symbole":" - "},{"id":267,"name":"Man (Isle of)","code":"IM","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"GBP","created_at":"2020-08-26T03:11:25.000000Z","updated_at":"2020-08-26T03:11:25.000000Z","name_with_symbole":" - "},{"id":268,"name":"Micronesia","code":"FM","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:26.000000Z","updated_at":"2020-08-26T03:11:26.000000Z","name_with_symbole":" - $"},{"id":269,"name":"Netherlands The","code":"NL","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:28.000000Z","updated_at":"2020-08-26T03:11:28.000000Z","name_with_symbole":" - "},{"id":270,"name":"Northern Mariana Islands","code":"MP","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:29.000000Z","updated_at":"2020-08-26T03:11:29.000000Z","name_with_symbole":" - $"},{"id":271,"name":"Palestinian Territory Occupied","code":"PS","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"ILS","created_at":"2020-08-26T03:11:29.000000Z","updated_at":"2020-08-26T03:11:29.000000Z","name_with_symbole":" - "},{"id":272,"name":"Pitcairn Island","code":"PN","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"NZD","created_at":"2020-08-26T03:11:31.000000Z","updated_at":"2020-08-26T03:11:31.000000Z","name_with_symbole":" - "},{"id":273,"name":"Saint Helena","code":"SH","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"SHP","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":274,"name":"Saint Kitts And Nevis","code":"KN","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"XCD","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":275,"name":"Saint Pierre and Miquelon","code":"PM","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":276,"name":"Saint Vincent And The Grenadines","code":"VC","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"XCD","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":277,"name":"Saint-Barthelemy","code":"BL","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":278,"name":"Saint-Martin (French part)","code":"MF","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":279,"name":"Sao Tome and Principe","code":"ST","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"STD","created_at":"2020-08-26T03:11:33.000000Z","updated_at":"2020-08-26T03:11:33.000000Z","name_with_symbole":" - "},{"id":280,"name":"South Georgia","code":"GS","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"GBP","created_at":"2020-08-26T03:11:37.000000Z","updated_at":"2020-08-26T03:11:37.000000Z","name_with_symbole":" - "},{"id":281,"name":"South Sudan","code":"SS","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"SSP","created_at":"2020-08-26T03:11:37.000000Z","updated_at":"2020-08-26T03:11:37.000000Z","name_with_symbole":" - "},{"id":282,"name":"Svalbard And Jan Mayen Islands","code":"SJ","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"NOK","created_at":"2020-08-26T03:11:38.000000Z","updated_at":"2020-08-26T03:11:38.000000Z","name_with_symbole":" - "},{"id":283,"name":"Syria","code":"SY","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"SYP","created_at":"2020-08-26T03:11:39.000000Z","updated_at":"2020-08-26T03:11:39.000000Z","name_with_symbole":" - "},{"id":284,"name":"Tanzania","code":"TZ","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"TZS","created_at":"2020-08-26T03:11:39.000000Z","updated_at":"2020-08-26T03:11:39.000000Z","name_with_symbole":" - "},{"id":285,"name":"Turks And Caicos Islands","code":"TC","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:42.000000Z","updated_at":"2020-08-26T03:11:42.000000Z","name_with_symbole":" - $"},{"id":286,"name":"United States Minor Outlying Islands","code":"UM","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:47.000000Z","updated_at":"2020-08-26T03:11:47.000000Z","name_with_symbole":" - $"},{"id":287,"name":"Vatican City State (Holy See)","code":"VA","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"EUR","created_at":"2020-08-26T03:11:48.000000Z","updated_at":"2020-08-26T03:11:48.000000Z","name_with_symbole":" - "},{"id":288,"name":"Venezuela","code":"VE","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"VEF","created_at":"2020-08-26T03:11:48.000000Z","updated_at":"2020-08-26T03:11:48.000000Z","name_with_symbole":" - "},{"id":289,"name":"Virgin Islands (British)","code":"VG","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:49.000000Z","updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":" - $"},{"id":290,"name":"Virgin Islands (US)","code":"VI","dial_code":null,"currency_name":null,"currency_symbol":"$","currency_code":"USD","created_at":"2020-08-26T03:11:49.000000Z","updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":" - $"},{"id":291,"name":"Wallis And Futuna Islands","code":"WF","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"XPF","created_at":"2020-08-26T03:11:49.000000Z","updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":" - "},{"id":292,"name":"Western Sahara","code":"EH","dial_code":null,"currency_name":null,"currency_symbol":null,"currency_code":"MAD","created_at":"2020-08-26T03:11:49.000000Z","updated_at":"2020-08-26T03:11:49.000000Z","name_with_symbole":" - "}]
const statesData = [
    {
        "name": "Afghanistan",
        "iso3": "AFG",
        "iso2": "AF",
        "phone_code": "93",
        "capital": "Kabul",
        "currency": "AFN",
        "currency_symbol": "Ø‹",
        "tld": ".af",
        "native": "Ø§ÙØºØ§Ù†Ø³ØªØ§Ù†",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Kabul",
                "gmtOffset": 16200,
                "gmtOffsetName": "UTC+04:30",
                "abbreviation": "AFT",
                "tzName": "Afghanistan Time"
            }
        ],
        "translations": {
            "kr": "ì•„í”„ê°€ë‹ˆìŠ¤íƒ„",
            "br": "AfeganistÃ£o",
            "pt": "AfeganistÃ£o",
            "nl": "Afghanistan",
            "hr": "Afganistan",
            "fa": "Ø§ÙØºØ§Ù†Ø³ØªØ§Ù†",
            "de": "Afghanistan",
            "es": "AfganistÃ¡n",
            "fr": "Afghanistan",
            "ja": "ã‚¢ãƒ•ã‚¬ãƒ‹ã‚¹ã‚¿ãƒ³",
            "it": "Afghanistan",
            "cn": "é˜¿å¯Œæ±—"
        },
        "latitude": "33.00000000",
        "longitude": "65.00000000",
        "emoji": "ðŸ‡¦ðŸ‡«",
        "emojiU": "U+1F1E6 U+1F1EB",
        "states": [
            {
                "id": 3901,
                "name": "Badakhshan",
                "state_code": "BDS",
                "latitude": "36.73477250",
                "longitude": "70.81199530"
            },
            {
                "id": 3871,
                "name": "Badghis",
                "state_code": "BDG",
                "latitude": "35.16713390",
                "longitude": "63.76953840"
            },
            {
                "id": 3875,
                "name": "Baghlan",
                "state_code": "BGL",
                "latitude": "36.17890260",
                "longitude": "68.74530640"
            },
            {
                "id": 3884,
                "name": "Balkh",
                "state_code": "BAL",
                "latitude": "36.75506030",
                "longitude": "66.89753720"
            },
            {
                "id": 3872,
                "name": "Bamyan",
                "state_code": "BAM",
                "latitude": "34.81000670",
                "longitude": "67.82121040"
            },
            {
                "id": 3892,
                "name": "Daykundi",
                "state_code": "DAY",
                "latitude": "33.66949500",
                "longitude": "66.04635340"
            },
            {
                "id": 3899,
                "name": "Farah",
                "state_code": "FRA",
                "latitude": "32.49532800",
                "longitude": "62.26266270"
            },
            {
                "id": 3889,
                "name": "Faryab",
                "state_code": "FYB",
                "latitude": "36.07956130",
                "longitude": "64.90595500"
            },
            {
                "id": 3870,
                "name": "Ghazni",
                "state_code": "GHA",
                "latitude": "33.54505870",
                "longitude": "68.41739720"
            },
            {
                "id": 3888,
                "name": "GhÅr",
                "state_code": "GHO",
                "latitude": "34.09957760",
                "longitude": "64.90595500"
            },
            {
                "id": 3873,
                "name": "Helmand",
                "state_code": "HEL",
                "latitude": "39.29893610",
                "longitude": "-76.61604720"
            },
            {
                "id": 3887,
                "name": "Herat",
                "state_code": "HER",
                "latitude": "34.35286500",
                "longitude": "62.20402870"
            },
            {
                "id": 3886,
                "name": "Jowzjan",
                "state_code": "JOW",
                "latitude": "36.89696920",
                "longitude": "65.66585680"
            },
            {
                "id": 3902,
                "name": "Kabul",
                "state_code": "KAB",
                "latitude": "34.55534940",
                "longitude": "69.20748600"
            },
            {
                "id": 3890,
                "name": "Kandahar",
                "state_code": "KAN",
                "latitude": "31.62887100",
                "longitude": "65.73717490"
            },
            {
                "id": 3879,
                "name": "Kapisa",
                "state_code": "KAP",
                "latitude": "34.98105720",
                "longitude": "69.62145620"
            },
            {
                "id": 3878,
                "name": "Khost",
                "state_code": "KHO",
                "latitude": "33.33384720",
                "longitude": "69.93716730"
            },
            {
                "id": 3876,
                "name": "Kunar",
                "state_code": "KNR",
                "latitude": "34.84658930",
                "longitude": "71.09731700"
            },
            {
                "id": 3900,
                "name": "Kunduz Province",
                "state_code": "KDZ",
                "latitude": "36.72855110",
                "longitude": "68.86789820"
            },
            {
                "id": 3891,
                "name": "Laghman",
                "state_code": "LAG",
                "latitude": "34.68976870",
                "longitude": "70.14558050"
            },
            {
                "id": 3897,
                "name": "Logar",
                "state_code": "LOG",
                "latitude": "34.01455180",
                "longitude": "69.19239160"
            },
            {
                "id": 3882,
                "name": "Nangarhar",
                "state_code": "NAN",
                "latitude": "34.17183130",
                "longitude": "70.62167940"
            },
            {
                "id": 3896,
                "name": "Nimruz",
                "state_code": "NIM",
                "latitude": "31.02614880",
                "longitude": "62.45041540"
            },
            {
                "id": 3880,
                "name": "Nuristan",
                "state_code": "NUR",
                "latitude": "35.32502230",
                "longitude": "70.90712360"
            },
            {
                "id": 3894,
                "name": "Paktia",
                "state_code": "PIA",
                "latitude": "33.70619900",
                "longitude": "69.38310790"
            },
            {
                "id": 3877,
                "name": "Paktika",
                "state_code": "PKA",
                "latitude": "32.26453860",
                "longitude": "68.52471490"
            },
            {
                "id": 3881,
                "name": "Panjshir",
                "state_code": "PAN",
                "latitude": "38.88023910",
                "longitude": "-77.17172380"
            },
            {
                "id": 3895,
                "name": "Parwan",
                "state_code": "PAR",
                "latitude": "34.96309770",
                "longitude": "68.81088490"
            },
            {
                "id": 3883,
                "name": "Samangan",
                "state_code": "SAM",
                "latitude": "36.31555060",
                "longitude": "67.96428630"
            },
            {
                "id": 3885,
                "name": "Sar-e Pol",
                "state_code": "SAR",
                "latitude": "36.21662800",
                "longitude": "65.93336000"
            },
            {
                "id": 3893,
                "name": "Takhar",
                "state_code": "TAK",
                "latitude": "36.66980130",
                "longitude": "69.47845410"
            },
            {
                "id": 3898,
                "name": "Urozgan",
                "state_code": "URU",
                "latitude": "32.92712870",
                "longitude": "66.14152630"
            },
            {
                "id": 3874,
                "name": "Zabul",
                "state_code": "ZAB",
                "latitude": "32.19187820",
                "longitude": "67.18944880"
            }
        ]
    },
    {
        "name": "Aland Islands",
        "iso3": "ALA",
        "iso2": "AX",
        "phone_code": "+358-18",
        "capital": "Mariehamn",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".ax",
        "native": "Ã…land",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Mariehamn",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ì˜¬ëž€ë“œ ì œë„",
            "br": "Ilhas de Aland",
            "pt": "Ilhas de Aland",
            "nl": "Ã…landeilanden",
            "hr": "Ã…landski otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ø§Ù„Ù†Ø¯",
            "de": "Ã…land",
            "es": "Alandia",
            "fr": "Ã…land",
            "ja": "ã‚ªãƒ¼ãƒ©ãƒ³ãƒ‰è«¸å³¶",
            "it": "Isole Aland",
            "cn": "å¥¥å…°ç¾¤å²›"
        },
        "latitude": "60.11666700",
        "longitude": "19.90000000",
        "emoji": "ðŸ‡¦ðŸ‡½",
        "emojiU": "U+1F1E6 U+1F1FD",
        "states": []
    },
    {
        "name": "Albania",
        "iso3": "ALB",
        "iso2": "AL",
        "phone_code": "355",
        "capital": "Tirana",
        "currency": "ALL",
        "currency_symbol": "Lek",
        "tld": ".al",
        "native": "ShqipÃ«ria",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Tirane",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì•Œë°”ë‹ˆì•„",
            "br": "AlbÃ¢nia",
            "pt": "AlbÃ¢nia",
            "nl": "AlbaniÃ«",
            "hr": "Albanija",
            "fa": "Ø¢Ù„Ø¨Ø§Ù†ÛŒ",
            "de": "Albanien",
            "es": "Albania",
            "fr": "Albanie",
            "ja": "ã‚¢ãƒ«ãƒãƒ‹ã‚¢",
            "it": "Albania",
            "cn": "é˜¿å°”å·´å°¼äºš"
        },
        "latitude": "41.00000000",
        "longitude": "20.00000000",
        "emoji": "ðŸ‡¦ðŸ‡±",
        "emojiU": "U+1F1E6 U+1F1F1",
        "states": [
            {
                "id": 603,
                "name": "Berat County",
                "state_code": "01",
                "latitude": "40.69530120",
                "longitude": "20.04496620"
            },
            {
                "id": 629,
                "name": "Berat District",
                "state_code": "BR",
                "latitude": "40.70863770",
                "longitude": "19.94373140"
            },
            {
                "id": 607,
                "name": "BulqizÃ« District",
                "state_code": "BU",
                "latitude": "41.49425870",
                "longitude": "20.21471570"
            },
            {
                "id": 618,
                "name": "DelvinÃ« District",
                "state_code": "DL",
                "latitude": "39.94813640",
                "longitude": "20.09558910"
            },
            {
                "id": 608,
                "name": "Devoll District",
                "state_code": "DV",
                "latitude": "40.64473470",
                "longitude": "20.95066360"
            },
            {
                "id": 610,
                "name": "DibÃ«r County",
                "state_code": "09",
                "latitude": "41.58881630",
                "longitude": "20.23556470"
            },
            {
                "id": 605,
                "name": "DibÃ«r District",
                "state_code": "DI",
                "latitude": "41.58881630",
                "longitude": "20.23556470"
            },
            {
                "id": 632,
                "name": "DurrÃ«s County",
                "state_code": "02",
                "latitude": "41.50809720",
                "longitude": "19.61631850"
            },
            {
                "id": 639,
                "name": "DurrÃ«s District",
                "state_code": "DR",
                "latitude": "41.37065170",
                "longitude": "19.52110630"
            },
            {
                "id": 598,
                "name": "Elbasan County",
                "state_code": "03",
                "latitude": "41.12666720",
                "longitude": "20.23556470"
            },
            {
                "id": 631,
                "name": "Fier County",
                "state_code": "04",
                "latitude": "40.91913920",
                "longitude": "19.66393090"
            },
            {
                "id": 627,
                "name": "Fier District",
                "state_code": "FR",
                "latitude": "40.72750400",
                "longitude": "19.56275960"
            },
            {
                "id": 604,
                "name": "GjirokastÃ«r County",
                "state_code": "05",
                "latitude": "40.06728740",
                "longitude": "20.10452290"
            },
            {
                "id": 621,
                "name": "GjirokastÃ«r District",
                "state_code": "GJ",
                "latitude": "40.06728740",
                "longitude": "20.10452290"
            },
            {
                "id": 617,
                "name": "Gramsh District",
                "state_code": "GR",
                "latitude": "40.86698730",
                "longitude": "20.18493230"
            },
            {
                "id": 600,
                "name": "Has District",
                "state_code": "HA",
                "latitude": "42.79013360",
                "longitude": "-83.61220120"
            },
            {
                "id": 594,
                "name": "KavajÃ« District",
                "state_code": "KA",
                "latitude": "41.18445290",
                "longitude": "19.56275960"
            },
            {
                "id": 628,
                "name": "KolonjÃ« District",
                "state_code": "ER",
                "latitude": "40.33732620",
                "longitude": "20.67946760"
            },
            {
                "id": 630,
                "name": "KorÃ§Ã« County",
                "state_code": "06",
                "latitude": "40.59056700",
                "longitude": "20.61689210"
            },
            {
                "id": 597,
                "name": "KorÃ§Ã« District",
                "state_code": "KO",
                "latitude": "40.59056700",
                "longitude": "20.61689210"
            },
            {
                "id": 614,
                "name": "KrujÃ« District",
                "state_code": "KR",
                "latitude": "41.50947650",
                "longitude": "19.77107320"
            },
            {
                "id": 612,
                "name": "KuÃ§ovÃ« District",
                "state_code": "KC",
                "latitude": "40.78370630",
                "longitude": "19.87823480"
            },
            {
                "id": 601,
                "name": "KukÃ«s County",
                "state_code": "07",
                "latitude": "42.08074640",
                "longitude": "20.41429230"
            },
            {
                "id": 623,
                "name": "KukÃ«s District",
                "state_code": "KU",
                "latitude": "42.08074640",
                "longitude": "20.41429230"
            },
            {
                "id": 622,
                "name": "Kurbin District",
                "state_code": "KB",
                "latitude": "41.64126440",
                "longitude": "19.70559500"
            },
            {
                "id": 609,
                "name": "LezhÃ« County",
                "state_code": "08",
                "latitude": "41.78137590",
                "longitude": "19.80679160"
            },
            {
                "id": 595,
                "name": "LezhÃ« District",
                "state_code": "LE",
                "latitude": "41.78607300",
                "longitude": "19.64607580"
            },
            {
                "id": 596,
                "name": "Librazhd District",
                "state_code": "LB",
                "latitude": "41.18292320",
                "longitude": "20.31747690"
            },
            {
                "id": 599,
                "name": "LushnjÃ« District",
                "state_code": "LU",
                "latitude": "40.94198300",
                "longitude": "19.69964280"
            },
            {
                "id": 602,
                "name": "MalÃ«si e Madhe District",
                "state_code": "MM",
                "latitude": "42.42451730",
                "longitude": "19.61631850"
            },
            {
                "id": 637,
                "name": "MallakastÃ«r District",
                "state_code": "MK",
                "latitude": "40.52733760",
                "longitude": "19.78297910"
            },
            {
                "id": 635,
                "name": "Mat District",
                "state_code": "MT",
                "latitude": "41.59376750",
                "longitude": "19.99732440"
            },
            {
                "id": 638,
                "name": "MirditÃ« District",
                "state_code": "MR",
                "latitude": "41.76428600",
                "longitude": "19.90205090"
            },
            {
                "id": 619,
                "name": "Peqin District",
                "state_code": "PQ",
                "latitude": "41.04709020",
                "longitude": "19.75023840"
            },
            {
                "id": 625,
                "name": "PÃ«rmet District",
                "state_code": "PR",
                "latitude": "40.23618370",
                "longitude": "20.35173340"
            },
            {
                "id": 606,
                "name": "Pogradec District",
                "state_code": "PG",
                "latitude": "40.90153140",
                "longitude": "20.65562890"
            },
            {
                "id": 620,
                "name": "PukÃ« District",
                "state_code": "PU",
                "latitude": "42.04697720",
                "longitude": "19.89609680"
            },
            {
                "id": 624,
                "name": "SarandÃ« District",
                "state_code": "SR",
                "latitude": "39.85921190",
                "longitude": "20.02710010"
            },
            {
                "id": 611,
                "name": "ShkodÃ«r County",
                "state_code": "10",
                "latitude": "42.15037100",
                "longitude": "19.66393090"
            },
            {
                "id": 626,
                "name": "ShkodÃ«r District",
                "state_code": "SH",
                "latitude": "42.06929850",
                "longitude": "19.50325590"
            },
            {
                "id": 593,
                "name": "Skrapar District",
                "state_code": "SK",
                "latitude": "40.53499460",
                "longitude": "20.28322170"
            },
            {
                "id": 616,
                "name": "TepelenÃ« District",
                "state_code": "TE",
                "latitude": "40.29666320",
                "longitude": "20.01816730"
            },
            {
                "id": 615,
                "name": "Tirana County",
                "state_code": "11",
                "latitude": "41.24275980",
                "longitude": "19.80679160"
            },
            {
                "id": 633,
                "name": "Tirana District",
                "state_code": "TR",
                "latitude": "41.32754590",
                "longitude": "19.81869820"
            },
            {
                "id": 636,
                "name": "TropojÃ« District",
                "state_code": "TP",
                "latitude": "42.39821510",
                "longitude": "20.16259550"
            },
            {
                "id": 634,
                "name": "VlorÃ« County",
                "state_code": "12",
                "latitude": "40.15009600",
                "longitude": "19.80679160"
            },
            {
                "id": 613,
                "name": "VlorÃ« District",
                "state_code": "VL",
                "latitude": "40.46606680",
                "longitude": "19.49135600"
            }
        ]
    },
    {
        "name": "Algeria",
        "iso3": "DZA",
        "iso2": "DZ",
        "phone_code": "213",
        "capital": "Algiers",
        "currency": "DZD",
        "currency_symbol": "Ø¯Ø¬",
        "tld": ".dz",
        "native": "Ø§Ù„Ø¬Ø²Ø§Ø¦Ø±",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Algiers",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì•Œì œë¦¬",
            "br": "ArgÃ©lia",
            "pt": "ArgÃ©lia",
            "nl": "Algerije",
            "hr": "AlÅ¾ir",
            "fa": "Ø§Ù„Ø¬Ø²Ø§ÛŒØ±",
            "de": "Algerien",
            "es": "Argelia",
            "fr": "AlgÃ©rie",
            "ja": "ã‚¢ãƒ«ã‚¸ã‚§ãƒªã‚¢",
            "it": "Algeria",
            "cn": "é˜¿å°”åŠåˆ©äºš"
        },
        "latitude": "28.00000000",
        "longitude": "3.00000000",
        "emoji": "ðŸ‡©ðŸ‡¿",
        "emojiU": "U+1F1E9 U+1F1FF",
        "states": [
            {
                "id": 1118,
                "name": "Adrar",
                "state_code": "01",
                "latitude": "26.41813100",
                "longitude": "-0.60147170"
            },
            {
                "id": 1119,
                "name": "AÃ¯n Defla",
                "state_code": "44",
                "latitude": "36.25094290",
                "longitude": "1.93938150"
            },
            {
                "id": 1122,
                "name": "AÃ¯n TÃ©mouchent",
                "state_code": "46",
                "latitude": "35.29926980",
                "longitude": "-1.13927920"
            },
            {
                "id": 1144,
                "name": "Algiers",
                "state_code": "16",
                "latitude": "36.69972940",
                "longitude": "3.05761990"
            },
            {
                "id": 1103,
                "name": "Annaba",
                "state_code": "23",
                "latitude": "36.80205080",
                "longitude": "7.52472430"
            },
            {
                "id": 1142,
                "name": "Batna",
                "state_code": "05",
                "latitude": "35.59659540",
                "longitude": "5.89871390"
            },
            {
                "id": 1108,
                "name": "BÃ©char",
                "state_code": "08",
                "latitude": "31.62380980",
                "longitude": "-2.21624430"
            },
            {
                "id": 1128,
                "name": "BÃ©jaÃ¯a",
                "state_code": "06",
                "latitude": "36.75152580",
                "longitude": "5.05568370"
            },
            {
                "id": 4909,
                "name": "BÃ©ni AbbÃ¨s",
                "state_code": "53",
                "latitude": "30.08310420",
                "longitude": "-2.83450520"
            },
            {
                "id": 1114,
                "name": "Biskra",
                "state_code": "07",
                "latitude": "34.84494370",
                "longitude": "5.72485670"
            },
            {
                "id": 1111,
                "name": "Blida",
                "state_code": "09",
                "latitude": "36.53112300",
                "longitude": "2.89762540"
            },
            {
                "id": 4908,
                "name": "Bordj Baji Mokhtar",
                "state_code": "52",
                "latitude": "22.96633500",
                "longitude": "-3.94727320"
            },
            {
                "id": 1116,
                "name": "Bordj Bou ArrÃ©ridj",
                "state_code": "34",
                "latitude": "36.07399250",
                "longitude": "4.76302710"
            },
            {
                "id": 1104,
                "name": "BouÃ¯ra",
                "state_code": "10",
                "latitude": "36.36918460",
                "longitude": "3.90061940"
            },
            {
                "id": 1125,
                "name": "BoumerdÃ¨s",
                "state_code": "35",
                "latitude": "36.68395590",
                "longitude": "3.62178020"
            },
            {
                "id": 1105,
                "name": "Chlef",
                "state_code": "02",
                "latitude": "36.16935150",
                "longitude": "1.28910360"
            },
            {
                "id": 1121,
                "name": "Constantine",
                "state_code": "25",
                "latitude": "36.33739110",
                "longitude": "6.66381200"
            },
            {
                "id": 4912,
                "name": "Djanet",
                "state_code": "56",
                "latitude": "23.83108720",
                "longitude": "8.70046720"
            },
            {
                "id": 1098,
                "name": "Djelfa",
                "state_code": "17",
                "latitude": "34.67039560",
                "longitude": "3.25037610"
            },
            {
                "id": 1129,
                "name": "El Bayadh",
                "state_code": "32",
                "latitude": "32.71488240",
                "longitude": "0.90566230"
            },
            {
                "id": 4905,
                "name": "El M'ghair",
                "state_code": "49",
                "latitude": "33.95405610",
                "longitude": "5.13464180"
            },
            {
                "id": 4906,
                "name": "El Menia",
                "state_code": "50",
                "latitude": "31.36422500",
                "longitude": "2.57844950"
            },
            {
                "id": 1099,
                "name": "El Oued",
                "state_code": "39",
                "latitude": "33.36781100",
                "longitude": "6.85165110"
            },
            {
                "id": 1100,
                "name": "El Tarf",
                "state_code": "36",
                "latitude": "36.75766780",
                "longitude": "8.30763430"
            },
            {
                "id": 1127,
                "name": "GhardaÃ¯a",
                "state_code": "47",
                "latitude": "32.49437410",
                "longitude": "3.64446000"
            },
            {
                "id": 1137,
                "name": "Guelma",
                "state_code": "24",
                "latitude": "36.46274440",
                "longitude": "7.43308330"
            },
            {
                "id": 1112,
                "name": "Illizi",
                "state_code": "33",
                "latitude": "26.16900050",
                "longitude": "8.48424650"
            },
            {
                "id": 4914,
                "name": "In Guezzam",
                "state_code": "58",
                "latitude": "20.38643230",
                "longitude": "4.77893940"
            },
            {
                "id": 4913,
                "name": "In Salah",
                "state_code": "57",
                "latitude": "27.21492290",
                "longitude": "1.84843960"
            },
            {
                "id": 1113,
                "name": "Jijel",
                "state_code": "18",
                "latitude": "36.71796810",
                "longitude": "5.98325770"
            },
            {
                "id": 1126,
                "name": "Khenchela",
                "state_code": "40",
                "latitude": "35.42694040",
                "longitude": "7.14601550"
            },
            {
                "id": 1138,
                "name": "Laghouat",
                "state_code": "03",
                "latitude": "33.80783410",
                "longitude": "2.86282940"
            },
            {
                "id": 1134,
                "name": "M'Sila",
                "state_code": "28",
                "latitude": "35.71866460",
                "longitude": "4.52334230"
            },
            {
                "id": 1124,
                "name": "Mascara",
                "state_code": "29",
                "latitude": "35.39041250",
                "longitude": "0.14949880"
            },
            {
                "id": 1109,
                "name": "MÃ©dÃ©a",
                "state_code": "26",
                "latitude": "36.26370780",
                "longitude": "2.75878570"
            },
            {
                "id": 1132,
                "name": "Mila",
                "state_code": "43",
                "latitude": "36.36479570",
                "longitude": "6.15269850"
            },
            {
                "id": 1140,
                "name": "Mostaganem",
                "state_code": "27",
                "latitude": "35.95830540",
                "longitude": "0.33718890"
            },
            {
                "id": 1102,
                "name": "Naama",
                "state_code": "45",
                "latitude": "33.26673170",
                "longitude": "-0.31286590"
            },
            {
                "id": 1101,
                "name": "Oran",
                "state_code": "31",
                "latitude": "35.60823510",
                "longitude": "-0.56360900"
            },
            {
                "id": 1139,
                "name": "Ouargla",
                "state_code": "30",
                "latitude": "32.22648630",
                "longitude": "5.72998210"
            },
            {
                "id": 4907,
                "name": "Ouled Djellal",
                "state_code": "51",
                "latitude": "34.41782210",
                "longitude": "4.96858430"
            },
            {
                "id": 1136,
                "name": "Oum El Bouaghi",
                "state_code": "04",
                "latitude": "35.86887890",
                "longitude": "7.11082660"
            },
            {
                "id": 1130,
                "name": "Relizane",
                "state_code": "48",
                "latitude": "35.73834050",
                "longitude": "0.75328090"
            },
            {
                "id": 1123,
                "name": "SaÃ¯da",
                "state_code": "20",
                "latitude": "34.84152070",
                "longitude": "0.14560550"
            },
            {
                "id": 1141,
                "name": "SÃ©tif",
                "state_code": "19",
                "latitude": "36.30733890",
                "longitude": "5.56172790"
            },
            {
                "id": 4902,
                "name": "Sidi Bel AbbÃ¨s",
                "state_code": "22",
                "latitude": "34.68060240",
                "longitude": "-1.09994950"
            },
            {
                "id": 1110,
                "name": "Skikda",
                "state_code": "21",
                "latitude": "36.67211980",
                "longitude": "6.83509990"
            },
            {
                "id": 1143,
                "name": "Souk Ahras",
                "state_code": "41",
                "latitude": "36.28010620",
                "longitude": "7.93840330"
            },
            {
                "id": 1135,
                "name": "Tamanghasset",
                "state_code": "11",
                "latitude": "22.79029720",
                "longitude": "5.51932680"
            },
            {
                "id": 1117,
                "name": "TÃ©bessa",
                "state_code": "12",
                "latitude": "35.12906910",
                "longitude": "7.95928630"
            },
            {
                "id": 1106,
                "name": "Tiaret",
                "state_code": "14",
                "latitude": "35.37086890",
                "longitude": "1.32178520"
            },
            {
                "id": 4910,
                "name": "Timimoun",
                "state_code": "54",
                "latitude": "29.67890600",
                "longitude": "0.50046080"
            },
            {
                "id": 1120,
                "name": "Tindouf",
                "state_code": "37",
                "latitude": "27.80631190",
                "longitude": "-5.72998210"
            },
            {
                "id": 1115,
                "name": "Tipasa",
                "state_code": "42",
                "latitude": "36.54626500",
                "longitude": "2.18432850"
            },
            {
                "id": 1133,
                "name": "Tissemsilt",
                "state_code": "38",
                "latitude": "35.60537810",
                "longitude": "1.81309800"
            },
            {
                "id": 1131,
                "name": "Tizi Ouzou",
                "state_code": "15",
                "latitude": "36.70691100",
                "longitude": "4.23333550"
            },
            {
                "id": 1107,
                "name": "Tlemcen",
                "state_code": "13",
                "latitude": "34.67802840",
                "longitude": "-1.36621600"
            },
            {
                "id": 4911,
                "name": "Touggourt",
                "state_code": "55",
                "latitude": "33.12484760",
                "longitude": "5.78327150"
            }
        ]
    },
    {
        "name": "American Samoa",
        "iso3": "ASM",
        "iso2": "AS",
        "phone_code": "+1-684",
        "capital": "Pago Pago",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".as",
        "native": "American Samoa",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Pago_Pago",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "SST",
                "tzName": "Samoa Standard Time"
            }
        ],
        "translations": {
            "kr": "ì•„ë©”ë¦¬ì¹¸ì‚¬ëª¨ì•„",
            "br": "Samoa Americana",
            "pt": "Samoa Americana",
            "nl": "Amerikaans Samoa",
            "hr": "AmeriÄka Samoa",
            "fa": "Ø³Ø§Ù…ÙˆØ¢ÛŒ Ø¢Ù…Ø±ÛŒÚ©Ø§",
            "de": "Amerikanisch-Samoa",
            "es": "Samoa Americana",
            "fr": "Samoa amÃ©ricaines",
            "ja": "ã‚¢ãƒ¡ãƒªã‚«é ˜ã‚µãƒ¢ã‚¢",
            "it": "Samoa Americane",
            "cn": "ç¾Žå±žè¨æ‘©äºš"
        },
        "latitude": "-14.33333333",
        "longitude": "-170.00000000",
        "emoji": "ðŸ‡¦ðŸ‡¸",
        "emojiU": "U+1F1E6 U+1F1F8",
        "states": []
    },
    {
        "name": "Andorra",
        "iso3": "AND",
        "iso2": "AD",
        "phone_code": "376",
        "capital": "Andorra la Vella",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".ad",
        "native": "Andorra",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Andorra",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì•ˆë„ë¼",
            "br": "Andorra",
            "pt": "Andorra",
            "nl": "Andorra",
            "hr": "Andora",
            "fa": "Ø¢Ù†Ø¯ÙˆØ±Ø§",
            "de": "Andorra",
            "es": "Andorra",
            "fr": "Andorre",
            "ja": "ã‚¢ãƒ³ãƒ‰ãƒ©",
            "it": "Andorra",
            "cn": "å®‰é“å°”"
        },
        "latitude": "42.50000000",
        "longitude": "1.50000000",
        "emoji": "ðŸ‡¦ðŸ‡©",
        "emojiU": "U+1F1E6 U+1F1E9",
        "states": [
            {
                "id": 488,
                "name": "Andorra la Vella",
                "state_code": "07",
                "latitude": "42.50631740",
                "longitude": "1.52183550"
            },
            {
                "id": 489,
                "name": "Canillo",
                "state_code": "02",
                "latitude": "42.59782490",
                "longitude": "1.65663770"
            },
            {
                "id": 487,
                "name": "Encamp",
                "state_code": "03",
                "latitude": "42.53597640",
                "longitude": "1.58367730"
            },
            {
                "id": 492,
                "name": "Escaldes-Engordany",
                "state_code": "08",
                "latitude": "42.49093790",
                "longitude": "1.58869660"
            },
            {
                "id": 493,
                "name": "La Massana",
                "state_code": "04",
                "latitude": "42.54562500",
                "longitude": "1.51473920"
            },
            {
                "id": 491,
                "name": "Ordino",
                "state_code": "05",
                "latitude": "42.59944330",
                "longitude": "1.54023270"
            },
            {
                "id": 490,
                "name": "Sant JuliÃ  de LÃ²ria",
                "state_code": "06",
                "latitude": "42.45296310",
                "longitude": "1.49182350"
            }
        ]
    },
    {
        "name": "Angola",
        "iso3": "AGO",
        "iso2": "AO",
        "phone_code": "244",
        "capital": "Luanda",
        "currency": "AOA",
        "currency_symbol": "Kz",
        "tld": ".ao",
        "native": "Angola",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Luanda",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì•™ê³¨ë¼",
            "br": "Angola",
            "pt": "Angola",
            "nl": "Angola",
            "hr": "Angola",
            "fa": "Ø¢Ù†Ú¯ÙˆÙ„Ø§",
            "de": "Angola",
            "es": "Angola",
            "fr": "Angola",
            "ja": "ã‚¢ãƒ³ã‚´ãƒ©",
            "it": "Angola",
            "cn": "å®‰å“¥æ‹‰"
        },
        "latitude": "-12.50000000",
        "longitude": "18.50000000",
        "emoji": "ðŸ‡¦ðŸ‡´",
        "emojiU": "U+1F1E6 U+1F1F4",
        "states": [
            {
                "id": 221,
                "name": "Bengo Province",
                "state_code": "BGO",
                "latitude": "-9.10422570",
                "longitude": "13.72891670"
            },
            {
                "id": 218,
                "name": "Benguela Province",
                "state_code": "BGU",
                "latitude": "-12.80037440",
                "longitude": "13.91439900"
            },
            {
                "id": 212,
                "name": "BiÃ© Province",
                "state_code": "BIE",
                "latitude": "-12.57279070",
                "longitude": "17.66888700"
            },
            {
                "id": 228,
                "name": "Cabinda Province",
                "state_code": "CAB",
                "latitude": "-5.02487490",
                "longitude": "12.34638750"
            },
            {
                "id": 226,
                "name": "Cuando Cubango Province",
                "state_code": "CCU",
                "latitude": "-16.41808240",
                "longitude": "18.80761950"
            },
            {
                "id": 217,
                "name": "Cuanza Norte Province",
                "state_code": "CNO",
                "latitude": "-9.23985130",
                "longitude": "14.65878210"
            },
            {
                "id": 216,
                "name": "Cuanza Sul",
                "state_code": "CUS",
                "latitude": "-10.59519100",
                "longitude": "15.40680790"
            },
            {
                "id": 215,
                "name": "Cunene Province",
                "state_code": "CNN",
                "latitude": "-16.28022210",
                "longitude": "16.15809370"
            },
            {
                "id": 213,
                "name": "Huambo Province",
                "state_code": "HUA",
                "latitude": "-12.52682210",
                "longitude": "15.59433880"
            },
            {
                "id": 225,
                "name": "HuÃ­la Province",
                "state_code": "HUI",
                "latitude": "-14.92805530",
                "longitude": "14.65878210"
            },
            {
                "id": 222,
                "name": "Luanda Province",
                "state_code": "LUA",
                "latitude": "-9.03508800",
                "longitude": "13.26634790"
            },
            {
                "id": 223,
                "name": "Lunda Norte Province",
                "state_code": "LNO",
                "latitude": "-8.35250220",
                "longitude": "19.18800470"
            },
            {
                "id": 220,
                "name": "Lunda Sul Province",
                "state_code": "LSU",
                "latitude": "-10.28665780",
                "longitude": "20.71224650"
            },
            {
                "id": 227,
                "name": "Malanje Province",
                "state_code": "MAL",
                "latitude": "-9.82511830",
                "longitude": "16.91225100"
            },
            {
                "id": 219,
                "name": "Moxico Province",
                "state_code": "MOX",
                "latitude": "-13.42935790",
                "longitude": "20.33088140"
            },
            {
                "id": 224,
                "name": "UÃ­ge Province",
                "state_code": "UIG",
                "latitude": "-7.17367320",
                "longitude": "15.40680790"
            },
            {
                "id": 214,
                "name": "Zaire Province",
                "state_code": "ZAI",
                "latitude": "-6.57334580",
                "longitude": "13.17403480"
            }
        ]
    },
    {
        "name": "Anguilla",
        "iso3": "AIA",
        "iso2": "AI",
        "phone_code": "+1-264",
        "capital": "The Valley",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".ai",
        "native": "Anguilla",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì•µê·ˆë¼",
            "br": "Anguila",
            "pt": "Anguila",
            "nl": "Anguilla",
            "hr": "Angvila",
            "fa": "Ø¢Ù†Ú¯ÙˆÛŒÙ„Ø§",
            "de": "Anguilla",
            "es": "Anguilla",
            "fr": "Anguilla",
            "ja": "ã‚¢ãƒ³ã‚®ãƒ©",
            "it": "Anguilla",
            "cn": "å®‰åœ­æ‹‰"
        },
        "latitude": "18.25000000",
        "longitude": "-63.16666666",
        "emoji": "ðŸ‡¦ðŸ‡®",
        "emojiU": "U+1F1E6 U+1F1EE",
        "states": []
    },
    {
        "name": "Antarctica",
        "iso3": "ATA",
        "iso2": "AQ",
        "phone_code": "",
        "capital": "",
        "currency": "",
        "currency_symbol": "$",
        "tld": ".aq",
        "native": "Antarctica",
        "region": "Polar",
        "subregion": "",
        "timezones": [
            {
                "zoneName": "Antarctica\/Casey",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AWST",
                "tzName": "Australian Western Standard Time"
            },
            {
                "zoneName": "Antarctica\/Davis",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "DAVT",
                "tzName": "Davis Time"
            },
            {
                "zoneName": "Antarctica\/DumontDUrville",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "DDUT",
                "tzName": "Dumont d'Urville Time"
            },
            {
                "zoneName": "Antarctica\/Mawson",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MAWT",
                "tzName": "Mawson Station Time"
            },
            {
                "zoneName": "Antarctica\/McMurdo",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "NZDT",
                "tzName": "New Zealand Daylight Time"
            },
            {
                "zoneName": "Antarctica\/Palmer",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "Antarctica\/Rothera",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ROTT",
                "tzName": "Rothera Research Station Time"
            },
            {
                "zoneName": "Antarctica\/Syowa",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "SYOT",
                "tzName": "Showa Station Time"
            },
            {
                "zoneName": "Antarctica\/Troll",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            },
            {
                "zoneName": "Antarctica\/Vostok",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "VOST",
                "tzName": "Vostok Station Time"
            }
        ],
        "translations": {
            "kr": "ë‚¨ê·¹",
            "br": "AntÃ¡rtida",
            "pt": "AntÃ¡rctida",
            "nl": "Antarctica",
            "hr": "Antarktika",
            "fa": "Ø¬Ù†ÙˆØ¨Ú¯Ø§Ù†",
            "de": "Antarktika",
            "es": "AntÃ¡rtida",
            "fr": "Antarctique",
            "ja": "å—æ¥µå¤§é™¸",
            "it": "Antartide",
            "cn": "å—æžæ´²"
        },
        "latitude": "-74.65000000",
        "longitude": "4.48000000",
        "emoji": "ðŸ‡¦ðŸ‡¶",
        "emojiU": "U+1F1E6 U+1F1F6",
        "states": []
    },
    {
        "name": "Antigua And Barbuda",
        "iso3": "ATG",
        "iso2": "AG",
        "phone_code": "+1-268",
        "capital": "St. John's",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".ag",
        "native": "Antigua and Barbuda",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Antigua",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì•¤í‹°ê°€ ë°”ë¶€ë‹¤",
            "br": "AntÃ­gua e Barbuda",
            "pt": "AntÃ­gua e Barbuda",
            "nl": "Antigua en Barbuda",
            "hr": "Antigva i Barbuda",
            "fa": "Ø¢Ù†ØªÛŒÚ¯ÙˆØ§ Ùˆ Ø¨Ø§Ø±Ø¨ÙˆØ¯Ø§",
            "de": "Antigua und Barbuda",
            "es": "Antigua y Barbuda",
            "fr": "Antigua-et-Barbuda",
            "ja": "ã‚¢ãƒ³ãƒ†ã‚£ã‚°ã‚¢ãƒ»ãƒãƒ¼ãƒ–ãƒ¼ãƒ€",
            "it": "Antigua e Barbuda",
            "cn": "å®‰æç“œå’Œå·´å¸ƒè¾¾"
        },
        "latitude": "17.05000000",
        "longitude": "-61.80000000",
        "emoji": "ðŸ‡¦ðŸ‡¬",
        "emojiU": "U+1F1E6 U+1F1EC",
        "states": [
            {
                "id": 3708,
                "name": "Barbuda",
                "state_code": "10",
                "latitude": "17.62662420",
                "longitude": "-61.77130280"
            },
            {
                "id": 3703,
                "name": "Redonda",
                "state_code": "11",
                "latitude": "16.93841600",
                "longitude": "-62.34551480"
            },
            {
                "id": 3709,
                "name": "Saint George Parish",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3706,
                "name": "Saint John Parish",
                "state_code": "04",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3707,
                "name": "Saint Mary Parish",
                "state_code": "05",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3705,
                "name": "Saint Paul Parish",
                "state_code": "06",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3704,
                "name": "Saint Peter Parish",
                "state_code": "07",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3710,
                "name": "Saint Philip Parish",
                "state_code": "08",
                "latitude": "40.43682580",
                "longitude": "-80.06855320"
            }
        ]
    },
    {
        "name": "Argentina",
        "iso3": "ARG",
        "iso2": "AR",
        "phone_code": "54",
        "capital": "Buenos Aires",
        "currency": "ARS",
        "currency_symbol": "$",
        "tld": ".ar",
        "native": "Argentina",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Argentina\/Buenos_Aires",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Catamarca",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Cordoba",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Jujuy",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/La_Rioja",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Mendoza",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Rio_Gallegos",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Salta",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/San_Juan",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/San_Luis",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Tucuman",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            },
            {
                "zoneName": "America\/Argentina\/Ushuaia",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "ART",
                "tzName": "Argentina Time"
            }
        ],
        "translations": {
            "kr": "ì•„ë¥´í—¨í‹°ë‚˜",
            "br": "Argentina",
            "pt": "Argentina",
            "nl": "ArgentiniÃ«",
            "hr": "Argentina",
            "fa": "Ø¢Ø±Ú˜Ø§Ù†ØªÛŒÙ†",
            "de": "Argentinien",
            "es": "Argentina",
            "fr": "Argentine",
            "ja": "ã‚¢ãƒ«ã‚¼ãƒ³ãƒãƒ³",
            "it": "Argentina",
            "cn": "é˜¿æ ¹å»·"
        },
        "latitude": "-34.00000000",
        "longitude": "-64.00000000",
        "emoji": "ðŸ‡¦ðŸ‡·",
        "emojiU": "U+1F1E6 U+1F1F7",
        "states": [
            {
                "id": 4880,
                "name": "Autonomous City Of Buenos Aires",
                "state_code": "C",
                "latitude": "-34.60368440",
                "longitude": "-58.38155910"
            },
            {
                "id": 3656,
                "name": "Buenos Aires Province",
                "state_code": "B",
                "latitude": "-37.20172850",
                "longitude": "-59.84106970"
            },
            {
                "id": 3647,
                "name": "Catamarca Province",
                "state_code": "K",
                "latitude": "-28.47158770",
                "longitude": "-65.78772090"
            },
            {
                "id": 3640,
                "name": "Chaco Province",
                "state_code": "H",
                "latitude": "-27.42571750",
                "longitude": "-59.02437840"
            },
            {
                "id": 3651,
                "name": "Chubut Province",
                "state_code": "U",
                "latitude": "-43.29342460",
                "longitude": "-65.11148180"
            },
            {
                "id": 3642,
                "name": "CÃ³rdoba Province",
                "state_code": "X",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3638,
                "name": "Corrientes",
                "state_code": "W",
                "latitude": "-27.46921310",
                "longitude": "-58.83063490"
            },
            {
                "id": 3654,
                "name": "Entre RÃ­os Province",
                "state_code": "E",
                "latitude": "-31.77466540",
                "longitude": "-60.49564610"
            },
            {
                "id": 3652,
                "name": "Formosa Province",
                "state_code": "P",
                "latitude": "-26.18948040",
                "longitude": "-58.22428060"
            },
            {
                "id": 3645,
                "name": "Jujuy Province",
                "state_code": "Y",
                "latitude": "-24.18433970",
                "longitude": "-65.30217700"
            },
            {
                "id": 3655,
                "name": "La Pampa",
                "state_code": "L",
                "latitude": "-36.61475730",
                "longitude": "-64.28392090"
            },
            {
                "id": 3653,
                "name": "La Rioja Province",
                "state_code": "F",
                "latitude": "-29.41937930",
                "longitude": "-66.85599320"
            },
            {
                "id": 3646,
                "name": "Mendoza",
                "state_code": "M",
                "latitude": "-32.88945870",
                "longitude": "-68.84583860"
            },
            {
                "id": 3644,
                "name": "Misiones Province",
                "state_code": "N",
                "latitude": "-27.42692550",
                "longitude": "-55.94670760"
            },
            {
                "id": 3648,
                "name": "NeuquÃ©n Province",
                "state_code": "Q",
                "latitude": "-38.94587000",
                "longitude": "-68.07309250"
            },
            {
                "id": 3639,
                "name": "RÃ­o Negro Province",
                "state_code": "R",
                "latitude": "-40.82614340",
                "longitude": "-63.02663390"
            },
            {
                "id": 3643,
                "name": "Salta Province",
                "state_code": "A",
                "latitude": "-24.79976880",
                "longitude": "-65.41503670"
            },
            {
                "id": 3634,
                "name": "San Juan Province",
                "state_code": "J",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3636,
                "name": "San Luis Province",
                "state_code": "D",
                "latitude": "-33.29620420",
                "longitude": "-66.32949480"
            },
            {
                "id": 3649,
                "name": "Santa Cruz Province",
                "state_code": "Z",
                "latitude": "-51.63528210",
                "longitude": "-69.24743530"
            },
            {
                "id": 3641,
                "name": "Santa Fe Province",
                "state_code": "S",
                "latitude": "-31.58551090",
                "longitude": "-60.72380160"
            },
            {
                "id": 3635,
                "name": "Santiago del Estero Province",
                "state_code": "G",
                "latitude": "-27.78335740",
                "longitude": "-64.26416700"
            },
            {
                "id": 3650,
                "name": "Tierra del Fuego Province",
                "state_code": "V",
                "latitude": "-54.80539980",
                "longitude": "-68.32420610"
            },
            {
                "id": 3637,
                "name": "TucumÃ¡n Province",
                "state_code": "T",
                "latitude": "-26.82211270",
                "longitude": "-65.21929030"
            }
        ]
    },
    {
        "name": "Armenia",
        "iso3": "ARM",
        "iso2": "AM",
        "phone_code": "374",
        "capital": "Yerevan",
        "currency": "AMD",
        "currency_symbol": "Ö",
        "tld": ".am",
        "native": "Õ€Õ¡ÕµÕ¡Õ½Õ¿Õ¡Õ¶",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Yerevan",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "AMT",
                "tzName": "Armenia Time"
            }
        ],
        "translations": {
            "kr": "ì•„ë¥´ë©”ë‹ˆì•„",
            "br": "ArmÃªnia",
            "pt": "ArmÃ©nia",
            "nl": "ArmeniÃ«",
            "hr": "Armenija",
            "fa": "Ø§Ø±Ù…Ù†Ø³ØªØ§Ù†",
            "de": "Armenien",
            "es": "Armenia",
            "fr": "ArmÃ©nie",
            "ja": "ã‚¢ãƒ«ãƒ¡ãƒ‹ã‚¢",
            "it": "Armenia",
            "cn": "äºšç¾Žå°¼äºš"
        },
        "latitude": "40.00000000",
        "longitude": "45.00000000",
        "emoji": "ðŸ‡¦ðŸ‡²",
        "emojiU": "U+1F1E6 U+1F1F2",
        "states": [
            {
                "id": 2023,
                "name": "Aragatsotn Region",
                "state_code": "AG",
                "latitude": "40.33473010",
                "longitude": "44.37482960"
            },
            {
                "id": 2024,
                "name": "Ararat Province",
                "state_code": "AR",
                "latitude": "39.91394150",
                "longitude": "44.72000040"
            },
            {
                "id": 2026,
                "name": "Armavir Region",
                "state_code": "AV",
                "latitude": "40.15546310",
                "longitude": "44.03724460"
            },
            {
                "id": 2028,
                "name": "Gegharkunik Province",
                "state_code": "GR",
                "latitude": "40.35264260",
                "longitude": "45.12604140"
            },
            {
                "id": 2033,
                "name": "Kotayk Region",
                "state_code": "KT",
                "latitude": "40.54102140",
                "longitude": "44.76901480"
            },
            {
                "id": 2029,
                "name": "Lori Region",
                "state_code": "LO",
                "latitude": "40.96984520",
                "longitude": "44.49001380"
            },
            {
                "id": 2031,
                "name": "Shirak Region",
                "state_code": "SH",
                "latitude": "40.96308140",
                "longitude": "43.81024610"
            },
            {
                "id": 2027,
                "name": "Syunik Province",
                "state_code": "SU",
                "latitude": "39.51331120",
                "longitude": "46.33932340"
            },
            {
                "id": 2032,
                "name": "Tavush Region",
                "state_code": "TV",
                "latitude": "40.88662960",
                "longitude": "45.33934900"
            },
            {
                "id": 2025,
                "name": "Vayots Dzor Region",
                "state_code": "VD",
                "latitude": "39.76419960",
                "longitude": "45.33375280"
            },
            {
                "id": 2030,
                "name": "Yerevan",
                "state_code": "ER",
                "latitude": "40.18720230",
                "longitude": "44.51520900"
            }
        ]
    },
    {
        "name": "Aruba",
        "iso3": "ABW",
        "iso2": "AW",
        "phone_code": "297",
        "capital": "Oranjestad",
        "currency": "AWG",
        "currency_symbol": "Æ’",
        "tld": ".aw",
        "native": "Aruba",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Aruba",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì•„ë£¨ë°”",
            "br": "Aruba",
            "pt": "Aruba",
            "nl": "Aruba",
            "hr": "Aruba",
            "fa": "Ø¢Ø±ÙˆØ¨Ø§",
            "de": "Aruba",
            "es": "Aruba",
            "fr": "Aruba",
            "ja": "ã‚¢ãƒ«ãƒ",
            "it": "Aruba",
            "cn": "é˜¿é²å·´"
        },
        "latitude": "12.50000000",
        "longitude": "-69.96666666",
        "emoji": "ðŸ‡¦ðŸ‡¼",
        "emojiU": "U+1F1E6 U+1F1FC",
        "states": []
    },
    {
        "name": "Australia",
        "iso3": "AUS",
        "iso2": "AU",
        "phone_code": "61",
        "capital": "Canberra",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".au",
        "native": "Australia",
        "region": "Oceania",
        "subregion": "Australia and New Zealand",
        "timezones": [
            {
                "zoneName": "Antarctica\/Macquarie",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "MIST",
                "tzName": "Macquarie Island Station Time"
            },
            {
                "zoneName": "Australia\/Adelaide",
                "gmtOffset": 37800,
                "gmtOffsetName": "UTC+10:30",
                "abbreviation": "ACDT",
                "tzName": "Australian Central Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Brisbane",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "AEST",
                "tzName": "Australian Eastern Standard Time"
            },
            {
                "zoneName": "Australia\/Broken_Hill",
                "gmtOffset": 37800,
                "gmtOffsetName": "UTC+10:30",
                "abbreviation": "ACDT",
                "tzName": "Australian Central Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Currie",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Darwin",
                "gmtOffset": 34200,
                "gmtOffsetName": "UTC+09:30",
                "abbreviation": "ACST",
                "tzName": "Australian Central Standard Time"
            },
            {
                "zoneName": "Australia\/Eucla",
                "gmtOffset": 31500,
                "gmtOffsetName": "UTC+08:45",
                "abbreviation": "ACWST",
                "tzName": "Australian Central Western Standard Time (Unofficial)"
            },
            {
                "zoneName": "Australia\/Hobart",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Lindeman",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "AEST",
                "tzName": "Australian Eastern Standard Time"
            },
            {
                "zoneName": "Australia\/Lord_Howe",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "LHST",
                "tzName": "Lord Howe Summer Time"
            },
            {
                "zoneName": "Australia\/Melbourne",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            },
            {
                "zoneName": "Australia\/Perth",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "AWST",
                "tzName": "Australian Western Standard Time"
            },
            {
                "zoneName": "Australia\/Sydney",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "AEDT",
                "tzName": "Australian Eastern Daylight Saving Time"
            }
        ],
        "translations": {
            "kr": "í˜¸ì£¼",
            "br": "AustrÃ¡lia",
            "pt": "AustrÃ¡lia",
            "nl": "AustraliÃ«",
            "hr": "Australija",
            "fa": "Ø§Ø³ØªØ±Ø§Ù„ÛŒØ§",
            "de": "Australien",
            "es": "Australia",
            "fr": "Australie",
            "ja": "ã‚ªãƒ¼ã‚¹ãƒˆãƒ©ãƒªã‚¢",
            "it": "Australia",
            "cn": "æ¾³å¤§åˆ©äºš"
        },
        "latitude": "-27.00000000",
        "longitude": "133.00000000",
        "emoji": "ðŸ‡¦ðŸ‡º",
        "emojiU": "U+1F1E6 U+1F1FA",
        "states": [
            {
                "id": 3907,
                "name": "Australian Capital Territory",
                "state_code": "ACT",
                "latitude": "-35.47346790",
                "longitude": "149.01236790"
            },
            {
                "id": 3909,
                "name": "New South Wales",
                "state_code": "NSW",
                "latitude": "-31.25321830",
                "longitude": "146.92109900"
            },
            {
                "id": 3910,
                "name": "Northern Territory",
                "state_code": "NT",
                "latitude": "-19.49141080",
                "longitude": "132.55096030"
            },
            {
                "id": 3905,
                "name": "Queensland",
                "state_code": "QLD",
                "latitude": "-20.91757380",
                "longitude": "142.70279560"
            },
            {
                "id": 3904,
                "name": "South Australia",
                "state_code": "SA",
                "latitude": "-30.00023150",
                "longitude": "136.20915470"
            },
            {
                "id": 3908,
                "name": "Tasmania",
                "state_code": "TAS",
                "latitude": "-41.45451960",
                "longitude": "145.97066470"
            },
            {
                "id": 3903,
                "name": "Victoria",
                "state_code": "VIC",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3906,
                "name": "Western Australia",
                "state_code": "WA",
                "latitude": "-27.67281680",
                "longitude": "121.62830980"
            }
        ]
    },
    {
        "name": "Austria",
        "iso3": "AUT",
        "iso2": "AT",
        "phone_code": "43",
        "capital": "Vienna",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".at",
        "native": "Ã–sterreich",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Vienna",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì˜¤ìŠ¤íŠ¸ë¦¬ì•„",
            "br": "Ã¡ustria",
            "pt": "Ã¡ustria",
            "nl": "Oostenrijk",
            "hr": "Austrija",
            "fa": "Ø§ØªØ±ÛŒØ´",
            "de": "Ã–sterreich",
            "es": "Austria",
            "fr": "Autriche",
            "ja": "ã‚ªãƒ¼ã‚¹ãƒˆãƒªã‚¢",
            "it": "Austria",
            "cn": "å¥¥åœ°åˆ©"
        },
        "latitude": "47.33333333",
        "longitude": "13.33333333",
        "emoji": "ðŸ‡¦ðŸ‡¹",
        "emojiU": "U+1F1E6 U+1F1F9",
        "states": [
            {
                "id": 2062,
                "name": "Burgenland",
                "state_code": "1",
                "latitude": "47.15371650",
                "longitude": "16.26887970"
            },
            {
                "id": 2057,
                "name": "Carinthia",
                "state_code": "2",
                "latitude": "46.72220300",
                "longitude": "14.18058820"
            },
            {
                "id": 2065,
                "name": "Lower Austria",
                "state_code": "3",
                "latitude": "48.10807700",
                "longitude": "15.80495580"
            },
            {
                "id": 2061,
                "name": "Salzburg",
                "state_code": "5",
                "latitude": "47.80949000",
                "longitude": "13.05501000"
            },
            {
                "id": 2059,
                "name": "Styria",
                "state_code": "6",
                "latitude": "47.35934420",
                "longitude": "14.46998270"
            },
            {
                "id": 2064,
                "name": "Tyrol",
                "state_code": "7",
                "latitude": "47.25374140",
                "longitude": "11.60148700"
            },
            {
                "id": 2058,
                "name": "Upper Austria",
                "state_code": "4",
                "latitude": "48.02585400",
                "longitude": "13.97236650"
            },
            {
                "id": 2060,
                "name": "Vienna",
                "state_code": "9",
                "latitude": "48.20817430",
                "longitude": "16.37381890"
            },
            {
                "id": 2063,
                "name": "Vorarlberg",
                "state_code": "8",
                "latitude": "47.24974270",
                "longitude": "9.97973730"
            }
        ]
    },
    {
        "name": "Azerbaijan",
        "iso3": "AZE",
        "iso2": "AZ",
        "phone_code": "994",
        "capital": "Baku",
        "currency": "AZN",
        "currency_symbol": "m",
        "tld": ".az",
        "native": "AzÉ™rbaycan",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Baku",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "AZT",
                "tzName": "Azerbaijan Time"
            }
        ],
        "translations": {
            "kr": "ì•„ì œë¥´ë°”ì´ìž”",
            "br": "AzerbaijÃ£o",
            "pt": "AzerbaijÃ£o",
            "nl": "Azerbeidzjan",
            "hr": "AzerbajdÅ¾an",
            "fa": "Ø¢Ø°Ø±Ø¨Ø§ÛŒØ¬Ø§Ù†",
            "de": "Aserbaidschan",
            "es": "AzerbaiyÃ¡n",
            "fr": "AzerbaÃ¯djan",
            "ja": "ã‚¢ã‚¼ãƒ«ãƒã‚¤ã‚¸ãƒ£ãƒ³",
            "it": "Azerbaijan",
            "cn": "é˜¿å¡žæ‹œç–†"
        },
        "latitude": "40.50000000",
        "longitude": "47.50000000",
        "emoji": "ðŸ‡¦ðŸ‡¿",
        "emojiU": "U+1F1E6 U+1F1FF",
        "states": [
            {
                "id": 540,
                "name": "Absheron District",
                "state_code": "ABS",
                "latitude": "40.36296930",
                "longitude": "49.27368150"
            },
            {
                "id": 559,
                "name": "Agdam District",
                "state_code": "AGM",
                "latitude": "39.99318530",
                "longitude": "46.99495620"
            },
            {
                "id": 553,
                "name": "Agdash District",
                "state_code": "AGS",
                "latitude": "40.63354270",
                "longitude": "47.46743100"
            },
            {
                "id": 577,
                "name": "Aghjabadi District",
                "state_code": "AGC",
                "latitude": "28.78918410",
                "longitude": "77.51607880"
            },
            {
                "id": 543,
                "name": "Agstafa District",
                "state_code": "AGA",
                "latitude": "41.26559330",
                "longitude": "45.51342910"
            },
            {
                "id": 547,
                "name": "Agsu District",
                "state_code": "AGU",
                "latitude": "40.52833390",
                "longitude": "48.36508350"
            },
            {
                "id": 528,
                "name": "Astara District",
                "state_code": "AST",
                "latitude": "38.49378450",
                "longitude": "48.69443650"
            },
            {
                "id": 575,
                "name": "Babek District",
                "state_code": "BAB",
                "latitude": "39.15076130",
                "longitude": "45.44853680"
            },
            {
                "id": 552,
                "name": "Baku",
                "state_code": "BA",
                "latitude": "40.40926170",
                "longitude": "49.86709240"
            },
            {
                "id": 560,
                "name": "Balakan District",
                "state_code": "BAL",
                "latitude": "41.70375090",
                "longitude": "46.40442130"
            },
            {
                "id": 569,
                "name": "Barda District",
                "state_code": "BAR",
                "latitude": "40.37065550",
                "longitude": "47.13789090"
            },
            {
                "id": 554,
                "name": "Beylagan District",
                "state_code": "BEY",
                "latitude": "39.77230730",
                "longitude": "47.61541660"
            },
            {
                "id": 532,
                "name": "Bilasuvar District",
                "state_code": "BIL",
                "latitude": "39.45988330",
                "longitude": "48.55098130"
            },
            {
                "id": 561,
                "name": "Dashkasan District",
                "state_code": "DAS",
                "latitude": "40.52022570",
                "longitude": "46.07793040"
            },
            {
                "id": 527,
                "name": "Fizuli District",
                "state_code": "FUZ",
                "latitude": "39.53786050",
                "longitude": "47.30338770"
            },
            {
                "id": 585,
                "name": "Ganja",
                "state_code": "GA",
                "latitude": "36.36873380",
                "longitude": "-95.99857670"
            },
            {
                "id": 589,
                "name": "GÉ™dÉ™bÉ™y",
                "state_code": "GAD",
                "latitude": "40.56996390",
                "longitude": "45.81068830"
            },
            {
                "id": 573,
                "name": "Gobustan District",
                "state_code": "QOB",
                "latitude": "40.53261040",
                "longitude": "48.92737500"
            },
            {
                "id": 551,
                "name": "Goranboy District",
                "state_code": "GOR",
                "latitude": "40.53805060",
                "longitude": "46.59908910"
            },
            {
                "id": 531,
                "name": "Goychay",
                "state_code": "GOY",
                "latitude": "40.62361680",
                "longitude": "47.74030340"
            },
            {
                "id": 574,
                "name": "Goygol District",
                "state_code": "GYG",
                "latitude": "40.55953780",
                "longitude": "46.33149530"
            },
            {
                "id": 571,
                "name": "Hajigabul District",
                "state_code": "HAC",
                "latitude": "40.03937700",
                "longitude": "48.92025330"
            },
            {
                "id": 544,
                "name": "Imishli District",
                "state_code": "IMI",
                "latitude": "39.86946860",
                "longitude": "48.06652180"
            },
            {
                "id": 564,
                "name": "Ismailli District",
                "state_code": "ISM",
                "latitude": "40.74299360",
                "longitude": "48.21255560"
            },
            {
                "id": 570,
                "name": "Jabrayil District",
                "state_code": "CAB",
                "latitude": "39.26455440",
                "longitude": "46.96215620"
            },
            {
                "id": 578,
                "name": "Jalilabad District",
                "state_code": "CAL",
                "latitude": "39.20516320",
                "longitude": "48.51006040"
            },
            {
                "id": 572,
                "name": "Julfa District",
                "state_code": "CUL",
                "latitude": "38.96049830",
                "longitude": "45.62929390"
            },
            {
                "id": 525,
                "name": "Kalbajar District",
                "state_code": "KAL",
                "latitude": "40.10243290",
                "longitude": "46.03648720"
            },
            {
                "id": 567,
                "name": "Kangarli District",
                "state_code": "KAN",
                "latitude": "39.38719400",
                "longitude": "45.16398520"
            },
            {
                "id": 590,
                "name": "Khachmaz District",
                "state_code": "XAC",
                "latitude": "41.45911680",
                "longitude": "48.80206260"
            },
            {
                "id": 537,
                "name": "Khizi District",
                "state_code": "XIZ",
                "latitude": "40.91094890",
                "longitude": "49.07292640"
            },
            {
                "id": 524,
                "name": "Khojali District",
                "state_code": "XCI",
                "latitude": "39.91325530",
                "longitude": "46.79430500"
            },
            {
                "id": 549,
                "name": "Kurdamir District",
                "state_code": "KUR",
                "latitude": "40.36986510",
                "longitude": "48.16446260"
            },
            {
                "id": 541,
                "name": "Lachin District",
                "state_code": "LAC",
                "latitude": "39.63834140",
                "longitude": "46.54608530"
            },
            {
                "id": 587,
                "name": "Lankaran",
                "state_code": "LAN",
                "latitude": "38.75286690",
                "longitude": "48.84750150"
            },
            {
                "id": 558,
                "name": "Lankaran District",
                "state_code": "LA",
                "latitude": "38.75286690",
                "longitude": "48.84750150"
            },
            {
                "id": 546,
                "name": "Lerik District",
                "state_code": "LER",
                "latitude": "38.77361920",
                "longitude": "48.41514830"
            },
            {
                "id": 568,
                "name": "Martuni",
                "state_code": "XVD",
                "latitude": "39.79146930",
                "longitude": "47.11008140"
            },
            {
                "id": 555,
                "name": "Masally District",
                "state_code": "MAS",
                "latitude": "39.03407220",
                "longitude": "48.65893540"
            },
            {
                "id": 580,
                "name": "Mingachevir",
                "state_code": "MI",
                "latitude": "40.77025630",
                "longitude": "47.04960150"
            },
            {
                "id": 562,
                "name": "Nakhchivan Autonomous Republic",
                "state_code": "NX",
                "latitude": "39.32568140",
                "longitude": "45.49126480"
            },
            {
                "id": 530,
                "name": "Neftchala District",
                "state_code": "NEF",
                "latitude": "39.38810520",
                "longitude": "49.24137430"
            },
            {
                "id": 556,
                "name": "Oghuz District",
                "state_code": "OGU",
                "latitude": "41.07279240",
                "longitude": "47.46506720"
            },
            {
                "id": 534,
                "name": "Ordubad District",
                "state_code": "ORD",
                "latitude": "38.90216220",
                "longitude": "46.02376250"
            },
            {
                "id": 542,
                "name": "Qabala District",
                "state_code": "QAB",
                "latitude": "40.92539250",
                "longitude": "47.80161060"
            },
            {
                "id": 526,
                "name": "Qakh District",
                "state_code": "QAX",
                "latitude": "41.42068270",
                "longitude": "46.93201840"
            },
            {
                "id": 521,
                "name": "Qazakh District",
                "state_code": "QAZ",
                "latitude": "41.09710740",
                "longitude": "45.35163310"
            },
            {
                "id": 563,
                "name": "Quba District",
                "state_code": "QBA",
                "latitude": "41.15642420",
                "longitude": "48.41350210"
            },
            {
                "id": 548,
                "name": "Qubadli District",
                "state_code": "QBI",
                "latitude": "39.27139960",
                "longitude": "46.63543120"
            },
            {
                "id": 588,
                "name": "Qusar District",
                "state_code": "QUS",
                "latitude": "41.42668860",
                "longitude": "48.43455770"
            },
            {
                "id": 557,
                "name": "Saatly District",
                "state_code": "SAT",
                "latitude": "39.90955030",
                "longitude": "48.35951220"
            },
            {
                "id": 565,
                "name": "Sabirabad District",
                "state_code": "SAB",
                "latitude": "39.98706630",
                "longitude": "48.46925450"
            },
            {
                "id": 522,
                "name": "Sadarak District",
                "state_code": "SAD",
                "latitude": "39.71051140",
                "longitude": "44.88642770"
            },
            {
                "id": 545,
                "name": "Salyan District",
                "state_code": "SAL",
                "latitude": "28.35248110",
                "longitude": "82.12784000"
            },
            {
                "id": 536,
                "name": "Samukh District",
                "state_code": "SMX",
                "latitude": "40.76046310",
                "longitude": "46.40631810"
            },
            {
                "id": 591,
                "name": "Shabran District",
                "state_code": "SBN",
                "latitude": "41.22283760",
                "longitude": "48.84573040"
            },
            {
                "id": 579,
                "name": "Shahbuz District",
                "state_code": "SAH",
                "latitude": "39.44521030",
                "longitude": "45.65680090"
            },
            {
                "id": 518,
                "name": "Shaki",
                "state_code": "SA",
                "latitude": "41.19747530",
                "longitude": "47.15712410"
            },
            {
                "id": 586,
                "name": "Shaki District",
                "state_code": "SAK",
                "latitude": "41.11346620",
                "longitude": "47.13169270"
            },
            {
                "id": 529,
                "name": "Shamakhi District",
                "state_code": "SMI",
                "latitude": "40.63187310",
                "longitude": "48.63638010"
            },
            {
                "id": 583,
                "name": "Shamkir District",
                "state_code": "SKR",
                "latitude": "40.82881440",
                "longitude": "46.01668790"
            },
            {
                "id": 535,
                "name": "Sharur District",
                "state_code": "SAR",
                "latitude": "39.55363320",
                "longitude": "44.98456800"
            },
            {
                "id": 520,
                "name": "Shirvan",
                "state_code": "SR",
                "latitude": "39.94697070",
                "longitude": "48.92239190"
            },
            {
                "id": 592,
                "name": "Shusha District",
                "state_code": "SUS",
                "latitude": "39.75374380",
                "longitude": "46.74647550"
            },
            {
                "id": 584,
                "name": "Siazan District",
                "state_code": "SIY",
                "latitude": "41.07838330",
                "longitude": "49.11184770"
            },
            {
                "id": 582,
                "name": "Sumqayit",
                "state_code": "SM",
                "latitude": "40.58547650",
                "longitude": "49.63174110"
            },
            {
                "id": 519,
                "name": "Tartar District",
                "state_code": "TAR",
                "latitude": "40.34438750",
                "longitude": "46.93765190"
            },
            {
                "id": 533,
                "name": "Tovuz District",
                "state_code": "TOV",
                "latitude": "40.99545230",
                "longitude": "45.61659070"
            },
            {
                "id": 539,
                "name": "Ujar District",
                "state_code": "UCA",
                "latitude": "40.50675250",
                "longitude": "47.64896410"
            },
            {
                "id": 550,
                "name": "Yardymli District",
                "state_code": "YAR",
                "latitude": "38.90589170",
                "longitude": "48.24961270"
            },
            {
                "id": 538,
                "name": "Yevlakh",
                "state_code": "YE",
                "latitude": "40.61966380",
                "longitude": "47.15003240"
            },
            {
                "id": 523,
                "name": "Yevlakh District",
                "state_code": "YEV",
                "latitude": "40.61966380",
                "longitude": "47.15003240"
            },
            {
                "id": 581,
                "name": "Zangilan District",
                "state_code": "ZAN",
                "latitude": "39.08568990",
                "longitude": "46.65247280"
            },
            {
                "id": 566,
                "name": "Zaqatala District",
                "state_code": "ZAQ",
                "latitude": "41.59068890",
                "longitude": "46.72403730"
            },
            {
                "id": 576,
                "name": "Zardab District",
                "state_code": "ZAR",
                "latitude": "40.21481140",
                "longitude": "47.71494400"
            }
        ]
    },
    {
        "name": "Bahamas The",
        "iso3": "BHS",
        "iso2": "BS",
        "phone_code": "+1-242",
        "capital": "Nassau",
        "currency": "BSD",
        "currency_symbol": "B$",
        "tld": ".bs",
        "native": "Bahamas",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Nassau",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America)"
            }
        ],
        "translations": {
            "kr": "ë°”í•˜ë§ˆ",
            "br": "Bahamas",
            "pt": "Baamas",
            "nl": "Bahamaâ€™s",
            "hr": "Bahami",
            "fa": "Ø¨Ø§Ù‡Ø§Ù…Ø§",
            "de": "Bahamas",
            "es": "Bahamas",
            "fr": "Bahamas",
            "ja": "ãƒãƒãƒž",
            "it": "Bahamas",
            "cn": "å·´å“ˆé©¬"
        },
        "latitude": "24.25000000",
        "longitude": "-76.00000000",
        "emoji": "ðŸ‡§ðŸ‡¸",
        "emojiU": "U+1F1E7 U+1F1F8",
        "states": [
            {
                "id": 3601,
                "name": "Acklins",
                "state_code": "AK",
                "latitude": "22.36577080",
                "longitude": "-74.05351260"
            },
            {
                "id": 3628,
                "name": "Acklins and Crooked Islands",
                "state_code": "AC",
                "latitude": "22.36577080",
                "longitude": "-74.05351260"
            },
            {
                "id": 3593,
                "name": "Berry Islands",
                "state_code": "BY",
                "latitude": "25.62500420",
                "longitude": "-77.82522030"
            },
            {
                "id": 3629,
                "name": "Bimini",
                "state_code": "BI",
                "latitude": "24.64153250",
                "longitude": "-79.85062260"
            },
            {
                "id": 3605,
                "name": "Black Point",
                "state_code": "BP",
                "latitude": "41.39510240",
                "longitude": "-71.46505560"
            },
            {
                "id": 3611,
                "name": "Cat Island",
                "state_code": "CI",
                "latitude": "30.22801360",
                "longitude": "-89.10149330"
            },
            {
                "id": 3603,
                "name": "Central Abaco",
                "state_code": "CO",
                "latitude": "26.35550290",
                "longitude": "-77.14851630"
            },
            {
                "id": 3631,
                "name": "Central Andros",
                "state_code": "CS",
                "latitude": "24.46884820",
                "longitude": "-77.97386500"
            },
            {
                "id": 3596,
                "name": "Central Eleuthera",
                "state_code": "CE",
                "latitude": "25.13620370",
                "longitude": "-76.14359150"
            },
            {
                "id": 3621,
                "name": "Crooked Island",
                "state_code": "CK",
                "latitude": "22.63909820",
                "longitude": "-74.00650900"
            },
            {
                "id": 3614,
                "name": "East Grand Bahama",
                "state_code": "EG",
                "latitude": "26.65828230",
                "longitude": "-78.22482910"
            },
            {
                "id": 3612,
                "name": "Exuma",
                "state_code": "EX",
                "latitude": "23.61925980",
                "longitude": "-75.96954650"
            },
            {
                "id": 3626,
                "name": "Freeport",
                "state_code": "FP",
                "latitude": "42.29668610",
                "longitude": "-89.62122710"
            },
            {
                "id": 3619,
                "name": "Fresh Creek",
                "state_code": "FC",
                "latitude": "40.65437560",
                "longitude": "-73.89479390"
            },
            {
                "id": 3597,
                "name": "Governor's Harbour",
                "state_code": "GH",
                "latitude": "25.19480960",
                "longitude": "-76.24396220"
            },
            {
                "id": 3632,
                "name": "Grand Cay",
                "state_code": "GC",
                "latitude": "27.21626150",
                "longitude": "-78.32305590"
            },
            {
                "id": 3595,
                "name": "Green Turtle Cay",
                "state_code": "GT",
                "latitude": "26.77471070",
                "longitude": "-77.32957080"
            },
            {
                "id": 3613,
                "name": "Harbour Island",
                "state_code": "HI",
                "latitude": "25.50011000",
                "longitude": "-76.63405110"
            },
            {
                "id": 3598,
                "name": "High Rock",
                "state_code": "HR",
                "latitude": "46.68434150",
                "longitude": "-121.90174610"
            },
            {
                "id": 3624,
                "name": "Hope Town",
                "state_code": "HT",
                "latitude": "26.50095040",
                "longitude": "-76.99598720"
            },
            {
                "id": 3609,
                "name": "Inagua",
                "state_code": "IN",
                "latitude": "21.06560660",
                "longitude": "-73.32370800"
            },
            {
                "id": 3618,
                "name": "Kemps Bay",
                "state_code": "KB",
                "latitude": "24.02364000",
                "longitude": "-77.54534900"
            },
            {
                "id": 3610,
                "name": "Long Island",
                "state_code": "LI",
                "latitude": "40.78914200",
                "longitude": "-73.13496100"
            },
            {
                "id": 3625,
                "name": "Mangrove Cay",
                "state_code": "MC",
                "latitude": "24.14814250",
                "longitude": "-77.76809520"
            },
            {
                "id": 3604,
                "name": "Marsh Harbour",
                "state_code": "MH",
                "latitude": "26.52416530",
                "longitude": "-77.09098090"
            },
            {
                "id": 3633,
                "name": "Mayaguana District",
                "state_code": "MG",
                "latitude": "22.40177140",
                "longitude": "-73.06413960"
            },
            {
                "id": 4881,
                "name": "New Providence",
                "state_code": "NP",
                "latitude": "40.69843480",
                "longitude": "-74.40154050"
            },
            {
                "id": 3594,
                "name": "Nichollstown and Berry Islands",
                "state_code": "NB",
                "latitude": "25.72362340",
                "longitude": "-77.83101040"
            },
            {
                "id": 3616,
                "name": "North Abaco",
                "state_code": "NO",
                "latitude": "26.78716970",
                "longitude": "-77.43577390"
            },
            {
                "id": 3617,
                "name": "North Andros",
                "state_code": "NS",
                "latitude": "24.70638050",
                "longitude": "-78.01953870"
            },
            {
                "id": 3602,
                "name": "North Eleuthera",
                "state_code": "NE",
                "latitude": "25.46475170",
                "longitude": "-76.67592200"
            },
            {
                "id": 3615,
                "name": "Ragged Island",
                "state_code": "RI",
                "latitude": "41.59743100",
                "longitude": "-71.26020200"
            },
            {
                "id": 3623,
                "name": "Rock Sound",
                "state_code": "RS",
                "latitude": "39.01424430",
                "longitude": "-95.67089890"
            },
            {
                "id": 3600,
                "name": "Rum Cay District",
                "state_code": "RC",
                "latitude": "23.68546760",
                "longitude": "-74.83901620"
            },
            {
                "id": 3620,
                "name": "San Salvador and Rum Cay",
                "state_code": "SR",
                "latitude": "23.68546760",
                "longitude": "-74.83901620"
            },
            {
                "id": 3627,
                "name": "San Salvador Island",
                "state_code": "SS",
                "latitude": "24.07755460",
                "longitude": "-74.47600880"
            },
            {
                "id": 3606,
                "name": "Sandy Point",
                "state_code": "SP",
                "latitude": "39.01454640",
                "longitude": "-76.39989250"
            },
            {
                "id": 3608,
                "name": "South Abaco",
                "state_code": "SO",
                "latitude": "26.06405910",
                "longitude": "-77.26350380"
            },
            {
                "id": 3622,
                "name": "South Andros",
                "state_code": "SA",
                "latitude": "23.97135560",
                "longitude": "-77.60778650"
            },
            {
                "id": 3607,
                "name": "South Eleuthera",
                "state_code": "SE",
                "latitude": "24.77085620",
                "longitude": "-76.21314740"
            },
            {
                "id": 3630,
                "name": "Spanish Wells",
                "state_code": "SW",
                "latitude": "26.32505990",
                "longitude": "-81.79803280"
            },
            {
                "id": 3599,
                "name": "West Grand Bahama",
                "state_code": "WG",
                "latitude": "26.65944700",
                "longitude": "-78.52065000"
            }
        ]
    },
    {
        "name": "Bahrain",
        "iso3": "BHR",
        "iso2": "BH",
        "phone_code": "973",
        "capital": "Manama",
        "currency": "BHD",
        "currency_symbol": ".Ø¯.Ø¨",
        "tld": ".bh",
        "native": "â€Ø§Ù„Ø¨Ø­Ø±ÙŠÙ†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Bahrain",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ë°”ë ˆì¸",
            "br": "Bahrein",
            "pt": "BarÃ©m",
            "nl": "Bahrein",
            "hr": "Bahrein",
            "fa": "Ø¨Ø­Ø±ÛŒÙ†",
            "de": "Bahrain",
            "es": "Bahrein",
            "fr": "BahreÃ¯n",
            "ja": "ãƒãƒ¼ãƒ¬ãƒ¼ãƒ³",
            "it": "Bahrein",
            "cn": "å·´æž—"
        },
        "latitude": "26.00000000",
        "longitude": "50.55000000",
        "emoji": "ðŸ‡§ðŸ‡­",
        "emojiU": "U+1F1E7 U+1F1ED",
        "states": [
            {
                "id": 1992,
                "name": "Capital Governorate",
                "state_code": "13",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 1996,
                "name": "Central Governorate",
                "state_code": "16",
                "latitude": "26.14260930",
                "longitude": "50.56532940"
            },
            {
                "id": 1995,
                "name": "Muharraq Governorate",
                "state_code": "15",
                "latitude": "26.26856530",
                "longitude": "50.64825170"
            },
            {
                "id": 1994,
                "name": "Northern Governorate",
                "state_code": "17",
                "latitude": "26.15519140",
                "longitude": "50.48251730"
            },
            {
                "id": 1993,
                "name": "Southern Governorate",
                "state_code": "14",
                "latitude": "25.93810180",
                "longitude": "50.57568870"
            }
        ]
    },
    {
        "name": "Bangladesh",
        "iso3": "BGD",
        "iso2": "BD",
        "phone_code": "880",
        "capital": "Dhaka",
        "currency": "BDT",
        "currency_symbol": "à§³",
        "tld": ".bd",
        "native": "Bangladesh",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Dhaka",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "BDT",
                "tzName": "Bangladesh Standard Time"
            }
        ],
        "translations": {
            "kr": "ë°©ê¸€ë¼ë°ì‹œ",
            "br": "Bangladesh",
            "pt": "Bangladeche",
            "nl": "Bangladesh",
            "hr": "BangladeÅ¡",
            "fa": "Ø¨Ù†Ú¯Ù„Ø§Ø¯Ø´",
            "de": "Bangladesch",
            "es": "Bangladesh",
            "fr": "Bangladesh",
            "ja": "ãƒãƒ³ã‚°ãƒ©ãƒ‡ã‚·ãƒ¥",
            "it": "Bangladesh",
            "cn": "å­ŸåŠ æ‹‰"
        },
        "latitude": "24.00000000",
        "longitude": "90.00000000",
        "emoji": "ðŸ‡§ðŸ‡©",
        "emojiU": "U+1F1E7 U+1F1E9",
        "states": [
            {
                "id": 796,
                "name": "Bagerhat District",
                "state_code": "05",
                "latitude": "22.66024360",
                "longitude": "89.78954780"
            },
            {
                "id": 802,
                "name": "Bahadia",
                "state_code": "33",
                "latitude": "23.78987120",
                "longitude": "90.16714830"
            },
            {
                "id": 752,
                "name": "Bandarban District",
                "state_code": "01",
                "latitude": "21.83110020",
                "longitude": "92.36863210"
            },
            {
                "id": 784,
                "name": "Barguna District",
                "state_code": "02",
                "latitude": "22.09529150",
                "longitude": "90.11206960"
            },
            {
                "id": 818,
                "name": "Barisal District",
                "state_code": "06",
                "latitude": "22.70220980",
                "longitude": "90.36963160"
            },
            {
                "id": 807,
                "name": "Barisal Division",
                "state_code": "A",
                "latitude": "22.38111310",
                "longitude": "90.33718890"
            },
            {
                "id": 756,
                "name": "Bhola District",
                "state_code": "07",
                "latitude": "22.17853150",
                "longitude": "90.71010230"
            },
            {
                "id": 797,
                "name": "Bogra District",
                "state_code": "03",
                "latitude": "24.85104020",
                "longitude": "89.36972250"
            },
            {
                "id": 810,
                "name": "Brahmanbaria District",
                "state_code": "04",
                "latitude": "23.96081810",
                "longitude": "91.11150140"
            },
            {
                "id": 768,
                "name": "Chandpur District",
                "state_code": "09",
                "latitude": "23.25131480",
                "longitude": "90.85178460"
            },
            {
                "id": 761,
                "name": "Chapai Nawabganj District",
                "state_code": "45",
                "latitude": "24.74131110",
                "longitude": "88.29120690"
            },
            {
                "id": 785,
                "name": "Chittagong District",
                "state_code": "10",
                "latitude": "22.51501050",
                "longitude": "91.75388170"
            },
            {
                "id": 803,
                "name": "Chittagong Division",
                "state_code": "B",
                "latitude": "23.17931570",
                "longitude": "91.98815270"
            },
            {
                "id": 788,
                "name": "Chuadanga District",
                "state_code": "12",
                "latitude": "23.61605120",
                "longitude": "88.82630060"
            },
            {
                "id": 763,
                "name": "Comilla District",
                "state_code": "08",
                "latitude": "23.45756670",
                "longitude": "91.18089960"
            },
            {
                "id": 751,
                "name": "Cox's Bazar District",
                "state_code": "11",
                "latitude": "21.56406260",
                "longitude": "92.02821290"
            },
            {
                "id": 771,
                "name": "Dhaka District",
                "state_code": "13",
                "latitude": "23.81051400",
                "longitude": "90.33718890"
            },
            {
                "id": 760,
                "name": "Dhaka Division",
                "state_code": "C",
                "latitude": "23.95357420",
                "longitude": "90.14949880"
            },
            {
                "id": 783,
                "name": "Dinajpur District",
                "state_code": "14",
                "latitude": "25.62791230",
                "longitude": "88.63317580"
            },
            {
                "id": 762,
                "name": "Faridpur District",
                "state_code": "15",
                "latitude": "23.54239190",
                "longitude": "89.63089210"
            },
            {
                "id": 816,
                "name": "Feni District",
                "state_code": "16",
                "latitude": "22.94087840",
                "longitude": "91.40666460"
            },
            {
                "id": 795,
                "name": "Gaibandha District",
                "state_code": "19",
                "latitude": "25.32969280",
                "longitude": "89.54296520"
            },
            {
                "id": 798,
                "name": "Gazipur District",
                "state_code": "18",
                "latitude": "24.09581710",
                "longitude": "90.41251810"
            },
            {
                "id": 792,
                "name": "Gopalganj District",
                "state_code": "17",
                "latitude": "26.48315840",
                "longitude": "84.43655000"
            },
            {
                "id": 805,
                "name": "Habiganj District",
                "state_code": "20",
                "latitude": "24.47712360",
                "longitude": "91.45065650"
            },
            {
                "id": 808,
                "name": "Jamalpur District",
                "state_code": "21",
                "latitude": "25.08309260",
                "longitude": "89.78532180"
            },
            {
                "id": 757,
                "name": "Jessore District",
                "state_code": "22",
                "latitude": "23.16340140",
                "longitude": "89.21816640"
            },
            {
                "id": 778,
                "name": "Jhalokati District",
                "state_code": "25",
                "latitude": "22.57208000",
                "longitude": "90.18696440"
            },
            {
                "id": 789,
                "name": "Jhenaidah District",
                "state_code": "23",
                "latitude": "23.54498730",
                "longitude": "89.17260310"
            },
            {
                "id": 806,
                "name": "Joypurhat District",
                "state_code": "24",
                "latitude": "25.09473490",
                "longitude": "89.09449370"
            },
            {
                "id": 786,
                "name": "Khagrachari District",
                "state_code": "29",
                "latitude": "23.13217510",
                "longitude": "91.94902100"
            },
            {
                "id": 811,
                "name": "Khulna District",
                "state_code": "27",
                "latitude": "22.67377350",
                "longitude": "89.39665810"
            },
            {
                "id": 775,
                "name": "Khulna Division",
                "state_code": "D",
                "latitude": "22.80878160",
                "longitude": "89.24671910"
            },
            {
                "id": 779,
                "name": "Kishoreganj District",
                "state_code": "26",
                "latitude": "24.42604570",
                "longitude": "90.98206680"
            },
            {
                "id": 793,
                "name": "Kurigram District",
                "state_code": "28",
                "latitude": "25.80724140",
                "longitude": "89.62947460"
            },
            {
                "id": 774,
                "name": "Kushtia District",
                "state_code": "30",
                "latitude": "23.89069950",
                "longitude": "89.10993680"
            },
            {
                "id": 819,
                "name": "Lakshmipur District",
                "state_code": "31",
                "latitude": "22.94467440",
                "longitude": "90.82819070"
            },
            {
                "id": 780,
                "name": "Lalmonirhat District",
                "state_code": "32",
                "latitude": "25.99233980",
                "longitude": "89.28472510"
            },
            {
                "id": 817,
                "name": "Madaripur District",
                "state_code": "36",
                "latitude": "23.23933460",
                "longitude": "90.18696440"
            },
            {
                "id": 776,
                "name": "Meherpur District",
                "state_code": "39",
                "latitude": "23.80519910",
                "longitude": "88.67235780"
            },
            {
                "id": 794,
                "name": "Moulvibazar District",
                "state_code": "38",
                "latitude": "24.30953440",
                "longitude": "91.73149030"
            },
            {
                "id": 790,
                "name": "Munshiganj District",
                "state_code": "35",
                "latitude": "23.49809310",
                "longitude": "90.41266210"
            },
            {
                "id": 766,
                "name": "Mymensingh District",
                "state_code": "34",
                "latitude": "24.75385750",
                "longitude": "90.40729190"
            },
            {
                "id": 758,
                "name": "Mymensingh Division",
                "state_code": "H",
                "latitude": "24.71362000",
                "longitude": "90.45023680"
            },
            {
                "id": 814,
                "name": "Naogaon District",
                "state_code": "48",
                "latitude": "24.91315970",
                "longitude": "88.75309520"
            },
            {
                "id": 769,
                "name": "Narail District",
                "state_code": "43",
                "latitude": "23.11629290",
                "longitude": "89.58404040"
            },
            {
                "id": 770,
                "name": "Narayanganj District",
                "state_code": "40",
                "latitude": "23.71466010",
                "longitude": "90.56360900"
            },
            {
                "id": 787,
                "name": "Natore District",
                "state_code": "44",
                "latitude": "24.41024300",
                "longitude": "89.00761770"
            },
            {
                "id": 764,
                "name": "Netrokona District",
                "state_code": "41",
                "latitude": "24.81032840",
                "longitude": "90.86564150"
            },
            {
                "id": 772,
                "name": "Nilphamari District",
                "state_code": "46",
                "latitude": "25.84827980",
                "longitude": "88.94141340"
            },
            {
                "id": 815,
                "name": "Noakhali District",
                "state_code": "47",
                "latitude": "22.87237890",
                "longitude": "91.09731840"
            },
            {
                "id": 754,
                "name": "Pabna District",
                "state_code": "49",
                "latitude": "24.15850500",
                "longitude": "89.44807180"
            },
            {
                "id": 800,
                "name": "Panchagarh District",
                "state_code": "52",
                "latitude": "26.27087050",
                "longitude": "88.59517510"
            },
            {
                "id": 777,
                "name": "Patuakhali District",
                "state_code": "51",
                "latitude": "22.22486320",
                "longitude": "90.45475030"
            },
            {
                "id": 791,
                "name": "Pirojpur District",
                "state_code": "50",
                "latitude": "22.57907440",
                "longitude": "89.97592640"
            },
            {
                "id": 773,
                "name": "Rajbari District",
                "state_code": "53",
                "latitude": "23.71513400",
                "longitude": "89.58748190"
            },
            {
                "id": 813,
                "name": "Rajshahi District",
                "state_code": "54",
                "latitude": "24.37330870",
                "longitude": "88.60487160"
            },
            {
                "id": 753,
                "name": "Rajshahi Division",
                "state_code": "E",
                "latitude": "24.71057760",
                "longitude": "88.94138650"
            },
            {
                "id": 809,
                "name": "Rangamati Hill District",
                "state_code": "56",
                "latitude": "22.73241730",
                "longitude": "92.29851340"
            },
            {
                "id": 759,
                "name": "Rangpur District",
                "state_code": "55",
                "latitude": "25.74679250",
                "longitude": "89.25083350"
            },
            {
                "id": 750,
                "name": "Rangpur Division",
                "state_code": "F",
                "latitude": "25.84833880",
                "longitude": "88.94138650"
            },
            {
                "id": 799,
                "name": "Satkhira District",
                "state_code": "58",
                "latitude": "22.31548120",
                "longitude": "89.11145250"
            },
            {
                "id": 801,
                "name": "Shariatpur District",
                "state_code": "62",
                "latitude": "23.24232140",
                "longitude": "90.43477110"
            },
            {
                "id": 755,
                "name": "Sherpur District",
                "state_code": "57",
                "latitude": "25.07462350",
                "longitude": "90.14949040"
            },
            {
                "id": 781,
                "name": "Sirajganj District",
                "state_code": "59",
                "latitude": "24.31411150",
                "longitude": "89.56996150"
            },
            {
                "id": 812,
                "name": "Sunamganj District",
                "state_code": "61",
                "latitude": "25.07145350",
                "longitude": "91.39916270"
            },
            {
                "id": 767,
                "name": "Sylhet District",
                "state_code": "60",
                "latitude": "24.89933570",
                "longitude": "91.87004730"
            },
            {
                "id": 765,
                "name": "Sylhet Division",
                "state_code": "G",
                "latitude": "24.70498110",
                "longitude": "91.67606910"
            },
            {
                "id": 782,
                "name": "Tangail District",
                "state_code": "63",
                "latitude": "24.39174270",
                "longitude": "89.99482570"
            },
            {
                "id": 804,
                "name": "Thakurgaon District",
                "state_code": "64",
                "latitude": "26.04183920",
                "longitude": "88.42826160"
            }
        ]
    },
    {
        "name": "Barbados",
        "iso3": "BRB",
        "iso2": "BB",
        "phone_code": "+1-246",
        "capital": "Bridgetown",
        "currency": "BBD",
        "currency_symbol": "Bds$",
        "tld": ".bb",
        "native": "Barbados",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Barbados",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë°”ë² ì´ë„ìŠ¤",
            "br": "Barbados",
            "pt": "Barbados",
            "nl": "Barbados",
            "hr": "Barbados",
            "fa": "Ø¨Ø§Ø±Ø¨Ø§Ø¯ÙˆØ³",
            "de": "Barbados",
            "es": "Barbados",
            "fr": "Barbade",
            "ja": "ãƒãƒ«ãƒãƒ‰ã‚¹",
            "it": "Barbados",
            "cn": "å·´å·´å¤šæ–¯"
        },
        "latitude": "13.16666666",
        "longitude": "-59.53333333",
        "emoji": "ðŸ‡§ðŸ‡§",
        "emojiU": "U+1F1E7 U+1F1E7",
        "states": [
            {
                "id": 1228,
                "name": "Christ Church",
                "state_code": "01",
                "latitude": "36.00604070",
                "longitude": "-95.92112100"
            },
            {
                "id": 1229,
                "name": "Saint Andrew",
                "state_code": "02",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 1226,
                "name": "Saint George",
                "state_code": "03",
                "latitude": "37.09652780",
                "longitude": "-113.56841640"
            },
            {
                "id": 1224,
                "name": "Saint James",
                "state_code": "04",
                "latitude": "48.52356600",
                "longitude": "-1.32378850"
            },
            {
                "id": 1227,
                "name": "Saint John",
                "state_code": "05",
                "latitude": "45.27331530",
                "longitude": "-66.06330800"
            },
            {
                "id": 1223,
                "name": "Saint Joseph",
                "state_code": "06",
                "latitude": "39.76745780",
                "longitude": "-94.84668100"
            },
            {
                "id": 1221,
                "name": "Saint Lucy",
                "state_code": "07",
                "latitude": "38.76146250",
                "longitude": "-77.44914390"
            },
            {
                "id": 1230,
                "name": "Saint Michael",
                "state_code": "08",
                "latitude": "36.03597700",
                "longitude": "-95.84905200"
            },
            {
                "id": 1222,
                "name": "Saint Peter",
                "state_code": "09",
                "latitude": "37.08271190",
                "longitude": "-94.51712500"
            },
            {
                "id": 1220,
                "name": "Saint Philip",
                "state_code": "10",
                "latitude": "35.23311400",
                "longitude": "-89.43640420"
            },
            {
                "id": 1225,
                "name": "Saint Thomas",
                "state_code": "11",
                "latitude": "18.33809650",
                "longitude": "-64.89409460"
            }
        ]
    },
    {
        "name": "Belarus",
        "iso3": "BLR",
        "iso2": "BY",
        "phone_code": "375",
        "capital": "Minsk",
        "currency": "BYN",
        "currency_symbol": "Br",
        "tld": ".by",
        "native": "Ð‘ÐµÐ»Ð°Ñ€ÑƒÌÑÑŒ",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Minsk",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            }
        ],
        "translations": {
            "kr": "ë²¨ë¼ë£¨ìŠ¤",
            "br": "BielorrÃºssia",
            "pt": "BielorrÃºssia",
            "nl": "Wit-Rusland",
            "hr": "Bjelorusija",
            "fa": "Ø¨Ù„Ø§Ø±ÙˆØ³",
            "de": "WeiÃŸrussland",
            "es": "Bielorrusia",
            "fr": "BiÃ©lorussie",
            "ja": "ãƒ™ãƒ©ãƒ«ãƒ¼ã‚·",
            "it": "Bielorussia",
            "cn": "ç™½ä¿„ç½—æ–¯"
        },
        "latitude": "53.00000000",
        "longitude": "28.00000000",
        "emoji": "ðŸ‡§ðŸ‡¾",
        "emojiU": "U+1F1E7 U+1F1FE",
        "states": [
            {
                "id": 2959,
                "name": "Brest Region",
                "state_code": "BR",
                "latitude": "52.52966410",
                "longitude": "25.46064800"
            },
            {
                "id": 2955,
                "name": "Gomel Region",
                "state_code": "HO",
                "latitude": "52.16487540",
                "longitude": "29.13332510"
            },
            {
                "id": 2956,
                "name": "Grodno Region",
                "state_code": "HR",
                "latitude": "53.65999450",
                "longitude": "25.34485710"
            },
            {
                "id": 2958,
                "name": "Minsk",
                "state_code": "HM",
                "latitude": "53.90060110",
                "longitude": "27.55897200"
            },
            {
                "id": 2957,
                "name": "Minsk Region",
                "state_code": "MI",
                "latitude": "54.10678890",
                "longitude": "27.41292450"
            },
            {
                "id": 2954,
                "name": "Mogilev Region",
                "state_code": "MA",
                "latitude": "53.51017910",
                "longitude": "30.40064440"
            },
            {
                "id": 2960,
                "name": "Vitebsk Region",
                "state_code": "VI",
                "latitude": "55.29598330",
                "longitude": "28.75836270"
            }
        ]
    },
    {
        "name": "Belgium",
        "iso3": "BEL",
        "iso2": "BE",
        "phone_code": "32",
        "capital": "Brussels",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".be",
        "native": "BelgiÃ«",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Brussels",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë²¨ê¸°ì—",
            "br": "BÃ©lgica",
            "pt": "BÃ©lgica",
            "nl": "BelgiÃ«",
            "hr": "Belgija",
            "fa": "Ø¨Ù„Ú˜ÛŒÚ©",
            "de": "Belgien",
            "es": "BÃ©lgica",
            "fr": "Belgique",
            "ja": "ãƒ™ãƒ«ã‚®ãƒ¼",
            "it": "Belgio",
            "cn": "æ¯”åˆ©æ—¶"
        },
        "latitude": "50.83333333",
        "longitude": "4.00000000",
        "emoji": "ðŸ‡§ðŸ‡ª",
        "emojiU": "U+1F1E7 U+1F1EA",
        "states": [
            {
                "id": 1381,
                "name": "Antwerp",
                "state_code": "VAN",
                "latitude": "51.21944750",
                "longitude": "4.40246430"
            },
            {
                "id": 1376,
                "name": "Brussels-Capital Region",
                "state_code": "BRU",
                "latitude": "50.85034630",
                "longitude": "4.35172110"
            },
            {
                "id": 1377,
                "name": "East Flanders",
                "state_code": "VOV",
                "latitude": "51.03621010",
                "longitude": "3.73731240"
            },
            {
                "id": 1373,
                "name": "Flanders",
                "state_code": "VLG",
                "latitude": "51.01087060",
                "longitude": "3.72646130"
            },
            {
                "id": 1374,
                "name": "Flemish Brabant",
                "state_code": "VBR",
                "latitude": "50.88154340",
                "longitude": "4.56459700"
            },
            {
                "id": 1375,
                "name": "Hainaut",
                "state_code": "WHT",
                "latitude": "50.52570760",
                "longitude": "4.06210170"
            },
            {
                "id": 1384,
                "name": "LiÃ¨ge",
                "state_code": "WLG",
                "latitude": "50.63255740",
                "longitude": "5.57966620"
            },
            {
                "id": 1372,
                "name": "Limburg",
                "state_code": "VLI",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 1379,
                "name": "Luxembourg",
                "state_code": "WLX",
                "latitude": "49.81527300",
                "longitude": "6.12958300"
            },
            {
                "id": 1378,
                "name": "Namur",
                "state_code": "WNA",
                "latitude": "50.46738830",
                "longitude": "4.87198540"
            },
            {
                "id": 1380,
                "name": "Wallonia",
                "state_code": "WAL",
                "latitude": "50.41756370",
                "longitude": "4.45100660"
            },
            {
                "id": 1382,
                "name": "Walloon Brabant",
                "state_code": "WBR",
                "latitude": "50.63324100",
                "longitude": "4.52431500"
            },
            {
                "id": 1383,
                "name": "West Flanders",
                "state_code": "VWV",
                "latitude": "40.01793340",
                "longitude": "-105.28067330"
            }
        ]
    },
    {
        "name": "Belize",
        "iso3": "BLZ",
        "iso2": "BZ",
        "phone_code": "501",
        "capital": "Belmopan",
        "currency": "BZD",
        "currency_symbol": "$",
        "tld": ".bz",
        "native": "Belize",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Belize",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America)"
            }
        ],
        "translations": {
            "kr": "ë²¨ë¦¬ì¦ˆ",
            "br": "Belize",
            "pt": "Belize",
            "nl": "Belize",
            "hr": "Belize",
            "fa": "Ø¨Ù„ÛŒØ²",
            "de": "Belize",
            "es": "Belice",
            "fr": "Belize",
            "ja": "ãƒ™ãƒªãƒ¼ã‚º",
            "it": "Belize",
            "cn": "ä¼¯åˆ©å…¹"
        },
        "latitude": "17.25000000",
        "longitude": "-88.75000000",
        "emoji": "ðŸ‡§ðŸ‡¿",
        "emojiU": "U+1F1E7 U+1F1FF",
        "states": [
            {
                "id": 264,
                "name": "Belize District",
                "state_code": "BZ",
                "latitude": "17.56776790",
                "longitude": "-88.40160410"
            },
            {
                "id": 269,
                "name": "Cayo District",
                "state_code": "CY",
                "latitude": "17.09844450",
                "longitude": "-88.94138650"
            },
            {
                "id": 266,
                "name": "Corozal District",
                "state_code": "CZL",
                "latitude": "18.13492380",
                "longitude": "-88.24611830"
            },
            {
                "id": 268,
                "name": "Orange Walk District",
                "state_code": "OW",
                "latitude": "17.76035300",
                "longitude": "-88.86469800"
            },
            {
                "id": 265,
                "name": "Stann Creek District",
                "state_code": "SC",
                "latitude": "16.81166310",
                "longitude": "-88.40160410"
            },
            {
                "id": 267,
                "name": "Toledo District",
                "state_code": "TOL",
                "latitude": "16.24919230",
                "longitude": "-88.86469800"
            }
        ]
    },
    {
        "name": "Benin",
        "iso3": "BEN",
        "iso2": "BJ",
        "phone_code": "229",
        "capital": "Porto-Novo",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".bj",
        "native": "BÃ©nin",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Porto-Novo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ë² ëƒ‰",
            "br": "Benin",
            "pt": "Benim",
            "nl": "Benin",
            "hr": "Benin",
            "fa": "Ø¨Ù†ÛŒÙ†",
            "de": "Benin",
            "es": "BenÃ­n",
            "fr": "BÃ©nin",
            "ja": "ãƒ™ãƒŠãƒ³",
            "it": "Benin",
            "cn": "è´å®"
        },
        "latitude": "9.50000000",
        "longitude": "2.25000000",
        "emoji": "ðŸ‡§ðŸ‡¯",
        "emojiU": "U+1F1E7 U+1F1EF",
        "states": [
            {
                "id": 3077,
                "name": "Alibori Department",
                "state_code": "AL",
                "latitude": "10.96810930",
                "longitude": "2.77798130"
            },
            {
                "id": 3076,
                "name": "Atakora Department",
                "state_code": "AK",
                "latitude": "10.79549310",
                "longitude": "1.67606910"
            },
            {
                "id": 3079,
                "name": "Atlantique Department",
                "state_code": "AQ",
                "latitude": "6.65883910",
                "longitude": "2.22366670"
            },
            {
                "id": 3078,
                "name": "Borgou Department",
                "state_code": "BO",
                "latitude": "9.53408640",
                "longitude": "2.77798130"
            },
            {
                "id": 3070,
                "name": "Collines Department",
                "state_code": "CO",
                "latitude": "8.30222970",
                "longitude": "2.30244600"
            },
            {
                "id": 3072,
                "name": "Donga Department",
                "state_code": "DO",
                "latitude": "9.71918670",
                "longitude": "1.67606910"
            },
            {
                "id": 3071,
                "name": "Kouffo Department",
                "state_code": "KO",
                "latitude": "7.00358940",
                "longitude": "1.75388170"
            },
            {
                "id": 3081,
                "name": "Littoral Department",
                "state_code": "LI",
                "latitude": "6.38069730",
                "longitude": "2.44063870"
            },
            {
                "id": 3075,
                "name": "Mono Department",
                "state_code": "MO",
                "latitude": "37.92186080",
                "longitude": "-118.95286450"
            },
            {
                "id": 3080,
                "name": "OuÃ©mÃ© Department",
                "state_code": "OU",
                "latitude": "6.61481520",
                "longitude": "2.49999180"
            },
            {
                "id": 3074,
                "name": "Plateau Department",
                "state_code": "PL",
                "latitude": "7.34451410",
                "longitude": "2.53960300"
            },
            {
                "id": 3073,
                "name": "Zou Department",
                "state_code": "ZO",
                "latitude": "7.34692680",
                "longitude": "2.06651970"
            }
        ]
    },
    {
        "name": "Bermuda",
        "iso3": "BMU",
        "iso2": "BM",
        "phone_code": "+1-441",
        "capital": "Hamilton",
        "currency": "BMD",
        "currency_symbol": "$",
        "tld": ".bm",
        "native": "Bermuda",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "Atlantic\/Bermuda",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë²„ë®¤ë‹¤",
            "br": "Bermudas",
            "pt": "Bermudas",
            "nl": "Bermuda",
            "hr": "Bermudi",
            "fa": "Ø¨Ø±Ù…ÙˆØ¯Ø§",
            "de": "Bermuda",
            "es": "Bermudas",
            "fr": "Bermudes",
            "ja": "ãƒãƒŸãƒ¥ãƒ¼ãƒ€",
            "it": "Bermuda",
            "cn": "ç™¾æ…•å¤§"
        },
        "latitude": "32.33333333",
        "longitude": "-64.75000000",
        "emoji": "ðŸ‡§ðŸ‡²",
        "emojiU": "U+1F1E7 U+1F1F2",
        "states": [
            {
                "id": 4860,
                "name": "Devonshire Parish",
                "state_code": "DEV",
                "latitude": "32.30380620",
                "longitude": "-64.76069540"
            },
            {
                "id": 4862,
                "name": "Hamilton Municipality",
                "state_code": "HAM",
                "latitude": "43.32394400",
                "longitude": "-79.90592190"
            },
            {
                "id": 4861,
                "name": "Hamilton Parish",
                "state_code": "HA",
                "latitude": "32.34494320",
                "longitude": "-64.72365000"
            },
            {
                "id": 4863,
                "name": "Paget Parish",
                "state_code": "PAG",
                "latitude": "32.28107400",
                "longitude": "-64.77847870"
            },
            {
                "id": 4864,
                "name": "Pembroke Parish",
                "state_code": "PEM",
                "latitude": "32.30076720",
                "longitude": "-64.79626300"
            },
            {
                "id": 4865,
                "name": "Saint George's Municipality",
                "state_code": "SG",
                "latitude": "37.09652780",
                "longitude": "-113.56841640"
            },
            {
                "id": 4866,
                "name": "Saint George's Parish",
                "state_code": "SGE",
                "latitude": "17.12577590",
                "longitude": "-62.56198110"
            },
            {
                "id": 4867,
                "name": "Sandys Parish",
                "state_code": "SAN",
                "latitude": "32.29995280",
                "longitude": "-64.86741030"
            },
            {
                "id": 4868,
                "name": "Smith's Parish,",
                "state_code": "SMI",
                "latitude": "32.31339660",
                "longitude": "-64.73105880"
            },
            {
                "id": 4869,
                "name": "Southampton Parish",
                "state_code": "SOU",
                "latitude": "32.25400950",
                "longitude": "-64.82590580"
            },
            {
                "id": 4870,
                "name": "Warwick Parish",
                "state_code": "WAR",
                "latitude": "32.26615340",
                "longitude": "-64.80811980"
            }
        ]
    },
    {
        "name": "Bhutan",
        "iso3": "BTN",
        "iso2": "BT",
        "phone_code": "975",
        "capital": "Thimphu",
        "currency": "BTN",
        "currency_symbol": "Nu.",
        "tld": ".bt",
        "native": "Ê¼brug-yul",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Thimphu",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "BTT",
                "tzName": "Bhutan Time"
            }
        ],
        "translations": {
            "kr": "ë¶€íƒ„",
            "br": "ButÃ£o",
            "pt": "ButÃ£o",
            "nl": "Bhutan",
            "hr": "Butan",
            "fa": "Ø¨ÙˆØªØ§Ù†",
            "de": "Bhutan",
            "es": "ButÃ¡n",
            "fr": "Bhoutan",
            "ja": "ãƒ–ãƒ¼ã‚¿ãƒ³",
            "it": "Bhutan",
            "cn": "ä¸ä¸¹"
        },
        "latitude": "27.50000000",
        "longitude": "90.50000000",
        "emoji": "ðŸ‡§ðŸ‡¹",
        "emojiU": "U+1F1E7 U+1F1F9",
        "states": [
            {
                "id": 240,
                "name": "Bumthang District",
                "state_code": "33",
                "latitude": "27.64183900",
                "longitude": "90.67730460"
            },
            {
                "id": 239,
                "name": "Chukha District",
                "state_code": "12",
                "latitude": "27.07843040",
                "longitude": "89.47421770"
            },
            {
                "id": 238,
                "name": "Dagana District",
                "state_code": "22",
                "latitude": "27.03228610",
                "longitude": "89.88793040"
            },
            {
                "id": 229,
                "name": "Gasa District",
                "state_code": "GA",
                "latitude": "28.01858860",
                "longitude": "89.92532330"
            },
            {
                "id": 232,
                "name": "Haa District",
                "state_code": "13",
                "latitude": "27.26516690",
                "longitude": "89.17059980"
            },
            {
                "id": 234,
                "name": "Lhuntse District",
                "state_code": "44",
                "latitude": "27.82649890",
                "longitude": "91.13530200"
            },
            {
                "id": 242,
                "name": "Mongar District",
                "state_code": "42",
                "latitude": "27.26170590",
                "longitude": "91.28910360"
            },
            {
                "id": 237,
                "name": "Paro District",
                "state_code": "11",
                "latitude": "27.42859490",
                "longitude": "89.41665160"
            },
            {
                "id": 244,
                "name": "Pemagatshel District",
                "state_code": "43",
                "latitude": "27.00238200",
                "longitude": "91.34692470"
            },
            {
                "id": 235,
                "name": "Punakha District",
                "state_code": "23",
                "latitude": "27.69037160",
                "longitude": "89.88793040"
            },
            {
                "id": 243,
                "name": "Samdrup Jongkhar District",
                "state_code": "45",
                "latitude": "26.80356820",
                "longitude": "91.50392070"
            },
            {
                "id": 246,
                "name": "Samtse District",
                "state_code": "14",
                "latitude": "27.02918320",
                "longitude": "89.05615320"
            },
            {
                "id": 247,
                "name": "Sarpang District",
                "state_code": "31",
                "latitude": "26.93730410",
                "longitude": "90.48799160"
            },
            {
                "id": 241,
                "name": "Thimphu District",
                "state_code": "15",
                "latitude": "27.47122160",
                "longitude": "89.63390410"
            },
            {
                "id": 236,
                "name": "Trashigang District",
                "state_code": "41",
                "latitude": "27.25667950",
                "longitude": "91.75388170"
            },
            {
                "id": 245,
                "name": "Trongsa District",
                "state_code": "32",
                "latitude": "27.50022690",
                "longitude": "90.50806340"
            },
            {
                "id": 230,
                "name": "Tsirang District",
                "state_code": "21",
                "latitude": "27.03220700",
                "longitude": "90.18696440"
            },
            {
                "id": 231,
                "name": "Wangdue Phodrang District",
                "state_code": "24",
                "latitude": "27.45260460",
                "longitude": "90.06749280"
            },
            {
                "id": 233,
                "name": "Zhemgang District",
                "state_code": "34",
                "latitude": "27.07697500",
                "longitude": "90.82940020"
            }
        ]
    },
    {
        "name": "Bolivia",
        "iso3": "BOL",
        "iso2": "BO",
        "phone_code": "591",
        "capital": "Sucre",
        "currency": "BOB",
        "currency_symbol": "Bs.",
        "tld": ".bo",
        "native": "Bolivia",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/La_Paz",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "BOT",
                "tzName": "Bolivia Time"
            }
        ],
        "translations": {
            "kr": "ë³¼ë¦¬ë¹„ì•„",
            "br": "BolÃ­via",
            "pt": "BolÃ­via",
            "nl": "Bolivia",
            "hr": "Bolivija",
            "fa": "Ø¨ÙˆÙ„ÛŒÙˆÛŒ",
            "de": "Bolivien",
            "es": "Bolivia",
            "fr": "Bolivie",
            "ja": "ãƒœãƒªãƒ“ã‚¢å¤šæ°‘æ—å›½",
            "it": "Bolivia",
            "cn": "çŽ»åˆ©ç»´äºš"
        },
        "latitude": "-17.00000000",
        "longitude": "-65.00000000",
        "emoji": "ðŸ‡§ðŸ‡´",
        "emojiU": "U+1F1E7 U+1F1F4",
        "states": [
            {
                "id": 3375,
                "name": "Beni Department",
                "state_code": "B",
                "latitude": "-14.37827470",
                "longitude": "-65.09577920"
            },
            {
                "id": 3382,
                "name": "Chuquisaca Department",
                "state_code": "H",
                "latitude": "-20.02491440",
                "longitude": "-64.14782360"
            },
            {
                "id": 3381,
                "name": "Cochabamba Department",
                "state_code": "C",
                "latitude": "-17.56816750",
                "longitude": "-65.47573600"
            },
            {
                "id": 3380,
                "name": "La Paz Department",
                "state_code": "L",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3376,
                "name": "Oruro Department",
                "state_code": "O",
                "latitude": "-18.57115790",
                "longitude": "-67.76159830"
            },
            {
                "id": 3379,
                "name": "Pando Department",
                "state_code": "N",
                "latitude": "-10.79889010",
                "longitude": "-66.99880110"
            },
            {
                "id": 3383,
                "name": "PotosÃ­ Department",
                "state_code": "P",
                "latitude": "-20.62471300",
                "longitude": "-66.99880110"
            },
            {
                "id": 3377,
                "name": "Santa Cruz Department",
                "state_code": "S",
                "latitude": "-16.74760370",
                "longitude": "-62.07509980"
            },
            {
                "id": 3378,
                "name": "Tarija Department",
                "state_code": "T",
                "latitude": "-21.58315950",
                "longitude": "-63.95861110"
            }
        ]
    },
    {
        "name": "Bonaire, Sint Eustatius and Saba",
        "iso3": "BES",
        "iso2": "BQ",
        "phone_code": "599",
        "capital": "Kralendijk",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".an",
        "native": "Caribisch Nederland",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë³´ë„¤ë¥´ ì„¬",
            "br": "Bonaire",
            "pt": "Bonaire",
            "fa": "Ø¨ÙˆÙ†ÛŒØ±",
            "de": "Bonaire, Sint Eustatius und Saba",
            "fr": "Bonaire, Saint-Eustache et Saba",
            "it": "Bonaire, Saint-Eustache e Saba",
            "cn": "åšå†…å°”å²›ã€åœ£å°¤æ–¯ç‰¹æ­‡æ–¯å’Œè¨å·´å²›"
        },
        "latitude": "12.15000000",
        "longitude": "-68.26666700",
        "emoji": "ðŸ‡§ðŸ‡¶",
        "emojiU": "U+1F1E7 U+1F1F6",
        "states": []
    },
    {
        "name": "Bosnia and Herzegovina",
        "iso3": "BIH",
        "iso2": "BA",
        "phone_code": "387",
        "capital": "Sarajevo",
        "currency": "BAM",
        "currency_symbol": "KM",
        "tld": ".ba",
        "native": "Bosna i Hercegovina",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Sarajevo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë³´ìŠ¤ë‹ˆì•„ í—¤ë¥´ì²´ê³ ë¹„ë‚˜",
            "br": "BÃ³snia e Herzegovina",
            "pt": "BÃ³snia e Herzegovina",
            "nl": "BosniÃ« en Herzegovina",
            "hr": "Bosna i Hercegovina",
            "fa": "Ø¨ÙˆØ³Ù†ÛŒ Ùˆ Ù‡Ø±Ø²Ú¯ÙˆÛŒÙ†",
            "de": "Bosnien und Herzegowina",
            "es": "Bosnia y Herzegovina",
            "fr": "Bosnie-HerzÃ©govine",
            "ja": "ãƒœã‚¹ãƒ‹ã‚¢ãƒ»ãƒ˜ãƒ«ãƒ„ã‚§ã‚´ãƒ“ãƒŠ",
            "it": "Bosnia ed Erzegovina",
            "cn": "æ³¢æ–¯å°¼äºšå’Œé»‘å¡žå“¥ç»´é‚£"
        },
        "latitude": "44.00000000",
        "longitude": "18.00000000",
        "emoji": "ðŸ‡§ðŸ‡¦",
        "emojiU": "U+1F1E7 U+1F1E6",
        "states": [
            {
                "id": 472,
                "name": "Bosnian Podrinje Canton",
                "state_code": "05",
                "latitude": "43.68749000",
                "longitude": "18.82443940"
            },
            {
                "id": 460,
                "name": "BrÄko District",
                "state_code": "BRC",
                "latitude": "44.84059440",
                "longitude": "18.74215300"
            },
            {
                "id": 471,
                "name": "Canton 10",
                "state_code": "10",
                "latitude": "43.95341550",
                "longitude": "16.94251870"
            },
            {
                "id": 462,
                "name": "Central Bosnia Canton",
                "state_code": "06",
                "latitude": "44.13818560",
                "longitude": "17.68667140"
            },
            {
                "id": 467,
                "name": "Federation of Bosnia and Herzegovina",
                "state_code": "BIH",
                "latitude": "43.88748970",
                "longitude": "17.84279300"
            },
            {
                "id": 463,
                "name": "Herzegovina-Neretva Canton",
                "state_code": "07",
                "latitude": "43.52651590",
                "longitude": "17.76362100"
            },
            {
                "id": 464,
                "name": "Posavina Canton",
                "state_code": "02",
                "latitude": "45.07520940",
                "longitude": "18.37763040"
            },
            {
                "id": 470,
                "name": "Republika Srpska",
                "state_code": "SRP",
                "latitude": "44.72801860",
                "longitude": "17.31481360"
            },
            {
                "id": 466,
                "name": "Sarajevo Canton",
                "state_code": "09",
                "latitude": "43.85125640",
                "longitude": "18.29534420"
            },
            {
                "id": 461,
                "name": "Tuzla Canton",
                "state_code": "03",
                "latitude": "44.53434630",
                "longitude": "18.69727970"
            },
            {
                "id": 465,
                "name": "Una-Sana Canton",
                "state_code": "01",
                "latitude": "44.65031160",
                "longitude": "16.31716290"
            },
            {
                "id": 469,
                "name": "West Herzegovina Canton",
                "state_code": "08",
                "latitude": "43.43692440",
                "longitude": "17.38488310"
            },
            {
                "id": 468,
                "name": "Zenica-Doboj Canton",
                "state_code": "04",
                "latitude": "44.21271090",
                "longitude": "18.16046250"
            }
        ]
    },
    {
        "name": "Botswana",
        "iso3": "BWA",
        "iso2": "BW",
        "phone_code": "267",
        "capital": "Gaborone",
        "currency": "BWP",
        "currency_symbol": "P",
        "tld": ".bw",
        "native": "Botswana",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Gaborone",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ë³´ì¸ ì™€ë‚˜",
            "br": "Botsuana",
            "pt": "Botsuana",
            "nl": "Botswana",
            "hr": "Bocvana",
            "fa": "Ø¨ÙˆØªØ³ÙˆØ§Ù†Ø§",
            "de": "Botswana",
            "es": "Botswana",
            "fr": "Botswana",
            "ja": "ãƒœãƒ„ãƒ¯ãƒŠ",
            "it": "Botswana",
            "cn": "åšèŒ¨ç“¦çº³"
        },
        "latitude": "-22.00000000",
        "longitude": "24.00000000",
        "emoji": "ðŸ‡§ðŸ‡¼",
        "emojiU": "U+1F1E7 U+1F1FC",
        "states": [
            {
                "id": 3067,
                "name": "Central District",
                "state_code": "CE",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3061,
                "name": "Ghanzi District",
                "state_code": "GH",
                "latitude": "-21.86523140",
                "longitude": "21.85685860"
            },
            {
                "id": 3066,
                "name": "Kgalagadi District",
                "state_code": "KG",
                "latitude": "-24.75502850",
                "longitude": "21.85685860"
            },
            {
                "id": 3062,
                "name": "Kgatleng District",
                "state_code": "KL",
                "latitude": "-24.19704450",
                "longitude": "26.23046160"
            },
            {
                "id": 3069,
                "name": "Kweneng District",
                "state_code": "KW",
                "latitude": "-23.83672490",
                "longitude": "25.28375850"
            },
            {
                "id": 3060,
                "name": "Ngamiland",
                "state_code": "NG",
                "latitude": "-19.19053210",
                "longitude": "23.00119890"
            },
            {
                "id": 3068,
                "name": "North-East District",
                "state_code": "NE",
                "latitude": "37.58844610",
                "longitude": "-94.68637820"
            },
            {
                "id": 3065,
                "name": "North-West District",
                "state_code": "NW",
                "latitude": "39.34463070",
                "longitude": "-76.68542830"
            },
            {
                "id": 3064,
                "name": "South-East District",
                "state_code": "SE",
                "latitude": "31.21637980",
                "longitude": "-82.35270440"
            },
            {
                "id": 3063,
                "name": "Southern District",
                "state_code": "SO",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Bouvet Island",
        "iso3": "BVT",
        "iso2": "BV",
        "phone_code": "0055",
        "capital": "",
        "currency": "NOK",
        "currency_symbol": "kr",
        "tld": ".bv",
        "native": "BouvetÃ¸ya",
        "region": "",
        "subregion": "",
        "timezones": [
            {
                "zoneName": "Europe\/Oslo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë¶€ë²³ ì„¬",
            "br": "Ilha Bouvet",
            "pt": "Ilha Bouvet",
            "nl": "Bouveteiland",
            "hr": "Otok Bouvet",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ø¨ÙˆÙˆÙ‡",
            "de": "Bouvetinsel",
            "es": "Isla Bouvet",
            "fr": "ÃŽle Bouvet",
            "ja": "ãƒ–ãƒ¼ãƒ™å³¶",
            "it": "Isola Bouvet",
            "cn": "å¸ƒç»´å²›"
        },
        "latitude": "-54.43333333",
        "longitude": "3.40000000",
        "emoji": "ðŸ‡§ðŸ‡»",
        "emojiU": "U+1F1E7 U+1F1FB",
        "states": []
    },
    {
        "name": "Brazil",
        "iso3": "BRA",
        "iso2": "BR",
        "phone_code": "55",
        "capital": "Brasilia",
        "currency": "BRL",
        "currency_symbol": "R$",
        "tld": ".br",
        "native": "Brasil",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Araguaina",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Bahia",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Belem",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Boa_Vista",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Campo_Grande",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Cuiaba",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "BRT",
                "tzName": "Brasilia Time"
            },
            {
                "zoneName": "America\/Eirunepe",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ACT",
                "tzName": "Acre Time"
            },
            {
                "zoneName": "America\/Fortaleza",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Maceio",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Manaus",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)"
            },
            {
                "zoneName": "America\/Noronha",
                "gmtOffset": -7200,
                "gmtOffsetName": "UTC-02:00",
                "abbreviation": "FNT",
                "tzName": "Fernando de Noronha Time"
            },
            {
                "zoneName": "America\/Porto_Velho",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AMT",
                "tzName": "Amazon Time (Brazil)[3"
            },
            {
                "zoneName": "America\/Recife",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Rio_Branco",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ACT",
                "tzName": "Acre Time"
            },
            {
                "zoneName": "America\/Santarem",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            },
            {
                "zoneName": "America\/Sao_Paulo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "BRT",
                "tzName": "BrasÃ­lia Time"
            }
        ],
        "translations": {
            "kr": "ë¸Œë¼ì§ˆ",
            "br": "Brasil",
            "pt": "Brasil",
            "nl": "BraziliÃ«",
            "hr": "Brazil",
            "fa": "Ø¨Ø±Ø²ÛŒÙ„",
            "de": "Brasilien",
            "es": "Brasil",
            "fr": "BrÃ©sil",
            "ja": "ãƒ–ãƒ©ã‚¸ãƒ«",
            "it": "Brasile",
            "cn": "å·´è¥¿"
        },
        "latitude": "-10.00000000",
        "longitude": "-55.00000000",
        "emoji": "ðŸ‡§ðŸ‡·",
        "emojiU": "U+1F1E7 U+1F1F7",
        "states": [
            {
                "id": 2012,
                "name": "Acre",
                "state_code": "AC",
                "latitude": "32.93305200",
                "longitude": "35.08267800"
            },
            {
                "id": 2007,
                "name": "Alagoas",
                "state_code": "AL",
                "latitude": "-9.57130580",
                "longitude": "-36.78195050"
            },
            {
                "id": 1999,
                "name": "AmapÃ¡",
                "state_code": "AP",
                "latitude": "0.90199250",
                "longitude": "-52.00295650"
            },
            {
                "id": 2004,
                "name": "Amazonas",
                "state_code": "AM",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2002,
                "name": "Bahia",
                "state_code": "BA",
                "latitude": "26.11353900",
                "longitude": "-80.10620400"
            },
            {
                "id": 2016,
                "name": "CearÃ¡",
                "state_code": "CE",
                "latitude": "-5.49839770",
                "longitude": "-39.32062410"
            },
            {
                "id": 2018,
                "name": "EspÃ­rito Santo",
                "state_code": "ES",
                "latitude": "-19.18342290",
                "longitude": "-40.30886260"
            },
            {
                "id": 2017,
                "name": "Federal District",
                "state_code": "DF",
                "latitude": "-15.79976540",
                "longitude": "-47.86447150"
            },
            {
                "id": 2000,
                "name": "GoiÃ¡s",
                "state_code": "GO",
                "latitude": "-15.82703690",
                "longitude": "-49.83622370"
            },
            {
                "id": 2015,
                "name": "MaranhÃ£o",
                "state_code": "MA",
                "latitude": "-4.96094980",
                "longitude": "-45.27441590"
            },
            {
                "id": 2011,
                "name": "Mato Grosso",
                "state_code": "MT",
                "latitude": "-12.68187120",
                "longitude": "-56.92109900"
            },
            {
                "id": 2010,
                "name": "Mato Grosso do Sul",
                "state_code": "MS",
                "latitude": "-20.77222950",
                "longitude": "-54.78515310"
            },
            {
                "id": 1998,
                "name": "Minas Gerais",
                "state_code": "MG",
                "latitude": "-18.51217800",
                "longitude": "-44.55503080"
            },
            {
                "id": 2009,
                "name": "ParÃ¡",
                "state_code": "PA",
                "latitude": "-1.99812710",
                "longitude": "-54.93061520"
            },
            {
                "id": 2005,
                "name": "ParaÃ­ba",
                "state_code": "PB",
                "latitude": "-7.23996090",
                "longitude": "-36.78195050"
            },
            {
                "id": 2022,
                "name": "ParanÃ¡",
                "state_code": "PR",
                "latitude": "-25.25208880",
                "longitude": "-52.02154150"
            },
            {
                "id": 2006,
                "name": "Pernambuco",
                "state_code": "PE",
                "latitude": "-8.81371730",
                "longitude": "-36.95410700"
            },
            {
                "id": 2008,
                "name": "PiauÃ­",
                "state_code": "PI",
                "latitude": "-7.71834010",
                "longitude": "-42.72892360"
            },
            {
                "id": 1997,
                "name": "Rio de Janeiro",
                "state_code": "RJ",
                "latitude": "-22.90684670",
                "longitude": "-43.17289650"
            },
            {
                "id": 2019,
                "name": "Rio Grande do Norte",
                "state_code": "RN",
                "latitude": "-5.40258030",
                "longitude": "-36.95410700"
            },
            {
                "id": 2001,
                "name": "Rio Grande do Sul",
                "state_code": "RS",
                "latitude": "-30.03463160",
                "longitude": "-51.21769860"
            },
            {
                "id": 2013,
                "name": "RondÃ´nia",
                "state_code": "RO",
                "latitude": "-11.50573410",
                "longitude": "-63.58061100"
            },
            {
                "id": 4858,
                "name": "Roraima",
                "state_code": "RR",
                "latitude": "2.73759710",
                "longitude": "-62.07509980"
            },
            {
                "id": 2014,
                "name": "Santa Catarina",
                "state_code": "SC",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2021,
                "name": "SÃ£o Paulo",
                "state_code": "SP",
                "latitude": "-23.55051990",
                "longitude": "-46.63330940"
            },
            {
                "id": 2003,
                "name": "Sergipe",
                "state_code": "SE",
                "latitude": "-10.57409340",
                "longitude": "-37.38565810"
            },
            {
                "id": 2020,
                "name": "Tocantins",
                "state_code": "TO",
                "latitude": "-10.17528000",
                "longitude": "-48.29824740"
            }
        ]
    },
    {
        "name": "British Indian Ocean Territory",
        "iso3": "IOT",
        "iso2": "IO",
        "phone_code": "246",
        "capital": "Diego Garcia",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".io",
        "native": "British Indian Ocean Territory",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Chagos",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "IOT",
                "tzName": "Indian Ocean Time"
            }
        ],
        "translations": {
            "kr": "ì˜êµ­ë ¹ ì¸ë„ì–‘ ì§€ì—­",
            "br": "TerritÃ³rio BritÃ¢nico do Oceano Ã­Ãdico",
            "pt": "TerritÃ³rio BritÃ¢nico do Oceano Ãndico",
            "nl": "Britse Gebieden in de Indische Oceaan",
            "hr": "Britanski Indijskooceanski teritorij",
            "fa": "Ù‚Ù„Ù…Ø±Ùˆ Ø¨Ø±ÛŒØªØ§Ù†ÛŒØ§ Ø¯Ø± Ø§Ù‚ÛŒØ§Ù†ÙˆØ³ Ù‡Ù†Ø¯",
            "de": "Britisches Territorium im Indischen Ozean",
            "es": "Territorio BritÃ¡nico del OcÃ©ano Ãndico",
            "fr": "Territoire britannique de l'ocÃ©an Indien",
            "ja": "ã‚¤ã‚®ãƒªã‚¹é ˜ã‚¤ãƒ³ãƒ‰æ´‹åœ°åŸŸ",
            "it": "Territorio britannico dell'oceano indiano",
            "cn": "è‹±å±žå°åº¦æ´‹é¢†åœ°"
        },
        "latitude": "-6.00000000",
        "longitude": "71.50000000",
        "emoji": "ðŸ‡®ðŸ‡´",
        "emojiU": "U+1F1EE U+1F1F4",
        "states": []
    },
    {
        "name": "Brunei",
        "iso3": "BRN",
        "iso2": "BN",
        "phone_code": "673",
        "capital": "Bandar Seri Begawan",
        "currency": "BND",
        "currency_symbol": "B$",
        "tld": ".bn",
        "native": "Negara Brunei Darussalam",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Brunei",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "BNT",
                "tzName": "Brunei Darussalam Time"
            }
        ],
        "translations": {
            "kr": "ë¸Œë£¨ë‚˜ì´",
            "br": "Brunei",
            "pt": "Brunei",
            "nl": "Brunei",
            "hr": "Brunej",
            "fa": "Ø¨Ø±ÙˆÙ†Ø¦ÛŒ",
            "de": "Brunei",
            "es": "Brunei",
            "fr": "Brunei",
            "ja": "ãƒ–ãƒ«ãƒã‚¤ãƒ»ãƒ€ãƒ«ã‚µãƒ©ãƒ¼ãƒ ",
            "it": "Brunei",
            "cn": "æ–‡èŽ±"
        },
        "latitude": "4.50000000",
        "longitude": "114.66666666",
        "emoji": "ðŸ‡§ðŸ‡³",
        "emojiU": "U+1F1E7 U+1F1F3",
        "states": [
            {
                "id": 1217,
                "name": "Belait District",
                "state_code": "BE",
                "latitude": "4.37507490",
                "longitude": "114.61928990"
            },
            {
                "id": 1216,
                "name": "Brunei-Muara District",
                "state_code": "BM",
                "latitude": "4.93112060",
                "longitude": "114.95168690"
            },
            {
                "id": 1218,
                "name": "Temburong District",
                "state_code": "TE",
                "latitude": "4.62041280",
                "longitude": "115.14148400"
            },
            {
                "id": 1219,
                "name": "Tutong District",
                "state_code": "TU",
                "latitude": "4.71403730",
                "longitude": "114.66679390"
            }
        ]
    },
    {
        "name": "Bulgaria",
        "iso3": "BGR",
        "iso2": "BG",
        "phone_code": "359",
        "capital": "Sofia",
        "currency": "BGN",
        "currency_symbol": "Ð›Ð².",
        "tld": ".bg",
        "native": "Ð‘ÑŠÐ»Ð³Ð°Ñ€Ð¸Ñ",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Sofia",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë¶ˆê°€ë¦¬ì•„",
            "br": "BulgÃ¡ria",
            "pt": "BulgÃ¡ria",
            "nl": "Bulgarije",
            "hr": "Bugarska",
            "fa": "Ø¨Ù„ØºØ§Ø±Ø³ØªØ§Ù†",
            "de": "Bulgarien",
            "es": "Bulgaria",
            "fr": "Bulgarie",
            "ja": "ãƒ–ãƒ«ã‚¬ãƒªã‚¢",
            "it": "Bulgaria",
            "cn": "ä¿åŠ åˆ©äºš"
        },
        "latitude": "43.00000000",
        "longitude": "25.00000000",
        "emoji": "ðŸ‡§ðŸ‡¬",
        "emojiU": "U+1F1E7 U+1F1EC",
        "states": [
            {
                "id": 4699,
                "name": "Blagoevgrad Province",
                "state_code": "01",
                "latitude": "42.02086140",
                "longitude": "23.09433560"
            },
            {
                "id": 4715,
                "name": "Burgas Province",
                "state_code": "02",
                "latitude": "42.50480000",
                "longitude": "27.46260790"
            },
            {
                "id": 4718,
                "name": "Dobrich Province",
                "state_code": "08",
                "latitude": "43.57278600",
                "longitude": "27.82728020"
            },
            {
                "id": 4693,
                "name": "Gabrovo Province",
                "state_code": "07",
                "latitude": "42.86847000",
                "longitude": "25.31688900"
            },
            {
                "id": 4704,
                "name": "Haskovo Province",
                "state_code": "26",
                "latitude": "41.93441780",
                "longitude": "25.55546720"
            },
            {
                "id": 4702,
                "name": "Kardzhali Province",
                "state_code": "09",
                "latitude": "41.63384160",
                "longitude": "25.37766870"
            },
            {
                "id": 4703,
                "name": "Kyustendil Province",
                "state_code": "10",
                "latitude": "42.28687990",
                "longitude": "22.69396350"
            },
            {
                "id": 4710,
                "name": "Lovech Province",
                "state_code": "11",
                "latitude": "43.13677980",
                "longitude": "24.71393350"
            },
            {
                "id": 4696,
                "name": "Montana Province",
                "state_code": "12",
                "latitude": "43.40851480",
                "longitude": "23.22575890"
            },
            {
                "id": 4712,
                "name": "Pazardzhik Province",
                "state_code": "13",
                "latitude": "42.19275670",
                "longitude": "24.33362260"
            },
            {
                "id": 4695,
                "name": "Pernik Province",
                "state_code": "14",
                "latitude": "42.60519900",
                "longitude": "23.03779160"
            },
            {
                "id": 4706,
                "name": "Pleven Province",
                "state_code": "15",
                "latitude": "43.41701690",
                "longitude": "24.60667080"
            },
            {
                "id": 4701,
                "name": "Plovdiv Province",
                "state_code": "16",
                "latitude": "42.13540790",
                "longitude": "24.74529040"
            },
            {
                "id": 4698,
                "name": "Razgrad Province",
                "state_code": "17",
                "latitude": "43.52717050",
                "longitude": "26.52412280"
            },
            {
                "id": 4713,
                "name": "Ruse Province",
                "state_code": "18",
                "latitude": "43.83559640",
                "longitude": "25.96561440"
            },
            {
                "id": 4882,
                "name": "Shumen",
                "state_code": "27",
                "latitude": "43.27123980",
                "longitude": "26.93612860"
            },
            {
                "id": 4708,
                "name": "Silistra Province",
                "state_code": "19",
                "latitude": "44.11471010",
                "longitude": "27.26714540"
            },
            {
                "id": 4700,
                "name": "Sliven Province",
                "state_code": "20",
                "latitude": "42.68167020",
                "longitude": "26.32285690"
            },
            {
                "id": 4694,
                "name": "Smolyan Province",
                "state_code": "21",
                "latitude": "41.57741480",
                "longitude": "24.70108710"
            },
            {
                "id": 4705,
                "name": "Sofia City Province",
                "state_code": "22",
                "latitude": "42.75701090",
                "longitude": "23.45046830"
            },
            {
                "id": 4719,
                "name": "Sofia Province",
                "state_code": "23",
                "latitude": "42.67344000",
                "longitude": "23.83349370"
            },
            {
                "id": 4707,
                "name": "Stara Zagora Province",
                "state_code": "24",
                "latitude": "42.42577090",
                "longitude": "25.63448550"
            },
            {
                "id": 4714,
                "name": "Targovishte Province",
                "state_code": "25",
                "latitude": "43.24623490",
                "longitude": "26.56912510"
            },
            {
                "id": 4717,
                "name": "Varna Province",
                "state_code": "03",
                "latitude": "43.20464770",
                "longitude": "27.91054880"
            },
            {
                "id": 4709,
                "name": "Veliko Tarnovo Province",
                "state_code": "04",
                "latitude": "43.07565390",
                "longitude": "25.61715000"
            },
            {
                "id": 4697,
                "name": "Vidin Province",
                "state_code": "05",
                "latitude": "43.99617390",
                "longitude": "22.86795150"
            },
            {
                "id": 4711,
                "name": "Vratsa Province",
                "state_code": "06",
                "latitude": "43.21018060",
                "longitude": "23.55292100"
            },
            {
                "id": 4716,
                "name": "Yambol Province",
                "state_code": "28",
                "latitude": "42.48414940",
                "longitude": "26.50352960"
            }
        ]
    },
    {
        "name": "Burkina Faso",
        "iso3": "BFA",
        "iso2": "BF",
        "phone_code": "226",
        "capital": "Ouagadougou",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".bf",
        "native": "Burkina Faso",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Ouagadougou",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ë¶€ë¥´í‚¤ë‚˜ íŒŒì†Œ",
            "br": "Burkina Faso",
            "pt": "Burquina Faso",
            "nl": "Burkina Faso",
            "hr": "Burkina Faso",
            "fa": "Ø¨ÙˆØ±Ú©ÛŒÙ†Ø§ÙØ§Ø³Ùˆ",
            "de": "Burkina Faso",
            "es": "Burkina Faso",
            "fr": "Burkina Faso",
            "ja": "ãƒ–ãƒ«ã‚­ãƒŠãƒ•ã‚¡ã‚½",
            "it": "Burkina Faso",
            "cn": "å¸ƒåŸºçº³æ³•ç´¢"
        },
        "latitude": "13.00000000",
        "longitude": "-2.00000000",
        "emoji": "ðŸ‡§ðŸ‡«",
        "emojiU": "U+1F1E7 U+1F1EB",
        "states": [
            {
                "id": 3160,
                "name": "BalÃ© Province",
                "state_code": "BAL",
                "latitude": "11.78206020",
                "longitude": "-3.01757120"
            },
            {
                "id": 3155,
                "name": "Bam Province",
                "state_code": "BAM",
                "latitude": "13.44613300",
                "longitude": "-1.59839590"
            },
            {
                "id": 3120,
                "name": "Banwa Province",
                "state_code": "BAN",
                "latitude": "12.13230530",
                "longitude": "-4.15137640"
            },
            {
                "id": 3152,
                "name": "BazÃ¨ga Province",
                "state_code": "BAZ",
                "latitude": "11.97676920",
                "longitude": "-1.44346900"
            },
            {
                "id": 3138,
                "name": "Boucle du Mouhoun Region",
                "state_code": "01",
                "latitude": "12.41660000",
                "longitude": "-3.41955270"
            },
            {
                "id": 3121,
                "name": "Bougouriba Province",
                "state_code": "BGR",
                "latitude": "10.87226460",
                "longitude": "-3.33889170"
            },
            {
                "id": 3131,
                "name": "Boulgou",
                "state_code": "BLG",
                "latitude": "11.43367660",
                "longitude": "-0.37483540"
            },
            {
                "id": 3153,
                "name": "Cascades Region",
                "state_code": "02",
                "latitude": "10.40729920",
                "longitude": "-4.56244260"
            },
            {
                "id": 3136,
                "name": "Centre",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3162,
                "name": "Centre-Est Region",
                "state_code": "04",
                "latitude": "11.52476740",
                "longitude": "-0.14949880"
            },
            {
                "id": 3127,
                "name": "Centre-Nord Region",
                "state_code": "05",
                "latitude": "13.17244640",
                "longitude": "-0.90566230"
            },
            {
                "id": 3115,
                "name": "Centre-Ouest Region",
                "state_code": "06",
                "latitude": "11.87984660",
                "longitude": "-2.30244600"
            },
            {
                "id": 3149,
                "name": "Centre-Sud Region",
                "state_code": "07",
                "latitude": "11.52289110",
                "longitude": "-1.05861350"
            },
            {
                "id": 3167,
                "name": "ComoÃ© Province",
                "state_code": "COM",
                "latitude": "10.40729920",
                "longitude": "-4.56244260"
            },
            {
                "id": 3158,
                "name": "Est Region",
                "state_code": "08",
                "latitude": "12.43655260",
                "longitude": "0.90566230"
            },
            {
                "id": 3148,
                "name": "Ganzourgou Province",
                "state_code": "GAN",
                "latitude": "12.25376480",
                "longitude": "-0.75328090"
            },
            {
                "id": 3122,
                "name": "Gnagna Province",
                "state_code": "GNA",
                "latitude": "12.89749920",
                "longitude": "0.07467670"
            },
            {
                "id": 3143,
                "name": "Gourma Province",
                "state_code": "GOU",
                "latitude": "12.16244730",
                "longitude": "0.67730460"
            },
            {
                "id": 3165,
                "name": "Hauts-Bassins Region",
                "state_code": "09",
                "latitude": "11.49420030",
                "longitude": "-4.23333550"
            },
            {
                "id": 3129,
                "name": "Houet Province",
                "state_code": "HOU",
                "latitude": "11.13204470",
                "longitude": "-4.23333550"
            },
            {
                "id": 3135,
                "name": "Ioba Province",
                "state_code": "IOB",
                "latitude": "11.05620340",
                "longitude": "-3.01757120"
            },
            {
                "id": 3168,
                "name": "Kadiogo Province",
                "state_code": "KAD",
                "latitude": "12.34258970",
                "longitude": "-1.44346900"
            },
            {
                "id": 3112,
                "name": "KÃ©nÃ©dougou Province",
                "state_code": "KEN",
                "latitude": "11.39193950",
                "longitude": "-4.97665400"
            },
            {
                "id": 3132,
                "name": "Komondjari Province",
                "state_code": "KMD",
                "latitude": "12.71265270",
                "longitude": "0.67730460"
            },
            {
                "id": 3157,
                "name": "Kompienga Province",
                "state_code": "KMP",
                "latitude": "11.52383620",
                "longitude": "0.75328090"
            },
            {
                "id": 3146,
                "name": "Kossi Province",
                "state_code": "KOS",
                "latitude": "12.96045800",
                "longitude": "-3.90626880"
            },
            {
                "id": 3133,
                "name": "KoulpÃ©logo Province",
                "state_code": "KOP",
                "latitude": "11.52476740",
                "longitude": "0.14949880"
            },
            {
                "id": 3161,
                "name": "Kouritenga Province",
                "state_code": "KOT",
                "latitude": "12.16318130",
                "longitude": "-0.22446620"
            },
            {
                "id": 3147,
                "name": "KourwÃ©ogo Province",
                "state_code": "KOW",
                "latitude": "12.70774950",
                "longitude": "-1.75388170"
            },
            {
                "id": 3159,
                "name": "LÃ©raba Province",
                "state_code": "LER",
                "latitude": "10.66487850",
                "longitude": "-5.31025050"
            },
            {
                "id": 3151,
                "name": "Loroum Province",
                "state_code": "LOR",
                "latitude": "13.81298140",
                "longitude": "-2.06651970"
            },
            {
                "id": 3123,
                "name": "Mouhoun",
                "state_code": "MOU",
                "latitude": "12.14323810",
                "longitude": "-3.33889170"
            },
            {
                "id": 3116,
                "name": "Nahouri Province",
                "state_code": "NAO",
                "latitude": "11.25022670",
                "longitude": "-1.13530200"
            },
            {
                "id": 3113,
                "name": "Namentenga Province",
                "state_code": "NAM",
                "latitude": "13.08125840",
                "longitude": "-0.52578230"
            },
            {
                "id": 3142,
                "name": "Nayala Province",
                "state_code": "NAY",
                "latitude": "12.69645580",
                "longitude": "-3.01757120"
            },
            {
                "id": 3164,
                "name": "Nord Region, Burkina Faso",
                "state_code": "10",
                "latitude": "13.71825200",
                "longitude": "-2.30244600"
            },
            {
                "id": 3156,
                "name": "Noumbiel Province",
                "state_code": "NOU",
                "latitude": "9.84409460",
                "longitude": "-2.97755580"
            },
            {
                "id": 3141,
                "name": "Oubritenga Province",
                "state_code": "OUB",
                "latitude": "12.70960870",
                "longitude": "-1.44346900"
            },
            {
                "id": 3144,
                "name": "Oudalan Province",
                "state_code": "OUD",
                "latitude": "14.47190200",
                "longitude": "-0.45023680"
            },
            {
                "id": 3117,
                "name": "PassorÃ© Province",
                "state_code": "PAS",
                "latitude": "12.88812210",
                "longitude": "-2.22366670"
            },
            {
                "id": 3125,
                "name": "Plateau-Central Region",
                "state_code": "11",
                "latitude": "12.25376480",
                "longitude": "-0.75328090"
            },
            {
                "id": 3163,
                "name": "Poni Province",
                "state_code": "PON",
                "latitude": "10.33259960",
                "longitude": "-3.33889170"
            },
            {
                "id": 3114,
                "name": "Sahel Region",
                "state_code": "12",
                "latitude": "14.10008650",
                "longitude": "-0.14949880"
            },
            {
                "id": 3154,
                "name": "SanguiÃ© Province",
                "state_code": "SNG",
                "latitude": "12.15018610",
                "longitude": "-2.69838680"
            },
            {
                "id": 3126,
                "name": "Sanmatenga Province",
                "state_code": "SMT",
                "latitude": "13.35653040",
                "longitude": "-1.05861350"
            },
            {
                "id": 3139,
                "name": "SÃ©no Province",
                "state_code": "SEN",
                "latitude": "14.00722340",
                "longitude": "-0.07467670"
            },
            {
                "id": 3119,
                "name": "Sissili Province",
                "state_code": "SIS",
                "latitude": "11.24412190",
                "longitude": "-2.22366670"
            },
            {
                "id": 3166,
                "name": "Soum Province",
                "state_code": "SOM",
                "latitude": "14.09628410",
                "longitude": "-1.36621600"
            },
            {
                "id": 3137,
                "name": "Sourou Province",
                "state_code": "SOR",
                "latitude": "13.34180300",
                "longitude": "-2.93757390"
            },
            {
                "id": 3140,
                "name": "Sud-Ouest Region",
                "state_code": "13",
                "latitude": "10.42314930",
                "longitude": "-3.25836260"
            },
            {
                "id": 3128,
                "name": "Tapoa Province",
                "state_code": "TAP",
                "latitude": "12.24970720",
                "longitude": "1.67606910"
            },
            {
                "id": 3134,
                "name": "Tuy Province",
                "state_code": "TUI",
                "latitude": "38.88868400",
                "longitude": "-77.00471900"
            },
            {
                "id": 3124,
                "name": "Yagha Province",
                "state_code": "YAG",
                "latitude": "13.35761570",
                "longitude": "0.75328090"
            },
            {
                "id": 3150,
                "name": "Yatenga Province",
                "state_code": "YAT",
                "latitude": "13.62493440",
                "longitude": "-2.38136210"
            },
            {
                "id": 3145,
                "name": "Ziro Province",
                "state_code": "ZIR",
                "latitude": "11.60949950",
                "longitude": "-1.90992380"
            },
            {
                "id": 3130,
                "name": "Zondoma Province",
                "state_code": "ZON",
                "latitude": "13.11659260",
                "longitude": "-2.42087130"
            },
            {
                "id": 3118,
                "name": "ZoundwÃ©ogo Province",
                "state_code": "ZOU",
                "latitude": "11.61411740",
                "longitude": "-0.98206680"
            }
        ]
    },
    {
        "name": "Burundi",
        "iso3": "BDI",
        "iso2": "BI",
        "phone_code": "257",
        "capital": "Bujumbura",
        "currency": "BIF",
        "currency_symbol": "FBu",
        "tld": ".bi",
        "native": "Burundi",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Bujumbura",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ë¶€ë£¬ë””",
            "br": "Burundi",
            "pt": "BurÃºndi",
            "nl": "Burundi",
            "hr": "Burundi",
            "fa": "Ø¨ÙˆØ±ÙˆÙ†Ø¯ÛŒ",
            "de": "Burundi",
            "es": "Burundi",
            "fr": "Burundi",
            "ja": "ãƒ–ãƒ«ãƒ³ã‚¸",
            "it": "Burundi",
            "cn": "å¸ƒéš†è¿ª"
        },
        "latitude": "-3.50000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡§ðŸ‡®",
        "emojiU": "U+1F1E7 U+1F1EE",
        "states": [
            {
                "id": 3196,
                "name": "Bubanza Province",
                "state_code": "BB",
                "latitude": "-3.15724030",
                "longitude": "29.37149090"
            },
            {
                "id": 3198,
                "name": "Bujumbura Mairie Province",
                "state_code": "BM",
                "latitude": "-3.38841410",
                "longitude": "29.34826460"
            },
            {
                "id": 3200,
                "name": "Bujumbura Rural Province",
                "state_code": "BL",
                "latitude": "-3.50901440",
                "longitude": "29.46435900"
            },
            {
                "id": 3202,
                "name": "Bururi Province",
                "state_code": "BR",
                "latitude": "-3.90068510",
                "longitude": "29.51077080"
            },
            {
                "id": 3201,
                "name": "Cankuzo Province",
                "state_code": "CA",
                "latitude": "-3.15277880",
                "longitude": "30.61998950"
            },
            {
                "id": 3190,
                "name": "Cibitoke Province",
                "state_code": "CI",
                "latitude": "-2.81028970",
                "longitude": "29.18557850"
            },
            {
                "id": 3197,
                "name": "Gitega Province",
                "state_code": "GI",
                "latitude": "-3.49290510",
                "longitude": "29.92779470"
            },
            {
                "id": 3194,
                "name": "Karuzi Province",
                "state_code": "KR",
                "latitude": "-3.13403470",
                "longitude": "30.11273500"
            },
            {
                "id": 3192,
                "name": "Kayanza Province",
                "state_code": "KY",
                "latitude": "-3.00779810",
                "longitude": "29.64991620"
            },
            {
                "id": 3195,
                "name": "Kirundo Province",
                "state_code": "KI",
                "latitude": "-2.57628820",
                "longitude": "30.11273500"
            },
            {
                "id": 3188,
                "name": "Makamba Province",
                "state_code": "MA",
                "latitude": "-4.32570620",
                "longitude": "29.69626770"
            },
            {
                "id": 3193,
                "name": "Muramvya Province",
                "state_code": "MU",
                "latitude": "-3.28983980",
                "longitude": "29.64991620"
            },
            {
                "id": 3186,
                "name": "Muyinga Province",
                "state_code": "MY",
                "latitude": "-2.77935110",
                "longitude": "30.29741990"
            },
            {
                "id": 3187,
                "name": "Mwaro Province",
                "state_code": "MW",
                "latitude": "-3.50259180",
                "longitude": "29.64991620"
            },
            {
                "id": 3199,
                "name": "Ngozi Province",
                "state_code": "NG",
                "latitude": "-2.89582430",
                "longitude": "29.88152030"
            },
            {
                "id": 3185,
                "name": "Rumonge Province",
                "state_code": "RM",
                "latitude": "-3.97540490",
                "longitude": "29.43880140"
            },
            {
                "id": 3189,
                "name": "Rutana Province",
                "state_code": "RT",
                "latitude": "-3.87915230",
                "longitude": "30.06652360"
            },
            {
                "id": 3191,
                "name": "Ruyigi Province",
                "state_code": "RY",
                "latitude": "-3.44620700",
                "longitude": "30.25127280"
            }
        ]
    },
    {
        "name": "Cambodia",
        "iso3": "KHM",
        "iso2": "KH",
        "phone_code": "855",
        "capital": "Phnom Penh",
        "currency": "KHR",
        "currency_symbol": "KHR",
        "tld": ".kh",
        "native": "KÃ¢mpÅ­chÃ©a",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Phnom_Penh",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "kr": "ìº„ë³´ë””ì•„",
            "br": "Camboja",
            "pt": "Camboja",
            "nl": "Cambodja",
            "hr": "KambodÅ¾a",
            "fa": "Ú©Ø§Ù…Ø¨ÙˆØ¬",
            "de": "Kambodscha",
            "es": "Camboya",
            "fr": "Cambodge",
            "ja": "ã‚«ãƒ³ãƒœã‚¸ã‚¢",
            "it": "Cambogia",
            "cn": "æŸ¬åŸ”å¯¨"
        },
        "latitude": "13.00000000",
        "longitude": "105.00000000",
        "emoji": "ðŸ‡°ðŸ‡­",
        "emojiU": "U+1F1F0 U+1F1ED",
        "states": [
            {
                "id": 3984,
                "name": "Banteay Meanchey Province",
                "state_code": "1",
                "latitude": "13.75319140",
                "longitude": "102.98961500"
            },
            {
                "id": 3976,
                "name": "Battambang Province",
                "state_code": "2",
                "latitude": "13.02869710",
                "longitude": "102.98961500"
            },
            {
                "id": 3991,
                "name": "Kampong Cham Province",
                "state_code": "3",
                "latitude": "12.09829180",
                "longitude": "105.31311850"
            },
            {
                "id": 3979,
                "name": "Kampong Chhnang Province",
                "state_code": "4",
                "latitude": "12.13923520",
                "longitude": "104.56552730"
            },
            {
                "id": 3988,
                "name": "Kampong Speu Province",
                "state_code": "5",
                "latitude": "11.61551090",
                "longitude": "104.37919120"
            },
            {
                "id": 3981,
                "name": "Kampot Province",
                "state_code": "7",
                "latitude": "10.73253510",
                "longitude": "104.37919120"
            },
            {
                "id": 3983,
                "name": "Kandal Province",
                "state_code": "8",
                "latitude": "11.22373830",
                "longitude": "105.12589550"
            },
            {
                "id": 3978,
                "name": "Kep Province",
                "state_code": "23",
                "latitude": "10.53608900",
                "longitude": "104.35591580"
            },
            {
                "id": 3982,
                "name": "Koh Kong Province",
                "state_code": "9",
                "latitude": "11.57628040",
                "longitude": "103.35872880"
            },
            {
                "id": 3986,
                "name": "KratiÃ© Province",
                "state_code": "10",
                "latitude": "12.50436080",
                "longitude": "105.96998780"
            },
            {
                "id": 3985,
                "name": "Mondulkiri Province",
                "state_code": "11",
                "latitude": "12.78794270",
                "longitude": "107.10119310"
            },
            {
                "id": 3987,
                "name": "Oddar Meanchey Province",
                "state_code": "22",
                "latitude": "14.16097380",
                "longitude": "103.82162610"
            },
            {
                "id": 3980,
                "name": "Pailin Province",
                "state_code": "24",
                "latitude": "12.90929620",
                "longitude": "102.66755750"
            },
            {
                "id": 3994,
                "name": "Phnom Penh",
                "state_code": "12",
                "latitude": "11.55637380",
                "longitude": "104.92820990"
            },
            {
                "id": 3973,
                "name": "Preah Vihear Province",
                "state_code": "13",
                "latitude": "14.00857970",
                "longitude": "104.84546190"
            },
            {
                "id": 3974,
                "name": "Prey Veng Province",
                "state_code": "14",
                "latitude": "11.38024420",
                "longitude": "105.50054830"
            },
            {
                "id": 3977,
                "name": "Pursat Province",
                "state_code": "15",
                "latitude": "12.27209560",
                "longitude": "103.72891670"
            },
            {
                "id": 3990,
                "name": "Ratanakiri Province",
                "state_code": "16",
                "latitude": "13.85766070",
                "longitude": "107.10119310"
            },
            {
                "id": 3992,
                "name": "Siem Reap Province",
                "state_code": "17",
                "latitude": "13.33026600",
                "longitude": "104.10013260"
            },
            {
                "id": 3989,
                "name": "Sihanoukville Province",
                "state_code": "18",
                "latitude": "10.75818990",
                "longitude": "103.82162610"
            },
            {
                "id": 3993,
                "name": "Stung Treng Province",
                "state_code": "19",
                "latitude": "13.57647300",
                "longitude": "105.96998780"
            },
            {
                "id": 3972,
                "name": "Svay Rieng Province",
                "state_code": "20",
                "latitude": "11.14272200",
                "longitude": "105.82902980"
            },
            {
                "id": 3975,
                "name": "TakÃ©o Province",
                "state_code": "21",
                "latitude": "10.93215190",
                "longitude": "104.79877100"
            }
        ]
    },
    {
        "name": "Cameroon",
        "iso3": "CMR",
        "iso2": "CM",
        "phone_code": "237",
        "capital": "Yaounde",
        "currency": "XAF",
        "currency_symbol": "FCFA",
        "tld": ".cm",
        "native": "Cameroon",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Douala",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì¹´ë©”ë£¬",
            "br": "CamarÃµes",
            "pt": "CamarÃµes",
            "nl": "Kameroen",
            "hr": "Kamerun",
            "fa": "Ú©Ø§Ù…Ø±ÙˆÙ†",
            "de": "Kamerun",
            "es": "CamerÃºn",
            "fr": "Cameroun",
            "ja": "ã‚«ãƒ¡ãƒ«ãƒ¼ãƒ³",
            "it": "Camerun",
            "cn": "å–€éº¦éš†"
        },
        "latitude": "6.00000000",
        "longitude": "12.00000000",
        "emoji": "ðŸ‡¨ðŸ‡²",
        "emojiU": "U+1F1E8 U+1F1F2",
        "states": [
            {
                "id": 2663,
                "name": "Adamawa",
                "state_code": "AD",
                "latitude": "9.32647510",
                "longitude": "12.39838530"
            },
            {
                "id": 2660,
                "name": "Centre",
                "state_code": "CE",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2661,
                "name": "East",
                "state_code": "ES",
                "latitude": "39.01853360",
                "longitude": "-94.27924110"
            },
            {
                "id": 2656,
                "name": "Far North",
                "state_code": "EN",
                "latitude": "66.76134510",
                "longitude": "124.12375300"
            },
            {
                "id": 2662,
                "name": "Littoral",
                "state_code": "LT",
                "latitude": "48.46227570",
                "longitude": "-68.51780710"
            },
            {
                "id": 2665,
                "name": "North",
                "state_code": "NO",
                "latitude": "37.09024000",
                "longitude": "-95.71289100"
            },
            {
                "id": 2657,
                "name": "Northwest",
                "state_code": "NW",
                "latitude": "36.37118570",
                "longitude": "-94.19346060"
            },
            {
                "id": 2659,
                "name": "South",
                "state_code": "SU",
                "latitude": "37.63159500",
                "longitude": "-97.34584090"
            },
            {
                "id": 2658,
                "name": "Southwest",
                "state_code": "SW",
                "latitude": "36.19088130",
                "longitude": "-95.88974480"
            },
            {
                "id": 2664,
                "name": "West",
                "state_code": "OU",
                "latitude": "37.03649890",
                "longitude": "-95.67059870"
            }
        ]
    },
    {
        "name": "Canada",
        "iso3": "CAN",
        "iso2": "CA",
        "phone_code": "1",
        "capital": "Ottawa",
        "currency": "CAD",
        "currency_symbol": "$",
        "tld": ".ca",
        "native": "Canada",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "America\/Atikokan",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America)"
            },
            {
                "zoneName": "America\/Blanc-Sablon",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Cambridge_Bay",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Creston",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Dawson",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Dawson_Creek",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Edmonton",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Fort_Nelson",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America)"
            },
            {
                "zoneName": "America\/Glace_Bay",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Goose_Bay",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Halifax",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Inuvik",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Iqaluit",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Moncton",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            },
            {
                "zoneName": "America\/Nipigon",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Pangnirtung",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Rainy_River",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Rankin_Inlet",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Regina",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Resolute",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/St_Johns",
                "gmtOffset": -12600,
                "gmtOffsetName": "UTC-03:30",
                "abbreviation": "NST",
                "tzName": "Newfoundland Standard Time"
            },
            {
                "zoneName": "America\/Swift_Current",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Thunder_Bay",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Toronto",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Vancouver",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            },
            {
                "zoneName": "America\/Whitehorse",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Winnipeg",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Yellowknife",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ìºë‚˜ë‹¤",
            "br": "CanadÃ¡",
            "pt": "CanadÃ¡",
            "nl": "Canada",
            "hr": "Kanada",
            "fa": "Ú©Ø§Ù†Ø§Ø¯Ø§",
            "de": "Kanada",
            "es": "CanadÃ¡",
            "fr": "Canada",
            "ja": "ã‚«ãƒŠãƒ€",
            "it": "Canada",
            "cn": "åŠ æ‹¿å¤§"
        },
        "latitude": "60.00000000",
        "longitude": "-95.00000000",
        "emoji": "ðŸ‡¨ðŸ‡¦",
        "emojiU": "U+1F1E8 U+1F1E6",
        "states": [
            {
                "id": 872,
                "name": "Alberta",
                "state_code": "AB",
                "latitude": "53.93327060",
                "longitude": "-116.57650350"
            },
            {
                "id": 875,
                "name": "British Columbia",
                "state_code": "BC",
                "latitude": "53.72666830",
                "longitude": "-127.64762050"
            },
            {
                "id": 867,
                "name": "Manitoba",
                "state_code": "MB",
                "latitude": "53.76086080",
                "longitude": "-98.81387620"
            },
            {
                "id": 868,
                "name": "New Brunswick",
                "state_code": "NB",
                "latitude": "46.56531630",
                "longitude": "-66.46191640"
            },
            {
                "id": 877,
                "name": "Newfoundland and Labrador",
                "state_code": "NL",
                "latitude": "53.13550910",
                "longitude": "-57.66043640"
            },
            {
                "id": 878,
                "name": "Northwest Territories",
                "state_code": "NT",
                "latitude": "64.82554410",
                "longitude": "-124.84573340"
            },
            {
                "id": 874,
                "name": "Nova Scotia",
                "state_code": "NS",
                "latitude": "44.68198660",
                "longitude": "-63.74431100"
            },
            {
                "id": 876,
                "name": "Nunavut",
                "state_code": "NU",
                "latitude": "70.29977110",
                "longitude": "-83.10757700"
            },
            {
                "id": 866,
                "name": "Ontario",
                "state_code": "ON",
                "latitude": "51.25377500",
                "longitude": "-85.32321400"
            },
            {
                "id": 871,
                "name": "Prince Edward Island",
                "state_code": "PE",
                "latitude": "46.51071200",
                "longitude": "-63.41681360"
            },
            {
                "id": 873,
                "name": "Quebec",
                "state_code": "QC",
                "latitude": "52.93991590",
                "longitude": "-73.54913610"
            },
            {
                "id": 870,
                "name": "Saskatchewan",
                "state_code": "SK",
                "latitude": "52.93991590",
                "longitude": "-106.45086390"
            },
            {
                "id": 869,
                "name": "Yukon",
                "state_code": "YT",
                "latitude": "35.50672150",
                "longitude": "-97.76254410"
            }
        ]
    },
    {
        "name": "Cape Verde",
        "iso3": "CPV",
        "iso2": "CV",
        "phone_code": "238",
        "capital": "Praia",
        "currency": "CVE",
        "currency_symbol": "$",
        "tld": ".cv",
        "native": "Cabo Verde",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Atlantic\/Cape_Verde",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "CVT",
                "tzName": "Cape Verde Time"
            }
        ],
        "translations": {
            "kr": "ì¹´ë³´ë² ë¥´ë°",
            "br": "Cabo Verde",
            "pt": "Cabo Verde",
            "nl": "KaapverdiÃ«",
            "hr": "Zelenortska Republika",
            "fa": "Ú©ÛŒÙ¾ ÙˆØ±Ø¯",
            "de": "Kap Verde",
            "es": "Cabo Verde",
            "fr": "Cap Vert",
            "ja": "ã‚«ãƒ¼ãƒœãƒ™ãƒ«ãƒ‡",
            "it": "Capo Verde",
            "cn": "ä½›å¾—è§’"
        },
        "latitude": "16.00000000",
        "longitude": "-24.00000000",
        "emoji": "ðŸ‡¨ðŸ‡»",
        "emojiU": "U+1F1E8 U+1F1FB",
        "states": [
            {
                "id": 2994,
                "name": "Barlavento Islands",
                "state_code": "B",
                "latitude": "16.82368450",
                "longitude": "-23.99348810"
            },
            {
                "id": 2999,
                "name": "Boa Vista",
                "state_code": "BV",
                "latitude": "38.74346600",
                "longitude": "-120.73042970"
            },
            {
                "id": 2996,
                "name": "Brava",
                "state_code": "BR",
                "latitude": "40.98977780",
                "longitude": "-73.68357150"
            },
            {
                "id": 2991,
                "name": "Maio Municipality",
                "state_code": "MA",
                "latitude": "15.20030980",
                "longitude": "-23.16797930"
            },
            {
                "id": 2987,
                "name": "Mosteiros",
                "state_code": "MO",
                "latitude": "37.89043480",
                "longitude": "-25.82075560"
            },
            {
                "id": 2997,
                "name": "Paul",
                "state_code": "PA",
                "latitude": "37.06250000",
                "longitude": "-95.67706800"
            },
            {
                "id": 2989,
                "name": "Porto Novo",
                "state_code": "PN",
                "latitude": "6.49685740",
                "longitude": "2.62885230"
            },
            {
                "id": 2988,
                "name": "Praia",
                "state_code": "PR",
                "latitude": "14.93305000",
                "longitude": "-23.51332670"
            },
            {
                "id": 2982,
                "name": "Ribeira Brava Municipality",
                "state_code": "RB",
                "latitude": "16.60707390",
                "longitude": "-24.20338430"
            },
            {
                "id": 3002,
                "name": "Ribeira Grande",
                "state_code": "RG",
                "latitude": "37.82103690",
                "longitude": "-25.51481370"
            },
            {
                "id": 2984,
                "name": "Ribeira Grande de Santiago",
                "state_code": "RS",
                "latitude": "14.98302980",
                "longitude": "-23.65617250"
            },
            {
                "id": 2998,
                "name": "Sal",
                "state_code": "SL",
                "latitude": "26.59581220",
                "longitude": "-80.20450830"
            },
            {
                "id": 2985,
                "name": "Santa Catarina",
                "state_code": "CA",
                "latitude": "-27.24233920",
                "longitude": "-50.21885560"
            },
            {
                "id": 2995,
                "name": "Santa Catarina do Fogo",
                "state_code": "CF",
                "latitude": "14.93091040",
                "longitude": "-24.32225770"
            },
            {
                "id": 3004,
                "name": "Santa Cruz",
                "state_code": "CR",
                "latitude": "36.97411710",
                "longitude": "-122.03079630"
            },
            {
                "id": 2986,
                "name": "SÃ£o Domingos",
                "state_code": "SD",
                "latitude": "15.02861650",
                "longitude": "-23.56392200"
            },
            {
                "id": 3000,
                "name": "SÃ£o Filipe",
                "state_code": "SF",
                "latitude": "14.89516790",
                "longitude": "-24.49456360"
            },
            {
                "id": 2993,
                "name": "SÃ£o LourenÃ§o dos Ã“rgÃ£os",
                "state_code": "SO",
                "latitude": "15.05378410",
                "longitude": "-23.60856120"
            },
            {
                "id": 2990,
                "name": "SÃ£o Miguel",
                "state_code": "SM",
                "latitude": "37.78041100",
                "longitude": "-25.49704660"
            },
            {
                "id": 3001,
                "name": "SÃ£o Vicente",
                "state_code": "SV",
                "latitude": "-23.96071570",
                "longitude": "-46.39620220"
            },
            {
                "id": 2992,
                "name": "Sotavento Islands",
                "state_code": "S",
                "latitude": "15.00000000",
                "longitude": "-24.00000000"
            },
            {
                "id": 2983,
                "name": "Tarrafal",
                "state_code": "TA",
                "latitude": "15.27605780",
                "longitude": "-23.74840770"
            },
            {
                "id": 3003,
                "name": "Tarrafal de SÃ£o Nicolau",
                "state_code": "TS",
                "latitude": "16.56364980",
                "longitude": "-24.35494200"
            }
        ]
    },
    {
        "name": "Cayman Islands",
        "iso3": "CYM",
        "iso2": "KY",
        "phone_code": "+1-345",
        "capital": "George Town",
        "currency": "KYD",
        "currency_symbol": "$",
        "tld": ".ky",
        "native": "Cayman Islands",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Cayman",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ì¼€ì´ë¨¼ ì œë„",
            "br": "Ilhas Cayman",
            "pt": "Ilhas CaimÃ£o",
            "nl": "Caymaneilanden",
            "hr": "Kajmanski otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ú©ÛŒÙ…Ù†",
            "de": "Kaimaninseln",
            "es": "Islas CaimÃ¡n",
            "fr": "ÃŽles CaÃ¯mans",
            "ja": "ã‚±ã‚¤ãƒžãƒ³è«¸å³¶",
            "it": "Isole Cayman",
            "cn": "å¼€æ›¼ç¾¤å²›"
        },
        "latitude": "19.50000000",
        "longitude": "-80.50000000",
        "emoji": "ðŸ‡°ðŸ‡¾",
        "emojiU": "U+1F1F0 U+1F1FE",
        "states": []
    },
    {
        "name": "Central African Republic",
        "iso3": "CAF",
        "iso2": "CF",
        "phone_code": "236",
        "capital": "Bangui",
        "currency": "XAF",
        "currency_symbol": "FCFA",
        "tld": ".cf",
        "native": "KÃ¶dÃ¶rÃ¶sÃªse tÃ® BÃªafrÃ®ka",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Bangui",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì¤‘ì•™ì•„í”„ë¦¬ì¹´ ê³µí™”êµ­",
            "br": "RepÃºblica Centro-Africana",
            "pt": "RepÃºblica Centro-Africana",
            "nl": "Centraal-Afrikaanse Republiek",
            "hr": "SrednjoafriÄka Republika",
            "fa": "Ø¬Ù…Ù‡ÙˆØ±ÛŒ Ø¢ÙØ±ÛŒÙ‚Ø§ÛŒ Ù…Ø±Ú©Ø²ÛŒ",
            "de": "Zentralafrikanische Republik",
            "es": "RepÃºblica Centroafricana",
            "fr": "RÃ©publique centrafricaine",
            "ja": "ä¸­å¤®ã‚¢ãƒ•ãƒªã‚«å…±å’Œå›½",
            "it": "Repubblica Centrafricana",
            "cn": "ä¸­éž"
        },
        "latitude": "7.00000000",
        "longitude": "21.00000000",
        "emoji": "ðŸ‡¨ðŸ‡«",
        "emojiU": "U+1F1E8 U+1F1EB",
        "states": [
            {
                "id": 1259,
                "name": "Bamingui-Bangoran Prefecture",
                "state_code": "BB",
                "latitude": "8.27334550",
                "longitude": "20.71224650"
            },
            {
                "id": 1262,
                "name": "Bangui",
                "state_code": "BGF",
                "latitude": "4.39467350",
                "longitude": "18.55818990"
            },
            {
                "id": 1264,
                "name": "Basse-Kotto Prefecture",
                "state_code": "BK",
                "latitude": "4.87193190",
                "longitude": "21.28450250"
            },
            {
                "id": 1258,
                "name": "Haut-Mbomou Prefecture",
                "state_code": "HM",
                "latitude": "6.25371340",
                "longitude": "25.47335540"
            },
            {
                "id": 1268,
                "name": "Haute-Kotto Prefecture",
                "state_code": "HK",
                "latitude": "7.79643790",
                "longitude": "23.38235450"
            },
            {
                "id": 1263,
                "name": "KÃ©mo Prefecture",
                "state_code": "KG",
                "latitude": "5.88677940",
                "longitude": "19.37832060"
            },
            {
                "id": 1256,
                "name": "Lobaye Prefecture",
                "state_code": "LB",
                "latitude": "4.35259810",
                "longitude": "17.47951730"
            },
            {
                "id": 1257,
                "name": "MambÃ©rÃ©-KadÃ©Ã¯",
                "state_code": "HS",
                "latitude": "4.70556530",
                "longitude": "15.96998780"
            },
            {
                "id": 1266,
                "name": "Mbomou Prefecture",
                "state_code": "MB",
                "latitude": "5.55683700",
                "longitude": "23.76328280"
            },
            {
                "id": 1253,
                "name": "Nana-GrÃ©bizi Economic Prefecture",
                "state_code": "KB",
                "latitude": "7.18486070",
                "longitude": "19.37832060"
            },
            {
                "id": 1260,
                "name": "Nana-MambÃ©rÃ© Prefecture",
                "state_code": "NM",
                "latitude": "5.69321350",
                "longitude": "15.21948080"
            },
            {
                "id": 1255,
                "name": "Ombella-M'Poko Prefecture",
                "state_code": "MP",
                "latitude": "5.11888250",
                "longitude": "18.42760470"
            },
            {
                "id": 1265,
                "name": "Ouaka Prefecture",
                "state_code": "UK",
                "latitude": "6.31682160",
                "longitude": "20.71224650"
            },
            {
                "id": 1254,
                "name": "Ouham Prefecture",
                "state_code": "AC",
                "latitude": "7.09091100",
                "longitude": "17.66888700"
            },
            {
                "id": 1267,
                "name": "Ouham-PendÃ© Prefecture",
                "state_code": "OP",
                "latitude": "6.48509840",
                "longitude": "16.15809370"
            },
            {
                "id": 1252,
                "name": "Sangha-MbaÃ©rÃ©",
                "state_code": "SE",
                "latitude": "3.43686070",
                "longitude": "16.34637910"
            },
            {
                "id": 1261,
                "name": "Vakaga Prefecture",
                "state_code": "VK",
                "latitude": "9.51132960",
                "longitude": "22.23840170"
            }
        ]
    },
    {
        "name": "Chad",
        "iso3": "TCD",
        "iso2": "TD",
        "phone_code": "235",
        "capital": "N'Djamena",
        "currency": "XAF",
        "currency_symbol": "FCFA",
        "tld": ".td",
        "native": "Tchad",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Ndjamena",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì°¨ë“œ",
            "br": "Chade",
            "pt": "Chade",
            "nl": "Tsjaad",
            "hr": "ÄŒad",
            "fa": "Ú†Ø§Ø¯",
            "de": "Tschad",
            "es": "Chad",
            "fr": "Tchad",
            "ja": "ãƒãƒ£ãƒ‰",
            "it": "Ciad",
            "cn": "ä¹å¾—"
        },
        "latitude": "15.00000000",
        "longitude": "19.00000000",
        "emoji": "ðŸ‡¹ðŸ‡©",
        "emojiU": "U+1F1F9 U+1F1E9",
        "states": [
            {
                "id": 3583,
                "name": "Bahr el Gazel",
                "state_code": "BG",
                "latitude": "14.77022660",
                "longitude": "16.91225100"
            },
            {
                "id": 3590,
                "name": "Batha Region",
                "state_code": "BA",
                "latitude": "13.93717750",
                "longitude": "18.42760470"
            },
            {
                "id": 3574,
                "name": "Borkou",
                "state_code": "BO",
                "latitude": "17.86888450",
                "longitude": "18.80761950"
            },
            {
                "id": 3578,
                "name": "Ennedi Region",
                "state_code": "EN",
                "latitude": "17.54145780",
                "longitude": "21.85685860"
            },
            {
                "id": 3575,
                "name": "Ennedi-Est",
                "state_code": "EE",
                "latitude": "16.34204960",
                "longitude": "23.00119890"
            },
            {
                "id": 3584,
                "name": "Ennedi-Ouest",
                "state_code": "EO",
                "latitude": "18.97756300",
                "longitude": "21.85685860"
            },
            {
                "id": 3576,
                "name": "GuÃ©ra Region",
                "state_code": "GR",
                "latitude": "11.12190150",
                "longitude": "18.42760470"
            },
            {
                "id": 3573,
                "name": "Hadjer-Lamis",
                "state_code": "HL",
                "latitude": "12.45772730",
                "longitude": "16.72346390"
            },
            {
                "id": 3588,
                "name": "Kanem Region",
                "state_code": "KA",
                "latitude": "14.87812620",
                "longitude": "15.40680790"
            },
            {
                "id": 3577,
                "name": "Lac Region",
                "state_code": "LC",
                "latitude": "13.69153770",
                "longitude": "14.10013260"
            },
            {
                "id": 3585,
                "name": "Logone Occidental Region",
                "state_code": "LO",
                "latitude": "8.75967600",
                "longitude": "15.87600400"
            },
            {
                "id": 3591,
                "name": "Logone Oriental Region",
                "state_code": "LR",
                "latitude": "8.31499490",
                "longitude": "16.34637910"
            },
            {
                "id": 3589,
                "name": "Mandoul Region",
                "state_code": "MA",
                "latitude": "8.60309100",
                "longitude": "17.47951730"
            },
            {
                "id": 3580,
                "name": "Mayo-Kebbi Est Region",
                "state_code": "ME",
                "latitude": "9.40460390",
                "longitude": "14.84546190"
            },
            {
                "id": 3571,
                "name": "Mayo-Kebbi Ouest Region",
                "state_code": "MO",
                "latitude": "10.41130140",
                "longitude": "15.59433880"
            },
            {
                "id": 3570,
                "name": "Moyen-Chari Region",
                "state_code": "MC",
                "latitude": "9.06399980",
                "longitude": "18.42760470"
            },
            {
                "id": 3586,
                "name": "N'Djamena",
                "state_code": "ND",
                "latitude": "12.13484570",
                "longitude": "15.05574150"
            },
            {
                "id": 3582,
                "name": "OuaddaÃ¯ Region",
                "state_code": "OD",
                "latitude": "13.74847600",
                "longitude": "20.71224650"
            },
            {
                "id": 3592,
                "name": "Salamat Region",
                "state_code": "SA",
                "latitude": "10.96916010",
                "longitude": "20.71224650"
            },
            {
                "id": 3572,
                "name": "Sila Region",
                "state_code": "SI",
                "latitude": "12.13074000",
                "longitude": "21.28450250"
            },
            {
                "id": 3579,
                "name": "TandjilÃ© Region",
                "state_code": "TA",
                "latitude": "9.66257290",
                "longitude": "16.72346390"
            },
            {
                "id": 3587,
                "name": "Tibesti Region",
                "state_code": "TI",
                "latitude": "21.36500310",
                "longitude": "16.91225100"
            },
            {
                "id": 3581,
                "name": "Wadi Fira Region",
                "state_code": "WF",
                "latitude": "15.08924160",
                "longitude": "21.47528510"
            }
        ]
    },
    {
        "name": "Chile",
        "iso3": "CHL",
        "iso2": "CL",
        "phone_code": "56",
        "capital": "Santiago",
        "currency": "CLP",
        "currency_symbol": "$",
        "tld": ".cl",
        "native": "Chile",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Punta_Arenas",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "America\/Santiago",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "CLST",
                "tzName": "Chile Summer Time"
            },
            {
                "zoneName": "Pacific\/Easter",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EASST",
                "tzName": "Easter Island Summer Time"
            }
        ],
        "translations": {
            "kr": "ì¹ ë¦¬",
            "br": "Chile",
            "pt": "Chile",
            "nl": "Chili",
            "hr": "ÄŒile",
            "fa": "Ø´ÛŒÙ„ÛŒ",
            "de": "Chile",
            "es": "Chile",
            "fr": "Chili",
            "ja": "ãƒãƒª",
            "it": "Cile",
            "cn": "æ™ºåˆ©"
        },
        "latitude": "-30.00000000",
        "longitude": "-71.00000000",
        "emoji": "ðŸ‡¨ðŸ‡±",
        "emojiU": "U+1F1E8 U+1F1F1",
        "states": [
            {
                "id": 2828,
                "name": "AisÃ©n del General Carlos IbaÃ±ez del Campo",
                "state_code": "AI",
                "latitude": "-46.37834500",
                "longitude": "-72.30076230"
            },
            {
                "id": 2832,
                "name": "Antofagasta",
                "state_code": "AN",
                "latitude": "-23.83691040",
                "longitude": "-69.28775350"
            },
            {
                "id": 2829,
                "name": "Arica y Parinacota",
                "state_code": "AP",
                "latitude": "-18.59404850",
                "longitude": "-69.47845410"
            },
            {
                "id": 2823,
                "name": "Atacama",
                "state_code": "AT",
                "latitude": "-27.56605580",
                "longitude": "-70.05031400"
            },
            {
                "id": 2827,
                "name": "BiobÃ­o",
                "state_code": "BI",
                "latitude": "-37.44644280",
                "longitude": "-72.14161320"
            },
            {
                "id": 2825,
                "name": "Coquimbo",
                "state_code": "CO",
                "latitude": "-30.54018100",
                "longitude": "-70.81199530"
            },
            {
                "id": 2826,
                "name": "La AraucanÃ­a",
                "state_code": "AR",
                "latitude": "-38.94892100",
                "longitude": "-72.33111300"
            },
            {
                "id": 2838,
                "name": "Libertador General Bernardo O'Higgins",
                "state_code": "LI",
                "latitude": "-34.57553740",
                "longitude": "-71.00223110"
            },
            {
                "id": 2835,
                "name": "Los Lagos",
                "state_code": "LL",
                "latitude": "-41.91977790",
                "longitude": "-72.14161320"
            },
            {
                "id": 2834,
                "name": "Los RÃ­os",
                "state_code": "LR",
                "latitude": "-40.23102170",
                "longitude": "-72.33111300"
            },
            {
                "id": 2836,
                "name": "Magallanes y de la AntÃ¡rtica Chilena",
                "state_code": "MA",
                "latitude": "-52.20643160",
                "longitude": "-72.16850010"
            },
            {
                "id": 2833,
                "name": "Maule",
                "state_code": "ML",
                "latitude": "-35.51636030",
                "longitude": "-71.57239530"
            },
            {
                "id": 2831,
                "name": "Ã‘uble",
                "state_code": "NB",
                "latitude": "-36.72257430",
                "longitude": "-71.76224810"
            },
            {
                "id": 2824,
                "name": "RegiÃ³n Metropolitana de Santiago",
                "state_code": "RM",
                "latitude": "-33.43755450",
                "longitude": "-70.65048960"
            },
            {
                "id": 2837,
                "name": "TarapacÃ¡",
                "state_code": "TA",
                "latitude": "-20.20287990",
                "longitude": "-69.28775350"
            },
            {
                "id": 2830,
                "name": "ValparaÃ­so",
                "state_code": "VS",
                "latitude": "-33.04723800",
                "longitude": "-71.61268850"
            }
        ]
    },
    {
        "name": "China",
        "iso3": "CHN",
        "iso2": "CN",
        "phone_code": "86",
        "capital": "Beijing",
        "currency": "CNY",
        "currency_symbol": "Â¥",
        "tld": ".cn",
        "native": "ä¸­å›½",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Shanghai",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            },
            {
                "zoneName": "Asia\/Urumqi",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "XJT",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¤‘êµ­",
            "br": "China",
            "pt": "China",
            "nl": "China",
            "hr": "Kina",
            "fa": "Ú†ÛŒÙ†",
            "de": "China",
            "es": "China",
            "fr": "Chine",
            "ja": "ä¸­å›½",
            "it": "Cina",
            "cn": "ä¸­å›½"
        },
        "latitude": "35.00000000",
        "longitude": "105.00000000",
        "emoji": "ðŸ‡¨ðŸ‡³",
        "emojiU": "U+1F1E8 U+1F1F3",
        "states": [
            {
                "id": 2251,
                "name": "Anhui",
                "state_code": "AH",
                "latitude": "30.60067730",
                "longitude": "117.92490020"
            },
            {
                "id": 2257,
                "name": "Beijing",
                "state_code": "BJ",
                "latitude": "39.90419990",
                "longitude": "116.40739630"
            },
            {
                "id": 2271,
                "name": "Chongqing",
                "state_code": "CQ",
                "latitude": "29.43158610",
                "longitude": "106.91225100"
            },
            {
                "id": 2248,
                "name": "Fujian",
                "state_code": "FJ",
                "latitude": "26.48368420",
                "longitude": "117.92490020"
            },
            {
                "id": 2275,
                "name": "Gansu",
                "state_code": "GS",
                "latitude": "35.75183260",
                "longitude": "104.28611160"
            },
            {
                "id": 2279,
                "name": "Guangdong",
                "state_code": "GD",
                "latitude": "23.37903330",
                "longitude": "113.76328280"
            },
            {
                "id": 2278,
                "name": "Guangxi Zhuang Autonomous Region",
                "state_code": "GX",
                "latitude": "23.72475990",
                "longitude": "108.80761950"
            },
            {
                "id": 2261,
                "name": "Guizhou",
                "state_code": "GZ",
                "latitude": "26.84296450",
                "longitude": "107.29028390"
            },
            {
                "id": 2273,
                "name": "Hainan",
                "state_code": "HI",
                "latitude": "19.56639470",
                "longitude": "109.94968600"
            },
            {
                "id": 2280,
                "name": "Hebei",
                "state_code": "HE",
                "latitude": "37.89565940",
                "longitude": "114.90422080"
            },
            {
                "id": 2265,
                "name": "Heilongjiang",
                "state_code": "HL",
                "latitude": "47.12164720",
                "longitude": "128.73823100"
            },
            {
                "id": 2259,
                "name": "Henan",
                "state_code": "HA",
                "latitude": "34.29043020",
                "longitude": "113.38235450"
            },
            {
                "id": 2267,
                "name": "Hong Kong",
                "state_code": "HK",
                "latitude": "22.31930390",
                "longitude": "114.16936110"
            },
            {
                "id": 2274,
                "name": "Hubei",
                "state_code": "HB",
                "latitude": "30.73781180",
                "longitude": "112.23840170"
            },
            {
                "id": 2258,
                "name": "Hunan",
                "state_code": "HN",
                "latitude": "36.73412940",
                "longitude": "-95.93449020"
            },
            {
                "id": 2269,
                "name": "Inner Mongolia",
                "state_code": "NM",
                "latitude": "43.37822000",
                "longitude": "115.05948150"
            },
            {
                "id": 2250,
                "name": "Jiangsu",
                "state_code": "JS",
                "latitude": "33.14017150",
                "longitude": "119.78892480"
            },
            {
                "id": 2256,
                "name": "Jiangxi",
                "state_code": "JX",
                "latitude": "27.08745640",
                "longitude": "114.90422080"
            },
            {
                "id": 2253,
                "name": "Jilin",
                "state_code": "JL",
                "latitude": "43.83788300",
                "longitude": "126.54957200"
            },
            {
                "id": 2276,
                "name": "Keelung",
                "state_code": "TW-KEE",
                "latitude": "25.12760330",
                "longitude": "121.73918330"
            },
            {
                "id": 2268,
                "name": "Liaoning",
                "state_code": "LN",
                "latitude": "41.94365430",
                "longitude": "122.52903760"
            },
            {
                "id": 2266,
                "name": "Macau",
                "state_code": "MO",
                "latitude": "22.19874500",
                "longitude": "113.54387300"
            },
            {
                "id": 2262,
                "name": "Ningxia Hui Autonomous Region",
                "state_code": "NX",
                "latitude": "37.19873100",
                "longitude": "106.15809370"
            },
            {
                "id": 2270,
                "name": "Qinghai",
                "state_code": "QH",
                "latitude": "35.74479800",
                "longitude": "96.40773580"
            },
            {
                "id": 2272,
                "name": "Shaanxi",
                "state_code": "SN",
                "latitude": "35.39399080",
                "longitude": "109.18800470"
            },
            {
                "id": 2252,
                "name": "Shandong",
                "state_code": "SD",
                "latitude": "37.80060640",
                "longitude": "-122.26999180"
            },
            {
                "id": 2249,
                "name": "Shanghai",
                "state_code": "SH",
                "latitude": "31.23041600",
                "longitude": "121.47370100"
            },
            {
                "id": 2254,
                "name": "Shanxi",
                "state_code": "SX",
                "latitude": "37.24256490",
                "longitude": "111.85685860"
            },
            {
                "id": 2277,
                "name": "Sichuan",
                "state_code": "SC",
                "latitude": "30.26380320",
                "longitude": "102.80547530"
            },
            {
                "id": 2255,
                "name": "Taiwan Province, People's Republic of China",
                "state_code": "TW",
                "latitude": "23.69781000",
                "longitude": "120.96051500"
            },
            {
                "id": 2264,
                "name": "Tibet Autonomous Region",
                "state_code": "XZ",
                "latitude": "30.15336050",
                "longitude": "88.78786780"
            },
            {
                "id": 2263,
                "name": "Xinjiang",
                "state_code": "XJ",
                "latitude": "42.52463570",
                "longitude": "87.53958550"
            },
            {
                "id": 2260,
                "name": "Yunnan",
                "state_code": "YN",
                "latitude": "24.47528470",
                "longitude": "101.34310580"
            },
            {
                "id": 2247,
                "name": "Zhejiang",
                "state_code": "ZJ",
                "latitude": "29.14164320",
                "longitude": "119.78892480"
            }
        ]
    },
    {
        "name": "Christmas Island",
        "iso3": "CXR",
        "iso2": "CX",
        "phone_code": "61",
        "capital": "Flying Fish Cove",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".cx",
        "native": "Christmas Island",
        "region": "Oceania",
        "subregion": "Australia and New Zealand",
        "timezones": [
            {
                "zoneName": "Indian\/Christmas",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "CXT",
                "tzName": "Christmas Island Time"
            }
        ],
        "translations": {
            "kr": "í¬ë¦¬ìŠ¤ë§ˆìŠ¤ ì„¬",
            "br": "Ilha Christmas",
            "pt": "Ilha do Natal",
            "nl": "Christmaseiland",
            "hr": "BoÅ¾iÄ‡ni otok",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ú©Ø±ÛŒØ³Ù…Ø³",
            "de": "Weihnachtsinsel",
            "es": "Isla de Navidad",
            "fr": "ÃŽle Christmas",
            "ja": "ã‚¯ãƒªã‚¹ãƒžã‚¹å³¶",
            "it": "Isola di Natale",
            "cn": "åœ£è¯žå²›"
        },
        "latitude": "-10.50000000",
        "longitude": "105.66666666",
        "emoji": "ðŸ‡¨ðŸ‡½",
        "emojiU": "U+1F1E8 U+1F1FD",
        "states": []
    },
    {
        "name": "Cocos (Keeling) Islands",
        "iso3": "CCK",
        "iso2": "CC",
        "phone_code": "61",
        "capital": "West Island",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".cc",
        "native": "Cocos (Keeling) Islands",
        "region": "Oceania",
        "subregion": "Australia and New Zealand",
        "timezones": [
            {
                "zoneName": "Indian\/Cocos",
                "gmtOffset": 23400,
                "gmtOffsetName": "UTC+06:30",
                "abbreviation": "CCT",
                "tzName": "Cocos Islands Time"
            }
        ],
        "translations": {
            "kr": "ì½”ì½”ìŠ¤ ì œë„",
            "br": "Ilhas Cocos",
            "pt": "Ilhas dos Cocos",
            "nl": "Cocoseilanden",
            "hr": "Kokosovi Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ú©ÙˆÚ©ÙˆØ³",
            "de": "Kokosinseln",
            "es": "Islas Cocos o Islas Keeling",
            "fr": "ÃŽles Cocos",
            "ja": "ã‚³ã‚³ã‚¹ï¼ˆã‚­ãƒ¼ãƒªãƒ³ã‚°ï¼‰è«¸å³¶",
            "it": "Isole Cocos e Keeling",
            "cn": "ç§‘ç§‘æ–¯ï¼ˆåŸºæž—ï¼‰ç¾¤å²›"
        },
        "latitude": "-12.50000000",
        "longitude": "96.83333333",
        "emoji": "ðŸ‡¨ðŸ‡¨",
        "emojiU": "U+1F1E8 U+1F1E8",
        "states": []
    },
    {
        "name": "Colombia",
        "iso3": "COL",
        "iso2": "CO",
        "phone_code": "57",
        "capital": "Bogota",
        "currency": "COP",
        "currency_symbol": "$",
        "tld": ".co",
        "native": "Colombia",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Bogota",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "COT",
                "tzName": "Colombia Time"
            }
        ],
        "translations": {
            "kr": "ì½œë¡¬ë¹„ì•„",
            "br": "ColÃ´mbia",
            "pt": "ColÃ´mbia",
            "nl": "Colombia",
            "hr": "Kolumbija",
            "fa": "Ú©Ù„Ù…Ø¨ÛŒØ§",
            "de": "Kolumbien",
            "es": "Colombia",
            "fr": "Colombie",
            "ja": "ã‚³ãƒ­ãƒ³ãƒ“ã‚¢",
            "it": "Colombia",
            "cn": "å“¥ä¼¦æ¯”äºš"
        },
        "latitude": "4.00000000",
        "longitude": "-72.00000000",
        "emoji": "ðŸ‡¨ðŸ‡´",
        "emojiU": "U+1F1E8 U+1F1F4",
        "states": [
            {
                "id": 2895,
                "name": "Amazonas",
                "state_code": "AMA",
                "latitude": "-1.44291230",
                "longitude": "-71.57239530"
            },
            {
                "id": 2890,
                "name": "Antioquia",
                "state_code": "ANT",
                "latitude": "7.19860640",
                "longitude": "-75.34121790"
            },
            {
                "id": 2881,
                "name": "Arauca",
                "state_code": "ARA",
                "latitude": "6.54730600",
                "longitude": "-71.00223110"
            },
            {
                "id": 2880,
                "name": "AtlÃ¡ntico",
                "state_code": "ATL",
                "latitude": "10.69661590",
                "longitude": "-74.87410450"
            },
            {
                "id": 4921,
                "name": "BogotÃ¡",
                "state_code": "DC",
                "latitude": "4.28204150",
                "longitude": "-74.50270420"
            },
            {
                "id": 2893,
                "name": "BolÃ­var",
                "state_code": "BOL",
                "latitude": "8.67043820",
                "longitude": "-74.03001220"
            },
            {
                "id": 2903,
                "name": "BoyacÃ¡",
                "state_code": "BOY",
                "latitude": "5.45451100",
                "longitude": "-73.36200300"
            },
            {
                "id": 2887,
                "name": "Caldas",
                "state_code": "CAL",
                "latitude": "5.29826000",
                "longitude": "-75.24790610"
            },
            {
                "id": 2891,
                "name": "CaquetÃ¡",
                "state_code": "CAQ",
                "latitude": "0.86989200",
                "longitude": "-73.84190630"
            },
            {
                "id": 2892,
                "name": "Casanare",
                "state_code": "CAS",
                "latitude": "5.75892690",
                "longitude": "-71.57239530"
            },
            {
                "id": 2884,
                "name": "Cauca",
                "state_code": "CAU",
                "latitude": "2.70498130",
                "longitude": "-76.82596520"
            },
            {
                "id": 2899,
                "name": "Cesar",
                "state_code": "CES",
                "latitude": "9.33729480",
                "longitude": "-73.65362090"
            },
            {
                "id": 2876,
                "name": "ChocÃ³",
                "state_code": "CHO",
                "latitude": "5.25280330",
                "longitude": "-76.82596520"
            },
            {
                "id": 2898,
                "name": "CÃ³rdoba",
                "state_code": "COR",
                "latitude": "8.04929300",
                "longitude": "-75.57405000"
            },
            {
                "id": 2875,
                "name": "Cundinamarca",
                "state_code": "CUN",
                "latitude": "5.02600300",
                "longitude": "-74.03001220"
            },
            {
                "id": 2882,
                "name": "GuainÃ­a",
                "state_code": "GUA",
                "latitude": "2.58539300",
                "longitude": "-68.52471490"
            },
            {
                "id": 2888,
                "name": "Guaviare",
                "state_code": "GUV",
                "latitude": "2.04392400",
                "longitude": "-72.33111300"
            },
            {
                "id": 4871,
                "name": "Huila",
                "state_code": "HUI",
                "latitude": "2.53593490",
                "longitude": "-75.52766990"
            },
            {
                "id": 2889,
                "name": "La Guajira",
                "state_code": "LAG",
                "latitude": "11.35477430",
                "longitude": "-72.52048270"
            },
            {
                "id": 2886,
                "name": "Magdalena",
                "state_code": "MAG",
                "latitude": "10.41130140",
                "longitude": "-74.40566120"
            },
            {
                "id": 2878,
                "name": "Meta",
                "state_code": "MET",
                "latitude": "39.76732580",
                "longitude": "-104.97535950"
            },
            {
                "id": 2897,
                "name": "NariÃ±o",
                "state_code": "NAR",
                "latitude": "1.28915100",
                "longitude": "-77.35794000"
            },
            {
                "id": 2877,
                "name": "Norte de Santander",
                "state_code": "NSA",
                "latitude": "7.94628310",
                "longitude": "-72.89880690"
            },
            {
                "id": 2896,
                "name": "Putumayo",
                "state_code": "PUT",
                "latitude": "0.43595060",
                "longitude": "-75.52766990"
            },
            {
                "id": 2874,
                "name": "QuindÃ­o",
                "state_code": "QUI",
                "latitude": "4.46101910",
                "longitude": "-75.66735600"
            },
            {
                "id": 2879,
                "name": "Risaralda",
                "state_code": "RIS",
                "latitude": "5.31584750",
                "longitude": "-75.99276520"
            },
            {
                "id": 2900,
                "name": "San AndrÃ©s, Providencia y Santa Catalina",
                "state_code": "SAP",
                "latitude": "12.55673240",
                "longitude": "-81.71852530"
            },
            {
                "id": 2901,
                "name": "Santander",
                "state_code": "SAN",
                "latitude": "6.64370760",
                "longitude": "-73.65362090"
            },
            {
                "id": 2902,
                "name": "Sucre",
                "state_code": "SUC",
                "latitude": "8.81397700",
                "longitude": "-74.72328300"
            },
            {
                "id": 2883,
                "name": "Tolima",
                "state_code": "TOL",
                "latitude": "4.09251680",
                "longitude": "-75.15453810"
            },
            {
                "id": 2904,
                "name": "Valle del Cauca",
                "state_code": "VAC",
                "latitude": "3.80088930",
                "longitude": "-76.64127120"
            },
            {
                "id": 2885,
                "name": "VaupÃ©s",
                "state_code": "VAU",
                "latitude": "0.85535610",
                "longitude": "-70.81199530"
            },
            {
                "id": 2894,
                "name": "Vichada",
                "state_code": "VID",
                "latitude": "4.42344520",
                "longitude": "-69.28775350"
            }
        ]
    },
    {
        "name": "Comoros",
        "iso3": "COM",
        "iso2": "KM",
        "phone_code": "269",
        "capital": "Moroni",
        "currency": "KMF",
        "currency_symbol": "CF",
        "tld": ".km",
        "native": "Komori",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Comoro",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì½”ëª¨ë¡œ",
            "br": "Comores",
            "pt": "Comores",
            "nl": "Comoren",
            "hr": "Komori",
            "fa": "Ú©ÙˆÙ…ÙˆØ±",
            "de": "Union der Komoren",
            "es": "Comoras",
            "fr": "Comores",
            "ja": "ã‚³ãƒ¢ãƒ­",
            "it": "Comore",
            "cn": "ç§‘æ‘©ç½—"
        },
        "latitude": "-12.16666666",
        "longitude": "44.25000000",
        "emoji": "ðŸ‡°ðŸ‡²",
        "emojiU": "U+1F1F0 U+1F1F2",
        "states": [
            {
                "id": 2821,
                "name": "Anjouan",
                "state_code": "A",
                "latitude": "-12.21381450",
                "longitude": "44.43706060"
            },
            {
                "id": 2822,
                "name": "Grande Comore",
                "state_code": "G",
                "latitude": "-11.71673380",
                "longitude": "43.36807880"
            },
            {
                "id": 2820,
                "name": "MohÃ©li",
                "state_code": "M",
                "latitude": "-12.33773760",
                "longitude": "43.73340890"
            }
        ]
    },
    {
        "name": "Congo",
        "iso3": "COG",
        "iso2": "CG",
        "phone_code": "242",
        "capital": "Brazzaville",
        "currency": "XAF",
        "currency_symbol": "FC",
        "tld": ".cg",
        "native": "RÃ©publique du Congo",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Brazzaville",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì½©ê³ ",
            "br": "Congo",
            "pt": "Congo",
            "nl": "Congo [Republiek]",
            "hr": "Kongo",
            "fa": "Ú©Ù†Ú¯Ùˆ",
            "de": "Kongo",
            "es": "Congo",
            "fr": "Congo",
            "ja": "ã‚³ãƒ³ã‚´å…±å’Œå›½",
            "it": "Congo",
            "cn": "åˆšæžœ"
        },
        "latitude": "-1.00000000",
        "longitude": "15.00000000",
        "emoji": "ðŸ‡¨ðŸ‡¬",
        "emojiU": "U+1F1E8 U+1F1EC",
        "states": [
            {
                "id": 2866,
                "name": "Bouenza Department",
                "state_code": "11",
                "latitude": "-4.11280790",
                "longitude": "13.72891670"
            },
            {
                "id": 2870,
                "name": "Brazzaville",
                "state_code": "BZV",
                "latitude": "-4.26335970",
                "longitude": "15.24288530"
            },
            {
                "id": 2864,
                "name": "Cuvette Department",
                "state_code": "8",
                "latitude": "-0.28774460",
                "longitude": "16.15809370"
            },
            {
                "id": 2869,
                "name": "Cuvette-Ouest Department",
                "state_code": "15",
                "latitude": "0.14475500",
                "longitude": "14.47233010"
            },
            {
                "id": 2867,
                "name": "Kouilou Department",
                "state_code": "5",
                "latitude": "-4.14284130",
                "longitude": "11.88917210"
            },
            {
                "id": 2868,
                "name": "LÃ©koumou Department",
                "state_code": "2",
                "latitude": "-3.17038200",
                "longitude": "13.35872880"
            },
            {
                "id": 2865,
                "name": "Likouala Department",
                "state_code": "7",
                "latitude": "2.04392400",
                "longitude": "17.66888700"
            },
            {
                "id": 2872,
                "name": "Niari Department",
                "state_code": "9",
                "latitude": "-3.18427000",
                "longitude": "12.25479190"
            },
            {
                "id": 2862,
                "name": "Plateaux Department",
                "state_code": "14",
                "latitude": "-2.06800880",
                "longitude": "15.40680790"
            },
            {
                "id": 2863,
                "name": "Pointe-Noire",
                "state_code": "16",
                "latitude": "-4.76916230",
                "longitude": "11.86636200"
            },
            {
                "id": 2873,
                "name": "Pool Department",
                "state_code": "12",
                "latitude": "-3.77626280",
                "longitude": "14.84546190"
            },
            {
                "id": 2871,
                "name": "Sangha Department",
                "state_code": "13",
                "latitude": "1.46623280",
                "longitude": "15.40680790"
            }
        ]
    },
    {
        "name": "Congo The Democratic Republic Of The",
        "iso3": "COD",
        "iso2": "CD",
        "phone_code": "243",
        "capital": "Kinshasa",
        "currency": "CDF",
        "currency_symbol": "FC",
        "tld": ".cd",
        "native": "RÃ©publique dÃ©mocratique du Congo",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Kinshasa",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            },
            {
                "zoneName": "Africa\/Lubumbashi",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ì½©ê³  ë¯¼ì£¼ ê³µí™”êµ­",
            "br": "RD Congo",
            "pt": "RD Congo",
            "nl": "Congo [DRC]",
            "hr": "Kongo, Demokratska Republika",
            "fa": "Ø¬Ù…Ù‡ÙˆØ±ÛŒ Ú©Ù†Ú¯Ùˆ",
            "de": "Kongo (Dem. Rep.)",
            "es": "Congo (Rep. Dem.)",
            "fr": "Congo (RÃ©p. dÃ©m.)",
            "ja": "ã‚³ãƒ³ã‚´æ°‘ä¸»å…±å’Œå›½",
            "it": "Congo (Rep. Dem.)",
            "cn": "åˆšæžœï¼ˆé‡‘ï¼‰"
        },
        "latitude": "0.00000000",
        "longitude": "25.00000000",
        "emoji": "ðŸ‡¨ðŸ‡©",
        "emojiU": "U+1F1E8 U+1F1E9",
        "states": [
            {
                "id": 2754,
                "name": "Bandundu Province",
                "state_code": "BN",
                "latitude": "-4.16367900",
                "longitude": "18.80761950"
            },
            {
                "id": 2746,
                "name": "Bas-Congo province",
                "state_code": "BC",
                "latitude": "-5.23656850",
                "longitude": "13.91439900"
            },
            {
                "id": 2753,
                "name": "Bas-Uele",
                "state_code": "BU",
                "latitude": "3.99010090",
                "longitude": "24.90422080"
            },
            {
                "id": 2744,
                "name": "Ã‰quateur",
                "state_code": "EQ",
                "latitude": "-1.83123900",
                "longitude": "-78.18340600"
            },
            {
                "id": 2750,
                "name": "Haut-Katanga Province",
                "state_code": "HK",
                "latitude": "-10.41020750",
                "longitude": "27.54958460"
            },
            {
                "id": 2758,
                "name": "Haut-Lomami District",
                "state_code": "HL",
                "latitude": "-7.70527520",
                "longitude": "24.90422080"
            },
            {
                "id": 2734,
                "name": "Haut-Uele",
                "state_code": "HU",
                "latitude": "3.58451540",
                "longitude": "28.29943500"
            },
            {
                "id": 2751,
                "name": "Ituri Interim Administration",
                "state_code": "IT",
                "latitude": "1.59576820",
                "longitude": "29.41793240"
            },
            {
                "id": 2757,
                "name": "KasaÃ¯ District",
                "state_code": "KS",
                "latitude": "-5.04719790",
                "longitude": "20.71224650"
            },
            {
                "id": 2737,
                "name": "KasaÃ¯-Occidental",
                "state_code": "KW",
                "latitude": "-5.32054730",
                "longitude": "21.85685860"
            },
            {
                "id": 2735,
                "name": "KasaÃ¯-Oriental",
                "state_code": "KE",
                "latitude": "-6.03362300",
                "longitude": "23.57285010"
            },
            {
                "id": 2742,
                "name": "Katanga Province",
                "state_code": "KA",
                "latitude": "-8.88511450",
                "longitude": "26.41938900"
            },
            {
                "id": 2741,
                "name": "Kinshasa",
                "state_code": "KN",
                "latitude": "-4.44193110",
                "longitude": "15.26629310"
            },
            {
                "id": 2740,
                "name": "Kwango District",
                "state_code": "KG",
                "latitude": "-6.43374090",
                "longitude": "17.66888700"
            },
            {
                "id": 2759,
                "name": "Kwilu District",
                "state_code": "KL",
                "latitude": "-5.11888250",
                "longitude": "18.42760470"
            },
            {
                "id": 2747,
                "name": "Lomami Province",
                "state_code": "LO",
                "latitude": "-6.14539310",
                "longitude": "24.52426400"
            },
            {
                "id": 2755,
                "name": "Mai-Ndombe Province",
                "state_code": "MN",
                "latitude": "-2.63574340",
                "longitude": "18.42760470"
            },
            {
                "id": 2745,
                "name": "Maniema",
                "state_code": "MA",
                "latitude": "-3.07309290",
                "longitude": "26.04138890"
            },
            {
                "id": 2752,
                "name": "Mongala District",
                "state_code": "MO",
                "latitude": "1.99623240",
                "longitude": "21.47528510"
            },
            {
                "id": 2739,
                "name": "Nord-Ubangi District",
                "state_code": "NU",
                "latitude": "3.78787260",
                "longitude": "21.47528510"
            },
            {
                "id": 2749,
                "name": "North Kivu",
                "state_code": "NK",
                "latitude": "-0.79177290",
                "longitude": "29.04599270"
            },
            {
                "id": 2736,
                "name": "Orientale Province",
                "state_code": "OR",
                "latitude": "1.64062960",
                "longitude": "26.41938900"
            },
            {
                "id": 2743,
                "name": "Sankuru District",
                "state_code": "SA",
                "latitude": "-2.84374530",
                "longitude": "23.38235450"
            },
            {
                "id": 2738,
                "name": "South Kivu",
                "state_code": "SK",
                "latitude": "-3.01165800",
                "longitude": "28.29943500"
            },
            {
                "id": 2748,
                "name": "Sud-Ubangi",
                "state_code": "SU",
                "latitude": "3.22999420",
                "longitude": "19.18800470"
            },
            {
                "id": 2733,
                "name": "Tanganyika Province",
                "state_code": "TA",
                "latitude": "-6.27401180",
                "longitude": "27.92490020"
            },
            {
                "id": 2756,
                "name": "Tshopo District",
                "state_code": "TO",
                "latitude": "0.54554620",
                "longitude": "24.90422080"
            },
            {
                "id": 2732,
                "name": "Tshuapa District",
                "state_code": "TU",
                "latitude": "-0.99030230",
                "longitude": "23.02888440"
            }
        ]
    },
    {
        "name": "Cook Islands",
        "iso3": "COK",
        "iso2": "CK",
        "phone_code": "682",
        "capital": "Avarua",
        "currency": "NZD",
        "currency_symbol": "$",
        "tld": ".ck",
        "native": "Cook Islands",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Rarotonga",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "CKT",
                "tzName": "Cook Island Time"
            }
        ],
        "translations": {
            "kr": "ì¿¡ ì œë„",
            "br": "Ilhas Cook",
            "pt": "Ilhas Cook",
            "nl": "Cookeilanden",
            "hr": "Cookovo OtoÄje",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ú©ÙˆÚ©",
            "de": "Cookinseln",
            "es": "Islas Cook",
            "fr": "ÃŽles Cook",
            "ja": "ã‚¯ãƒƒã‚¯è«¸å³¶",
            "it": "Isole Cook",
            "cn": "åº“å…‹ç¾¤å²›"
        },
        "latitude": "-21.23333333",
        "longitude": "-159.76666666",
        "emoji": "ðŸ‡¨ðŸ‡°",
        "emojiU": "U+1F1E8 U+1F1F0",
        "states": []
    },
    {
        "name": "Costa Rica",
        "iso3": "CRI",
        "iso2": "CR",
        "phone_code": "506",
        "capital": "San Jose",
        "currency": "CRC",
        "currency_symbol": "â‚¡",
        "tld": ".cr",
        "native": "Costa Rica",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Costa_Rica",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ì½”ìŠ¤íƒ€ë¦¬ì¹´",
            "br": "Costa Rica",
            "pt": "Costa Rica",
            "nl": "Costa Rica",
            "hr": "Kostarika",
            "fa": "Ú©Ø§Ø³ØªØ§Ø±ÛŒÚ©Ø§",
            "de": "Costa Rica",
            "es": "Costa Rica",
            "fr": "Costa Rica",
            "ja": "ã‚³ã‚¹ã‚¿ãƒªã‚«",
            "it": "Costa Rica",
            "cn": "å“¥æ–¯è¾¾é»ŽåŠ "
        },
        "latitude": "10.00000000",
        "longitude": "-84.00000000",
        "emoji": "ðŸ‡¨ðŸ‡·",
        "emojiU": "U+1F1E8 U+1F1F7",
        "states": [
            {
                "id": 1215,
                "name": "Alajuela Province",
                "state_code": "A",
                "latitude": "10.39158300",
                "longitude": "-84.43827210"
            },
            {
                "id": 1209,
                "name": "Guanacaste Province",
                "state_code": "G",
                "latitude": "10.62673990",
                "longitude": "-85.44367060"
            },
            {
                "id": 1212,
                "name": "Heredia Province",
                "state_code": "H",
                "latitude": "10.47352300",
                "longitude": "-84.01674230"
            },
            {
                "id": 1213,
                "name": "LimÃ³n Province",
                "state_code": "L",
                "latitude": "9.98963980",
                "longitude": "-83.03324170"
            },
            {
                "id": 1211,
                "name": "Provincia de Cartago",
                "state_code": "C",
                "latitude": "9.86223110",
                "longitude": "-83.92141870"
            },
            {
                "id": 1210,
                "name": "Puntarenas Province",
                "state_code": "P",
                "latitude": "9.21695310",
                "longitude": "-83.33618800"
            },
            {
                "id": 1214,
                "name": "San JosÃ© Province",
                "state_code": "SJ",
                "latitude": "9.91297270",
                "longitude": "-84.07682940"
            }
        ]
    },
    {
        "name": "Cote D'Ivoire (Ivory Coast)",
        "iso3": "CIV",
        "iso2": "CI",
        "phone_code": "225",
        "capital": "Yamoussoukro",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".ci",
        "native": null,
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Abidjan",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì½”íŠ¸ë””ë¶€ì•„ë¥´",
            "br": "Costa do Marfim",
            "pt": "Costa do Marfim",
            "nl": "Ivoorkust",
            "hr": "Obala Bjelokosti",
            "fa": "Ø³Ø§Ø­Ù„ Ø¹Ø§Ø¬",
            "de": "ElfenbeinkÃ¼ste",
            "es": "Costa de Marfil",
            "fr": "CÃ´te d'Ivoire",
            "ja": "ã‚³ãƒ¼ãƒˆã‚¸ãƒœãƒ¯ãƒ¼ãƒ«",
            "it": "Costa D'Avorio",
            "cn": "ç§‘ç‰¹è¿ªç“¦"
        },
        "latitude": "8.00000000",
        "longitude": "-5.00000000",
        "emoji": "ðŸ‡¨ðŸ‡®",
        "emojiU": "U+1F1E8 U+1F1EE",
        "states": [
            {
                "id": 2634,
                "name": "Abidjan",
                "state_code": "AB",
                "latitude": "5.35995170",
                "longitude": "-4.00825630"
            },
            {
                "id": 2626,
                "name": "AgnÃ©by",
                "state_code": "16",
                "latitude": "5.32245030",
                "longitude": "-4.34495290"
            },
            {
                "id": 2636,
                "name": "Bafing Region",
                "state_code": "17",
                "latitude": "8.32520470",
                "longitude": "-7.52472430"
            },
            {
                "id": 2643,
                "name": "Bas-Sassandra District",
                "state_code": "BS",
                "latitude": "5.27983560",
                "longitude": "-6.15269850"
            },
            {
                "id": 2635,
                "name": "Bas-Sassandra Region",
                "state_code": "09",
                "latitude": "5.35679160",
                "longitude": "-6.74939930"
            },
            {
                "id": 2654,
                "name": "ComoÃ© District",
                "state_code": "CM",
                "latitude": "5.55279300",
                "longitude": "-3.25836260"
            },
            {
                "id": 2644,
                "name": "DenguÃ©lÃ© District",
                "state_code": "DN",
                "latitude": "48.07077630",
                "longitude": "-68.56093410"
            },
            {
                "id": 2642,
                "name": "DenguÃ©lÃ© Region",
                "state_code": "10",
                "latitude": "9.46623720",
                "longitude": "-7.43813550"
            },
            {
                "id": 2645,
                "name": "Dix-Huit Montagnes",
                "state_code": "06",
                "latitude": "7.37623730",
                "longitude": "-7.43813550"
            },
            {
                "id": 2633,
                "name": "Fromager",
                "state_code": "18",
                "latitude": "45.54502130",
                "longitude": "-73.60462230"
            },
            {
                "id": 2651,
                "name": "GÃ´h-Djiboua District",
                "state_code": "GD",
                "latitude": "5.87113930",
                "longitude": "-5.56172790"
            },
            {
                "id": 2638,
                "name": "Haut-Sassandra",
                "state_code": "02",
                "latitude": "6.87578480",
                "longitude": "-6.57833870"
            },
            {
                "id": 2632,
                "name": "Lacs District",
                "state_code": "LC",
                "latitude": "48.19801690",
                "longitude": "-80.45644120"
            },
            {
                "id": 2640,
                "name": "Lacs Region",
                "state_code": "07",
                "latitude": "47.73958660",
                "longitude": "-70.41866520"
            },
            {
                "id": 2627,
                "name": "Lagunes District",
                "state_code": "LG",
                "latitude": "5.88273340",
                "longitude": "-4.23333550"
            },
            {
                "id": 2639,
                "name": "Lagunes region",
                "state_code": "01",
                "latitude": "5.88273340",
                "longitude": "-4.23333550"
            },
            {
                "id": 2631,
                "name": "MarahouÃ© Region",
                "state_code": "12",
                "latitude": "6.88462070",
                "longitude": "-5.89871390"
            },
            {
                "id": 2629,
                "name": "Montagnes District",
                "state_code": "MG",
                "latitude": "7.37623730",
                "longitude": "-7.43813550"
            },
            {
                "id": 2646,
                "name": "Moyen-Cavally",
                "state_code": "19",
                "latitude": "6.52087930",
                "longitude": "-7.61142170"
            },
            {
                "id": 2630,
                "name": "Moyen-ComoÃ©",
                "state_code": "05",
                "latitude": "6.65149170",
                "longitude": "-3.50034540"
            },
            {
                "id": 2655,
                "name": "N'zi-ComoÃ©",
                "state_code": "11",
                "latitude": "7.24567490",
                "longitude": "-4.23333550"
            },
            {
                "id": 2648,
                "name": "Sassandra-MarahouÃ© District",
                "state_code": "SM",
                "latitude": "6.88033480",
                "longitude": "-6.23759470"
            },
            {
                "id": 2625,
                "name": "Savanes Region",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2628,
                "name": "Sud-Bandama",
                "state_code": "15",
                "latitude": "5.53570830",
                "longitude": "-5.56172790"
            },
            {
                "id": 2652,
                "name": "Sud-ComoÃ©",
                "state_code": "13",
                "latitude": "5.55279300",
                "longitude": "-3.25836260"
            },
            {
                "id": 2637,
                "name": "VallÃ©e du Bandama District",
                "state_code": "VB",
                "latitude": "8.27897800",
                "longitude": "-4.89356270"
            },
            {
                "id": 2647,
                "name": "VallÃ©e du Bandama Region",
                "state_code": "04",
                "latitude": "8.27897800",
                "longitude": "-4.89356270"
            },
            {
                "id": 2650,
                "name": "Woroba District",
                "state_code": "WR",
                "latitude": "8.24913720",
                "longitude": "-6.92091350"
            },
            {
                "id": 2649,
                "name": "Worodougou",
                "state_code": "14",
                "latitude": "8.25489620",
                "longitude": "-6.57833870"
            },
            {
                "id": 2653,
                "name": "Yamoussoukro",
                "state_code": "YM",
                "latitude": "6.82762280",
                "longitude": "-5.28934330"
            },
            {
                "id": 2641,
                "name": "Zanzan Region",
                "state_code": "ZZ",
                "latitude": "8.82079040",
                "longitude": "-3.41955270"
            }
        ]
    },
    {
        "name": "Croatia (Hrvatska)",
        "iso3": "HRV",
        "iso2": "HR",
        "phone_code": "385",
        "capital": "Zagreb",
        "currency": "HRK",
        "currency_symbol": "kn",
        "tld": ".hr",
        "native": "Hrvatska",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Zagreb",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "í¬ë¡œì•„í‹°ì•„",
            "br": "CroÃ¡cia",
            "pt": "CroÃ¡cia",
            "nl": "KroatiÃ«",
            "hr": "Hrvatska",
            "fa": "Ú©Ø±ÙˆØ§Ø³ÛŒ",
            "de": "Kroatien",
            "es": "Croacia",
            "fr": "Croatie",
            "ja": "ã‚¯ãƒ­ã‚¢ãƒã‚¢",
            "it": "Croazia",
            "cn": "å…‹ç½—åœ°äºš"
        },
        "latitude": "45.16666666",
        "longitude": "15.50000000",
        "emoji": "ðŸ‡­ðŸ‡·",
        "emojiU": "U+1F1ED U+1F1F7",
        "states": [
            {
                "id": 734,
                "name": "Bjelovar-Bilogora County",
                "state_code": "07",
                "latitude": "45.89879720",
                "longitude": "16.84230930"
            },
            {
                "id": 737,
                "name": "Brod-Posavina County",
                "state_code": "12",
                "latitude": "45.26379510",
                "longitude": "17.32645620"
            },
            {
                "id": 728,
                "name": "Dubrovnik-Neretva County",
                "state_code": "19",
                "latitude": "43.07665880",
                "longitude": "17.52684710"
            },
            {
                "id": 743,
                "name": "Istria County",
                "state_code": "18",
                "latitude": "45.12864550",
                "longitude": "13.90154200"
            },
            {
                "id": 742,
                "name": "Koprivnica-KriÅ¾evci County",
                "state_code": "06",
                "latitude": "46.15689190",
                "longitude": "16.83908260"
            },
            {
                "id": 729,
                "name": "Krapina-Zagorje County",
                "state_code": "02",
                "latitude": "46.10133930",
                "longitude": "15.88096930"
            },
            {
                "id": 731,
                "name": "Lika-Senj County",
                "state_code": "09",
                "latitude": "44.61922180",
                "longitude": "15.47016080"
            },
            {
                "id": 726,
                "name": "MeÄ‘imurje County",
                "state_code": "20",
                "latitude": "46.37666440",
                "longitude": "16.42132980"
            },
            {
                "id": 740,
                "name": "Osijek-Baranja County",
                "state_code": "14",
                "latitude": "45.55764280",
                "longitude": "18.39421410"
            },
            {
                "id": 724,
                "name": "PoÅ¾ega-Slavonia County",
                "state_code": "11",
                "latitude": "45.34178680",
                "longitude": "17.81143590"
            },
            {
                "id": 735,
                "name": "Primorje-Gorski Kotar County",
                "state_code": "08",
                "latitude": "45.31739960",
                "longitude": "14.81674660"
            },
            {
                "id": 730,
                "name": "Å ibenik-Knin County",
                "state_code": "15",
                "latitude": "43.92814850",
                "longitude": "16.10376940"
            },
            {
                "id": 733,
                "name": "Sisak-Moslavina County",
                "state_code": "03",
                "latitude": "45.38379260",
                "longitude": "16.53809940"
            },
            {
                "id": 725,
                "name": "Split-Dalmatia County",
                "state_code": "17",
                "latitude": "43.52403280",
                "longitude": "16.81783770"
            },
            {
                "id": 739,
                "name": "VaraÅ¾din County",
                "state_code": "05",
                "latitude": "46.23174730",
                "longitude": "16.33605590"
            },
            {
                "id": 732,
                "name": "Virovitica-Podravina County",
                "state_code": "10",
                "latitude": "45.65579850",
                "longitude": "17.79324720"
            },
            {
                "id": 741,
                "name": "Vukovar-Syrmia County",
                "state_code": "16",
                "latitude": "45.17735520",
                "longitude": "18.80535270"
            },
            {
                "id": 727,
                "name": "Zadar County",
                "state_code": "13",
                "latitude": "44.14693900",
                "longitude": "15.61649430"
            },
            {
                "id": 738,
                "name": "Zagreb",
                "state_code": "21",
                "latitude": "45.81501080",
                "longitude": "15.98191890"
            },
            {
                "id": 736,
                "name": "Zagreb County",
                "state_code": "01",
                "latitude": "45.87066120",
                "longitude": "16.39549100"
            }
        ]
    },
    {
        "name": "Cuba",
        "iso3": "CUB",
        "iso2": "CU",
        "phone_code": "53",
        "capital": "Havana",
        "currency": "CUP",
        "currency_symbol": "$",
        "tld": ".cu",
        "native": "Cuba",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Havana",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "CST",
                "tzName": "Cuba Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¿ ë°”",
            "br": "Cuba",
            "pt": "Cuba",
            "nl": "Cuba",
            "hr": "Kuba",
            "fa": "Ú©ÙˆØ¨Ø§",
            "de": "Kuba",
            "es": "Cuba",
            "fr": "Cuba",
            "ja": "ã‚­ãƒ¥ãƒ¼ãƒ",
            "it": "Cuba",
            "cn": "å¤å·´"
        },
        "latitude": "21.50000000",
        "longitude": "-80.00000000",
        "emoji": "ðŸ‡¨ðŸ‡º",
        "emojiU": "U+1F1E8 U+1F1FA",
        "states": [
            {
                "id": 283,
                "name": "Artemisa Province",
                "state_code": "15",
                "latitude": "22.75229030",
                "longitude": "-82.99316070"
            },
            {
                "id": 286,
                "name": "CamagÃ¼ey Province",
                "state_code": "09",
                "latitude": "21.21672470",
                "longitude": "-77.74520810"
            },
            {
                "id": 282,
                "name": "Ciego de Ãvila Province",
                "state_code": "08",
                "latitude": "21.93295150",
                "longitude": "-78.56608520"
            },
            {
                "id": 287,
                "name": "Cienfuegos Province",
                "state_code": "06",
                "latitude": "22.23797830",
                "longitude": "-80.36586500"
            },
            {
                "id": 275,
                "name": "Granma Province",
                "state_code": "12",
                "latitude": "20.38449020",
                "longitude": "-76.64127120"
            },
            {
                "id": 285,
                "name": "GuantÃ¡namo Province",
                "state_code": "14",
                "latitude": "20.14559170",
                "longitude": "-74.87410450"
            },
            {
                "id": 272,
                "name": "Havana Province",
                "state_code": "03",
                "latitude": "23.05406980",
                "longitude": "-82.34518900"
            },
            {
                "id": 279,
                "name": "HolguÃ­n Province",
                "state_code": "11",
                "latitude": "20.78378930",
                "longitude": "-75.80690820"
            },
            {
                "id": 278,
                "name": "Isla de la Juventud",
                "state_code": "99",
                "latitude": "21.70847370",
                "longitude": "-82.82202320"
            },
            {
                "id": 281,
                "name": "Las Tunas Province",
                "state_code": "10",
                "latitude": "21.06051620",
                "longitude": "-76.91820970"
            },
            {
                "id": 284,
                "name": "Matanzas Province",
                "state_code": "04",
                "latitude": "22.57671230",
                "longitude": "-81.33994140"
            },
            {
                "id": 276,
                "name": "Mayabeque Province",
                "state_code": "16",
                "latitude": "22.89265290",
                "longitude": "-81.95348150"
            },
            {
                "id": 277,
                "name": "Pinar del RÃ­o Province",
                "state_code": "01",
                "latitude": "22.40762560",
                "longitude": "-83.84730150"
            },
            {
                "id": 274,
                "name": "Sancti SpÃ­ritus Province",
                "state_code": "07",
                "latitude": "21.99382140",
                "longitude": "-79.47038850"
            },
            {
                "id": 273,
                "name": "Santiago de Cuba Province",
                "state_code": "13",
                "latitude": "20.23976820",
                "longitude": "-75.99276520"
            },
            {
                "id": 280,
                "name": "Villa Clara Province",
                "state_code": "05",
                "latitude": "22.49372040",
                "longitude": "-79.91927020"
            }
        ]
    },
    {
        "name": "CuraÃ§ao",
        "iso3": "CUW",
        "iso2": "CW",
        "phone_code": "599",
        "capital": "Willemstad",
        "currency": "ANG",
        "currency_symbol": "Æ’",
        "tld": ".cw",
        "native": "CuraÃ§ao",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Curacao",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "í€´ë¼ì†Œ",
            "br": "CuraÃ§ao",
            "pt": "CuraÃ§ao",
            "nl": "CuraÃ§ao",
            "fa": "Ú©ÙˆØ±Ø§Ø³Ø§Ø¦Ùˆ",
            "de": "CuraÃ§ao",
            "fr": "CuraÃ§ao",
            "it": "CuraÃ§ao",
            "cn": "åº“æ‹‰ç´¢"
        },
        "latitude": "12.11666700",
        "longitude": "-68.93333300",
        "emoji": "ðŸ‡¨ðŸ‡¼",
        "emojiU": "U+1F1E8 U+1F1FC",
        "states": []
    },
    {
        "name": "Cyprus",
        "iso3": "CYP",
        "iso2": "CY",
        "phone_code": "357",
        "capital": "Nicosia",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".cy",
        "native": "ÎšÏÏ€ÏÎ¿Ï‚",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Asia\/Famagusta",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Asia\/Nicosia",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "í‚¤í”„ë¡œìŠ¤",
            "br": "Chipre",
            "pt": "Chipre",
            "nl": "Cyprus",
            "hr": "Cipar",
            "fa": "Ù‚Ø¨Ø±Ø³",
            "de": "Zypern",
            "es": "Chipre",
            "fr": "Chypre",
            "ja": "ã‚­ãƒ—ãƒ­ã‚¹",
            "it": "Cipro",
            "cn": "å¡žæµ¦è·¯æ–¯"
        },
        "latitude": "35.00000000",
        "longitude": "33.00000000",
        "emoji": "ðŸ‡¨ðŸ‡¾",
        "emojiU": "U+1F1E8 U+1F1FE",
        "states": [
            {
                "id": 749,
                "name": "Famagusta District",
                "state_code": "04",
                "latitude": "35.28570230",
                "longitude": "33.84112880"
            },
            {
                "id": 744,
                "name": "Kyrenia District",
                "state_code": "06",
                "latitude": "35.29919400",
                "longitude": "33.23632460"
            },
            {
                "id": 747,
                "name": "Larnaca District",
                "state_code": "03",
                "latitude": "34.85072060",
                "longitude": "33.48319060"
            },
            {
                "id": 748,
                "name": "Limassol District",
                "state_code": "02",
                "latitude": "34.70713010",
                "longitude": "33.02261740"
            },
            {
                "id": 745,
                "name": "Nicosia District",
                "state_code": "01",
                "latitude": "35.18556590",
                "longitude": "33.38227640"
            },
            {
                "id": 746,
                "name": "Paphos District",
                "state_code": "05",
                "latitude": "34.91645940",
                "longitude": "32.49200880"
            }
        ]
    },
    {
        "name": "Czech Republic",
        "iso3": "CZE",
        "iso2": "CZ",
        "phone_code": "420",
        "capital": "Prague",
        "currency": "CZK",
        "currency_symbol": "KÄ",
        "tld": ".cz",
        "native": "ÄŒeskÃ¡ republika",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Prague",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì²´ì½”",
            "br": "RepÃºblica Tcheca",
            "pt": "RepÃºblica Checa",
            "nl": "TsjechiÃ«",
            "hr": "ÄŒeÅ¡ka",
            "fa": "Ø¬Ù…Ù‡ÙˆØ±ÛŒ Ú†Ú©",
            "de": "Tschechische Republik",
            "es": "RepÃºblica Checa",
            "fr": "RÃ©publique tchÃ¨que",
            "ja": "ãƒã‚§ã‚³",
            "it": "Repubblica Ceca",
            "cn": "æ·å…‹"
        },
        "latitude": "49.75000000",
        "longitude": "15.50000000",
        "emoji": "ðŸ‡¨ðŸ‡¿",
        "emojiU": "U+1F1E8 U+1F1FF",
        "states": [
            {
                "id": 4627,
                "name": "BeneÅ¡ov",
                "state_code": "201",
                "latitude": "49.69008280",
                "longitude": "14.77643990"
            },
            {
                "id": 4620,
                "name": "Beroun",
                "state_code": "202",
                "latitude": "49.95734280",
                "longitude": "13.98407150"
            },
            {
                "id": 4615,
                "name": "Blansko",
                "state_code": "641",
                "latitude": "49.36485020",
                "longitude": "16.64775520"
            },
            {
                "id": 4542,
                "name": "BÅ™eclav",
                "state_code": "644",
                "latitude": "48.75314000",
                "longitude": "16.88251690"
            },
            {
                "id": 4568,
                "name": "Brno-mÄ›sto",
                "state_code": "642",
                "latitude": "49.19506020",
                "longitude": "16.60683710"
            },
            {
                "id": 4545,
                "name": "Brno-venkov",
                "state_code": "643",
                "latitude": "49.12501380",
                "longitude": "16.45588240"
            },
            {
                "id": 4644,
                "name": "BruntÃ¡l",
                "state_code": "801",
                "latitude": "49.98817670",
                "longitude": "17.46369410"
            },
            {
                "id": 4633,
                "name": "ÄŒeskÃ¡ LÃ­pa",
                "state_code": "511",
                "latitude": "50.67852010",
                "longitude": "14.53969910"
            },
            {
                "id": 4556,
                "name": "ÄŒeskÃ© BudÄ›jovice",
                "state_code": "311",
                "latitude": "48.97755530",
                "longitude": "14.51507470"
            },
            {
                "id": 4543,
                "name": "ÄŒeskÃ½ Krumlov",
                "state_code": "312",
                "latitude": "48.81273540",
                "longitude": "14.31746570"
            },
            {
                "id": 4573,
                "name": "Cheb",
                "state_code": "411",
                "latitude": "50.07953340",
                "longitude": "12.36986360"
            },
            {
                "id": 4553,
                "name": "Chomutov",
                "state_code": "422",
                "latitude": "50.45838720",
                "longitude": "13.30179100"
            },
            {
                "id": 4634,
                "name": "Chrudim",
                "state_code": "531",
                "latitude": "49.88302160",
                "longitude": "15.82908660"
            },
            {
                "id": 4609,
                "name": "DÄ›ÄÃ­n",
                "state_code": "421",
                "latitude": "50.77255630",
                "longitude": "14.21276120"
            },
            {
                "id": 4641,
                "name": "DomaÅ¾lice",
                "state_code": "321",
                "latitude": "49.43970270",
                "longitude": "12.93114350"
            },
            {
                "id": 4559,
                "name": "FrÃ½dek-MÃ­stek",
                "state_code": "802",
                "latitude": "49.68193050",
                "longitude": "18.36732160"
            },
            {
                "id": 4611,
                "name": "HavlÃ­ÄkÅ¯v Brod",
                "state_code": "631",
                "latitude": "49.60433640",
                "longitude": "15.57965520"
            },
            {
                "id": 4561,
                "name": "HodonÃ­n",
                "state_code": "645",
                "latitude": "48.85293910",
                "longitude": "17.12600250"
            },
            {
                "id": 4580,
                "name": "Hradec KrÃ¡lovÃ©",
                "state_code": "521",
                "latitude": "50.24148050",
                "longitude": "15.67430000"
            },
            {
                "id": 4612,
                "name": "Jablonec nad Nisou",
                "state_code": "512",
                "latitude": "50.72205280",
                "longitude": "15.17031350"
            },
            {
                "id": 4625,
                "name": "JesenÃ­k",
                "state_code": "711",
                "latitude": "50.22462490",
                "longitude": "17.19804710"
            },
            {
                "id": 4640,
                "name": "JiÄÃ­n",
                "state_code": "522",
                "latitude": "50.43533250",
                "longitude": "15.36104400"
            },
            {
                "id": 4613,
                "name": "Jihlava",
                "state_code": "632",
                "latitude": "49.39837820",
                "longitude": "15.58704150"
            },
            {
                "id": 4639,
                "name": "JihoÄeskÃ½ kraj",
                "state_code": "31",
                "latitude": "48.94577890",
                "longitude": "14.44160550"
            },
            {
                "id": 4602,
                "name": "JihomoravskÃ½ kraj",
                "state_code": "64",
                "latitude": "48.95445280",
                "longitude": "16.76768990"
            },
            {
                "id": 4624,
                "name": "JindÅ™ichÅ¯v Hradec",
                "state_code": "313",
                "latitude": "49.14448230",
                "longitude": "15.00613890"
            },
            {
                "id": 4581,
                "name": "KarlovarskÃ½ kraj",
                "state_code": "41",
                "latitude": "50.14350000",
                "longitude": "12.75018990"
            },
            {
                "id": 4604,
                "name": "Karlovy Vary",
                "state_code": "412",
                "latitude": "50.14350000",
                "longitude": "12.75018990"
            },
            {
                "id": 4586,
                "name": "KarvinÃ¡",
                "state_code": "803",
                "latitude": "49.85665240",
                "longitude": "18.54321860"
            },
            {
                "id": 4631,
                "name": "Kladno",
                "state_code": "203",
                "latitude": "50.19402580",
                "longitude": "14.10436570"
            },
            {
                "id": 4591,
                "name": "Klatovy",
                "state_code": "322",
                "latitude": "49.39555490",
                "longitude": "13.29509370"
            },
            {
                "id": 4618,
                "name": "KolÃ­n",
                "state_code": "204",
                "latitude": "49.98832930",
                "longitude": "15.05519770"
            },
            {
                "id": 4575,
                "name": "Kraj VysoÄina",
                "state_code": "63",
                "latitude": "49.44900520",
                "longitude": "15.64059340"
            },
            {
                "id": 4614,
                "name": "KrÃ¡lovÃ©hradeckÃ½ kraj",
                "state_code": "52",
                "latitude": "50.35124840",
                "longitude": "15.79764590"
            },
            {
                "id": 4593,
                "name": "KromÄ›Å™Ã­Å¾",
                "state_code": "721",
                "latitude": "49.29165820",
                "longitude": "17.39938000"
            },
            {
                "id": 4923,
                "name": "KutnÃ¡ Hora",
                "state_code": "205",
                "latitude": "49.94920890",
                "longitude": "15.24704400"
            },
            {
                "id": 4590,
                "name": "Liberec",
                "state_code": "513",
                "latitude": "50.75641010",
                "longitude": "14.99650410"
            },
            {
                "id": 4601,
                "name": "LibereckÃ½ kraj",
                "state_code": "51",
                "latitude": "50.65942400",
                "longitude": "14.76324240"
            },
            {
                "id": 4605,
                "name": "LitomÄ›Å™ice",
                "state_code": "423",
                "latitude": "50.53841970",
                "longitude": "14.13054580"
            },
            {
                "id": 4617,
                "name": "Louny",
                "state_code": "424",
                "latitude": "50.35398120",
                "longitude": "13.80335510"
            },
            {
                "id": 4638,
                "name": "MÄ›lnÃ­k",
                "state_code": "206",
                "latitude": "50.31044150",
                "longitude": "14.51792230"
            },
            {
                "id": 4643,
                "name": "MladÃ¡ Boleslav",
                "state_code": "207",
                "latitude": "50.42523170",
                "longitude": "14.93624770"
            },
            {
                "id": 4600,
                "name": "MoravskoslezskÃ½ kraj",
                "state_code": "80",
                "latitude": "49.73053270",
                "longitude": "18.23326370"
            },
            {
                "id": 4629,
                "name": "Most",
                "state_code": "425",
                "latitude": "37.15540830",
                "longitude": "-94.29488840"
            },
            {
                "id": 4550,
                "name": "NÃ¡chod",
                "state_code": "523",
                "latitude": "50.41457220",
                "longitude": "16.16563470"
            },
            {
                "id": 4548,
                "name": "NovÃ½ JiÄÃ­n",
                "state_code": "804",
                "latitude": "49.59432510",
                "longitude": "18.01353560"
            },
            {
                "id": 4582,
                "name": "Nymburk",
                "state_code": "208",
                "latitude": "50.18558160",
                "longitude": "15.04366040"
            },
            {
                "id": 4574,
                "name": "Olomouc",
                "state_code": "712",
                "latitude": "49.59377800",
                "longitude": "17.25087870"
            },
            {
                "id": 4589,
                "name": "OlomouckÃ½ kraj",
                "state_code": "71",
                "latitude": "49.65865490",
                "longitude": "17.08114060"
            },
            {
                "id": 4623,
                "name": "Opava",
                "state_code": "805",
                "latitude": "49.90837570",
                "longitude": "17.91633800"
            },
            {
                "id": 4584,
                "name": "Ostrava-mÄ›sto",
                "state_code": "806",
                "latitude": "49.82092260",
                "longitude": "18.26252430"
            },
            {
                "id": 4547,
                "name": "Pardubice",
                "state_code": "532",
                "latitude": "49.94444790",
                "longitude": "16.28569160"
            },
            {
                "id": 4588,
                "name": "PardubickÃ½ kraj",
                "state_code": "53",
                "latitude": "49.94444790",
                "longitude": "16.28569160"
            },
            {
                "id": 4645,
                "name": "PelhÅ™imov",
                "state_code": "633",
                "latitude": "49.43062070",
                "longitude": "15.22298300"
            },
            {
                "id": 4560,
                "name": "PÃ­sek",
                "state_code": "314",
                "latitude": "49.34199380",
                "longitude": "14.24697600"
            },
            {
                "id": 4608,
                "name": "PlzeÅˆ-jih",
                "state_code": "324",
                "latitude": "49.59048850",
                "longitude": "13.57158610"
            },
            {
                "id": 4544,
                "name": "PlzeÅˆ-mÄ›sto",
                "state_code": "323",
                "latitude": "49.73843140",
                "longitude": "13.37363710"
            },
            {
                "id": 4564,
                "name": "PlzeÅˆ-sever",
                "state_code": "325",
                "latitude": "49.87748930",
                "longitude": "13.25374280"
            },
            {
                "id": 4607,
                "name": "PlzeÅˆskÃ½ kraj",
                "state_code": "32",
                "latitude": "49.41348120",
                "longitude": "13.31572460"
            },
            {
                "id": 4578,
                "name": "Prachatice",
                "state_code": "315",
                "latitude": "49.01091000",
                "longitude": "14.00000050"
            },
            {
                "id": 4606,
                "name": "Praha-vÃ½chod",
                "state_code": "209",
                "latitude": "49.93893070",
                "longitude": "14.79244720"
            },
            {
                "id": 4619,
                "name": "Praha-zÃ¡pad",
                "state_code": "20A",
                "latitude": "49.89352350",
                "longitude": "14.32937790"
            },
            {
                "id": 4598,
                "name": "Praha, HlavnÃ­ mÄ›sto",
                "state_code": "10",
                "latitude": "50.07553810",
                "longitude": "14.43780050"
            },
            {
                "id": 4626,
                "name": "PÅ™erov",
                "state_code": "714",
                "latitude": "49.46713560",
                "longitude": "17.50773320"
            },
            {
                "id": 4546,
                "name": "PÅ™Ã­bram",
                "state_code": "20B",
                "latitude": "49.69479590",
                "longitude": "14.08238100"
            },
            {
                "id": 4551,
                "name": "ProstÄ›jov",
                "state_code": "713",
                "latitude": "49.44184010",
                "longitude": "17.12779040"
            },
            {
                "id": 4558,
                "name": "RakovnÃ­k",
                "state_code": "20C",
                "latitude": "50.10612300",
                "longitude": "13.73966230"
            },
            {
                "id": 4583,
                "name": "Rokycany",
                "state_code": "326",
                "latitude": "49.82628270",
                "longitude": "13.68749430"
            },
            {
                "id": 4636,
                "name": "Rychnov nad KnÄ›Å¾nou",
                "state_code": "524",
                "latitude": "50.16596510",
                "longitude": "16.27768420"
            },
            {
                "id": 4596,
                "name": "Semily",
                "state_code": "514",
                "latitude": "50.60515760",
                "longitude": "15.32814090"
            },
            {
                "id": 4595,
                "name": "Sokolov",
                "state_code": "413",
                "latitude": "50.20134340",
                "longitude": "12.60546360"
            },
            {
                "id": 4628,
                "name": "Strakonice",
                "state_code": "316",
                "latitude": "49.26040430",
                "longitude": "13.91030850"
            },
            {
                "id": 4554,
                "name": "StÅ™edoÄeskÃ½ kraj",
                "state_code": "20",
                "latitude": "49.87822230",
                "longitude": "14.93629550"
            },
            {
                "id": 4642,
                "name": "Å umperk",
                "state_code": "715",
                "latitude": "49.97784070",
                "longitude": "16.97177540"
            },
            {
                "id": 4571,
                "name": "Svitavy",
                "state_code": "533",
                "latitude": "49.75516290",
                "longitude": "16.46918610"
            },
            {
                "id": 4565,
                "name": "TÃ¡bor",
                "state_code": "317",
                "latitude": "49.36462930",
                "longitude": "14.71912930"
            },
            {
                "id": 4646,
                "name": "Tachov",
                "state_code": "327",
                "latitude": "49.79878030",
                "longitude": "12.63619210"
            },
            {
                "id": 4621,
                "name": "Teplice",
                "state_code": "426",
                "latitude": "50.65846050",
                "longitude": "13.75132270"
            },
            {
                "id": 4597,
                "name": "TÅ™ebÃ­Ä",
                "state_code": "634",
                "latitude": "49.21478690",
                "longitude": "15.87955160"
            },
            {
                "id": 4579,
                "name": "Trutnov",
                "state_code": "525",
                "latitude": "50.56538380",
                "longitude": "15.90909230"
            },
            {
                "id": 4592,
                "name": "UherskÃ© HradiÅ¡tÄ›",
                "state_code": "722",
                "latitude": "49.05979690",
                "longitude": "17.49585010"
            },
            {
                "id": 4576,
                "name": "ÃšsteckÃ½ kraj",
                "state_code": "42",
                "latitude": "50.61190370",
                "longitude": "13.78700860"
            },
            {
                "id": 4599,
                "name": "ÃšstÃ­ nad Labem",
                "state_code": "427",
                "latitude": "50.61190370",
                "longitude": "13.78700860"
            },
            {
                "id": 4647,
                "name": "ÃšstÃ­ nad OrlicÃ­",
                "state_code": "534",
                "latitude": "49.97218010",
                "longitude": "16.39966170"
            },
            {
                "id": 4572,
                "name": "VsetÃ­n",
                "state_code": "723",
                "latitude": "49.37932500",
                "longitude": "18.06181620"
            },
            {
                "id": 4622,
                "name": "VyÅ¡kov",
                "state_code": "646",
                "latitude": "49.21274450",
                "longitude": "16.98559270"
            },
            {
                "id": 4648,
                "name": "Å½ÄÃ¡r nad SÃ¡zavou",
                "state_code": "635",
                "latitude": "49.56430120",
                "longitude": "15.93910300"
            },
            {
                "id": 4563,
                "name": "ZlÃ­n",
                "state_code": "724",
                "latitude": "49.16960520",
                "longitude": "17.80252200"
            },
            {
                "id": 4552,
                "name": "ZlÃ­nskÃ½ kraj",
                "state_code": "72",
                "latitude": "49.21622960",
                "longitude": "17.77203530"
            },
            {
                "id": 4630,
                "name": "Znojmo",
                "state_code": "647",
                "latitude": "48.92723270",
                "longitude": "16.10378080"
            }
        ]
    },
    {
        "name": "Denmark",
        "iso3": "DNK",
        "iso2": "DK",
        "phone_code": "45",
        "capital": "Copenhagen",
        "currency": "DKK",
        "currency_symbol": "Kr.",
        "tld": ".dk",
        "native": "Danmark",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Copenhagen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë´ë§ˆí¬",
            "br": "Dinamarca",
            "pt": "Dinamarca",
            "nl": "Denemarken",
            "hr": "Danska",
            "fa": "Ø¯Ø§Ù†Ù…Ø§Ø±Ú©",
            "de": "DÃ¤nemark",
            "es": "Dinamarca",
            "fr": "Danemark",
            "ja": "ãƒ‡ãƒ³ãƒžãƒ¼ã‚¯",
            "it": "Danimarca",
            "cn": "ä¸¹éº¦"
        },
        "latitude": "56.00000000",
        "longitude": "10.00000000",
        "emoji": "ðŸ‡©ðŸ‡°",
        "emojiU": "U+1F1E9 U+1F1F0",
        "states": [
            {
                "id": 1530,
                "name": "Capital Region of Denmark",
                "state_code": "84",
                "latitude": "55.67518120",
                "longitude": "12.54932610"
            },
            {
                "id": 1531,
                "name": "Central Denmark Region",
                "state_code": "82",
                "latitude": "56.30213900",
                "longitude": "9.30277700"
            },
            {
                "id": 1532,
                "name": "North Denmark Region",
                "state_code": "81",
                "latitude": "56.83074160",
                "longitude": "9.49305270"
            },
            {
                "id": 1529,
                "name": "Region of Southern Denmark",
                "state_code": "83",
                "latitude": "55.33077140",
                "longitude": "9.09249030"
            },
            {
                "id": 1528,
                "name": "Region Zealand",
                "state_code": "85",
                "latitude": "55.46325180",
                "longitude": "11.72149790"
            }
        ]
    },
    {
        "name": "Djibouti",
        "iso3": "DJI",
        "iso2": "DJ",
        "phone_code": "253",
        "capital": "Djibouti",
        "currency": "DJF",
        "currency_symbol": "Fdj",
        "tld": ".dj",
        "native": "Djibouti",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Djibouti",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì§€ë¶€í‹°",
            "br": "Djibuti",
            "pt": "Djibuti",
            "nl": "Djibouti",
            "hr": "DÅ¾ibuti",
            "fa": "Ø¬ÛŒØ¨ÙˆØªÛŒ",
            "de": "Dschibuti",
            "es": "Yibuti",
            "fr": "Djibouti",
            "ja": "ã‚¸ãƒ–ãƒ",
            "it": "Gibuti",
            "cn": "å‰å¸ƒæ"
        },
        "latitude": "11.50000000",
        "longitude": "43.00000000",
        "emoji": "ðŸ‡©ðŸ‡¯",
        "emojiU": "U+1F1E9 U+1F1EF",
        "states": [
            {
                "id": 2933,
                "name": "Ali Sabieh Region",
                "state_code": "AS",
                "latitude": "11.19289730",
                "longitude": "42.94169800"
            },
            {
                "id": 2932,
                "name": "Arta Region",
                "state_code": "AR",
                "latitude": "11.52555280",
                "longitude": "42.84794740"
            },
            {
                "id": 2930,
                "name": "Dikhil Region",
                "state_code": "DI",
                "latitude": "11.10543360",
                "longitude": "42.37047440"
            },
            {
                "id": 2929,
                "name": "Djibouti",
                "state_code": "DJ",
                "latitude": "11.82513800",
                "longitude": "42.59027500"
            },
            {
                "id": 2928,
                "name": "Obock Region",
                "state_code": "OB",
                "latitude": "12.38956910",
                "longitude": "43.01948970"
            },
            {
                "id": 2931,
                "name": "Tadjourah Region",
                "state_code": "TA",
                "latitude": "11.93388850",
                "longitude": "42.39383750"
            }
        ]
    },
    {
        "name": "Dominica",
        "iso3": "DMA",
        "iso2": "DM",
        "phone_code": "+1-767",
        "capital": "Roseau",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".dm",
        "native": "Dominica",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Dominica",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë„ë¯¸ë‹ˆì¹´ ì—°ë°©",
            "br": "Dominica",
            "pt": "Dominica",
            "nl": "Dominica",
            "hr": "Dominika",
            "fa": "Ø¯ÙˆÙ…ÛŒÙ†ÛŒÚ©Ø§",
            "de": "Dominica",
            "es": "Dominica",
            "fr": "Dominique",
            "ja": "ãƒ‰ãƒŸãƒ‹ã‚«å›½",
            "it": "Dominica",
            "cn": "å¤šç±³å°¼åŠ "
        },
        "latitude": "15.41666666",
        "longitude": "-61.33333333",
        "emoji": "ðŸ‡©ðŸ‡²",
        "emojiU": "U+1F1E9 U+1F1F2",
        "states": [
            {
                "id": 4082,
                "name": "Saint Andrew Parish",
                "state_code": "02",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4078,
                "name": "Saint David Parish",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4079,
                "name": "Saint George Parish",
                "state_code": "04",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4076,
                "name": "Saint John Parish",
                "state_code": "05",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4085,
                "name": "Saint Joseph Parish",
                "state_code": "06",
                "latitude": "39.02227120",
                "longitude": "-94.71765040"
            },
            {
                "id": 4083,
                "name": "Saint Luke Parish",
                "state_code": "07",
                "latitude": "42.10513630",
                "longitude": "-80.05707220"
            },
            {
                "id": 4077,
                "name": "Saint Mark Parish",
                "state_code": "08",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4080,
                "name": "Saint Patrick Parish",
                "state_code": "09",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4084,
                "name": "Saint Paul Parish",
                "state_code": "10",
                "latitude": "38.86146000",
                "longitude": "-90.74356190"
            },
            {
                "id": 4081,
                "name": "Saint Peter Parish",
                "state_code": "11",
                "latitude": "40.45241940",
                "longitude": "-80.00850560"
            }
        ]
    },
    {
        "name": "Dominican Republic",
        "iso3": "DOM",
        "iso2": "DO",
        "phone_code": "+1-809 and 1-829",
        "capital": "Santo Domingo",
        "currency": "DOP",
        "currency_symbol": "$",
        "tld": ".do",
        "native": "RepÃºblica Dominicana",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Santo_Domingo",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë„ë¯¸ë‹ˆì¹´ ê³µí™”êµ­",
            "br": "RepÃºblica Dominicana",
            "pt": "RepÃºblica Dominicana",
            "nl": "Dominicaanse Republiek",
            "hr": "Dominikanska Republika",
            "fa": "Ø¬Ù…Ù‡ÙˆØ±ÛŒ Ø¯ÙˆÙ…ÛŒÙ†ÛŒÚ©Ù†",
            "de": "Dominikanische Republik",
            "es": "RepÃºblica Dominicana",
            "fr": "RÃ©publique dominicaine",
            "ja": "ãƒ‰ãƒŸãƒ‹ã‚«å…±å’Œå›½",
            "it": "Repubblica Dominicana",
            "cn": "å¤šæ˜Žå°¼åŠ å…±å’Œå›½"
        },
        "latitude": "19.00000000",
        "longitude": "-70.66666666",
        "emoji": "ðŸ‡©ðŸ‡´",
        "emojiU": "U+1F1E9 U+1F1F4",
        "states": [
            {
                "id": 4114,
                "name": "Azua Province",
                "state_code": "02",
                "latitude": "18.45527090",
                "longitude": "-70.73809280"
            },
            {
                "id": 4105,
                "name": "Baoruco Province",
                "state_code": "03",
                "latitude": "18.48798980",
                "longitude": "-71.41822490"
            },
            {
                "id": 4090,
                "name": "Barahona Province",
                "state_code": "04",
                "latitude": "18.21390660",
                "longitude": "-71.10437590"
            },
            {
                "id": 4107,
                "name": "DajabÃ³n Province",
                "state_code": "05",
                "latitude": "19.54992410",
                "longitude": "-71.70865140"
            },
            {
                "id": 4095,
                "name": "Distrito Nacional",
                "state_code": "01",
                "latitude": "18.48605750",
                "longitude": "-69.93121170"
            },
            {
                "id": 4113,
                "name": "Duarte Province",
                "state_code": "06",
                "latitude": "19.20908230",
                "longitude": "-70.02700040"
            },
            {
                "id": 4086,
                "name": "El Seibo Province",
                "state_code": "08",
                "latitude": "18.76584960",
                "longitude": "-69.04066800"
            },
            {
                "id": 4102,
                "name": "Espaillat Province",
                "state_code": "09",
                "latitude": "19.62776580",
                "longitude": "-70.27867750"
            },
            {
                "id": 4106,
                "name": "Hato Mayor Province",
                "state_code": "30",
                "latitude": "18.76357990",
                "longitude": "-69.25576370"
            },
            {
                "id": 4089,
                "name": "Hermanas Mirabal Province",
                "state_code": "19",
                "latitude": "19.37475590",
                "longitude": "-70.35132350"
            },
            {
                "id": 4097,
                "name": "Independencia",
                "state_code": "10",
                "latitude": "32.63357480",
                "longitude": "-115.42892940"
            },
            {
                "id": 4109,
                "name": "La Altagracia Province",
                "state_code": "11",
                "latitude": "18.58502360",
                "longitude": "-68.62010720"
            },
            {
                "id": 4087,
                "name": "La Romana Province",
                "state_code": "12",
                "latitude": "18.43102710",
                "longitude": "-68.98373730"
            },
            {
                "id": 4116,
                "name": "La Vega Province",
                "state_code": "13",
                "latitude": "19.22115540",
                "longitude": "-70.52887530"
            },
            {
                "id": 4094,
                "name": "MarÃ­a Trinidad SÃ¡nchez Province",
                "state_code": "14",
                "latitude": "19.37345970",
                "longitude": "-69.85144390"
            },
            {
                "id": 4099,
                "name": "MonseÃ±or Nouel Province",
                "state_code": "28",
                "latitude": "18.92152340",
                "longitude": "-70.38368150"
            },
            {
                "id": 4115,
                "name": "Monte Cristi Province",
                "state_code": "15",
                "latitude": "19.73968990",
                "longitude": "-71.44339840"
            },
            {
                "id": 4111,
                "name": "Monte Plata Province",
                "state_code": "29",
                "latitude": "18.80808780",
                "longitude": "-69.78691460"
            },
            {
                "id": 4101,
                "name": "Pedernales Province",
                "state_code": "16",
                "latitude": "17.85376260",
                "longitude": "-71.33032090"
            },
            {
                "id": 4096,
                "name": "Peravia Province",
                "state_code": "17",
                "latitude": "18.27865940",
                "longitude": "-70.33358870"
            },
            {
                "id": 4092,
                "name": "Puerto Plata Province",
                "state_code": "18",
                "latitude": "19.75432250",
                "longitude": "-70.83328470"
            },
            {
                "id": 4103,
                "name": "SamanÃ¡ Province",
                "state_code": "20",
                "latitude": "19.20583710",
                "longitude": "-69.33629490"
            },
            {
                "id": 4091,
                "name": "San CristÃ³bal Province",
                "state_code": "21",
                "latitude": "18.41804140",
                "longitude": "-70.10658490"
            },
            {
                "id": 4112,
                "name": "San JosÃ© de Ocoa Province",
                "state_code": "31",
                "latitude": "18.54385800",
                "longitude": "-70.50418160"
            },
            {
                "id": 4098,
                "name": "San Juan Province",
                "state_code": "22",
                "latitude": "-31.52871270",
                "longitude": "-68.53604030"
            },
            {
                "id": 4110,
                "name": "San Pedro de MacorÃ­s",
                "state_code": "23",
                "latitude": "18.46266000",
                "longitude": "-69.30512340"
            },
            {
                "id": 4088,
                "name": "SÃ¡nchez RamÃ­rez Province",
                "state_code": "24",
                "latitude": "19.05270600",
                "longitude": "-70.14922640"
            },
            {
                "id": 4108,
                "name": "Santiago Province",
                "state_code": "25",
                "latitude": "-33.45000000",
                "longitude": "-70.66670000"
            },
            {
                "id": 4100,
                "name": "Santiago RodrÃ­guez Province",
                "state_code": "26",
                "latitude": "19.47131810",
                "longitude": "-71.33958010"
            },
            {
                "id": 4093,
                "name": "Santo Domingo Province",
                "state_code": "32",
                "latitude": "18.51042530",
                "longitude": "-69.84040540"
            },
            {
                "id": 4104,
                "name": "Valverde Province",
                "state_code": "27",
                "latitude": "19.58812210",
                "longitude": "-70.98033100"
            }
        ]
    },
    {
        "name": "East Timor",
        "iso3": "TLS",
        "iso2": "TL",
        "phone_code": "670",
        "capital": "Dili",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".tl",
        "native": "Timor-Leste",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Dili",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "TLT",
                "tzName": "Timor Leste Time"
            }
        ],
        "translations": {
            "kr": "ë™í‹°ëª¨ë¥´",
            "br": "Timor Leste",
            "pt": "Timor Leste",
            "nl": "Oost-Timor",
            "hr": "IstoÄni Timor",
            "fa": "ØªÛŒÙ…ÙˆØ± Ø´Ø±Ù‚ÛŒ",
            "de": "Timor-Leste",
            "es": "Timor Oriental",
            "fr": "Timor oriental",
            "ja": "æ±ãƒ†ã‚£ãƒ¢ãƒ¼ãƒ«",
            "it": "Timor Est",
            "cn": "ä¸œå¸æ±¶"
        },
        "latitude": "-8.83333333",
        "longitude": "125.91666666",
        "emoji": "ðŸ‡¹ðŸ‡±",
        "emojiU": "U+1F1F9 U+1F1F1",
        "states": [
            {
                "id": 4520,
                "name": "Aileu municipality",
                "state_code": "AL",
                "latitude": "-8.70439940",
                "longitude": "125.60954740"
            },
            {
                "id": 4518,
                "name": "Ainaro Municipality",
                "state_code": "AN",
                "latitude": "-9.01131710",
                "longitude": "125.52200120"
            },
            {
                "id": 4521,
                "name": "Baucau Municipality",
                "state_code": "BA",
                "latitude": "-8.47143080",
                "longitude": "126.45759910"
            },
            {
                "id": 4525,
                "name": "Bobonaro Municipality",
                "state_code": "BO",
                "latitude": "-8.96554060",
                "longitude": "125.25879640"
            },
            {
                "id": 4522,
                "name": "Cova Lima Municipality",
                "state_code": "CO",
                "latitude": "-9.26503750",
                "longitude": "125.25879640"
            },
            {
                "id": 4524,
                "name": "Dili municipality",
                "state_code": "DI",
                "latitude": "-8.24496130",
                "longitude": "125.58766970"
            },
            {
                "id": 4516,
                "name": "Ermera District",
                "state_code": "ER",
                "latitude": "-8.75248020",
                "longitude": "125.39872940"
            },
            {
                "id": 4523,
                "name": "LautÃ©m Municipality",
                "state_code": "LA",
                "latitude": "-8.36423070",
                "longitude": "126.90438450"
            },
            {
                "id": 4515,
                "name": "LiquiÃ§Ã¡ Municipality",
                "state_code": "LI",
                "latitude": "-8.66740950",
                "longitude": "125.25879640"
            },
            {
                "id": 4517,
                "name": "Manatuto District",
                "state_code": "MT",
                "latitude": "-8.51556080",
                "longitude": "126.01592550"
            },
            {
                "id": 4519,
                "name": "Manufahi Municipality",
                "state_code": "MF",
                "latitude": "-9.01454950",
                "longitude": "125.82799590"
            },
            {
                "id": 4514,
                "name": "Viqueque Municipality",
                "state_code": "VI",
                "latitude": "-8.85979180",
                "longitude": "126.36335160"
            }
        ]
    },
    {
        "name": "Ecuador",
        "iso3": "ECU",
        "iso2": "EC",
        "phone_code": "593",
        "capital": "Quito",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".ec",
        "native": "Ecuador",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Guayaquil",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "ECT",
                "tzName": "Ecuador Time"
            },
            {
                "zoneName": "Pacific\/Galapagos",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "GALT",
                "tzName": "GalÃ¡pagos Time"
            }
        ],
        "translations": {
            "kr": "ì—ì½°ë„ë¥´",
            "br": "Equador",
            "pt": "Equador",
            "nl": "Ecuador",
            "hr": "Ekvador",
            "fa": "Ø§Ú©ÙˆØ§Ø¯ÙˆØ±",
            "de": "Ecuador",
            "es": "Ecuador",
            "fr": "Ã‰quateur",
            "ja": "ã‚¨ã‚¯ã‚¢ãƒ‰ãƒ«",
            "it": "Ecuador",
            "cn": "åŽ„ç“œå¤šå°”"
        },
        "latitude": "-2.00000000",
        "longitude": "-77.50000000",
        "emoji": "ðŸ‡ªðŸ‡¨",
        "emojiU": "U+1F1EA U+1F1E8",
        "states": [
            {
                "id": 2923,
                "name": "Azuay Province",
                "state_code": "A",
                "latitude": "-2.89430680",
                "longitude": "-78.99683440"
            },
            {
                "id": 2920,
                "name": "BolÃ­var Province",
                "state_code": "B",
                "latitude": "-1.70958280",
                "longitude": "-79.04504290"
            },
            {
                "id": 2917,
                "name": "CaÃ±ar Province",
                "state_code": "F",
                "latitude": "-2.55893150",
                "longitude": "-78.93881910"
            },
            {
                "id": 2915,
                "name": "Carchi Province",
                "state_code": "C",
                "latitude": "0.50269120",
                "longitude": "-77.90425210"
            },
            {
                "id": 2925,
                "name": "Chimborazo Province",
                "state_code": "H",
                "latitude": "-1.66479950",
                "longitude": "-78.65432550"
            },
            {
                "id": 2921,
                "name": "Cotopaxi Province",
                "state_code": "X",
                "latitude": "-0.83842060",
                "longitude": "-78.66626780"
            },
            {
                "id": 2924,
                "name": "El Oro Province",
                "state_code": "O",
                "latitude": "-3.25924130",
                "longitude": "-79.95835410"
            },
            {
                "id": 2922,
                "name": "Esmeraldas",
                "state_code": "E",
                "latitude": "0.96817890",
                "longitude": "-79.65172020"
            },
            {
                "id": 2905,
                "name": "GalÃ¡pagos Province",
                "state_code": "W",
                "latitude": "-0.95376910",
                "longitude": "-90.96560190"
            },
            {
                "id": 2914,
                "name": "Guayas Province",
                "state_code": "G",
                "latitude": "-1.95748390",
                "longitude": "-79.91927020"
            },
            {
                "id": 2911,
                "name": "Imbabura Province",
                "state_code": "I",
                "latitude": "0.34997680",
                "longitude": "-78.12601290"
            },
            {
                "id": 2910,
                "name": "Los RÃ­os Province",
                "state_code": "R",
                "latitude": "-1.02306070",
                "longitude": "-79.46088970"
            },
            {
                "id": 2913,
                "name": "ManabÃ­ Province",
                "state_code": "M",
                "latitude": "-1.05434340",
                "longitude": "-80.45264400"
            },
            {
                "id": 2918,
                "name": "Morona-Santiago Province",
                "state_code": "S",
                "latitude": "-2.30510620",
                "longitude": "-78.11468660"
            },
            {
                "id": 2916,
                "name": "Napo Province",
                "state_code": "N",
                "latitude": "-0.99559640",
                "longitude": "-77.81296840"
            },
            {
                "id": 2926,
                "name": "Orellana Province",
                "state_code": "D",
                "latitude": "-0.45451630",
                "longitude": "-76.99502860"
            },
            {
                "id": 2907,
                "name": "Pastaza Province",
                "state_code": "Y",
                "latitude": "-1.48822650",
                "longitude": "-78.00310570"
            },
            {
                "id": 2927,
                "name": "Pichincha Province",
                "state_code": "P",
                "latitude": "-0.14648470",
                "longitude": "-78.47519450"
            },
            {
                "id": 2912,
                "name": "Santa Elena Province",
                "state_code": "SE",
                "latitude": "-2.22671050",
                "longitude": "-80.85949900"
            },
            {
                "id": 2919,
                "name": "Santo Domingo de los TsÃ¡chilas Province",
                "state_code": "SD",
                "latitude": "-0.25218820",
                "longitude": "-79.18793830"
            },
            {
                "id": 2906,
                "name": "SucumbÃ­os Province",
                "state_code": "U",
                "latitude": "0.08892310",
                "longitude": "-76.88975570"
            },
            {
                "id": 2908,
                "name": "Tungurahua Province",
                "state_code": "T",
                "latitude": "-1.26352840",
                "longitude": "-78.56608520"
            },
            {
                "id": 2909,
                "name": "Zamora-Chinchipe Province",
                "state_code": "Z",
                "latitude": "-4.06558920",
                "longitude": "-78.95035250"
            }
        ]
    },
    {
        "name": "Egypt",
        "iso3": "EGY",
        "iso2": "EG",
        "phone_code": "20",
        "capital": "Cairo",
        "currency": "EGP",
        "currency_symbol": "Ø¬.Ù…",
        "tld": ".eg",
        "native": "Ù…ØµØ±â€Ž",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Cairo",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ì´ì§‘íŠ¸",
            "br": "Egito",
            "pt": "Egipto",
            "nl": "Egypte",
            "hr": "Egipat",
            "fa": "Ù…ØµØ±",
            "de": "Ã„gypten",
            "es": "Egipto",
            "fr": "Ã‰gypte",
            "ja": "ã‚¨ã‚¸ãƒ—ãƒˆ",
            "it": "Egitto",
            "cn": "åŸƒåŠ"
        },
        "latitude": "27.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡ªðŸ‡¬",
        "emojiU": "U+1F1EA U+1F1EC",
        "states": [
            {
                "id": 3235,
                "name": "Alexandria Governorate",
                "state_code": "ALX",
                "latitude": "30.87605680",
                "longitude": "29.74260400"
            },
            {
                "id": 3225,
                "name": "Aswan Governorate",
                "state_code": "ASN",
                "latitude": "23.69664980",
                "longitude": "32.71813750"
            },
            {
                "id": 3236,
                "name": "Asyut Governorate",
                "state_code": "AST",
                "latitude": "27.21338310",
                "longitude": "31.44561790"
            },
            {
                "id": 3241,
                "name": "Beheira Governorate",
                "state_code": "BH",
                "latitude": "30.84809860",
                "longitude": "30.34355060"
            },
            {
                "id": 3230,
                "name": "Beni Suef Governorate",
                "state_code": "BNS",
                "latitude": "28.89388370",
                "longitude": "31.44561790"
            },
            {
                "id": 3223,
                "name": "Cairo Governorate",
                "state_code": "C",
                "latitude": "29.95375640",
                "longitude": "31.53700030"
            },
            {
                "id": 3245,
                "name": "Dakahlia Governorate",
                "state_code": "DK",
                "latitude": "31.16560440",
                "longitude": "31.49131820"
            },
            {
                "id": 3224,
                "name": "Damietta Governorate",
                "state_code": "DT",
                "latitude": "31.36257990",
                "longitude": "31.67393710"
            },
            {
                "id": 3238,
                "name": "Faiyum Governorate",
                "state_code": "FYM",
                "latitude": "29.30840210",
                "longitude": "30.84284970"
            },
            {
                "id": 3234,
                "name": "Gharbia Governorate",
                "state_code": "GH",
                "latitude": "30.87535560",
                "longitude": "31.03351000"
            },
            {
                "id": 3239,
                "name": "Giza Governorate",
                "state_code": "GZ",
                "latitude": "28.76662160",
                "longitude": "29.23207840"
            },
            {
                "id": 3244,
                "name": "Ismailia Governorate",
                "state_code": "IS",
                "latitude": "30.58309340",
                "longitude": "32.26538870"
            },
            {
                "id": 3222,
                "name": "Kafr el-Sheikh Governorate",
                "state_code": "KFS",
                "latitude": "31.30854440",
                "longitude": "30.80394740"
            },
            {
                "id": 3242,
                "name": "Luxor Governorate",
                "state_code": "LX",
                "latitude": "25.39444440",
                "longitude": "32.49200880"
            },
            {
                "id": 3231,
                "name": "Matrouh Governorate",
                "state_code": "MT",
                "latitude": "29.56963500",
                "longitude": "26.41938900"
            },
            {
                "id": 3243,
                "name": "Minya Governorate",
                "state_code": "MN",
                "latitude": "28.28472900",
                "longitude": "30.52790960"
            },
            {
                "id": 3228,
                "name": "Monufia Governorate",
                "state_code": "MNF",
                "latitude": "30.59724550",
                "longitude": "30.98763210"
            },
            {
                "id": 3246,
                "name": "New Valley Governorate",
                "state_code": "WAD",
                "latitude": "24.54556380",
                "longitude": "27.17353160"
            },
            {
                "id": 3227,
                "name": "North Sinai Governorate",
                "state_code": "SIN",
                "latitude": "30.28236500",
                "longitude": "33.61757700"
            },
            {
                "id": 3229,
                "name": "Port Said Governorate",
                "state_code": "PTS",
                "latitude": "31.07586060",
                "longitude": "32.26538870"
            },
            {
                "id": 3232,
                "name": "Qalyubia Governorate",
                "state_code": "KB",
                "latitude": "30.32923680",
                "longitude": "31.21684660"
            },
            {
                "id": 3247,
                "name": "Qena Governorate",
                "state_code": "KN",
                "latitude": "26.23460330",
                "longitude": "32.98883190"
            },
            {
                "id": 3240,
                "name": "Red Sea Governorate",
                "state_code": "BA",
                "latitude": "24.68263160",
                "longitude": "34.15319470"
            },
            {
                "id": 3226,
                "name": "Sohag Governorate",
                "state_code": "SHG",
                "latitude": "26.69383400",
                "longitude": "32.17460500"
            },
            {
                "id": 3237,
                "name": "South Sinai Governorate",
                "state_code": "JS",
                "latitude": "29.31018280",
                "longitude": "34.15319470"
            },
            {
                "id": 3233,
                "name": "Suez Governorate",
                "state_code": "SUZ",
                "latitude": "29.36822550",
                "longitude": "32.17460500"
            }
        ]
    },
    {
        "name": "El Salvador",
        "iso3": "SLV",
        "iso2": "SV",
        "phone_code": "503",
        "capital": "San Salvador",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".sv",
        "native": "El Salvador",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/El_Salvador",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ì—˜ì‚´ë°”ë„ë¥´",
            "br": "El Salvador",
            "pt": "El Salvador",
            "nl": "El Salvador",
            "hr": "Salvador",
            "fa": "Ø§Ù„Ø³Ø§Ù„ÙˆØ§Ø¯ÙˆØ±",
            "de": "El Salvador",
            "es": "El Salvador",
            "fr": "Salvador",
            "ja": "ã‚¨ãƒ«ã‚µãƒ«ãƒãƒ‰ãƒ«",
            "it": "El Salvador",
            "cn": "è¨å°”ç“¦å¤š"
        },
        "latitude": "13.83333333",
        "longitude": "-88.91666666",
        "emoji": "ðŸ‡¸ðŸ‡»",
        "emojiU": "U+1F1F8 U+1F1FB",
        "states": [
            {
                "id": 4139,
                "name": "AhuachapÃ¡n Department",
                "state_code": "AH",
                "latitude": "13.82161480",
                "longitude": "-89.92532330"
            },
            {
                "id": 4132,
                "name": "CabaÃ±as Department",
                "state_code": "CA",
                "latitude": "13.86482880",
                "longitude": "-88.74939980"
            },
            {
                "id": 4131,
                "name": "Chalatenango Department",
                "state_code": "CH",
                "latitude": "14.19166480",
                "longitude": "-89.17059980"
            },
            {
                "id": 4137,
                "name": "CuscatlÃ¡n Department",
                "state_code": "CU",
                "latitude": "13.86619570",
                "longitude": "-89.05615320"
            },
            {
                "id": 4134,
                "name": "La Libertad Department",
                "state_code": "LI",
                "latitude": "13.68176610",
                "longitude": "-89.36062980"
            },
            {
                "id": 4136,
                "name": "La Paz Department",
                "state_code": "PA",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4138,
                "name": "La UniÃ³n Department",
                "state_code": "UN",
                "latitude": "13.48864430",
                "longitude": "-87.89424510"
            },
            {
                "id": 4130,
                "name": "MorazÃ¡n Department",
                "state_code": "MO",
                "latitude": "13.76820000",
                "longitude": "-88.12913870"
            },
            {
                "id": 4135,
                "name": "San Miguel Department",
                "state_code": "SM",
                "latitude": "13.44510410",
                "longitude": "-88.24611830"
            },
            {
                "id": 4133,
                "name": "San Salvador Department",
                "state_code": "SS",
                "latitude": "13.77399970",
                "longitude": "-89.20867730"
            },
            {
                "id": 4127,
                "name": "San Vicente Department",
                "state_code": "SV",
                "latitude": "13.58685610",
                "longitude": "-88.74939980"
            },
            {
                "id": 4128,
                "name": "Santa Ana Department",
                "state_code": "SA",
                "latitude": "14.14611210",
                "longitude": "-89.51200840"
            },
            {
                "id": 4140,
                "name": "Sonsonate Department",
                "state_code": "SO",
                "latitude": "13.68235800",
                "longitude": "-89.66281110"
            },
            {
                "id": 4129,
                "name": "UsulutÃ¡n Department",
                "state_code": "US",
                "latitude": "13.44706340",
                "longitude": "-88.55653100"
            }
        ]
    },
    {
        "name": "Equatorial Guinea",
        "iso3": "GNQ",
        "iso2": "GQ",
        "phone_code": "240",
        "capital": "Malabo",
        "currency": "XAF",
        "currency_symbol": "FCFA",
        "tld": ".gq",
        "native": "Guinea Ecuatorial",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Malabo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ì ë„ ê¸°ë‹ˆ",
            "br": "GuinÃ© Equatorial",
            "pt": "GuinÃ© Equatorial",
            "nl": "Equatoriaal-Guinea",
            "hr": "Ekvatorijalna Gvineja",
            "fa": "Ú¯ÛŒÙ†Ù‡ Ø§Ø³ØªÙˆØ§ÛŒÛŒ",
            "de": "Ã„quatorial-Guinea",
            "es": "Guinea Ecuatorial",
            "fr": "GuinÃ©e-Ã‰quatoriale",
            "ja": "èµ¤é“ã‚®ãƒ‹ã‚¢",
            "it": "Guinea Equatoriale",
            "cn": "èµ¤é“å‡ å†…äºš"
        },
        "latitude": "2.00000000",
        "longitude": "10.00000000",
        "emoji": "ðŸ‡¬ðŸ‡¶",
        "emojiU": "U+1F1EC U+1F1F6",
        "states": [
            {
                "id": 3444,
                "name": "AnnobÃ³n Province",
                "state_code": "AN",
                "latitude": "-1.42687820",
                "longitude": "5.63528010"
            },
            {
                "id": 3446,
                "name": "Bioko Norte Province",
                "state_code": "BN",
                "latitude": "3.65950720",
                "longitude": "8.79218360"
            },
            {
                "id": 3443,
                "name": "Bioko Sur Province",
                "state_code": "BS",
                "latitude": "3.42097850",
                "longitude": "8.61606740"
            },
            {
                "id": 3445,
                "name": "Centro Sur Province",
                "state_code": "CS",
                "latitude": "1.34360840",
                "longitude": "10.43965600"
            },
            {
                "id": 3442,
                "name": "Insular Region",
                "state_code": "I",
                "latitude": "37.09024000",
                "longitude": "-95.71289100"
            },
            {
                "id": 3439,
                "name": "KiÃ©-Ntem Province",
                "state_code": "KN",
                "latitude": "2.02809300",
                "longitude": "11.07117580"
            },
            {
                "id": 3441,
                "name": "Litoral Province",
                "state_code": "LI",
                "latitude": "1.57502440",
                "longitude": "9.81249350"
            },
            {
                "id": 3438,
                "name": "RÃ­o Muni",
                "state_code": "C",
                "latitude": "1.46106060",
                "longitude": "9.67868940"
            },
            {
                "id": 3440,
                "name": "Wele-Nzas Province",
                "state_code": "WN",
                "latitude": "1.41661620",
                "longitude": "11.07117580"
            }
        ]
    },
    {
        "name": "Eritrea",
        "iso3": "ERI",
        "iso2": "ER",
        "phone_code": "291",
        "capital": "Asmara",
        "currency": "ERN",
        "currency_symbol": "Nfk",
        "tld": ".er",
        "native": "áŠ¤áˆ­á‰µáˆ«",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Asmara",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì—ë¦¬íŠ¸ë ˆì•„",
            "br": "Eritreia",
            "pt": "Eritreia",
            "nl": "Eritrea",
            "hr": "Eritreja",
            "fa": "Ø§Ø±ÛŒØªØ±Ù‡",
            "de": "Eritrea",
            "es": "Eritrea",
            "fr": "Ã‰rythrÃ©e",
            "ja": "ã‚¨ãƒªãƒˆãƒªã‚¢",
            "it": "Eritrea",
            "cn": "åŽ„ç«‹ç‰¹é‡Œäºš"
        },
        "latitude": "15.00000000",
        "longitude": "39.00000000",
        "emoji": "ðŸ‡ªðŸ‡·",
        "emojiU": "U+1F1EA U+1F1F7",
        "states": [
            {
                "id": 3425,
                "name": "Anseba Region",
                "state_code": "AN",
                "latitude": "16.47455310",
                "longitude": "37.80876930"
            },
            {
                "id": 3427,
                "name": "Debub Region",
                "state_code": "DU",
                "latitude": "14.94786920",
                "longitude": "39.15436770"
            },
            {
                "id": 3428,
                "name": "Gash-Barka Region",
                "state_code": "GB",
                "latitude": "15.40688250",
                "longitude": "37.63866220"
            },
            {
                "id": 3426,
                "name": "Maekel Region",
                "state_code": "MA",
                "latitude": "15.35514090",
                "longitude": "38.86236830"
            },
            {
                "id": 3424,
                "name": "Northern Red Sea Region",
                "state_code": "SK",
                "latitude": "16.25839970",
                "longitude": "38.82054540"
            },
            {
                "id": 3429,
                "name": "Southern Red Sea Region",
                "state_code": "DK",
                "latitude": "13.51371030",
                "longitude": "41.76064720"
            }
        ]
    },
    {
        "name": "Estonia",
        "iso3": "EST",
        "iso2": "EE",
        "phone_code": "372",
        "capital": "Tallinn",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".ee",
        "native": "Eesti",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Tallinn",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ì—ìŠ¤í† ë‹ˆì•„",
            "br": "EstÃ´nia",
            "pt": "EstÃ³nia",
            "nl": "Estland",
            "hr": "Estonija",
            "fa": "Ø§Ø³ØªÙˆÙ†ÛŒ",
            "de": "Estland",
            "es": "Estonia",
            "fr": "Estonie",
            "ja": "ã‚¨ã‚¹ãƒˆãƒ‹ã‚¢",
            "it": "Estonia",
            "cn": "çˆ±æ²™å°¼äºš"
        },
        "latitude": "59.00000000",
        "longitude": "26.00000000",
        "emoji": "ðŸ‡ªðŸ‡ª",
        "emojiU": "U+1F1EA U+1F1EA",
        "states": [
            {
                "id": 3567,
                "name": "Harju County",
                "state_code": "37",
                "latitude": "59.33342390",
                "longitude": "25.24669740"
            },
            {
                "id": 3555,
                "name": "Hiiu County",
                "state_code": "39",
                "latitude": "58.92395530",
                "longitude": "22.59194680"
            },
            {
                "id": 3569,
                "name": "Ida-Viru County",
                "state_code": "44",
                "latitude": "59.25926630",
                "longitude": "27.41365350"
            },
            {
                "id": 3566,
                "name": "JÃ¤rva County",
                "state_code": "51",
                "latitude": "58.88667130",
                "longitude": "25.50006240"
            },
            {
                "id": 3565,
                "name": "JÃµgeva County",
                "state_code": "49",
                "latitude": "58.75061430",
                "longitude": "26.36048780"
            },
            {
                "id": 3568,
                "name": "LÃ¤Ã¤ne County",
                "state_code": "57",
                "latitude": "58.97227420",
                "longitude": "23.87408340"
            },
            {
                "id": 3564,
                "name": "LÃ¤Ã¤ne-Viru County",
                "state_code": "59",
                "latitude": "59.30188160",
                "longitude": "26.32803120"
            },
            {
                "id": 3562,
                "name": "PÃ¤rnu County",
                "state_code": "67",
                "latitude": "58.52619520",
                "longitude": "24.40201590"
            },
            {
                "id": 3563,
                "name": "PÃµlva County",
                "state_code": "65",
                "latitude": "58.11606220",
                "longitude": "27.20663940"
            },
            {
                "id": 3559,
                "name": "Rapla County",
                "state_code": "70",
                "latitude": "58.84926250",
                "longitude": "24.73465690"
            },
            {
                "id": 3561,
                "name": "Saare County",
                "state_code": "74",
                "latitude": "58.48497210",
                "longitude": "22.61364080"
            },
            {
                "id": 3557,
                "name": "Tartu County",
                "state_code": "78",
                "latitude": "58.40571280",
                "longitude": "26.80157600"
            },
            {
                "id": 3558,
                "name": "Valga County",
                "state_code": "82",
                "latitude": "57.91034410",
                "longitude": "26.16018190"
            },
            {
                "id": 3556,
                "name": "Viljandi County",
                "state_code": "84",
                "latitude": "58.28217460",
                "longitude": "25.57522330"
            },
            {
                "id": 3560,
                "name": "VÃµru County",
                "state_code": "86",
                "latitude": "57.73773720",
                "longitude": "27.13989380"
            }
        ]
    },
    {
        "name": "Ethiopia",
        "iso3": "ETH",
        "iso2": "ET",
        "phone_code": "251",
        "capital": "Addis Ababa",
        "currency": "ETB",
        "currency_symbol": "Nkf",
        "tld": ".et",
        "native": "áŠ¢á‰µá‹®áŒµá‹«",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Addis_Ababa",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì—í‹°ì˜¤í”¼ì•„",
            "br": "EtiÃ³pia",
            "pt": "EtiÃ³pia",
            "nl": "EthiopiÃ«",
            "hr": "Etiopija",
            "fa": "Ø§ØªÛŒÙˆÙ¾ÛŒ",
            "de": "Ã„thiopien",
            "es": "EtiopÃ­a",
            "fr": "Ã‰thiopie",
            "ja": "ã‚¨ãƒã‚ªãƒ”ã‚¢",
            "it": "Etiopia",
            "cn": "åŸƒå¡žä¿„æ¯”äºš"
        },
        "latitude": "8.00000000",
        "longitude": "38.00000000",
        "emoji": "ðŸ‡ªðŸ‡¹",
        "emojiU": "U+1F1EA U+1F1F9",
        "states": [
            {
                "id": 11,
                "name": "Addis Ababa",
                "state_code": "AA",
                "latitude": "8.98060340",
                "longitude": "38.75776050"
            },
            {
                "id": 6,
                "name": "Afar Region",
                "state_code": "AF",
                "latitude": "11.75593880",
                "longitude": "40.95868800"
            },
            {
                "id": 3,
                "name": "Amhara Region",
                "state_code": "AM",
                "latitude": "11.34942470",
                "longitude": "37.97845850"
            },
            {
                "id": 9,
                "name": "Benishangul-Gumuz Region",
                "state_code": "BE",
                "latitude": "10.78028890",
                "longitude": "35.56578620"
            },
            {
                "id": 8,
                "name": "Dire Dawa",
                "state_code": "DD",
                "latitude": "9.60087470",
                "longitude": "41.85014200"
            },
            {
                "id": 10,
                "name": "Gambela Region",
                "state_code": "GA",
                "latitude": "7.92196870",
                "longitude": "34.15319470"
            },
            {
                "id": 7,
                "name": "Harari Region",
                "state_code": "HA",
                "latitude": "9.31486600",
                "longitude": "42.19677160"
            },
            {
                "id": 5,
                "name": "Oromia Region",
                "state_code": "OR",
                "latitude": "7.54603770",
                "longitude": "40.63468510"
            },
            {
                "id": 2,
                "name": "Somali Region",
                "state_code": "SO",
                "latitude": "6.66122930",
                "longitude": "43.79084530"
            },
            {
                "id": 1,
                "name": "Southern Nations, Nationalities, and Peoples' Region",
                "state_code": "SN",
                "latitude": "6.51569110",
                "longitude": "36.95410700"
            },
            {
                "id": 4,
                "name": "Tigray Region",
                "state_code": "TI",
                "latitude": "14.03233360",
                "longitude": "38.31657250"
            }
        ]
    },
    {
        "name": "Falkland Islands",
        "iso3": "FLK",
        "iso2": "FK",
        "phone_code": "500",
        "capital": "Stanley",
        "currency": "FKP",
        "currency_symbol": "Â£",
        "tld": ".fk",
        "native": "Falkland Islands",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "Atlantic\/Stanley",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "FKST",
                "tzName": "Falkland Islands Summer Time"
            }
        ],
        "translations": {
            "kr": "í¬í´ëžœë“œ ì œë„",
            "br": "Ilhas Malvinas",
            "pt": "Ilhas Falkland",
            "nl": "Falklandeilanden [Islas Malvinas]",
            "hr": "Falklandski Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± ÙØ§Ù„Ú©Ù„Ù†Ø¯",
            "de": "Falklandinseln",
            "es": "Islas Malvinas",
            "fr": "ÃŽles Malouines",
            "ja": "ãƒ•ã‚©ãƒ¼ã‚¯ãƒ©ãƒ³ãƒ‰ï¼ˆãƒžãƒ«ãƒ“ãƒŠã‚¹ï¼‰è«¸å³¶",
            "it": "Isole Falkland o Isole Malvine",
            "cn": "ç¦å…‹å…°ç¾¤å²›"
        },
        "latitude": "-51.75000000",
        "longitude": "-59.00000000",
        "emoji": "ðŸ‡«ðŸ‡°",
        "emojiU": "U+1F1EB U+1F1F0",
        "states": []
    },
    {
        "name": "Faroe Islands",
        "iso3": "FRO",
        "iso2": "FO",
        "phone_code": "298",
        "capital": "Torshavn",
        "currency": "DKK",
        "currency_symbol": "Kr.",
        "tld": ".fo",
        "native": "FÃ¸royar",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Atlantic\/Faroe",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            }
        ],
        "translations": {
            "kr": "íŽ˜ë¡œ ì œë„",
            "br": "Ilhas FaroÃ©",
            "pt": "Ilhas FaroÃ©",
            "nl": "FaerÃ¶er",
            "hr": "Farski Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± ÙØ§Ø±Ùˆ",
            "de": "FÃ¤rÃ¶er-Inseln",
            "es": "Islas Faroe",
            "fr": "ÃŽles FÃ©roÃ©",
            "ja": "ãƒ•ã‚§ãƒ­ãƒ¼è«¸å³¶",
            "it": "Isole Far Oer",
            "cn": "æ³•ç½—ç¾¤å²›"
        },
        "latitude": "62.00000000",
        "longitude": "-7.00000000",
        "emoji": "ðŸ‡«ðŸ‡´",
        "emojiU": "U+1F1EB U+1F1F4",
        "states": []
    },
    {
        "name": "Fiji Islands",
        "iso3": "FJI",
        "iso2": "FJ",
        "phone_code": "679",
        "capital": "Suva",
        "currency": "FJD",
        "currency_symbol": "FJ$",
        "tld": ".fj",
        "native": "Fiji",
        "region": "Oceania",
        "subregion": "Melanesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Fiji",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "FJT",
                "tzName": "Fiji Time"
            }
        ],
        "translations": {
            "kr": "í”¼ì§€",
            "br": "Fiji",
            "pt": "Fiji",
            "nl": "Fiji",
            "hr": "FiÄ‘i",
            "fa": "ÙÛŒØ¬ÛŒ",
            "de": "Fidschi",
            "es": "Fiyi",
            "fr": "Fidji",
            "ja": "ãƒ•ã‚£ã‚¸ãƒ¼",
            "it": "Figi",
            "cn": "æ–æµŽ"
        },
        "latitude": "-18.00000000",
        "longitude": "175.00000000",
        "emoji": "ðŸ‡«ðŸ‡¯",
        "emojiU": "U+1F1EB U+1F1EF",
        "states": [
            {
                "id": 1917,
                "name": "Ba",
                "state_code": "01",
                "latitude": "36.06138930",
                "longitude": "-95.80058720"
            },
            {
                "id": 1930,
                "name": "Bua",
                "state_code": "02",
                "latitude": "43.09645840",
                "longitude": "-89.50088000"
            },
            {
                "id": 1924,
                "name": "Cakaudrove",
                "state_code": "03",
                "latitude": "-16.58141050",
                "longitude": "179.51200840"
            },
            {
                "id": 1929,
                "name": "Central Division",
                "state_code": "C",
                "latitude": "34.04400660",
                "longitude": "-118.24727380"
            },
            {
                "id": 1932,
                "name": "Eastern Division",
                "state_code": "E",
                "latitude": "32.80943050",
                "longitude": "-117.12899370"
            },
            {
                "id": 1934,
                "name": "Kadavu",
                "state_code": "04",
                "latitude": "-19.01271220",
                "longitude": "178.18766760"
            },
            {
                "id": 1933,
                "name": "Lau",
                "state_code": "05",
                "latitude": "31.66870150",
                "longitude": "-106.39557630"
            },
            {
                "id": 1916,
                "name": "Lomaiviti",
                "state_code": "06",
                "latitude": "-17.70900000",
                "longitude": "179.09100000"
            },
            {
                "id": 1922,
                "name": "Macuata",
                "state_code": "07",
                "latitude": "-16.48649220",
                "longitude": "179.28472510"
            },
            {
                "id": 1919,
                "name": "Nadroga-Navosa",
                "state_code": "08",
                "latitude": "-17.98652780",
                "longitude": "177.65811300"
            },
            {
                "id": 1927,
                "name": "Naitasiri",
                "state_code": "09",
                "latitude": "-17.89757540",
                "longitude": "178.20715980"
            },
            {
                "id": 1928,
                "name": "Namosi",
                "state_code": "10",
                "latitude": "-18.08641760",
                "longitude": "178.12913870"
            },
            {
                "id": 1921,
                "name": "Northern Division",
                "state_code": "N",
                "latitude": "32.87687660",
                "longitude": "-117.21563450"
            },
            {
                "id": 1926,
                "name": "Ra",
                "state_code": "11",
                "latitude": "37.10031530",
                "longitude": "-95.67442460"
            },
            {
                "id": 1920,
                "name": "Rewa",
                "state_code": "12",
                "latitude": "34.79235170",
                "longitude": "-82.36092640"
            },
            {
                "id": 1931,
                "name": "Rotuma",
                "state_code": "R",
                "latitude": "-12.50250690",
                "longitude": "177.07241640"
            },
            {
                "id": 1925,
                "name": "Serua",
                "state_code": "13",
                "latitude": "-18.18047490",
                "longitude": "178.05097900"
            },
            {
                "id": 1918,
                "name": "Tailevu",
                "state_code": "14",
                "latitude": "-17.82691110",
                "longitude": "178.29324800"
            },
            {
                "id": 1923,
                "name": "Western Division",
                "state_code": "W",
                "latitude": "42.96621980",
                "longitude": "-78.70211340"
            }
        ]
    },
    {
        "name": "Finland",
        "iso3": "FIN",
        "iso2": "FI",
        "phone_code": "358",
        "capital": "Helsinki",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".fi",
        "native": "Suomi",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Helsinki",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "í•€ëž€ë“œ",
            "br": "FinlÃ¢ndia",
            "pt": "FinlÃ¢ndia",
            "nl": "Finland",
            "hr": "Finska",
            "fa": "ÙÙ†Ù„Ø§Ù†Ø¯",
            "de": "Finnland",
            "es": "Finlandia",
            "fr": "Finlande",
            "ja": "ãƒ•ã‚£ãƒ³ãƒ©ãƒ³ãƒ‰",
            "it": "Finlandia",
            "cn": "èŠ¬å…°"
        },
        "latitude": "64.00000000",
        "longitude": "26.00000000",
        "emoji": "ðŸ‡«ðŸ‡®",
        "emojiU": "U+1F1EB U+1F1EE",
        "states": [
            {
                "id": 1509,
                "name": "Ã…land Islands",
                "state_code": "01",
                "latitude": "60.17852470",
                "longitude": "19.91561050"
            },
            {
                "id": 1511,
                "name": "Central Finland",
                "state_code": "08",
                "latitude": "62.56667430",
                "longitude": "25.55494450"
            },
            {
                "id": 1494,
                "name": "Central Ostrobothnia",
                "state_code": "07",
                "latitude": "63.56217350",
                "longitude": "24.00136310"
            },
            {
                "id": 1492,
                "name": "Eastern Finland Province",
                "state_code": "IS",
                "latitude": "62.56338910",
                "longitude": "28.50240420"
            },
            {
                "id": 1507,
                "name": "Finland Proper",
                "state_code": "19",
                "latitude": "60.36279140",
                "longitude": "22.44393690"
            },
            {
                "id": 1496,
                "name": "Kainuu",
                "state_code": "05",
                "latitude": "64.37365640",
                "longitude": "28.74374750"
            },
            {
                "id": 1512,
                "name": "Kymenlaakso",
                "state_code": "09",
                "latitude": "60.78051200",
                "longitude": "26.88293360"
            },
            {
                "id": 1500,
                "name": "Lapland",
                "state_code": "LL",
                "latitude": "67.92223040",
                "longitude": "26.50464380"
            },
            {
                "id": 1504,
                "name": "North Karelia",
                "state_code": "13",
                "latitude": "62.80620780",
                "longitude": "30.15538870"
            },
            {
                "id": 1505,
                "name": "Northern Ostrobothnia",
                "state_code": "14",
                "latitude": "65.27949300",
                "longitude": "26.28904170"
            },
            {
                "id": 1503,
                "name": "Northern Savonia",
                "state_code": "15",
                "latitude": "63.08448000",
                "longitude": "27.02535040"
            },
            {
                "id": 1508,
                "name": "Ostrobothnia",
                "state_code": "12",
                "latitude": "63.11817570",
                "longitude": "21.90610620"
            },
            {
                "id": 1499,
                "name": "Oulu Province",
                "state_code": "OL",
                "latitude": "65.01207480",
                "longitude": "25.46504960"
            },
            {
                "id": 1502,
                "name": "PÃ¤ijÃ¤nne Tavastia",
                "state_code": "16",
                "latitude": "61.32300410",
                "longitude": "25.73224960"
            },
            {
                "id": 1506,
                "name": "Pirkanmaa",
                "state_code": "11",
                "latitude": "61.69869180",
                "longitude": "23.78955980"
            },
            {
                "id": 1501,
                "name": "Satakunta",
                "state_code": "17",
                "latitude": "61.59327580",
                "longitude": "22.14830810"
            },
            {
                "id": 1497,
                "name": "South Karelia",
                "state_code": "02",
                "latitude": "61.11819490",
                "longitude": "28.10243720"
            },
            {
                "id": 1498,
                "name": "Southern Ostrobothnia",
                "state_code": "03",
                "latitude": "62.94330990",
                "longitude": "23.52852670"
            },
            {
                "id": 1495,
                "name": "Southern Savonia",
                "state_code": "04",
                "latitude": "61.69451480",
                "longitude": "27.80050150"
            },
            {
                "id": 1493,
                "name": "Tavastia Proper",
                "state_code": "06",
                "latitude": "60.90701500",
                "longitude": "24.30054980"
            },
            {
                "id": 1510,
                "name": "Uusimaa",
                "state_code": "18",
                "latitude": "60.21872000",
                "longitude": "25.27162100"
            }
        ]
    },
    {
        "name": "France",
        "iso3": "FRA",
        "iso2": "FR",
        "phone_code": "33",
        "capital": "Paris",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".fr",
        "native": "France",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Paris",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "í”„ëž‘ìŠ¤",
            "br": "FranÃ§a",
            "pt": "FranÃ§a",
            "nl": "Frankrijk",
            "hr": "Francuska",
            "fa": "ÙØ±Ø§Ù†Ø³Ù‡",
            "de": "Frankreich",
            "es": "Francia",
            "fr": "France",
            "ja": "ãƒ•ãƒ©ãƒ³ã‚¹",
            "it": "Francia",
            "cn": "æ³•å›½"
        },
        "latitude": "46.00000000",
        "longitude": "2.00000000",
        "emoji": "ðŸ‡«ðŸ‡·",
        "emojiU": "U+1F1EB U+1F1F7",
        "states": [
            {
                "id": 4800,
                "name": "Alo",
                "state_code": "WF-AL",
                "latitude": "40.71583620",
                "longitude": "-73.95963170"
            },
            {
                "id": 4811,
                "name": "Alsace",
                "state_code": "A",
                "latitude": "48.31817950",
                "longitude": "7.44162410"
            },
            {
                "id": 4808,
                "name": "Aquitaine",
                "state_code": "B",
                "latitude": "44.70022220",
                "longitude": "-0.29957850"
            },
            {
                "id": 4789,
                "name": "Auvergne",
                "state_code": "C",
                "latitude": "45.70326950",
                "longitude": "3.34485360"
            },
            {
                "id": 4798,
                "name": "Auvergne-RhÃ´ne-Alpes",
                "state_code": "ARA",
                "latitude": "45.44714310",
                "longitude": "4.38525070"
            },
            {
                "id": 4825,
                "name": "Bourgogne-Franche-ComtÃ©",
                "state_code": "BFC",
                "latitude": "47.28051270",
                "longitude": "4.99943720"
            },
            {
                "id": 4807,
                "name": "Brittany",
                "state_code": "BRE",
                "latitude": "48.20204710",
                "longitude": "-2.93264350"
            },
            {
                "id": 4788,
                "name": "Burgundy",
                "state_code": "D",
                "latitude": "47.05250470",
                "longitude": "4.38372150"
            },
            {
                "id": 4818,
                "name": "Centre-Val de Loire",
                "state_code": "CVL",
                "latitude": "47.75156860",
                "longitude": "1.67506310"
            },
            {
                "id": 4791,
                "name": "Champagne-Ardenne",
                "state_code": "G",
                "latitude": "48.79340920",
                "longitude": "4.47252490"
            },
            {
                "id": 4806,
                "name": "Corsica",
                "state_code": "COR",
                "latitude": "42.03960420",
                "longitude": "9.01289260"
            },
            {
                "id": 4805,
                "name": "Franche-ComtÃ©",
                "state_code": "I",
                "latitude": "47.13432070",
                "longitude": "6.02230160"
            },
            {
                "id": 4822,
                "name": "French Guiana",
                "state_code": "GF",
                "latitude": "3.93388900",
                "longitude": "-53.12578200"
            },
            {
                "id": 4824,
                "name": "French Polynesia",
                "state_code": "PF",
                "latitude": "-17.67974200",
                "longitude": "-149.40684300"
            },
            {
                "id": 4820,
                "name": "Grand Est",
                "state_code": "GES",
                "latitude": "48.69980300",
                "longitude": "6.18780740"
            },
            {
                "id": 4829,
                "name": "Guadeloupe",
                "state_code": "GP",
                "latitude": "16.26500000",
                "longitude": "-61.55100000"
            },
            {
                "id": 4828,
                "name": "Hauts-de-France",
                "state_code": "HDF",
                "latitude": "50.48011530",
                "longitude": "2.79372650"
            },
            {
                "id": 4796,
                "name": "ÃŽle-de-France",
                "state_code": "IDF",
                "latitude": "48.84991980",
                "longitude": "2.63704110"
            },
            {
                "id": 4803,
                "name": "Languedoc-Roussillon",
                "state_code": "K",
                "latitude": "43.59123560",
                "longitude": "3.25836260"
            },
            {
                "id": 4792,
                "name": "Limousin",
                "state_code": "L",
                "latitude": "45.89322310",
                "longitude": "1.56960180"
            },
            {
                "id": 4801,
                "name": "Lorraine",
                "state_code": "M",
                "latitude": "48.87442330",
                "longitude": "6.20809320"
            },
            {
                "id": 4814,
                "name": "Lower Normandy",
                "state_code": "P",
                "latitude": "48.87884720",
                "longitude": "-0.51574920"
            },
            {
                "id": 4827,
                "name": "Martinique",
                "state_code": "MQ",
                "latitude": "14.64152800",
                "longitude": "-61.02417400"
            },
            {
                "id": 4797,
                "name": "Mayotte",
                "state_code": "YT",
                "latitude": "-12.82750000",
                "longitude": "45.16624400"
            },
            {
                "id": 4793,
                "name": "Nord-Pas-de-Calais",
                "state_code": "O",
                "latitude": "50.48011530",
                "longitude": "2.79372650"
            },
            {
                "id": 4804,
                "name": "Normandy",
                "state_code": "NOR",
                "latitude": "48.87987040",
                "longitude": "0.17125290"
            },
            {
                "id": 4795,
                "name": "Nouvelle-Aquitaine",
                "state_code": "NAQ",
                "latitude": "45.70871820",
                "longitude": "0.62689100"
            },
            {
                "id": 4799,
                "name": "Occitania",
                "state_code": "OCC",
                "latitude": "43.89272320",
                "longitude": "3.28276250"
            },
            {
                "id": 4816,
                "name": "Paris",
                "state_code": "75",
                "latitude": "48.85661400",
                "longitude": "2.35222190"
            },
            {
                "id": 4802,
                "name": "Pays de la Loire",
                "state_code": "PDL",
                "latitude": "47.76328360",
                "longitude": "-0.32996870"
            },
            {
                "id": 4790,
                "name": "Picardy",
                "state_code": "S",
                "latitude": "49.66361270",
                "longitude": "2.52807320"
            },
            {
                "id": 4815,
                "name": "Poitou-Charentes",
                "state_code": "T",
                "latitude": "45.90355200",
                "longitude": "-0.30918370"
            },
            {
                "id": 4812,
                "name": "Provence-Alpes-CÃ´te d'Azur",
                "state_code": "PAC",
                "latitude": "43.93516910",
                "longitude": "6.06791940"
            },
            {
                "id": 4823,
                "name": "RÃ©union",
                "state_code": "RE",
                "latitude": "-21.11514100",
                "longitude": "55.53638400"
            },
            {
                "id": 4813,
                "name": "RhÃ´ne-Alpes",
                "state_code": "V",
                "latitude": "45.64029050",
                "longitude": "5.68649940"
            },
            {
                "id": 4794,
                "name": "Saint BarthÃ©lemy",
                "state_code": "BL",
                "latitude": "17.90051340",
                "longitude": "-62.82058710"
            },
            {
                "id": 4809,
                "name": "Saint Martin",
                "state_code": "MF",
                "latitude": "18.07082980",
                "longitude": "-63.05008090"
            },
            {
                "id": 4821,
                "name": "Saint Pierre and Miquelon",
                "state_code": "PM",
                "latitude": "46.88520000",
                "longitude": "-56.31590000"
            },
            {
                "id": 4819,
                "name": "Sigave",
                "state_code": "WF-SG",
                "latitude": "-14.27325920",
                "longitude": "-178.16329000"
            },
            {
                "id": 4826,
                "name": "Upper Normandy",
                "state_code": "Q",
                "latitude": "49.52464100",
                "longitude": "0.88283290"
            },
            {
                "id": 4817,
                "name": "Uvea",
                "state_code": "WF-UV",
                "latitude": "41.98329800",
                "longitude": "-87.66836200"
            },
            {
                "id": 4810,
                "name": "Wallis and Futuna",
                "state_code": "WF",
                "latitude": "-14.29380000",
                "longitude": "-178.11650000"
            }
        ]
    },
    {
        "name": "French Guiana",
        "iso3": "GUF",
        "iso2": "GF",
        "phone_code": "594",
        "capital": "Cayenne",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".gf",
        "native": "Guyane franÃ§aise",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Cayenne",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "GFT",
                "tzName": "French Guiana Time"
            }
        ],
        "translations": {
            "kr": "í”„ëž‘ìŠ¤ë ¹ ê¸°ì•„ë‚˜",
            "br": "Guiana Francesa",
            "pt": "Guiana Francesa",
            "nl": "Frans-Guyana",
            "hr": "Francuska Gvajana",
            "fa": "Ú¯ÙˆÛŒØ§Ù† ÙØ±Ø§Ù†Ø³Ù‡",
            "de": "FranzÃ¶sisch Guyana",
            "es": "Guayana Francesa",
            "fr": "Guayane",
            "ja": "ãƒ•ãƒ©ãƒ³ã‚¹é ˜ã‚®ã‚¢ãƒŠ",
            "it": "Guyana francese",
            "cn": "æ³•å±žåœ­äºšé‚£"
        },
        "latitude": "4.00000000",
        "longitude": "-53.00000000",
        "emoji": "ðŸ‡¬ðŸ‡«",
        "emojiU": "U+1F1EC U+1F1EB",
        "states": []
    },
    {
        "name": "French Polynesia",
        "iso3": "PYF",
        "iso2": "PF",
        "phone_code": "689",
        "capital": "Papeete",
        "currency": "XPF",
        "currency_symbol": "â‚£",
        "tld": ".pf",
        "native": "PolynÃ©sie franÃ§aise",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Gambier",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "GAMT",
                "tzName": "Gambier Islands Time"
            },
            {
                "zoneName": "Pacific\/Marquesas",
                "gmtOffset": -34200,
                "gmtOffsetName": "UTC-09:30",
                "abbreviation": "MART",
                "tzName": "Marquesas Islands Time"
            },
            {
                "zoneName": "Pacific\/Tahiti",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "TAHT",
                "tzName": "Tahiti Time"
            }
        ],
        "translations": {
            "kr": "í”„ëž‘ìŠ¤ë ¹ í´ë¦¬ë„¤ì‹œì•„",
            "br": "PolinÃ©sia Francesa",
            "pt": "PolinÃ©sia Francesa",
            "nl": "Frans-PolynesiÃ«",
            "hr": "Francuska Polinezija",
            "fa": "Ù¾Ù„ÛŒâ€ŒÙ†Ø²ÛŒ ÙØ±Ø§Ù†Ø³Ù‡",
            "de": "FranzÃ¶sisch-Polynesien",
            "es": "Polinesia Francesa",
            "fr": "PolynÃ©sie franÃ§aise",
            "ja": "ãƒ•ãƒ©ãƒ³ã‚¹é ˜ãƒãƒªãƒã‚·ã‚¢",
            "it": "Polinesia Francese",
            "cn": "æ³•å±žæ³¢åˆ©å°¼è¥¿äºš"
        },
        "latitude": "-15.00000000",
        "longitude": "-140.00000000",
        "emoji": "ðŸ‡µðŸ‡«",
        "emojiU": "U+1F1F5 U+1F1EB",
        "states": []
    },
    {
        "name": "French Southern Territories",
        "iso3": "ATF",
        "iso2": "TF",
        "phone_code": "",
        "capital": "Port-aux-Francais",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".tf",
        "native": "Territoire des Terres australes et antarctiques fr",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Kerguelen",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TFT",
                "tzName": "French Southern and Antarctic Time"
            }
        ],
        "translations": {
            "kr": "í”„ëž‘ìŠ¤ë ¹ ë‚¨ë°© ë° ë‚¨ê·¹",
            "br": "Terras Austrais e AntÃ¡rticas Francesas",
            "pt": "Terras Austrais e AntÃ¡rticas Francesas",
            "nl": "Franse Gebieden in de zuidelijke Indische Oceaan",
            "hr": "Francuski juÅ¾ni i antarktiÄki teritoriji",
            "fa": "Ø³Ø±Ø²Ù…ÛŒÙ†â€ŒÙ‡Ø§ÛŒ Ø¬Ù†ÙˆØ¨ÛŒ Ùˆ Ø¬Ù†ÙˆØ¨Ú¯Ø§Ù†ÛŒ ÙØ±Ø§Ù†Ø³Ù‡",
            "de": "FranzÃ¶sische SÃ¼d- und Antarktisgebiete",
            "es": "Tierras Australes y AntÃ¡rticas Francesas",
            "fr": "Terres australes et antarctiques franÃ§aises",
            "ja": "ãƒ•ãƒ©ãƒ³ã‚¹é ˜å—æ–¹ãƒ»å—æ¥µåœ°åŸŸ",
            "it": "Territori Francesi del Sud",
            "cn": "æ³•å±žå—éƒ¨é¢†åœ°"
        },
        "latitude": "-49.25000000",
        "longitude": "69.16700000",
        "emoji": "ðŸ‡¹ðŸ‡«",
        "emojiU": "U+1F1F9 U+1F1EB",
        "states": []
    },
    {
        "name": "Gabon",
        "iso3": "GAB",
        "iso2": "GA",
        "phone_code": "241",
        "capital": "Libreville",
        "currency": "XAF",
        "currency_symbol": "FCFA",
        "tld": ".ga",
        "native": "Gabon",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Libreville",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ê°€ë´‰",
            "br": "GabÃ£o",
            "pt": "GabÃ£o",
            "nl": "Gabon",
            "hr": "Gabon",
            "fa": "Ú¯Ø§Ø¨Ù†",
            "de": "Gabun",
            "es": "GabÃ³n",
            "fr": "Gabon",
            "ja": "ã‚¬ãƒœãƒ³",
            "it": "Gabon",
            "cn": "åŠ è“¬"
        },
        "latitude": "-1.00000000",
        "longitude": "11.75000000",
        "emoji": "ðŸ‡¬ðŸ‡¦",
        "emojiU": "U+1F1EC U+1F1E6",
        "states": [
            {
                "id": 2727,
                "name": "Estuaire Province",
                "state_code": "1",
                "latitude": "0.44328640",
                "longitude": "10.08072980"
            },
            {
                "id": 2726,
                "name": "Haut-OgoouÃ© Province",
                "state_code": "2",
                "latitude": "-1.47625440",
                "longitude": "13.91439900"
            },
            {
                "id": 2730,
                "name": "Moyen-OgoouÃ© Province",
                "state_code": "3",
                "latitude": "-0.44278400",
                "longitude": "10.43965600"
            },
            {
                "id": 2731,
                "name": "NgouniÃ© Province",
                "state_code": "4",
                "latitude": "-1.49303030",
                "longitude": "10.98070030"
            },
            {
                "id": 2725,
                "name": "Nyanga Province",
                "state_code": "5",
                "latitude": "-2.88210330",
                "longitude": "11.16173560"
            },
            {
                "id": 2724,
                "name": "OgoouÃ©-Ivindo Province",
                "state_code": "6",
                "latitude": "0.88183110",
                "longitude": "13.17403480"
            },
            {
                "id": 2729,
                "name": "OgoouÃ©-Lolo Province",
                "state_code": "7",
                "latitude": "-0.88440930",
                "longitude": "12.43805810"
            },
            {
                "id": 2728,
                "name": "OgoouÃ©-Maritime Province",
                "state_code": "8",
                "latitude": "-1.34659750",
                "longitude": "9.72326730"
            },
            {
                "id": 2723,
                "name": "Woleu-Ntem Province",
                "state_code": "9",
                "latitude": "2.29898270",
                "longitude": "11.44669140"
            }
        ]
    },
    {
        "name": "Gambia The",
        "iso3": "GMB",
        "iso2": "GM",
        "phone_code": "220",
        "capital": "Banjul",
        "currency": "GMD",
        "currency_symbol": "D",
        "tld": ".gm",
        "native": "Gambia",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Banjul",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ê°ë¹„ì•„",
            "br": "GÃ¢mbia",
            "pt": "GÃ¢mbia",
            "nl": "Gambia",
            "hr": "Gambija",
            "fa": "Ú¯Ø§Ù…Ø¨ÛŒØ§",
            "de": "Gambia",
            "es": "Gambia",
            "fr": "Gambie",
            "ja": "ã‚¬ãƒ³ãƒ“ã‚¢",
            "it": "Gambia",
            "cn": "å†ˆæ¯”äºš"
        },
        "latitude": "13.46666666",
        "longitude": "-16.56666666",
        "emoji": "ðŸ‡¬ðŸ‡²",
        "emojiU": "U+1F1EC U+1F1F2",
        "states": [
            {
                "id": 2666,
                "name": "Banjul",
                "state_code": "B",
                "latitude": "13.45487610",
                "longitude": "-16.57903230"
            },
            {
                "id": 2669,
                "name": "Central River Division",
                "state_code": "M",
                "latitude": "13.59944690",
                "longitude": "-14.89216680"
            },
            {
                "id": 2670,
                "name": "Lower River Division",
                "state_code": "L",
                "latitude": "13.35533060",
                "longitude": "-15.92299000"
            },
            {
                "id": 2671,
                "name": "North Bank Division",
                "state_code": "N",
                "latitude": "13.52854360",
                "longitude": "-16.01699710"
            },
            {
                "id": 2668,
                "name": "Upper River Division",
                "state_code": "U",
                "latitude": "13.42573660",
                "longitude": "-14.00723480"
            },
            {
                "id": 2667,
                "name": "West Coast Division",
                "state_code": "W",
                "latitude": "5.97727980",
                "longitude": "116.07542880"
            }
        ]
    },
    {
        "name": "Georgia",
        "iso3": "GEO",
        "iso2": "GE",
        "phone_code": "995",
        "capital": "Tbilisi",
        "currency": "GEL",
        "currency_symbol": "áƒš",
        "tld": ".ge",
        "native": "áƒ¡áƒáƒ¥áƒáƒ áƒ—áƒ•áƒ”áƒšáƒ",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Tbilisi",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GET",
                "tzName": "Georgia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¡°ì§€ì•„",
            "br": "GeÃ³rgia",
            "pt": "GeÃ³rgia",
            "nl": "GeorgiÃ«",
            "hr": "Gruzija",
            "fa": "Ú¯Ø±Ø¬Ø³ØªØ§Ù†",
            "de": "Georgien",
            "es": "Georgia",
            "fr": "GÃ©orgie",
            "ja": "ã‚°ãƒ«ã‚¸ã‚¢",
            "it": "Georgia",
            "cn": "æ ¼é²å‰äºš"
        },
        "latitude": "42.00000000",
        "longitude": "43.50000000",
        "emoji": "ðŸ‡¬ðŸ‡ª",
        "emojiU": "U+1F1EC U+1F1EA",
        "states": [
            {
                "id": 900,
                "name": "Adjara",
                "state_code": "AJ",
                "latitude": "41.60056260",
                "longitude": "42.06883830"
            },
            {
                "id": 901,
                "name": "Autonomous Republic of Abkhazia",
                "state_code": "AB",
                "latitude": "43.00155440",
                "longitude": "41.02340700"
            },
            {
                "id": 907,
                "name": "Guria",
                "state_code": "GU",
                "latitude": "41.94427360",
                "longitude": "42.04580910"
            },
            {
                "id": 905,
                "name": "Imereti",
                "state_code": "IM",
                "latitude": "42.23010800",
                "longitude": "42.90086640"
            },
            {
                "id": 910,
                "name": "Kakheti",
                "state_code": "KA",
                "latitude": "41.64816020",
                "longitude": "45.69055540"
            },
            {
                "id": 897,
                "name": "Khelvachauri Municipality",
                "state_code": "29",
                "latitude": "41.58019260",
                "longitude": "41.66107420"
            },
            {
                "id": 904,
                "name": "Kvemo Kartli",
                "state_code": "KK",
                "latitude": "41.47918330",
                "longitude": "44.65604510"
            },
            {
                "id": 902,
                "name": "Mtskheta-Mtianeti",
                "state_code": "MM",
                "latitude": "42.16821850",
                "longitude": "44.65060580"
            },
            {
                "id": 909,
                "name": "Racha-Lechkhumi and Kvemo Svaneti",
                "state_code": "RL",
                "latitude": "42.67188730",
                "longitude": "43.05628360"
            },
            {
                "id": 908,
                "name": "Samegrelo-Zemo Svaneti",
                "state_code": "SZ",
                "latitude": "42.73522470",
                "longitude": "42.16893620"
            },
            {
                "id": 906,
                "name": "Samtskhe-Javakheti",
                "state_code": "SJ",
                "latitude": "41.54792960",
                "longitude": "43.27764000"
            },
            {
                "id": 898,
                "name": "Senaki Municipality",
                "state_code": "50",
                "latitude": "42.26963600",
                "longitude": "42.06568960"
            },
            {
                "id": 903,
                "name": "Shida Kartli",
                "state_code": "SK",
                "latitude": "42.07569440",
                "longitude": "43.95404620"
            },
            {
                "id": 899,
                "name": "Tbilisi",
                "state_code": "TB",
                "latitude": "41.71513770",
                "longitude": "44.82709600"
            }
        ]
    },
    {
        "name": "Germany",
        "iso3": "DEU",
        "iso2": "DE",
        "phone_code": "49",
        "capital": "Berlin",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".de",
        "native": "Deutschland",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Berlin",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            },
            {
                "zoneName": "Europe\/Busingen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë…ì¼",
            "br": "Alemanha",
            "pt": "Alemanha",
            "nl": "Duitsland",
            "hr": "NjemaÄka",
            "fa": "Ø¢Ù„Ù…Ø§Ù†",
            "de": "Deutschland",
            "es": "Alemania",
            "fr": "Allemagne",
            "ja": "ãƒ‰ã‚¤ãƒ„",
            "it": "Germania",
            "cn": "å¾·å›½"
        },
        "latitude": "51.00000000",
        "longitude": "9.00000000",
        "emoji": "ðŸ‡©ðŸ‡ª",
        "emojiU": "U+1F1E9 U+1F1EA",
        "states": [
            {
                "id": 3006,
                "name": "Baden-WÃ¼rttemberg",
                "state_code": "BW",
                "latitude": "48.66160370",
                "longitude": "9.35013360"
            },
            {
                "id": 3009,
                "name": "Bavaria",
                "state_code": "BY",
                "latitude": "48.79044720",
                "longitude": "11.49788950"
            },
            {
                "id": 3010,
                "name": "Berlin",
                "state_code": "BE",
                "latitude": "52.52000660",
                "longitude": "13.40495400"
            },
            {
                "id": 3013,
                "name": "Brandenburg",
                "state_code": "BB",
                "latitude": "52.41252870",
                "longitude": "12.53164440"
            },
            {
                "id": 3014,
                "name": "Bremen",
                "state_code": "HB",
                "latitude": "53.07929620",
                "longitude": "8.80169360"
            },
            {
                "id": 3016,
                "name": "Hamburg",
                "state_code": "HH",
                "latitude": "53.55108460",
                "longitude": "9.99368190"
            },
            {
                "id": 3018,
                "name": "Hesse",
                "state_code": "HE",
                "latitude": "50.65205150",
                "longitude": "9.16243760"
            },
            {
                "id": 3008,
                "name": "Lower Saxony",
                "state_code": "NI",
                "latitude": "52.63670360",
                "longitude": "9.84507660"
            },
            {
                "id": 3007,
                "name": "Mecklenburg-Vorpommern",
                "state_code": "MV",
                "latitude": "53.61265050",
                "longitude": "12.42959530"
            },
            {
                "id": 3017,
                "name": "North Rhine-Westphalia",
                "state_code": "NW",
                "latitude": "51.43323670",
                "longitude": "7.66159380"
            },
            {
                "id": 3019,
                "name": "Rhineland-Palatinate",
                "state_code": "RP",
                "latitude": "50.11834600",
                "longitude": "7.30895270"
            },
            {
                "id": 3020,
                "name": "Saarland",
                "state_code": "SL",
                "latitude": "49.39642340",
                "longitude": "7.02296070"
            },
            {
                "id": 3021,
                "name": "Saxony",
                "state_code": "SN",
                "latitude": "51.10454070",
                "longitude": "13.20173840"
            },
            {
                "id": 3011,
                "name": "Saxony-Anhalt",
                "state_code": "ST",
                "latitude": "51.95026490",
                "longitude": "11.69227340"
            },
            {
                "id": 3005,
                "name": "Schleswig-Holstein",
                "state_code": "SH",
                "latitude": "54.21936720",
                "longitude": "9.69611670"
            },
            {
                "id": 3015,
                "name": "Thuringia",
                "state_code": "TH",
                "latitude": "51.01098920",
                "longitude": "10.84534600"
            }
        ]
    },
    {
        "name": "Ghana",
        "iso3": "GHA",
        "iso2": "GH",
        "phone_code": "233",
        "capital": "Accra",
        "currency": "GHS",
        "currency_symbol": "GHâ‚µ",
        "tld": ".gh",
        "native": "Ghana",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Accra",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ê°€ë‚˜",
            "br": "Gana",
            "pt": "Gana",
            "nl": "Ghana",
            "hr": "Gana",
            "fa": "ØºÙ†Ø§",
            "de": "Ghana",
            "es": "Ghana",
            "fr": "Ghana",
            "ja": "ã‚¬ãƒ¼ãƒŠ",
            "it": "Ghana",
            "cn": "åŠ çº³"
        },
        "latitude": "8.00000000",
        "longitude": "-2.00000000",
        "emoji": "ðŸ‡¬ðŸ‡­",
        "emojiU": "U+1F1EC U+1F1ED",
        "states": [
            {
                "id": 48,
                "name": "Ashanti Region",
                "state_code": "AH",
                "latitude": "6.74704360",
                "longitude": "-1.52086240"
            },
            {
                "id": 53,
                "name": "Brong-Ahafo Region",
                "state_code": "BA",
                "latitude": "7.95592470",
                "longitude": "-1.67606910"
            },
            {
                "id": 52,
                "name": "Central Region",
                "state_code": "CP",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 50,
                "name": "Eastern Region",
                "state_code": "EP",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 54,
                "name": "Greater Accra Region",
                "state_code": "AA",
                "latitude": "5.81428360",
                "longitude": "0.07467670"
            },
            {
                "id": 51,
                "name": "Northern Region",
                "state_code": "NP",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 55,
                "name": "Upper East Region",
                "state_code": "UE",
                "latitude": "10.70824990",
                "longitude": "-0.98206680"
            },
            {
                "id": 57,
                "name": "Upper West Region",
                "state_code": "UW",
                "latitude": "10.25297570",
                "longitude": "-2.14502450"
            },
            {
                "id": 56,
                "name": "Volta Region",
                "state_code": "TV",
                "latitude": "6.57813730",
                "longitude": "0.45023680"
            },
            {
                "id": 49,
                "name": "Western Region",
                "state_code": "WP",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Gibraltar",
        "iso3": "GIB",
        "iso2": "GI",
        "phone_code": "350",
        "capital": "Gibraltar",
        "currency": "GIP",
        "currency_symbol": "Â£",
        "tld": ".gi",
        "native": "Gibraltar",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Gibraltar",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì§€ë¸Œë¡¤í„°",
            "br": "Gibraltar",
            "pt": "Gibraltar",
            "nl": "Gibraltar",
            "hr": "Gibraltar",
            "fa": "Ø¬Ø¨Ù„â€ŒØ·Ø§Ø±Ù‚",
            "de": "Gibraltar",
            "es": "Gibraltar",
            "fr": "Gibraltar",
            "ja": "ã‚¸ãƒ–ãƒ©ãƒ«ã‚¿ãƒ«",
            "it": "Gibilterra",
            "cn": "ç›´å¸ƒç½—é™€"
        },
        "latitude": "36.13333333",
        "longitude": "-5.35000000",
        "emoji": "ðŸ‡¬ðŸ‡®",
        "emojiU": "U+1F1EC U+1F1EE",
        "states": []
    },
    {
        "name": "Greece",
        "iso3": "GRC",
        "iso2": "GR",
        "phone_code": "30",
        "capital": "Athens",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".gr",
        "native": "Î•Î»Î»Î¬Î´Î±",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Athens",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ê·¸ë¦¬ìŠ¤",
            "br": "GrÃ©cia",
            "pt": "GrÃ©cia",
            "nl": "Griekenland",
            "hr": "GrÄka",
            "fa": "ÛŒÙˆÙ†Ø§Ù†",
            "de": "Griechenland",
            "es": "Grecia",
            "fr": "GrÃ¨ce",
            "ja": "ã‚®ãƒªã‚·ãƒ£",
            "it": "Grecia",
            "cn": "å¸Œè…Š"
        },
        "latitude": "39.00000000",
        "longitude": "22.00000000",
        "emoji": "ðŸ‡¬ðŸ‡·",
        "emojiU": "U+1F1EC U+1F1F7",
        "states": [
            {
                "id": 2116,
                "name": "Achaea Regional Unit",
                "state_code": "13",
                "latitude": "38.11587290",
                "longitude": "21.95224910"
            },
            {
                "id": 2123,
                "name": "Aetolia-Acarnania Regional Unit",
                "state_code": "01",
                "latitude": "38.70843860",
                "longitude": "21.37989280"
            },
            {
                "id": 2098,
                "name": "Arcadia Prefecture",
                "state_code": "12",
                "latitude": "37.55578250",
                "longitude": "22.33377690"
            },
            {
                "id": 2105,
                "name": "Argolis Regional Unit",
                "state_code": "11",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2122,
                "name": "Attica Region",
                "state_code": "I",
                "latitude": "38.04575680",
                "longitude": "23.85847370"
            },
            {
                "id": 2126,
                "name": "Boeotia Regional Unit",
                "state_code": "03",
                "latitude": "38.36636640",
                "longitude": "23.09650640"
            },
            {
                "id": 2128,
                "name": "Central Greece Region",
                "state_code": "H",
                "latitude": "38.60439840",
                "longitude": "22.71521310"
            },
            {
                "id": 2125,
                "name": "Central Macedonia",
                "state_code": "B",
                "latitude": "40.62117300",
                "longitude": "23.19180210"
            },
            {
                "id": 2115,
                "name": "Chania Regional Unit",
                "state_code": "94",
                "latitude": "35.51382980",
                "longitude": "24.01803670"
            },
            {
                "id": 2124,
                "name": "Corfu Prefecture",
                "state_code": "22",
                "latitude": "39.62498380",
                "longitude": "19.92234610"
            },
            {
                "id": 2129,
                "name": "Corinthia Regional Unit",
                "state_code": "15",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2109,
                "name": "Crete Region",
                "state_code": "M",
                "latitude": "35.24011700",
                "longitude": "24.80926910"
            },
            {
                "id": 2130,
                "name": "Drama Regional Unit",
                "state_code": "52",
                "latitude": "41.23400230",
                "longitude": "24.23904980"
            },
            {
                "id": 2120,
                "name": "East Attica Regional Unit",
                "state_code": "A2",
                "latitude": "38.20540930",
                "longitude": "23.85847370"
            },
            {
                "id": 2117,
                "name": "East Macedonia and Thrace",
                "state_code": "A",
                "latitude": "41.12951260",
                "longitude": "24.88771910"
            },
            {
                "id": 2110,
                "name": "Epirus Region",
                "state_code": "D",
                "latitude": "39.57064130",
                "longitude": "20.76428430"
            },
            {
                "id": 2101,
                "name": "Euboea",
                "state_code": "04",
                "latitude": "38.52360360",
                "longitude": "23.85847370"
            },
            {
                "id": 2102,
                "name": "Grevena Prefecture",
                "state_code": "51",
                "latitude": "40.08376260",
                "longitude": "21.42732990"
            },
            {
                "id": 2099,
                "name": "Imathia Regional Unit",
                "state_code": "53",
                "latitude": "40.60600670",
                "longitude": "22.14302150"
            },
            {
                "id": 2113,
                "name": "Ioannina Regional Unit",
                "state_code": "33",
                "latitude": "39.66502880",
                "longitude": "20.85374660"
            },
            {
                "id": 2131,
                "name": "Ionian Islands Region",
                "state_code": "F",
                "latitude": "37.96948980",
                "longitude": "21.38023720"
            },
            {
                "id": 2095,
                "name": "Karditsa Regional Unit",
                "state_code": "41",
                "latitude": "39.36402580",
                "longitude": "21.92140490"
            },
            {
                "id": 2100,
                "name": "Kastoria Regional Unit",
                "state_code": "56",
                "latitude": "40.51926910",
                "longitude": "21.26871710"
            },
            {
                "id": 2127,
                "name": "Kefalonia Prefecture",
                "state_code": "23",
                "latitude": "38.17536750",
                "longitude": "20.56921790"
            },
            {
                "id": 2111,
                "name": "Kilkis Regional Unit",
                "state_code": "57",
                "latitude": "40.99370710",
                "longitude": "22.87536740"
            },
            {
                "id": 2112,
                "name": "Kozani Prefecture",
                "state_code": "58",
                "latitude": "40.30055860",
                "longitude": "21.78877370"
            },
            {
                "id": 2106,
                "name": "Laconia",
                "state_code": "16",
                "latitude": "43.52785460",
                "longitude": "-71.47035090"
            },
            {
                "id": 2132,
                "name": "Larissa Prefecture",
                "state_code": "42",
                "latitude": "39.63902240",
                "longitude": "22.41912540"
            },
            {
                "id": 2104,
                "name": "Lefkada Regional Unit",
                "state_code": "24",
                "latitude": "38.83336630",
                "longitude": "20.70691080"
            },
            {
                "id": 2107,
                "name": "Pella Regional Unit",
                "state_code": "59",
                "latitude": "40.91480390",
                "longitude": "22.14302150"
            },
            {
                "id": 2119,
                "name": "Peloponnese Region",
                "state_code": "J",
                "latitude": "37.50794720",
                "longitude": "22.37349000"
            },
            {
                "id": 2114,
                "name": "Phthiotis Prefecture",
                "state_code": "06",
                "latitude": "38.99978500",
                "longitude": "22.33377690"
            },
            {
                "id": 2103,
                "name": "Preveza Prefecture",
                "state_code": "34",
                "latitude": "38.95926490",
                "longitude": "20.75171550"
            },
            {
                "id": 2121,
                "name": "Serres Prefecture",
                "state_code": "62",
                "latitude": "41.08638540",
                "longitude": "23.54838190"
            },
            {
                "id": 2118,
                "name": "South Aegean",
                "state_code": "L",
                "latitude": "37.08553020",
                "longitude": "25.14892150"
            },
            {
                "id": 2097,
                "name": "Thessaloniki Regional Unit",
                "state_code": "54",
                "latitude": "40.64006290",
                "longitude": "22.94441910"
            },
            {
                "id": 2096,
                "name": "West Greece Region",
                "state_code": "G",
                "latitude": "38.51154960",
                "longitude": "21.57067860"
            },
            {
                "id": 2108,
                "name": "West Macedonia Region",
                "state_code": "C",
                "latitude": "40.30040580",
                "longitude": "21.79035590"
            }
        ]
    },
    {
        "name": "Greenland",
        "iso3": "GRL",
        "iso2": "GL",
        "phone_code": "299",
        "capital": "Nuuk",
        "currency": "DKK",
        "currency_symbol": "Kr.",
        "tld": ".gl",
        "native": "Kalaallit Nunaat",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "America\/Danmarkshavn",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            },
            {
                "zoneName": "America\/Nuuk",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "WGT",
                "tzName": "West Greenland Time"
            },
            {
                "zoneName": "America\/Scoresbysund",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "EGT",
                "tzName": "Eastern Greenland Time"
            },
            {
                "zoneName": "America\/Thule",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ê·¸ë¦°ëž€ë“œ",
            "br": "GroelÃ¢ndia",
            "pt": "GronelÃ¢ndia",
            "nl": "Groenland",
            "hr": "Grenland",
            "fa": "Ú¯Ø±ÛŒÙ†Ù„Ù†Ø¯",
            "de": "GrÃ¶nland",
            "es": "Groenlandia",
            "fr": "Groenland",
            "ja": "ã‚°ãƒªãƒ¼ãƒ³ãƒ©ãƒ³ãƒ‰",
            "it": "Groenlandia",
            "cn": "æ ¼é™µå…°å²›"
        },
        "latitude": "72.00000000",
        "longitude": "-40.00000000",
        "emoji": "ðŸ‡¬ðŸ‡±",
        "emojiU": "U+1F1EC U+1F1F1",
        "states": []
    },
    {
        "name": "Grenada",
        "iso3": "GRD",
        "iso2": "GD",
        "phone_code": "+1-473",
        "capital": "St. George's",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".gd",
        "native": "Grenada",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Grenada",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ê·¸ë ˆë‚˜ë‹¤",
            "br": "Granada",
            "pt": "Granada",
            "nl": "Grenada",
            "hr": "Grenada",
            "fa": "Ú¯Ø±Ù†Ø§Ø¯Ø§",
            "de": "Grenada",
            "es": "Grenada",
            "fr": "Grenade",
            "ja": "ã‚°ãƒ¬ãƒŠãƒ€",
            "it": "Grenada",
            "cn": "æ ¼æž—çº³è¾¾"
        },
        "latitude": "12.11666666",
        "longitude": "-61.66666666",
        "emoji": "ðŸ‡¬ðŸ‡©",
        "emojiU": "U+1F1EC U+1F1E9",
        "states": [
            {
                "id": 3867,
                "name": "Carriacou and Petite Martinique",
                "state_code": "10",
                "latitude": "12.47858880",
                "longitude": "-61.44938420"
            },
            {
                "id": 3865,
                "name": "Saint Andrew Parish",
                "state_code": "01",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3869,
                "name": "Saint David Parish",
                "state_code": "02",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3864,
                "name": "Saint George Parish",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3868,
                "name": "Saint John Parish",
                "state_code": "04",
                "latitude": "30.11183310",
                "longitude": "-90.48799160"
            },
            {
                "id": 3866,
                "name": "Saint Mark Parish",
                "state_code": "05",
                "latitude": "40.58818630",
                "longitude": "-73.94957010"
            },
            {
                "id": 3863,
                "name": "Saint Patrick Parish",
                "state_code": "06",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Guadeloupe",
        "iso3": "GLP",
        "iso2": "GP",
        "phone_code": "590",
        "capital": "Basse-Terre",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".gp",
        "native": "Guadeloupe",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Guadeloupe",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ê³¼ë“¤ë£¨í”„",
            "br": "Guadalupe",
            "pt": "Guadalupe",
            "nl": "Guadeloupe",
            "hr": "Gvadalupa",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ú¯ÙˆØ§Ø¯Ù„ÙˆÙ¾",
            "de": "Guadeloupe",
            "es": "Guadalupe",
            "fr": "Guadeloupe",
            "ja": "ã‚°ã‚¢ãƒ‰ãƒ«ãƒ¼ãƒ—",
            "it": "Guadeloupa",
            "cn": "ç“œå¾·ç½—æ™®å²›"
        },
        "latitude": "16.25000000",
        "longitude": "-61.58333300",
        "emoji": "ðŸ‡¬ðŸ‡µ",
        "emojiU": "U+1F1EC U+1F1F5",
        "states": []
    },
    {
        "name": "Guam",
        "iso3": "GUM",
        "iso2": "GU",
        "phone_code": "+1-671",
        "capital": "Hagatna",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".gu",
        "native": "Guam",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Guam",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "CHST",
                "tzName": "Chamorro Standard Time"
            }
        ],
        "translations": {
            "kr": "ê´Œ",
            "br": "Guam",
            "pt": "Guame",
            "nl": "Guam",
            "hr": "Guam",
            "fa": "Ú¯ÙˆØ§Ù…",
            "de": "Guam",
            "es": "Guam",
            "fr": "Guam",
            "ja": "ã‚°ã‚¢ãƒ ",
            "it": "Guam",
            "cn": "å…³å²›"
        },
        "latitude": "13.46666666",
        "longitude": "144.78333333",
        "emoji": "ðŸ‡¬ðŸ‡º",
        "emojiU": "U+1F1EC U+1F1FA",
        "states": []
    },
    {
        "name": "Guatemala",
        "iso3": "GTM",
        "iso2": "GT",
        "phone_code": "502",
        "capital": "Guatemala City",
        "currency": "GTQ",
        "currency_symbol": "Q",
        "tld": ".gt",
        "native": "Guatemala",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Guatemala",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ê³¼í…Œë§ë¼",
            "br": "Guatemala",
            "pt": "Guatemala",
            "nl": "Guatemala",
            "hr": "Gvatemala",
            "fa": "Ú¯ÙˆØ§ØªÙ…Ø§Ù„Ø§",
            "de": "Guatemala",
            "es": "Guatemala",
            "fr": "Guatemala",
            "ja": "ã‚°ã‚¢ãƒ†ãƒžãƒ©",
            "it": "Guatemala",
            "cn": "å±åœ°é©¬æ‹‰"
        },
        "latitude": "15.50000000",
        "longitude": "-90.25000000",
        "emoji": "ðŸ‡¬ðŸ‡¹",
        "emojiU": "U+1F1EC U+1F1F9",
        "states": [
            {
                "id": 3671,
                "name": "Alta Verapaz Department",
                "state_code": "AV",
                "latitude": "15.59428830",
                "longitude": "-90.14949880"
            },
            {
                "id": 3674,
                "name": "Baja Verapaz Department",
                "state_code": "BV",
                "latitude": "15.12558670",
                "longitude": "-90.37483540"
            },
            {
                "id": 3675,
                "name": "Chimaltenango Department",
                "state_code": "CM",
                "latitude": "14.56347870",
                "longitude": "-90.98206680"
            },
            {
                "id": 3666,
                "name": "Chiquimula Department",
                "state_code": "CQ",
                "latitude": "14.75149990",
                "longitude": "-89.47421770"
            },
            {
                "id": 3662,
                "name": "El Progreso Department",
                "state_code": "PR",
                "latitude": "14.93887320",
                "longitude": "-90.07467670"
            },
            {
                "id": 3677,
                "name": "Escuintla Department",
                "state_code": "ES",
                "latitude": "14.19109120",
                "longitude": "-90.98206680"
            },
            {
                "id": 3672,
                "name": "Guatemala Department",
                "state_code": "GU",
                "latitude": "14.56494010",
                "longitude": "-90.52578230"
            },
            {
                "id": 3670,
                "name": "Huehuetenango Department",
                "state_code": "HU",
                "latitude": "15.58799140",
                "longitude": "-91.67606910"
            },
            {
                "id": 3659,
                "name": "Izabal Department",
                "state_code": "IZ",
                "latitude": "15.49765170",
                "longitude": "-88.86469800"
            },
            {
                "id": 3658,
                "name": "Jalapa Department",
                "state_code": "JA",
                "latitude": "14.61214460",
                "longitude": "-89.96267990"
            },
            {
                "id": 3673,
                "name": "Jutiapa Department",
                "state_code": "JU",
                "latitude": "14.19308020",
                "longitude": "-89.92532330"
            },
            {
                "id": 3669,
                "name": "PetÃ©n Department",
                "state_code": "PE",
                "latitude": "16.91203300",
                "longitude": "-90.29957850"
            },
            {
                "id": 3668,
                "name": "Quetzaltenango Department",
                "state_code": "QZ",
                "latitude": "14.79243300",
                "longitude": "-91.71495800"
            },
            {
                "id": 3657,
                "name": "QuichÃ© Department",
                "state_code": "QC",
                "latitude": "15.49838080",
                "longitude": "-90.98206680"
            },
            {
                "id": 3664,
                "name": "Retalhuleu Department",
                "state_code": "RE",
                "latitude": "14.52454850",
                "longitude": "-91.68578800"
            },
            {
                "id": 3676,
                "name": "SacatepÃ©quez Department",
                "state_code": "SA",
                "latitude": "14.51783790",
                "longitude": "-90.71527490"
            },
            {
                "id": 3667,
                "name": "San Marcos Department",
                "state_code": "SM",
                "latitude": "14.93095690",
                "longitude": "-91.90992380"
            },
            {
                "id": 3665,
                "name": "Santa Rosa Department",
                "state_code": "SR",
                "latitude": "38.44057590",
                "longitude": "-122.70375430"
            },
            {
                "id": 3661,
                "name": "SololÃ¡ Department",
                "state_code": "SO",
                "latitude": "14.74852300",
                "longitude": "-91.28910360"
            },
            {
                "id": 3660,
                "name": "SuchitepÃ©quez Department",
                "state_code": "SU",
                "latitude": "14.42159820",
                "longitude": "-91.40482490"
            },
            {
                "id": 3663,
                "name": "TotonicapÃ¡n Department",
                "state_code": "TO",
                "latitude": "14.91734020",
                "longitude": "-91.36139230"
            }
        ]
    },
    {
        "name": "Guernsey and Alderney",
        "iso3": "GGY",
        "iso2": "GG",
        "phone_code": "+44-1481",
        "capital": "St Peter Port",
        "currency": "GBP",
        "currency_symbol": "Â£",
        "tld": ".gg",
        "native": "Guernsey",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Guernsey",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ê±´ì§€, ì˜¬ë”ë‹ˆ",
            "br": "Guernsey",
            "pt": "Guernsey",
            "nl": "Guernsey",
            "hr": "Guernsey",
            "fa": "Ú¯Ø±Ù†Ø²ÛŒ",
            "de": "Guernsey",
            "es": "Guernsey",
            "fr": "Guernesey",
            "ja": "ã‚¬ãƒ¼ãƒ³ã‚¸ãƒ¼",
            "it": "Guernsey",
            "cn": "æ ¹è¥¿å²›"
        },
        "latitude": "49.46666666",
        "longitude": "-2.58333333",
        "emoji": "ðŸ‡¬ðŸ‡¬",
        "emojiU": "U+1F1EC U+1F1EC",
        "states": []
    },
    {
        "name": "Guinea",
        "iso3": "GIN",
        "iso2": "GN",
        "phone_code": "224",
        "capital": "Conakry",
        "currency": "GNF",
        "currency_symbol": "FG",
        "tld": ".gn",
        "native": "GuinÃ©e",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Conakry",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ê¸°ë‹ˆ",
            "br": "GuinÃ©",
            "pt": "GuinÃ©",
            "nl": "Guinee",
            "hr": "Gvineja",
            "fa": "Ú¯ÛŒÙ†Ù‡",
            "de": "Guinea",
            "es": "Guinea",
            "fr": "GuinÃ©e",
            "ja": "ã‚®ãƒ‹ã‚¢",
            "it": "Guinea",
            "cn": "å‡ å†…äºš"
        },
        "latitude": "11.00000000",
        "longitude": "-10.00000000",
        "emoji": "ðŸ‡¬ðŸ‡³",
        "emojiU": "U+1F1EC U+1F1F3",
        "states": [
            {
                "id": 2672,
                "name": "Beyla Prefecture",
                "state_code": "BE",
                "latitude": "8.91981780",
                "longitude": "-8.30884410"
            },
            {
                "id": 2699,
                "name": "Boffa Prefecture",
                "state_code": "BF",
                "latitude": "10.18082540",
                "longitude": "-14.03916150"
            },
            {
                "id": 2709,
                "name": "BokÃ© Prefecture",
                "state_code": "BK",
                "latitude": "11.08473790",
                "longitude": "-14.37919120"
            },
            {
                "id": 2676,
                "name": "BokÃ© Region",
                "state_code": "B",
                "latitude": "11.18646720",
                "longitude": "-14.10013260"
            },
            {
                "id": 2686,
                "name": "Conakry",
                "state_code": "C",
                "latitude": "9.64118550",
                "longitude": "-13.57840120"
            },
            {
                "id": 2705,
                "name": "Coyah Prefecture",
                "state_code": "CO",
                "latitude": "9.77155350",
                "longitude": "-13.31252990"
            },
            {
                "id": 2679,
                "name": "Dabola Prefecture",
                "state_code": "DB",
                "latitude": "10.72978060",
                "longitude": "-11.11078540"
            },
            {
                "id": 2706,
                "name": "Dalaba Prefecture",
                "state_code": "DL",
                "latitude": "10.68681760",
                "longitude": "-12.24906970"
            },
            {
                "id": 2688,
                "name": "Dinguiraye Prefecture",
                "state_code": "DI",
                "latitude": "11.68442220",
                "longitude": "-10.80000510"
            },
            {
                "id": 2681,
                "name": "DubrÃ©ka Prefecture",
                "state_code": "DU",
                "latitude": "9.79073480",
                "longitude": "-13.51477350"
            },
            {
                "id": 2682,
                "name": "Faranah Prefecture",
                "state_code": "FA",
                "latitude": "9.90573990",
                "longitude": "-10.80000510"
            },
            {
                "id": 2683,
                "name": "ForÃ©cariah Prefecture",
                "state_code": "FO",
                "latitude": "9.38861870",
                "longitude": "-13.08179030"
            },
            {
                "id": 2675,
                "name": "Fria Prefecture",
                "state_code": "FR",
                "latitude": "10.36745430",
                "longitude": "-13.58418710"
            },
            {
                "id": 2685,
                "name": "Gaoual Prefecture",
                "state_code": "GA",
                "latitude": "11.57628040",
                "longitude": "-13.35872880"
            },
            {
                "id": 2711,
                "name": "GuÃ©ckÃ©dou Prefecture",
                "state_code": "GU",
                "latitude": "8.56496880",
                "longitude": "-10.13111630"
            },
            {
                "id": 2704,
                "name": "Kankan Prefecture",
                "state_code": "KA",
                "latitude": "10.30344650",
                "longitude": "-9.36730840"
            },
            {
                "id": 2697,
                "name": "Kankan Region",
                "state_code": "K",
                "latitude": "10.12092300",
                "longitude": "-9.54509740"
            },
            {
                "id": 2710,
                "name": "KÃ©rouanÃ© Prefecture",
                "state_code": "KE",
                "latitude": "9.25366430",
                "longitude": "-9.01289260"
            },
            {
                "id": 2693,
                "name": "Kindia Prefecture",
                "state_code": "KD",
                "latitude": "10.10132920",
                "longitude": "-12.71351210"
            },
            {
                "id": 2701,
                "name": "Kindia Region",
                "state_code": "D",
                "latitude": "10.17816940",
                "longitude": "-12.98961500"
            },
            {
                "id": 2691,
                "name": "Kissidougou Prefecture",
                "state_code": "KS",
                "latitude": "9.22520220",
                "longitude": "-10.08072980"
            },
            {
                "id": 2692,
                "name": "Koubia Prefecture",
                "state_code": "KB",
                "latitude": "11.58235400",
                "longitude": "-11.89202370"
            },
            {
                "id": 2703,
                "name": "Koundara Prefecture",
                "state_code": "KN",
                "latitude": "12.48940210",
                "longitude": "-13.30675620"
            },
            {
                "id": 2695,
                "name": "Kouroussa Prefecture",
                "state_code": "KO",
                "latitude": "10.64892290",
                "longitude": "-9.88505860"
            },
            {
                "id": 2680,
                "name": "LabÃ© Prefecture",
                "state_code": "LA",
                "latitude": "11.35419390",
                "longitude": "-12.34638750"
            },
            {
                "id": 2677,
                "name": "LabÃ© Region",
                "state_code": "L",
                "latitude": "11.32320420",
                "longitude": "-12.28913140"
            },
            {
                "id": 2690,
                "name": "LÃ©louma Prefecture",
                "state_code": "LE",
                "latitude": "11.18333300",
                "longitude": "-12.93333300"
            },
            {
                "id": 2708,
                "name": "Lola Prefecture",
                "state_code": "LO",
                "latitude": "7.96138180",
                "longitude": "-8.39649380"
            },
            {
                "id": 2702,
                "name": "Macenta Prefecture",
                "state_code": "MC",
                "latitude": "8.46157950",
                "longitude": "-9.27855830"
            },
            {
                "id": 2700,
                "name": "Mali Prefecture",
                "state_code": "ML",
                "latitude": "11.98370900",
                "longitude": "-12.25479190"
            },
            {
                "id": 2689,
                "name": "Mamou Prefecture",
                "state_code": "MM",
                "latitude": "10.57360240",
                "longitude": "-11.88917210"
            },
            {
                "id": 2698,
                "name": "Mamou Region",
                "state_code": "M",
                "latitude": "10.57360240",
                "longitude": "-11.88917210"
            },
            {
                "id": 2673,
                "name": "Mandiana Prefecture",
                "state_code": "MD",
                "latitude": "10.61728270",
                "longitude": "-8.69857160"
            },
            {
                "id": 2678,
                "name": "NzÃ©rÃ©korÃ© Prefecture",
                "state_code": "NZ",
                "latitude": "7.74783590",
                "longitude": "-8.82525020"
            },
            {
                "id": 2684,
                "name": "NzÃ©rÃ©korÃ© Region",
                "state_code": "N",
                "latitude": "8.03858700",
                "longitude": "-8.83627550"
            },
            {
                "id": 2694,
                "name": "Pita Prefecture",
                "state_code": "PI",
                "latitude": "10.80620860",
                "longitude": "-12.71351210"
            },
            {
                "id": 2707,
                "name": "Siguiri Prefecture",
                "state_code": "SI",
                "latitude": "11.41481130",
                "longitude": "-9.17883040"
            },
            {
                "id": 2687,
                "name": "TÃ©limÃ©lÃ© Prefecture",
                "state_code": "TE",
                "latitude": "10.90893640",
                "longitude": "-13.02993310"
            },
            {
                "id": 2696,
                "name": "TouguÃ© Prefecture",
                "state_code": "TO",
                "latitude": "11.38415830",
                "longitude": "-11.61577730"
            },
            {
                "id": 2674,
                "name": "Yomou Prefecture",
                "state_code": "YO",
                "latitude": "7.56962790",
                "longitude": "-9.25915710"
            }
        ]
    },
    {
        "name": "Guinea-Bissau",
        "iso3": "GNB",
        "iso2": "GW",
        "phone_code": "245",
        "capital": "Bissau",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".gw",
        "native": "GuinÃ©-Bissau",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Bissau",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ê¸°ë‹ˆë¹„ì‚¬ìš°",
            "br": "GuinÃ©-Bissau",
            "pt": "GuinÃ©-Bissau",
            "nl": "Guinee-Bissau",
            "hr": "Gvineja Bisau",
            "fa": "Ú¯ÛŒÙ†Ù‡ Ø¨ÛŒØ³Ø§Ø¦Ùˆ",
            "de": "Guinea-Bissau",
            "es": "Guinea-BisÃ¡u",
            "fr": "GuinÃ©e-Bissau",
            "ja": "ã‚®ãƒ‹ã‚¢ãƒ“ã‚µã‚¦",
            "it": "Guinea-Bissau",
            "cn": "å‡ å†…äºšæ¯”ç»"
        },
        "latitude": "12.00000000",
        "longitude": "-15.00000000",
        "emoji": "ðŸ‡¬ðŸ‡¼",
        "emojiU": "U+1F1EC U+1F1FC",
        "states": [
            {
                "id": 2720,
                "name": "BafatÃ¡",
                "state_code": "BA",
                "latitude": "12.17352430",
                "longitude": "-14.65295200"
            },
            {
                "id": 2714,
                "name": "Biombo Region",
                "state_code": "BM",
                "latitude": "11.85290610",
                "longitude": "-15.73511710"
            },
            {
                "id": 2722,
                "name": "Bolama Region",
                "state_code": "BL",
                "latitude": "11.14805910",
                "longitude": "-16.13457050"
            },
            {
                "id": 2713,
                "name": "Cacheu Region",
                "state_code": "CA",
                "latitude": "12.05514160",
                "longitude": "-16.06401790"
            },
            {
                "id": 2719,
                "name": "GabÃº Region",
                "state_code": "GA",
                "latitude": "11.89624880",
                "longitude": "-14.10013260"
            },
            {
                "id": 2721,
                "name": "Leste Province",
                "state_code": "L",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2717,
                "name": "Norte Province",
                "state_code": "N",
                "latitude": "7.87218110",
                "longitude": "123.88577470"
            },
            {
                "id": 2718,
                "name": "Oio Region",
                "state_code": "OI",
                "latitude": "12.27607090",
                "longitude": "-15.31311850"
            },
            {
                "id": 2715,
                "name": "Quinara Region",
                "state_code": "QU",
                "latitude": "11.79556200",
                "longitude": "-15.17268160"
            },
            {
                "id": 2716,
                "name": "Sul Province",
                "state_code": "S",
                "latitude": "-10.28665780",
                "longitude": "20.71224650"
            },
            {
                "id": 2712,
                "name": "Tombali Region",
                "state_code": "TO",
                "latitude": "11.36326960",
                "longitude": "-14.98561760"
            }
        ]
    },
    {
        "name": "Guyana",
        "iso3": "GUY",
        "iso2": "GY",
        "phone_code": "592",
        "capital": "Georgetown",
        "currency": "GYD",
        "currency_symbol": "$",
        "tld": ".gy",
        "native": "Guyana",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Guyana",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "GYT",
                "tzName": "Guyana Time"
            }
        ],
        "translations": {
            "kr": "ê°€ì´ì•„ë‚˜",
            "br": "Guiana",
            "pt": "Guiana",
            "nl": "Guyana",
            "hr": "Gvajana",
            "fa": "Ú¯ÙˆÛŒØ§Ù†",
            "de": "Guyana",
            "es": "Guyana",
            "fr": "Guyane",
            "ja": "ã‚¬ã‚¤ã‚¢ãƒŠ",
            "it": "Guyana",
            "cn": "åœ­äºšé‚£"
        },
        "latitude": "5.00000000",
        "longitude": "-59.00000000",
        "emoji": "ðŸ‡¬ðŸ‡¾",
        "emojiU": "U+1F1EC U+1F1FE",
        "states": [
            {
                "id": 2764,
                "name": "Barima-Waini",
                "state_code": "BA",
                "latitude": "7.48824190",
                "longitude": "-59.65644940"
            },
            {
                "id": 2760,
                "name": "Cuyuni-Mazaruni",
                "state_code": "CU",
                "latitude": "6.46421410",
                "longitude": "-60.21107520"
            },
            {
                "id": 2767,
                "name": "Demerara-Mahaica",
                "state_code": "DE",
                "latitude": "6.54642600",
                "longitude": "-58.09820460"
            },
            {
                "id": 2766,
                "name": "East Berbice-Corentyne",
                "state_code": "EB",
                "latitude": "2.74779220",
                "longitude": "-57.46272590"
            },
            {
                "id": 2768,
                "name": "Essequibo Islands-West Demerara",
                "state_code": "ES",
                "latitude": "6.57201320",
                "longitude": "-58.46299970"
            },
            {
                "id": 2762,
                "name": "Mahaica-Berbice",
                "state_code": "MA",
                "latitude": "6.23849600",
                "longitude": "-57.91625550"
            },
            {
                "id": 2765,
                "name": "Pomeroon-Supenaam",
                "state_code": "PM",
                "latitude": "7.12941660",
                "longitude": "-58.92062950"
            },
            {
                "id": 2761,
                "name": "Potaro-Siparuni",
                "state_code": "PT",
                "latitude": "4.78558530",
                "longitude": "-59.28799770"
            },
            {
                "id": 2763,
                "name": "Upper Demerara-Berbice",
                "state_code": "UD",
                "latitude": "5.30648790",
                "longitude": "-58.18929210"
            },
            {
                "id": 2769,
                "name": "Upper Takutu-Upper Essequibo",
                "state_code": "UT",
                "latitude": "2.92395950",
                "longitude": "-58.73736340"
            }
        ]
    },
    {
        "name": "Haiti",
        "iso3": "HTI",
        "iso2": "HT",
        "phone_code": "509",
        "capital": "Port-au-Prince",
        "currency": "HTG",
        "currency_symbol": "G",
        "tld": ".ht",
        "native": "HaÃ¯ti",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Port-au-Prince",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ì•„ì´í‹°",
            "br": "Haiti",
            "pt": "Haiti",
            "nl": "HaÃ¯ti",
            "hr": "Haiti",
            "fa": "Ù‡Ø§Ø¦ÛŒØªÛŒ",
            "de": "Haiti",
            "es": "Haiti",
            "fr": "HaÃ¯ti",
            "ja": "ãƒã‚¤ãƒ",
            "it": "Haiti",
            "cn": "æµ·åœ°"
        },
        "latitude": "19.00000000",
        "longitude": "-72.41666666",
        "emoji": "ðŸ‡­ðŸ‡¹",
        "emojiU": "U+1F1ED U+1F1F9",
        "states": [
            {
                "id": 4123,
                "name": "Artibonite",
                "state_code": "AR",
                "latitude": "19.36290200",
                "longitude": "-72.42581450"
            },
            {
                "id": 4125,
                "name": "Centre",
                "state_code": "CE",
                "latitude": "32.83702510",
                "longitude": "-96.77738820"
            },
            {
                "id": 4119,
                "name": "Grand'Anse",
                "state_code": "GA",
                "latitude": "12.01666670",
                "longitude": "-61.76666670"
            },
            {
                "id": 4118,
                "name": "Nippes",
                "state_code": "NI",
                "latitude": "18.39907350",
                "longitude": "-73.41802110"
            },
            {
                "id": 4117,
                "name": "Nord",
                "state_code": "ND",
                "latitude": "43.19052600",
                "longitude": "-89.43792100"
            },
            {
                "id": 4121,
                "name": "Nord-Est",
                "state_code": "NE",
                "latitude": "19.48897230",
                "longitude": "-71.85713310"
            },
            {
                "id": 4126,
                "name": "Nord-Ouest",
                "state_code": "NO",
                "latitude": "19.83740090",
                "longitude": "-73.04052770"
            },
            {
                "id": 4120,
                "name": "Ouest",
                "state_code": "OU",
                "latitude": "45.45472490",
                "longitude": "-73.65023650"
            },
            {
                "id": 4122,
                "name": "Sud",
                "state_code": "SD",
                "latitude": "29.92132480",
                "longitude": "-90.09737720"
            },
            {
                "id": 4124,
                "name": "Sud-Est",
                "state_code": "SE",
                "latitude": "18.27835980",
                "longitude": "-72.35479150"
            }
        ]
    },
    {
        "name": "Heard Island and McDonald Islands",
        "iso3": "HMD",
        "iso2": "HM",
        "phone_code": "",
        "capital": "",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".hm",
        "native": "Heard Island and McDonald Islands",
        "region": "",
        "subregion": "",
        "timezones": [
            {
                "zoneName": "Indian\/Kerguelen",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TFT",
                "tzName": "French Southern and Antarctic Time"
            }
        ],
        "translations": {
            "kr": "í—ˆë“œ ë§¥ë„ë‚ ë“œ ì œë„",
            "br": "Ilha Heard e Ilhas McDonald",
            "pt": "Ilha Heard e Ilhas McDonald",
            "nl": "Heard- en McDonaldeilanden",
            "hr": "Otok Heard i otoÄje McDonald",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ù‡Ø±Ø¯ Ùˆ Ø¬Ø²Ø§ÛŒØ± Ù…Ú©â€ŒØ¯ÙˆÙ†Ø§Ù„Ø¯",
            "de": "Heard und die McDonaldinseln",
            "es": "Islas Heard y McDonald",
            "fr": "ÃŽles Heard-et-MacDonald",
            "ja": "ãƒãƒ¼ãƒ‰å³¶ã¨ãƒžã‚¯ãƒ‰ãƒŠãƒ«ãƒ‰è«¸å³¶",
            "it": "Isole Heard e McDonald",
            "cn": "èµ«å¾·Â·å”çº³å²›åŠéº¦å”çº³å²›"
        },
        "latitude": "-53.10000000",
        "longitude": "72.51666666",
        "emoji": "ðŸ‡­ðŸ‡²",
        "emojiU": "U+1F1ED U+1F1F2",
        "states": []
    },
    {
        "name": "Honduras",
        "iso3": "HND",
        "iso2": "HN",
        "phone_code": "504",
        "capital": "Tegucigalpa",
        "currency": "HNL",
        "currency_symbol": "L",
        "tld": ".hn",
        "native": "Honduras",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Tegucigalpa",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ì˜¨ë‘ë¼ìŠ¤",
            "br": "Honduras",
            "pt": "Honduras",
            "nl": "Honduras",
            "hr": "Honduras",
            "fa": "Ù‡Ù†Ø¯ÙˆØ±Ø§Ø³",
            "de": "Honduras",
            "es": "Honduras",
            "fr": "Honduras",
            "ja": "ãƒ›ãƒ³ã‚¸ãƒ¥ãƒ©ã‚¹",
            "it": "Honduras",
            "cn": "æ´ªéƒ½æ‹‰æ–¯"
        },
        "latitude": "15.00000000",
        "longitude": "-86.50000000",
        "emoji": "ðŸ‡­ðŸ‡³",
        "emojiU": "U+1F1ED U+1F1F3",
        "states": [
            {
                "id": 4047,
                "name": "AtlÃ¡ntida Department",
                "state_code": "AT",
                "latitude": "15.66962830",
                "longitude": "-87.14228950"
            },
            {
                "id": 4045,
                "name": "Bay Islands Department",
                "state_code": "IB",
                "latitude": "16.48266140",
                "longitude": "-85.87932520"
            },
            {
                "id": 4041,
                "name": "Choluteca Department",
                "state_code": "CH",
                "latitude": "13.25043250",
                "longitude": "-87.14228950"
            },
            {
                "id": 4051,
                "name": "ColÃ³n Department",
                "state_code": "CL",
                "latitude": "15.64259650",
                "longitude": "-85.52002400"
            },
            {
                "id": 4042,
                "name": "Comayagua Department",
                "state_code": "CM",
                "latitude": "14.55348280",
                "longitude": "-87.61863790"
            },
            {
                "id": 4049,
                "name": "CopÃ¡n Department",
                "state_code": "CP",
                "latitude": "14.93608380",
                "longitude": "-88.86469800"
            },
            {
                "id": 4046,
                "name": "CortÃ©s Department",
                "state_code": "CR",
                "latitude": "15.49235080",
                "longitude": "-88.09007620"
            },
            {
                "id": 4043,
                "name": "El ParaÃ­so Department",
                "state_code": "EP",
                "latitude": "13.98212940",
                "longitude": "-86.49965460"
            },
            {
                "id": 4052,
                "name": "Francisco MorazÃ¡n Department",
                "state_code": "FM",
                "latitude": "14.45411000",
                "longitude": "-87.06242610"
            },
            {
                "id": 4048,
                "name": "Gracias a Dios Department",
                "state_code": "GD",
                "latitude": "15.34180600",
                "longitude": "-84.60604490"
            },
            {
                "id": 4044,
                "name": "IntibucÃ¡ Department",
                "state_code": "IN",
                "latitude": "14.37273400",
                "longitude": "-88.24611830"
            },
            {
                "id": 4058,
                "name": "La Paz Department",
                "state_code": "LP",
                "latitude": "-15.08924160",
                "longitude": "-68.52471490"
            },
            {
                "id": 4054,
                "name": "Lempira Department",
                "state_code": "LE",
                "latitude": "14.18876980",
                "longitude": "-88.55653100"
            },
            {
                "id": 4056,
                "name": "Ocotepeque Department",
                "state_code": "OC",
                "latitude": "14.51703470",
                "longitude": "-89.05615320"
            },
            {
                "id": 4050,
                "name": "Olancho Department",
                "state_code": "OL",
                "latitude": "14.80674060",
                "longitude": "-85.76666450"
            },
            {
                "id": 4053,
                "name": "Santa BÃ¡rbara Department",
                "state_code": "SB",
                "latitude": "15.12027950",
                "longitude": "-88.40160410"
            },
            {
                "id": 4055,
                "name": "Valle Department",
                "state_code": "VA",
                "latitude": "13.57829360",
                "longitude": "-87.57912870"
            },
            {
                "id": 4057,
                "name": "Yoro Department",
                "state_code": "YO",
                "latitude": "15.29496790",
                "longitude": "-87.14228950"
            }
        ]
    },
    {
        "name": "Hong Kong S.A.R.",
        "iso3": "HKG",
        "iso2": "HK",
        "phone_code": "852",
        "capital": "Hong Kong",
        "currency": "HKD",
        "currency_symbol": "$",
        "tld": ".hk",
        "native": "é¦™æ¸¯",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Hong_Kong",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "HKT",
                "tzName": "Hong Kong Time"
            }
        ],
        "translations": {
            "kr": "í™ì½©",
            "br": "Hong Kong",
            "pt": "Hong Kong",
            "nl": "Hongkong",
            "hr": "Hong Kong",
            "fa": "Ù‡Ù†Ú¯â€ŒÚ©Ù†Ú¯",
            "de": "Hong Kong",
            "es": "Hong Kong",
            "fr": "Hong Kong",
            "ja": "é¦™æ¸¯",
            "it": "Hong Kong",
            "cn": "ä¸­å›½é¦™æ¸¯"
        },
        "latitude": "22.25000000",
        "longitude": "114.16666666",
        "emoji": "ðŸ‡­ðŸ‡°",
        "emojiU": "U+1F1ED U+1F1F0",
        "states": [
            {
                "id": 4889,
                "name": "Central and Western District",
                "state_code": "HCW",
                "latitude": "22.28666000",
                "longitude": "114.15497000"
            },
            {
                "id": 4891,
                "name": "Eastern",
                "state_code": "HEA",
                "latitude": "22.28411000",
                "longitude": "114.22414000"
            },
            {
                "id": 4888,
                "name": "Islands District",
                "state_code": "NIS",
                "latitude": "22.26114000",
                "longitude": "113.94608000"
            },
            {
                "id": 4895,
                "name": "Kowloon City",
                "state_code": "KKC",
                "latitude": "22.32820000",
                "longitude": "114.19155000"
            },
            {
                "id": 4898,
                "name": "Kwai Tsing",
                "state_code": "NKT",
                "latitude": "22.35488000",
                "longitude": "114.08401000"
            },
            {
                "id": 4897,
                "name": "Kwun Tong",
                "state_code": "KKT",
                "latitude": "22.31326000",
                "longitude": "114.22581000"
            },
            {
                "id": 4900,
                "name": "North",
                "state_code": "NNO",
                "latitude": "22.49471000",
                "longitude": "114.13812000"
            },
            {
                "id": 4887,
                "name": "Sai Kung District",
                "state_code": "NSK",
                "latitude": "22.38143000",
                "longitude": "114.27052000"
            },
            {
                "id": 4901,
                "name": "Sha Tin",
                "state_code": "NST",
                "latitude": "22.38715000",
                "longitude": "114.19534000"
            },
            {
                "id": 4894,
                "name": "Sham Shui Po",
                "state_code": "KSS",
                "latitude": "22.33074000",
                "longitude": "114.16220000"
            },
            {
                "id": 4892,
                "name": "Southern",
                "state_code": "HSO",
                "latitude": "22.24725000",
                "longitude": "114.15884000"
            },
            {
                "id": 4885,
                "name": "Tai Po District",
                "state_code": "NTP",
                "latitude": "22.45085000",
                "longitude": "114.16422000"
            },
            {
                "id": 4884,
                "name": "Tsuen Wan District",
                "state_code": "NTW",
                "latitude": "22.36281000",
                "longitude": "114.12907000"
            },
            {
                "id": 4899,
                "name": "Tuen Mun",
                "state_code": "NTM",
                "latitude": "22.39163000",
                "longitude": "113.97708850"
            },
            {
                "id": 4890,
                "name": "Wan Chai",
                "state_code": "HWC",
                "latitude": "22.27968000",
                "longitude": "114.17168000"
            },
            {
                "id": 4896,
                "name": "Wong Tai Sin",
                "state_code": "KWT",
                "latitude": "22.33353000",
                "longitude": "114.19686000"
            },
            {
                "id": 4893,
                "name": "Yau Tsim Mong",
                "state_code": "KYT",
                "latitude": "22.32138000",
                "longitude": "114.17260000"
            },
            {
                "id": 4883,
                "name": "Yuen Long District",
                "state_code": "NYL",
                "latitude": "22.44559000",
                "longitude": "114.02218000"
            }
        ]
    },
    {
        "name": "Hungary",
        "iso3": "HUN",
        "iso2": "HU",
        "phone_code": "36",
        "capital": "Budapest",
        "currency": "HUF",
        "currency_symbol": "Ft",
        "tld": ".hu",
        "native": "MagyarorszÃ¡g",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Budapest",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "í—ê°€ë¦¬",
            "br": "Hungria",
            "pt": "Hungria",
            "nl": "Hongarije",
            "hr": "MaÄ‘arska",
            "fa": "Ù…Ø¬Ø§Ø±Ø³ØªØ§Ù†",
            "de": "Ungarn",
            "es": "HungrÃ­a",
            "fr": "Hongrie",
            "ja": "ãƒãƒ³ã‚¬ãƒªãƒ¼",
            "it": "Ungheria",
            "cn": "åŒˆç‰™åˆ©"
        },
        "latitude": "47.00000000",
        "longitude": "20.00000000",
        "emoji": "ðŸ‡­ðŸ‡º",
        "emojiU": "U+1F1ED U+1F1FA",
        "states": [
            {
                "id": 1048,
                "name": "BÃ¡cs-Kiskun County",
                "state_code": "BK",
                "latitude": "46.56614370",
                "longitude": "19.42724640"
            },
            {
                "id": 1055,
                "name": "Baranya County",
                "state_code": "BA",
                "latitude": "46.04845850",
                "longitude": "18.27191730"
            },
            {
                "id": 1060,
                "name": "BÃ©kÃ©s County",
                "state_code": "BE",
                "latitude": "46.67048990",
                "longitude": "21.04349960"
            },
            {
                "id": 1036,
                "name": "BÃ©kÃ©scsaba",
                "state_code": "BC",
                "latitude": "46.67359390",
                "longitude": "21.08773090"
            },
            {
                "id": 1058,
                "name": "Borsod-AbaÃºj-ZemplÃ©n County",
                "state_code": "BZ",
                "latitude": "48.29394010",
                "longitude": "20.69341120"
            },
            {
                "id": 1064,
                "name": "Budapest",
                "state_code": "BU",
                "latitude": "47.49791200",
                "longitude": "19.04023500"
            },
            {
                "id": 1031,
                "name": "CsongrÃ¡d County",
                "state_code": "CS",
                "latitude": "46.41670500",
                "longitude": "20.25661610"
            },
            {
                "id": 1032,
                "name": "Debrecen",
                "state_code": "DE",
                "latitude": "47.53160490",
                "longitude": "21.62731240"
            },
            {
                "id": 1049,
                "name": "DunaÃºjvÃ¡ros",
                "state_code": "DU",
                "latitude": "46.96190590",
                "longitude": "18.93552270"
            },
            {
                "id": 1037,
                "name": "Eger",
                "state_code": "EG",
                "latitude": "47.90253480",
                "longitude": "20.37722840"
            },
            {
                "id": 1028,
                "name": "Ã‰rd",
                "state_code": "ER",
                "latitude": "47.39197180",
                "longitude": "18.90454400"
            },
            {
                "id": 1044,
                "name": "FejÃ©r County",
                "state_code": "FE",
                "latitude": "47.12179320",
                "longitude": "18.52948150"
            },
            {
                "id": 1041,
                "name": "GyÅ‘r",
                "state_code": "GY",
                "latitude": "47.68745690",
                "longitude": "17.65039740"
            },
            {
                "id": 1042,
                "name": "GyÅ‘r-Moson-Sopron County",
                "state_code": "GS",
                "latitude": "47.65092850",
                "longitude": "17.25058830"
            },
            {
                "id": 1063,
                "name": "HajdÃº-Bihar County",
                "state_code": "HB",
                "latitude": "47.46883550",
                "longitude": "21.54532270"
            },
            {
                "id": 1040,
                "name": "Heves County",
                "state_code": "HE",
                "latitude": "47.80576170",
                "longitude": "20.20385590"
            },
            {
                "id": 1027,
                "name": "HÃ³dmezÅ‘vÃ¡sÃ¡rhely",
                "state_code": "HV",
                "latitude": "46.41812620",
                "longitude": "20.33003150"
            },
            {
                "id": 1043,
                "name": "JÃ¡sz-Nagykun-Szolnok County",
                "state_code": "JN",
                "latitude": "47.25555790",
                "longitude": "20.52324560"
            },
            {
                "id": 1067,
                "name": "KaposvÃ¡r",
                "state_code": "KV",
                "latitude": "46.35936060",
                "longitude": "17.79676390"
            },
            {
                "id": 1056,
                "name": "KecskemÃ©t",
                "state_code": "KM",
                "latitude": "46.89637110",
                "longitude": "19.68968610"
            },
            {
                "id": 1065,
                "name": "Miskolc",
                "state_code": "MI",
                "latitude": "48.10347750",
                "longitude": "20.77843840"
            },
            {
                "id": 1030,
                "name": "Nagykanizsa",
                "state_code": "NK",
                "latitude": "46.45902180",
                "longitude": "16.98967960"
            },
            {
                "id": 1051,
                "name": "NÃ³grÃ¡d County",
                "state_code": "NO",
                "latitude": "47.90410310",
                "longitude": "19.04985040"
            },
            {
                "id": 1034,
                "name": "NyÃ­regyhÃ¡za",
                "state_code": "NY",
                "latitude": "47.94953240",
                "longitude": "21.72440530"
            },
            {
                "id": 1053,
                "name": "PÃ©cs",
                "state_code": "PS",
                "latitude": "46.07273450",
                "longitude": "18.23226600"
            },
            {
                "id": 1059,
                "name": "Pest County",
                "state_code": "PE",
                "latitude": "47.44800010",
                "longitude": "19.46181280"
            },
            {
                "id": 1068,
                "name": "SalgÃ³tarjÃ¡n",
                "state_code": "ST",
                "latitude": "48.09352370",
                "longitude": "19.79998130"
            },
            {
                "id": 1035,
                "name": "Somogy County",
                "state_code": "SO",
                "latitude": "46.55485900",
                "longitude": "17.58667320"
            },
            {
                "id": 1057,
                "name": "Sopron",
                "state_code": "SN",
                "latitude": "47.68166190",
                "longitude": "16.58447950"
            },
            {
                "id": 1045,
                "name": "Szabolcs-SzatmÃ¡r-Bereg County",
                "state_code": "SZ",
                "latitude": "48.03949540",
                "longitude": "22.00333000"
            },
            {
                "id": 1029,
                "name": "Szeged",
                "state_code": "SD",
                "latitude": "46.25301020",
                "longitude": "20.14142530"
            },
            {
                "id": 1033,
                "name": "SzÃ©kesfehÃ©rvÃ¡r",
                "state_code": "SF",
                "latitude": "47.18602620",
                "longitude": "18.42213580"
            },
            {
                "id": 1061,
                "name": "SzekszÃ¡rd",
                "state_code": "SS",
                "latitude": "46.34743260",
                "longitude": "18.70622930"
            },
            {
                "id": 1047,
                "name": "Szolnok",
                "state_code": "SK",
                "latitude": "47.16213550",
                "longitude": "20.18247120"
            },
            {
                "id": 1052,
                "name": "Szombathely",
                "state_code": "SH",
                "latitude": "47.23068510",
                "longitude": "16.62184410"
            },
            {
                "id": 1066,
                "name": "TatabÃ¡nya",
                "state_code": "TB",
                "latitude": "47.56924600",
                "longitude": "18.40481800"
            },
            {
                "id": 1038,
                "name": "Tolna County",
                "state_code": "TO",
                "latitude": "46.47627540",
                "longitude": "18.55706270"
            },
            {
                "id": 1039,
                "name": "Vas County",
                "state_code": "VA",
                "latitude": "47.09291110",
                "longitude": "16.68121830"
            },
            {
                "id": 1062,
                "name": "VeszprÃ©m",
                "state_code": "VM",
                "latitude": "47.10280870",
                "longitude": "17.90930190"
            },
            {
                "id": 1054,
                "name": "VeszprÃ©m County",
                "state_code": "VE",
                "latitude": "47.09309740",
                "longitude": "17.91007630"
            },
            {
                "id": 1046,
                "name": "Zala County",
                "state_code": "ZA",
                "latitude": "46.73844040",
                "longitude": "16.91522520"
            },
            {
                "id": 1050,
                "name": "Zalaegerszeg",
                "state_code": "ZE",
                "latitude": "46.84169360",
                "longitude": "16.84163220"
            }
        ]
    },
    {
        "name": "Iceland",
        "iso3": "ISL",
        "iso2": "IS",
        "phone_code": "354",
        "capital": "Reykjavik",
        "currency": "ISK",
        "currency_symbol": "kr",
        "tld": ".is",
        "native": "Ãsland",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Atlantic\/Reykjavik",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì•„ì´ìŠ¬ëž€ë“œ",
            "br": "IslÃ¢ndia",
            "pt": "IslÃ¢ndia",
            "nl": "IJsland",
            "hr": "Island",
            "fa": "Ø§ÛŒØ³Ù„Ù†Ø¯",
            "de": "Island",
            "es": "Islandia",
            "fr": "Islande",
            "ja": "ã‚¢ã‚¤ã‚¹ãƒ©ãƒ³ãƒ‰",
            "it": "Islanda",
            "cn": "å†°å²›"
        },
        "latitude": "65.00000000",
        "longitude": "-18.00000000",
        "emoji": "ðŸ‡®ðŸ‡¸",
        "emojiU": "U+1F1EE U+1F1F8",
        "states": [
            {
                "id": 3431,
                "name": "Capital Region",
                "state_code": "1",
                "latitude": "38.56569570",
                "longitude": "-92.18169490"
            },
            {
                "id": 3433,
                "name": "Eastern Region",
                "state_code": "7",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3437,
                "name": "Northeastern Region",
                "state_code": "6",
                "latitude": "43.29942850",
                "longitude": "-74.21793260"
            },
            {
                "id": 3435,
                "name": "Northwestern Region",
                "state_code": "5",
                "latitude": "41.91339320",
                "longitude": "-73.04716880"
            },
            {
                "id": 3430,
                "name": "Southern Peninsula Region",
                "state_code": "2",
                "latitude": "63.91548030",
                "longitude": "-22.36496670"
            },
            {
                "id": 3434,
                "name": "Southern Region",
                "state_code": "8",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3436,
                "name": "Western Region",
                "state_code": "3",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3432,
                "name": "Westfjords",
                "state_code": "4",
                "latitude": "65.91961500",
                "longitude": "-21.88117640"
            }
        ]
    },
    {
        "name": "India",
        "iso3": "IND",
        "iso2": "IN",
        "phone_code": "91",
        "capital": "New Delhi",
        "currency": "INR",
        "currency_symbol": "â‚¹",
        "tld": ".in",
        "native": "à¤­à¤¾à¤°à¤¤",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Kolkata",
                "gmtOffset": 19800,
                "gmtOffsetName": "UTC+05:30",
                "abbreviation": "IST",
                "tzName": "Indian Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¸ë„",
            "br": "Ãndia",
            "pt": "Ãndia",
            "nl": "India",
            "hr": "Indija",
            "fa": "Ù‡Ù†Ø¯",
            "de": "Indien",
            "es": "India",
            "fr": "Inde",
            "ja": "ã‚¤ãƒ³ãƒ‰",
            "it": "India",
            "cn": "å°åº¦"
        },
        "latitude": "20.00000000",
        "longitude": "77.00000000",
        "emoji": "ðŸ‡®ðŸ‡³",
        "emojiU": "U+1F1EE U+1F1F3",
        "states": [
            {
                "id": 4023,
                "name": "Andaman and Nicobar Islands",
                "state_code": "AN",
                "latitude": "11.74008670",
                "longitude": "92.65864010"
            },
            {
                "id": 4017,
                "name": "Andhra Pradesh",
                "state_code": "AP",
                "latitude": "15.91289980",
                "longitude": "79.73998750"
            },
            {
                "id": 4024,
                "name": "Arunachal Pradesh",
                "state_code": "AR",
                "latitude": "28.21799940",
                "longitude": "94.72775280"
            },
            {
                "id": 4027,
                "name": "Assam",
                "state_code": "AS",
                "latitude": "26.20060430",
                "longitude": "92.93757390"
            },
            {
                "id": 4037,
                "name": "Bihar",
                "state_code": "BR",
                "latitude": "25.09607420",
                "longitude": "85.31311940"
            },
            {
                "id": 4031,
                "name": "Chandigarh",
                "state_code": "CH",
                "latitude": "30.73331480",
                "longitude": "76.77941790"
            },
            {
                "id": 4040,
                "name": "Chhattisgarh",
                "state_code": "CT",
                "latitude": "21.27865670",
                "longitude": "81.86614420"
            },
            {
                "id": 4033,
                "name": "Dadra and Nagar Haveli and Daman and Diu",
                "state_code": "DH",
                "latitude": "20.39737360",
                "longitude": "72.83279910"
            },
            {
                "id": 4021,
                "name": "Delhi",
                "state_code": "DL",
                "latitude": "28.70405920",
                "longitude": "77.10249020"
            },
            {
                "id": 4009,
                "name": "Goa",
                "state_code": "GA",
                "latitude": "15.29932650",
                "longitude": "74.12399600"
            },
            {
                "id": 4030,
                "name": "Gujarat",
                "state_code": "GJ",
                "latitude": "22.25865200",
                "longitude": "71.19238050"
            },
            {
                "id": 4007,
                "name": "Haryana",
                "state_code": "HR",
                "latitude": "29.05877570",
                "longitude": "76.08560100"
            },
            {
                "id": 4020,
                "name": "Himachal Pradesh",
                "state_code": "HP",
                "latitude": "31.10482940",
                "longitude": "77.17339010"
            },
            {
                "id": 4029,
                "name": "Jammu and Kashmir",
                "state_code": "JK",
                "latitude": "33.27783900",
                "longitude": "75.34121790"
            },
            {
                "id": 4025,
                "name": "Jharkhand",
                "state_code": "JH",
                "latitude": "23.61018080",
                "longitude": "85.27993540"
            },
            {
                "id": 4026,
                "name": "Karnataka",
                "state_code": "KA",
                "latitude": "15.31727750",
                "longitude": "75.71388840"
            },
            {
                "id": 4028,
                "name": "Kerala",
                "state_code": "KL",
                "latitude": "10.85051590",
                "longitude": "76.27108330"
            },
            {
                "id": 4852,
                "name": "Ladakh",
                "state_code": "LA",
                "latitude": "34.22684750",
                "longitude": "77.56194190"
            },
            {
                "id": 4019,
                "name": "Lakshadweep",
                "state_code": "LD",
                "latitude": "10.32802650",
                "longitude": "72.78463360"
            },
            {
                "id": 4039,
                "name": "Madhya Pradesh",
                "state_code": "MP",
                "latitude": "22.97342290",
                "longitude": "78.65689420"
            },
            {
                "id": 4008,
                "name": "Maharashtra",
                "state_code": "MH",
                "latitude": "19.75147980",
                "longitude": "75.71388840"
            },
            {
                "id": 4010,
                "name": "Manipur",
                "state_code": "MN",
                "latitude": "24.66371730",
                "longitude": "93.90626880"
            },
            {
                "id": 4006,
                "name": "Meghalaya",
                "state_code": "ML",
                "latitude": "25.46703080",
                "longitude": "91.36621600"
            },
            {
                "id": 4036,
                "name": "Mizoram",
                "state_code": "MZ",
                "latitude": "23.16454300",
                "longitude": "92.93757390"
            },
            {
                "id": 4018,
                "name": "Nagaland",
                "state_code": "NL",
                "latitude": "26.15843540",
                "longitude": "94.56244260"
            },
            {
                "id": 4013,
                "name": "Odisha",
                "state_code": "OR",
                "latitude": "20.95166580",
                "longitude": "85.09852360"
            },
            {
                "id": 4011,
                "name": "Puducherry",
                "state_code": "PY",
                "latitude": "11.94159150",
                "longitude": "79.80831330"
            },
            {
                "id": 4015,
                "name": "Punjab",
                "state_code": "PB",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4014,
                "name": "Rajasthan",
                "state_code": "RJ",
                "latitude": "27.02380360",
                "longitude": "74.21793260"
            },
            {
                "id": 4034,
                "name": "Sikkim",
                "state_code": "SK",
                "latitude": "27.53297180",
                "longitude": "88.51221780"
            },
            {
                "id": 4035,
                "name": "Tamil Nadu",
                "state_code": "TN",
                "latitude": "11.12712250",
                "longitude": "78.65689420"
            },
            {
                "id": 4012,
                "name": "Telangana",
                "state_code": "TG",
                "latitude": "18.11243720",
                "longitude": "79.01929970"
            },
            {
                "id": 4038,
                "name": "Tripura",
                "state_code": "TR",
                "latitude": "23.94084820",
                "longitude": "91.98815270"
            },
            {
                "id": 4022,
                "name": "Uttar Pradesh",
                "state_code": "UP",
                "latitude": "26.84670880",
                "longitude": "80.94615920"
            },
            {
                "id": 4016,
                "name": "Uttarakhand",
                "state_code": "UT",
                "latitude": "30.06675300",
                "longitude": "79.01929970"
            },
            {
                "id": 4853,
                "name": "West Bengal",
                "state_code": "WB",
                "latitude": "22.98675690",
                "longitude": "87.85497550"
            }
        ]
    },
    {
        "name": "Indonesia",
        "iso3": "IDN",
        "iso2": "ID",
        "phone_code": "62",
        "capital": "Jakarta",
        "currency": "IDR",
        "currency_symbol": "Rp",
        "tld": ".id",
        "native": "Indonesia",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Jakarta",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "WIB",
                "tzName": "Western Indonesian Time"
            },
            {
                "zoneName": "Asia\/Jayapura",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "WIT",
                "tzName": "Eastern Indonesian Time"
            },
            {
                "zoneName": "Asia\/Makassar",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "WITA",
                "tzName": "Central Indonesia Time"
            },
            {
                "zoneName": "Asia\/Pontianak",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "WIB",
                "tzName": "Western Indonesian Time"
            }
        ],
        "translations": {
            "kr": "ì¸ë„ë„¤ì‹œì•„",
            "br": "IndonÃ©sia",
            "pt": "IndonÃ©sia",
            "nl": "IndonesiÃ«",
            "hr": "Indonezija",
            "fa": "Ø§Ù†Ø¯ÙˆÙ†Ø²ÛŒ",
            "de": "Indonesien",
            "es": "Indonesia",
            "fr": "IndonÃ©sie",
            "ja": "ã‚¤ãƒ³ãƒ‰ãƒã‚·ã‚¢",
            "it": "Indonesia",
            "cn": "å°åº¦å°¼è¥¿äºš"
        },
        "latitude": "-5.00000000",
        "longitude": "120.00000000",
        "emoji": "ðŸ‡®ðŸ‡©",
        "emojiU": "U+1F1EE U+1F1E9",
        "states": [
            {
                "id": 1822,
                "name": "Aceh",
                "state_code": "AC",
                "latitude": "4.69513500",
                "longitude": "96.74939930"
            },
            {
                "id": 1826,
                "name": "Bali",
                "state_code": "BA",
                "latitude": "-8.34053890",
                "longitude": "115.09195090"
            },
            {
                "id": 1820,
                "name": "Bangka Belitung Islands",
                "state_code": "BB",
                "latitude": "-2.74105130",
                "longitude": "106.44058720"
            },
            {
                "id": 1810,
                "name": "Banten",
                "state_code": "BT",
                "latitude": "-6.40581720",
                "longitude": "106.06401790"
            },
            {
                "id": 1793,
                "name": "Bengkulu",
                "state_code": "BE",
                "latitude": "-3.79284510",
                "longitude": "102.26076410"
            },
            {
                "id": 1802,
                "name": "Central Java",
                "state_code": "JT",
                "latitude": "-7.15097500",
                "longitude": "110.14025940"
            },
            {
                "id": 1794,
                "name": "Central Kalimantan",
                "state_code": "KT",
                "latitude": "-1.68148780",
                "longitude": "113.38235450"
            },
            {
                "id": 1813,
                "name": "Central Sulawesi",
                "state_code": "ST",
                "latitude": "-1.43002540",
                "longitude": "121.44561790"
            },
            {
                "id": 1827,
                "name": "East Java",
                "state_code": "JI",
                "latitude": "-7.53606390",
                "longitude": "112.23840170"
            },
            {
                "id": 1804,
                "name": "East Kalimantan",
                "state_code": "KI",
                "latitude": "0.53865860",
                "longitude": "116.41938900"
            },
            {
                "id": 1818,
                "name": "East Nusa Tenggara",
                "state_code": "NT",
                "latitude": "-8.65738190",
                "longitude": "121.07937050"
            },
            {
                "id": 1812,
                "name": "Gorontalo",
                "state_code": "GO",
                "latitude": "0.54354420",
                "longitude": "123.05676930"
            },
            {
                "id": 1805,
                "name": "Jakarta",
                "state_code": "JK",
                "latitude": "-6.20876340",
                "longitude": "106.84559900"
            },
            {
                "id": 1815,
                "name": "Jambi",
                "state_code": "JA",
                "latitude": "-1.61012290",
                "longitude": "103.61312030"
            },
            {
                "id": 1806,
                "name": "Kalimantan",
                "state_code": "KA",
                "latitude": "0.96188340",
                "longitude": "114.55484950"
            },
            {
                "id": 1811,
                "name": "Lampung",
                "state_code": "LA",
                "latitude": "-4.55858490",
                "longitude": "105.40680790"
            },
            {
                "id": 1821,
                "name": "Lesser Sunda Islands",
                "state_code": "NU",
                "latitude": "-9.00000000",
                "longitude": "120.00000000"
            },
            {
                "id": 1800,
                "name": "Maluku",
                "state_code": "MA",
                "latitude": "-3.23846160",
                "longitude": "130.14527340"
            },
            {
                "id": 1823,
                "name": "Maluku Islands",
                "state_code": "ML",
                "latitude": "-2.86461660",
                "longitude": "129.57659740"
            },
            {
                "id": 1824,
                "name": "North Kalimantan",
                "state_code": "KU",
                "latitude": "3.07309290",
                "longitude": "116.04138890"
            },
            {
                "id": 1801,
                "name": "North Maluku",
                "state_code": "MU",
                "latitude": "1.57099930",
                "longitude": "127.80876930"
            },
            {
                "id": 1808,
                "name": "North Sulawesi",
                "state_code": "SA",
                "latitude": "0.62469320",
                "longitude": "123.97500180"
            },
            {
                "id": 1792,
                "name": "North Sumatra",
                "state_code": "SU",
                "latitude": "2.11535470",
                "longitude": "99.54509740"
            },
            {
                "id": 1798,
                "name": "Papua",
                "state_code": "PA",
                "latitude": "-5.01222020",
                "longitude": "141.34701590"
            },
            {
                "id": 1809,
                "name": "Riau",
                "state_code": "RI",
                "latitude": "0.29334690",
                "longitude": "101.70682940"
            },
            {
                "id": 1807,
                "name": "Riau Islands",
                "state_code": "KR",
                "latitude": "3.94565140",
                "longitude": "108.14286690"
            },
            {
                "id": 1819,
                "name": "South Kalimantan",
                "state_code": "KS",
                "latitude": "-3.09264150",
                "longitude": "115.28375850"
            },
            {
                "id": 1795,
                "name": "South Sulawesi",
                "state_code": "SN",
                "latitude": "-3.66879940",
                "longitude": "119.97405340"
            },
            {
                "id": 1816,
                "name": "South Sumatra",
                "state_code": "SS",
                "latitude": "-3.31943740",
                "longitude": "103.91439900"
            },
            {
                "id": 1796,
                "name": "Southeast Sulawesi",
                "state_code": "SG",
                "latitude": "-4.14491000",
                "longitude": "122.17460500"
            },
            {
                "id": 1829,
                "name": "Special Region of Yogyakarta",
                "state_code": "YO",
                "latitude": "-7.87538490",
                "longitude": "110.42620880"
            },
            {
                "id": 1803,
                "name": "Sulawesi",
                "state_code": "SL",
                "latitude": "-1.84790000",
                "longitude": "120.52790000"
            },
            {
                "id": 1797,
                "name": "Sumatra",
                "state_code": "SM",
                "latitude": "-0.58972400",
                "longitude": "101.34310580"
            },
            {
                "id": 1825,
                "name": "West Java",
                "state_code": "JB",
                "latitude": "-7.09091100",
                "longitude": "107.66888700"
            },
            {
                "id": 1814,
                "name": "West Nusa Tenggara",
                "state_code": "NB",
                "latitude": "-8.65293340",
                "longitude": "117.36164760"
            },
            {
                "id": 1799,
                "name": "West Papua",
                "state_code": "PB",
                "latitude": "-1.33611540",
                "longitude": "133.17471620"
            },
            {
                "id": 1817,
                "name": "West Sulawesi",
                "state_code": "SR",
                "latitude": "-2.84413710",
                "longitude": "119.23207840"
            },
            {
                "id": 1828,
                "name": "West Sumatra",
                "state_code": "SB",
                "latitude": "-0.73993970",
                "longitude": "100.80000510"
            }
        ]
    },
    {
        "name": "Iran",
        "iso3": "IRN",
        "iso2": "IR",
        "phone_code": "98",
        "capital": "Tehran",
        "currency": "IRR",
        "currency_symbol": "ï·¼",
        "tld": ".ir",
        "native": "Ø§ÛŒØ±Ø§Ù†",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Tehran",
                "gmtOffset": 12600,
                "gmtOffsetName": "UTC+03:30",
                "abbreviation": "IRDT",
                "tzName": "Iran Daylight Time"
            }
        ],
        "translations": {
            "kr": "ì´ëž€",
            "br": "IrÃ£",
            "pt": "IrÃ£o",
            "nl": "Iran",
            "hr": "Iran",
            "fa": "Ø§ÛŒØ±Ø§Ù†",
            "de": "Iran",
            "es": "Iran",
            "fr": "Iran",
            "ja": "ã‚¤ãƒ©ãƒ³ãƒ»ã‚¤ã‚¹ãƒ©ãƒ å…±å’Œå›½",
            "cn": "ä¼Šæœ—"
        },
        "latitude": "32.00000000",
        "longitude": "53.00000000",
        "emoji": "ðŸ‡®ðŸ‡·",
        "emojiU": "U+1F1EE U+1F1F7",
        "states": [
            {
                "id": 3929,
                "name": "Alborz Province",
                "state_code": "30",
                "latitude": "35.99604670",
                "longitude": "50.92892460"
            },
            {
                "id": 3934,
                "name": "Ardabil Province",
                "state_code": "24",
                "latitude": "38.48532760",
                "longitude": "47.89112090"
            },
            {
                "id": 3932,
                "name": "Bushehr Province",
                "state_code": "18",
                "latitude": "28.76207390",
                "longitude": "51.51500770"
            },
            {
                "id": 3921,
                "name": "Chaharmahal and Bakhtiari Province",
                "state_code": "14",
                "latitude": "31.99704190",
                "longitude": "50.66138490"
            },
            {
                "id": 3944,
                "name": "East Azerbaijan Province",
                "state_code": "03",
                "latitude": "37.90357330",
                "longitude": "46.26821090"
            },
            {
                "id": 3939,
                "name": "Fars Province",
                "state_code": "07",
                "latitude": "29.10438130",
                "longitude": "53.04589300"
            },
            {
                "id": 3920,
                "name": "Gilan Province",
                "state_code": "01",
                "latitude": "37.28094550",
                "longitude": "49.59241340"
            },
            {
                "id": 3933,
                "name": "Golestan Province",
                "state_code": "27",
                "latitude": "37.28981230",
                "longitude": "55.13758340"
            },
            {
                "id": 4920,
                "name": "Hamadan Province",
                "state_code": "13",
                "latitude": "34.91936070",
                "longitude": "47.48329250"
            },
            {
                "id": 3937,
                "name": "Hormozgan Province",
                "state_code": "22",
                "latitude": "27.13872300",
                "longitude": "55.13758340"
            },
            {
                "id": 3918,
                "name": "Ilam Province",
                "state_code": "16",
                "latitude": "33.29576180",
                "longitude": "46.67053400"
            },
            {
                "id": 3923,
                "name": "Isfahan Province",
                "state_code": "10",
                "latitude": "33.27710730",
                "longitude": "52.36133780"
            },
            {
                "id": 3943,
                "name": "Kerman Province",
                "state_code": "08",
                "latitude": "29.48500890",
                "longitude": "57.64390480"
            },
            {
                "id": 3919,
                "name": "Kermanshah Province",
                "state_code": "05",
                "latitude": "34.45762330",
                "longitude": "46.67053400"
            },
            {
                "id": 3917,
                "name": "Khuzestan Province",
                "state_code": "06",
                "latitude": "31.43601490",
                "longitude": "49.04131200"
            },
            {
                "id": 3926,
                "name": "Kohgiluyeh and Boyer-Ahmad Province",
                "state_code": "17",
                "latitude": "30.72458600",
                "longitude": "50.84563230"
            },
            {
                "id": 3935,
                "name": "Kurdistan Province",
                "state_code": "12",
                "latitude": "35.95535790",
                "longitude": "47.13621250"
            },
            {
                "id": 3928,
                "name": "Lorestan Province",
                "state_code": "15",
                "latitude": "33.58183940",
                "longitude": "48.39881860"
            },
            {
                "id": 3916,
                "name": "Markazi Province",
                "state_code": "00",
                "latitude": "34.61230500",
                "longitude": "49.85472660"
            },
            {
                "id": 3938,
                "name": "Mazandaran Province",
                "state_code": "02",
                "latitude": "36.22623930",
                "longitude": "52.53186040"
            },
            {
                "id": 3942,
                "name": "North Khorasan Province",
                "state_code": "28",
                "latitude": "37.47103530",
                "longitude": "57.10131880"
            },
            {
                "id": 3941,
                "name": "Qazvin Province",
                "state_code": "26",
                "latitude": "36.08813170",
                "longitude": "49.85472660"
            },
            {
                "id": 3922,
                "name": "Qom Province",
                "state_code": "25",
                "latitude": "34.64157640",
                "longitude": "50.87460350"
            },
            {
                "id": 3927,
                "name": "Razavi Khorasan Province",
                "state_code": "09",
                "latitude": "35.10202530",
                "longitude": "59.10417580"
            },
            {
                "id": 3940,
                "name": "Semnan Province",
                "state_code": "20",
                "latitude": "35.22555850",
                "longitude": "54.43421380"
            },
            {
                "id": 3931,
                "name": "Sistan and Baluchestan",
                "state_code": "11",
                "latitude": "27.52999060",
                "longitude": "60.58206760"
            },
            {
                "id": 3930,
                "name": "South Khorasan Province",
                "state_code": "29",
                "latitude": "32.51756430",
                "longitude": "59.10417580"
            },
            {
                "id": 3945,
                "name": "Tehran Province",
                "state_code": "23",
                "latitude": "35.72484160",
                "longitude": "51.38165300"
            },
            {
                "id": 3924,
                "name": "West Azarbaijan Province",
                "state_code": "04",
                "latitude": "37.45500620",
                "longitude": "45.00000000"
            },
            {
                "id": 3936,
                "name": "Yazd Province",
                "state_code": "21",
                "latitude": "32.10063870",
                "longitude": "54.43421380"
            },
            {
                "id": 3925,
                "name": "Zanjan Province",
                "state_code": "19",
                "latitude": "36.50181850",
                "longitude": "48.39881860"
            }
        ]
    },
    {
        "name": "Iraq",
        "iso3": "IRQ",
        "iso2": "IQ",
        "phone_code": "964",
        "capital": "Baghdad",
        "currency": "IQD",
        "currency_symbol": "Ø¯.Ø¹",
        "tld": ".iq",
        "native": "Ø§Ù„Ø¹Ø±Ø§Ù‚",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Baghdad",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì´ë¼í¬",
            "br": "Iraque",
            "pt": "Iraque",
            "nl": "Irak",
            "hr": "Irak",
            "fa": "Ø¹Ø±Ø§Ù‚",
            "de": "Irak",
            "es": "Irak",
            "fr": "Irak",
            "ja": "ã‚¤ãƒ©ã‚¯",
            "it": "Iraq",
            "cn": "ä¼Šæ‹‰å…‹"
        },
        "latitude": "33.00000000",
        "longitude": "44.00000000",
        "emoji": "ðŸ‡®ðŸ‡¶",
        "emojiU": "U+1F1EE U+1F1F6",
        "states": [
            {
                "id": 3964,
                "name": "Al Anbar Governorate",
                "state_code": "AN",
                "latitude": "32.55976140",
                "longitude": "41.91964710"
            },
            {
                "id": 3958,
                "name": "Al Muthanna Governorate",
                "state_code": "MU",
                "latitude": "29.91331710",
                "longitude": "45.29938620"
            },
            {
                "id": 3956,
                "name": "Al-QÄdisiyyah Governorate",
                "state_code": "QA",
                "latitude": "32.04369100",
                "longitude": "45.14945050"
            },
            {
                "id": 3955,
                "name": "Babylon Governorate",
                "state_code": "BB",
                "latitude": "32.46819100",
                "longitude": "44.55019350"
            },
            {
                "id": 3959,
                "name": "Baghdad Governorate",
                "state_code": "BG",
                "latitude": "33.31526180",
                "longitude": "44.36606530"
            },
            {
                "id": 3960,
                "name": "Basra Governorate",
                "state_code": "BA",
                "latitude": "30.51142520",
                "longitude": "47.82962530"
            },
            {
                "id": 3954,
                "name": "Dhi Qar Governorate",
                "state_code": "DQ",
                "latitude": "31.10422920",
                "longitude": "46.36246860"
            },
            {
                "id": 3965,
                "name": "Diyala Governorate",
                "state_code": "DI",
                "latitude": "33.77334870",
                "longitude": "45.14945050"
            },
            {
                "id": 3967,
                "name": "Dohuk Governorate",
                "state_code": "DA",
                "latitude": "36.90772520",
                "longitude": "43.06316890"
            },
            {
                "id": 3968,
                "name": "Erbil Governorate",
                "state_code": "AR",
                "latitude": "36.55706280",
                "longitude": "44.38512630"
            },
            {
                "id": 3957,
                "name": "Karbala Governorate",
                "state_code": "KA",
                "latitude": "32.40454930",
                "longitude": "43.86732220"
            },
            {
                "id": 3971,
                "name": "Kirkuk Governorate",
                "state_code": "KI",
                "latitude": "35.32920140",
                "longitude": "43.94367880"
            },
            {
                "id": 3966,
                "name": "Maysan Governorate",
                "state_code": "MA",
                "latitude": "31.87340020",
                "longitude": "47.13621250"
            },
            {
                "id": 3962,
                "name": "Najaf Governorate",
                "state_code": "NA",
                "latitude": "31.35174860",
                "longitude": "44.09603110"
            },
            {
                "id": 3963,
                "name": "Nineveh Governorate",
                "state_code": "NI",
                "latitude": "36.22957400",
                "longitude": "42.23624350"
            },
            {
                "id": 3961,
                "name": "Saladin Governorate",
                "state_code": "SD",
                "latitude": "34.53375270",
                "longitude": "43.48373800"
            },
            {
                "id": 3969,
                "name": "Sulaymaniyah Governorate",
                "state_code": "SU",
                "latitude": "35.54663480",
                "longitude": "45.30036830"
            },
            {
                "id": 3970,
                "name": "Wasit Governorate",
                "state_code": "WA",
                "latitude": "32.60240940",
                "longitude": "45.75209850"
            }
        ]
    },
    {
        "name": "Ireland",
        "iso3": "IRL",
        "iso2": "IE",
        "phone_code": "353",
        "capital": "Dublin",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".ie",
        "native": "Ã‰ire",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Dublin",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì•„ì¼ëžœë“œ",
            "br": "Irlanda",
            "pt": "Irlanda",
            "nl": "Ierland",
            "hr": "Irska",
            "fa": "Ø§ÛŒØ±Ù„Ù†Ø¯",
            "de": "Irland",
            "es": "Irlanda",
            "fr": "Irlande",
            "ja": "ã‚¢ã‚¤ãƒ«ãƒ©ãƒ³ãƒ‰",
            "it": "Irlanda",
            "cn": "çˆ±å°”å…°"
        },
        "latitude": "53.00000000",
        "longitude": "-8.00000000",
        "emoji": "ðŸ‡®ðŸ‡ª",
        "emojiU": "U+1F1EE U+1F1EA",
        "states": [
            {
                "id": 1087,
                "name": "Connacht",
                "state_code": "C",
                "latitude": "53.83762430",
                "longitude": "-8.95844810"
            },
            {
                "id": 1095,
                "name": "County Carlow",
                "state_code": "CW",
                "latitude": "52.72322170",
                "longitude": "-6.81082950"
            },
            {
                "id": 1088,
                "name": "County Cavan",
                "state_code": "CN",
                "latitude": "53.97654240",
                "longitude": "-7.29966230"
            },
            {
                "id": 1091,
                "name": "County Clare",
                "state_code": "CE",
                "latitude": "43.04664000",
                "longitude": "-87.89958100"
            },
            {
                "id": 1074,
                "name": "County Cork",
                "state_code": "CO",
                "latitude": "51.89851430",
                "longitude": "-8.47560350"
            },
            {
                "id": 1071,
                "name": "County Donegal",
                "state_code": "DL",
                "latitude": "54.65489930",
                "longitude": "-8.10409670"
            },
            {
                "id": 1072,
                "name": "County Dublin",
                "state_code": "D",
                "latitude": "53.34980530",
                "longitude": "-6.26030970"
            },
            {
                "id": 1079,
                "name": "County Galway",
                "state_code": "G",
                "latitude": "53.35645090",
                "longitude": "-8.85341130"
            },
            {
                "id": 1077,
                "name": "County Kerry",
                "state_code": "KY",
                "latitude": "52.15446070",
                "longitude": "-9.56686330"
            },
            {
                "id": 1082,
                "name": "County Kildare",
                "state_code": "KE",
                "latitude": "53.21204340",
                "longitude": "-6.81947080"
            },
            {
                "id": 1090,
                "name": "County Kilkenny",
                "state_code": "KK",
                "latitude": "52.57769570",
                "longitude": "-7.21800200"
            },
            {
                "id": 1096,
                "name": "County Laois",
                "state_code": "LS",
                "latitude": "52.99429500",
                "longitude": "-7.33230070"
            },
            {
                "id": 1094,
                "name": "County Limerick",
                "state_code": "LK",
                "latitude": "52.50905170",
                "longitude": "-8.74749550"
            },
            {
                "id": 1076,
                "name": "County Longford",
                "state_code": "LD",
                "latitude": "53.72749820",
                "longitude": "-7.79315270"
            },
            {
                "id": 1083,
                "name": "County Louth",
                "state_code": "LH",
                "latitude": "53.92523240",
                "longitude": "-6.48894230"
            },
            {
                "id": 1084,
                "name": "County Mayo",
                "state_code": "MO",
                "latitude": "54.01526040",
                "longitude": "-9.42893690"
            },
            {
                "id": 1092,
                "name": "County Meath",
                "state_code": "MH",
                "latitude": "53.60554800",
                "longitude": "-6.65641690"
            },
            {
                "id": 1075,
                "name": "County Monaghan",
                "state_code": "MN",
                "latitude": "54.24920460",
                "longitude": "-6.96831320"
            },
            {
                "id": 1078,
                "name": "County Offaly",
                "state_code": "OY",
                "latitude": "53.23568710",
                "longitude": "-7.71222290"
            },
            {
                "id": 1081,
                "name": "County Roscommon",
                "state_code": "RN",
                "latitude": "53.75926040",
                "longitude": "-8.26816210"
            },
            {
                "id": 1070,
                "name": "County Sligo",
                "state_code": "SO",
                "latitude": "54.15532770",
                "longitude": "-8.60645320"
            },
            {
                "id": 1069,
                "name": "County Tipperary",
                "state_code": "TA",
                "latitude": "52.47378940",
                "longitude": "-8.16185140"
            },
            {
                "id": 1089,
                "name": "County Waterford",
                "state_code": "WD",
                "latitude": "52.19435490",
                "longitude": "-7.62275120"
            },
            {
                "id": 1097,
                "name": "County Westmeath",
                "state_code": "WH",
                "latitude": "53.53453080",
                "longitude": "-7.46532170"
            },
            {
                "id": 1093,
                "name": "County Wexford",
                "state_code": "WX",
                "latitude": "52.47936030",
                "longitude": "-6.58399130"
            },
            {
                "id": 1085,
                "name": "County Wicklow",
                "state_code": "WW",
                "latitude": "52.98623130",
                "longitude": "-6.36725430"
            },
            {
                "id": 1073,
                "name": "Leinster",
                "state_code": "L",
                "latitude": "53.32715380",
                "longitude": "-7.51408410"
            },
            {
                "id": 1080,
                "name": "Munster",
                "state_code": "M",
                "latitude": "51.94711970",
                "longitude": "7.58453200"
            },
            {
                "id": 1086,
                "name": "Ulster",
                "state_code": "U",
                "latitude": "54.76165550",
                "longitude": "-6.96122730"
            }
        ]
    },
    {
        "name": "Israel",
        "iso3": "ISR",
        "iso2": "IL",
        "phone_code": "972",
        "capital": "Jerusalem",
        "currency": "ILS",
        "currency_symbol": "â‚ª",
        "tld": ".il",
        "native": "×™Ö´×©Ö°×‚×¨Ö¸×Öµ×œ",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Jerusalem",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "IST",
                "tzName": "Israel Standard Time"
            }
        ],
        "translations": {
            "kr": "ì´ìŠ¤ë¼ì—˜",
            "br": "Israel",
            "pt": "Israel",
            "nl": "IsraÃ«l",
            "hr": "Izrael",
            "fa": "Ø§Ø³Ø±Ø§Ø¦ÛŒÙ„",
            "de": "Israel",
            "es": "Israel",
            "fr": "IsraÃ«l",
            "ja": "ã‚¤ã‚¹ãƒ©ã‚¨ãƒ«",
            "it": "Israele",
            "cn": "ä»¥è‰²åˆ—"
        },
        "latitude": "31.50000000",
        "longitude": "34.75000000",
        "emoji": "ðŸ‡®ðŸ‡±",
        "emojiU": "U+1F1EE U+1F1F1",
        "states": [
            {
                "id": 1367,
                "name": "Central District",
                "state_code": "M",
                "latitude": "47.60875830",
                "longitude": "-122.29642350"
            },
            {
                "id": 1369,
                "name": "Haifa District",
                "state_code": "HA",
                "latitude": "32.48141110",
                "longitude": "34.99475100"
            },
            {
                "id": 1370,
                "name": "Jerusalem District",
                "state_code": "JM",
                "latitude": "31.76482430",
                "longitude": "34.99475100"
            },
            {
                "id": 1366,
                "name": "Northern District",
                "state_code": "Z",
                "latitude": "36.15118640",
                "longitude": "-95.99517630"
            },
            {
                "id": 1368,
                "name": "Southern District",
                "state_code": "D",
                "latitude": "40.71375860",
                "longitude": "-74.00090590"
            },
            {
                "id": 1371,
                "name": "Tel Aviv District",
                "state_code": "TA",
                "latitude": "32.09290750",
                "longitude": "34.80721650"
            }
        ]
    },
    {
        "name": "Italy",
        "iso3": "ITA",
        "iso2": "IT",
        "phone_code": "39",
        "capital": "Rome",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".it",
        "native": "Italia",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Rome",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì´íƒˆë¦¬ì•„",
            "br": "ItÃ¡lia",
            "pt": "ItÃ¡lia",
            "nl": "ItaliÃ«",
            "hr": "Italija",
            "fa": "Ø§ÛŒØªØ§Ù„ÛŒØ§",
            "de": "Italien",
            "es": "Italia",
            "fr": "Italie",
            "ja": "ã‚¤ã‚¿ãƒªã‚¢",
            "it": "Italia",
            "cn": "æ„å¤§åˆ©"
        },
        "latitude": "42.83333333",
        "longitude": "12.83333333",
        "emoji": "ðŸ‡®ðŸ‡¹",
        "emojiU": "U+1F1EE U+1F1F9",
        "states": [
            {
                "id": 1679,
                "name": "Abruzzo",
                "state_code": "65",
                "latitude": "42.19201190",
                "longitude": "13.72891670"
            },
            {
                "id": 1716,
                "name": "Aosta Valley",
                "state_code": "23",
                "latitude": "45.73888780",
                "longitude": "7.42618660"
            },
            {
                "id": 1688,
                "name": "Apulia",
                "state_code": "75",
                "latitude": "40.79283930",
                "longitude": "17.10119310"
            },
            {
                "id": 1706,
                "name": "Basilicata",
                "state_code": "77",
                "latitude": "40.64307660",
                "longitude": "15.96998780"
            },
            {
                "id": 1701,
                "name": "Benevento Province",
                "state_code": "BN",
                "latitude": "41.20350930",
                "longitude": "14.75209390"
            },
            {
                "id": 1703,
                "name": "Calabria",
                "state_code": "78",
                "latitude": "39.30877140",
                "longitude": "16.34637910"
            },
            {
                "id": 1669,
                "name": "Campania",
                "state_code": "72",
                "latitude": "40.66708870",
                "longitude": "15.10681130"
            },
            {
                "id": 1773,
                "name": "Emilia-Romagna",
                "state_code": "45",
                "latitude": "44.59676070",
                "longitude": "11.21863960"
            },
            {
                "id": 1756,
                "name": "Friuliâ€“Venezia Giulia",
                "state_code": "36",
                "latitude": "46.22591770",
                "longitude": "13.10336460"
            },
            {
                "id": 1678,
                "name": "Lazio",
                "state_code": "62",
                "latitude": "45.69916670",
                "longitude": "-73.65583330"
            },
            {
                "id": 1727,
                "name": "Libero consorzio comunale di Agrigento",
                "state_code": "AG",
                "latitude": "37.31052020",
                "longitude": "13.58579780"
            },
            {
                "id": 1718,
                "name": "Libero consorzio comunale di Caltanissetta",
                "state_code": "CL",
                "latitude": "37.48601300",
                "longitude": "14.06149820"
            },
            {
                "id": 1723,
                "name": "Libero consorzio comunale di Enna",
                "state_code": "EN",
                "latitude": "37.56762160",
                "longitude": "14.27953490"
            },
            {
                "id": 1729,
                "name": "Libero consorzio comunale di Ragusa",
                "state_code": "RG",
                "latitude": "36.92692730",
                "longitude": "14.72551290"
            },
            {
                "id": 1667,
                "name": "Libero consorzio comunale di Siracusa",
                "state_code": "SR",
                "latitude": "37.06569240",
                "longitude": "15.28571090"
            },
            {
                "id": 1733,
                "name": "Libero consorzio comunale di Trapani",
                "state_code": "TP",
                "latitude": "38.01831160",
                "longitude": "12.51482650"
            },
            {
                "id": 1768,
                "name": "Liguria",
                "state_code": "42",
                "latitude": "44.31679170",
                "longitude": "8.39649380"
            },
            {
                "id": 1705,
                "name": "Lombardy",
                "state_code": "25",
                "latitude": "45.47906710",
                "longitude": "9.84524330"
            },
            {
                "id": 1670,
                "name": "Marche",
                "state_code": "57",
                "latitude": "30.55670700",
                "longitude": "-81.44930300"
            },
            {
                "id": 1772,
                "name": "Metropolitan City of Bari",
                "state_code": "BA",
                "latitude": "41.11714320",
                "longitude": "16.87187150"
            },
            {
                "id": 1684,
                "name": "Metropolitan City of Bologna",
                "state_code": "BO",
                "latitude": "44.49488700",
                "longitude": "11.34261620"
            },
            {
                "id": 1682,
                "name": "Metropolitan City of Cagliari",
                "state_code": "CA",
                "latitude": "39.22384110",
                "longitude": "9.12166130"
            },
            {
                "id": 1766,
                "name": "Metropolitan City of Catania",
                "state_code": "CT",
                "latitude": "37.45154380",
                "longitude": "15.05574150"
            },
            {
                "id": 1680,
                "name": "Metropolitan City of Florence",
                "state_code": "FI",
                "latitude": "43.76791780",
                "longitude": "11.25237920"
            },
            {
                "id": 1699,
                "name": "Metropolitan City of Genoa",
                "state_code": "GE",
                "latitude": "44.40564930",
                "longitude": "8.94625640"
            },
            {
                "id": 1770,
                "name": "Metropolitan City of Messina",
                "state_code": "ME",
                "latitude": "38.19373350",
                "longitude": "15.55420570"
            },
            {
                "id": 1698,
                "name": "Metropolitan City of Milan",
                "state_code": "MI",
                "latitude": "45.45862600",
                "longitude": "9.18187300"
            },
            {
                "id": 1724,
                "name": "Metropolitan City of Naples",
                "state_code": "NA",
                "latitude": "40.90197500",
                "longitude": "14.33264400"
            },
            {
                "id": 1668,
                "name": "Metropolitan City of Palermo",
                "state_code": "PA",
                "latitude": "38.11569000",
                "longitude": "13.36148680"
            },
            {
                "id": 1671,
                "name": "Metropolitan City of Reggio Calabria",
                "state_code": "RC",
                "latitude": "38.10843960",
                "longitude": "15.64370480"
            },
            {
                "id": 1711,
                "name": "Metropolitan City of Rome",
                "state_code": "RM",
                "latitude": "41.90270080",
                "longitude": "12.49623520"
            },
            {
                "id": 1710,
                "name": "Metropolitan City of Turin",
                "state_code": "TO",
                "latitude": "45.06329900",
                "longitude": "7.66928900"
            },
            {
                "id": 1673,
                "name": "Metropolitan City of Venice",
                "state_code": "VE",
                "latitude": "45.44146850",
                "longitude": "12.31526720"
            },
            {
                "id": 1695,
                "name": "Molise",
                "state_code": "67",
                "latitude": "41.67388650",
                "longitude": "14.75209390"
            },
            {
                "id": 1693,
                "name": "Pesaro and Urbino Province",
                "state_code": "PU",
                "latitude": "43.61301180",
                "longitude": "12.71351210"
            },
            {
                "id": 1702,
                "name": "Piedmont",
                "state_code": "21",
                "latitude": "45.05223660",
                "longitude": "7.51538850"
            },
            {
                "id": 1783,
                "name": "Province of Alessandria",
                "state_code": "AL",
                "latitude": "44.81755870",
                "longitude": "8.70466270"
            },
            {
                "id": 1672,
                "name": "Province of Ancona",
                "state_code": "AN",
                "latitude": "43.54932450",
                "longitude": "13.26634790"
            },
            {
                "id": 1681,
                "name": "Province of Ascoli Piceno",
                "state_code": "AP",
                "latitude": "42.86389330",
                "longitude": "13.58997330"
            },
            {
                "id": 1780,
                "name": "Province of Asti",
                "state_code": "AT",
                "latitude": "44.90076520",
                "longitude": "8.20643150"
            },
            {
                "id": 1692,
                "name": "Province of Avellino",
                "state_code": "AV",
                "latitude": "40.99645100",
                "longitude": "15.12589550"
            },
            {
                "id": 1686,
                "name": "Province of Barletta-Andria-Trani",
                "state_code": "BT",
                "latitude": "41.20045430",
                "longitude": "16.20514840"
            },
            {
                "id": 1689,
                "name": "Province of Belluno",
                "state_code": "BL",
                "latitude": "46.24976590",
                "longitude": "12.19695650"
            },
            {
                "id": 1704,
                "name": "Province of Bergamo",
                "state_code": "BG",
                "latitude": "45.69826420",
                "longitude": "9.67726980"
            },
            {
                "id": 1778,
                "name": "Province of Biella",
                "state_code": "BI",
                "latitude": "45.56281760",
                "longitude": "8.05827170"
            },
            {
                "id": 1717,
                "name": "Province of Brescia",
                "state_code": "BS",
                "latitude": "45.54155260",
                "longitude": "10.21180190"
            },
            {
                "id": 1714,
                "name": "Province of Brindisi",
                "state_code": "BR",
                "latitude": "40.61126630",
                "longitude": "17.76362100"
            },
            {
                "id": 1721,
                "name": "Province of Campobasso",
                "state_code": "CB",
                "latitude": "41.67388650",
                "longitude": "14.75209390"
            },
            {
                "id": 1730,
                "name": "Province of Carbonia-Iglesias",
                "state_code": "CI",
                "latitude": "39.25346590",
                "longitude": "8.57210160"
            },
            {
                "id": 1731,
                "name": "Province of Caserta",
                "state_code": "CE",
                "latitude": "41.20783540",
                "longitude": "14.10013260"
            },
            {
                "id": 1728,
                "name": "Province of Catanzaro",
                "state_code": "CZ",
                "latitude": "38.88963480",
                "longitude": "16.44058720"
            },
            {
                "id": 1739,
                "name": "Province of Chieti",
                "state_code": "CH",
                "latitude": "42.03344280",
                "longitude": "14.37919120"
            },
            {
                "id": 1740,
                "name": "Province of Como",
                "state_code": "CO",
                "latitude": "45.80804160",
                "longitude": "9.08517930"
            },
            {
                "id": 1742,
                "name": "Province of Cosenza",
                "state_code": "CS",
                "latitude": "39.56441050",
                "longitude": "16.25221430"
            },
            {
                "id": 1751,
                "name": "Province of Cremona",
                "state_code": "CR",
                "latitude": "45.20143750",
                "longitude": "9.98365820"
            },
            {
                "id": 1754,
                "name": "Province of Crotone",
                "state_code": "KR",
                "latitude": "39.13098560",
                "longitude": "17.00670310"
            },
            {
                "id": 1775,
                "name": "Province of Cuneo",
                "state_code": "CN",
                "latitude": "44.59703140",
                "longitude": "7.61142170"
            },
            {
                "id": 1744,
                "name": "Province of Fermo",
                "state_code": "FM",
                "latitude": "43.09313670",
                "longitude": "13.58997330"
            },
            {
                "id": 1746,
                "name": "Province of Ferrara",
                "state_code": "FE",
                "latitude": "44.76636800",
                "longitude": "11.76440680"
            },
            {
                "id": 1771,
                "name": "Province of Foggia",
                "state_code": "FG",
                "latitude": "41.63844800",
                "longitude": "15.59433880"
            },
            {
                "id": 1779,
                "name": "Province of ForlÃ¬-Cesena",
                "state_code": "FC",
                "latitude": "43.99476810",
                "longitude": "11.98046130"
            },
            {
                "id": 1776,
                "name": "Province of Frosinone",
                "state_code": "FR",
                "latitude": "41.65765280",
                "longitude": "13.63627150"
            },
            {
                "id": 1777,
                "name": "Province of Gorizia",
                "state_code": "GO",
                "latitude": "45.90538990",
                "longitude": "13.51637250"
            },
            {
                "id": 1787,
                "name": "Province of Grosseto",
                "state_code": "GR",
                "latitude": "42.85180070",
                "longitude": "11.25237920"
            },
            {
                "id": 1788,
                "name": "Province of Imperia",
                "state_code": "IM",
                "latitude": "43.94186600",
                "longitude": "7.82863680"
            },
            {
                "id": 1789,
                "name": "Province of Isernia",
                "state_code": "IS",
                "latitude": "41.58915550",
                "longitude": "14.19309180"
            },
            {
                "id": 1781,
                "name": "Province of L'Aquila",
                "state_code": "AQ",
                "latitude": "42.12563170",
                "longitude": "13.63627150"
            },
            {
                "id": 1791,
                "name": "Province of La Spezia",
                "state_code": "SP",
                "latitude": "44.24479130",
                "longitude": "9.76786870"
            },
            {
                "id": 1674,
                "name": "Province of Latina",
                "state_code": "LT",
                "latitude": "41.40874760",
                "longitude": "13.08179030"
            },
            {
                "id": 1675,
                "name": "Province of Lecce",
                "state_code": "LE",
                "latitude": "40.23473930",
                "longitude": "18.14286690"
            },
            {
                "id": 1677,
                "name": "Province of Lecco",
                "state_code": "LC",
                "latitude": "45.93829410",
                "longitude": "9.38572900"
            },
            {
                "id": 1745,
                "name": "Province of Livorno",
                "state_code": "LI",
                "latitude": "43.02398480",
                "longitude": "10.66471010"
            },
            {
                "id": 1747,
                "name": "Province of Lodi",
                "state_code": "LO",
                "latitude": "45.24050360",
                "longitude": "9.52925120"
            },
            {
                "id": 1749,
                "name": "Province of Lucca",
                "state_code": "LU",
                "latitude": "43.83767360",
                "longitude": "10.49505300"
            },
            {
                "id": 1750,
                "name": "Province of Macerata",
                "state_code": "MC",
                "latitude": "43.24593220",
                "longitude": "13.26634790"
            },
            {
                "id": 1758,
                "name": "Province of Mantua",
                "state_code": "MN",
                "latitude": "45.16677280",
                "longitude": "10.77536130"
            },
            {
                "id": 1759,
                "name": "Province of Massa and Carrara",
                "state_code": "MS",
                "latitude": "44.22139980",
                "longitude": "10.03596610"
            },
            {
                "id": 1760,
                "name": "Province of Matera",
                "state_code": "MT",
                "latitude": "40.66634960",
                "longitude": "16.60436360"
            },
            {
                "id": 1761,
                "name": "Province of Medio Campidano",
                "state_code": "VS",
                "latitude": "39.53173890",
                "longitude": "8.70407500"
            },
            {
                "id": 1757,
                "name": "Province of Modena",
                "state_code": "MO",
                "latitude": "44.55137990",
                "longitude": "10.91804800"
            },
            {
                "id": 1769,
                "name": "Province of Monza and Brianza",
                "state_code": "MB",
                "latitude": "45.62359900",
                "longitude": "9.25880150"
            },
            {
                "id": 1774,
                "name": "Province of Novara",
                "state_code": "NO",
                "latitude": "45.54851330",
                "longitude": "8.51507930"
            },
            {
                "id": 1790,
                "name": "Province of Nuoro",
                "state_code": "NU",
                "latitude": "40.32869040",
                "longitude": "9.45615500"
            },
            {
                "id": 1782,
                "name": "Province of Ogliastra",
                "state_code": "OG",
                "latitude": "39.84105360",
                "longitude": "9.45615500"
            },
            {
                "id": 1784,
                "name": "Province of Olbia-Tempio",
                "state_code": "OT",
                "latitude": "40.82683830",
                "longitude": "9.27855830"
            },
            {
                "id": 1786,
                "name": "Province of Oristano",
                "state_code": "OR",
                "latitude": "40.05990680",
                "longitude": "8.74811670"
            },
            {
                "id": 1665,
                "name": "Province of Padua",
                "state_code": "PD",
                "latitude": "45.36618640",
                "longitude": "11.82091390"
            },
            {
                "id": 1666,
                "name": "Province of Parma",
                "state_code": "PR",
                "latitude": "44.80153220",
                "longitude": "10.32793540"
            },
            {
                "id": 1676,
                "name": "Province of Pavia",
                "state_code": "PV",
                "latitude": "45.32181660",
                "longitude": "8.84662360"
            },
            {
                "id": 1691,
                "name": "Province of Perugia",
                "state_code": "PG",
                "latitude": "42.93800400",
                "longitude": "12.62162110"
            },
            {
                "id": 1694,
                "name": "Province of Pescara",
                "state_code": "PE",
                "latitude": "42.35706550",
                "longitude": "13.96080910"
            },
            {
                "id": 1696,
                "name": "Province of Piacenza",
                "state_code": "PC",
                "latitude": "44.82631120",
                "longitude": "9.52914470"
            },
            {
                "id": 1685,
                "name": "Province of Pisa",
                "state_code": "PI",
                "latitude": "43.72283150",
                "longitude": "10.40171940"
            },
            {
                "id": 1687,
                "name": "Province of Pistoia",
                "state_code": "PT",
                "latitude": "43.95437330",
                "longitude": "10.89030990"
            },
            {
                "id": 1690,
                "name": "Province of Pordenone",
                "state_code": "PN",
                "latitude": "46.03788620",
                "longitude": "12.71083500"
            },
            {
                "id": 1697,
                "name": "Province of Potenza",
                "state_code": "PZ",
                "latitude": "40.41821940",
                "longitude": "15.87600400"
            },
            {
                "id": 1700,
                "name": "Province of Prato",
                "state_code": "PO",
                "latitude": "44.04539000",
                "longitude": "11.11644520"
            },
            {
                "id": 1707,
                "name": "Province of Ravenna",
                "state_code": "RA",
                "latitude": "44.41844430",
                "longitude": "12.20359980"
            },
            {
                "id": 1708,
                "name": "Province of Reggio Emilia",
                "state_code": "RE",
                "latitude": "44.58565800",
                "longitude": "10.55647360"
            },
            {
                "id": 1712,
                "name": "Province of Rieti",
                "state_code": "RI",
                "latitude": "42.36744050",
                "longitude": "12.89750980"
            },
            {
                "id": 1713,
                "name": "Province of Rimini",
                "state_code": "RN",
                "latitude": "44.06782880",
                "longitude": "12.56951580"
            },
            {
                "id": 1719,
                "name": "Province of Rovigo",
                "state_code": "RO",
                "latitude": "45.02418180",
                "longitude": "11.82381620"
            },
            {
                "id": 1720,
                "name": "Province of Salerno",
                "state_code": "SA",
                "latitude": "40.42878320",
                "longitude": "15.21948080"
            },
            {
                "id": 1722,
                "name": "Province of Sassari",
                "state_code": "SS",
                "latitude": "40.79679070",
                "longitude": "8.57504070"
            },
            {
                "id": 1732,
                "name": "Province of Savona",
                "state_code": "SV",
                "latitude": "44.28879950",
                "longitude": "8.26505800"
            },
            {
                "id": 1734,
                "name": "Province of Siena",
                "state_code": "SI",
                "latitude": "43.29377320",
                "longitude": "11.43391480"
            },
            {
                "id": 1741,
                "name": "Province of Sondrio",
                "state_code": "SO",
                "latitude": "46.17276360",
                "longitude": "9.79949170"
            },
            {
                "id": 1743,
                "name": "Province of Taranto",
                "state_code": "TA",
                "latitude": "40.57409010",
                "longitude": "17.24299760"
            },
            {
                "id": 1752,
                "name": "Province of Teramo",
                "state_code": "TE",
                "latitude": "42.58956080",
                "longitude": "13.63627150"
            },
            {
                "id": 1755,
                "name": "Province of Terni",
                "state_code": "TR",
                "latitude": "42.56345340",
                "longitude": "12.52980280"
            },
            {
                "id": 1762,
                "name": "Province of Treviso",
                "state_code": "TV",
                "latitude": "45.66685170",
                "longitude": "12.24306170"
            },
            {
                "id": 1763,
                "name": "Province of Trieste",
                "state_code": "TS",
                "latitude": "45.68948230",
                "longitude": "13.78330720"
            },
            {
                "id": 1764,
                "name": "Province of Udine",
                "state_code": "UD",
                "latitude": "46.14079720",
                "longitude": "13.16628960"
            },
            {
                "id": 1765,
                "name": "Province of Varese",
                "state_code": "VA",
                "latitude": "45.79902600",
                "longitude": "8.73009450"
            },
            {
                "id": 1726,
                "name": "Province of Verbano-Cusio-Ossola",
                "state_code": "VB",
                "latitude": "46.13996880",
                "longitude": "8.27246490"
            },
            {
                "id": 1785,
                "name": "Province of Vercelli",
                "state_code": "VC",
                "latitude": "45.32022040",
                "longitude": "8.41850800"
            },
            {
                "id": 1736,
                "name": "Province of Verona",
                "state_code": "VR",
                "latitude": "45.44184980",
                "longitude": "11.07353160"
            },
            {
                "id": 1737,
                "name": "Province of Vibo Valentia",
                "state_code": "VV",
                "latitude": "38.63785650",
                "longitude": "16.20514840"
            },
            {
                "id": 1738,
                "name": "Province of Vicenza",
                "state_code": "VI",
                "latitude": "45.69839950",
                "longitude": "11.56614650"
            },
            {
                "id": 1735,
                "name": "Province of Viterbo",
                "state_code": "VT",
                "latitude": "42.40024200",
                "longitude": "11.88917210"
            },
            {
                "id": 1715,
                "name": "Sardinia",
                "state_code": "88",
                "latitude": "40.12087520",
                "longitude": "9.01289260"
            },
            {
                "id": 1709,
                "name": "Sicily",
                "state_code": "82",
                "latitude": "37.59999380",
                "longitude": "14.01535570"
            },
            {
                "id": 1767,
                "name": "South Tyrol",
                "state_code": "BZ",
                "latitude": "46.49494500",
                "longitude": "11.34026570"
            },
            {
                "id": 1748,
                "name": "Trentino",
                "state_code": "TN",
                "latitude": "46.05120040",
                "longitude": "11.11753920"
            },
            {
                "id": 1725,
                "name": "Trentino-South Tyrol",
                "state_code": "32",
                "latitude": "46.43366620",
                "longitude": "11.16932960"
            },
            {
                "id": 1664,
                "name": "Tuscany",
                "state_code": "52",
                "latitude": "43.77105130",
                "longitude": "11.24862080"
            },
            {
                "id": 1683,
                "name": "Umbria",
                "state_code": "55",
                "latitude": "42.93800400",
                "longitude": "12.62162110"
            },
            {
                "id": 1753,
                "name": "Veneto",
                "state_code": "34",
                "latitude": "45.44146620",
                "longitude": "12.31525950"
            }
        ]
    },
    {
        "name": "Jamaica",
        "iso3": "JAM",
        "iso2": "JM",
        "phone_code": "+1-876",
        "capital": "Kingston",
        "currency": "JMD",
        "currency_symbol": "J$",
        "tld": ".jm",
        "native": "Jamaica",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Jamaica",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ìžë©”ì´ì¹´",
            "br": "Jamaica",
            "pt": "Jamaica",
            "nl": "Jamaica",
            "hr": "Jamajka",
            "fa": "Ø¬Ø§Ù…Ø§Ø¦ÛŒÚ©Ø§",
            "de": "Jamaika",
            "es": "Jamaica",
            "fr": "JamaÃ¯que",
            "ja": "ã‚¸ãƒ£ãƒžã‚¤ã‚«",
            "it": "Giamaica",
            "cn": "ç‰™ä¹°åŠ "
        },
        "latitude": "18.25000000",
        "longitude": "-77.50000000",
        "emoji": "ðŸ‡¯ðŸ‡²",
        "emojiU": "U+1F1EF U+1F1F2",
        "states": [
            {
                "id": 3753,
                "name": "Clarendon Parish",
                "state_code": "13",
                "latitude": "17.95571830",
                "longitude": "-77.24051530"
            },
            {
                "id": 3749,
                "name": "Hanover Parish",
                "state_code": "09",
                "latitude": "18.40977070",
                "longitude": "-78.13363800"
            },
            {
                "id": 3748,
                "name": "Kingston Parish",
                "state_code": "01",
                "latitude": "17.96832710",
                "longitude": "-76.78270200"
            },
            {
                "id": 3754,
                "name": "Manchester Parish",
                "state_code": "12",
                "latitude": "18.06696540",
                "longitude": "-77.51607880"
            },
            {
                "id": 3752,
                "name": "Portland Parish",
                "state_code": "04",
                "latitude": "18.08442740",
                "longitude": "-76.41002670"
            },
            {
                "id": 3751,
                "name": "Saint Andrew",
                "state_code": "02",
                "latitude": "37.22451030",
                "longitude": "-95.70211890"
            },
            {
                "id": 3744,
                "name": "Saint Ann Parish",
                "state_code": "06",
                "latitude": "37.28714520",
                "longitude": "-77.41035330"
            },
            {
                "id": 3746,
                "name": "Saint Catherine Parish",
                "state_code": "14",
                "latitude": "18.03641340",
                "longitude": "-77.05644640"
            },
            {
                "id": 3743,
                "name": "Saint Elizabeth Parish",
                "state_code": "11",
                "latitude": "38.99253080",
                "longitude": "-94.58992000"
            },
            {
                "id": 3745,
                "name": "Saint James Parish",
                "state_code": "08",
                "latitude": "30.01792920",
                "longitude": "-90.79132270"
            },
            {
                "id": 3747,
                "name": "Saint Mary Parish",
                "state_code": "05",
                "latitude": "36.09252200",
                "longitude": "-95.97384400"
            },
            {
                "id": 3750,
                "name": "Saint Thomas Parish",
                "state_code": "03",
                "latitude": "41.44253890",
                "longitude": "-81.74022180"
            },
            {
                "id": 3755,
                "name": "Trelawny Parish",
                "state_code": "07",
                "latitude": "18.35261430",
                "longitude": "-77.60778650"
            },
            {
                "id": 3742,
                "name": "Westmoreland Parish",
                "state_code": "10",
                "latitude": "18.29443780",
                "longitude": "-78.15644320"
            }
        ]
    },
    {
        "name": "Japan",
        "iso3": "JPN",
        "iso2": "JP",
        "phone_code": "81",
        "capital": "Tokyo",
        "currency": "JPY",
        "currency_symbol": "Â¥",
        "tld": ".jp",
        "native": "æ—¥æœ¬",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Tokyo",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "JST",
                "tzName": "Japan Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¼ë³¸",
            "br": "JapÃ£o",
            "pt": "JapÃ£o",
            "nl": "Japan",
            "hr": "Japan",
            "fa": "Ú˜Ø§Ù¾Ù†",
            "de": "Japan",
            "es": "JapÃ³n",
            "fr": "Japon",
            "ja": "æ—¥æœ¬",
            "it": "Giappone",
            "cn": "æ—¥æœ¬"
        },
        "latitude": "36.00000000",
        "longitude": "138.00000000",
        "emoji": "ðŸ‡¯ðŸ‡µ",
        "emojiU": "U+1F1EF U+1F1F5",
        "states": [
            {
                "id": 827,
                "name": "Aichi Prefecture",
                "state_code": "23",
                "latitude": "35.01825050",
                "longitude": "137.29238930"
            },
            {
                "id": 829,
                "name": "Akita Prefecture",
                "state_code": "05",
                "latitude": "40.13762930",
                "longitude": "140.33434100"
            },
            {
                "id": 839,
                "name": "Aomori Prefecture",
                "state_code": "02",
                "latitude": "40.76570770",
                "longitude": "140.91758790"
            },
            {
                "id": 821,
                "name": "Chiba Prefecture",
                "state_code": "12",
                "latitude": "35.33541550",
                "longitude": "140.18325160"
            },
            {
                "id": 865,
                "name": "Ehime Prefecture",
                "state_code": "38",
                "latitude": "33.60253060",
                "longitude": "132.78575830"
            },
            {
                "id": 848,
                "name": "Fukui Prefecture",
                "state_code": "18",
                "latitude": "35.89622700",
                "longitude": "136.21115790"
            },
            {
                "id": 861,
                "name": "Fukuoka Prefecture",
                "state_code": "40",
                "latitude": "33.56625590",
                "longitude": "130.71585700"
            },
            {
                "id": 847,
                "name": "Fukushima Prefecture",
                "state_code": "07",
                "latitude": "37.38343730",
                "longitude": "140.18325160"
            },
            {
                "id": 858,
                "name": "Gifu Prefecture",
                "state_code": "21",
                "latitude": "35.74374910",
                "longitude": "136.98051030"
            },
            {
                "id": 862,
                "name": "Gunma Prefecture",
                "state_code": "10",
                "latitude": "36.56053880",
                "longitude": "138.87999720"
            },
            {
                "id": 828,
                "name": "Hiroshima Prefecture",
                "state_code": "34",
                "latitude": "34.88234080",
                "longitude": "133.01948970"
            },
            {
                "id": 832,
                "name": "HokkaidÅ Prefecture",
                "state_code": "01",
                "latitude": "43.22032660",
                "longitude": "142.86347370"
            },
            {
                "id": 831,
                "name": "HyÅgo Prefecture",
                "state_code": "28",
                "latitude": "34.85795180",
                "longitude": "134.54537870"
            },
            {
                "id": 851,
                "name": "Ibaraki Prefecture",
                "state_code": "08",
                "latitude": "36.21935710",
                "longitude": "140.18325160"
            },
            {
                "id": 830,
                "name": "Ishikawa Prefecture",
                "state_code": "17",
                "latitude": "36.32603170",
                "longitude": "136.52896530"
            },
            {
                "id": 856,
                "name": "Iwate Prefecture",
                "state_code": "03",
                "latitude": "39.58329890",
                "longitude": "141.25345740"
            },
            {
                "id": 864,
                "name": "Kagawa Prefecture",
                "state_code": "37",
                "latitude": "34.22259150",
                "longitude": "134.01991520"
            },
            {
                "id": 840,
                "name": "Kagoshima Prefecture",
                "state_code": "46",
                "latitude": "31.39119580",
                "longitude": "130.87785860"
            },
            {
                "id": 842,
                "name": "Kanagawa Prefecture",
                "state_code": "14",
                "latitude": "35.49135350",
                "longitude": "139.28414300"
            },
            {
                "id": 4924,
                "name": "KÅchi Prefecture",
                "state_code": "39",
                "latitude": "33.28791610",
                "longitude": "132.27592620"
            },
            {
                "id": 846,
                "name": "Kumamoto Prefecture",
                "state_code": "43",
                "latitude": "32.85944270",
                "longitude": "130.79691490"
            },
            {
                "id": 834,
                "name": "KyÅto Prefecture",
                "state_code": "26",
                "latitude": "35.15666090",
                "longitude": "135.52519820"
            },
            {
                "id": 833,
                "name": "Mie Prefecture",
                "state_code": "24",
                "latitude": "33.81439010",
                "longitude": "136.04870470"
            },
            {
                "id": 857,
                "name": "Miyagi Prefecture",
                "state_code": "04",
                "latitude": "38.63061200",
                "longitude": "141.11930480"
            },
            {
                "id": 855,
                "name": "Miyazaki Prefecture",
                "state_code": "45",
                "latitude": "32.60360220",
                "longitude": "131.44125100"
            },
            {
                "id": 843,
                "name": "Nagano Prefecture",
                "state_code": "20",
                "latitude": "36.15439410",
                "longitude": "137.92182040"
            },
            {
                "id": 849,
                "name": "Nagasaki Prefecture",
                "state_code": "42",
                "latitude": "33.24885250",
                "longitude": "129.69309120"
            },
            {
                "id": 824,
                "name": "Nara Prefecture",
                "state_code": "29",
                "latitude": "34.29755280",
                "longitude": "135.82797340"
            },
            {
                "id": 841,
                "name": "Niigata Prefecture",
                "state_code": "15",
                "latitude": "37.51783860",
                "longitude": "138.92697940"
            },
            {
                "id": 822,
                "name": "ÅŒita Prefecture",
                "state_code": "44",
                "latitude": "33.15892990",
                "longitude": "131.36111210"
            },
            {
                "id": 820,
                "name": "Okayama Prefecture",
                "state_code": "33",
                "latitude": "34.89634070",
                "longitude": "133.63753140"
            },
            {
                "id": 853,
                "name": "Okinawa Prefecture",
                "state_code": "47",
                "latitude": "26.12019110",
                "longitude": "127.70250120"
            },
            {
                "id": 859,
                "name": "ÅŒsaka Prefecture",
                "state_code": "27",
                "latitude": "34.64133150",
                "longitude": "135.56293940"
            },
            {
                "id": 863,
                "name": "Saga Prefecture",
                "state_code": "41",
                "latitude": "33.30783710",
                "longitude": "130.22712430"
            },
            {
                "id": 860,
                "name": "Saitama Prefecture",
                "state_code": "11",
                "latitude": "35.99625130",
                "longitude": "139.44660050"
            },
            {
                "id": 845,
                "name": "Shiga Prefecture",
                "state_code": "25",
                "latitude": "35.32920140",
                "longitude": "136.05632120"
            },
            {
                "id": 826,
                "name": "Shimane Prefecture",
                "state_code": "32",
                "latitude": "35.12440940",
                "longitude": "132.62934460"
            },
            {
                "id": 825,
                "name": "Shizuoka Prefecture",
                "state_code": "22",
                "latitude": "35.09293970",
                "longitude": "138.31902760"
            },
            {
                "id": 854,
                "name": "Tochigi Prefecture",
                "state_code": "09",
                "latitude": "36.67147390",
                "longitude": "139.85472660"
            },
            {
                "id": 836,
                "name": "Tokushima Prefecture",
                "state_code": "36",
                "latitude": "33.94196550",
                "longitude": "134.32365570"
            },
            {
                "id": 823,
                "name": "Tokyo",
                "state_code": "13",
                "latitude": "35.67619190",
                "longitude": "139.65031060"
            },
            {
                "id": 850,
                "name": "Tottori Prefecture",
                "state_code": "31",
                "latitude": "35.35731610",
                "longitude": "133.40666180"
            },
            {
                "id": 838,
                "name": "Toyama Prefecture",
                "state_code": "16",
                "latitude": "36.69582660",
                "longitude": "137.21370710"
            },
            {
                "id": 844,
                "name": "Wakayama Prefecture",
                "state_code": "30",
                "latitude": "33.94809140",
                "longitude": "135.37453580"
            },
            {
                "id": 837,
                "name": "Yamagata Prefecture",
                "state_code": "06",
                "latitude": "38.53705640",
                "longitude": "140.14351980"
            },
            {
                "id": 835,
                "name": "Yamaguchi Prefecture",
                "state_code": "35",
                "latitude": "34.27967690",
                "longitude": "131.52127420"
            },
            {
                "id": 852,
                "name": "Yamanashi Prefecture",
                "state_code": "19",
                "latitude": "35.66351130",
                "longitude": "138.63888790"
            }
        ]
    },
    {
        "name": "Jersey",
        "iso3": "JEY",
        "iso2": "JE",
        "phone_code": "+44-1534",
        "capital": "Saint Helier",
        "currency": "GBP",
        "currency_symbol": "Â£",
        "tld": ".je",
        "native": "Jersey",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Jersey",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì €ì§€ ì„¬",
            "br": "Jersey",
            "pt": "Jersey",
            "nl": "Jersey",
            "hr": "Jersey",
            "fa": "Ø¬Ø±Ø²ÛŒ",
            "de": "Jersey",
            "es": "Jersey",
            "fr": "Jersey",
            "ja": "ã‚¸ãƒ£ãƒ¼ã‚¸ãƒ¼",
            "it": "Isola di Jersey",
            "cn": "æ³½è¥¿å²›"
        },
        "latitude": "49.25000000",
        "longitude": "-2.16666666",
        "emoji": "ðŸ‡¯ðŸ‡ª",
        "emojiU": "U+1F1EF U+1F1EA",
        "states": []
    },
    {
        "name": "Jordan",
        "iso3": "JOR",
        "iso2": "JO",
        "phone_code": "962",
        "capital": "Amman",
        "currency": "JOD",
        "currency_symbol": "Ø§.Ø¯",
        "tld": ".jo",
        "native": "Ø§Ù„Ø£Ø±Ø¯Ù†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Amman",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ìš”ë¥´ë‹¨",
            "br": "JordÃ¢nia",
            "pt": "JordÃ¢nia",
            "nl": "JordaniÃ«",
            "hr": "Jordan",
            "fa": "Ø§Ø±Ø¯Ù†",
            "de": "Jordanien",
            "es": "Jordania",
            "fr": "Jordanie",
            "ja": "ãƒ¨ãƒ«ãƒ€ãƒ³",
            "it": "Giordania",
            "cn": "çº¦æ—¦"
        },
        "latitude": "31.00000000",
        "longitude": "36.00000000",
        "emoji": "ðŸ‡¯ðŸ‡´",
        "emojiU": "U+1F1EF U+1F1F4",
        "states": [
            {
                "id": 963,
                "name": "Ajloun Governorate",
                "state_code": "AJ",
                "latitude": "32.33255840",
                "longitude": "35.75168440"
            },
            {
                "id": 965,
                "name": "Amman Governorate",
                "state_code": "AM",
                "latitude": "31.94536330",
                "longitude": "35.92838950"
            },
            {
                "id": 959,
                "name": "Aqaba Governorate",
                "state_code": "AQ",
                "latitude": "29.53208600",
                "longitude": "35.00628210"
            },
            {
                "id": 961,
                "name": "Balqa Governorate",
                "state_code": "BA",
                "latitude": "32.03668060",
                "longitude": "35.72884800"
            },
            {
                "id": 960,
                "name": "Irbid Governorate",
                "state_code": "IR",
                "latitude": "32.55696360",
                "longitude": "35.84789650"
            },
            {
                "id": 966,
                "name": "Jerash Governorate",
                "state_code": "JA",
                "latitude": "32.27472370",
                "longitude": "35.89609540"
            },
            {
                "id": 956,
                "name": "Karak Governorate",
                "state_code": "KA",
                "latitude": "31.18535270",
                "longitude": "35.70476820"
            },
            {
                "id": 964,
                "name": "Ma'an Governorate",
                "state_code": "MN",
                "latitude": "30.19267890",
                "longitude": "35.72493190"
            },
            {
                "id": 958,
                "name": "Madaba Governorate",
                "state_code": "MD",
                "latitude": "31.71960970",
                "longitude": "35.79327540"
            },
            {
                "id": 962,
                "name": "Mafraq Governorate",
                "state_code": "MA",
                "latitude": "32.34169230",
                "longitude": "36.20201750"
            },
            {
                "id": 957,
                "name": "Tafilah Governorate",
                "state_code": "AT",
                "latitude": "30.83380630",
                "longitude": "35.61605130"
            },
            {
                "id": 967,
                "name": "Zarqa Governorate",
                "state_code": "AZ",
                "latitude": "32.06085050",
                "longitude": "36.09421210"
            }
        ]
    },
    {
        "name": "Kazakhstan",
        "iso3": "KAZ",
        "iso2": "KZ",
        "phone_code": "7",
        "capital": "Astana",
        "currency": "KZT",
        "currency_symbol": "Ð»Ð²",
        "tld": ".kz",
        "native": "ÒšÐ°Ð·Ð°Ò›ÑÑ‚Ð°Ð½",
        "region": "Asia",
        "subregion": "Central Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Almaty",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "ALMT",
                "tzName": "Alma-Ata Time[1"
            },
            {
                "zoneName": "Asia\/Aqtau",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "AQTT",
                "tzName": "Aqtobe Time"
            },
            {
                "zoneName": "Asia\/Aqtobe",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "AQTT",
                "tzName": "Aqtobe Time"
            },
            {
                "zoneName": "Asia\/Atyrau",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MSD+1",
                "tzName": "Moscow Daylight Time+1"
            },
            {
                "zoneName": "Asia\/Oral",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "ORAT",
                "tzName": "Oral Time"
            },
            {
                "zoneName": "Asia\/Qostanay",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "QYZST",
                "tzName": "Qyzylorda Summer Time"
            },
            {
                "zoneName": "Asia\/Qyzylorda",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "QYZT",
                "tzName": "Qyzylorda Summer Time"
            }
        ],
        "translations": {
            "kr": "ì¹´ìžíìŠ¤íƒ„",
            "br": "CazaquistÃ£o",
            "pt": "CazaquistÃ£o",
            "nl": "Kazachstan",
            "hr": "Kazahstan",
            "fa": "Ù‚Ø²Ø§Ù‚Ø³ØªØ§Ù†",
            "de": "Kasachstan",
            "es": "KazajistÃ¡n",
            "fr": "Kazakhstan",
            "ja": "ã‚«ã‚¶ãƒ•ã‚¹ã‚¿ãƒ³",
            "it": "Kazakistan",
            "cn": "å“ˆè¨å…‹æ–¯å¦"
        },
        "latitude": "48.00000000",
        "longitude": "68.00000000",
        "emoji": "ðŸ‡°ðŸ‡¿",
        "emojiU": "U+1F1F0 U+1F1FF",
        "states": [
            {
                "id": 145,
                "name": "Akmola Region",
                "state_code": "AKM",
                "latitude": "51.91653200",
                "longitude": "69.41104940"
            },
            {
                "id": 151,
                "name": "Aktobe Region",
                "state_code": "AKT",
                "latitude": "48.77970780",
                "longitude": "57.99743780"
            },
            {
                "id": 152,
                "name": "Almaty",
                "state_code": "ALA",
                "latitude": "43.22201460",
                "longitude": "76.85124850"
            },
            {
                "id": 143,
                "name": "Almaty Region",
                "state_code": "ALM",
                "latitude": "45.01192270",
                "longitude": "78.42293920"
            },
            {
                "id": 153,
                "name": "Atyrau Region",
                "state_code": "ATY",
                "latitude": "47.10761880",
                "longitude": "51.91413300"
            },
            {
                "id": 155,
                "name": "Baikonur",
                "state_code": "BAY",
                "latitude": "45.96458510",
                "longitude": "63.30524280"
            },
            {
                "id": 154,
                "name": "East Kazakhstan Region",
                "state_code": "VOS",
                "latitude": "48.70626870",
                "longitude": "80.79225340"
            },
            {
                "id": 147,
                "name": "Jambyl Region",
                "state_code": "ZHA",
                "latitude": "44.22203080",
                "longitude": "72.36579670"
            },
            {
                "id": 150,
                "name": "Karaganda Region",
                "state_code": "KAR",
                "latitude": "47.90221820",
                "longitude": "71.77068070"
            },
            {
                "id": 157,
                "name": "Kostanay Region",
                "state_code": "KUS",
                "latitude": "51.50770960",
                "longitude": "64.04790730"
            },
            {
                "id": 142,
                "name": "Kyzylorda Region",
                "state_code": "KZY",
                "latitude": "44.69226130",
                "longitude": "62.65718850"
            },
            {
                "id": 141,
                "name": "Mangystau Region",
                "state_code": "MAN",
                "latitude": "44.59080200",
                "longitude": "53.84995080"
            },
            {
                "id": 144,
                "name": "North Kazakhstan Region",
                "state_code": "SEV",
                "latitude": "54.16220660",
                "longitude": "69.93870710"
            },
            {
                "id": 156,
                "name": "Nur-Sultan",
                "state_code": "AST",
                "latitude": "51.16052270",
                "longitude": "71.47035580"
            },
            {
                "id": 146,
                "name": "Pavlodar Region",
                "state_code": "PAV",
                "latitude": "52.28784440",
                "longitude": "76.97334530"
            },
            {
                "id": 149,
                "name": "Turkestan Region",
                "state_code": "YUZ",
                "latitude": "43.36669580",
                "longitude": "68.40944050"
            },
            {
                "id": 148,
                "name": "West Kazakhstan Province",
                "state_code": "ZAP",
                "latitude": "49.56797270",
                "longitude": "50.80666160"
            }
        ]
    },
    {
        "name": "Kenya",
        "iso3": "KEN",
        "iso2": "KE",
        "phone_code": "254",
        "capital": "Nairobi",
        "currency": "KES",
        "currency_symbol": "KSh",
        "tld": ".ke",
        "native": "Kenya",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Nairobi",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì¼€ëƒ",
            "br": "QuÃªnia",
            "pt": "QuÃ©nia",
            "nl": "Kenia",
            "hr": "Kenija",
            "fa": "Ú©Ù†ÛŒØ§",
            "de": "Kenia",
            "es": "Kenia",
            "fr": "Kenya",
            "ja": "ã‚±ãƒ‹ã‚¢",
            "it": "Kenya",
            "cn": "è‚¯å°¼äºš"
        },
        "latitude": "1.00000000",
        "longitude": "38.00000000",
        "emoji": "ðŸ‡°ðŸ‡ª",
        "emojiU": "U+1F1F0 U+1F1EA",
        "states": [
            {
                "id": 181,
                "name": "Baringo County",
                "state_code": "01",
                "latitude": "0.85549880",
                "longitude": "36.08934060"
            },
            {
                "id": 210,
                "name": "Bomet County",
                "state_code": "02",
                "latitude": "-0.80150090",
                "longitude": "35.30272260"
            },
            {
                "id": 168,
                "name": "Bungoma County",
                "state_code": "03",
                "latitude": "0.56952520",
                "longitude": "34.55837660"
            },
            {
                "id": 161,
                "name": "Busia County",
                "state_code": "04",
                "latitude": "0.43465060",
                "longitude": "34.24215970"
            },
            {
                "id": 160,
                "name": "Central Province",
                "state_code": "200",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 172,
                "name": "Coast Province",
                "state_code": "300",
                "latitude": "39.13733050",
                "longitude": "-76.72941440"
            },
            {
                "id": 189,
                "name": "Eastern Province",
                "state_code": "400",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 201,
                "name": "Elgeyo-Marakwet County",
                "state_code": "05",
                "latitude": "1.04982370",
                "longitude": "35.47819260"
            },
            {
                "id": 163,
                "name": "Embu County",
                "state_code": "06",
                "latitude": "-0.65604770",
                "longitude": "37.72376780"
            },
            {
                "id": 196,
                "name": "Garissa County",
                "state_code": "07",
                "latitude": "-0.45322930",
                "longitude": "39.64609880"
            },
            {
                "id": 195,
                "name": "Homa Bay County",
                "state_code": "08",
                "latitude": "-0.62206550",
                "longitude": "34.33103640"
            },
            {
                "id": 170,
                "name": "Isiolo County",
                "state_code": "09",
                "latitude": "0.35243520",
                "longitude": "38.48499230"
            },
            {
                "id": 197,
                "name": "Kajiado County",
                "state_code": "10",
                "latitude": "-2.09807510",
                "longitude": "36.78195050"
            },
            {
                "id": 158,
                "name": "Kakamega County",
                "state_code": "11",
                "latitude": "0.30789400",
                "longitude": "34.77407930"
            },
            {
                "id": 193,
                "name": "Kericho County",
                "state_code": "12",
                "latitude": "-0.18279130",
                "longitude": "35.47819260"
            },
            {
                "id": 199,
                "name": "Kiambu County",
                "state_code": "13",
                "latitude": "-1.03137010",
                "longitude": "36.86807910"
            },
            {
                "id": 174,
                "name": "Kilifi County",
                "state_code": "14",
                "latitude": "-3.51065080",
                "longitude": "39.90932690"
            },
            {
                "id": 167,
                "name": "Kirinyaga County",
                "state_code": "15",
                "latitude": "-0.65905650",
                "longitude": "37.38272340"
            },
            {
                "id": 159,
                "name": "Kisii County",
                "state_code": "16",
                "latitude": "-0.67733400",
                "longitude": "34.77960300"
            },
            {
                "id": 171,
                "name": "Kisumu County",
                "state_code": "17",
                "latitude": "-0.09170160",
                "longitude": "34.76795680"
            },
            {
                "id": 211,
                "name": "Kitui County",
                "state_code": "18",
                "latitude": "-1.68328220",
                "longitude": "38.31657250"
            },
            {
                "id": 173,
                "name": "Kwale County",
                "state_code": "19",
                "latitude": "-4.18161150",
                "longitude": "39.46056120"
            },
            {
                "id": 164,
                "name": "Laikipia County",
                "state_code": "20",
                "latitude": "0.36060630",
                "longitude": "36.78195050"
            },
            {
                "id": 166,
                "name": "Lamu County",
                "state_code": "21",
                "latitude": "-2.23550580",
                "longitude": "40.47200040"
            },
            {
                "id": 184,
                "name": "Machakos County",
                "state_code": "22",
                "latitude": "-1.51768370",
                "longitude": "37.26341460"
            },
            {
                "id": 188,
                "name": "Makueni County",
                "state_code": "23",
                "latitude": "-2.25587340",
                "longitude": "37.89366630"
            },
            {
                "id": 187,
                "name": "Mandera County",
                "state_code": "24",
                "latitude": "3.57379910",
                "longitude": "40.95868800"
            },
            {
                "id": 194,
                "name": "Marsabit County",
                "state_code": "25",
                "latitude": "2.44264030",
                "longitude": "37.97845850"
            },
            {
                "id": 198,
                "name": "Meru County",
                "state_code": "26",
                "latitude": "0.35571740",
                "longitude": "37.80876930"
            },
            {
                "id": 190,
                "name": "Migori County",
                "state_code": "27",
                "latitude": "-0.93657020",
                "longitude": "34.41982430"
            },
            {
                "id": 200,
                "name": "Mombasa County",
                "state_code": "28",
                "latitude": "-3.97682910",
                "longitude": "39.71371810"
            },
            {
                "id": 178,
                "name": "Muranga County",
                "state_code": "29",
                "latitude": "-0.78392810",
                "longitude": "37.04003390"
            },
            {
                "id": 191,
                "name": "Nairobi",
                "state_code": "110",
                "latitude": "-1.29206590",
                "longitude": "36.82194620"
            },
            {
                "id": 203,
                "name": "Nakuru District",
                "state_code": "31",
                "latitude": "-0.30309880",
                "longitude": "36.08002600"
            },
            {
                "id": 165,
                "name": "Nandi District",
                "state_code": "32",
                "latitude": "0.18358670",
                "longitude": "35.12687810"
            },
            {
                "id": 175,
                "name": "Narok County",
                "state_code": "33",
                "latitude": "-1.10411100",
                "longitude": "36.08934060"
            },
            {
                "id": 162,
                "name": "North Eastern Province",
                "state_code": "500",
                "latitude": "7.78530510",
                "longitude": "81.42789840"
            },
            {
                "id": 209,
                "name": "Nyamira District",
                "state_code": "34",
                "latitude": "-0.56694050",
                "longitude": "34.93412340"
            },
            {
                "id": 192,
                "name": "Nyandarua County",
                "state_code": "35",
                "latitude": "-0.18038550",
                "longitude": "36.52296410"
            },
            {
                "id": 204,
                "name": "Nyanza Province",
                "state_code": "600",
                "latitude": "-0.08898940",
                "longitude": "34.77179120"
            },
            {
                "id": 180,
                "name": "Nyeri County",
                "state_code": "36",
                "latitude": "-0.41969150",
                "longitude": "37.04003390"
            },
            {
                "id": 179,
                "name": "Rift Valley Province",
                "state_code": "700",
                "latitude": "11.40987370",
                "longitude": "41.28085770"
            },
            {
                "id": 207,
                "name": "Samburu County",
                "state_code": "37",
                "latitude": "1.21545060",
                "longitude": "36.95410700"
            },
            {
                "id": 186,
                "name": "Siaya County",
                "state_code": "38",
                "latitude": "-0.06173280",
                "longitude": "34.24215970"
            },
            {
                "id": 176,
                "name": "Taitaâ€“Taveta County",
                "state_code": "39",
                "latitude": "-3.31606870",
                "longitude": "38.48499230"
            },
            {
                "id": 205,
                "name": "Tana River County",
                "state_code": "40",
                "latitude": "-1.65184680",
                "longitude": "39.65181650"
            },
            {
                "id": 185,
                "name": "Tharaka Nithi County",
                "state_code": "41",
                "latitude": "-0.29648510",
                "longitude": "37.72376780"
            },
            {
                "id": 183,
                "name": "Trans-Nzoia District",
                "state_code": "42",
                "latitude": "1.05666670",
                "longitude": "34.95066250"
            },
            {
                "id": 206,
                "name": "Turkana County",
                "state_code": "43",
                "latitude": "3.31224770",
                "longitude": "35.56578620"
            },
            {
                "id": 169,
                "name": "Uasin Gishu District",
                "state_code": "44",
                "latitude": "0.55276380",
                "longitude": "35.30272260"
            },
            {
                "id": 202,
                "name": "Vihiga District",
                "state_code": "45",
                "latitude": "0.07675530",
                "longitude": "34.70776650"
            },
            {
                "id": 182,
                "name": "Wajir County",
                "state_code": "46",
                "latitude": "1.63604750",
                "longitude": "40.30886260"
            },
            {
                "id": 208,
                "name": "West Pokot County",
                "state_code": "47",
                "latitude": "1.62100760",
                "longitude": "35.39050460"
            },
            {
                "id": 177,
                "name": "Western Province",
                "state_code": "800",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Kiribati",
        "iso3": "KIR",
        "iso2": "KI",
        "phone_code": "686",
        "capital": "Tarawa",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".ki",
        "native": "Kiribati",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Enderbury",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "PHOT",
                "tzName": "Phoenix Island Time"
            },
            {
                "zoneName": "Pacific\/Kiritimati",
                "gmtOffset": 50400,
                "gmtOffsetName": "UTC+14:00",
                "abbreviation": "LINT",
                "tzName": "Line Islands Time"
            },
            {
                "zoneName": "Pacific\/Tarawa",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "GILT",
                "tzName": "Gilbert Island Time"
            }
        ],
        "translations": {
            "kr": "í‚¤ë¦¬ë°”ì‹œ",
            "br": "Kiribati",
            "pt": "QuiribÃ¡ti",
            "nl": "Kiribati",
            "hr": "Kiribati",
            "fa": "Ú©ÛŒØ±ÛŒØ¨Ø§ØªÛŒ",
            "de": "Kiribati",
            "es": "Kiribati",
            "fr": "Kiribati",
            "ja": "ã‚­ãƒªãƒã‚¹",
            "it": "Kiribati",
            "cn": "åŸºé‡Œå·´æ–¯"
        },
        "latitude": "1.41666666",
        "longitude": "173.00000000",
        "emoji": "ðŸ‡°ðŸ‡®",
        "emojiU": "U+1F1F0 U+1F1EE",
        "states": [
            {
                "id": 1831,
                "name": "Gilbert Islands",
                "state_code": "G",
                "latitude": "0.35242620",
                "longitude": "174.75526340"
            },
            {
                "id": 1832,
                "name": "Line Islands",
                "state_code": "L",
                "latitude": "1.74294390",
                "longitude": "-157.21328260"
            },
            {
                "id": 1830,
                "name": "Phoenix Islands",
                "state_code": "P",
                "latitude": "33.32843690",
                "longitude": "-111.98247740"
            }
        ]
    },
    {
        "name": "Korea North",
        "iso3": "PRK",
        "iso2": "KP",
        "phone_code": "850",
        "capital": "Pyongyang",
        "currency": "KPW",
        "currency_symbol": "â‚©",
        "tld": ".kp",
        "native": "ë¶í•œ",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Pyongyang",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "KST",
                "tzName": "Korea Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¡°ì„ ë¯¼ì£¼ì£¼ì˜ì¸ë¯¼ê³µí™”êµ­",
            "br": "Coreia do Norte",
            "pt": "Coreia do Norte",
            "nl": "Noord-Korea",
            "hr": "Sjeverna Koreja",
            "fa": "Ú©Ø±Ù‡ Ø¬Ù†ÙˆØ¨ÛŒ",
            "de": "Nordkorea",
            "es": "Corea del Norte",
            "fr": "CorÃ©e du Nord",
            "ja": "æœé®®æ°‘ä¸»ä¸»ç¾©äººæ°‘å…±å’Œå›½",
            "it": "Corea del Nord",
            "cn": "æœé²œ"
        },
        "latitude": "40.00000000",
        "longitude": "127.00000000",
        "emoji": "ðŸ‡°ðŸ‡µ",
        "emojiU": "U+1F1F0 U+1F1F5",
        "states": [
            {
                "id": 3998,
                "name": "Chagang Province",
                "state_code": "04",
                "latitude": "40.72028090",
                "longitude": "126.56211370"
            },
            {
                "id": 3999,
                "name": "Kangwon Province",
                "state_code": "07",
                "latitude": "38.84323930",
                "longitude": "127.55970670"
            },
            {
                "id": 3995,
                "name": "North Hamgyong Province",
                "state_code": "09",
                "latitude": "41.81487580",
                "longitude": "129.45819550"
            },
            {
                "id": 4004,
                "name": "North Hwanghae Province",
                "state_code": "06",
                "latitude": "38.37860850",
                "longitude": "126.43643630"
            },
            {
                "id": 4002,
                "name": "North Pyongan Province",
                "state_code": "03",
                "latitude": "39.92556180",
                "longitude": "125.39280250"
            },
            {
                "id": 4005,
                "name": "Pyongyang",
                "state_code": "01",
                "latitude": "39.03921930",
                "longitude": "125.76252410"
            },
            {
                "id": 4001,
                "name": "Rason",
                "state_code": "13",
                "latitude": "42.25690630",
                "longitude": "130.29771860"
            },
            {
                "id": 3996,
                "name": "Ryanggang Province",
                "state_code": "10",
                "latitude": "41.23189210",
                "longitude": "128.50763590"
            },
            {
                "id": 4000,
                "name": "South Hamgyong Province",
                "state_code": "08",
                "latitude": "40.37253390",
                "longitude": "128.29888400"
            },
            {
                "id": 4003,
                "name": "South Hwanghae Province",
                "state_code": "05",
                "latitude": "38.20072150",
                "longitude": "125.47819260"
            },
            {
                "id": 3997,
                "name": "South Pyongan Province",
                "state_code": "02",
                "latitude": "39.35391780",
                "longitude": "126.16827100"
            }
        ]
    },
    {
        "name": "Korea South",
        "iso3": "KOR",
        "iso2": "KR",
        "phone_code": "82",
        "capital": "Seoul",
        "currency": "KRW",
        "currency_symbol": "â‚©",
        "tld": ".kr",
        "native": "ëŒ€í•œë¯¼êµ­",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Seoul",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "KST",
                "tzName": "Korea Standard Time"
            }
        ],
        "translations": {
            "kr": "ëŒ€í•œë¯¼êµ­",
            "br": "Coreia do Sul",
            "pt": "Coreia do Sul",
            "nl": "Zuid-Korea",
            "hr": "JuÅ¾na Koreja",
            "fa": "Ú©Ø±Ù‡ Ø´Ù…Ø§Ù„ÛŒ",
            "de": "SÃ¼dkorea",
            "es": "Corea del Sur",
            "fr": "CorÃ©e du Sud",
            "ja": "å¤§éŸ“æ°‘å›½",
            "it": "Corea del Sud",
            "cn": "éŸ©å›½"
        },
        "latitude": "37.00000000",
        "longitude": "127.50000000",
        "emoji": "ðŸ‡°ðŸ‡·",
        "emojiU": "U+1F1F0 U+1F1F7",
        "states": [
            {
                "id": 3860,
                "name": "Busan",
                "state_code": "26",
                "latitude": "35.17955430",
                "longitude": "129.07564160"
            },
            {
                "id": 3846,
                "name": "Daegu",
                "state_code": "27",
                "latitude": "35.87143540",
                "longitude": "128.60144500"
            },
            {
                "id": 3850,
                "name": "Daejeon",
                "state_code": "30",
                "latitude": "36.35041190",
                "longitude": "127.38454750"
            },
            {
                "id": 3862,
                "name": "Gangwon Province",
                "state_code": "42",
                "latitude": "37.82280000",
                "longitude": "128.15550000"
            },
            {
                "id": 3858,
                "name": "Gwangju",
                "state_code": "29",
                "latitude": "35.15954540",
                "longitude": "126.85260120"
            },
            {
                "id": 3847,
                "name": "Gyeonggi Province",
                "state_code": "41",
                "latitude": "37.41380000",
                "longitude": "127.51830000"
            },
            {
                "id": 3848,
                "name": "Incheon",
                "state_code": "28",
                "latitude": "37.45625570",
                "longitude": "126.70520620"
            },
            {
                "id": 3853,
                "name": "Jeju",
                "state_code": "49",
                "latitude": "33.95682780",
                "longitude": "-84.13135000"
            },
            {
                "id": 3854,
                "name": "North Chungcheong Province",
                "state_code": "43",
                "latitude": "36.80000000",
                "longitude": "127.70000000"
            },
            {
                "id": 3855,
                "name": "North Gyeongsang Province",
                "state_code": "47",
                "latitude": "36.49190000",
                "longitude": "128.88890000"
            },
            {
                "id": 3851,
                "name": "North Jeolla Province",
                "state_code": "45",
                "latitude": "35.71750000",
                "longitude": "127.15300000"
            },
            {
                "id": 3861,
                "name": "Sejong City",
                "state_code": "50",
                "latitude": "34.05233230",
                "longitude": "-118.30848970"
            },
            {
                "id": 3849,
                "name": "Seoul",
                "state_code": "11",
                "latitude": "37.56653500",
                "longitude": "126.97796920"
            },
            {
                "id": 3859,
                "name": "South Chungcheong Province",
                "state_code": "44",
                "latitude": "36.51840000",
                "longitude": "126.80000000"
            },
            {
                "id": 3857,
                "name": "South Gyeongsang Province",
                "state_code": "48",
                "latitude": "35.46060000",
                "longitude": "128.21320000"
            },
            {
                "id": 3856,
                "name": "South Jeolla Province",
                "state_code": "46",
                "latitude": "34.86790000",
                "longitude": "126.99100000"
            },
            {
                "id": 3852,
                "name": "Ulsan",
                "state_code": "31",
                "latitude": "35.53837730",
                "longitude": "129.31135960"
            }
        ]
    },
    {
        "name": "Kosovo",
        "iso3": "XKX",
        "iso2": "XK",
        "phone_code": "383",
        "capital": "Pristina",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".xk",
        "native": "Republika e KosovÃ«s",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Belgrade",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì½”ì†Œë³´",
            "cn": "ç§‘ç´¢æ²ƒ"
        },
        "latitude": "42.56129090",
        "longitude": "20.34030350",
        "emoji": "ðŸ‡½ðŸ‡°",
        "emojiU": "U+1F1FD U+1F1F0",
        "states": [
            {
                "id": 4876,
                "name": "Äakovica District (Gjakove)",
                "state_code": "XDG",
                "latitude": "42.43757560",
                "longitude": "20.37854380"
            },
            {
                "id": 4877,
                "name": "Gjilan District",
                "state_code": "XGJ",
                "latitude": "42.46352060",
                "longitude": "21.46940110"
            },
            {
                "id": 4878,
                "name": "Kosovska Mitrovica District",
                "state_code": "XKM",
                "latitude": "42.89139090",
                "longitude": "20.86599950"
            },
            {
                "id": 3738,
                "name": "PeÄ‡ District",
                "state_code": "XPE",
                "latitude": "42.65921550",
                "longitude": "20.28876240"
            },
            {
                "id": 4879,
                "name": "Pristina (PriÅŸtine)",
                "state_code": "XPI",
                "latitude": "42.66291380",
                "longitude": "21.16550280"
            },
            {
                "id": 3723,
                "name": "Prizren District",
                "state_code": "XPR",
                "latitude": "42.21525220",
                "longitude": "20.74147720"
            },
            {
                "id": 4874,
                "name": "UroÅ¡evac District (Ferizaj)",
                "state_code": "XUF",
                "latitude": "42.37018440",
                "longitude": "21.14832810"
            }
        ]
    },
    {
        "name": "Kuwait",
        "iso3": "KWT",
        "iso2": "KW",
        "phone_code": "965",
        "capital": "Kuwait City",
        "currency": "KWD",
        "currency_symbol": "Ùƒ.Ø¯",
        "tld": ".kw",
        "native": "Ø§Ù„ÙƒÙˆÙŠØª",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Kuwait",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¿ ì›¨ì´íŠ¸",
            "br": "Kuwait",
            "pt": "Kuwait",
            "nl": "Koeweit",
            "hr": "Kuvajt",
            "fa": "Ú©ÙˆÛŒØª",
            "de": "Kuwait",
            "es": "Kuwait",
            "fr": "KoweÃ¯t",
            "ja": "ã‚¯ã‚¦ã‚§ãƒ¼ãƒˆ",
            "it": "Kuwait",
            "cn": "ç§‘å¨ç‰¹"
        },
        "latitude": "29.50000000",
        "longitude": "45.75000000",
        "emoji": "ðŸ‡°ðŸ‡¼",
        "emojiU": "U+1F1F0 U+1F1FC",
        "states": [
            {
                "id": 977,
                "name": "Al Ahmadi Governorate",
                "state_code": "AH",
                "latitude": "28.57451250",
                "longitude": "48.10247430"
            },
            {
                "id": 975,
                "name": "Al Farwaniyah Governorate",
                "state_code": "FA",
                "latitude": "29.27335700",
                "longitude": "47.94001540"
            },
            {
                "id": 972,
                "name": "Al Jahra Governorate",
                "state_code": "JA",
                "latitude": "29.99318310",
                "longitude": "47.76347310"
            },
            {
                "id": 976,
                "name": "Capital Governorate",
                "state_code": "KU",
                "latitude": "26.22851610",
                "longitude": "50.58604970"
            },
            {
                "id": 973,
                "name": "Hawalli Governorate",
                "state_code": "HA",
                "latitude": "29.30567160",
                "longitude": "48.03076130"
            },
            {
                "id": 974,
                "name": "Mubarak Al-Kabeer Governorate",
                "state_code": "MU",
                "latitude": "29.21224000",
                "longitude": "48.06051080"
            }
        ]
    },
    {
        "name": "Kyrgyzstan",
        "iso3": "KGZ",
        "iso2": "KG",
        "phone_code": "996",
        "capital": "Bishkek",
        "currency": "KGS",
        "currency_symbol": "Ð»Ð²",
        "tld": ".kg",
        "native": "ÐšÑ‹Ñ€Ð³Ñ‹Ð·ÑÑ‚Ð°Ð½",
        "region": "Asia",
        "subregion": "Central Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Bishkek",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "KGT",
                "tzName": "Kyrgyzstan Time"
            }
        ],
        "translations": {
            "kr": "í‚¤ë¥´ê¸°ìŠ¤ìŠ¤íƒ„",
            "br": "QuirguistÃ£o",
            "pt": "QuirguizistÃ£o",
            "nl": "KirgiziÃ«",
            "hr": "Kirgistan",
            "fa": "Ù‚Ø±Ù‚ÛŒØ²Ø³ØªØ§Ù†",
            "de": "Kirgisistan",
            "es": "KirguizistÃ¡n",
            "fr": "Kirghizistan",
            "ja": "ã‚­ãƒ«ã‚®ã‚¹",
            "it": "Kirghizistan",
            "cn": "å‰å°”å‰æ–¯æ–¯å¦"
        },
        "latitude": "41.00000000",
        "longitude": "75.00000000",
        "emoji": "ðŸ‡°ðŸ‡¬",
        "emojiU": "U+1F1F0 U+1F1EC",
        "states": [
            {
                "id": 998,
                "name": "Batken Region",
                "state_code": "B",
                "latitude": "39.97214250",
                "longitude": "69.85974060"
            },
            {
                "id": 1001,
                "name": "Bishkek",
                "state_code": "GB",
                "latitude": "42.87462120",
                "longitude": "74.56976170"
            },
            {
                "id": 1004,
                "name": "Chuy Region",
                "state_code": "C",
                "latitude": "42.56550000",
                "longitude": "74.40566120"
            },
            {
                "id": 1002,
                "name": "Issyk-Kul Region",
                "state_code": "Y",
                "latitude": "42.18594280",
                "longitude": "77.56194190"
            },
            {
                "id": 1000,
                "name": "Jalal-Abad Region",
                "state_code": "J",
                "latitude": "41.10680800",
                "longitude": "72.89880690"
            },
            {
                "id": 999,
                "name": "Naryn Region",
                "state_code": "N",
                "latitude": "41.29432270",
                "longitude": "75.34121790"
            },
            {
                "id": 1003,
                "name": "Osh",
                "state_code": "GO",
                "latitude": "36.06313990",
                "longitude": "-95.91828950"
            },
            {
                "id": 1005,
                "name": "Osh Region",
                "state_code": "O",
                "latitude": "39.84073660",
                "longitude": "72.89880690"
            },
            {
                "id": 997,
                "name": "Talas Region",
                "state_code": "T",
                "latitude": "42.28673390",
                "longitude": "72.52048270"
            }
        ]
    },
    {
        "name": "Laos",
        "iso3": "LAO",
        "iso2": "LA",
        "phone_code": "856",
        "capital": "Vientiane",
        "currency": "LAK",
        "currency_symbol": "â‚­",
        "tld": ".la",
        "native": "àºªàº›àº›àº¥àº²àº§",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Vientiane",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "kr": "ë¼ì˜¤ìŠ¤",
            "br": "Laos",
            "pt": "Laos",
            "nl": "Laos",
            "hr": "Laos",
            "fa": "Ù„Ø§Ø¦ÙˆØ³",
            "de": "Laos",
            "es": "Laos",
            "fr": "Laos",
            "ja": "ãƒ©ã‚ªã‚¹äººæ°‘æ°‘ä¸»å…±å’Œå›½",
            "it": "Laos",
            "cn": "å¯®äººæ°‘æ°‘ä¸»å…±å’Œå›½"
        },
        "latitude": "18.00000000",
        "longitude": "105.00000000",
        "emoji": "ðŸ‡±ðŸ‡¦",
        "emojiU": "U+1F1F1 U+1F1E6",
        "states": [
            {
                "id": 982,
                "name": "Attapeu Province",
                "state_code": "AT",
                "latitude": "14.93634000",
                "longitude": "107.10119310"
            },
            {
                "id": 991,
                "name": "Bokeo Province",
                "state_code": "BK",
                "latitude": "20.28726620",
                "longitude": "100.70978670"
            },
            {
                "id": 985,
                "name": "Bolikhamsai Province",
                "state_code": "BL",
                "latitude": "18.43629240",
                "longitude": "104.47233010"
            },
            {
                "id": 996,
                "name": "Champasak Province",
                "state_code": "CH",
                "latitude": "14.65786640",
                "longitude": "105.96998780"
            },
            {
                "id": 989,
                "name": "Houaphanh Province",
                "state_code": "HO",
                "latitude": "20.32541750",
                "longitude": "104.10013260"
            },
            {
                "id": 986,
                "name": "Khammouane Province",
                "state_code": "KH",
                "latitude": "17.63840660",
                "longitude": "105.21948080"
            },
            {
                "id": 992,
                "name": "Luang Namtha Province",
                "state_code": "LM",
                "latitude": "20.91701870",
                "longitude": "101.16173560"
            },
            {
                "id": 978,
                "name": "Luang Prabang Province",
                "state_code": "LP",
                "latitude": "20.06562290",
                "longitude": "102.62162110"
            },
            {
                "id": 988,
                "name": "Oudomxay Province",
                "state_code": "OU",
                "latitude": "20.49219290",
                "longitude": "101.88917210"
            },
            {
                "id": 987,
                "name": "Phongsaly Province",
                "state_code": "PH",
                "latitude": "21.59193770",
                "longitude": "102.25479190"
            },
            {
                "id": 993,
                "name": "Sainyabuli Province",
                "state_code": "XA",
                "latitude": "19.39078860",
                "longitude": "101.52480550"
            },
            {
                "id": 981,
                "name": "Salavan Province",
                "state_code": "SL",
                "latitude": "15.81710730",
                "longitude": "106.25221430"
            },
            {
                "id": 990,
                "name": "Savannakhet Province",
                "state_code": "SV",
                "latitude": "16.50653810",
                "longitude": "105.59433880"
            },
            {
                "id": 984,
                "name": "Sekong Province",
                "state_code": "XE",
                "latitude": "15.57674460",
                "longitude": "107.00670310"
            },
            {
                "id": 979,
                "name": "Vientiane Prefecture",
                "state_code": "VT",
                "latitude": "18.11054100",
                "longitude": "102.52980280"
            },
            {
                "id": 980,
                "name": "Vientiane Province",
                "state_code": "VI",
                "latitude": "18.57050630",
                "longitude": "102.62162110"
            },
            {
                "id": 994,
                "name": "Xaisomboun",
                "state_code": "XN",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 983,
                "name": "Xaisomboun Province",
                "state_code": "XS",
                "latitude": "18.43629240",
                "longitude": "104.47233010"
            },
            {
                "id": 995,
                "name": "Xiangkhouang Province",
                "state_code": "XI",
                "latitude": "19.60930030",
                "longitude": "103.72891670"
            }
        ]
    },
    {
        "name": "Latvia",
        "iso3": "LVA",
        "iso2": "LV",
        "phone_code": "371",
        "capital": "Riga",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".lv",
        "native": "Latvija",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Riga",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë¼íŠ¸ë¹„ì•„",
            "br": "LetÃ´nia",
            "pt": "LetÃ³nia",
            "nl": "Letland",
            "hr": "Latvija",
            "fa": "Ù„ØªÙˆÙ†ÛŒ",
            "de": "Lettland",
            "es": "Letonia",
            "fr": "Lettonie",
            "ja": "ãƒ©ãƒˆãƒ“ã‚¢",
            "it": "Lettonia",
            "cn": "æ‹‰è„±ç»´äºš"
        },
        "latitude": "57.00000000",
        "longitude": "25.00000000",
        "emoji": "ðŸ‡±ðŸ‡»",
        "emojiU": "U+1F1F1 U+1F1FB",
        "states": [
            {
                "id": 4445,
                "name": "Aglona Municipality",
                "state_code": "001",
                "latitude": "56.10890060",
                "longitude": "27.12862270"
            },
            {
                "id": 4472,
                "name": "Aizkraukle Municipality",
                "state_code": "002",
                "latitude": "56.64610800",
                "longitude": "25.23708540"
            },
            {
                "id": 4496,
                "name": "Aizpute Municipality",
                "state_code": "003",
                "latitude": "56.71825960",
                "longitude": "21.60727590"
            },
            {
                "id": 4499,
                "name": "AknÄ«ste Municipality",
                "state_code": "004",
                "latitude": "56.16130370",
                "longitude": "25.74848270"
            },
            {
                "id": 4484,
                "name": "Aloja Municipality",
                "state_code": "005",
                "latitude": "57.76713600",
                "longitude": "24.87708390"
            },
            {
                "id": 4485,
                "name": "Alsunga Municipality",
                "state_code": "006",
                "latitude": "56.98285310",
                "longitude": "21.55559190"
            },
            {
                "id": 4487,
                "name": "AlÅ«ksne Municipality",
                "state_code": "007",
                "latitude": "57.42544850",
                "longitude": "27.04249680"
            },
            {
                "id": 4497,
                "name": "Amata Municipality",
                "state_code": "008",
                "latitude": "56.99387260",
                "longitude": "25.26276750"
            },
            {
                "id": 4457,
                "name": "Ape Municipality",
                "state_code": "009",
                "latitude": "57.53926970",
                "longitude": "26.69416490"
            },
            {
                "id": 4481,
                "name": "Auce Municipality",
                "state_code": "010",
                "latitude": "56.46016800",
                "longitude": "22.90547810"
            },
            {
                "id": 4427,
                "name": "BabÄ«te Municipality",
                "state_code": "012",
                "latitude": "56.95415500",
                "longitude": "23.94539900"
            },
            {
                "id": 4482,
                "name": "Baldone Municipality",
                "state_code": "013",
                "latitude": "56.74246000",
                "longitude": "24.39115440"
            },
            {
                "id": 4498,
                "name": "Baltinava Municipality",
                "state_code": "014",
                "latitude": "56.94584680",
                "longitude": "27.64410660"
            },
            {
                "id": 4505,
                "name": "Balvi Municipality",
                "state_code": "015",
                "latitude": "57.13262400",
                "longitude": "27.26466850"
            },
            {
                "id": 4465,
                "name": "Bauska Municipality",
                "state_code": "016",
                "latitude": "56.41018680",
                "longitude": "24.20006890"
            },
            {
                "id": 4471,
                "name": "BeverÄ«na Municipality",
                "state_code": "017",
                "latitude": "57.51971090",
                "longitude": "25.60736540"
            },
            {
                "id": 4468,
                "name": "BrocÄ“ni Municipality",
                "state_code": "018",
                "latitude": "56.73475410",
                "longitude": "22.63573710"
            },
            {
                "id": 4411,
                "name": "Burtnieki Municipality",
                "state_code": "019",
                "latitude": "57.69490040",
                "longitude": "25.27647770"
            },
            {
                "id": 4454,
                "name": "Carnikava Municipality",
                "state_code": "020",
                "latitude": "57.10241210",
                "longitude": "24.21086620"
            },
            {
                "id": 4469,
                "name": "CÄ“sis Municipality",
                "state_code": "022",
                "latitude": "57.31028970",
                "longitude": "25.26761250"
            },
            {
                "id": 4414,
                "name": "Cesvaine Municipality",
                "state_code": "021",
                "latitude": "56.96792640",
                "longitude": "26.30831720"
            },
            {
                "id": 4410,
                "name": "Cibla Municipality",
                "state_code": "023",
                "latitude": "56.61023440",
                "longitude": "27.86965980"
            },
            {
                "id": 4504,
                "name": "Dagda Municipality",
                "state_code": "024",
                "latitude": "56.09560890",
                "longitude": "27.53245900"
            },
            {
                "id": 4463,
                "name": "Daugavpils",
                "state_code": "DGV",
                "latitude": "55.87473600",
                "longitude": "26.53617900"
            },
            {
                "id": 4492,
                "name": "Daugavpils Municipality",
                "state_code": "025",
                "latitude": "55.89917830",
                "longitude": "26.61020120"
            },
            {
                "id": 4437,
                "name": "Dobele Municipality",
                "state_code": "026",
                "latitude": "56.62630500",
                "longitude": "23.28090660"
            },
            {
                "id": 4428,
                "name": "Dundaga Municipality",
                "state_code": "027",
                "latitude": "57.50491670",
                "longitude": "22.35051140"
            },
            {
                "id": 4458,
                "name": "Durbe Municipality",
                "state_code": "028",
                "latitude": "56.62798570",
                "longitude": "21.49162450"
            },
            {
                "id": 4448,
                "name": "Engure Municipality",
                "state_code": "029",
                "latitude": "57.16235000",
                "longitude": "23.21966340"
            },
            {
                "id": 4444,
                "name": "Ä’rgÄ¼i Municipality",
                "state_code": "030",
                "latitude": "56.92370650",
                "longitude": "25.67538520"
            },
            {
                "id": 4510,
                "name": "Garkalne Municipality",
                "state_code": "031",
                "latitude": "57.01903870",
                "longitude": "24.38261810"
            },
            {
                "id": 4470,
                "name": "GrobiÅ†a Municipality",
                "state_code": "032",
                "latitude": "56.53963200",
                "longitude": "21.16689200"
            },
            {
                "id": 4400,
                "name": "Gulbene Municipality",
                "state_code": "033",
                "latitude": "57.21556450",
                "longitude": "26.64529550"
            },
            {
                "id": 4441,
                "name": "Iecava Municipality",
                "state_code": "034",
                "latitude": "56.59867930",
                "longitude": "24.19962720"
            },
            {
                "id": 4511,
                "name": "IkÅ¡Ä·ile Municipality",
                "state_code": "035",
                "latitude": "56.83736670",
                "longitude": "24.49747450"
            },
            {
                "id": 4399,
                "name": "IlÅ«kste Municipality",
                "state_code": "036",
                "latitude": "55.97825470",
                "longitude": "26.29650880"
            },
            {
                "id": 4449,
                "name": "InÄukalns Municipality",
                "state_code": "037",
                "latitude": "57.09943420",
                "longitude": "24.68555700"
            },
            {
                "id": 4475,
                "name": "Jaunjelgava Municipality",
                "state_code": "038",
                "latitude": "56.52836590",
                "longitude": "25.39214430"
            },
            {
                "id": 4407,
                "name": "Jaunpiebalga Municipality",
                "state_code": "039",
                "latitude": "57.14334710",
                "longitude": "25.99518880"
            },
            {
                "id": 4489,
                "name": "Jaunpils Municipality",
                "state_code": "040",
                "latitude": "56.73141940",
                "longitude": "23.01256160"
            },
            {
                "id": 4464,
                "name": "JÄ“kabpils",
                "state_code": "JKB",
                "latitude": "56.50145500",
                "longitude": "25.87829900"
            },
            {
                "id": 4438,
                "name": "JÄ“kabpils Municipality",
                "state_code": "042",
                "latitude": "56.29193200",
                "longitude": "25.98120170"
            },
            {
                "id": 4500,
                "name": "Jelgava",
                "state_code": "JEL",
                "latitude": "56.65110910",
                "longitude": "23.72135410"
            },
            {
                "id": 4424,
                "name": "Jelgava Municipality",
                "state_code": "041",
                "latitude": "56.58956890",
                "longitude": "23.66104810"
            },
            {
                "id": 4446,
                "name": "JÅ«rmala",
                "state_code": "JUR",
                "latitude": "56.94707900",
                "longitude": "23.61684850"
            },
            {
                "id": 4420,
                "name": "Kandava Municipality",
                "state_code": "043",
                "latitude": "57.03406730",
                "longitude": "22.78018130"
            },
            {
                "id": 4453,
                "name": "KÄrsava Municipality",
                "state_code": "044",
                "latitude": "56.76458420",
                "longitude": "27.73582950"
            },
            {
                "id": 4412,
                "name": "Ä¶egums Municipality",
                "state_code": "051",
                "latitude": "56.74753570",
                "longitude": "24.71736450"
            },
            {
                "id": 4435,
                "name": "Ä¶ekava Municipality",
                "state_code": "052",
                "latitude": "56.80643510",
                "longitude": "24.19394930"
            },
            {
                "id": 4495,
                "name": "KocÄ“ni Municipality",
                "state_code": "045",
                "latitude": "57.52262920",
                "longitude": "25.33495070"
            },
            {
                "id": 4452,
                "name": "Koknese Municipality",
                "state_code": "046",
                "latitude": "56.72055600",
                "longitude": "25.48939090"
            },
            {
                "id": 4474,
                "name": "KrÄslava Municipality",
                "state_code": "047",
                "latitude": "55.89514640",
                "longitude": "27.18145770"
            },
            {
                "id": 4422,
                "name": "Krimulda Municipality",
                "state_code": "048",
                "latitude": "57.17912730",
                "longitude": "24.71401270"
            },
            {
                "id": 4413,
                "name": "Krustpils Municipality",
                "state_code": "049",
                "latitude": "56.54155780",
                "longitude": "26.24463970"
            },
            {
                "id": 4490,
                "name": "KuldÄ«ga Municipality",
                "state_code": "050",
                "latitude": "56.96872570",
                "longitude": "21.96137390"
            },
            {
                "id": 4512,
                "name": "LielvÄrde Municipality",
                "state_code": "053",
                "latitude": "56.73929760",
                "longitude": "24.97116180"
            },
            {
                "id": 4460,
                "name": "LiepÄja",
                "state_code": "LPX",
                "latitude": "56.50466780",
                "longitude": "21.01080600"
            },
            {
                "id": 4488,
                "name": "LÄ«gatne Municipality",
                "state_code": "055",
                "latitude": "57.19442040",
                "longitude": "25.09406810"
            },
            {
                "id": 4418,
                "name": "LimbaÅ¾i Municipality",
                "state_code": "054",
                "latitude": "57.54032270",
                "longitude": "24.71344510"
            },
            {
                "id": 4401,
                "name": "LÄ«vÄni Municipality",
                "state_code": "056",
                "latitude": "56.35509420",
                "longitude": "26.17251900"
            },
            {
                "id": 4419,
                "name": "LubÄna Municipality",
                "state_code": "057",
                "latitude": "56.89992690",
                "longitude": "26.71987890"
            },
            {
                "id": 4501,
                "name": "Ludza Municipality",
                "state_code": "058",
                "latitude": "56.54595900",
                "longitude": "27.71431990"
            },
            {
                "id": 4433,
                "name": "Madona Municipality",
                "state_code": "059",
                "latitude": "56.85989230",
                "longitude": "26.22762010"
            },
            {
                "id": 4461,
                "name": "MÄlpils Municipality",
                "state_code": "061",
                "latitude": "57.00841190",
                "longitude": "24.95742780"
            },
            {
                "id": 4450,
                "name": "MÄrupe Municipality",
                "state_code": "062",
                "latitude": "56.89657170",
                "longitude": "24.04600490"
            },
            {
                "id": 4513,
                "name": "Mazsalaca Municipality",
                "state_code": "060",
                "latitude": "57.92677490",
                "longitude": "25.06698950"
            },
            {
                "id": 4451,
                "name": "MÄ“rsrags Municipality",
                "state_code": "063",
                "latitude": "57.33068810",
                "longitude": "23.10237070"
            },
            {
                "id": 4398,
                "name": "NaukÅ¡Ä“ni Municipality",
                "state_code": "064",
                "latitude": "57.92953610",
                "longitude": "25.51192660"
            },
            {
                "id": 4432,
                "name": "Nereta Municipality",
                "state_code": "065",
                "latitude": "56.19866550",
                "longitude": "25.32529690"
            },
            {
                "id": 4436,
                "name": "NÄ«ca Municipality",
                "state_code": "066",
                "latitude": "56.34649830",
                "longitude": "21.06549300"
            },
            {
                "id": 4416,
                "name": "Ogre Municipality",
                "state_code": "067",
                "latitude": "56.81473550",
                "longitude": "24.60445550"
            },
            {
                "id": 4417,
                "name": "Olaine Municipality",
                "state_code": "068",
                "latitude": "56.79523530",
                "longitude": "24.01535890"
            },
            {
                "id": 4442,
                "name": "Ozolnieki Municipality",
                "state_code": "069",
                "latitude": "56.67563050",
                "longitude": "23.89948160"
            },
            {
                "id": 4507,
                "name": "PÄrgauja Municipality",
                "state_code": "070",
                "latitude": "57.36481220",
                "longitude": "24.98220450"
            },
            {
                "id": 4467,
                "name": "PÄvilosta Municipality",
                "state_code": "071",
                "latitude": "56.88654240",
                "longitude": "21.19468490"
            },
            {
                "id": 4405,
                "name": "PÄ¼aviÅ†as Municipality",
                "state_code": "072",
                "latitude": "56.61773130",
                "longitude": "25.71940430"
            },
            {
                "id": 4483,
                "name": "PreiÄ¼i Municipality",
                "state_code": "073",
                "latitude": "56.15111570",
                "longitude": "26.74397670"
            },
            {
                "id": 4429,
                "name": "Priekule Municipality",
                "state_code": "074",
                "latitude": "56.41794130",
                "longitude": "21.55033360"
            },
            {
                "id": 4506,
                "name": "PriekuÄ¼i Municipality",
                "state_code": "075",
                "latitude": "57.36171380",
                "longitude": "25.44104230"
            },
            {
                "id": 4479,
                "name": "Rauna Municipality",
                "state_code": "076",
                "latitude": "57.33169300",
                "longitude": "25.61003390"
            },
            {
                "id": 4509,
                "name": "RÄ“zekne",
                "state_code": "REZ",
                "latitude": "56.50992230",
                "longitude": "27.33313570"
            },
            {
                "id": 4455,
                "name": "RÄ“zekne Municipality",
                "state_code": "077",
                "latitude": "56.32736380",
                "longitude": "27.32843310"
            },
            {
                "id": 4502,
                "name": "RiebiÅ†i Municipality",
                "state_code": "078",
                "latitude": "56.34361900",
                "longitude": "26.80181380"
            },
            {
                "id": 4491,
                "name": "Riga",
                "state_code": "RIX",
                "latitude": "56.94964870",
                "longitude": "24.10518650"
            },
            {
                "id": 4440,
                "name": "Roja Municipality",
                "state_code": "079",
                "latitude": "57.50467130",
                "longitude": "22.80121640"
            },
            {
                "id": 4493,
                "name": "RopaÅ¾i Municipality",
                "state_code": "080",
                "latitude": "56.96157860",
                "longitude": "24.60104760"
            },
            {
                "id": 4503,
                "name": "Rucava Municipality",
                "state_code": "081",
                "latitude": "56.15931240",
                "longitude": "21.16181210"
            },
            {
                "id": 4423,
                "name": "RugÄji Municipality",
                "state_code": "082",
                "latitude": "57.00560230",
                "longitude": "27.13172030"
            },
            {
                "id": 4426,
                "name": "RÅ«jiena Municipality",
                "state_code": "084",
                "latitude": "57.89372910",
                "longitude": "25.33910080"
            },
            {
                "id": 4404,
                "name": "RundÄle Municipality",
                "state_code": "083",
                "latitude": "56.40972100",
                "longitude": "24.01241390"
            },
            {
                "id": 4434,
                "name": "Sala Municipality",
                "state_code": "085",
                "latitude": "59.96796130",
                "longitude": "16.49782170"
            },
            {
                "id": 4396,
                "name": "SalacgrÄ«va Municipality",
                "state_code": "086",
                "latitude": "57.75808830",
                "longitude": "24.35431810"
            },
            {
                "id": 4402,
                "name": "Salaspils Municipality",
                "state_code": "087",
                "latitude": "56.86081520",
                "longitude": "24.34978810"
            },
            {
                "id": 4439,
                "name": "Saldus Municipality",
                "state_code": "088",
                "latitude": "56.66650880",
                "longitude": "22.49354930"
            },
            {
                "id": 4443,
                "name": "Saulkrasti Municipality",
                "state_code": "089",
                "latitude": "57.25794180",
                "longitude": "24.41831460"
            },
            {
                "id": 4408,
                "name": "SÄ“ja Municipality",
                "state_code": "090",
                "latitude": "57.20069950",
                "longitude": "24.59228210"
            },
            {
                "id": 4476,
                "name": "Sigulda Municipality",
                "state_code": "091",
                "latitude": "57.10550920",
                "longitude": "24.83142590"
            },
            {
                "id": 4415,
                "name": "SkrÄ«veri Municipality",
                "state_code": "092",
                "latitude": "56.67613910",
                "longitude": "25.09788490"
            },
            {
                "id": 4447,
                "name": "Skrunda Municipality",
                "state_code": "093",
                "latitude": "56.66434580",
                "longitude": "22.00457290"
            },
            {
                "id": 4462,
                "name": "Smiltene Municipality",
                "state_code": "094",
                "latitude": "57.42303320",
                "longitude": "25.90027800"
            },
            {
                "id": 4478,
                "name": "StopiÅ†i Municipality",
                "state_code": "095",
                "latitude": "56.93644900",
                "longitude": "24.28729490"
            },
            {
                "id": 4494,
                "name": "StrenÄi Municipality",
                "state_code": "096",
                "latitude": "57.62254710",
                "longitude": "25.80480860"
            },
            {
                "id": 4459,
                "name": "Talsi Municipality",
                "state_code": "097",
                "latitude": "57.34152080",
                "longitude": "22.57131250"
            },
            {
                "id": 4480,
                "name": "TÄ“rvete Municipality",
                "state_code": "098",
                "latitude": "56.41192010",
                "longitude": "23.31883320"
            },
            {
                "id": 4409,
                "name": "Tukums Municipality",
                "state_code": "099",
                "latitude": "56.96728680",
                "longitude": "23.15243790"
            },
            {
                "id": 4508,
                "name": "VaiÅ†ode Municipality",
                "state_code": "100",
                "latitude": "56.41542710",
                "longitude": "21.85139840"
            },
            {
                "id": 4425,
                "name": "Valka Municipality",
                "state_code": "101",
                "latitude": "57.77439000",
                "longitude": "26.01700500"
            },
            {
                "id": 4473,
                "name": "Valmiera",
                "state_code": "VMR",
                "latitude": "57.53846590",
                "longitude": "25.42636180"
            },
            {
                "id": 4431,
                "name": "VarakÄ¼Äni Municipality",
                "state_code": "102",
                "latitude": "56.66880060",
                "longitude": "26.56364140"
            },
            {
                "id": 4406,
                "name": "VÄrkava Municipality",
                "state_code": "103",
                "latitude": "56.24657440",
                "longitude": "26.56643710"
            },
            {
                "id": 4466,
                "name": "Vecpiebalga Municipality",
                "state_code": "104",
                "latitude": "57.06033560",
                "longitude": "25.81615920"
            },
            {
                "id": 4397,
                "name": "Vecumnieki Municipality",
                "state_code": "105",
                "latitude": "56.60623370",
                "longitude": "24.52218910"
            },
            {
                "id": 4421,
                "name": "Ventspils",
                "state_code": "VEN",
                "latitude": "57.39372160",
                "longitude": "21.56470660"
            },
            {
                "id": 4403,
                "name": "Ventspils Municipality",
                "state_code": "106",
                "latitude": "57.28336820",
                "longitude": "21.85875580"
            },
            {
                "id": 4456,
                "name": "ViesÄ«te Municipality",
                "state_code": "107",
                "latitude": "56.31130850",
                "longitude": "25.50704640"
            },
            {
                "id": 4477,
                "name": "ViÄ¼aka Municipality",
                "state_code": "108",
                "latitude": "57.17222630",
                "longitude": "27.66731880"
            },
            {
                "id": 4486,
                "name": "ViÄ¼Äni Municipality",
                "state_code": "109",
                "latitude": "56.54561710",
                "longitude": "26.91679270"
            },
            {
                "id": 4430,
                "name": "Zilupe Municipality",
                "state_code": "110",
                "latitude": "56.30189850",
                "longitude": "28.13395900"
            }
        ]
    },
    {
        "name": "Lebanon",
        "iso3": "LBN",
        "iso2": "LB",
        "phone_code": "961",
        "capital": "Beirut",
        "currency": "LBP",
        "currency_symbol": "Â£",
        "tld": ".lb",
        "native": "Ù„Ø¨Ù†Ø§Ù†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Beirut",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë ˆë°”ë…¼",
            "br": "LÃ­bano",
            "pt": "LÃ­bano",
            "nl": "Libanon",
            "hr": "Libanon",
            "fa": "Ù„Ø¨Ù†Ø§Ù†",
            "de": "Libanon",
            "es": "LÃ­bano",
            "fr": "Liban",
            "ja": "ãƒ¬ãƒãƒŽãƒ³",
            "it": "Libano",
            "cn": "é»Žå·´å«©"
        },
        "latitude": "33.83333333",
        "longitude": "35.83333333",
        "emoji": "ðŸ‡±ðŸ‡§",
        "emojiU": "U+1F1F1 U+1F1E7",
        "states": [
            {
                "id": 2285,
                "name": "Akkar Governorate",
                "state_code": "AK",
                "latitude": "34.53287630",
                "longitude": "36.13281320"
            },
            {
                "id": 2283,
                "name": "Baalbek-Hermel Governorate",
                "state_code": "BH",
                "latitude": "34.26585560",
                "longitude": "36.34980970"
            },
            {
                "id": 2286,
                "name": "Beirut Governorate",
                "state_code": "BA",
                "latitude": "33.88861060",
                "longitude": "35.49547720"
            },
            {
                "id": 2287,
                "name": "Beqaa Governorate",
                "state_code": "BI",
                "latitude": "33.84626620",
                "longitude": "35.90194890"
            },
            {
                "id": 2282,
                "name": "Mount Lebanon Governorate",
                "state_code": "JL",
                "latitude": "33.81008580",
                "longitude": "35.59731390"
            },
            {
                "id": 2288,
                "name": "Nabatieh Governorate",
                "state_code": "NA",
                "latitude": "33.37716930",
                "longitude": "35.48382930"
            },
            {
                "id": 2284,
                "name": "North Governorate",
                "state_code": "AS",
                "latitude": "34.43806250",
                "longitude": "35.83082330"
            },
            {
                "id": 2281,
                "name": "South Governorate",
                "state_code": "JA",
                "latitude": "33.27214790",
                "longitude": "35.20327780"
            }
        ]
    },
    {
        "name": "Lesotho",
        "iso3": "LSO",
        "iso2": "LS",
        "phone_code": "266",
        "capital": "Maseru",
        "currency": "LSL",
        "currency_symbol": "L",
        "tld": ".ls",
        "native": "Lesotho",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Maseru",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "kr": "ë ˆì†Œí† ",
            "br": "Lesoto",
            "pt": "Lesoto",
            "nl": "Lesotho",
            "hr": "Lesoto",
            "fa": "Ù„Ø³ÙˆØªÙˆ",
            "de": "Lesotho",
            "es": "Lesotho",
            "fr": "Lesotho",
            "ja": "ãƒ¬ã‚½ãƒˆ",
            "it": "Lesotho",
            "cn": "èŽ±ç´¢æ‰˜"
        },
        "latitude": "-29.50000000",
        "longitude": "28.50000000",
        "emoji": "ðŸ‡±ðŸ‡¸",
        "emojiU": "U+1F1F1 U+1F1F8",
        "states": [
            {
                "id": 3030,
                "name": "Berea District",
                "state_code": "D",
                "latitude": "41.36616140",
                "longitude": "-81.85430260"
            },
            {
                "id": 3029,
                "name": "Butha-Buthe District",
                "state_code": "B",
                "latitude": "-28.76537540",
                "longitude": "28.24681480"
            },
            {
                "id": 3026,
                "name": "Leribe District",
                "state_code": "C",
                "latitude": "-28.86380650",
                "longitude": "28.04788260"
            },
            {
                "id": 3022,
                "name": "Mafeteng District",
                "state_code": "E",
                "latitude": "-29.80410080",
                "longitude": "27.50261740"
            },
            {
                "id": 3028,
                "name": "Maseru District",
                "state_code": "A",
                "latitude": "-29.51656500",
                "longitude": "27.83114280"
            },
            {
                "id": 3023,
                "name": "Mohale's Hoek District",
                "state_code": "F",
                "latitude": "-30.14259170",
                "longitude": "27.46738450"
            },
            {
                "id": 3024,
                "name": "Mokhotlong District",
                "state_code": "J",
                "latitude": "-29.25731930",
                "longitude": "28.95286450"
            },
            {
                "id": 3025,
                "name": "Qacha's Nek District",
                "state_code": "H",
                "latitude": "-30.11145650",
                "longitude": "28.67897900"
            },
            {
                "id": 3027,
                "name": "Quthing District",
                "state_code": "G",
                "latitude": "-30.40156870",
                "longitude": "27.70801330"
            },
            {
                "id": 3031,
                "name": "Thaba-Tseka District",
                "state_code": "K",
                "latitude": "-29.52389750",
                "longitude": "28.60897520"
            }
        ]
    },
    {
        "name": "Liberia",
        "iso3": "LBR",
        "iso2": "LR",
        "phone_code": "231",
        "capital": "Monrovia",
        "currency": "LRD",
        "currency_symbol": "$",
        "tld": ".lr",
        "native": "Liberia",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Monrovia",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ë¼ì´ë² ë¦¬ì•„",
            "br": "LibÃ©ria",
            "pt": "LibÃ©ria",
            "nl": "Liberia",
            "hr": "Liberija",
            "fa": "Ù„ÛŒØ¨Ø±ÛŒØ§",
            "de": "Liberia",
            "es": "Liberia",
            "fr": "Liberia",
            "ja": "ãƒªãƒ™ãƒªã‚¢",
            "it": "Liberia",
            "cn": "åˆ©æ¯”é‡Œäºš"
        },
        "latitude": "6.50000000",
        "longitude": "-9.50000000",
        "emoji": "ðŸ‡±ðŸ‡·",
        "emojiU": "U+1F1F1 U+1F1F7",
        "states": [
            {
                "id": 3041,
                "name": "Bomi County",
                "state_code": "BM",
                "latitude": "6.75629260",
                "longitude": "-10.84514670"
            },
            {
                "id": 3034,
                "name": "Bong County",
                "state_code": "BG",
                "latitude": "6.82950190",
                "longitude": "-9.36730840"
            },
            {
                "id": 3044,
                "name": "Gbarpolu County",
                "state_code": "GP",
                "latitude": "7.49526370",
                "longitude": "-10.08072980"
            },
            {
                "id": 3040,
                "name": "Grand Bassa County",
                "state_code": "GB",
                "latitude": "6.23084520",
                "longitude": "-9.81249350"
            },
            {
                "id": 3036,
                "name": "Grand Cape Mount County",
                "state_code": "CM",
                "latitude": "7.04677580",
                "longitude": "-11.07117580"
            },
            {
                "id": 3039,
                "name": "Grand Gedeh County",
                "state_code": "GG",
                "latitude": "5.92220780",
                "longitude": "-8.22129790"
            },
            {
                "id": 3045,
                "name": "Grand Kru County",
                "state_code": "GK",
                "latitude": "4.76138620",
                "longitude": "-8.22129790"
            },
            {
                "id": 3037,
                "name": "Lofa County",
                "state_code": "LO",
                "latitude": "8.19111840",
                "longitude": "-9.72326730"
            },
            {
                "id": 3043,
                "name": "Margibi County",
                "state_code": "MG",
                "latitude": "6.51518750",
                "longitude": "-10.30488970"
            },
            {
                "id": 3042,
                "name": "Maryland County",
                "state_code": "MY",
                "latitude": "39.04575490",
                "longitude": "-76.64127120"
            },
            {
                "id": 3032,
                "name": "Montserrado County",
                "state_code": "MO",
                "latitude": "6.55258150",
                "longitude": "-10.52961150"
            },
            {
                "id": 3046,
                "name": "Nimba",
                "state_code": "NI",
                "latitude": "7.61666670",
                "longitude": "-8.41666670"
            },
            {
                "id": 3033,
                "name": "River Cess County",
                "state_code": "RI",
                "latitude": "5.90253280",
                "longitude": "-9.45615500"
            },
            {
                "id": 3038,
                "name": "River Gee County",
                "state_code": "RG",
                "latitude": "5.26048940",
                "longitude": "-7.87216000"
            },
            {
                "id": 3035,
                "name": "Sinoe County",
                "state_code": "SI",
                "latitude": "5.49871000",
                "longitude": "-8.66005860"
            }
        ]
    },
    {
        "name": "Libya",
        "iso3": "LBY",
        "iso2": "LY",
        "phone_code": "218",
        "capital": "Tripolis",
        "currency": "LYD",
        "currency_symbol": "Ø¯.Ù„",
        "tld": ".ly",
        "native": "â€Ù„ÙŠØ¨ÙŠØ§",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Tripoli",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë¦¬ë¹„ì•„",
            "br": "LÃ­bia",
            "pt": "LÃ­bia",
            "nl": "LibiÃ«",
            "hr": "Libija",
            "fa": "Ù„ÛŒØ¨ÛŒ",
            "de": "Libyen",
            "es": "Libia",
            "fr": "Libye",
            "ja": "ãƒªãƒ“ã‚¢",
            "it": "Libia",
            "cn": "åˆ©æ¯”äºš"
        },
        "latitude": "25.00000000",
        "longitude": "17.00000000",
        "emoji": "ðŸ‡±ðŸ‡¾",
        "emojiU": "U+1F1F1 U+1F1FE",
        "states": [
            {
                "id": 2964,
                "name": "Al Wahat District",
                "state_code": "WA",
                "latitude": "29.04668080",
                "longitude": "21.85685860"
            },
            {
                "id": 2981,
                "name": "Benghazi",
                "state_code": "BA",
                "latitude": "32.11942420",
                "longitude": "20.08679090"
            },
            {
                "id": 2966,
                "name": "Derna District",
                "state_code": "DR",
                "latitude": "32.75561300",
                "longitude": "22.63774320"
            },
            {
                "id": 2969,
                "name": "Ghat District",
                "state_code": "GT",
                "latitude": "24.96403710",
                "longitude": "10.17592850"
            },
            {
                "id": 2980,
                "name": "Jabal al Akhdar",
                "state_code": "JA",
                "latitude": "23.18560810",
                "longitude": "57.37138790"
            },
            {
                "id": 2974,
                "name": "Jabal al Gharbi District",
                "state_code": "JG",
                "latitude": "30.26380320",
                "longitude": "12.80547530"
            },
            {
                "id": 2979,
                "name": "Jafara",
                "state_code": "JI",
                "latitude": "32.45259040",
                "longitude": "12.94355360"
            },
            {
                "id": 2970,
                "name": "Jufra",
                "state_code": "JU",
                "latitude": "27.98351350",
                "longitude": "16.91225100"
            },
            {
                "id": 2972,
                "name": "Kufra District",
                "state_code": "KF",
                "latitude": "23.31123890",
                "longitude": "21.85685860"
            },
            {
                "id": 2968,
                "name": "Marj District",
                "state_code": "MJ",
                "latitude": "32.05503630",
                "longitude": "21.18911510"
            },
            {
                "id": 2978,
                "name": "Misrata District",
                "state_code": "MI",
                "latitude": "32.32558840",
                "longitude": "15.09925560"
            },
            {
                "id": 2961,
                "name": "Murqub",
                "state_code": "MB",
                "latitude": "32.45996770",
                "longitude": "14.10013260"
            },
            {
                "id": 2967,
                "name": "Murzuq District",
                "state_code": "MQ",
                "latitude": "25.91822620",
                "longitude": "13.92600010"
            },
            {
                "id": 2976,
                "name": "Nalut District",
                "state_code": "NL",
                "latitude": "31.87423480",
                "longitude": "10.97504840"
            },
            {
                "id": 2962,
                "name": "Nuqat al Khams",
                "state_code": "NQ",
                "latitude": "32.69149090",
                "longitude": "11.88917210"
            },
            {
                "id": 2965,
                "name": "Sabha District",
                "state_code": "SB",
                "latitude": "27.03654060",
                "longitude": "14.42902360"
            },
            {
                "id": 2977,
                "name": "Sirte District",
                "state_code": "SR",
                "latitude": "31.18968900",
                "longitude": "16.57019270"
            },
            {
                "id": 2971,
                "name": "Tripoli District",
                "state_code": "TB",
                "latitude": "32.64080210",
                "longitude": "13.26634790"
            },
            {
                "id": 2973,
                "name": "Wadi al Hayaa District",
                "state_code": "WD",
                "latitude": "26.42259260",
                "longitude": "12.62162110"
            },
            {
                "id": 2975,
                "name": "Wadi al Shatii District",
                "state_code": "WS",
                "latitude": "27.73514680",
                "longitude": "12.43805810"
            },
            {
                "id": 2963,
                "name": "Zawiya District",
                "state_code": "ZA",
                "latitude": "32.76302820",
                "longitude": "12.73649620"
            }
        ]
    },
    {
        "name": "Liechtenstein",
        "iso3": "LIE",
        "iso2": "LI",
        "phone_code": "423",
        "capital": "Vaduz",
        "currency": "CHF",
        "currency_symbol": "CHf",
        "tld": ".li",
        "native": "Liechtenstein",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Vaduz",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë¦¬ížˆí…ìŠˆíƒ€ì¸",
            "br": "Liechtenstein",
            "pt": "Listenstaine",
            "nl": "Liechtenstein",
            "hr": "LihtenÅ¡tajn",
            "fa": "Ù„ÛŒØ®ØªÙ†â€ŒØ§Ø´ØªØ§ÛŒÙ†",
            "de": "Liechtenstein",
            "es": "Liechtenstein",
            "fr": "Liechtenstein",
            "ja": "ãƒªãƒ’ãƒ†ãƒ³ã‚·ãƒ¥ã‚¿ã‚¤ãƒ³",
            "it": "Liechtenstein",
            "cn": "åˆ—æ”¯æ•¦å£«ç™»"
        },
        "latitude": "47.26666666",
        "longitude": "9.53333333",
        "emoji": "ðŸ‡±ðŸ‡®",
        "emojiU": "U+1F1F1 U+1F1EE",
        "states": [
            {
                "id": 458,
                "name": "Balzers",
                "state_code": "01",
                "latitude": "42.05283570",
                "longitude": "-88.03668480"
            },
            {
                "id": 451,
                "name": "Eschen",
                "state_code": "02",
                "latitude": "40.76695740",
                "longitude": "-73.95228210"
            },
            {
                "id": 457,
                "name": "Gamprin",
                "state_code": "03",
                "latitude": "47.21324900",
                "longitude": "9.50251950"
            },
            {
                "id": 455,
                "name": "Mauren",
                "state_code": "04",
                "latitude": "47.21892850",
                "longitude": "9.54173500"
            },
            {
                "id": 454,
                "name": "Planken",
                "state_code": "05",
                "latitude": "40.66505760",
                "longitude": "-73.50479800"
            },
            {
                "id": 453,
                "name": "Ruggell",
                "state_code": "06",
                "latitude": "47.25292220",
                "longitude": "9.54021270"
            },
            {
                "id": 450,
                "name": "Schaan",
                "state_code": "07",
                "latitude": "47.12043400",
                "longitude": "9.59416020"
            },
            {
                "id": 449,
                "name": "Schellenberg",
                "state_code": "08",
                "latitude": "47.23096600",
                "longitude": "9.54678430"
            },
            {
                "id": 459,
                "name": "Triesen",
                "state_code": "09",
                "latitude": "47.10979880",
                "longitude": "9.52482960"
            },
            {
                "id": 456,
                "name": "Triesenberg",
                "state_code": "10",
                "latitude": "47.12245110",
                "longitude": "9.57019850"
            },
            {
                "id": 452,
                "name": "Vaduz",
                "state_code": "11",
                "latitude": "47.14103030",
                "longitude": "9.52092770"
            }
        ]
    },
    {
        "name": "Lithuania",
        "iso3": "LTU",
        "iso2": "LT",
        "phone_code": "370",
        "capital": "Vilnius",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".lt",
        "native": "Lietuva",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Vilnius",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë¦¬íˆ¬ì•„ë‹ˆì•„",
            "br": "LituÃ¢nia",
            "pt": "LituÃ¢nia",
            "nl": "Litouwen",
            "hr": "Litva",
            "fa": "Ù„ÛŒØªÙˆØ§Ù†ÛŒ",
            "de": "Litauen",
            "es": "Lituania",
            "fr": "Lituanie",
            "ja": "ãƒªãƒˆã‚¢ãƒ‹ã‚¢",
            "it": "Lituania",
            "cn": "ç«‹é™¶å®›"
        },
        "latitude": "56.00000000",
        "longitude": "24.00000000",
        "emoji": "ðŸ‡±ðŸ‡¹",
        "emojiU": "U+1F1F1 U+1F1F9",
        "states": [
            {
                "id": 1561,
                "name": "AkmenÄ— District Municipality",
                "state_code": "01",
                "latitude": "56.24550290",
                "longitude": "22.74711690"
            },
            {
                "id": 1605,
                "name": "Alytus City Municipality",
                "state_code": "02",
                "latitude": "54.39629380",
                "longitude": "24.04587610"
            },
            {
                "id": 1574,
                "name": "Alytus County",
                "state_code": "AL",
                "latitude": "54.20002140",
                "longitude": "24.15126340"
            },
            {
                "id": 1599,
                "name": "Alytus District Municipality",
                "state_code": "03",
                "latitude": "54.32974960",
                "longitude": "24.19609310"
            },
            {
                "id": 1603,
                "name": "BirÅ¡tonas Municipality",
                "state_code": "05",
                "latitude": "54.56696640",
                "longitude": "24.00930980"
            },
            {
                "id": 1566,
                "name": "BirÅ¾ai District Municipality",
                "state_code": "06",
                "latitude": "56.20177190",
                "longitude": "24.75601180"
            },
            {
                "id": 1579,
                "name": "Druskininkai municipality",
                "state_code": "07",
                "latitude": "53.99336850",
                "longitude": "24.03424380"
            },
            {
                "id": 1559,
                "name": "ElektrÄ—nai municipality",
                "state_code": "08",
                "latitude": "54.76539340",
                "longitude": "24.77405830"
            },
            {
                "id": 1562,
                "name": "Ignalina District Municipality",
                "state_code": "09",
                "latitude": "55.40903420",
                "longitude": "26.32848930"
            },
            {
                "id": 1567,
                "name": "Jonava District Municipality",
                "state_code": "10",
                "latitude": "55.07272420",
                "longitude": "24.27933370"
            },
            {
                "id": 1581,
                "name": "JoniÅ¡kis District Municipality",
                "state_code": "11",
                "latitude": "56.23607300",
                "longitude": "23.61365790"
            },
            {
                "id": 1555,
                "name": "Jurbarkas District Municipality",
                "state_code": "12",
                "latitude": "55.07740700",
                "longitude": "22.74195690"
            },
            {
                "id": 1583,
                "name": "KaiÅ¡iadorys District Municipality",
                "state_code": "13",
                "latitude": "54.85886690",
                "longitude": "24.42779290"
            },
            {
                "id": 1591,
                "name": "Kalvarija municipality",
                "state_code": "14",
                "latitude": "54.37616740",
                "longitude": "23.19203210"
            },
            {
                "id": 1580,
                "name": "Kaunas City Municipality",
                "state_code": "15",
                "latitude": "54.91453260",
                "longitude": "23.90535180"
            },
            {
                "id": 1556,
                "name": "Kaunas County",
                "state_code": "KU",
                "latitude": "54.98728630",
                "longitude": "23.95257360"
            },
            {
                "id": 1565,
                "name": "Kaunas District Municipality",
                "state_code": "16",
                "latitude": "54.99362360",
                "longitude": "23.63249410"
            },
            {
                "id": 1575,
                "name": "KazlÅ³ RÅ«da municipality",
                "state_code": "17",
                "latitude": "54.78075260",
                "longitude": "23.48402430"
            },
            {
                "id": 1584,
                "name": "KÄ—dainiai District Municipality",
                "state_code": "18",
                "latitude": "55.35609470",
                "longitude": "23.98326830"
            },
            {
                "id": 1618,
                "name": "KelmÄ— District Municipality",
                "state_code": "19",
                "latitude": "55.62663520",
                "longitude": "22.87817200"
            },
            {
                "id": 1597,
                "name": "Klaipeda City Municipality",
                "state_code": "20",
                "latitude": "55.70329480",
                "longitude": "21.14427950"
            },
            {
                "id": 1600,
                "name": "KlaipÄ—da County",
                "state_code": "KL",
                "latitude": "55.65197440",
                "longitude": "21.37439560"
            },
            {
                "id": 1604,
                "name": "KlaipÄ—da District Municipality",
                "state_code": "21",
                "latitude": "55.68416150",
                "longitude": "21.44164640"
            },
            {
                "id": 1571,
                "name": "Kretinga District Municipality",
                "state_code": "22",
                "latitude": "55.88384200",
                "longitude": "21.23509190"
            },
            {
                "id": 1585,
                "name": "KupiÅ¡kis District Municipality",
                "state_code": "23",
                "latitude": "55.84287410",
                "longitude": "25.02958160"
            },
            {
                "id": 1611,
                "name": "Lazdijai District Municipality",
                "state_code": "24",
                "latitude": "54.23432670",
                "longitude": "23.51565050"
            },
            {
                "id": 1570,
                "name": "MarijampolÄ— County",
                "state_code": "MR",
                "latitude": "54.78199710",
                "longitude": "23.13413650"
            },
            {
                "id": 1610,
                "name": "MarijampolÄ— Municipality",
                "state_code": "25",
                "latitude": "54.57110940",
                "longitude": "23.48593710"
            },
            {
                "id": 1557,
                "name": "MaÅ¾eikiai District Municipality",
                "state_code": "26",
                "latitude": "56.30924390",
                "longitude": "22.34146800"
            },
            {
                "id": 1582,
                "name": "MolÄ—tai District Municipality",
                "state_code": "27",
                "latitude": "55.22653090",
                "longitude": "25.41800110"
            },
            {
                "id": 1563,
                "name": "Neringa Municipality",
                "state_code": "28",
                "latitude": "55.45724030",
                "longitude": "21.08390050"
            },
            {
                "id": 1612,
                "name": "PagÄ—giai municipality",
                "state_code": "29",
                "latitude": "55.17213200",
                "longitude": "21.96836140"
            },
            {
                "id": 1595,
                "name": "Pakruojis District Municipality",
                "state_code": "30",
                "latitude": "56.07326050",
                "longitude": "23.93899060"
            },
            {
                "id": 1588,
                "name": "Palanga City Municipality",
                "state_code": "31",
                "latitude": "55.92019800",
                "longitude": "21.06776140"
            },
            {
                "id": 1589,
                "name": "PanevÄ—Å¾ys City Municipality",
                "state_code": "32",
                "latitude": "55.73479150",
                "longitude": "24.35747740"
            },
            {
                "id": 1558,
                "name": "PanevÄ—Å¾ys County",
                "state_code": "PN",
                "latitude": "55.97480490",
                "longitude": "25.07947670"
            },
            {
                "id": 1614,
                "name": "PanevÄ—Å¾ys District Municipality",
                "state_code": "33",
                "latitude": "55.61667280",
                "longitude": "24.31422830"
            },
            {
                "id": 1616,
                "name": "Pasvalys District Municipality",
                "state_code": "34",
                "latitude": "56.06046190",
                "longitude": "24.39629100"
            },
            {
                "id": 1553,
                "name": "PlungÄ— District Municipality",
                "state_code": "35",
                "latitude": "55.91078400",
                "longitude": "21.84540690"
            },
            {
                "id": 1578,
                "name": "Prienai District Municipality",
                "state_code": "36",
                "latitude": "54.63835800",
                "longitude": "23.94680090"
            },
            {
                "id": 1568,
                "name": "RadviliÅ¡kis District Municipality",
                "state_code": "37",
                "latitude": "55.81083990",
                "longitude": "23.54648700"
            },
            {
                "id": 1587,
                "name": "Raseiniai District Municipality",
                "state_code": "38",
                "latitude": "55.38194990",
                "longitude": "23.11561290"
            },
            {
                "id": 1590,
                "name": "Rietavas municipality",
                "state_code": "39",
                "latitude": "55.70217190",
                "longitude": "21.99865640"
            },
            {
                "id": 1615,
                "name": "RokiÅ¡kis District Municipality",
                "state_code": "40",
                "latitude": "55.95550390",
                "longitude": "25.58592490"
            },
            {
                "id": 1576,
                "name": "Å akiai District Municipality",
                "state_code": "41",
                "latitude": "54.95267100",
                "longitude": "23.04801990"
            },
            {
                "id": 1577,
                "name": "Å alÄininkai District Municipality",
                "state_code": "42",
                "latitude": "54.30976700",
                "longitude": "25.38756400"
            },
            {
                "id": 1609,
                "name": "Å iauliai City Municipality",
                "state_code": "43",
                "latitude": "55.93490850",
                "longitude": "23.31368230"
            },
            {
                "id": 1586,
                "name": "Å iauliai County",
                "state_code": "SA",
                "latitude": "55.99857510",
                "longitude": "23.13800510"
            },
            {
                "id": 1554,
                "name": "Å iauliai District Municipality",
                "state_code": "44",
                "latitude": "55.97214560",
                "longitude": "23.03323710"
            },
            {
                "id": 1613,
                "name": "Å ilalÄ— District Municipality",
                "state_code": "45",
                "latitude": "55.49268000",
                "longitude": "22.18455590"
            },
            {
                "id": 1607,
                "name": "Å ilutÄ— District Municipality",
                "state_code": "46",
                "latitude": "55.35041400",
                "longitude": "21.46598590"
            },
            {
                "id": 1594,
                "name": "Å irvintos District Municipality",
                "state_code": "47",
                "latitude": "55.04310200",
                "longitude": "24.95698100"
            },
            {
                "id": 1617,
                "name": "Skuodas District Municipality",
                "state_code": "48",
                "latitude": "56.27021690",
                "longitude": "21.52143310"
            },
            {
                "id": 1560,
                "name": "Å venÄionys District Municipality",
                "state_code": "49",
                "latitude": "55.10280980",
                "longitude": "26.00718550"
            },
            {
                "id": 1573,
                "name": "TauragÄ— County",
                "state_code": "TA",
                "latitude": "55.30725860",
                "longitude": "22.35729390"
            },
            {
                "id": 1572,
                "name": "TauragÄ— District Municipality",
                "state_code": "50",
                "latitude": "55.25036600",
                "longitude": "22.29095000"
            },
            {
                "id": 1569,
                "name": "TelÅ¡iai County",
                "state_code": "TE",
                "latitude": "56.10266160",
                "longitude": "22.11139150"
            },
            {
                "id": 1608,
                "name": "TelÅ¡iai District Municipality",
                "state_code": "51",
                "latitude": "55.91752150",
                "longitude": "22.34518400"
            },
            {
                "id": 1593,
                "name": "Trakai District Municipality",
                "state_code": "52",
                "latitude": "54.63791130",
                "longitude": "24.93468940"
            },
            {
                "id": 1596,
                "name": "UkmergÄ— District Municipality",
                "state_code": "53",
                "latitude": "55.24526500",
                "longitude": "24.77607490"
            },
            {
                "id": 1621,
                "name": "Utena County",
                "state_code": "UT",
                "latitude": "55.53189690",
                "longitude": "25.79046990"
            },
            {
                "id": 1598,
                "name": "Utena District Municipality",
                "state_code": "54",
                "latitude": "55.50846140",
                "longitude": "25.68326420"
            },
            {
                "id": 1602,
                "name": "VarÄ—na District Municipality",
                "state_code": "55",
                "latitude": "54.22033300",
                "longitude": "24.57899700"
            },
            {
                "id": 1620,
                "name": "VilkaviÅ¡kis District Municipality",
                "state_code": "56",
                "latitude": "54.65194500",
                "longitude": "23.03515500"
            },
            {
                "id": 1606,
                "name": "Vilnius City Municipality",
                "state_code": "57",
                "latitude": "54.67107610",
                "longitude": "25.28787210"
            },
            {
                "id": 1601,
                "name": "Vilnius County",
                "state_code": "VL",
                "latitude": "54.80865020",
                "longitude": "25.21821390"
            },
            {
                "id": 1592,
                "name": "Vilnius District Municipality",
                "state_code": "58",
                "latitude": "54.77325780",
                "longitude": "25.58671130"
            },
            {
                "id": 1564,
                "name": "Visaginas Municipality",
                "state_code": "59",
                "latitude": "55.59411800",
                "longitude": "26.43079540"
            },
            {
                "id": 1619,
                "name": "Zarasai District Municipality",
                "state_code": "60",
                "latitude": "55.73096090",
                "longitude": "26.24529500"
            }
        ]
    },
    {
        "name": "Luxembourg",
        "iso3": "LUX",
        "iso2": "LU",
        "phone_code": "352",
        "capital": "Luxembourg",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".lu",
        "native": "Luxembourg",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Luxembourg",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë£©ì…ˆë¶€ë¥´í¬",
            "br": "Luxemburgo",
            "pt": "Luxemburgo",
            "nl": "Luxemburg",
            "hr": "Luksemburg",
            "fa": "Ù„ÙˆÚ©Ø²Ø§Ù…Ø¨ÙˆØ±Ú¯",
            "de": "Luxemburg",
            "es": "Luxemburgo",
            "fr": "Luxembourg",
            "ja": "ãƒ«ã‚¯ã‚»ãƒ³ãƒ–ãƒ«ã‚¯",
            "it": "Lussemburgo",
            "cn": "å¢æ£®å ¡"
        },
        "latitude": "49.75000000",
        "longitude": "6.16666666",
        "emoji": "ðŸ‡±ðŸ‡º",
        "emojiU": "U+1F1F1 U+1F1FA",
        "states": [
            {
                "id": 1518,
                "name": "Canton of Capellen",
                "state_code": "CA",
                "latitude": "49.64039310",
                "longitude": "5.95538460"
            },
            {
                "id": 1521,
                "name": "Canton of Clervaux",
                "state_code": "CL",
                "latitude": "50.05463130",
                "longitude": "6.02858750"
            },
            {
                "id": 1513,
                "name": "Canton of Diekirch",
                "state_code": "DI",
                "latitude": "49.86717840",
                "longitude": "6.15956330"
            },
            {
                "id": 1515,
                "name": "Canton of Echternach",
                "state_code": "EC",
                "latitude": "49.81141330",
                "longitude": "6.41756350"
            },
            {
                "id": 1517,
                "name": "Canton of Esch-sur-Alzette",
                "state_code": "ES",
                "latitude": "49.50088050",
                "longitude": "5.98609250"
            },
            {
                "id": 1525,
                "name": "Canton of Grevenmacher",
                "state_code": "GR",
                "latitude": "49.68084100",
                "longitude": "6.44075930"
            },
            {
                "id": 1527,
                "name": "Canton of Luxembourg",
                "state_code": "LU",
                "latitude": "49.63010250",
                "longitude": "6.15201850"
            },
            {
                "id": 1522,
                "name": "Canton of Mersch",
                "state_code": "ME",
                "latitude": "49.75429060",
                "longitude": "6.12921850"
            },
            {
                "id": 1516,
                "name": "Canton of Redange",
                "state_code": "RD",
                "latitude": "49.76455000",
                "longitude": "5.88948000"
            },
            {
                "id": 1519,
                "name": "Canton of Remich",
                "state_code": "RM",
                "latitude": "49.54501700",
                "longitude": "6.36742220"
            },
            {
                "id": 1523,
                "name": "Canton of Vianden",
                "state_code": "VD",
                "latitude": "49.93419240",
                "longitude": "6.20199170"
            },
            {
                "id": 1526,
                "name": "Canton of Wiltz",
                "state_code": "WI",
                "latitude": "49.96622000",
                "longitude": "5.93243060"
            },
            {
                "id": 1524,
                "name": "Diekirch District",
                "state_code": "D",
                "latitude": "49.86717200",
                "longitude": "6.15963620"
            },
            {
                "id": 1520,
                "name": "Grevenmacher District",
                "state_code": "G",
                "latitude": "49.68085100",
                "longitude": "6.44075240"
            },
            {
                "id": 1514,
                "name": "Luxembourg District",
                "state_code": "L",
                "latitude": "49.59537060",
                "longitude": "6.13331780"
            }
        ]
    },
    {
        "name": "Macau S.A.R.",
        "iso3": "MAC",
        "iso2": "MO",
        "phone_code": "853",
        "capital": "Macao",
        "currency": "MOP",
        "currency_symbol": "$",
        "tld": ".mo",
        "native": "æ¾³é–€",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Macau",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆì¹´ì˜¤",
            "br": "Macau",
            "pt": "Macau",
            "nl": "Macao",
            "hr": "Makao",
            "fa": "Ù…Ú©Ø§Ø¦Ùˆ",
            "de": "Macao",
            "es": "Macao",
            "fr": "Macao",
            "ja": "ãƒžã‚«ã‚ª",
            "it": "Macao",
            "cn": "ä¸­å›½æ¾³é—¨"
        },
        "latitude": "22.16666666",
        "longitude": "113.55000000",
        "emoji": "ðŸ‡²ðŸ‡´",
        "emojiU": "U+1F1F2 U+1F1F4",
        "states": []
    },
    {
        "name": "Macedonia",
        "iso3": "MKD",
        "iso2": "MK",
        "phone_code": "389",
        "capital": "Skopje",
        "currency": "MKD",
        "currency_symbol": "Ð´ÐµÐ½",
        "tld": ".mk",
        "native": "Ð¡ÐµÐ²ÐµÑ€Ð½Ð° ÐœÐ°ÐºÐµÐ´Ð¾Ð½Ð¸Ñ˜Ð°",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Skopje",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆì¼€ë„ë‹ˆì•„",
            "br": "MacedÃ´nia",
            "pt": "MacedÃ³nia",
            "nl": "MacedoniÃ«",
            "hr": "Makedonija",
            "fa": "",
            "de": "Mazedonien",
            "es": "Macedonia",
            "fr": "MacÃ©doine",
            "ja": "ãƒžã‚±ãƒ‰ãƒ‹ã‚¢æ—§ãƒ¦ãƒ¼ã‚´ã‚¹ãƒ©ãƒ“ã‚¢å…±å’Œå›½",
            "it": "Macedonia",
            "cn": "é©¬å…¶é¡¿"
        },
        "latitude": "41.83333333",
        "longitude": "22.00000000",
        "emoji": "ðŸ‡²ðŸ‡°",
        "emojiU": "U+1F1F2 U+1F1F0",
        "states": [
            {
                "id": 703,
                "name": "Aerodrom Municipality",
                "state_code": "01",
                "latitude": "41.94643630",
                "longitude": "21.49317130"
            },
            {
                "id": 656,
                "name": "AraÄinovo Municipality",
                "state_code": "02",
                "latitude": "42.02473810",
                "longitude": "21.57664070"
            },
            {
                "id": 716,
                "name": "Berovo Municipality",
                "state_code": "03",
                "latitude": "41.66619290",
                "longitude": "22.76288300"
            },
            {
                "id": 679,
                "name": "Bitola Municipality",
                "state_code": "04",
                "latitude": "41.03633020",
                "longitude": "21.33219740"
            },
            {
                "id": 649,
                "name": "Bogdanci Municipality",
                "state_code": "05",
                "latitude": "41.18696160",
                "longitude": "22.59602680"
            },
            {
                "id": 721,
                "name": "Bogovinje Municipality",
                "state_code": "06",
                "latitude": "41.92363710",
                "longitude": "20.91638870"
            },
            {
                "id": 652,
                "name": "Bosilovo Municipality",
                "state_code": "07",
                "latitude": "41.49048640",
                "longitude": "22.78671740"
            },
            {
                "id": 660,
                "name": "Brvenica Municipality",
                "state_code": "08",
                "latitude": "41.96814820",
                "longitude": "20.98195860"
            },
            {
                "id": 694,
                "name": "Butel Municipality",
                "state_code": "09",
                "latitude": "42.08950680",
                "longitude": "21.46336100"
            },
            {
                "id": 704,
                "name": "ÄŒair Municipality",
                "state_code": "79",
                "latitude": "41.99303550",
                "longitude": "21.43653180"
            },
            {
                "id": 676,
                "name": "ÄŒaÅ¡ka Municipality",
                "state_code": "80",
                "latitude": "41.64743800",
                "longitude": "21.69141150"
            },
            {
                "id": 702,
                "name": "Centar Municipality",
                "state_code": "77",
                "latitude": "41.96989340",
                "longitude": "21.42162670"
            },
            {
                "id": 720,
                "name": "Centar Å½upa Municipality",
                "state_code": "78",
                "latitude": "41.46522590",
                "longitude": "20.59305480"
            },
            {
                "id": 644,
                "name": "ÄŒeÅ¡inovo-ObleÅ¡evo Municipality",
                "state_code": "81",
                "latitude": "41.86393160",
                "longitude": "22.26224600"
            },
            {
                "id": 715,
                "name": "ÄŒuÄer-Sandevo Municipality",
                "state_code": "82",
                "latitude": "42.14839460",
                "longitude": "21.40374070"
            },
            {
                "id": 645,
                "name": "Debarca Municipality",
                "state_code": "22",
                "latitude": "41.35840770",
                "longitude": "20.85529190"
            },
            {
                "id": 695,
                "name": "DelÄevo Municipality",
                "state_code": "23",
                "latitude": "41.96843870",
                "longitude": "22.76288300"
            },
            {
                "id": 687,
                "name": "Demir Hisar Municipality",
                "state_code": "25",
                "latitude": "41.22708300",
                "longitude": "21.14142260"
            },
            {
                "id": 655,
                "name": "Demir Kapija Municipality",
                "state_code": "24",
                "latitude": "41.37955380",
                "longitude": "22.21455710"
            },
            {
                "id": 697,
                "name": "Dojran Municipality",
                "state_code": "26",
                "latitude": "41.24366720",
                "longitude": "22.69137640"
            },
            {
                "id": 675,
                "name": "Dolneni Municipality",
                "state_code": "27",
                "latitude": "41.46409350",
                "longitude": "21.40374070"
            },
            {
                "id": 657,
                "name": "Drugovo Municipality",
                "state_code": "28",
                "latitude": "41.44081530",
                "longitude": "20.92682010"
            },
            {
                "id": 707,
                "name": "Gazi Baba Municipality",
                "state_code": "17",
                "latitude": "42.01629610",
                "longitude": "21.49913340"
            },
            {
                "id": 648,
                "name": "Gevgelija Municipality",
                "state_code": "18",
                "latitude": "41.21186060",
                "longitude": "22.38146240"
            },
            {
                "id": 722,
                "name": "GjorÄe Petrov Municipality",
                "state_code": "29",
                "latitude": "42.06063740",
                "longitude": "21.32027360"
            },
            {
                "id": 693,
                "name": "Gostivar Municipality",
                "state_code": "19",
                "latitude": "41.80255410",
                "longitude": "20.90893780"
            },
            {
                "id": 708,
                "name": "Gradsko Municipality",
                "state_code": "20",
                "latitude": "41.59916080",
                "longitude": "21.88070640"
            },
            {
                "id": 684,
                "name": "Greater Skopje",
                "state_code": "85",
                "latitude": "41.99812940",
                "longitude": "21.42543550"
            },
            {
                "id": 690,
                "name": "Ilinden Municipality",
                "state_code": "34",
                "latitude": "41.99574430",
                "longitude": "21.56769750"
            },
            {
                "id": 678,
                "name": "Jegunovce Municipality",
                "state_code": "35",
                "latitude": "42.07407200",
                "longitude": "21.12204780"
            },
            {
                "id": 674,
                "name": "Karbinci",
                "state_code": "37",
                "latitude": "41.81801590",
                "longitude": "22.23247580"
            },
            {
                "id": 681,
                "name": "KarpoÅ¡ Municipality",
                "state_code": "38",
                "latitude": "41.97096610",
                "longitude": "21.39181680"
            },
            {
                "id": 713,
                "name": "Kavadarci Municipality",
                "state_code": "36",
                "latitude": "41.28900680",
                "longitude": "21.99994350"
            },
            {
                "id": 688,
                "name": "KiÄevo Municipality",
                "state_code": "40",
                "latitude": "41.51291120",
                "longitude": "20.95250650"
            },
            {
                "id": 686,
                "name": "Kisela Voda Municipality",
                "state_code": "39",
                "latitude": "41.92748000",
                "longitude": "21.49317130"
            },
            {
                "id": 723,
                "name": "KoÄani Municipality",
                "state_code": "42",
                "latitude": "41.98583740",
                "longitude": "22.40530460"
            },
            {
                "id": 665,
                "name": "KonÄe Municipality",
                "state_code": "41",
                "latitude": "41.51710110",
                "longitude": "22.38146240"
            },
            {
                "id": 641,
                "name": "Kratovo Municipality",
                "state_code": "43",
                "latitude": "42.05371410",
                "longitude": "22.07148350"
            },
            {
                "id": 677,
                "name": "Kriva Palanka Municipality",
                "state_code": "44",
                "latitude": "42.20584540",
                "longitude": "22.33079650"
            },
            {
                "id": 647,
                "name": "KrivogaÅ¡tani Municipality",
                "state_code": "45",
                "latitude": "41.30823060",
                "longitude": "21.36796890"
            },
            {
                "id": 714,
                "name": "KruÅ¡evo Municipality",
                "state_code": "46",
                "latitude": "41.37693310",
                "longitude": "21.26065540"
            },
            {
                "id": 683,
                "name": "Kumanovo Municipality",
                "state_code": "47",
                "latitude": "42.07326130",
                "longitude": "21.78531430"
            },
            {
                "id": 659,
                "name": "Lipkovo Municipality",
                "state_code": "48",
                "latitude": "42.20066260",
                "longitude": "21.61837550"
            },
            {
                "id": 705,
                "name": "Lozovo Municipality",
                "state_code": "49",
                "latitude": "41.78181390",
                "longitude": "21.90008270"
            },
            {
                "id": 701,
                "name": "Makedonska Kamenica Municipality",
                "state_code": "51",
                "latitude": "42.06946040",
                "longitude": "22.54834900"
            },
            {
                "id": 692,
                "name": "Makedonski Brod Municipality",
                "state_code": "52",
                "latitude": "41.51330880",
                "longitude": "21.21743290"
            },
            {
                "id": 669,
                "name": "Mavrovo and RostuÅ¡a Municipality",
                "state_code": "50",
                "latitude": "41.60924270",
                "longitude": "20.60124880"
            },
            {
                "id": 653,
                "name": "Mogila Municipality",
                "state_code": "53",
                "latitude": "41.14796450",
                "longitude": "21.45143690"
            },
            {
                "id": 664,
                "name": "Negotino Municipality",
                "state_code": "54",
                "latitude": "41.49899850",
                "longitude": "22.09532970"
            },
            {
                "id": 696,
                "name": "Novaci Municipality",
                "state_code": "55",
                "latitude": "41.04426610",
                "longitude": "21.45888940"
            },
            {
                "id": 718,
                "name": "Novo Selo Municipality",
                "state_code": "56",
                "latitude": "41.43255800",
                "longitude": "22.88204890"
            },
            {
                "id": 699,
                "name": "Ohrid Municipality",
                "state_code": "58",
                "latitude": "41.06820880",
                "longitude": "20.75992660"
            },
            {
                "id": 682,
                "name": "Oslomej Municipality",
                "state_code": "57",
                "latitude": "41.57583910",
                "longitude": "21.02219600"
            },
            {
                "id": 685,
                "name": "PehÄevo Municipality",
                "state_code": "60",
                "latitude": "41.77371320",
                "longitude": "22.88204890"
            },
            {
                "id": 698,
                "name": "Petrovec Municipality",
                "state_code": "59",
                "latitude": "41.90298970",
                "longitude": "21.68992100"
            },
            {
                "id": 670,
                "name": "Plasnica Municipality",
                "state_code": "61",
                "latitude": "41.45463490",
                "longitude": "21.10565390"
            },
            {
                "id": 666,
                "name": "Prilep Municipality",
                "state_code": "62",
                "latitude": "41.26931420",
                "longitude": "21.71376940"
            },
            {
                "id": 646,
                "name": "ProbiÅ¡tip Municipality",
                "state_code": "63",
                "latitude": "41.95891460",
                "longitude": "22.16686700"
            },
            {
                "id": 709,
                "name": "RadoviÅ¡ Municipality",
                "state_code": "64",
                "latitude": "41.64955310",
                "longitude": "22.47682870"
            },
            {
                "id": 717,
                "name": "Rankovce Municipality",
                "state_code": "65",
                "latitude": "42.18081410",
                "longitude": "22.09532970"
            },
            {
                "id": 712,
                "name": "Resen Municipality",
                "state_code": "66",
                "latitude": "40.93680930",
                "longitude": "21.04604070"
            },
            {
                "id": 691,
                "name": "Rosoman Municipality",
                "state_code": "67",
                "latitude": "41.48480060",
                "longitude": "21.88070640"
            },
            {
                "id": 667,
                "name": "Saraj Municipality",
                "state_code": "68",
                "latitude": "41.98694960",
                "longitude": "21.26065540"
            },
            {
                "id": 719,
                "name": "SopiÅ¡te Municipality",
                "state_code": "70",
                "latitude": "41.86384920",
                "longitude": "21.30834990"
            },
            {
                "id": 643,
                "name": "Staro NagoriÄane Municipality",
                "state_code": "71",
                "latitude": "42.21916920",
                "longitude": "21.90455410"
            },
            {
                "id": 661,
                "name": "Å tip Municipality",
                "state_code": "83",
                "latitude": "41.70792970",
                "longitude": "22.19071220"
            },
            {
                "id": 700,
                "name": "Struga Municipality",
                "state_code": "72",
                "latitude": "41.31737440",
                "longitude": "20.66456830"
            },
            {
                "id": 710,
                "name": "Strumica Municipality",
                "state_code": "73",
                "latitude": "41.43780040",
                "longitude": "22.64274280"
            },
            {
                "id": 711,
                "name": "StudeniÄani Municipality",
                "state_code": "74",
                "latitude": "41.92256390",
                "longitude": "21.53639650"
            },
            {
                "id": 680,
                "name": "Å uto Orizari Municipality",
                "state_code": "84",
                "latitude": "42.02904160",
                "longitude": "21.40970270"
            },
            {
                "id": 640,
                "name": "Sveti Nikole Municipality",
                "state_code": "69",
                "latitude": "41.89803120",
                "longitude": "21.99994350"
            },
            {
                "id": 654,
                "name": "Tearce Municipality",
                "state_code": "75",
                "latitude": "42.07775110",
                "longitude": "21.05349230"
            },
            {
                "id": 663,
                "name": "Tetovo Municipality",
                "state_code": "76",
                "latitude": "42.02748600",
                "longitude": "20.95066360"
            },
            {
                "id": 671,
                "name": "Valandovo Municipality",
                "state_code": "10",
                "latitude": "41.32119090",
                "longitude": "22.50066930"
            },
            {
                "id": 658,
                "name": "Vasilevo Municipality",
                "state_code": "11",
                "latitude": "41.47416990",
                "longitude": "22.64221280"
            },
            {
                "id": 651,
                "name": "Veles Municipality",
                "state_code": "13",
                "latitude": "41.72744260",
                "longitude": "21.71376940"
            },
            {
                "id": 662,
                "name": "VevÄani Municipality",
                "state_code": "12",
                "latitude": "41.24075430",
                "longitude": "20.59156490"
            },
            {
                "id": 672,
                "name": "Vinica Municipality",
                "state_code": "14",
                "latitude": "41.85710200",
                "longitude": "22.57218810"
            },
            {
                "id": 650,
                "name": "VraneÅ¡tica Municipality",
                "state_code": "15",
                "latitude": "41.48290870",
                "longitude": "21.05796320"
            },
            {
                "id": 689,
                "name": "VrapÄiÅ¡te Municipality",
                "state_code": "16",
                "latitude": "41.87911600",
                "longitude": "20.83145000"
            },
            {
                "id": 642,
                "name": "Zajas Municipality",
                "state_code": "31",
                "latitude": "41.60303280",
                "longitude": "20.87913430"
            },
            {
                "id": 706,
                "name": "Zelenikovo Municipality",
                "state_code": "32",
                "latitude": "41.87338120",
                "longitude": "21.60272500"
            },
            {
                "id": 668,
                "name": "Å½elino Municipality",
                "state_code": "30",
                "latitude": "41.90065310",
                "longitude": "21.11757670"
            },
            {
                "id": 673,
                "name": "Zrnovci Municipality",
                "state_code": "33",
                "latitude": "41.82282210",
                "longitude": "22.41722560"
            }
        ]
    },
    {
        "name": "Madagascar",
        "iso3": "MDG",
        "iso2": "MG",
        "phone_code": "261",
        "capital": "Antananarivo",
        "currency": "MGA",
        "currency_symbol": "Ar",
        "tld": ".mg",
        "native": "Madagasikara",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Antananarivo",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆë‹¤ê°€ìŠ¤ì¹´ë¥´",
            "br": "Madagascar",
            "pt": "MadagÃ¡scar",
            "nl": "Madagaskar",
            "hr": "Madagaskar",
            "fa": "Ù…Ø§Ø¯Ø§Ú¯Ø§Ø³Ú©Ø§Ø±",
            "de": "Madagaskar",
            "es": "Madagascar",
            "fr": "Madagascar",
            "ja": "ãƒžãƒ€ã‚¬ã‚¹ã‚«ãƒ«",
            "it": "Madagascar",
            "cn": "é©¬è¾¾åŠ æ–¯åŠ "
        },
        "latitude": "-20.00000000",
        "longitude": "47.00000000",
        "emoji": "ðŸ‡²ðŸ‡¬",
        "emojiU": "U+1F1F2 U+1F1EC",
        "states": [
            {
                "id": 2951,
                "name": "Antananarivo Province",
                "state_code": "T",
                "latitude": "-18.70514740",
                "longitude": "46.82528380"
            },
            {
                "id": 2950,
                "name": "Antsiranana Province",
                "state_code": "D",
                "latitude": "-13.77153900",
                "longitude": "49.52799960"
            },
            {
                "id": 2948,
                "name": "Fianarantsoa Province",
                "state_code": "F",
                "latitude": "-22.35362400",
                "longitude": "46.82528380"
            },
            {
                "id": 2953,
                "name": "Mahajanga Province",
                "state_code": "M",
                "latitude": "-16.52388300",
                "longitude": "46.51626200"
            },
            {
                "id": 2952,
                "name": "Toamasina Province",
                "state_code": "A",
                "latitude": "-18.14428110",
                "longitude": "49.39578360"
            },
            {
                "id": 2949,
                "name": "Toliara Province",
                "state_code": "U",
                "latitude": "-23.35161910",
                "longitude": "43.68549360"
            }
        ]
    },
    {
        "name": "Malawi",
        "iso3": "MWI",
        "iso2": "MW",
        "phone_code": "265",
        "capital": "Lilongwe",
        "currency": "MWK",
        "currency_symbol": "MK",
        "tld": ".mw",
        "native": "Malawi",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Blantyre",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ë§ë¼ìœ„",
            "br": "Malawi",
            "pt": "MalÃ¡vi",
            "nl": "Malawi",
            "hr": "Malavi",
            "fa": "Ù…Ø§Ù„Ø§ÙˆÛŒ",
            "de": "Malawi",
            "es": "Malawi",
            "fr": "Malawi",
            "ja": "ãƒžãƒ©ã‚¦ã‚¤",
            "it": "Malawi",
            "cn": "é©¬æ‹‰ç»´"
        },
        "latitude": "-13.50000000",
        "longitude": "34.00000000",
        "emoji": "ðŸ‡²ðŸ‡¼",
        "emojiU": "U+1F1F2 U+1F1FC",
        "states": [
            {
                "id": 3096,
                "name": "Balaka District",
                "state_code": "BA",
                "latitude": "-15.05065950",
                "longitude": "35.08285880"
            },
            {
                "id": 3102,
                "name": "Blantyre District",
                "state_code": "BL",
                "latitude": "-15.67785410",
                "longitude": "34.95066250"
            },
            {
                "id": 3092,
                "name": "Central Region",
                "state_code": "C",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3107,
                "name": "Chikwawa District",
                "state_code": "CK",
                "latitude": "-16.19584460",
                "longitude": "34.77407930"
            },
            {
                "id": 3109,
                "name": "Chiradzulu District",
                "state_code": "CR",
                "latitude": "-15.74231510",
                "longitude": "35.25879640"
            },
            {
                "id": 3087,
                "name": "Chitipa district",
                "state_code": "CT",
                "latitude": "-9.70376550",
                "longitude": "33.27002530"
            },
            {
                "id": 3097,
                "name": "Dedza District",
                "state_code": "DE",
                "latitude": "-14.18945850",
                "longitude": "34.24215970"
            },
            {
                "id": 3090,
                "name": "Dowa District",
                "state_code": "DO",
                "latitude": "-13.60412560",
                "longitude": "33.88577470"
            },
            {
                "id": 3091,
                "name": "Karonga District",
                "state_code": "KR",
                "latitude": "-9.90363650",
                "longitude": "33.97500180"
            },
            {
                "id": 3094,
                "name": "Kasungu District",
                "state_code": "KS",
                "latitude": "-13.13670650",
                "longitude": "33.25879300"
            },
            {
                "id": 3093,
                "name": "Likoma District",
                "state_code": "LK",
                "latitude": "-12.05840050",
                "longitude": "34.73540310"
            },
            {
                "id": 3101,
                "name": "Lilongwe District",
                "state_code": "LI",
                "latitude": "-14.04752280",
                "longitude": "33.61757700"
            },
            {
                "id": 3082,
                "name": "Machinga District",
                "state_code": "MH",
                "latitude": "-14.94072630",
                "longitude": "35.47819260"
            },
            {
                "id": 3110,
                "name": "Mangochi District",
                "state_code": "MG",
                "latitude": "-14.13882480",
                "longitude": "35.03881640"
            },
            {
                "id": 3099,
                "name": "Mchinji District",
                "state_code": "MC",
                "latitude": "-13.74015250",
                "longitude": "32.98883190"
            },
            {
                "id": 3103,
                "name": "Mulanje District",
                "state_code": "MU",
                "latitude": "-15.93464340",
                "longitude": "35.52200120"
            },
            {
                "id": 3084,
                "name": "Mwanza District",
                "state_code": "MW",
                "latitude": "-2.46711970",
                "longitude": "32.89868120"
            },
            {
                "id": 3104,
                "name": "Mzimba District",
                "state_code": "MZ",
                "latitude": "-11.74754520",
                "longitude": "33.52800720"
            },
            {
                "id": 3095,
                "name": "Nkhata Bay District",
                "state_code": "NB",
                "latitude": "-11.71850420",
                "longitude": "34.33103640"
            },
            {
                "id": 3100,
                "name": "Nkhotakota District",
                "state_code": "NK",
                "latitude": "-12.75419610",
                "longitude": "34.24215970"
            },
            {
                "id": 3105,
                "name": "Northern Region",
                "state_code": "N",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3085,
                "name": "Nsanje District",
                "state_code": "NS",
                "latitude": "-16.72882020",
                "longitude": "35.17087410"
            },
            {
                "id": 3088,
                "name": "Ntcheu District",
                "state_code": "NU",
                "latitude": "-14.90375380",
                "longitude": "34.77407930"
            },
            {
                "id": 3111,
                "name": "Ntchisi District",
                "state_code": "NI",
                "latitude": "-13.28419920",
                "longitude": "33.88577470"
            },
            {
                "id": 3108,
                "name": "Phalombe District",
                "state_code": "PH",
                "latitude": "-15.70920380",
                "longitude": "35.65328480"
            },
            {
                "id": 3089,
                "name": "Rumphi District",
                "state_code": "RU",
                "latitude": "-10.78515370",
                "longitude": "34.33103640"
            },
            {
                "id": 3086,
                "name": "Salima District",
                "state_code": "SA",
                "latitude": "-13.68095860",
                "longitude": "34.41982430"
            },
            {
                "id": 3106,
                "name": "Southern Region",
                "state_code": "S",
                "latitude": "32.75049570",
                "longitude": "-97.33154760"
            },
            {
                "id": 3098,
                "name": "Thyolo District",
                "state_code": "TH",
                "latitude": "-16.12991770",
                "longitude": "35.12687810"
            },
            {
                "id": 3083,
                "name": "Zomba District",
                "state_code": "ZO",
                "latitude": "-15.37658570",
                "longitude": "35.33565180"
            }
        ]
    },
    {
        "name": "Malaysia",
        "iso3": "MYS",
        "iso2": "MY",
        "phone_code": "60",
        "capital": "Kuala Lumpur",
        "currency": "MYR",
        "currency_symbol": "RM",
        "tld": ".my",
        "native": "Malaysia",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Kuala_Lumpur",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "MYT",
                "tzName": "Malaysia Time"
            },
            {
                "zoneName": "Asia\/Kuching",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "MYT",
                "tzName": "Malaysia Time"
            }
        ],
        "translations": {
            "kr": "ë§ë ˆì´ì‹œì•„",
            "br": "MalÃ¡sia",
            "pt": "MalÃ¡sia",
            "nl": "MaleisiÃ«",
            "hr": "Malezija",
            "fa": "Ù…Ø§Ù„Ø²ÛŒ",
            "de": "Malaysia",
            "es": "Malasia",
            "fr": "Malaisie",
            "ja": "ãƒžãƒ¬ãƒ¼ã‚·ã‚¢",
            "it": "Malesia",
            "cn": "é©¬æ¥è¥¿äºš"
        },
        "latitude": "2.50000000",
        "longitude": "112.50000000",
        "emoji": "ðŸ‡²ðŸ‡¾",
        "emojiU": "U+1F1F2 U+1F1FE",
        "states": [
            {
                "id": 1950,
                "name": "Johor",
                "state_code": "01",
                "latitude": "1.48536820",
                "longitude": "103.76181540"
            },
            {
                "id": 1947,
                "name": "Kedah",
                "state_code": "02",
                "latitude": "6.11839640",
                "longitude": "100.36845950"
            },
            {
                "id": 1946,
                "name": "Kelantan",
                "state_code": "03",
                "latitude": "6.12539690",
                "longitude": "102.23807100"
            },
            {
                "id": 1949,
                "name": "Kuala Lumpur",
                "state_code": "14",
                "latitude": "3.13900300",
                "longitude": "101.68685500"
            },
            {
                "id": 1935,
                "name": "Labuan",
                "state_code": "15",
                "latitude": "5.28314560",
                "longitude": "115.23082500"
            },
            {
                "id": 1941,
                "name": "Malacca",
                "state_code": "04",
                "latitude": "2.18959400",
                "longitude": "102.25008680"
            },
            {
                "id": 1948,
                "name": "Negeri Sembilan",
                "state_code": "05",
                "latitude": "2.72580580",
                "longitude": "101.94237820"
            },
            {
                "id": 1940,
                "name": "Pahang",
                "state_code": "06",
                "latitude": "3.81263180",
                "longitude": "103.32562040"
            },
            {
                "id": 1939,
                "name": "Penang",
                "state_code": "07",
                "latitude": "5.41639350",
                "longitude": "100.33267860"
            },
            {
                "id": 1943,
                "name": "Perak",
                "state_code": "08",
                "latitude": "4.59211260",
                "longitude": "101.09010900"
            },
            {
                "id": 1938,
                "name": "Perlis",
                "state_code": "09",
                "latitude": "29.92270940",
                "longitude": "-90.12285590"
            },
            {
                "id": 1945,
                "name": "Putrajaya",
                "state_code": "16",
                "latitude": "2.92636100",
                "longitude": "101.69644500"
            },
            {
                "id": 1936,
                "name": "Sabah",
                "state_code": "12",
                "latitude": "5.97883980",
                "longitude": "116.07531990"
            },
            {
                "id": 1937,
                "name": "Sarawak",
                "state_code": "13",
                "latitude": "1.55327830",
                "longitude": "110.35921270"
            },
            {
                "id": 1944,
                "name": "Selangor",
                "state_code": "10",
                "latitude": "3.07383790",
                "longitude": "101.51834690"
            },
            {
                "id": 1942,
                "name": "Terengganu",
                "state_code": "11",
                "latitude": "5.31169160",
                "longitude": "103.13241540"
            }
        ]
    },
    {
        "name": "Maldives",
        "iso3": "MDV",
        "iso2": "MV",
        "phone_code": "960",
        "capital": "Male",
        "currency": "MVR",
        "currency_symbol": "Rf",
        "tld": ".mv",
        "native": "Maldives",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Indian\/Maldives",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "MVT",
                "tzName": "Maldives Time"
            }
        ],
        "translations": {
            "kr": "ëª°ë””ë¸Œ",
            "br": "Maldivas",
            "pt": "Maldivas",
            "nl": "Maldiven",
            "hr": "Maldivi",
            "fa": "Ù…Ø§Ù„Ø¯ÛŒÙˆ",
            "de": "Malediven",
            "es": "Maldivas",
            "fr": "Maldives",
            "ja": "ãƒ¢ãƒ«ãƒ‡ã‚£ãƒ–",
            "it": "Maldive",
            "cn": "é©¬å°”ä»£å¤«"
        },
        "latitude": "3.25000000",
        "longitude": "73.00000000",
        "emoji": "ðŸ‡²ðŸ‡»",
        "emojiU": "U+1F1F2 U+1F1FB",
        "states": [
            {
                "id": 2594,
                "name": "Addu Atoll",
                "state_code": "01",
                "latitude": "-0.63009950",
                "longitude": "73.15856260"
            },
            {
                "id": 2587,
                "name": "Alif Alif Atoll",
                "state_code": "02",
                "latitude": "4.08500000",
                "longitude": "72.85154790"
            },
            {
                "id": 2600,
                "name": "Alif Dhaal Atoll",
                "state_code": "00",
                "latitude": "3.65433020",
                "longitude": "72.80427970"
            },
            {
                "id": 2604,
                "name": "Central Province",
                "state_code": "CE",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2590,
                "name": "Dhaalu Atoll",
                "state_code": "17",
                "latitude": "2.84685020",
                "longitude": "72.94605660"
            },
            {
                "id": 2599,
                "name": "Faafu Atoll",
                "state_code": "14",
                "latitude": "3.23094090",
                "longitude": "72.94605660"
            },
            {
                "id": 2598,
                "name": "Gaafu Alif Atoll",
                "state_code": "27",
                "latitude": "0.61248130",
                "longitude": "73.32370800"
            },
            {
                "id": 2603,
                "name": "Gaafu Dhaalu Atoll",
                "state_code": "28",
                "latitude": "0.35880400",
                "longitude": "73.18216230"
            },
            {
                "id": 2595,
                "name": "Gnaviyani Atoll",
                "state_code": "29",
                "latitude": "-0.30064250",
                "longitude": "73.42391430"
            },
            {
                "id": 2586,
                "name": "Haa Alif Atoll",
                "state_code": "07",
                "latitude": "6.99034880",
                "longitude": "72.94605660"
            },
            {
                "id": 2597,
                "name": "Haa Dhaalu Atoll",
                "state_code": "23",
                "latitude": "6.57827170",
                "longitude": "72.94605660"
            },
            {
                "id": 2596,
                "name": "Kaafu Atoll",
                "state_code": "26",
                "latitude": "4.45589790",
                "longitude": "73.55941280"
            },
            {
                "id": 2601,
                "name": "Laamu Atoll",
                "state_code": "05",
                "latitude": "1.94307370",
                "longitude": "73.41802110"
            },
            {
                "id": 2607,
                "name": "Lhaviyani Atoll",
                "state_code": "03",
                "latitude": "5.37470210",
                "longitude": "73.51229280"
            },
            {
                "id": 2609,
                "name": "MalÃ©",
                "state_code": "MLE",
                "latitude": "46.34888670",
                "longitude": "10.90724890"
            },
            {
                "id": 2608,
                "name": "Meemu Atoll",
                "state_code": "12",
                "latitude": "3.00903450",
                "longitude": "73.51229280"
            },
            {
                "id": 2592,
                "name": "Noonu Atoll",
                "state_code": "25",
                "latitude": "5.85512760",
                "longitude": "73.32370800"
            },
            {
                "id": 2589,
                "name": "North Central Province",
                "state_code": "NC",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2588,
                "name": "North Province",
                "state_code": "NO",
                "latitude": "8.88550270",
                "longitude": "80.27673270"
            },
            {
                "id": 2602,
                "name": "Raa Atoll",
                "state_code": "13",
                "latitude": "5.60064570",
                "longitude": "72.94605660"
            },
            {
                "id": 2585,
                "name": "Shaviyani Atoll",
                "state_code": "24",
                "latitude": "6.17511000",
                "longitude": "73.13496050"
            },
            {
                "id": 2606,
                "name": "South Central Province",
                "state_code": "SC",
                "latitude": "7.25649960",
                "longitude": "80.72144170"
            },
            {
                "id": 2605,
                "name": "South Province",
                "state_code": "SU",
                "latitude": "-21.74820060",
                "longitude": "166.17837390"
            },
            {
                "id": 2591,
                "name": "Thaa Atoll",
                "state_code": "08",
                "latitude": "2.43111610",
                "longitude": "73.18216230"
            },
            {
                "id": 2593,
                "name": "Upper South Province",
                "state_code": "US",
                "latitude": "0.23070000",
                "longitude": "73.27948460"
            },
            {
                "id": 2584,
                "name": "Vaavu Atoll",
                "state_code": "04",
                "latitude": "3.39554380",
                "longitude": "73.51229280"
            }
        ]
    },
    {
        "name": "Mali",
        "iso3": "MLI",
        "iso2": "ML",
        "phone_code": "223",
        "capital": "Bamako",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".ml",
        "native": "Mali",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Bamako",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ë§ë¦¬",
            "br": "Mali",
            "pt": "Mali",
            "nl": "Mali",
            "hr": "Mali",
            "fa": "Ù…Ø§Ù„ÛŒ",
            "de": "Mali",
            "es": "Mali",
            "fr": "Mali",
            "ja": "ãƒžãƒª",
            "it": "Mali",
            "cn": "é©¬é‡Œ"
        },
        "latitude": "17.00000000",
        "longitude": "-4.00000000",
        "emoji": "ðŸ‡²ðŸ‡±",
        "emojiU": "U+1F1F2 U+1F1F1",
        "states": [
            {
                "id": 253,
                "name": "Bamako",
                "state_code": "BKO",
                "latitude": "12.63923160",
                "longitude": "-8.00288920"
            },
            {
                "id": 258,
                "name": "Gao Region",
                "state_code": "7",
                "latitude": "16.90663320",
                "longitude": "1.52086240"
            },
            {
                "id": 252,
                "name": "Kayes Region",
                "state_code": "1",
                "latitude": "14.08183080",
                "longitude": "-9.90181310"
            },
            {
                "id": 257,
                "name": "Kidal Region",
                "state_code": "8",
                "latitude": "18.79868320",
                "longitude": "1.83183340"
            },
            {
                "id": 250,
                "name": "Koulikoro Region",
                "state_code": "2",
                "latitude": "13.80180740",
                "longitude": "-7.43813550"
            },
            {
                "id": 251,
                "name": "MÃ©naka Region",
                "state_code": "9",
                "latitude": "15.91564210",
                "longitude": "2.39617400"
            },
            {
                "id": 255,
                "name": "Mopti Region",
                "state_code": "5",
                "latitude": "14.63380390",
                "longitude": "-3.41955270"
            },
            {
                "id": 249,
                "name": "SÃ©gou Region",
                "state_code": "4",
                "latitude": "13.83944560",
                "longitude": "-6.06791940"
            },
            {
                "id": 254,
                "name": "Sikasso Region",
                "state_code": "3",
                "latitude": "10.89051860",
                "longitude": "-7.43813550"
            },
            {
                "id": 256,
                "name": "TaoudÃ©nit Region",
                "state_code": "10",
                "latitude": "22.67641320",
                "longitude": "-3.97891430"
            },
            {
                "id": 248,
                "name": "Tombouctou Region",
                "state_code": "6",
                "latitude": "21.05267060",
                "longitude": "-3.74350900"
            }
        ]
    },
    {
        "name": "Malta",
        "iso3": "MLT",
        "iso2": "MT",
        "phone_code": "356",
        "capital": "Valletta",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".mt",
        "native": "Malta",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Malta",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ëª°íƒ€",
            "br": "Malta",
            "pt": "Malta",
            "nl": "Malta",
            "hr": "Malta",
            "fa": "Ù…Ø§Ù„Øª",
            "de": "Malta",
            "es": "Malta",
            "fr": "Malte",
            "ja": "ãƒžãƒ«ã‚¿",
            "it": "Malta",
            "cn": "é©¬è€³ä»–"
        },
        "latitude": "35.83333333",
        "longitude": "14.58333333",
        "emoji": "ðŸ‡²ðŸ‡¹",
        "emojiU": "U+1F1F2 U+1F1F9",
        "states": [
            {
                "id": 110,
                "name": "Attard",
                "state_code": "01",
                "latitude": "35.89049670",
                "longitude": "14.41993220"
            },
            {
                "id": 108,
                "name": "Balzan",
                "state_code": "02",
                "latitude": "35.89574140",
                "longitude": "14.45340650"
            },
            {
                "id": 107,
                "name": "Birgu",
                "state_code": "03",
                "latitude": "35.88792140",
                "longitude": "14.52256200"
            },
            {
                "id": 97,
                "name": "Birkirkara",
                "state_code": "04",
                "latitude": "35.89547060",
                "longitude": "14.46650720"
            },
            {
                "id": 88,
                "name": "BirÅ¼ebbuÄ¡a",
                "state_code": "05",
                "latitude": "35.81359890",
                "longitude": "14.52474630"
            },
            {
                "id": 138,
                "name": "Cospicua",
                "state_code": "06",
                "latitude": "35.88067530",
                "longitude": "14.52183380"
            },
            {
                "id": 117,
                "name": "Dingli",
                "state_code": "07",
                "latitude": "35.86273090",
                "longitude": "14.38501070"
            },
            {
                "id": 129,
                "name": "Fgura",
                "state_code": "08",
                "latitude": "35.87382690",
                "longitude": "14.52329010"
            },
            {
                "id": 84,
                "name": "Floriana",
                "state_code": "09",
                "latitude": "45.49521850",
                "longitude": "-73.71395760"
            },
            {
                "id": 134,
                "name": "Fontana",
                "state_code": "10",
                "latitude": "34.09223350",
                "longitude": "-117.43504800"
            },
            {
                "id": 130,
                "name": "GÄ§ajnsielem",
                "state_code": "13",
                "latitude": "36.02479660",
                "longitude": "14.28029610"
            },
            {
                "id": 92,
                "name": "GÄ§arb",
                "state_code": "14",
                "latitude": "36.06890900",
                "longitude": "14.20180980"
            },
            {
                "id": 120,
                "name": "GÄ§argÄ§ur",
                "state_code": "15",
                "latitude": "35.92205690",
                "longitude": "14.45631760"
            },
            {
                "id": 106,
                "name": "GÄ§asri",
                "state_code": "16",
                "latitude": "36.06680750",
                "longitude": "14.21924750"
            },
            {
                "id": 124,
                "name": "GÄ§axaq",
                "state_code": "17",
                "latitude": "35.84403590",
                "longitude": "14.51600900"
            },
            {
                "id": 118,
                "name": "Gudja",
                "state_code": "11",
                "latitude": "35.84698030",
                "longitude": "14.50290400"
            },
            {
                "id": 113,
                "name": "GÅ¼ira",
                "state_code": "12",
                "latitude": "35.90589700",
                "longitude": "14.49533380"
            },
            {
                "id": 105,
                "name": "Ä¦amrun",
                "state_code": "18",
                "latitude": "35.88612370",
                "longitude": "14.48834420"
            },
            {
                "id": 93,
                "name": "Iklin",
                "state_code": "19",
                "latitude": "35.90987740",
                "longitude": "14.45777320"
            },
            {
                "id": 99,
                "name": "Kalkara",
                "state_code": "21",
                "latitude": "35.89142420",
                "longitude": "14.53202780"
            },
            {
                "id": 91,
                "name": "KerÄ‹em",
                "state_code": "22",
                "latitude": "36.04479390",
                "longitude": "14.22506050"
            },
            {
                "id": 82,
                "name": "Kirkop",
                "state_code": "23",
                "latitude": "35.84378620",
                "longitude": "14.48543240"
            },
            {
                "id": 126,
                "name": "Lija",
                "state_code": "24",
                "latitude": "49.18007600",
                "longitude": "-123.10331700"
            },
            {
                "id": 77,
                "name": "Luqa",
                "state_code": "25",
                "latitude": "35.85828650",
                "longitude": "14.48688830"
            },
            {
                "id": 128,
                "name": "Marsa",
                "state_code": "26",
                "latitude": "34.03195870",
                "longitude": "-118.44555350"
            },
            {
                "id": 137,
                "name": "Marsaskala",
                "state_code": "27",
                "latitude": "35.86036400",
                "longitude": "14.55678760"
            },
            {
                "id": 78,
                "name": "Marsaxlokk",
                "state_code": "28",
                "latitude": "35.84116990",
                "longitude": "14.53930970"
            },
            {
                "id": 89,
                "name": "Mdina",
                "state_code": "29",
                "latitude": "35.88809300",
                "longitude": "14.40683570"
            },
            {
                "id": 102,
                "name": "MellieÄ§a",
                "state_code": "30",
                "latitude": "35.95235290",
                "longitude": "14.35009750"
            },
            {
                "id": 109,
                "name": "MÄ¡arr",
                "state_code": "31",
                "latitude": "35.91893270",
                "longitude": "14.36173430"
            },
            {
                "id": 140,
                "name": "Mosta",
                "state_code": "32",
                "latitude": "35.91415040",
                "longitude": "14.42284270"
            },
            {
                "id": 74,
                "name": "Mqabba",
                "state_code": "33",
                "latitude": "35.84441430",
                "longitude": "14.46941860"
            },
            {
                "id": 96,
                "name": "Msida",
                "state_code": "34",
                "latitude": "35.89563880",
                "longitude": "14.48688830"
            },
            {
                "id": 131,
                "name": "Mtarfa",
                "state_code": "35",
                "latitude": "35.88951250",
                "longitude": "14.39519530"
            },
            {
                "id": 132,
                "name": "Munxar",
                "state_code": "36",
                "latitude": "36.02880580",
                "longitude": "14.22506050"
            },
            {
                "id": 133,
                "name": "Nadur",
                "state_code": "37",
                "latitude": "36.04470190",
                "longitude": "14.29192730"
            },
            {
                "id": 112,
                "name": "Naxxar",
                "state_code": "38",
                "latitude": "35.93175180",
                "longitude": "14.43157460"
            },
            {
                "id": 115,
                "name": "Paola",
                "state_code": "39",
                "latitude": "38.57223530",
                "longitude": "-94.87912940"
            },
            {
                "id": 125,
                "name": "Pembroke",
                "state_code": "40",
                "latitude": "34.68016260",
                "longitude": "-79.19503730"
            },
            {
                "id": 127,
                "name": "PietÃ ",
                "state_code": "41",
                "latitude": "42.21862000",
                "longitude": "-83.73464700"
            },
            {
                "id": 79,
                "name": "Qala",
                "state_code": "42",
                "latitude": "36.03886280",
                "longitude": "14.31810100"
            },
            {
                "id": 119,
                "name": "Qormi",
                "state_code": "43",
                "latitude": "35.87643880",
                "longitude": "14.46941860"
            },
            {
                "id": 111,
                "name": "Qrendi",
                "state_code": "44",
                "latitude": "35.83284880",
                "longitude": "14.45486210"
            },
            {
                "id": 83,
                "name": "Rabat",
                "state_code": "46",
                "latitude": "33.97159040",
                "longitude": "-6.84981290"
            },
            {
                "id": 87,
                "name": "Saint Lawrence",
                "state_code": "50",
                "latitude": "38.95780560",
                "longitude": "-95.25656890"
            },
            {
                "id": 75,
                "name": "San Ä wann",
                "state_code": "49",
                "latitude": "35.90773650",
                "longitude": "14.47524160"
            },
            {
                "id": 116,
                "name": "Sannat",
                "state_code": "52",
                "latitude": "36.01926430",
                "longitude": "14.25994370"
            },
            {
                "id": 94,
                "name": "Santa LuÄ‹ija",
                "state_code": "53",
                "latitude": "35.85614200",
                "longitude": "14.50436000"
            },
            {
                "id": 90,
                "name": "Santa Venera",
                "state_code": "54",
                "latitude": "35.89022010",
                "longitude": "14.47669740"
            },
            {
                "id": 136,
                "name": "Senglea",
                "state_code": "20",
                "latitude": "35.88730410",
                "longitude": "14.51673710"
            },
            {
                "id": 98,
                "name": "SiÄ¡Ä¡iewi",
                "state_code": "55",
                "latitude": "35.84637420",
                "longitude": "14.43157460"
            },
            {
                "id": 104,
                "name": "Sliema",
                "state_code": "56",
                "latitude": "35.91100810",
                "longitude": "14.50290400"
            },
            {
                "id": 100,
                "name": "St. Julian's",
                "state_code": "48",
                "latitude": "42.21225130",
                "longitude": "-85.89171270"
            },
            {
                "id": 139,
                "name": "St. Paul's Bay",
                "state_code": "51",
                "latitude": "35.93601700",
                "longitude": "14.39665030"
            },
            {
                "id": 86,
                "name": "Swieqi",
                "state_code": "57",
                "latitude": "35.91911820",
                "longitude": "14.46941860"
            },
            {
                "id": 122,
                "name": "Ta' Xbiex",
                "state_code": "58",
                "latitude": "35.89914480",
                "longitude": "14.49635190"
            },
            {
                "id": 103,
                "name": "Tarxien",
                "state_code": "59",
                "latitude": "35.86725520",
                "longitude": "14.51164050"
            },
            {
                "id": 95,
                "name": "Valletta",
                "state_code": "60",
                "latitude": "35.89890850",
                "longitude": "14.51455280"
            },
            {
                "id": 101,
                "name": "Victoria",
                "state_code": "45",
                "latitude": "28.80526740",
                "longitude": "-97.00359820"
            },
            {
                "id": 114,
                "name": "XagÄ§ra",
                "state_code": "61",
                "latitude": "36.05084500",
                "longitude": "14.26748200"
            },
            {
                "id": 121,
                "name": "Xewkija",
                "state_code": "62",
                "latitude": "36.02992360",
                "longitude": "14.25994370"
            },
            {
                "id": 81,
                "name": "XgÄ§ajra",
                "state_code": "63",
                "latitude": "35.88682820",
                "longitude": "14.54723910"
            },
            {
                "id": 123,
                "name": "Å»abbar",
                "state_code": "64",
                "latitude": "35.87247150",
                "longitude": "14.54513540"
            },
            {
                "id": 85,
                "name": "Å»ebbuÄ¡ Gozo",
                "state_code": "65",
                "latitude": "36.07164030",
                "longitude": "14.24540800"
            },
            {
                "id": 80,
                "name": "Å»ebbuÄ¡ Malta",
                "state_code": "66",
                "latitude": "35.87646480",
                "longitude": "14.43908400"
            },
            {
                "id": 135,
                "name": "Å»ejtun",
                "state_code": "67",
                "latitude": "35.85487140",
                "longitude": "14.53639690"
            },
            {
                "id": 76,
                "name": "Å»urrieq",
                "state_code": "68",
                "latitude": "35.82163060",
                "longitude": "14.48106480"
            }
        ]
    },
    {
        "name": "Man (Isle of)",
        "iso3": "IMN",
        "iso2": "IM",
        "phone_code": "+44-1624",
        "capital": "Douglas, Isle of Man",
        "currency": "GBP",
        "currency_symbol": "Â£",
        "tld": ".im",
        "native": "Isle of Man",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Isle_of_Man",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ë§¨ ì„¬",
            "br": "Ilha de Man",
            "pt": "Ilha de Man",
            "nl": "Isle of Man",
            "hr": "Otok Man",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ù…Ù†",
            "de": "Insel Man",
            "es": "Isla de Man",
            "fr": "ÃŽle de Man",
            "ja": "ãƒžãƒ³å³¶",
            "it": "Isola di Man",
            "cn": "é©¬æ©å²›"
        },
        "latitude": "54.25000000",
        "longitude": "-4.50000000",
        "emoji": "ðŸ‡®ðŸ‡²",
        "emojiU": "U+1F1EE U+1F1F2",
        "states": []
    },
    {
        "name": "Marshall Islands",
        "iso3": "MHL",
        "iso2": "MH",
        "phone_code": "692",
        "capital": "Majuro",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".mh",
        "native": "MÌ§ajeÄ¼",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Kwajalein",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "MHT",
                "tzName": "Marshall Islands Time"
            },
            {
                "zoneName": "Pacific\/Majuro",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "MHT",
                "tzName": "Marshall Islands Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆì…œ ì œë„",
            "br": "Ilhas Marshall",
            "pt": "Ilhas Marshall",
            "nl": "Marshalleilanden",
            "hr": "MarÅ¡alovi Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ù…Ø§Ø±Ø´Ø§Ù„",
            "de": "Marshallinseln",
            "es": "Islas Marshall",
            "fr": "ÃŽles Marshall",
            "ja": "ãƒžãƒ¼ã‚·ãƒ£ãƒ«è«¸å³¶",
            "it": "Isole Marshall",
            "cn": "é©¬ç»å°”ç¾¤å²›"
        },
        "latitude": "9.00000000",
        "longitude": "168.00000000",
        "emoji": "ðŸ‡²ðŸ‡­",
        "emojiU": "U+1F1F2 U+1F1ED",
        "states": [
            {
                "id": 2574,
                "name": "Ralik Chain",
                "state_code": "L",
                "latitude": "8.13614600",
                "longitude": "164.88679560"
            },
            {
                "id": 2573,
                "name": "Ratak Chain",
                "state_code": "T",
                "latitude": "10.27632760",
                "longitude": "170.55009370"
            }
        ]
    },
    {
        "name": "Martinique",
        "iso3": "MTQ",
        "iso2": "MQ",
        "phone_code": "596",
        "capital": "Fort-de-France",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".mq",
        "native": "Martinique",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Martinique",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆë¥´í‹°ë‹ˆí¬",
            "br": "Martinica",
            "pt": "Martinica",
            "nl": "Martinique",
            "hr": "Martinique",
            "fa": "Ù…ÙˆÙ†ØªØ³Ø±Ø§Øª",
            "de": "Martinique",
            "es": "Martinica",
            "fr": "Martinique",
            "ja": "ãƒžãƒ«ãƒ†ã‚£ãƒ‹ãƒ¼ã‚¯",
            "it": "Martinica",
            "cn": "é©¬æå°¼å…‹å²›"
        },
        "latitude": "14.66666700",
        "longitude": "-61.00000000",
        "emoji": "ðŸ‡²ðŸ‡¶",
        "emojiU": "U+1F1F2 U+1F1F6",
        "states": []
    },
    {
        "name": "Mauritania",
        "iso3": "MRT",
        "iso2": "MR",
        "phone_code": "222",
        "capital": "Nouakchott",
        "currency": "MRO",
        "currency_symbol": "MRU",
        "tld": ".mr",
        "native": "Ù…ÙˆØ±ÙŠØªØ§Ù†ÙŠØ§",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Nouakchott",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ëª¨ë¦¬íƒ€ë‹ˆ",
            "br": "MauritÃ¢nia",
            "pt": "MauritÃ¢nia",
            "nl": "MauritaniÃ«",
            "hr": "Mauritanija",
            "fa": "Ù…ÙˆØ±ÛŒØªØ§Ù†ÛŒ",
            "de": "Mauretanien",
            "es": "Mauritania",
            "fr": "Mauritanie",
            "ja": "ãƒ¢ãƒ¼ãƒªã‚¿ãƒ‹ã‚¢",
            "it": "Mauritania",
            "cn": "æ¯›é‡Œå¡”å°¼äºš"
        },
        "latitude": "20.00000000",
        "longitude": "-12.00000000",
        "emoji": "ðŸ‡²ðŸ‡·",
        "emojiU": "U+1F1F2 U+1F1F7",
        "states": [
            {
                "id": 3344,
                "name": "Adrar Region",
                "state_code": "07",
                "latitude": "19.86521760",
                "longitude": "-12.80547530"
            },
            {
                "id": 3349,
                "name": "Assaba Region",
                "state_code": "03",
                "latitude": "16.77595580",
                "longitude": "-11.52480550"
            },
            {
                "id": 3339,
                "name": "Brakna Region",
                "state_code": "05",
                "latitude": "17.23175610",
                "longitude": "-13.17403480"
            },
            {
                "id": 3346,
                "name": "Dakhlet Nouadhibou",
                "state_code": "08",
                "latitude": "20.59855880",
                "longitude": "-16.25221430"
            },
            {
                "id": 3341,
                "name": "Gorgol Region",
                "state_code": "04",
                "latitude": "15.97173570",
                "longitude": "-12.62162110"
            },
            {
                "id": 3350,
                "name": "Guidimaka Region",
                "state_code": "10",
                "latitude": "15.25573310",
                "longitude": "-12.25479190"
            },
            {
                "id": 3338,
                "name": "Hodh Ech Chargui Region",
                "state_code": "01",
                "latitude": "18.67370260",
                "longitude": "-7.09287700"
            },
            {
                "id": 3351,
                "name": "Hodh El Gharbi Region",
                "state_code": "02",
                "latitude": "16.69121490",
                "longitude": "-9.54509740"
            },
            {
                "id": 3342,
                "name": "Inchiri Region",
                "state_code": "12",
                "latitude": "20.02805610",
                "longitude": "-15.40680790"
            },
            {
                "id": 3343,
                "name": "Nouakchott-Nord Region",
                "state_code": "14",
                "latitude": "18.11302050",
                "longitude": "-15.89949560"
            },
            {
                "id": 3352,
                "name": "Nouakchott-Ouest Region",
                "state_code": "13",
                "latitude": "18.15113570",
                "longitude": "-15.99349100"
            },
            {
                "id": 3347,
                "name": "Nouakchott-Sud Region",
                "state_code": "15",
                "latitude": "17.97092880",
                "longitude": "-15.94648740"
            },
            {
                "id": 3345,
                "name": "Tagant Region",
                "state_code": "09",
                "latitude": "18.54675270",
                "longitude": "-9.90181310"
            },
            {
                "id": 3340,
                "name": "Tiris Zemmour Region",
                "state_code": "11",
                "latitude": "24.57737640",
                "longitude": "-9.90181310"
            },
            {
                "id": 3348,
                "name": "Trarza Region",
                "state_code": "06",
                "latitude": "17.86649640",
                "longitude": "-14.65878210"
            }
        ]
    },
    {
        "name": "Mauritius",
        "iso3": "MUS",
        "iso2": "MU",
        "phone_code": "230",
        "capital": "Port Louis",
        "currency": "MUR",
        "currency_symbol": "â‚¨",
        "tld": ".mu",
        "native": "Maurice",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Mauritius",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MUT",
                "tzName": "Mauritius Time"
            }
        ],
        "translations": {
            "kr": "ëª¨ë¦¬ì…”ìŠ¤",
            "br": "MaurÃ­cio",
            "pt": "MaurÃ­cia",
            "nl": "Mauritius",
            "hr": "Mauricijus",
            "fa": "Ù…ÙˆØ±ÛŒØ³",
            "de": "Mauritius",
            "es": "Mauricio",
            "fr": "ÃŽle Maurice",
            "ja": "ãƒ¢ãƒ¼ãƒªã‚·ãƒ£ã‚¹",
            "it": "Mauritius",
            "cn": "æ¯›é‡Œæ±‚æ–¯"
        },
        "latitude": "-20.28333333",
        "longitude": "57.55000000",
        "emoji": "ðŸ‡²ðŸ‡º",
        "emojiU": "U+1F1F2 U+1F1FA",
        "states": [
            {
                "id": 3248,
                "name": "AgalÃ©ga",
                "state_code": "AG",
                "latitude": "-10.40000000",
                "longitude": "56.61666670"
            },
            {
                "id": 3262,
                "name": "Beau Bassin-Rose Hill",
                "state_code": "BR",
                "latitude": "-20.22303050",
                "longitude": "57.46838300"
            },
            {
                "id": 3251,
                "name": "Cargados Carajos",
                "state_code": "CC",
                "latitude": "-16.58333300",
                "longitude": "59.61666700"
            },
            {
                "id": 3255,
                "name": "Curepipe",
                "state_code": "CU",
                "latitude": "-20.31708720",
                "longitude": "57.52652890"
            },
            {
                "id": 3254,
                "name": "Flacq District",
                "state_code": "FL",
                "latitude": "-20.22578360",
                "longitude": "57.71192740"
            },
            {
                "id": 3264,
                "name": "Grand Port District",
                "state_code": "GP",
                "latitude": "-20.38515460",
                "longitude": "57.66657420"
            },
            {
                "id": 3253,
                "name": "Moka District",
                "state_code": "MO",
                "latitude": "-20.23997820",
                "longitude": "57.57592600"
            },
            {
                "id": 3250,
                "name": "Pamplemousses District",
                "state_code": "PA",
                "latitude": "-20.11360080",
                "longitude": "57.57592600"
            },
            {
                "id": 3263,
                "name": "Plaines Wilhems District",
                "state_code": "PW",
                "latitude": "-20.30548720",
                "longitude": "57.48535610"
            },
            {
                "id": 3256,
                "name": "Port Louis",
                "state_code": "PU",
                "latitude": "-20.16089120",
                "longitude": "57.50122220"
            },
            {
                "id": 3260,
                "name": "Port Louis District",
                "state_code": "PL",
                "latitude": "-20.16089120",
                "longitude": "57.50122220"
            },
            {
                "id": 3258,
                "name": "Quatre Bornes",
                "state_code": "QB",
                "latitude": "-20.26747180",
                "longitude": "57.47969810"
            },
            {
                "id": 3261,
                "name": "RiviÃ¨re du Rempart District",
                "state_code": "RR",
                "latitude": "-20.05609830",
                "longitude": "57.65523890"
            },
            {
                "id": 3259,
                "name": "RiviÃ¨re Noire District",
                "state_code": "BL",
                "latitude": "-20.37084920",
                "longitude": "57.39486490"
            },
            {
                "id": 3249,
                "name": "Rodrigues",
                "state_code": "RO",
                "latitude": "-19.72453850",
                "longitude": "63.42721850"
            },
            {
                "id": 3257,
                "name": "Savanne District",
                "state_code": "SA",
                "latitude": "-20.47395300",
                "longitude": "57.48535610"
            },
            {
                "id": 3252,
                "name": "Vacoas-Phoenix",
                "state_code": "VP",
                "latitude": "-20.29840260",
                "longitude": "57.49383550"
            }
        ]
    },
    {
        "name": "Mayotte",
        "iso3": "MYT",
        "iso2": "YT",
        "phone_code": "262",
        "capital": "Mamoudzou",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".yt",
        "native": "Mayotte",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Mayotte",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ë§ˆìš”íŠ¸",
            "br": "Mayotte",
            "pt": "Mayotte",
            "nl": "Mayotte",
            "hr": "Mayotte",
            "fa": "Ù…Ø§ÛŒÙˆØª",
            "de": "Mayotte",
            "es": "Mayotte",
            "fr": "Mayotte",
            "ja": "ãƒžãƒ¨ãƒƒãƒˆ",
            "it": "Mayotte",
            "cn": "é©¬çº¦ç‰¹"
        },
        "latitude": "-12.83333333",
        "longitude": "45.16666666",
        "emoji": "ðŸ‡¾ðŸ‡¹",
        "emojiU": "U+1F1FE U+1F1F9",
        "states": []
    },
    {
        "name": "Mexico",
        "iso3": "MEX",
        "iso2": "MX",
        "phone_code": "52",
        "capital": "Mexico City",
        "currency": "MXN",
        "currency_symbol": "$",
        "tld": ".mx",
        "native": "MÃ©xico",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Bahia_Banderas",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Cancun",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Chihuahua",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Hermosillo",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Matamoros",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Mazatlan",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Merida",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Mexico_City",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Monterrey",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Ojinaga",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Tijuana",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ë©•ì‹œì½”",
            "br": "MÃ©xico",
            "pt": "MÃ©xico",
            "nl": "Mexico",
            "hr": "Meksiko",
            "fa": "Ù…Ú©Ø²ÛŒÚ©",
            "de": "Mexiko",
            "es": "MÃ©xico",
            "fr": "Mexique",
            "ja": "ãƒ¡ã‚­ã‚·ã‚³",
            "it": "Messico",
            "cn": "å¢¨è¥¿å“¥"
        },
        "latitude": "23.00000000",
        "longitude": "-102.00000000",
        "emoji": "ðŸ‡²ðŸ‡½",
        "emojiU": "U+1F1F2 U+1F1FD",
        "states": [
            {
                "id": 3456,
                "name": "Aguascalientes",
                "state_code": "AGU",
                "latitude": "21.88525620",
                "longitude": "-102.29156770"
            },
            {
                "id": 3457,
                "name": "Baja California",
                "state_code": "BCN",
                "latitude": "30.84063380",
                "longitude": "-115.28375850"
            },
            {
                "id": 3460,
                "name": "Baja California Sur",
                "state_code": "BCS",
                "latitude": "26.04444460",
                "longitude": "-111.66607250"
            },
            {
                "id": 3475,
                "name": "Campeche",
                "state_code": "CAM",
                "latitude": "19.83012510",
                "longitude": "-90.53490870"
            },
            {
                "id": 3451,
                "name": "Chiapas",
                "state_code": "CHP",
                "latitude": "16.75693180",
                "longitude": "-93.12923530"
            },
            {
                "id": 3447,
                "name": "Chihuahua",
                "state_code": "CHH",
                "latitude": "28.63299570",
                "longitude": "-106.06910040"
            },
            {
                "id": 3471,
                "name": "Coahuila",
                "state_code": "COA",
                "latitude": "27.05867600",
                "longitude": "-101.70682940"
            },
            {
                "id": 3472,
                "name": "Colima",
                "state_code": "COL",
                "latitude": "19.24523420",
                "longitude": "-103.72408680"
            },
            {
                "id": 3453,
                "name": "Durango",
                "state_code": "DUR",
                "latitude": "37.27528000",
                "longitude": "-107.88006670"
            },
            {
                "id": 3469,
                "name": "Guanajuato",
                "state_code": "GUA",
                "latitude": "21.01901450",
                "longitude": "-101.25735860"
            },
            {
                "id": 3459,
                "name": "Guerrero",
                "state_code": "GRO",
                "latitude": "17.43919260",
                "longitude": "-99.54509740"
            },
            {
                "id": 3470,
                "name": "Hidalgo",
                "state_code": "HID",
                "latitude": "26.10035470",
                "longitude": "-98.26306840"
            },
            {
                "id": 4857,
                "name": "Jalisco",
                "state_code": "JAL",
                "latitude": "20.65953820",
                "longitude": "-103.34943760"
            },
            {
                "id": 3450,
                "name": "MÃ©xico",
                "state_code": "MEX",
                "latitude": "23.63450100",
                "longitude": "-102.55278400"
            },
            {
                "id": 3473,
                "name": "Mexico City",
                "state_code": "CMX",
                "latitude": "19.43260770",
                "longitude": "-99.13320800"
            },
            {
                "id": 3474,
                "name": "MichoacÃ¡n",
                "state_code": "MIC",
                "latitude": "19.56651920",
                "longitude": "-101.70682940"
            },
            {
                "id": 3465,
                "name": "Morelos",
                "state_code": "MOR",
                "latitude": "18.68130490",
                "longitude": "-99.10134980"
            },
            {
                "id": 3477,
                "name": "Nayarit",
                "state_code": "NAY",
                "latitude": "21.75138440",
                "longitude": "-104.84546190"
            },
            {
                "id": 3452,
                "name": "Nuevo LeÃ³n",
                "state_code": "NLE",
                "latitude": "25.59217200",
                "longitude": "-99.99619470"
            },
            {
                "id": 3448,
                "name": "Oaxaca",
                "state_code": "OAX",
                "latitude": "17.07318420",
                "longitude": "-96.72658890"
            },
            {
                "id": 3476,
                "name": "Puebla",
                "state_code": "PUE",
                "latitude": "19.04143980",
                "longitude": "-98.20627270"
            },
            {
                "id": 3455,
                "name": "QuerÃ©taro",
                "state_code": "QUE",
                "latitude": "20.58879320",
                "longitude": "-100.38988810"
            },
            {
                "id": 3467,
                "name": "Quintana Roo",
                "state_code": "ROO",
                "latitude": "19.18173930",
                "longitude": "-88.47913760"
            },
            {
                "id": 3461,
                "name": "San Luis PotosÃ­",
                "state_code": "SLP",
                "latitude": "22.15646990",
                "longitude": "-100.98554090"
            },
            {
                "id": 3449,
                "name": "Sinaloa",
                "state_code": "SIN",
                "latitude": "25.17210910",
                "longitude": "-107.47951730"
            },
            {
                "id": 3468,
                "name": "Sonora",
                "state_code": "SON",
                "latitude": "37.98294960",
                "longitude": "-120.38217240"
            },
            {
                "id": 3454,
                "name": "Tabasco",
                "state_code": "TAB",
                "latitude": "17.84091730",
                "longitude": "-92.61892730"
            },
            {
                "id": 3463,
                "name": "Tamaulipas",
                "state_code": "TAM",
                "latitude": "24.26694000",
                "longitude": "-98.83627550"
            },
            {
                "id": 3458,
                "name": "Tlaxcala",
                "state_code": "TLA",
                "latitude": "19.31815400",
                "longitude": "-98.23749540"
            },
            {
                "id": 3464,
                "name": "Veracruz",
                "state_code": "VER",
                "latitude": "19.17377300",
                "longitude": "-96.13422410"
            },
            {
                "id": 3466,
                "name": "YucatÃ¡n",
                "state_code": "YUC",
                "latitude": "20.70987860",
                "longitude": "-89.09433770"
            },
            {
                "id": 3462,
                "name": "Zacatecas",
                "state_code": "ZAC",
                "latitude": "22.77085550",
                "longitude": "-102.58324260"
            }
        ]
    },
    {
        "name": "Micronesia",
        "iso3": "FSM",
        "iso2": "FM",
        "phone_code": "691",
        "capital": "Palikir",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".fm",
        "native": "Micronesia",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Chuuk",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "CHUT",
                "tzName": "Chuuk Time"
            },
            {
                "zoneName": "Pacific\/Kosrae",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "KOST",
                "tzName": "Kosrae Time"
            },
            {
                "zoneName": "Pacific\/Pohnpei",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "PONT",
                "tzName": "Pohnpei Standard Time"
            }
        ],
        "translations": {
            "kr": "ë¯¸í¬ë¡œë„¤ì‹œì•„ ì—°ë°©",
            "br": "MicronÃ©sia",
            "pt": "MicronÃ©sia",
            "nl": "MicronesiÃ«",
            "hr": "Mikronezija",
            "fa": "Ø§ÛŒØ§Ù„Ø§Øª ÙØ¯Ø±Ø§Ù„ Ù…ÛŒÚ©Ø±ÙˆÙ†Ø²ÛŒ",
            "de": "Mikronesien",
            "es": "Micronesia",
            "fr": "MicronÃ©sie",
            "ja": "ãƒŸã‚¯ãƒ­ãƒã‚·ã‚¢é€£é‚¦",
            "it": "Micronesia",
            "cn": "å¯†å…‹ç½—å°¼è¥¿äºš"
        },
        "latitude": "6.91666666",
        "longitude": "158.25000000",
        "emoji": "ðŸ‡«ðŸ‡²",
        "emojiU": "U+1F1EB U+1F1F2",
        "states": [
            {
                "id": 2580,
                "name": "Chuuk State",
                "state_code": "TRK",
                "latitude": "7.13867590",
                "longitude": "151.55930650"
            },
            {
                "id": 2583,
                "name": "Kosrae State",
                "state_code": "KSA",
                "latitude": "5.30956180",
                "longitude": "162.98148770"
            },
            {
                "id": 2581,
                "name": "Pohnpei State",
                "state_code": "PNI",
                "latitude": "6.85412540",
                "longitude": "158.26238220"
            },
            {
                "id": 2582,
                "name": "Yap State",
                "state_code": "YAP",
                "latitude": "8.67164900",
                "longitude": "142.84393350"
            }
        ]
    },
    {
        "name": "Moldova",
        "iso3": "MDA",
        "iso2": "MD",
        "phone_code": "373",
        "capital": "Chisinau",
        "currency": "MDL",
        "currency_symbol": "L",
        "tld": ".md",
        "native": "Moldova",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Chisinau",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ëª°ë„ë°”",
            "br": "MoldÃ¡via",
            "pt": "MoldÃ¡via",
            "nl": "MoldaviÃ«",
            "hr": "Moldova",
            "fa": "Ù…ÙˆÙ„Ø¯Ø§ÙˆÛŒ",
            "de": "Moldawie",
            "es": "Moldavia",
            "fr": "Moldavie",
            "ja": "ãƒ¢ãƒ«ãƒ‰ãƒå…±å’Œå›½",
            "it": "Moldavia",
            "cn": "æ‘©å°”å¤šç“¦"
        },
        "latitude": "47.00000000",
        "longitude": "29.00000000",
        "emoji": "ðŸ‡²ðŸ‡©",
        "emojiU": "U+1F1F2 U+1F1E9",
        "states": [
            {
                "id": 4368,
                "name": "Anenii Noi District",
                "state_code": "AN",
                "latitude": "46.87956630",
                "longitude": "29.23121750"
            },
            {
                "id": 4393,
                "name": "BÄƒlÈ›i Municipality",
                "state_code": "BA",
                "latitude": "47.75399470",
                "longitude": "27.91841480"
            },
            {
                "id": 4379,
                "name": "Basarabeasca District",
                "state_code": "BS",
                "latitude": "46.42370600",
                "longitude": "28.89354920"
            },
            {
                "id": 4362,
                "name": "Bender Municipality",
                "state_code": "BD",
                "latitude": "46.82275510",
                "longitude": "29.46201010"
            },
            {
                "id": 4375,
                "name": "Briceni District",
                "state_code": "BR",
                "latitude": "48.36320220",
                "longitude": "27.07503980"
            },
            {
                "id": 4391,
                "name": "Cahul District",
                "state_code": "CA",
                "latitude": "45.89394040",
                "longitude": "28.18902750"
            },
            {
                "id": 4366,
                "name": "CÄƒlÄƒraÈ™i District",
                "state_code": "CL",
                "latitude": "47.28694600",
                "longitude": "28.27453100"
            },
            {
                "id": 4380,
                "name": "Cantemir District",
                "state_code": "CT",
                "latitude": "46.27717420",
                "longitude": "28.20096530"
            },
            {
                "id": 4365,
                "name": "CÄƒuÈ™eni District",
                "state_code": "CS",
                "latitude": "46.65547150",
                "longitude": "29.40912220"
            },
            {
                "id": 4373,
                "name": "ChiÈ™inÄƒu Municipality",
                "state_code": "CU",
                "latitude": "47.01045290",
                "longitude": "28.86381020"
            },
            {
                "id": 4360,
                "name": "CimiÈ™lia District",
                "state_code": "CM",
                "latitude": "46.52508510",
                "longitude": "28.77218350"
            },
            {
                "id": 4390,
                "name": "Criuleni District",
                "state_code": "CR",
                "latitude": "47.21361140",
                "longitude": "29.15575190"
            },
            {
                "id": 4384,
                "name": "DonduÈ™eni District",
                "state_code": "DO",
                "latitude": "48.23383050",
                "longitude": "27.59980870"
            },
            {
                "id": 4392,
                "name": "Drochia District",
                "state_code": "DR",
                "latitude": "48.07977880",
                "longitude": "27.86041140"
            },
            {
                "id": 4383,
                "name": "DubÄƒsari District",
                "state_code": "DU",
                "latitude": "47.26439420",
                "longitude": "29.15503480"
            },
            {
                "id": 4387,
                "name": "EdineÈ› District",
                "state_code": "ED",
                "latitude": "48.16789910",
                "longitude": "27.29361430"
            },
            {
                "id": 4381,
                "name": "FÄƒleÈ™ti District",
                "state_code": "FA",
                "latitude": "47.56477250",
                "longitude": "27.72655930"
            },
            {
                "id": 4370,
                "name": "FloreÈ™ti District",
                "state_code": "FL",
                "latitude": "47.86678490",
                "longitude": "28.33918640"
            },
            {
                "id": 4385,
                "name": "Gagauzia",
                "state_code": "GA",
                "latitude": "46.09794350",
                "longitude": "28.63846450"
            },
            {
                "id": 4367,
                "name": "Glodeni District",
                "state_code": "GL",
                "latitude": "47.77901560",
                "longitude": "27.51680100"
            },
            {
                "id": 4382,
                "name": "HÃ®nceÈ™ti District",
                "state_code": "HI",
                "latitude": "46.82811470",
                "longitude": "28.58508890"
            },
            {
                "id": 4369,
                "name": "Ialoveni District",
                "state_code": "IA",
                "latitude": "46.86308600",
                "longitude": "28.82342180"
            },
            {
                "id": 4363,
                "name": "Nisporeni District",
                "state_code": "NI",
                "latitude": "47.07513490",
                "longitude": "28.17681550"
            },
            {
                "id": 4389,
                "name": "OcniÈ›a District",
                "state_code": "OC",
                "latitude": "48.41104350",
                "longitude": "27.47680920"
            },
            {
                "id": 4361,
                "name": "Orhei District",
                "state_code": "OR",
                "latitude": "47.38604000",
                "longitude": "28.83030820"
            },
            {
                "id": 4394,
                "name": "Rezina District",
                "state_code": "RE",
                "latitude": "47.71804470",
                "longitude": "28.88710240"
            },
            {
                "id": 4376,
                "name": "RÃ®È™cani District",
                "state_code": "RI",
                "latitude": "47.90701530",
                "longitude": "27.53749960"
            },
            {
                "id": 4364,
                "name": "SÃ®ngerei District",
                "state_code": "SI",
                "latitude": "47.63891340",
                "longitude": "28.13718160"
            },
            {
                "id": 4388,
                "name": "È˜oldÄƒneÈ™ti District",
                "state_code": "SD",
                "latitude": "47.81473890",
                "longitude": "28.78895860"
            },
            {
                "id": 4374,
                "name": "Soroca District",
                "state_code": "SO",
                "latitude": "48.15497430",
                "longitude": "28.28707830"
            },
            {
                "id": 4378,
                "name": "È˜tefan VodÄƒ District",
                "state_code": "SV",
                "latitude": "46.55404880",
                "longitude": "29.70224200"
            },
            {
                "id": 4377,
                "name": "StrÄƒÈ™eni District",
                "state_code": "ST",
                "latitude": "47.14502670",
                "longitude": "28.61367360"
            },
            {
                "id": 4372,
                "name": "Taraclia District",
                "state_code": "TA",
                "latitude": "45.89865100",
                "longitude": "28.66716440"
            },
            {
                "id": 4371,
                "name": "TeleneÈ™ti District",
                "state_code": "TE",
                "latitude": "47.49839620",
                "longitude": "28.36760190"
            },
            {
                "id": 4395,
                "name": "Transnistria autonomous territorial unit",
                "state_code": "SN",
                "latitude": "47.21529720",
                "longitude": "29.46380540"
            },
            {
                "id": 4386,
                "name": "Ungheni District",
                "state_code": "UN",
                "latitude": "47.23057670",
                "longitude": "27.78926610"
            }
        ]
    },
    {
        "name": "Monaco",
        "iso3": "MCO",
        "iso2": "MC",
        "phone_code": "377",
        "capital": "Monaco",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".mc",
        "native": "Monaco",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Monaco",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ëª¨ë‚˜ì½”",
            "br": "MÃ´naco",
            "pt": "MÃ³naco",
            "nl": "Monaco",
            "hr": "Monako",
            "fa": "Ù…ÙˆÙ†Ø§Ú©Ùˆ",
            "de": "Monaco",
            "es": "MÃ³naco",
            "fr": "Monaco",
            "ja": "ãƒ¢ãƒŠã‚³",
            "it": "Principato di Monaco",
            "cn": "æ‘©çº³å“¥"
        },
        "latitude": "43.73333333",
        "longitude": "7.40000000",
        "emoji": "ðŸ‡²ðŸ‡¨",
        "emojiU": "U+1F1F2 U+1F1E8",
        "states": [
            {
                "id": 4917,
                "name": "La Colle",
                "state_code": "CL",
                "latitude": "43.73274650",
                "longitude": "7.41372760"
            },
            {
                "id": 4918,
                "name": "La Condamine",
                "state_code": "CO",
                "latitude": "43.73506650",
                "longitude": "7.41990600"
            },
            {
                "id": 4919,
                "name": "Moneghetti",
                "state_code": "MG",
                "latitude": "43.73649270",
                "longitude": "7.41533830"
            }
        ]
    },
    {
        "name": "Mongolia",
        "iso3": "MNG",
        "iso2": "MN",
        "phone_code": "976",
        "capital": "Ulan Bator",
        "currency": "MNT",
        "currency_symbol": "â‚®",
        "tld": ".mn",
        "native": "ÐœÐ¾Ð½Ð³Ð¾Ð» ÑƒÐ»Ñ",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Choibalsan",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CHOT",
                "tzName": "Choibalsan Standard Time"
            },
            {
                "zoneName": "Asia\/Hovd",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "HOVT",
                "tzName": "Hovd Time"
            },
            {
                "zoneName": "Asia\/Ulaanbaatar",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "ULAT",
                "tzName": "Ulaanbaatar Standard Time"
            }
        ],
        "translations": {
            "kr": "ëª½ê³¨",
            "br": "MongÃ³lia",
            "pt": "MongÃ³lia",
            "nl": "MongoliÃ«",
            "hr": "Mongolija",
            "fa": "Ù…ØºÙˆÙ„Ø³ØªØ§Ù†",
            "de": "Mongolei",
            "es": "Mongolia",
            "fr": "Mongolie",
            "ja": "ãƒ¢ãƒ³ã‚´ãƒ«",
            "it": "Mongolia",
            "cn": "è’™å¤"
        },
        "latitude": "46.00000000",
        "longitude": "105.00000000",
        "emoji": "ðŸ‡²ðŸ‡³",
        "emojiU": "U+1F1F2 U+1F1F3",
        "states": [
            {
                "id": 1973,
                "name": "Arkhangai Province",
                "state_code": "073",
                "latitude": "47.89711010",
                "longitude": "100.72401650"
            },
            {
                "id": 1969,
                "name": "Bayan-Ã–lgii Province",
                "state_code": "071",
                "latitude": "48.39832540",
                "longitude": "89.66259150"
            },
            {
                "id": 1976,
                "name": "Bayankhongor Province",
                "state_code": "069",
                "latitude": "45.15267070",
                "longitude": "100.10736670"
            },
            {
                "id": 1961,
                "name": "Bulgan Province",
                "state_code": "067",
                "latitude": "48.96909130",
                "longitude": "102.88317230"
            },
            {
                "id": 1962,
                "name": "Darkhan-Uul Province",
                "state_code": "037",
                "latitude": "49.46484340",
                "longitude": "105.97459190"
            },
            {
                "id": 1963,
                "name": "Dornod Province",
                "state_code": "061",
                "latitude": "47.46581540",
                "longitude": "115.39271200"
            },
            {
                "id": 1981,
                "name": "Dornogovi Province",
                "state_code": "063",
                "latitude": "43.96538890",
                "longitude": "109.17734590"
            },
            {
                "id": 1970,
                "name": "Dundgovi Province",
                "state_code": "059",
                "latitude": "45.58227860",
                "longitude": "106.76442090"
            },
            {
                "id": 1972,
                "name": "Govi-Altai Province",
                "state_code": "065",
                "latitude": "45.45112270",
                "longitude": "95.85057660"
            },
            {
                "id": 1978,
                "name": "GovisÃ¼mber Province",
                "state_code": "064",
                "latitude": "46.47627540",
                "longitude": "108.55706270"
            },
            {
                "id": 1974,
                "name": "Khentii Province",
                "state_code": "039",
                "latitude": "47.60812090",
                "longitude": "109.93728560"
            },
            {
                "id": 1964,
                "name": "Khovd Province",
                "state_code": "043",
                "latitude": "47.11296540",
                "longitude": "92.31107520"
            },
            {
                "id": 1975,
                "name": "KhÃ¶vsgÃ¶l Province",
                "state_code": "041",
                "latitude": "50.22044840",
                "longitude": "100.32137680"
            },
            {
                "id": 1967,
                "name": "Ã–mnÃ¶govi Province",
                "state_code": "053",
                "latitude": "43.50002400",
                "longitude": "104.28611160"
            },
            {
                "id": 1966,
                "name": "Orkhon Province",
                "state_code": "035",
                "latitude": "49.00470500",
                "longitude": "104.30165270"
            },
            {
                "id": 1965,
                "name": "Ã–vÃ¶rkhangai Province",
                "state_code": "055",
                "latitude": "45.76243920",
                "longitude": "103.09170320"
            },
            {
                "id": 1980,
                "name": "Selenge Province",
                "state_code": "049",
                "latitude": "50.00592730",
                "longitude": "106.44341080"
            },
            {
                "id": 1977,
                "name": "SÃ¼khbaatar Province",
                "state_code": "051",
                "latitude": "46.56531630",
                "longitude": "113.53808360"
            },
            {
                "id": 1968,
                "name": "TÃ¶v Province",
                "state_code": "047",
                "latitude": "47.21240560",
                "longitude": "106.41541000"
            },
            {
                "id": 1971,
                "name": "Uvs Province",
                "state_code": "046",
                "latitude": "49.64497070",
                "longitude": "93.27365760"
            },
            {
                "id": 1979,
                "name": "Zavkhan Province",
                "state_code": "057",
                "latitude": "48.23881470",
                "longitude": "96.07030190"
            }
        ]
    },
    {
        "name": "Montenegro",
        "iso3": "MNE",
        "iso2": "ME",
        "phone_code": "382",
        "capital": "Podgorica",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".me",
        "native": "Ð¦Ñ€Ð½Ð° Ð“Ð¾Ñ€Ð°",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Podgorica",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ëª¬í…Œë„¤ê·¸ë¡œ",
            "br": "Montenegro",
            "pt": "Montenegro",
            "nl": "Montenegro",
            "hr": "Crna Gora",
            "fa": "Ù…ÙˆÙ†ØªÙ‡â€ŒÙ†Ú¯Ø±Ùˆ",
            "de": "Montenegro",
            "es": "Montenegro",
            "fr": "MontÃ©nÃ©gro",
            "ja": "ãƒ¢ãƒ³ãƒ†ãƒã‚°ãƒ­",
            "it": "Montenegro",
            "cn": "é»‘å±±"
        },
        "latitude": "42.50000000",
        "longitude": "19.30000000",
        "emoji": "ðŸ‡²ðŸ‡ª",
        "emojiU": "U+1F1F2 U+1F1EA",
        "states": [
            {
                "id": 23,
                "name": "Andrijevica Municipality",
                "state_code": "01",
                "latitude": "42.73624770",
                "longitude": "19.78595560"
            },
            {
                "id": 13,
                "name": "Bar Municipality",
                "state_code": "02",
                "latitude": "42.12781190",
                "longitude": "19.14043800"
            },
            {
                "id": 21,
                "name": "Berane Municipality",
                "state_code": "03",
                "latitude": "42.82572890",
                "longitude": "19.90205090"
            },
            {
                "id": 25,
                "name": "Bijelo Polje Municipality",
                "state_code": "04",
                "latitude": "43.08465260",
                "longitude": "19.71154720"
            },
            {
                "id": 30,
                "name": "Budva Municipality",
                "state_code": "05",
                "latitude": "42.31407200",
                "longitude": "18.83138320"
            },
            {
                "id": 14,
                "name": "Danilovgrad Municipality",
                "state_code": "07",
                "latitude": "42.58357000",
                "longitude": "19.14043800"
            },
            {
                "id": 24,
                "name": "Gusinje Municipality",
                "state_code": "22",
                "latitude": "42.55634550",
                "longitude": "19.83060510"
            },
            {
                "id": 31,
                "name": "KolaÅ¡in Municipality",
                "state_code": "09",
                "latitude": "42.76019160",
                "longitude": "19.42591140"
            },
            {
                "id": 26,
                "name": "Kotor Municipality",
                "state_code": "10",
                "latitude": "42.57402610",
                "longitude": "18.64131450"
            },
            {
                "id": 22,
                "name": "Mojkovac Municipality",
                "state_code": "11",
                "latitude": "42.96880180",
                "longitude": "19.52110630"
            },
            {
                "id": 17,
                "name": "NikÅ¡iÄ‡ Municipality",
                "state_code": "12",
                "latitude": "42.79971840",
                "longitude": "18.76009630"
            },
            {
                "id": 28,
                "name": "Old Royal Capital Cetinje",
                "state_code": "06",
                "latitude": "42.39309590",
                "longitude": "18.91159640"
            },
            {
                "id": 12,
                "name": "Petnjica Municipality",
                "state_code": "23",
                "latitude": "42.93534800",
                "longitude": "20.02114490"
            },
            {
                "id": 19,
                "name": "Plav Municipality",
                "state_code": "13",
                "latitude": "42.60013370",
                "longitude": "19.94075410"
            },
            {
                "id": 20,
                "name": "Pljevlja Municipality",
                "state_code": "14",
                "latitude": "43.27233830",
                "longitude": "19.28315310"
            },
            {
                "id": 16,
                "name": "PluÅ¾ine Municipality",
                "state_code": "15",
                "latitude": "43.15933840",
                "longitude": "18.85514840"
            },
            {
                "id": 27,
                "name": "Podgorica Municipality",
                "state_code": "16",
                "latitude": "42.36938340",
                "longitude": "19.28315310"
            },
            {
                "id": 15,
                "name": "RoÅ¾aje Municipality",
                "state_code": "17",
                "latitude": "42.84083890",
                "longitude": "20.16706280"
            },
            {
                "id": 18,
                "name": "Å avnik Municipality",
                "state_code": "18",
                "latitude": "42.96037560",
                "longitude": "19.14043800"
            },
            {
                "id": 29,
                "name": "Tivat Municipality",
                "state_code": "19",
                "latitude": "42.42348000",
                "longitude": "18.71851840"
            },
            {
                "id": 33,
                "name": "Ulcinj Municipality",
                "state_code": "20",
                "latitude": "41.96527950",
                "longitude": "19.30694320"
            },
            {
                "id": 32,
                "name": "Å½abljak Municipality",
                "state_code": "21",
                "latitude": "43.15551520",
                "longitude": "19.12260180"
            }
        ]
    },
    {
        "name": "Montserrat",
        "iso3": "MSR",
        "iso2": "MS",
        "phone_code": "+1-664",
        "capital": "Plymouth",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".ms",
        "native": "Montserrat",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Montserrat",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ëª¬íŠ¸ì„¸ëž«",
            "br": "Montserrat",
            "pt": "Monserrate",
            "nl": "Montserrat",
            "hr": "Montserrat",
            "fa": "Ù…Ø§ÛŒÙˆØª",
            "de": "Montserrat",
            "es": "Montserrat",
            "fr": "Montserrat",
            "ja": "ãƒ¢ãƒ³ãƒˆã‚»ãƒ©ãƒˆ",
            "it": "Montserrat",
            "cn": "è’™ç‰¹å¡žæ‹‰ç‰¹"
        },
        "latitude": "16.75000000",
        "longitude": "-62.20000000",
        "emoji": "ðŸ‡²ðŸ‡¸",
        "emojiU": "U+1F1F2 U+1F1F8",
        "states": []
    },
    {
        "name": "Morocco",
        "iso3": "MAR",
        "iso2": "MA",
        "phone_code": "212",
        "capital": "Rabat",
        "currency": "MAD",
        "currency_symbol": "DH",
        "tld": ".ma",
        "native": "Ø§Ù„Ù…ØºØ±Ø¨",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Casablanca",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WEST",
                "tzName": "Western European Summer Time"
            }
        ],
        "translations": {
            "kr": "ëª¨ë¡œì½”",
            "br": "Marrocos",
            "pt": "Marrocos",
            "nl": "Marokko",
            "hr": "Maroko",
            "fa": "Ù…Ø±Ø§Ú©Ø´",
            "de": "Marokko",
            "es": "Marruecos",
            "fr": "Maroc",
            "ja": "ãƒ¢ãƒ­ãƒƒã‚³",
            "it": "Marocco",
            "cn": "æ‘©æ´›å“¥"
        },
        "latitude": "32.00000000",
        "longitude": "-5.00000000",
        "emoji": "ðŸ‡²ðŸ‡¦",
        "emojiU": "U+1F1F2 U+1F1E6",
        "states": [
            {
                "id": 3320,
                "name": "Al Haouz Province",
                "state_code": "HAO",
                "latitude": "31.29567290",
                "longitude": "-7.87216000"
            },
            {
                "id": 3267,
                "name": "Al HoceÃ¯ma Province",
                "state_code": "HOC",
                "latitude": "35.24455890",
                "longitude": "-3.93174680"
            },
            {
                "id": 3266,
                "name": "Aousserd Province",
                "state_code": "AOU",
                "latitude": "22.55215380",
                "longitude": "-14.32973530"
            },
            {
                "id": 3297,
                "name": "Assa-Zag Province",
                "state_code": "ASZ",
                "latitude": "28.14023950",
                "longitude": "-9.72326730"
            },
            {
                "id": 3321,
                "name": "Azilal Province",
                "state_code": "AZI",
                "latitude": "32.00426200",
                "longitude": "-6.57833870"
            },
            {
                "id": 3304,
                "name": "Ben Slimane Province",
                "state_code": "BES",
                "latitude": "33.61896980",
                "longitude": "-7.13055360"
            },
            {
                "id": 3278,
                "name": "BÃ©ni Mellal-KhÃ©nifra",
                "state_code": "05",
                "latitude": "32.57191840",
                "longitude": "-6.06791940"
            },
            {
                "id": 3272,
                "name": "BÃ©ni-Mellal Province",
                "state_code": "BEM",
                "latitude": "32.34244300",
                "longitude": "-6.37579900"
            },
            {
                "id": 3285,
                "name": "Berkane Province",
                "state_code": "BER",
                "latitude": "34.88408760",
                "longitude": "-2.34188700"
            },
            {
                "id": 3275,
                "name": "Boujdour Province",
                "state_code": "BOD",
                "latitude": "26.12524930",
                "longitude": "-14.48473470"
            },
            {
                "id": 3270,
                "name": "Boulemane Province",
                "state_code": "BOM",
                "latitude": "33.36251590",
                "longitude": "-4.73033970"
            },
            {
                "id": 3303,
                "name": "Casablanca-Settat",
                "state_code": "06",
                "latitude": "33.21608720",
                "longitude": "-7.43813550"
            },
            {
                "id": 3310,
                "name": "Chefchaouen Province",
                "state_code": "CHE",
                "latitude": "35.01817200",
                "longitude": "-5.14320680"
            },
            {
                "id": 3274,
                "name": "Chichaoua Province",
                "state_code": "CHI",
                "latitude": "31.53835810",
                "longitude": "-8.76463880"
            },
            {
                "id": 3306,
                "name": "Dakhla-Oued Ed-Dahab",
                "state_code": "12",
                "latitude": "22.73378920",
                "longitude": "-14.28611160"
            },
            {
                "id": 3290,
                "name": "DrÃ¢a-Tafilalet",
                "state_code": "08",
                "latitude": "31.14995380",
                "longitude": "-5.39395510"
            },
            {
                "id": 3291,
                "name": "El Hajeb Province",
                "state_code": "HAJ",
                "latitude": "33.68573500",
                "longitude": "-5.36778440"
            },
            {
                "id": 3280,
                "name": "El Jadida Province",
                "state_code": "JDI",
                "latitude": "33.23163260",
                "longitude": "-8.50071160"
            },
            {
                "id": 3299,
                "name": "Errachidia Province",
                "state_code": "ERR",
                "latitude": "31.90512750",
                "longitude": "-4.72775280"
            },
            {
                "id": 3292,
                "name": "Es Semara Province",
                "state_code": "ESM",
                "latitude": "26.74185600",
                "longitude": "-11.67836710"
            },
            {
                "id": 3316,
                "name": "Essaouira Province",
                "state_code": "ESI",
                "latitude": "31.50849260",
                "longitude": "-9.75950410"
            },
            {
                "id": 3300,
                "name": "Fahs Anjra Province",
                "state_code": "FAH",
                "latitude": "35.76019920",
                "longitude": "-5.66683060"
            },
            {
                "id": 3313,
                "name": "FÃ¨s-MeknÃ¨s",
                "state_code": "03",
                "latitude": "34.06252900",
                "longitude": "-4.72775280"
            },
            {
                "id": 3301,
                "name": "Figuig Province",
                "state_code": "FIG",
                "latitude": "32.10926130",
                "longitude": "-1.22980600"
            },
            {
                "id": 3265,
                "name": "Guelmim Province",
                "state_code": "GUE",
                "latitude": "28.98836590",
                "longitude": "-10.05274980"
            },
            {
                "id": 3305,
                "name": "Guelmim-Oued Noun",
                "state_code": "10",
                "latitude": "28.48442810",
                "longitude": "-10.08072980"
            },
            {
                "id": 3325,
                "name": "Ifrane Province",
                "state_code": "IFR",
                "latitude": "33.52280620",
                "longitude": "-5.11095520"
            },
            {
                "id": 3294,
                "name": "Inezgane-AÃ¯t Melloul Prefecture",
                "state_code": "INE",
                "latitude": "30.35090980",
                "longitude": "-9.38951100"
            },
            {
                "id": 3307,
                "name": "Jerada Province",
                "state_code": "JRA",
                "latitude": "34.30617910",
                "longitude": "-2.17941360"
            },
            {
                "id": 3309,
                "name": "Kelaat Sraghna Province",
                "state_code": "KES",
                "latitude": "32.05227670",
                "longitude": "-7.35165580"
            },
            {
                "id": 3308,
                "name": "KÃ©nitra Province",
                "state_code": "KEN",
                "latitude": "34.25405030",
                "longitude": "-6.58901660"
            },
            {
                "id": 3276,
                "name": "KhÃ©misset Province",
                "state_code": "KHE",
                "latitude": "33.81537040",
                "longitude": "-6.05733020"
            },
            {
                "id": 3317,
                "name": "KhÃ©nifra Province",
                "state_code": "KHN",
                "latitude": "32.93404710",
                "longitude": "-5.66157100"
            },
            {
                "id": 3326,
                "name": "Khouribga Province",
                "state_code": "KHO",
                "latitude": "32.88602300",
                "longitude": "-6.92086550"
            },
            {
                "id": 3293,
                "name": "LaÃ¢youne Province",
                "state_code": "LAA",
                "latitude": "27.15003840",
                "longitude": "-13.19907580"
            },
            {
                "id": 3298,
                "name": "LaÃ¢youne-Sakia El Hamra",
                "state_code": "11",
                "latitude": "27.86831940",
                "longitude": "-11.98046130"
            },
            {
                "id": 3268,
                "name": "Larache Province",
                "state_code": "LAR",
                "latitude": "35.17442710",
                "longitude": "-6.14739640"
            },
            {
                "id": 3288,
                "name": "Marrakesh-Safi",
                "state_code": "07",
                "latitude": "31.73308330",
                "longitude": "-8.13385580"
            },
            {
                "id": 3284,
                "name": "Mediouna Province",
                "state_code": "MED",
                "latitude": "33.45409390",
                "longitude": "-7.51660200"
            },
            {
                "id": 3315,
                "name": "Moulay Yacoub Province",
                "state_code": "MOU",
                "latitude": "34.08744790",
                "longitude": "-5.17840190"
            },
            {
                "id": 3281,
                "name": "Nador Province",
                "state_code": "NAD",
                "latitude": "34.91719260",
                "longitude": "-2.85771050"
            },
            {
                "id": 3287,
                "name": "Nouaceur Province",
                "state_code": "NOU",
                "latitude": "33.36703930",
                "longitude": "-7.57325370"
            },
            {
                "id": 3271,
                "name": "Oriental",
                "state_code": "02",
                "latitude": "37.06968300",
                "longitude": "-94.51227700"
            },
            {
                "id": 3269,
                "name": "Ouarzazate Province",
                "state_code": "OUA",
                "latitude": "30.93354360",
                "longitude": "-6.93701600"
            },
            {
                "id": 3319,
                "name": "Oued Ed-Dahab Province",
                "state_code": "OUD",
                "latitude": "22.73378920",
                "longitude": "-14.28611160"
            },
            {
                "id": 3311,
                "name": "Safi Province",
                "state_code": "SAF",
                "latitude": "32.29898720",
                "longitude": "-9.10134980"
            },
            {
                "id": 3289,
                "name": "Sefrou Province",
                "state_code": "SEF",
                "latitude": "33.83052440",
                "longitude": "-4.83531540"
            },
            {
                "id": 3282,
                "name": "Settat Province",
                "state_code": "SET",
                "latitude": "32.99242420",
                "longitude": "-7.62226650"
            },
            {
                "id": 3302,
                "name": "Shtouka Ait Baha Province",
                "state_code": "CHT",
                "latitude": "30.10724220",
                "longitude": "-9.27855830"
            },
            {
                "id": 3279,
                "name": "Sidi Kacem Province",
                "state_code": "SIK",
                "latitude": "34.22601720",
                "longitude": "-5.71291640"
            },
            {
                "id": 3273,
                "name": "Sidi Youssef Ben Ali",
                "state_code": "SYB",
                "latitude": "31.60843730",
                "longitude": "-7.96530670"
            },
            {
                "id": 3295,
                "name": "Souss-Massa",
                "state_code": "09",
                "latitude": "30.27506110",
                "longitude": "-8.13385580"
            },
            {
                "id": 3286,
                "name": "Tan-Tan Province",
                "state_code": "TNT",
                "latitude": "28.03012000",
                "longitude": "-11.16173560"
            },
            {
                "id": 3324,
                "name": "Tanger-TÃ©touan-Al HoceÃ¯ma",
                "state_code": "01",
                "latitude": "35.26295580",
                "longitude": "-5.56172790"
            },
            {
                "id": 3323,
                "name": "Taounate Province",
                "state_code": "TAO",
                "latitude": "34.53691700",
                "longitude": "-4.63986930"
            },
            {
                "id": 3322,
                "name": "Taourirt Province",
                "state_code": "TAI",
                "latitude": "34.21259800",
                "longitude": "-2.69838680"
            },
            {
                "id": 3314,
                "name": "Taroudant Province",
                "state_code": "TAR",
                "latitude": "30.47271260",
                "longitude": "-8.87487650"
            },
            {
                "id": 3312,
                "name": "Tata Province",
                "state_code": "TAT",
                "latitude": "29.75087700",
                "longitude": "-7.97563430"
            },
            {
                "id": 3296,
                "name": "Taza Province",
                "state_code": "TAZ",
                "latitude": "34.27889530",
                "longitude": "-3.58126920"
            },
            {
                "id": 3318,
                "name": "TÃ©touan Province",
                "state_code": "TET",
                "latitude": "35.58889950",
                "longitude": "-5.36255160"
            },
            {
                "id": 3277,
                "name": "Tiznit Province",
                "state_code": "TIZ",
                "latitude": "29.69339200",
                "longitude": "-9.73215700"
            },
            {
                "id": 3283,
                "name": "Zagora Province",
                "state_code": "ZAG",
                "latitude": "30.57860930",
                "longitude": "-5.89871390"
            }
        ]
    },
    {
        "name": "Mozambique",
        "iso3": "MOZ",
        "iso2": "MZ",
        "phone_code": "258",
        "capital": "Maputo",
        "currency": "MZN",
        "currency_symbol": "MT",
        "tld": ".mz",
        "native": "MoÃ§ambique",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Maputo",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ëª¨ìž ë¹„í¬",
            "br": "MoÃ§ambique",
            "pt": "MoÃ§ambique",
            "nl": "Mozambique",
            "hr": "Mozambik",
            "fa": "Ù…ÙˆØ²Ø§Ù…Ø¨ÛŒÚ©",
            "de": "Mosambik",
            "es": "Mozambique",
            "fr": "Mozambique",
            "ja": "ãƒ¢ã‚¶ãƒ³ãƒ“ãƒ¼ã‚¯",
            "it": "Mozambico",
            "cn": "èŽ«æ¡‘æ¯”å…‹"
        },
        "latitude": "-18.25000000",
        "longitude": "35.00000000",
        "emoji": "ðŸ‡²ðŸ‡¿",
        "emojiU": "U+1F1F2 U+1F1FF",
        "states": [
            {
                "id": 3327,
                "name": "Cabo Delgado Province",
                "state_code": "P",
                "latitude": "-12.33354740",
                "longitude": "39.32062410"
            },
            {
                "id": 3329,
                "name": "Gaza Province",
                "state_code": "G",
                "latitude": "-23.02219280",
                "longitude": "32.71813750"
            },
            {
                "id": 3330,
                "name": "Inhambane Province",
                "state_code": "I",
                "latitude": "-22.85279970",
                "longitude": "34.55087580"
            },
            {
                "id": 3337,
                "name": "Manica Province",
                "state_code": "B",
                "latitude": "-19.50597870",
                "longitude": "33.43835300"
            },
            {
                "id": 3335,
                "name": "Maputo",
                "state_code": "MPM",
                "latitude": "-25.96924800",
                "longitude": "32.57317460"
            },
            {
                "id": 3332,
                "name": "Maputo Province",
                "state_code": "L",
                "latitude": "-25.25698760",
                "longitude": "32.53727410"
            },
            {
                "id": 3336,
                "name": "Nampula Province",
                "state_code": "N",
                "latitude": "-14.76049310",
                "longitude": "39.32062410"
            },
            {
                "id": 3333,
                "name": "Niassa Province",
                "state_code": "A",
                "latitude": "-12.78262020",
                "longitude": "36.60939260"
            },
            {
                "id": 3331,
                "name": "Sofala Province",
                "state_code": "S",
                "latitude": "-19.20390730",
                "longitude": "34.86241660"
            },
            {
                "id": 3334,
                "name": "Tete Province",
                "state_code": "T",
                "latitude": "-15.65960560",
                "longitude": "32.71813750"
            },
            {
                "id": 3328,
                "name": "Zambezia Province",
                "state_code": "Q",
                "latitude": "-16.56389870",
                "longitude": "36.60939260"
            }
        ]
    },
    {
        "name": "Myanmar",
        "iso3": "MMR",
        "iso2": "MM",
        "phone_code": "95",
        "capital": "Nay Pyi Taw",
        "currency": "MMK",
        "currency_symbol": "K",
        "tld": ".mm",
        "native": "á€™á€¼á€”á€ºá€™á€¬",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Yangon",
                "gmtOffset": 23400,
                "gmtOffsetName": "UTC+06:30",
                "abbreviation": "MMT",
                "tzName": "Myanmar Standard Time"
            }
        ],
        "translations": {
            "kr": "ë¯¸ì–€ë§ˆ",
            "br": "Myanmar",
            "pt": "Myanmar",
            "nl": "Myanmar",
            "hr": "Mijanmar",
            "fa": "Ù…ÛŒØ§Ù†Ù…Ø§Ø±",
            "de": "Myanmar",
            "es": "Myanmar",
            "fr": "Myanmar",
            "ja": "ãƒŸãƒ£ãƒ³ãƒžãƒ¼",
            "it": "Birmania",
            "cn": "ç¼…ç”¸"
        },
        "latitude": "22.00000000",
        "longitude": "98.00000000",
        "emoji": "ðŸ‡²ðŸ‡²",
        "emojiU": "U+1F1F2 U+1F1F2",
        "states": [
            {
                "id": 2142,
                "name": "Ayeyarwady Region",
                "state_code": "07",
                "latitude": "17.03421250",
                "longitude": "95.22666750"
            },
            {
                "id": 2141,
                "name": "Bago",
                "state_code": "02",
                "latitude": "17.32207110",
                "longitude": "96.46632860"
            },
            {
                "id": 2137,
                "name": "Chin State",
                "state_code": "14",
                "latitude": "22.00869780",
                "longitude": "93.58126920"
            },
            {
                "id": 2143,
                "name": "Kachin State",
                "state_code": "11",
                "latitude": "25.85090400",
                "longitude": "97.43813550"
            },
            {
                "id": 2144,
                "name": "Kayah State",
                "state_code": "12",
                "latitude": "19.23420610",
                "longitude": "97.26528580"
            },
            {
                "id": 2133,
                "name": "Kayin State",
                "state_code": "13",
                "latitude": "16.94593460",
                "longitude": "97.95928630"
            },
            {
                "id": 2136,
                "name": "Magway Region",
                "state_code": "03",
                "latitude": "19.88713860",
                "longitude": "94.72775280"
            },
            {
                "id": 2134,
                "name": "Mandalay Region",
                "state_code": "04",
                "latitude": "21.56190580",
                "longitude": "95.89871390"
            },
            {
                "id": 2147,
                "name": "Mon State",
                "state_code": "15",
                "latitude": "16.30031330",
                "longitude": "97.69822720"
            },
            {
                "id": 2146,
                "name": "Naypyidaw Union Territory",
                "state_code": "18",
                "latitude": "19.93862450",
                "longitude": "96.15269850"
            },
            {
                "id": 2138,
                "name": "Rakhine State",
                "state_code": "16",
                "latitude": "20.10408180",
                "longitude": "93.58126920"
            },
            {
                "id": 2145,
                "name": "Sagaing Region",
                "state_code": "01",
                "latitude": "24.42838100",
                "longitude": "95.39395510"
            },
            {
                "id": 2139,
                "name": "Shan State",
                "state_code": "17",
                "latitude": "22.03619850",
                "longitude": "98.13385580"
            },
            {
                "id": 2140,
                "name": "Tanintharyi Region",
                "state_code": "05",
                "latitude": "12.47068760",
                "longitude": "99.01289260"
            },
            {
                "id": 2135,
                "name": "Yangon Region",
                "state_code": "06",
                "latitude": "16.91434880",
                "longitude": "96.15269850"
            }
        ]
    },
    {
        "name": "Namibia",
        "iso3": "NAM",
        "iso2": "NA",
        "phone_code": "264",
        "capital": "Windhoek",
        "currency": "NAD",
        "currency_symbol": "$",
        "tld": ".na",
        "native": "Namibia",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Windhoek",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "WAST",
                "tzName": "West Africa Summer Time"
            }
        ],
        "translations": {
            "kr": "ë‚˜ë¯¸ë¹„ì•„",
            "br": "NamÃ­bia",
            "pt": "NamÃ­bia",
            "nl": "NamibiÃ«",
            "hr": "Namibija",
            "fa": "Ù†Ø§Ù…ÛŒØ¨ÛŒØ§",
            "de": "Namibia",
            "es": "Namibia",
            "fr": "Namibie",
            "ja": "ãƒŠãƒŸãƒ“ã‚¢",
            "it": "Namibia",
            "cn": "çº³ç±³æ¯”äºš"
        },
        "latitude": "-22.00000000",
        "longitude": "17.00000000",
        "emoji": "ðŸ‡³ðŸ‡¦",
        "emojiU": "U+1F1F3 U+1F1E6",
        "states": [
            {
                "id": 43,
                "name": "Erongo Region",
                "state_code": "ER",
                "latitude": "-22.25656820",
                "longitude": "15.40680790"
            },
            {
                "id": 38,
                "name": "Hardap Region",
                "state_code": "HA",
                "latitude": "-24.23101340",
                "longitude": "17.66888700"
            },
            {
                "id": 45,
                "name": "Karas Region",
                "state_code": "KA",
                "latitude": "-26.84296450",
                "longitude": "17.29028390"
            },
            {
                "id": 36,
                "name": "Kavango East Region",
                "state_code": "KE",
                "latitude": "-18.27104800",
                "longitude": "18.42760470"
            },
            {
                "id": 35,
                "name": "Kavango West Region",
                "state_code": "KW",
                "latitude": "-18.27104800",
                "longitude": "18.42760470"
            },
            {
                "id": 44,
                "name": "Khomas Region",
                "state_code": "KH",
                "latitude": "-22.63778540",
                "longitude": "17.10119310"
            },
            {
                "id": 34,
                "name": "Kunene Region",
                "state_code": "KU",
                "latitude": "-19.40863170",
                "longitude": "13.91439900"
            },
            {
                "id": 40,
                "name": "Ohangwena Region",
                "state_code": "OW",
                "latitude": "-17.59792910",
                "longitude": "16.81783770"
            },
            {
                "id": 41,
                "name": "Omaheke Region",
                "state_code": "OH",
                "latitude": "-21.84666510",
                "longitude": "19.18800470"
            },
            {
                "id": 39,
                "name": "Omusati Region",
                "state_code": "OS",
                "latitude": "-18.40702940",
                "longitude": "14.84546190"
            },
            {
                "id": 37,
                "name": "Oshana Region",
                "state_code": "ON",
                "latitude": "-18.43050640",
                "longitude": "15.68817880"
            },
            {
                "id": 42,
                "name": "Oshikoto Region",
                "state_code": "OT",
                "latitude": "-18.41525750",
                "longitude": "16.91225100"
            },
            {
                "id": 46,
                "name": "Otjozondjupa Region",
                "state_code": "OD",
                "latitude": "-20.54869160",
                "longitude": "17.66888700"
            },
            {
                "id": 47,
                "name": "Zambezi Region",
                "state_code": "CA",
                "latitude": "-17.81934190",
                "longitude": "23.95364660"
            }
        ]
    },
    {
        "name": "Nauru",
        "iso3": "NRU",
        "iso2": "NR",
        "phone_code": "674",
        "capital": "Yaren",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".nr",
        "native": "Nauru",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Nauru",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "NRT",
                "tzName": "Nauru Time"
            }
        ],
        "translations": {
            "kr": "ë‚˜ìš°ë£¨",
            "br": "Nauru",
            "pt": "Nauru",
            "nl": "Nauru",
            "hr": "Nauru",
            "fa": "Ù†Ø§Ø¦ÙˆØ±Ùˆ",
            "de": "Nauru",
            "es": "Nauru",
            "fr": "Nauru",
            "ja": "ãƒŠã‚¦ãƒ«",
            "it": "Nauru",
            "cn": "ç‘™é²"
        },
        "latitude": "-0.53333333",
        "longitude": "166.91666666",
        "emoji": "ðŸ‡³ðŸ‡·",
        "emojiU": "U+1F1F3 U+1F1F7",
        "states": [
            {
                "id": 4656,
                "name": "Aiwo District",
                "state_code": "01",
                "latitude": "-0.53400120",
                "longitude": "166.91388730"
            },
            {
                "id": 4658,
                "name": "Anabar District",
                "state_code": "02",
                "latitude": "-0.51335170",
                "longitude": "166.94846240"
            },
            {
                "id": 4667,
                "name": "Anetan District",
                "state_code": "03",
                "latitude": "-0.50643430",
                "longitude": "166.94270060"
            },
            {
                "id": 4663,
                "name": "Anibare District",
                "state_code": "04",
                "latitude": "-0.52947580",
                "longitude": "166.95134320"
            },
            {
                "id": 4660,
                "name": "Baiti District",
                "state_code": "05",
                "latitude": "-0.51043100",
                "longitude": "166.92757440"
            },
            {
                "id": 4665,
                "name": "Boe District",
                "state_code": "06",
                "latitude": "39.07327760",
                "longitude": "-94.57104980"
            },
            {
                "id": 4662,
                "name": "Buada District",
                "state_code": "07",
                "latitude": "-0.53287770",
                "longitude": "166.92685410"
            },
            {
                "id": 4666,
                "name": "Denigomodu District",
                "state_code": "08",
                "latitude": "-0.52479640",
                "longitude": "166.91676890"
            },
            {
                "id": 4654,
                "name": "Ewa District",
                "state_code": "09",
                "latitude": "-0.50872410",
                "longitude": "166.93693840"
            },
            {
                "id": 4661,
                "name": "Ijuw District",
                "state_code": "10",
                "latitude": "-0.52027670",
                "longitude": "166.95710460"
            },
            {
                "id": 4657,
                "name": "Meneng District",
                "state_code": "11",
                "latitude": "-0.54672400",
                "longitude": "166.93837900"
            },
            {
                "id": 4659,
                "name": "Nibok District",
                "state_code": "12",
                "latitude": "-0.51962080",
                "longitude": "166.91893010"
            },
            {
                "id": 4655,
                "name": "Uaboe District",
                "state_code": "13",
                "latitude": "-0.52022220",
                "longitude": "166.93117610"
            },
            {
                "id": 4664,
                "name": "Yaren District",
                "state_code": "14",
                "latitude": "-0.54668570",
                "longitude": "166.92109130"
            }
        ]
    },
    {
        "name": "Nepal",
        "iso3": "NPL",
        "iso2": "NP",
        "phone_code": "977",
        "capital": "Kathmandu",
        "currency": "NPR",
        "currency_symbol": "â‚¨",
        "tld": ".np",
        "native": "à¤¨à¤ªà¤²",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Kathmandu",
                "gmtOffset": 20700,
                "gmtOffsetName": "UTC+05:45",
                "abbreviation": "NPT",
                "tzName": "Nepal Time"
            }
        ],
        "translations": {
            "kr": "ë„¤íŒ”",
            "br": "Nepal",
            "pt": "Nepal",
            "nl": "Nepal",
            "hr": "Nepal",
            "fa": "Ù†Ù¾Ø§Ù„",
            "de": "NÃ©pal",
            "es": "Nepal",
            "fr": "NÃ©pal",
            "ja": "ãƒãƒ‘ãƒ¼ãƒ«",
            "it": "Nepal",
            "cn": "å°¼æ³Šå°”"
        },
        "latitude": "28.00000000",
        "longitude": "84.00000000",
        "emoji": "ðŸ‡³ðŸ‡µ",
        "emojiU": "U+1F1F3 U+1F1F5",
        "states": [
            {
                "id": 2082,
                "name": "Bagmati Zone",
                "state_code": "BA",
                "latitude": "28.03675770",
                "longitude": "85.43755740"
            },
            {
                "id": 2071,
                "name": "Bheri Zone",
                "state_code": "BH",
                "latitude": "28.51745600",
                "longitude": "81.77870210"
            },
            {
                "id": 2073,
                "name": "Central Region",
                "state_code": "1",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2080,
                "name": "Dhaulagiri Zone",
                "state_code": "DH",
                "latitude": "28.61117600",
                "longitude": "83.50702030"
            },
            {
                "id": 2069,
                "name": "Eastern Development Region",
                "state_code": "4",
                "latitude": "27.33090720",
                "longitude": "87.06242610"
            },
            {
                "id": 2068,
                "name": "Far-Western Development Region",
                "state_code": "5",
                "latitude": "29.29878710",
                "longitude": "80.98710740"
            },
            {
                "id": 2081,
                "name": "Gandaki Zone",
                "state_code": "GA",
                "latitude": "28.37320370",
                "longitude": "84.43827210"
            },
            {
                "id": 2076,
                "name": "Janakpur Zone",
                "state_code": "JA",
                "latitude": "27.21108990",
                "longitude": "86.01215730"
            },
            {
                "id": 2079,
                "name": "Karnali Zone",
                "state_code": "KA",
                "latitude": "29.38625550",
                "longitude": "82.38857830"
            },
            {
                "id": 2072,
                "name": "Kosi Zone",
                "state_code": "KO",
                "latitude": "27.05365240",
                "longitude": "87.30161320"
            },
            {
                "id": 2074,
                "name": "Lumbini Zone",
                "state_code": "LU",
                "latitude": "27.45000000",
                "longitude": "83.25000000"
            },
            {
                "id": 2083,
                "name": "Mahakali Zone",
                "state_code": "MA",
                "latitude": "29.36010790",
                "longitude": "80.54384500"
            },
            {
                "id": 2070,
                "name": "Mechi Zone",
                "state_code": "ME",
                "latitude": "26.87600070",
                "longitude": "87.93348030"
            },
            {
                "id": 2066,
                "name": "Mid-Western Region",
                "state_code": "2",
                "latitude": "38.41118410",
                "longitude": "-90.38320980"
            },
            {
                "id": 2075,
                "name": "Narayani Zone",
                "state_code": "NA",
                "latitude": "27.36117660",
                "longitude": "84.85679320"
            },
            {
                "id": 2077,
                "name": "Rapti Zone",
                "state_code": "RA",
                "latitude": "28.27434700",
                "longitude": "82.38857830"
            },
            {
                "id": 2084,
                "name": "Sagarmatha Zone",
                "state_code": "SA",
                "latitude": "27.32382630",
                "longitude": "86.74163740"
            },
            {
                "id": 2078,
                "name": "Seti Zone",
                "state_code": "SE",
                "latitude": "29.69054270",
                "longitude": "81.33994140"
            },
            {
                "id": 2067,
                "name": "Western Region",
                "state_code": "3",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Netherlands The",
        "iso3": "NLD",
        "iso2": "NL",
        "phone_code": "31",
        "capital": "Amsterdam",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".nl",
        "native": "Nederland",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Amsterdam",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë„¤ëœëž€ë“œ ",
            "br": "Holanda",
            "pt": "PaÃ­ses Baixos",
            "nl": "Nederland",
            "hr": "Nizozemska",
            "fa": "Ù¾Ø§Ø¯Ø´Ø§Ù‡ÛŒ Ù‡Ù„Ù†Ø¯",
            "de": "Niederlande",
            "es": "PaÃ­ses Bajos",
            "fr": "Pays-Bas",
            "ja": "ã‚ªãƒ©ãƒ³ãƒ€",
            "it": "Paesi Bassi",
            "cn": "è·å…°"
        },
        "latitude": "52.50000000",
        "longitude": "5.75000000",
        "emoji": "ðŸ‡³ðŸ‡±",
        "emojiU": "U+1F1F3 U+1F1F1",
        "states": [
            {
                "id": 2624,
                "name": "Bonaire",
                "state_code": "BQ1",
                "latitude": "12.20189020",
                "longitude": "-68.26238220"
            },
            {
                "id": 2613,
                "name": "Drenthe",
                "state_code": "DR",
                "latitude": "52.94760120",
                "longitude": "6.62305860"
            },
            {
                "id": 2619,
                "name": "Flevoland",
                "state_code": "FL",
                "latitude": "52.52797810",
                "longitude": "5.59535080"
            },
            {
                "id": 2622,
                "name": "Friesland",
                "state_code": "FR",
                "latitude": "53.16416420",
                "longitude": "5.78175420"
            },
            {
                "id": 2611,
                "name": "Gelderland",
                "state_code": "GE",
                "latitude": "52.04515500",
                "longitude": "5.87182350"
            },
            {
                "id": 2617,
                "name": "Groningen",
                "state_code": "GR",
                "latitude": "53.21938350",
                "longitude": "6.56650170"
            },
            {
                "id": 2615,
                "name": "Limburg",
                "state_code": "LI",
                "latitude": "51.44272380",
                "longitude": "6.06087260"
            },
            {
                "id": 2623,
                "name": "North Brabant",
                "state_code": "NB",
                "latitude": "51.48265370",
                "longitude": "5.23216870"
            },
            {
                "id": 2612,
                "name": "North Holland",
                "state_code": "NH",
                "latitude": "52.52058690",
                "longitude": "4.78847400"
            },
            {
                "id": 2618,
                "name": "Overijssel",
                "state_code": "OV",
                "latitude": "52.43878140",
                "longitude": "6.50164110"
            },
            {
                "id": 2621,
                "name": "Saba",
                "state_code": "BQ2",
                "latitude": "17.63546420",
                "longitude": "-63.23267630"
            },
            {
                "id": 2616,
                "name": "Sint Eustatius",
                "state_code": "BQ3",
                "latitude": "17.48903060",
                "longitude": "-62.97355500"
            },
            {
                "id": 2614,
                "name": "South Holland",
                "state_code": "ZH",
                "latitude": "41.60086810",
                "longitude": "-87.60698940"
            },
            {
                "id": 2610,
                "name": "Utrecht",
                "state_code": "UT",
                "latitude": "52.09073740",
                "longitude": "5.12142010"
            },
            {
                "id": 2620,
                "name": "Zeeland",
                "state_code": "ZE",
                "latitude": "51.49403090",
                "longitude": "3.84968150"
            }
        ]
    },
    {
        "name": "New Caledonia",
        "iso3": "NCL",
        "iso2": "NC",
        "phone_code": "687",
        "capital": "Noumea",
        "currency": "XPF",
        "currency_symbol": "â‚£",
        "tld": ".nc",
        "native": "Nouvelle-CalÃ©donie",
        "region": "Oceania",
        "subregion": "Melanesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Noumea",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "NCT",
                "tzName": "New Caledonia Time"
            }
        ],
        "translations": {
            "kr": "ëˆ„ë²¨ì¹¼ë ˆë„ë‹ˆ",
            "br": "Nova CaledÃ´nia",
            "pt": "Nova CaledÃ³nia",
            "nl": "Nieuw-CaledoniÃ«",
            "hr": "Nova Kaledonija",
            "fa": "Ú©Ø§Ù„Ø¯ÙˆÙ†ÛŒØ§ÛŒ Ø¬Ø¯ÛŒØ¯",
            "de": "Neukaledonien",
            "es": "Nueva Caledonia",
            "fr": "Nouvelle-CalÃ©donie",
            "ja": "ãƒ‹ãƒ¥ãƒ¼ã‚«ãƒ¬ãƒ‰ãƒ‹ã‚¢",
            "it": "Nuova Caledonia",
            "cn": "æ–°å–€é‡Œå¤šå°¼äºš"
        },
        "latitude": "-21.50000000",
        "longitude": "165.50000000",
        "emoji": "ðŸ‡³ðŸ‡¨",
        "emojiU": "U+1F1F3 U+1F1E8",
        "states": []
    },
    {
        "name": "New Zealand",
        "iso3": "NZL",
        "iso2": "NZ",
        "phone_code": "64",
        "capital": "Wellington",
        "currency": "NZD",
        "currency_symbol": "$",
        "tld": ".nz",
        "native": "New Zealand",
        "region": "Oceania",
        "subregion": "Australia and New Zealand",
        "timezones": [
            {
                "zoneName": "Pacific\/Auckland",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "NZDT",
                "tzName": "New Zealand Daylight Time"
            },
            {
                "zoneName": "Pacific\/Chatham",
                "gmtOffset": 49500,
                "gmtOffsetName": "UTC+13:45",
                "abbreviation": "CHAST",
                "tzName": "Chatham Standard Time"
            }
        ],
        "translations": {
            "kr": "ë‰´ì§ˆëžœë“œ",
            "br": "Nova ZelÃ¢ndia",
            "pt": "Nova ZelÃ¢ndia",
            "nl": "Nieuw-Zeeland",
            "hr": "Novi Zeland",
            "fa": "Ù†ÛŒÙˆØ²ÛŒÙ„Ù†Ø¯",
            "de": "Neuseeland",
            "es": "Nueva Zelanda",
            "fr": "Nouvelle-ZÃ©lande",
            "ja": "ãƒ‹ãƒ¥ãƒ¼ã‚¸ãƒ¼ãƒ©ãƒ³ãƒ‰",
            "it": "Nuova Zelanda",
            "cn": "æ–°è¥¿å…°"
        },
        "latitude": "-41.00000000",
        "longitude": "174.00000000",
        "emoji": "ðŸ‡³ðŸ‡¿",
        "emojiU": "U+1F1F3 U+1F1FF",
        "states": [
            {
                "id": 4072,
                "name": "Auckland Region",
                "state_code": "AUK",
                "latitude": "-36.66753280",
                "longitude": "174.77333250"
            },
            {
                "id": 4074,
                "name": "Bay of Plenty Region",
                "state_code": "BOP",
                "latitude": "-37.42339170",
                "longitude": "176.74163740"
            },
            {
                "id": 4066,
                "name": "Canterbury Region",
                "state_code": "CAN",
                "latitude": "-43.75422750",
                "longitude": "171.16372450"
            },
            {
                "id": 4067,
                "name": "Chatham Islands",
                "state_code": "CIT",
                "latitude": "-44.00575230",
                "longitude": "-176.54006740"
            },
            {
                "id": 4068,
                "name": "Gisborne District",
                "state_code": "GIS",
                "latitude": "-38.13581740",
                "longitude": "178.32393090"
            },
            {
                "id": 4075,
                "name": "Hawke's Bay Region",
                "state_code": "HKB",
                "latitude": "-39.60165970",
                "longitude": "176.58044730"
            },
            {
                "id": 4060,
                "name": "Manawatu-Wanganui Region",
                "state_code": "MWT",
                "latitude": "-39.72733560",
                "longitude": "175.43755740"
            },
            {
                "id": 4063,
                "name": "Marlborough Region",
                "state_code": "MBH",
                "latitude": "-41.59168830",
                "longitude": "173.76240530"
            },
            {
                "id": 4070,
                "name": "Nelson Region",
                "state_code": "NSN",
                "latitude": "-41.29853970",
                "longitude": "173.24414910"
            },
            {
                "id": 4059,
                "name": "Northland Region",
                "state_code": "NTL",
                "latitude": "-35.41361720",
                "longitude": "173.93208060"
            },
            {
                "id": 4062,
                "name": "Otago Region",
                "state_code": "OTA",
                "latitude": "-45.47906710",
                "longitude": "170.15475670"
            },
            {
                "id": 4071,
                "name": "Southland Region",
                "state_code": "STL",
                "latitude": "-45.84891590",
                "longitude": "167.67553870"
            },
            {
                "id": 4069,
                "name": "Taranaki Region",
                "state_code": "TKI",
                "latitude": "-39.35381490",
                "longitude": "174.43827210"
            },
            {
                "id": 4073,
                "name": "Tasman District",
                "state_code": "TAS",
                "latitude": "-41.45711840",
                "longitude": "172.82097400"
            },
            {
                "id": 4061,
                "name": "Waikato Region",
                "state_code": "WKO",
                "latitude": "-37.61908620",
                "longitude": "175.02334600"
            },
            {
                "id": 4065,
                "name": "Wellington Region",
                "state_code": "WGN",
                "latitude": "-41.02993230",
                "longitude": "175.43755740"
            },
            {
                "id": 4064,
                "name": "West Coast Region",
                "state_code": "WTC",
                "latitude": "62.41136340",
                "longitude": "-149.07297140"
            }
        ]
    },
    {
        "name": "Nicaragua",
        "iso3": "NIC",
        "iso2": "NI",
        "phone_code": "505",
        "capital": "Managua",
        "currency": "NIO",
        "currency_symbol": "C$",
        "tld": ".ni",
        "native": "Nicaragua",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Managua",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "ë‹ˆì¹´ë¼ê³¼",
            "br": "NicarÃ¡gua",
            "pt": "NicarÃ¡gua",
            "nl": "Nicaragua",
            "hr": "Nikaragva",
            "fa": "Ù†ÛŒÚ©Ø§Ø±Ø§Ú¯ÙˆØ¦Ù‡",
            "de": "Nicaragua",
            "es": "Nicaragua",
            "fr": "Nicaragua",
            "ja": "ãƒ‹ã‚«ãƒ©ã‚°ã‚¢",
            "it": "Nicaragua",
            "cn": "å°¼åŠ æ‹‰ç“œ"
        },
        "latitude": "13.00000000",
        "longitude": "-85.00000000",
        "emoji": "ðŸ‡³ðŸ‡®",
        "emojiU": "U+1F1F3 U+1F1EE",
        "states": [
            {
                "id": 946,
                "name": "Boaco Department",
                "state_code": "BO",
                "latitude": "12.46928400",
                "longitude": "-85.66146820"
            },
            {
                "id": 950,
                "name": "Carazo Department",
                "state_code": "CA",
                "latitude": "11.72747290",
                "longitude": "-86.21584970"
            },
            {
                "id": 954,
                "name": "Chinandega Department",
                "state_code": "CI",
                "latitude": "12.88200620",
                "longitude": "-87.14228950"
            },
            {
                "id": 940,
                "name": "Chontales Department",
                "state_code": "CO",
                "latitude": "11.93947170",
                "longitude": "-85.18940450"
            },
            {
                "id": 945,
                "name": "EstelÃ­ Department",
                "state_code": "ES",
                "latitude": "13.08511390",
                "longitude": "-86.36301970"
            },
            {
                "id": 943,
                "name": "Granada Department",
                "state_code": "GR",
                "latitude": "11.93440730",
                "longitude": "-85.95600050"
            },
            {
                "id": 955,
                "name": "Jinotega Department",
                "state_code": "JI",
                "latitude": "13.08839070",
                "longitude": "-85.99939970"
            },
            {
                "id": 944,
                "name": "LeÃ³n Department",
                "state_code": "LE",
                "latitude": "12.50920370",
                "longitude": "-86.66110830"
            },
            {
                "id": 948,
                "name": "Madriz Department",
                "state_code": "MD",
                "latitude": "13.47260050",
                "longitude": "-86.45920910"
            },
            {
                "id": 941,
                "name": "Managua Department",
                "state_code": "MN",
                "latitude": "12.13916990",
                "longitude": "-86.33767610"
            },
            {
                "id": 953,
                "name": "Masaya Department",
                "state_code": "MS",
                "latitude": "11.97593280",
                "longitude": "-86.07334980"
            },
            {
                "id": 947,
                "name": "Matagalpa Department",
                "state_code": "MT",
                "latitude": "12.94984360",
                "longitude": "-85.43755740"
            },
            {
                "id": 951,
                "name": "North Caribbean Coast Autonomous Region",
                "state_code": "AN",
                "latitude": "13.83944560",
                "longitude": "-83.93208060"
            },
            {
                "id": 949,
                "name": "RÃ­o San Juan Department",
                "state_code": "SJ",
                "latitude": "11.47816100",
                "longitude": "-84.77333250"
            },
            {
                "id": 942,
                "name": "Rivas Department",
                "state_code": "RI",
                "latitude": "11.40234900",
                "longitude": "-85.68457800"
            },
            {
                "id": 952,
                "name": "South Caribbean Coast Autonomous Region",
                "state_code": "AS",
                "latitude": "12.19185020",
                "longitude": "-84.10128610"
            }
        ]
    },
    {
        "name": "Niger",
        "iso3": "NER",
        "iso2": "NE",
        "phone_code": "227",
        "capital": "Niamey",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".ne",
        "native": "Niger",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Niamey",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ë‹ˆì œë¥´",
            "br": "NÃ­ger",
            "pt": "NÃ­ger",
            "nl": "Niger",
            "hr": "Niger",
            "fa": "Ù†ÛŒØ¬Ø±",
            "de": "Niger",
            "es": "NÃ­ger",
            "fr": "Niger",
            "ja": "ãƒ‹ã‚¸ã‚§ãƒ¼ãƒ«",
            "it": "Niger",
            "cn": "å°¼æ—¥å°”"
        },
        "latitude": "16.00000000",
        "longitude": "8.00000000",
        "emoji": "ðŸ‡³ðŸ‡ª",
        "emojiU": "U+1F1F3 U+1F1EA",
        "states": [
            {
                "id": 71,
                "name": "Agadez Region",
                "state_code": "1",
                "latitude": "20.66707520",
                "longitude": "12.07182810"
            },
            {
                "id": 72,
                "name": "Diffa Region",
                "state_code": "2",
                "latitude": "13.67686470",
                "longitude": "12.71351210"
            },
            {
                "id": 68,
                "name": "Dosso Region",
                "state_code": "3",
                "latitude": "13.15139470",
                "longitude": "3.41955270"
            },
            {
                "id": 70,
                "name": "Maradi Region",
                "state_code": "4",
                "latitude": "13.80180740",
                "longitude": "7.43813550"
            },
            {
                "id": 73,
                "name": "Tahoua Region",
                "state_code": "5",
                "latitude": "16.09025430",
                "longitude": "5.39395510"
            },
            {
                "id": 67,
                "name": "TillabÃ©ri Region",
                "state_code": "6",
                "latitude": "14.64895250",
                "longitude": "2.14502450"
            },
            {
                "id": 69,
                "name": "Zinder Region",
                "state_code": "7",
                "latitude": "15.17188810",
                "longitude": "10.26001250"
            }
        ]
    },
    {
        "name": "Nigeria",
        "iso3": "NGA",
        "iso2": "NG",
        "phone_code": "234",
        "capital": "Abuja",
        "currency": "NGN",
        "currency_symbol": "â‚¦",
        "tld": ".ng",
        "native": "Nigeria",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Lagos",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WAT",
                "tzName": "West Africa Time"
            }
        ],
        "translations": {
            "kr": "ë‚˜ì´ì§€ë¦¬ì•„",
            "br": "NigÃ©ria",
            "pt": "NigÃ©ria",
            "nl": "Nigeria",
            "hr": "Nigerija",
            "fa": "Ù†ÛŒØ¬Ø±ÛŒÙ‡",
            "de": "Nigeria",
            "es": "Nigeria",
            "fr": "NigÃ©ria",
            "ja": "ãƒŠã‚¤ã‚¸ã‚§ãƒªã‚¢",
            "it": "Nigeria",
            "cn": "å°¼æ—¥åˆ©äºš"
        },
        "latitude": "10.00000000",
        "longitude": "8.00000000",
        "emoji": "ðŸ‡³ðŸ‡¬",
        "emojiU": "U+1F1F3 U+1F1EC",
        "states": [
            {
                "id": 303,
                "name": "Abia State",
                "state_code": "AB",
                "latitude": "5.45273540",
                "longitude": "7.52484140"
            },
            {
                "id": 320,
                "name": "Adamawa State",
                "state_code": "AD",
                "latitude": "9.32647510",
                "longitude": "12.39838530"
            },
            {
                "id": 304,
                "name": "Akwa Ibom State",
                "state_code": "AK",
                "latitude": "4.90573710",
                "longitude": "7.85366750"
            },
            {
                "id": 315,
                "name": "Anambra State",
                "state_code": "AN",
                "latitude": "6.22089970",
                "longitude": "6.93695590"
            },
            {
                "id": 312,
                "name": "Bauchi State",
                "state_code": "BA",
                "latitude": "10.77606240",
                "longitude": "9.99919430"
            },
            {
                "id": 305,
                "name": "Bayelsa State",
                "state_code": "BY",
                "latitude": "4.77190710",
                "longitude": "6.06985260"
            },
            {
                "id": 291,
                "name": "Benue State",
                "state_code": "BE",
                "latitude": "7.33690240",
                "longitude": "8.74036870"
            },
            {
                "id": 307,
                "name": "Borno State",
                "state_code": "BO",
                "latitude": "11.88463560",
                "longitude": "13.15196650"
            },
            {
                "id": 314,
                "name": "Cross River State",
                "state_code": "CR",
                "latitude": "5.87017240",
                "longitude": "8.59880140"
            },
            {
                "id": 316,
                "name": "Delta State",
                "state_code": "DE",
                "latitude": "33.74537840",
                "longitude": "-90.73545080"
            },
            {
                "id": 311,
                "name": "Ebonyi State",
                "state_code": "EB",
                "latitude": "6.26492320",
                "longitude": "8.01373020"
            },
            {
                "id": 318,
                "name": "Edo State",
                "state_code": "ED",
                "latitude": "6.63418310",
                "longitude": "5.93040560"
            },
            {
                "id": 309,
                "name": "Ekiti State",
                "state_code": "EK",
                "latitude": "7.71898620",
                "longitude": "5.31095050"
            },
            {
                "id": 289,
                "name": "Enugu State",
                "state_code": "EN",
                "latitude": "6.53635300",
                "longitude": "7.43561940"
            },
            {
                "id": 293,
                "name": "Federal Capital Territory",
                "state_code": "FC",
                "latitude": "8.89406910",
                "longitude": "7.18604020"
            },
            {
                "id": 310,
                "name": "Gombe State",
                "state_code": "GO",
                "latitude": "10.36377950",
                "longitude": "11.19275870"
            },
            {
                "id": 308,
                "name": "Imo State",
                "state_code": "IM",
                "latitude": "5.57201220",
                "longitude": "7.05882190"
            },
            {
                "id": 288,
                "name": "Jigawa State",
                "state_code": "JI",
                "latitude": "12.22801200",
                "longitude": "9.56158670"
            },
            {
                "id": 294,
                "name": "Kaduna State",
                "state_code": "KD",
                "latitude": "10.37640060",
                "longitude": "7.70945370"
            },
            {
                "id": 300,
                "name": "Kano State",
                "state_code": "KN",
                "latitude": "11.74706980",
                "longitude": "8.52471070"
            },
            {
                "id": 313,
                "name": "Katsina State",
                "state_code": "KT",
                "latitude": "12.37967070",
                "longitude": "7.63057480"
            },
            {
                "id": 290,
                "name": "Kebbi State",
                "state_code": "KE",
                "latitude": "11.49420030",
                "longitude": "4.23333550"
            },
            {
                "id": 298,
                "name": "Kogi State",
                "state_code": "KO",
                "latitude": "7.73373250",
                "longitude": "6.69058360"
            },
            {
                "id": 295,
                "name": "Kwara State",
                "state_code": "KW",
                "latitude": "8.96689610",
                "longitude": "4.38740510"
            },
            {
                "id": 306,
                "name": "Lagos",
                "state_code": "LA",
                "latitude": "6.52437930",
                "longitude": "3.37920570"
            },
            {
                "id": 301,
                "name": "Nasarawa State",
                "state_code": "NA",
                "latitude": "8.49979080",
                "longitude": "8.19969370"
            },
            {
                "id": 317,
                "name": "Niger State",
                "state_code": "NI",
                "latitude": "9.93092240",
                "longitude": "5.59832100"
            },
            {
                "id": 323,
                "name": "Ogun State",
                "state_code": "OG",
                "latitude": "6.99797470",
                "longitude": "3.47373780"
            },
            {
                "id": 321,
                "name": "Ondo State",
                "state_code": "ON",
                "latitude": "6.91486820",
                "longitude": "5.14781440"
            },
            {
                "id": 322,
                "name": "Osun State",
                "state_code": "OS",
                "latitude": "7.56289640",
                "longitude": "4.51995930"
            },
            {
                "id": 296,
                "name": "Oyo State",
                "state_code": "OY",
                "latitude": "8.15738090",
                "longitude": "3.61465340"
            },
            {
                "id": 302,
                "name": "Plateau State",
                "state_code": "PL",
                "latitude": "9.21820930",
                "longitude": "9.51794880"
            },
            {
                "id": 292,
                "name": "Sokoto State",
                "state_code": "SO",
                "latitude": "13.05331430",
                "longitude": "5.32227220"
            },
            {
                "id": 319,
                "name": "Taraba State",
                "state_code": "TA",
                "latitude": "7.99936160",
                "longitude": "10.77398630"
            },
            {
                "id": 297,
                "name": "Yobe State",
                "state_code": "YO",
                "latitude": "12.29387600",
                "longitude": "11.43904110"
            },
            {
                "id": 299,
                "name": "Zamfara State",
                "state_code": "ZA",
                "latitude": "12.12218050",
                "longitude": "6.22358190"
            }
        ]
    },
    {
        "name": "Niue",
        "iso3": "NIU",
        "iso2": "NU",
        "phone_code": "683",
        "capital": "Alofi",
        "currency": "NZD",
        "currency_symbol": "$",
        "tld": ".nu",
        "native": "NiuÄ“",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Niue",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "NUT",
                "tzName": "Niue Time"
            }
        ],
        "translations": {
            "kr": "ë‹ˆìš°ì—",
            "br": "Niue",
            "pt": "Niue",
            "nl": "Niue",
            "hr": "Niue",
            "fa": "Ù†ÛŒÙˆÙˆÛŒ",
            "de": "Niue",
            "es": "Niue",
            "fr": "Niue",
            "ja": "ãƒ‹ã‚¦ã‚¨",
            "it": "Niue",
            "cn": "çº½åŸƒ"
        },
        "latitude": "-19.03333333",
        "longitude": "-169.86666666",
        "emoji": "ðŸ‡³ðŸ‡º",
        "emojiU": "U+1F1F3 U+1F1FA",
        "states": []
    },
    {
        "name": "Norfolk Island",
        "iso3": "NFK",
        "iso2": "NF",
        "phone_code": "672",
        "capital": "Kingston",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".nf",
        "native": "Norfolk Island",
        "region": "Oceania",
        "subregion": "Australia and New Zealand",
        "timezones": [
            {
                "zoneName": "Pacific\/Norfolk",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "NFT",
                "tzName": "Norfolk Time"
            }
        ],
        "translations": {
            "kr": "ë…¸í½ ì„¬",
            "br": "Ilha Norfolk",
            "pt": "Ilha Norfolk",
            "nl": "Norfolkeiland",
            "hr": "Otok Norfolk",
            "fa": "Ø¬Ø²ÛŒØ±Ù‡ Ù†ÙˆØ±ÙÚ©",
            "de": "Norfolkinsel",
            "es": "Isla de Norfolk",
            "fr": "ÃŽle de Norfolk",
            "ja": "ãƒŽãƒ¼ãƒ•ã‚©ãƒ¼ã‚¯å³¶",
            "it": "Isola Norfolk",
            "cn": "è¯ºç¦å…‹å²›"
        },
        "latitude": "-29.03333333",
        "longitude": "167.95000000",
        "emoji": "ðŸ‡³ðŸ‡«",
        "emojiU": "U+1F1F3 U+1F1EB",
        "states": []
    },
    {
        "name": "Northern Mariana Islands",
        "iso3": "MNP",
        "iso2": "MP",
        "phone_code": "+1-670",
        "capital": "Saipan",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".mp",
        "native": "Northern Mariana Islands",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Saipan",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "ChST",
                "tzName": "Chamorro Standard Time"
            }
        ],
        "translations": {
            "kr": "ë¶ë§ˆë¦¬ì•„ë‚˜ ì œë„",
            "br": "Ilhas Marianas",
            "pt": "Ilhas Marianas",
            "nl": "Noordelijke Marianeneilanden",
            "hr": "Sjevernomarijanski otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ù…Ø§Ø±ÛŒØ§Ù†Ø§ÛŒ Ø´Ù…Ø§Ù„ÛŒ",
            "de": "NÃ¶rdliche Marianen",
            "es": "Islas Marianas del Norte",
            "fr": "ÃŽles Mariannes du Nord",
            "ja": "åŒ—ãƒžãƒªã‚¢ãƒŠè«¸å³¶",
            "it": "Isole Marianne Settentrionali",
            "cn": "åŒ—é©¬é‡Œäºšçº³ç¾¤å²›"
        },
        "latitude": "15.20000000",
        "longitude": "145.75000000",
        "emoji": "ðŸ‡²ðŸ‡µ",
        "emojiU": "U+1F1F2 U+1F1F5",
        "states": []
    },
    {
        "name": "Norway",
        "iso3": "NOR",
        "iso2": "NO",
        "phone_code": "47",
        "capital": "Oslo",
        "currency": "NOK",
        "currency_symbol": "kr",
        "tld": ".no",
        "native": "Norge",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Oslo",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë…¸ë¥´ì›¨ì´",
            "br": "Noruega",
            "pt": "Noruega",
            "nl": "Noorwegen",
            "hr": "NorveÅ¡ka",
            "fa": "Ù†Ø±ÙˆÚ˜",
            "de": "Norwegen",
            "es": "Noruega",
            "fr": "NorvÃ¨ge",
            "ja": "ãƒŽãƒ«ã‚¦ã‚§ãƒ¼",
            "it": "Norvegia",
            "cn": "æŒªå¨"
        },
        "latitude": "62.00000000",
        "longitude": "10.00000000",
        "emoji": "ðŸ‡³ðŸ‡´",
        "emojiU": "U+1F1F3 U+1F1F4",
        "states": [
            {
                "id": 1017,
                "name": "Akershus",
                "state_code": "02",
                "latitude": "28.37042030",
                "longitude": "-81.54680580"
            },
            {
                "id": 1011,
                "name": "Buskerud",
                "state_code": "06",
                "latitude": "60.48460250",
                "longitude": "8.69837640"
            },
            {
                "id": 1016,
                "name": "Finnmark",
                "state_code": "20",
                "latitude": "70.48303880",
                "longitude": "26.01351070"
            },
            {
                "id": 1019,
                "name": "Hedmark",
                "state_code": "04",
                "latitude": "61.39673110",
                "longitude": "11.56273690"
            },
            {
                "id": 1023,
                "name": "Hordaland",
                "state_code": "12",
                "latitude": "60.27336740",
                "longitude": "5.72201940"
            },
            {
                "id": 1026,
                "name": "Jan Mayen",
                "state_code": "22",
                "latitude": "71.03181800",
                "longitude": "-8.29203460"
            },
            {
                "id": 1020,
                "name": "MÃ¸re og Romsdal",
                "state_code": "15",
                "latitude": "62.84068330",
                "longitude": "7.00714300"
            },
            {
                "id": 1012,
                "name": "Nord-TrÃ¸ndelag",
                "state_code": "17",
                "latitude": "64.43707920",
                "longitude": "11.74629500"
            },
            {
                "id": 1025,
                "name": "Nordland",
                "state_code": "18",
                "latitude": "67.69305800",
                "longitude": "12.70739360"
            },
            {
                "id": 1009,
                "name": "Oppland",
                "state_code": "05",
                "latitude": "61.54227520",
                "longitude": "9.71663150"
            },
            {
                "id": 1007,
                "name": "Oslo",
                "state_code": "03",
                "latitude": "59.91386880",
                "longitude": "10.75224540"
            },
            {
                "id": 1022,
                "name": "Ã˜stfold",
                "state_code": "01",
                "latitude": "59.25582860",
                "longitude": "11.32790060"
            },
            {
                "id": 1021,
                "name": "Rogaland",
                "state_code": "11",
                "latitude": "59.14895440",
                "longitude": "6.01434320"
            },
            {
                "id": 1018,
                "name": "Sogn og Fjordane",
                "state_code": "14",
                "latitude": "61.55394350",
                "longitude": "6.33258790"
            },
            {
                "id": 1010,
                "name": "SÃ¸r-TrÃ¸ndelag",
                "state_code": "16",
                "latitude": "63.01368230",
                "longitude": "10.34871360"
            },
            {
                "id": 1013,
                "name": "Svalbard",
                "state_code": "21",
                "latitude": "77.87497250",
                "longitude": "20.97518210"
            },
            {
                "id": 1024,
                "name": "Telemark",
                "state_code": "08",
                "latitude": "59.39139850",
                "longitude": "8.32112090"
            },
            {
                "id": 1015,
                "name": "Troms",
                "state_code": "19",
                "latitude": "69.81782420",
                "longitude": "18.78193650"
            },
            {
                "id": 1006,
                "name": "TrÃ¸ndelag",
                "state_code": "50",
                "latitude": "63.54201250",
                "longitude": "10.93692670"
            },
            {
                "id": 1014,
                "name": "Vest-Agder",
                "state_code": "10",
                "latitude": "58.09990810",
                "longitude": "6.58698090"
            },
            {
                "id": 1008,
                "name": "Vestfold",
                "state_code": "07",
                "latitude": "59.17078620",
                "longitude": "10.11443550"
            }
        ]
    },
    {
        "name": "Oman",
        "iso3": "OMN",
        "iso2": "OM",
        "phone_code": "968",
        "capital": "Muscat",
        "currency": "OMR",
        "currency_symbol": ".Ø¹.Ø±",
        "tld": ".om",
        "native": "Ø¹Ù…Ø§Ù†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Muscat",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GST",
                "tzName": "Gulf Standard Time"
            }
        ],
        "translations": {
            "kr": "ì˜¤ë§Œ",
            "br": "OmÃ£",
            "pt": "OmÃ£",
            "nl": "Oman",
            "hr": "Oman",
            "fa": "Ø¹Ù…Ø§Ù†",
            "de": "Oman",
            "es": "OmÃ¡n",
            "fr": "Oman",
            "ja": "ã‚ªãƒžãƒ¼ãƒ³",
            "it": "oman",
            "cn": "é˜¿æ›¼"
        },
        "latitude": "21.00000000",
        "longitude": "57.00000000",
        "emoji": "ðŸ‡´ðŸ‡²",
        "emojiU": "U+1F1F4 U+1F1F2",
        "states": [
            {
                "id": 3058,
                "name": "Ad Dakhiliyah Governorate",
                "state_code": "DA",
                "latitude": "22.85887580",
                "longitude": "57.53943560"
            },
            {
                "id": 3047,
                "name": "Ad Dhahirah Governorate",
                "state_code": "ZA",
                "latitude": "23.21616740",
                "longitude": "56.49074440"
            },
            {
                "id": 3048,
                "name": "Al Batinah North Governorate",
                "state_code": "BS",
                "latitude": "24.34198460",
                "longitude": "56.72989040"
            },
            {
                "id": 3050,
                "name": "Al Batinah Region",
                "state_code": "BA",
                "latitude": "24.34198460",
                "longitude": "56.72989040"
            },
            {
                "id": 3049,
                "name": "Al Batinah South Governorate",
                "state_code": "BJ",
                "latitude": "23.43149030",
                "longitude": "57.42397960"
            },
            {
                "id": 3059,
                "name": "Al Buraimi Governorate",
                "state_code": "BU",
                "latitude": "24.16714130",
                "longitude": "56.11422530"
            },
            {
                "id": 3056,
                "name": "Al Wusta Governorate",
                "state_code": "WU",
                "latitude": "19.95710780",
                "longitude": "56.27568460"
            },
            {
                "id": 3053,
                "name": "Ash Sharqiyah North Governorate",
                "state_code": "SS",
                "latitude": "22.71411960",
                "longitude": "58.53080640"
            },
            {
                "id": 3051,
                "name": "Ash Sharqiyah Region",
                "state_code": "SH",
                "latitude": "22.71411960",
                "longitude": "58.53080640"
            },
            {
                "id": 3054,
                "name": "Ash Sharqiyah South Governorate",
                "state_code": "SJ",
                "latitude": "22.01582490",
                "longitude": "59.32519220"
            },
            {
                "id": 3057,
                "name": "Dhofar Governorate",
                "state_code": "ZU",
                "latitude": "17.03221210",
                "longitude": "54.14252140"
            },
            {
                "id": 3052,
                "name": "Musandam Governorate",
                "state_code": "MU",
                "latitude": "26.19861440",
                "longitude": "56.24609490"
            },
            {
                "id": 3055,
                "name": "Muscat Governorate",
                "state_code": "MA",
                "latitude": "23.58803070",
                "longitude": "58.38287170"
            }
        ]
    },
    {
        "name": "Pakistan",
        "iso3": "PAK",
        "iso2": "PK",
        "phone_code": "92",
        "capital": "Islamabad",
        "currency": "PKR",
        "currency_symbol": "â‚¨",
        "tld": ".pk",
        "native": "Pakistan",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Karachi",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "PKT",
                "tzName": "Pakistan Standard Time"
            }
        ],
        "translations": {
            "kr": "íŒŒí‚¤ìŠ¤íƒ„",
            "br": "PaquistÃ£o",
            "pt": "PaquistÃ£o",
            "nl": "Pakistan",
            "hr": "Pakistan",
            "fa": "Ù¾Ø§Ú©Ø³ØªØ§Ù†",
            "de": "Pakistan",
            "es": "PakistÃ¡n",
            "fr": "Pakistan",
            "ja": "ãƒ‘ã‚­ã‚¹ã‚¿ãƒ³",
            "it": "Pakistan",
            "cn": "å·´åŸºæ–¯å¦"
        },
        "latitude": "30.00000000",
        "longitude": "70.00000000",
        "emoji": "ðŸ‡µðŸ‡°",
        "emojiU": "U+1F1F5 U+1F1F0",
        "states": [
            {
                "id": 3172,
                "name": "Azad Kashmir",
                "state_code": "JK",
                "latitude": "33.92590550",
                "longitude": "73.78103340"
            },
            {
                "id": 3174,
                "name": "Balochistan",
                "state_code": "BA",
                "latitude": "28.49073320",
                "longitude": "65.09577920"
            },
            {
                "id": 3173,
                "name": "Federally Administered Tribal Areas",
                "state_code": "TA",
                "latitude": "32.66747600",
                "longitude": "69.85974060"
            },
            {
                "id": 3170,
                "name": "Gilgit-Baltistan",
                "state_code": "GB",
                "latitude": "35.80256670",
                "longitude": "74.98318080"
            },
            {
                "id": 3169,
                "name": "Islamabad Capital Territory",
                "state_code": "IS",
                "latitude": "33.72049970",
                "longitude": "73.04052770"
            },
            {
                "id": 3171,
                "name": "Khyber Pakhtunkhwa",
                "state_code": "KP",
                "latitude": "34.95262050",
                "longitude": "72.33111300"
            },
            {
                "id": 3176,
                "name": "Punjab",
                "state_code": "PB",
                "latitude": "31.14713050",
                "longitude": "75.34121790"
            },
            {
                "id": 3175,
                "name": "Sindh",
                "state_code": "SD",
                "latitude": "25.89430180",
                "longitude": "68.52471490"
            }
        ]
    },
    {
        "name": "Palau",
        "iso3": "PLW",
        "iso2": "PW",
        "phone_code": "680",
        "capital": "Melekeok",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".pw",
        "native": "Palau",
        "region": "Oceania",
        "subregion": "Micronesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Palau",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "PWT",
                "tzName": "Palau Time"
            }
        ],
        "translations": {
            "kr": "íŒ”ë¼ìš°",
            "br": "Palau",
            "pt": "Palau",
            "nl": "Palau",
            "hr": "Palau",
            "fa": "Ù¾Ø§Ù„Ø§Ø¦Ùˆ",
            "de": "Palau",
            "es": "Palau",
            "fr": "Palaos",
            "ja": "ãƒ‘ãƒ©ã‚ª",
            "it": "Palau",
            "cn": "å¸•åŠ³"
        },
        "latitude": "7.50000000",
        "longitude": "134.50000000",
        "emoji": "ðŸ‡µðŸ‡¼",
        "emojiU": "U+1F1F5 U+1F1FC",
        "states": [
            {
                "id": 4540,
                "name": "Aimeliik",
                "state_code": "002",
                "latitude": "7.44558590",
                "longitude": "134.50308780"
            },
            {
                "id": 4528,
                "name": "Airai",
                "state_code": "004",
                "latitude": "7.39661180",
                "longitude": "134.56902250"
            },
            {
                "id": 4538,
                "name": "Angaur",
                "state_code": "010",
                "latitude": "6.90922300",
                "longitude": "134.13879340"
            },
            {
                "id": 4529,
                "name": "Hatohobei",
                "state_code": "050",
                "latitude": "3.00706580",
                "longitude": "131.12377810"
            },
            {
                "id": 4539,
                "name": "Kayangel",
                "state_code": "100",
                "latitude": "8.07000000",
                "longitude": "134.70277800"
            },
            {
                "id": 4532,
                "name": "Koror",
                "state_code": "150",
                "latitude": "7.33756460",
                "longitude": "134.48894690"
            },
            {
                "id": 4530,
                "name": "Melekeok",
                "state_code": "212",
                "latitude": "7.51502860",
                "longitude": "134.59725180"
            },
            {
                "id": 4537,
                "name": "Ngaraard",
                "state_code": "214",
                "latitude": "7.60794000",
                "longitude": "134.63486450"
            },
            {
                "id": 4533,
                "name": "Ngarchelong",
                "state_code": "218",
                "latitude": "7.71054690",
                "longitude": "134.63016460"
            },
            {
                "id": 4527,
                "name": "Ngardmau",
                "state_code": "222",
                "latitude": "7.58504860",
                "longitude": "134.55960890"
            },
            {
                "id": 4531,
                "name": "Ngatpang",
                "state_code": "224",
                "latitude": "7.47109940",
                "longitude": "134.52664660"
            },
            {
                "id": 4536,
                "name": "Ngchesar",
                "state_code": "226",
                "latitude": "7.45232800",
                "longitude": "134.57843420"
            },
            {
                "id": 4541,
                "name": "Ngeremlengui",
                "state_code": "227",
                "latitude": "7.51983970",
                "longitude": "134.55960890"
            },
            {
                "id": 4534,
                "name": "Ngiwal",
                "state_code": "228",
                "latitude": "7.56147640",
                "longitude": "134.61606190"
            },
            {
                "id": 4526,
                "name": "Peleliu",
                "state_code": "350",
                "latitude": "7.00229060",
                "longitude": "134.24316280"
            },
            {
                "id": 4535,
                "name": "Sonsorol",
                "state_code": "370",
                "latitude": "5.32681190",
                "longitude": "132.22391170"
            }
        ]
    },
    {
        "name": "Palestinian Territory Occupied",
        "iso3": "PSE",
        "iso2": "PS",
        "phone_code": "970",
        "capital": "East Jerusalem",
        "currency": "ILS",
        "currency_symbol": "â‚ª",
        "tld": ".ps",
        "native": "ÙÙ„Ø³Ø·ÙŠÙ†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Gaza",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Asia\/Hebron",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "íŒ”ë ˆìŠ¤íƒ€ì¸ ì˜í† ",
            "br": "Palestina",
            "pt": "Palestina",
            "nl": "Palestijnse gebieden",
            "hr": "Palestina",
            "fa": "ÙÙ„Ø³Ø·ÛŒÙ†",
            "de": "PalÃ¤stina",
            "es": "Palestina",
            "fr": "Palestine",
            "ja": "ãƒ‘ãƒ¬ã‚¹ãƒãƒŠ",
            "it": "Palestina",
            "cn": "å·´å‹’æ–¯å¦"
        },
        "latitude": "31.90000000",
        "longitude": "35.20000000",
        "emoji": "ðŸ‡µðŸ‡¸",
        "emojiU": "U+1F1F5 U+1F1F8",
        "states": []
    },
    {
        "name": "Panama",
        "iso3": "PAN",
        "iso2": "PA",
        "phone_code": "507",
        "capital": "Panama City",
        "currency": "PAB",
        "currency_symbol": "B\/.",
        "tld": ".pa",
        "native": "PanamÃ¡",
        "region": "Americas",
        "subregion": "Central America",
        "timezones": [
            {
                "zoneName": "America\/Panama",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "íŒŒë‚˜ë§ˆ",
            "br": "PanamÃ¡",
            "pt": "PanamÃ¡",
            "nl": "Panama",
            "hr": "Panama",
            "fa": "Ù¾Ø§Ù†Ø§Ù…Ø§",
            "de": "Panama",
            "es": "PanamÃ¡",
            "fr": "Panama",
            "ja": "ãƒ‘ãƒŠãƒž",
            "it": "Panama",
            "cn": "å·´æ‹¿é©¬"
        },
        "latitude": "9.00000000",
        "longitude": "-80.00000000",
        "emoji": "ðŸ‡µðŸ‡¦",
        "emojiU": "U+1F1F5 U+1F1E6",
        "states": [
            {
                "id": 1393,
                "name": "Bocas del Toro Province",
                "state_code": "1",
                "latitude": "9.41655210",
                "longitude": "-82.52077870"
            },
            {
                "id": 1397,
                "name": "ChiriquÃ­ Province",
                "state_code": "4",
                "latitude": "8.58489800",
                "longitude": "-82.38857830"
            },
            {
                "id": 1387,
                "name": "CoclÃ© Province",
                "state_code": "2",
                "latitude": "8.62660680",
                "longitude": "-80.36586500"
            },
            {
                "id": 1386,
                "name": "ColÃ³n Province",
                "state_code": "3",
                "latitude": "9.18519890",
                "longitude": "-80.05349230"
            },
            {
                "id": 1385,
                "name": "DariÃ©n Province",
                "state_code": "5",
                "latitude": "7.86817130",
                "longitude": "-77.83672820"
            },
            {
                "id": 1396,
                "name": "EmberÃ¡-Wounaan Comarca",
                "state_code": "EM",
                "latitude": "8.37669830",
                "longitude": "-77.65361250"
            },
            {
                "id": 1388,
                "name": "Guna Yala",
                "state_code": "KY",
                "latitude": "9.23443950",
                "longitude": "-78.19262500"
            },
            {
                "id": 1389,
                "name": "Herrera Province",
                "state_code": "6",
                "latitude": "7.77042820",
                "longitude": "-80.72144170"
            },
            {
                "id": 1390,
                "name": "Los Santos Province",
                "state_code": "7",
                "latitude": "7.59093020",
                "longitude": "-80.36586500"
            },
            {
                "id": 1391,
                "name": "NgÃ¶be-BuglÃ© Comarca",
                "state_code": "NB",
                "latitude": "8.65958330",
                "longitude": "-81.77870210"
            },
            {
                "id": 1394,
                "name": "PanamÃ¡ Oeste Province",
                "state_code": "10",
                "latitude": "9.11967510",
                "longitude": "-79.29021330"
            },
            {
                "id": 1395,
                "name": "PanamÃ¡ Province",
                "state_code": "8",
                "latitude": "9.11967510",
                "longitude": "-79.29021330"
            },
            {
                "id": 1392,
                "name": "Veraguas Province",
                "state_code": "9",
                "latitude": "8.12310330",
                "longitude": "-81.07546570"
            }
        ]
    },
    {
        "name": "Papua new Guinea",
        "iso3": "PNG",
        "iso2": "PG",
        "phone_code": "675",
        "capital": "Port Moresby",
        "currency": "PGK",
        "currency_symbol": "K",
        "tld": ".pg",
        "native": "Papua Niugini",
        "region": "Oceania",
        "subregion": "Melanesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Bougainville",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "BST",
                "tzName": "Bougainville Standard Time[6"
            },
            {
                "zoneName": "Pacific\/Port_Moresby",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "PGT",
                "tzName": "Papua New Guinea Time"
            }
        ],
        "translations": {
            "kr": "íŒŒí‘¸ì•„ë‰´ê¸°ë‹ˆ",
            "br": "Papua Nova GuinÃ©",
            "pt": "Papua Nova GuinÃ©",
            "nl": "Papoea-Nieuw-Guinea",
            "hr": "Papua Nova Gvineja",
            "fa": "Ù¾Ø§Ù¾ÙˆØ¢ Ú¯ÛŒÙ†Ù‡ Ù†Ùˆ",
            "de": "Papua-Neuguinea",
            "es": "PapÃºa Nueva Guinea",
            "fr": "Papouasie-Nouvelle-GuinÃ©e",
            "ja": "ãƒ‘ãƒ—ã‚¢ãƒ‹ãƒ¥ãƒ¼ã‚®ãƒ‹ã‚¢",
            "it": "Papua Nuova Guinea",
            "cn": "å·´å¸ƒäºšæ–°å‡ å†…äºš"
        },
        "latitude": "-6.00000000",
        "longitude": "147.00000000",
        "emoji": "ðŸ‡µðŸ‡¬",
        "emojiU": "U+1F1F5 U+1F1EC",
        "states": [
            {
                "id": 4831,
                "name": "Bougainville",
                "state_code": "NSB",
                "latitude": "-6.37539190",
                "longitude": "155.38071010"
            },
            {
                "id": 4847,
                "name": "Central Province",
                "state_code": "CPM",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4846,
                "name": "Chimbu Province",
                "state_code": "CPK",
                "latitude": "-6.30876820",
                "longitude": "144.87312190"
            },
            {
                "id": 4834,
                "name": "East New Britain",
                "state_code": "EBR",
                "latitude": "-4.61289430",
                "longitude": "151.88773210"
            },
            {
                "id": 4845,
                "name": "Eastern Highlands Province",
                "state_code": "EHG",
                "latitude": "-6.58616740",
                "longitude": "145.66896360"
            },
            {
                "id": 4848,
                "name": "Enga Province",
                "state_code": "EPW",
                "latitude": "-5.30058490",
                "longitude": "143.56356370"
            },
            {
                "id": 4839,
                "name": "Gulf",
                "state_code": "GPK",
                "latitude": "37.05483150",
                "longitude": "-94.43704190"
            },
            {
                "id": 4833,
                "name": "Hela",
                "state_code": "HLA",
                "latitude": "42.33295160",
                "longitude": "-83.04826180"
            },
            {
                "id": 4832,
                "name": "Jiwaka Province",
                "state_code": "JWK",
                "latitude": "-5.86911540",
                "longitude": "144.69727740"
            },
            {
                "id": 4843,
                "name": "Madang Province",
                "state_code": "MPM",
                "latitude": "-4.98497330",
                "longitude": "145.13758340"
            },
            {
                "id": 4842,
                "name": "Manus Province",
                "state_code": "MRL",
                "latitude": "-2.09411690",
                "longitude": "146.87609510"
            },
            {
                "id": 4849,
                "name": "Milne Bay Province",
                "state_code": "MBA",
                "latitude": "-9.52214510",
                "longitude": "150.67496530"
            },
            {
                "id": 4835,
                "name": "Morobe Province",
                "state_code": "MPL",
                "latitude": "-6.80137370",
                "longitude": "146.56164700"
            },
            {
                "id": 4841,
                "name": "New Ireland Province",
                "state_code": "NIK",
                "latitude": "-4.28532560",
                "longitude": "152.92059180"
            },
            {
                "id": 4838,
                "name": "Oro Province",
                "state_code": "NPP",
                "latitude": "-8.89880630",
                "longitude": "148.18929210"
            },
            {
                "id": 4837,
                "name": "Port Moresby",
                "state_code": "NCD",
                "latitude": "-9.44380040",
                "longitude": "147.18026710"
            },
            {
                "id": 4836,
                "name": "Sandaun Province",
                "state_code": "SAN",
                "latitude": "-3.71261790",
                "longitude": "141.68342750"
            },
            {
                "id": 4844,
                "name": "Southern Highlands Province",
                "state_code": "SHM",
                "latitude": "-6.41790830",
                "longitude": "143.56356370"
            },
            {
                "id": 4830,
                "name": "West New Britain Province",
                "state_code": "WBK",
                "latitude": "-5.70474320",
                "longitude": "150.02594660"
            },
            {
                "id": 4840,
                "name": "Western Highlands Province",
                "state_code": "WHM",
                "latitude": "-5.62681280",
                "longitude": "144.25931180"
            },
            {
                "id": 4850,
                "name": "Western Province",
                "state_code": "WPD",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Paraguay",
        "iso3": "PRY",
        "iso2": "PY",
        "phone_code": "595",
        "capital": "Asuncion",
        "currency": "PYG",
        "currency_symbol": "â‚²",
        "tld": ".py",
        "native": "Paraguay",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Asuncion",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "PYST",
                "tzName": "Paraguay Summer Time"
            }
        ],
        "translations": {
            "kr": "íŒŒë¼ê³¼ì´",
            "br": "Paraguai",
            "pt": "Paraguai",
            "nl": "Paraguay",
            "hr": "Paragvaj",
            "fa": "Ù¾Ø§Ø±Ø§Ú¯ÙˆØ¦Ù‡",
            "de": "Paraguay",
            "es": "Paraguay",
            "fr": "Paraguay",
            "ja": "ãƒ‘ãƒ©ã‚°ã‚¢ã‚¤",
            "it": "Paraguay",
            "cn": "å·´æ‹‰åœ­"
        },
        "latitude": "-23.00000000",
        "longitude": "-58.00000000",
        "emoji": "ðŸ‡µðŸ‡¾",
        "emojiU": "U+1F1F5 U+1F1FE",
        "states": [
            {
                "id": 2785,
                "name": "Alto Paraguay Department",
                "state_code": "16",
                "latitude": "-20.08525080",
                "longitude": "-59.47209040"
            },
            {
                "id": 2784,
                "name": "Alto ParanÃ¡ Department",
                "state_code": "10",
                "latitude": "-25.60755460",
                "longitude": "-54.96118360"
            },
            {
                "id": 2782,
                "name": "Amambay Department",
                "state_code": "13",
                "latitude": "-22.55902720",
                "longitude": "-56.02499820"
            },
            {
                "id": 2780,
                "name": "BoquerÃ³n Department",
                "state_code": "19",
                "latitude": "-21.74492540",
                "longitude": "-60.95400730"
            },
            {
                "id": 2773,
                "name": "CaaguazÃº",
                "state_code": "5",
                "latitude": "-25.46458180",
                "longitude": "-56.01385100"
            },
            {
                "id": 2775,
                "name": "CaazapÃ¡",
                "state_code": "6",
                "latitude": "-26.18277130",
                "longitude": "-56.37123270"
            },
            {
                "id": 2771,
                "name": "CanindeyÃº",
                "state_code": "14",
                "latitude": "-24.13787350",
                "longitude": "-55.66896360"
            },
            {
                "id": 2777,
                "name": "Central Department",
                "state_code": "11",
                "latitude": "36.15592290",
                "longitude": "-95.96620750"
            },
            {
                "id": 2779,
                "name": "ConcepciÃ³n Department",
                "state_code": "1",
                "latitude": "-23.42142640",
                "longitude": "-57.43444510"
            },
            {
                "id": 2783,
                "name": "Cordillera Department",
                "state_code": "3",
                "latitude": "-25.22894910",
                "longitude": "-57.01116810"
            },
            {
                "id": 2772,
                "name": "GuairÃ¡ Department",
                "state_code": "4",
                "latitude": "-25.88109320",
                "longitude": "-56.29293810"
            },
            {
                "id": 2778,
                "name": "ItapÃºa",
                "state_code": "7",
                "latitude": "-26.79236230",
                "longitude": "-55.66896360"
            },
            {
                "id": 2786,
                "name": "Misiones Department",
                "state_code": "8",
                "latitude": "-26.84335120",
                "longitude": "-57.10131880"
            },
            {
                "id": 2781,
                "name": "Ã‘eembucÃº Department",
                "state_code": "12",
                "latitude": "-27.02991140",
                "longitude": "-57.82539500"
            },
            {
                "id": 2774,
                "name": "ParaguarÃ­ Department",
                "state_code": "9",
                "latitude": "-25.62621740",
                "longitude": "-57.15206420"
            },
            {
                "id": 2770,
                "name": "Presidente Hayes Department",
                "state_code": "15",
                "latitude": "-23.35126050",
                "longitude": "-58.73736340"
            },
            {
                "id": 2776,
                "name": "San Pedro Department",
                "state_code": "2",
                "latitude": "-24.19486680",
                "longitude": "-56.56164700"
            }
        ]
    },
    {
        "name": "Peru",
        "iso3": "PER",
        "iso2": "PE",
        "phone_code": "51",
        "capital": "Lima",
        "currency": "PEN",
        "currency_symbol": "S\/.",
        "tld": ".pe",
        "native": "PerÃº",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Lima",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "PET",
                "tzName": "Peru Time"
            }
        ],
        "translations": {
            "kr": "íŽ˜ë£¨",
            "br": "Peru",
            "pt": "Peru",
            "nl": "Peru",
            "hr": "Peru",
            "fa": "Ù¾Ø±Ùˆ",
            "de": "Peru",
            "es": "PerÃº",
            "fr": "PÃ©rou",
            "ja": "ãƒšãƒ«ãƒ¼",
            "it": "PerÃ¹",
            "cn": "ç§˜é²"
        },
        "latitude": "-10.00000000",
        "longitude": "-76.00000000",
        "emoji": "ðŸ‡µðŸ‡ª",
        "emojiU": "U+1F1F5 U+1F1EA",
        "states": [
            {
                "id": 3685,
                "name": "Amazonas",
                "state_code": "AMA",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 3680,
                "name": "Ãncash",
                "state_code": "ANC",
                "latitude": "-9.32504970",
                "longitude": "-77.56194190"
            },
            {
                "id": 3699,
                "name": "ApurÃ­mac",
                "state_code": "APU",
                "latitude": "-14.05045330",
                "longitude": "-73.08774900"
            },
            {
                "id": 3681,
                "name": "Arequipa",
                "state_code": "ARE",
                "latitude": "-16.40904740",
                "longitude": "-71.53745100"
            },
            {
                "id": 3692,
                "name": "Ayacucho",
                "state_code": "AYA",
                "latitude": "-13.16387370",
                "longitude": "-74.22356410"
            },
            {
                "id": 3688,
                "name": "Cajamarca",
                "state_code": "CAJ",
                "latitude": "-7.16174650",
                "longitude": "-78.51278550"
            },
            {
                "id": 3701,
                "name": "Callao",
                "state_code": "CAL",
                "latitude": "-12.05084910",
                "longitude": "-77.12598430"
            },
            {
                "id": 3691,
                "name": "Cusco",
                "state_code": "CUS",
                "latitude": "-13.53195000",
                "longitude": "-71.96746260"
            },
            {
                "id": 3679,
                "name": "Huancavelica",
                "state_code": "HUV",
                "latitude": "-12.78619780",
                "longitude": "-74.97640240"
            },
            {
                "id": 3687,
                "name": "Huanuco",
                "state_code": "HUC",
                "latitude": "-9.92076480",
                "longitude": "-76.24108430"
            },
            {
                "id": 3700,
                "name": "Ica",
                "state_code": "ICA",
                "latitude": "42.35288320",
                "longitude": "-71.04300970"
            },
            {
                "id": 3693,
                "name": "JunÃ­n",
                "state_code": "JUN",
                "latitude": "-11.15819250",
                "longitude": "-75.99263060"
            },
            {
                "id": 3683,
                "name": "La Libertad",
                "state_code": "LAL",
                "latitude": "13.49069700",
                "longitude": "-89.30846070"
            },
            {
                "id": 3702,
                "name": "Lambayeque",
                "state_code": "LAM",
                "latitude": "-6.71976660",
                "longitude": "-79.90807570"
            },
            {
                "id": 3695,
                "name": "Lima",
                "state_code": "LIM",
                "latitude": "-12.04637310",
                "longitude": "-77.04275400"
            },
            {
                "id": 4922,
                "name": "Loreto",
                "state_code": "LOR",
                "latitude": "-4.37416430",
                "longitude": "-76.13042640"
            },
            {
                "id": 3678,
                "name": "Madre de Dios",
                "state_code": "MDD",
                "latitude": "-11.76687050",
                "longitude": "-70.81199530"
            },
            {
                "id": 3698,
                "name": "Moquegua",
                "state_code": "MOQ",
                "latitude": "-17.19273610",
                "longitude": "-70.93281380"
            },
            {
                "id": 3686,
                "name": "Pasco",
                "state_code": "PAS",
                "latitude": "46.23050490",
                "longitude": "-119.09223160"
            },
            {
                "id": 3697,
                "name": "Piura",
                "state_code": "PIU",
                "latitude": "-5.17828840",
                "longitude": "-80.65488820"
            },
            {
                "id": 3682,
                "name": "Puno",
                "state_code": "PUN",
                "latitude": "-15.84022180",
                "longitude": "-70.02188050"
            },
            {
                "id": 3694,
                "name": "San MartÃ­n",
                "state_code": "SAM",
                "latitude": "37.08494640",
                "longitude": "-121.61022160"
            },
            {
                "id": 3696,
                "name": "Tacna",
                "state_code": "TAC",
                "latitude": "-18.00656790",
                "longitude": "-70.24627410"
            },
            {
                "id": 3689,
                "name": "Tumbes",
                "state_code": "TUM",
                "latitude": "-3.55649210",
                "longitude": "-80.42708850"
            },
            {
                "id": 3684,
                "name": "Ucayali",
                "state_code": "UCA",
                "latitude": "-9.82511830",
                "longitude": "-73.08774900"
            }
        ]
    },
    {
        "name": "Philippines",
        "iso3": "PHL",
        "iso2": "PH",
        "phone_code": "63",
        "capital": "Manila",
        "currency": "PHP",
        "currency_symbol": "â‚±",
        "tld": ".ph",
        "native": "Pilipinas",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Manila",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "PHT",
                "tzName": "Philippine Time"
            }
        ],
        "translations": {
            "kr": "í•„ë¦¬í•€",
            "br": "Filipinas",
            "pt": "Filipinas",
            "nl": "Filipijnen",
            "hr": "Filipini",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ø§Ù„Ù†Ø¯ÙÛŒÙ„ÛŒÙ¾ÛŒÙ†",
            "de": "Philippinen",
            "es": "Filipinas",
            "fr": "Philippines",
            "ja": "ãƒ•ã‚£ãƒªãƒ”ãƒ³",
            "it": "Filippine",
            "cn": "è²å¾‹å®¾"
        },
        "latitude": "13.00000000",
        "longitude": "122.00000000",
        "emoji": "ðŸ‡µðŸ‡­",
        "emojiU": "U+1F1F5 U+1F1ED",
        "states": [
            {
                "id": 1324,
                "name": "Abra",
                "state_code": "ABR",
                "latitude": "42.49708300",
                "longitude": "-96.38441000"
            },
            {
                "id": 1323,
                "name": "Agusan del Norte",
                "state_code": "AGN",
                "latitude": "8.94562590",
                "longitude": "125.53192340"
            },
            {
                "id": 1326,
                "name": "Agusan del Sur",
                "state_code": "AGS",
                "latitude": "8.04638880",
                "longitude": "126.06153840"
            },
            {
                "id": 1331,
                "name": "Aklan",
                "state_code": "AKL",
                "latitude": "11.81661090",
                "longitude": "122.09415410"
            },
            {
                "id": 1337,
                "name": "Albay",
                "state_code": "ALB",
                "latitude": "13.17748270",
                "longitude": "123.52800720"
            },
            {
                "id": 1336,
                "name": "Antique",
                "state_code": "ANT",
                "latitude": "37.03586950",
                "longitude": "-95.63616940"
            },
            {
                "id": 1334,
                "name": "Apayao",
                "state_code": "APA",
                "latitude": "18.01203040",
                "longitude": "121.17103890"
            },
            {
                "id": 1341,
                "name": "Aurora",
                "state_code": "AUR",
                "latitude": "36.97089100",
                "longitude": "-93.71797900"
            },
            {
                "id": 1316,
                "name": "Autonomous Region in Muslim Mindanao",
                "state_code": "14",
                "latitude": "6.95683130",
                "longitude": "124.24215970"
            },
            {
                "id": 1346,
                "name": "Basilan",
                "state_code": "BAS",
                "latitude": "6.42963490",
                "longitude": "121.98701650"
            },
            {
                "id": 1344,
                "name": "Bataan",
                "state_code": "BAN",
                "latitude": "14.64168420",
                "longitude": "120.48184460"
            },
            {
                "id": 1352,
                "name": "Batanes",
                "state_code": "BTN",
                "latitude": "20.44850740",
                "longitude": "121.97081290"
            },
            {
                "id": 1359,
                "name": "Batangas",
                "state_code": "BTG",
                "latitude": "13.75646510",
                "longitude": "121.05830760"
            },
            {
                "id": 1363,
                "name": "Benguet",
                "state_code": "BEN",
                "latitude": "16.55772570",
                "longitude": "120.80394740"
            },
            {
                "id": 1304,
                "name": "Bicol Region",
                "state_code": "05",
                "latitude": "13.42098850",
                "longitude": "123.41367360"
            },
            {
                "id": 1274,
                "name": "Biliran",
                "state_code": "BIL",
                "latitude": "11.58331520",
                "longitude": "124.46418480"
            },
            {
                "id": 1272,
                "name": "Bohol",
                "state_code": "BOH",
                "latitude": "9.84999110",
                "longitude": "124.14354270"
            },
            {
                "id": 1270,
                "name": "Bukidnon",
                "state_code": "BUK",
                "latitude": "8.05150540",
                "longitude": "124.92299460"
            },
            {
                "id": 1278,
                "name": "Bulacan",
                "state_code": "BUL",
                "latitude": "14.79427350",
                "longitude": "120.87990080"
            },
            {
                "id": 1279,
                "name": "Cagayan",
                "state_code": "CAG",
                "latitude": "18.24896290",
                "longitude": "121.87878330"
            },
            {
                "id": 1342,
                "name": "Cagayan Valley",
                "state_code": "02",
                "latitude": "16.97537580",
                "longitude": "121.81070790"
            },
            {
                "id": 1294,
                "name": "Calabarzon",
                "state_code": "40",
                "latitude": "14.10078030",
                "longitude": "121.07937050"
            },
            {
                "id": 1283,
                "name": "Camarines Norte",
                "state_code": "CAN",
                "latitude": "14.13902650",
                "longitude": "122.76330360"
            },
            {
                "id": 1287,
                "name": "Camarines Sur",
                "state_code": "CAS",
                "latitude": "13.52501970",
                "longitude": "123.34861470"
            },
            {
                "id": 1285,
                "name": "Camiguin",
                "state_code": "CAM",
                "latitude": "9.17321640",
                "longitude": "124.72987650"
            },
            {
                "id": 1292,
                "name": "Capiz",
                "state_code": "CAP",
                "latitude": "11.55288160",
                "longitude": "122.74072300"
            },
            {
                "id": 1314,
                "name": "Caraga",
                "state_code": "13",
                "latitude": "8.80145620",
                "longitude": "125.74068820"
            },
            {
                "id": 1301,
                "name": "Catanduanes",
                "state_code": "CAT",
                "latitude": "13.70886840",
                "longitude": "124.24215970"
            },
            {
                "id": 1307,
                "name": "Cavite",
                "state_code": "CAV",
                "latitude": "14.47912970",
                "longitude": "120.89696340"
            },
            {
                "id": 1306,
                "name": "Cebu",
                "state_code": "CEB",
                "latitude": "10.31569920",
                "longitude": "123.88543660"
            },
            {
                "id": 1345,
                "name": "Central Luzon",
                "state_code": "03",
                "latitude": "15.48277220",
                "longitude": "120.71200230"
            },
            {
                "id": 1308,
                "name": "Central Visayas",
                "state_code": "07",
                "latitude": "9.81687500",
                "longitude": "124.06414190"
            },
            {
                "id": 1311,
                "name": "Compostela Valley",
                "state_code": "COM",
                "latitude": "7.51251500",
                "longitude": "126.17626150"
            },
            {
                "id": 1335,
                "name": "Cordillera Administrative Region",
                "state_code": "15",
                "latitude": "17.35125420",
                "longitude": "121.17188510"
            },
            {
                "id": 1320,
                "name": "Cotabato",
                "state_code": "NCO",
                "latitude": "7.20466680",
                "longitude": "124.23104390"
            },
            {
                "id": 1319,
                "name": "Davao del Norte",
                "state_code": "DAV",
                "latitude": "7.56176990",
                "longitude": "125.65328480"
            },
            {
                "id": 1318,
                "name": "Davao del Sur",
                "state_code": "DAS",
                "latitude": "6.76626870",
                "longitude": "125.32842690"
            },
            {
                "id": 1309,
                "name": "Davao Occidental",
                "state_code": "DVO",
                "latitude": "6.09413960",
                "longitude": "125.60954740"
            },
            {
                "id": 1289,
                "name": "Davao Oriental",
                "state_code": "DAO",
                "latitude": "7.31715850",
                "longitude": "126.54198870"
            },
            {
                "id": 1340,
                "name": "Davao Region",
                "state_code": "11",
                "latitude": "7.30416220",
                "longitude": "126.08934060"
            },
            {
                "id": 1291,
                "name": "Dinagat Islands",
                "state_code": "DIN",
                "latitude": "10.12818160",
                "longitude": "125.60954740"
            },
            {
                "id": 1290,
                "name": "Eastern Samar",
                "state_code": "EAS",
                "latitude": "11.50007310",
                "longitude": "125.49999080"
            },
            {
                "id": 1322,
                "name": "Eastern Visayas",
                "state_code": "08",
                "latitude": "12.24455330",
                "longitude": "125.03881640"
            },
            {
                "id": 1303,
                "name": "Guimaras",
                "state_code": "GUI",
                "latitude": "10.59286610",
                "longitude": "122.63250810"
            },
            {
                "id": 1300,
                "name": "Ifugao",
                "state_code": "IFU",
                "latitude": "16.83307920",
                "longitude": "121.17103890"
            },
            {
                "id": 1298,
                "name": "Ilocos Norte",
                "state_code": "ILN",
                "latitude": "18.16472810",
                "longitude": "120.71155920"
            },
            {
                "id": 1355,
                "name": "Ilocos Region",
                "state_code": "01",
                "latitude": "16.08321440",
                "longitude": "120.61998950"
            },
            {
                "id": 1321,
                "name": "Ilocos Sur",
                "state_code": "ILS",
                "latitude": "17.22786640",
                "longitude": "120.57395790"
            },
            {
                "id": 1315,
                "name": "Iloilo",
                "state_code": "ILI",
                "latitude": "10.72015010",
                "longitude": "122.56210630"
            },
            {
                "id": 1313,
                "name": "Isabela",
                "state_code": "ISA",
                "latitude": "18.50077590",
                "longitude": "-67.02434620"
            },
            {
                "id": 1312,
                "name": "Kalinga",
                "state_code": "KAL",
                "latitude": "17.47404220",
                "longitude": "121.35416310"
            },
            {
                "id": 1317,
                "name": "La Union",
                "state_code": "LUN",
                "latitude": "38.87668780",
                "longitude": "-77.12809120"
            },
            {
                "id": 1328,
                "name": "Laguna",
                "state_code": "LAG",
                "latitude": "33.54271890",
                "longitude": "-117.78535680"
            },
            {
                "id": 1327,
                "name": "Lanao del Norte",
                "state_code": "LAN",
                "latitude": "7.87218110",
                "longitude": "123.88577470"
            },
            {
                "id": 1333,
                "name": "Lanao del Sur",
                "state_code": "LAS",
                "latitude": "7.82317600",
                "longitude": "124.41982430"
            },
            {
                "id": 1332,
                "name": "Leyte",
                "state_code": "LEY",
                "latitude": "10.86245360",
                "longitude": "124.88111950"
            },
            {
                "id": 1330,
                "name": "Maguindanao",
                "state_code": "MAG",
                "latitude": "6.94225810",
                "longitude": "124.41982430"
            },
            {
                "id": 1329,
                "name": "Marinduque",
                "state_code": "MAD",
                "latitude": "13.47671710",
                "longitude": "121.90321920"
            },
            {
                "id": 1338,
                "name": "Masbate",
                "state_code": "MAS",
                "latitude": "12.35743460",
                "longitude": "123.55040760"
            },
            {
                "id": 1347,
                "name": "Metro Manila",
                "state_code": "NCR",
                "latitude": "14.60905370",
                "longitude": "121.02225650"
            },
            {
                "id": 1299,
                "name": "Mimaropa",
                "state_code": "41",
                "latitude": "9.84320650",
                "longitude": "118.73647830"
            },
            {
                "id": 1343,
                "name": "Misamis Occidental",
                "state_code": "MSC",
                "latitude": "8.33749030",
                "longitude": "123.70706190"
            },
            {
                "id": 1348,
                "name": "Misamis Oriental",
                "state_code": "MSR",
                "latitude": "8.50455580",
                "longitude": "124.62195920"
            },
            {
                "id": 1353,
                "name": "Mountain Province",
                "state_code": "MOU",
                "latitude": "40.70754370",
                "longitude": "-73.95010330"
            },
            {
                "id": 1351,
                "name": "Negros Occidental",
                "state_code": "NEC",
                "latitude": "10.29256090",
                "longitude": "123.02465180"
            },
            {
                "id": 1350,
                "name": "Negros Oriental",
                "state_code": "NER",
                "latitude": "9.62820830",
                "longitude": "122.98883190"
            },
            {
                "id": 1339,
                "name": "Northern Mindanao",
                "state_code": "10",
                "latitude": "8.02016350",
                "longitude": "124.68565090"
            },
            {
                "id": 1349,
                "name": "Northern Samar",
                "state_code": "NSA",
                "latitude": "12.36131990",
                "longitude": "124.77407930"
            },
            {
                "id": 1360,
                "name": "Nueva Ecija",
                "state_code": "NUE",
                "latitude": "15.57837500",
                "longitude": "121.11126150"
            },
            {
                "id": 1358,
                "name": "Nueva Vizcaya",
                "state_code": "NUV",
                "latitude": "16.33011070",
                "longitude": "121.17103890"
            },
            {
                "id": 1356,
                "name": "Occidental Mindoro",
                "state_code": "MDC",
                "latitude": "13.10241110",
                "longitude": "120.76512840"
            },
            {
                "id": 1354,
                "name": "Oriental Mindoro",
                "state_code": "MDR",
                "latitude": "13.05645980",
                "longitude": "121.40694170"
            },
            {
                "id": 1361,
                "name": "Palawan",
                "state_code": "PLW",
                "latitude": "9.83494930",
                "longitude": "118.73836150"
            },
            {
                "id": 1365,
                "name": "Pampanga",
                "state_code": "PAM",
                "latitude": "15.07940900",
                "longitude": "120.61998950"
            },
            {
                "id": 1364,
                "name": "Pangasinan",
                "state_code": "PAN",
                "latitude": "15.89490550",
                "longitude": "120.28631830"
            },
            {
                "id": 1275,
                "name": "Quezon",
                "state_code": "QUE",
                "latitude": "14.03139060",
                "longitude": "122.11309090"
            },
            {
                "id": 1273,
                "name": "Quirino",
                "state_code": "QUI",
                "latitude": "16.27004240",
                "longitude": "121.53700030"
            },
            {
                "id": 1271,
                "name": "Rizal",
                "state_code": "RIZ",
                "latitude": "14.60374460",
                "longitude": "121.30840880"
            },
            {
                "id": 1269,
                "name": "Romblon",
                "state_code": "ROM",
                "latitude": "12.57780160",
                "longitude": "122.26914600"
            },
            {
                "id": 1277,
                "name": "Sarangani",
                "state_code": "SAR",
                "latitude": "5.92671750",
                "longitude": "124.99475100"
            },
            {
                "id": 1276,
                "name": "Siquijor",
                "state_code": "SIG",
                "latitude": "9.19987790",
                "longitude": "123.59519250"
            },
            {
                "id": 1310,
                "name": "Soccsksargen",
                "state_code": "12",
                "latitude": "6.27069180",
                "longitude": "124.68565090"
            },
            {
                "id": 1281,
                "name": "Sorsogon",
                "state_code": "SOR",
                "latitude": "12.99270950",
                "longitude": "124.01474640"
            },
            {
                "id": 1280,
                "name": "South Cotabato",
                "state_code": "SCO",
                "latitude": "6.33575650",
                "longitude": "124.77407930"
            },
            {
                "id": 1284,
                "name": "Southern Leyte",
                "state_code": "SLE",
                "latitude": "10.33462060",
                "longitude": "125.17087410"
            },
            {
                "id": 1282,
                "name": "Sultan Kudarat",
                "state_code": "SUK",
                "latitude": "6.50694010",
                "longitude": "124.41982430"
            },
            {
                "id": 1288,
                "name": "Sulu",
                "state_code": "SLU",
                "latitude": "5.97490110",
                "longitude": "121.03351000"
            },
            {
                "id": 1286,
                "name": "Surigao del Norte",
                "state_code": "SUN",
                "latitude": "9.51482800",
                "longitude": "125.69699840"
            },
            {
                "id": 1296,
                "name": "Surigao del Sur",
                "state_code": "SUR",
                "latitude": "8.54049060",
                "longitude": "126.11447580"
            },
            {
                "id": 1295,
                "name": "Tarlac",
                "state_code": "TAR",
                "latitude": "15.47547860",
                "longitude": "120.59634920"
            },
            {
                "id": 1293,
                "name": "Tawi-Tawi",
                "state_code": "TAW",
                "latitude": "5.13381100",
                "longitude": "119.95092600"
            },
            {
                "id": 1305,
                "name": "Western Visayas",
                "state_code": "06",
                "latitude": "11.00498360",
                "longitude": "122.53727410"
            },
            {
                "id": 1297,
                "name": "Zambales",
                "state_code": "ZMB",
                "latitude": "15.50817660",
                "longitude": "119.96978080"
            },
            {
                "id": 1302,
                "name": "Zamboanga del Norte",
                "state_code": "ZAN",
                "latitude": "8.38862820",
                "longitude": "123.16888830"
            },
            {
                "id": 1357,
                "name": "Zamboanga del Sur",
                "state_code": "ZAS",
                "latitude": "7.83830540",
                "longitude": "123.29666570"
            },
            {
                "id": 1325,
                "name": "Zamboanga Peninsula",
                "state_code": "09",
                "latitude": "8.15407700",
                "longitude": "123.25879300"
            },
            {
                "id": 1362,
                "name": "Zamboanga Sibugay",
                "state_code": "ZSI",
                "latitude": "7.52252470",
                "longitude": "122.31075170"
            }
        ]
    },
    {
        "name": "Pitcairn Island",
        "iso3": "PCN",
        "iso2": "PN",
        "phone_code": "870",
        "capital": "Adamstown",
        "currency": "NZD",
        "currency_symbol": "$",
        "tld": ".pn",
        "native": "Pitcairn Islands",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Pitcairn",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "í•ì¼€ì–¸ ì œë„",
            "br": "Ilhas Pitcairn",
            "pt": "Ilhas PicÃ¡rnia",
            "nl": "Pitcairneilanden",
            "hr": "Pitcairnovo otoÄje",
            "fa": "Ù¾ÛŒØªÚ©Ø±Ù†",
            "de": "Pitcairn",
            "es": "Islas Pitcairn",
            "fr": "ÃŽles Pitcairn",
            "ja": "ãƒ”ãƒˆã‚±ã‚¢ãƒ³",
            "it": "Isole Pitcairn",
            "cn": "çš®ç‰¹å‡¯æ©ç¾¤å²›"
        },
        "latitude": "-25.06666666",
        "longitude": "-130.10000000",
        "emoji": "ðŸ‡µðŸ‡³",
        "emojiU": "U+1F1F5 U+1F1F3",
        "states": []
    },
    {
        "name": "Poland",
        "iso3": "POL",
        "iso2": "PL",
        "phone_code": "48",
        "capital": "Warsaw",
        "currency": "PLN",
        "currency_symbol": "zÅ‚",
        "tld": ".pl",
        "native": "Polska",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Warsaw",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "í´ëž€ë“œ",
            "br": "PolÃ´nia",
            "pt": "PolÃ³nia",
            "nl": "Polen",
            "hr": "Poljska",
            "fa": "Ù„Ù‡Ø³ØªØ§Ù†",
            "de": "Polen",
            "es": "Polonia",
            "fr": "Pologne",
            "ja": "ãƒãƒ¼ãƒ©ãƒ³ãƒ‰",
            "it": "Polonia",
            "cn": "æ³¢å…°"
        },
        "latitude": "52.00000000",
        "longitude": "20.00000000",
        "emoji": "ðŸ‡µðŸ‡±",
        "emojiU": "U+1F1F5 U+1F1F1",
        "states": [
            {
                "id": 1634,
                "name": "Greater Poland Voivodeship",
                "state_code": "WP",
                "latitude": "52.27998600",
                "longitude": "17.35229390"
            },
            {
                "id": 1625,
                "name": "Kuyavian-Pomeranian Voivodeship",
                "state_code": "KP",
                "latitude": "53.16483630",
                "longitude": "18.48342240"
            },
            {
                "id": 1635,
                "name": "Lesser Poland Voivodeship",
                "state_code": "MA",
                "latitude": "49.72253060",
                "longitude": "20.25033580"
            },
            {
                "id": 1629,
                "name": "Lower Silesian Voivodeship",
                "state_code": "DS",
                "latitude": "51.13398610",
                "longitude": "16.88419610"
            },
            {
                "id": 1638,
                "name": "Lublin Voivodeship",
                "state_code": "LU",
                "latitude": "51.24935190",
                "longitude": "23.10113920"
            },
            {
                "id": 1631,
                "name": "Lubusz Voivodeship",
                "state_code": "LB",
                "latitude": "52.22746120",
                "longitude": "15.25591030"
            },
            {
                "id": 1636,
                "name": "ÅÃ³dÅº Voivodeship",
                "state_code": "LD",
                "latitude": "51.46347710",
                "longitude": "19.17269740"
            },
            {
                "id": 1637,
                "name": "Masovian Voivodeship",
                "state_code": "MZ",
                "latitude": "51.89271820",
                "longitude": "21.00216790"
            },
            {
                "id": 1622,
                "name": "Opole Voivodeship",
                "state_code": "OP",
                "latitude": "50.80037610",
                "longitude": "17.93798900"
            },
            {
                "id": 1626,
                "name": "Podkarpackie Voivodeship",
                "state_code": "PK",
                "latitude": "50.05747490",
                "longitude": "22.08956910"
            },
            {
                "id": 1632,
                "name": "Podlaskie Voivodeship",
                "state_code": "PD",
                "latitude": "53.06971590",
                "longitude": "22.96746390"
            },
            {
                "id": 1624,
                "name": "Pomeranian Voivodeship",
                "state_code": "PM",
                "latitude": "54.29442520",
                "longitude": "18.15311640"
            },
            {
                "id": 1623,
                "name": "Silesian Voivodeship",
                "state_code": "SL",
                "latitude": "50.57165950",
                "longitude": "19.32197680"
            },
            {
                "id": 1630,
                "name": "ÅšwiÄ™tokrzyskie Voivodeship",
                "state_code": "SK",
                "latitude": "50.62610410",
                "longitude": "20.94062790"
            },
            {
                "id": 1628,
                "name": "Warmian-Masurian Voivodeship",
                "state_code": "WN",
                "latitude": "53.86711170",
                "longitude": "20.70278610"
            },
            {
                "id": 1633,
                "name": "West Pomeranian Voivodeship",
                "state_code": "ZP",
                "latitude": "53.46578910",
                "longitude": "15.18225810"
            }
        ]
    },
    {
        "name": "Portugal",
        "iso3": "PRT",
        "iso2": "PT",
        "phone_code": "351",
        "capital": "Lisbon",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".pt",
        "native": "Portugal",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Atlantic\/Azores",
                "gmtOffset": -3600,
                "gmtOffsetName": "UTC-01:00",
                "abbreviation": "AZOT",
                "tzName": "Azores Standard Time"
            },
            {
                "zoneName": "Atlantic\/Madeira",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            },
            {
                "zoneName": "Europe\/Lisbon",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            }
        ],
        "translations": {
            "kr": "í¬ë¥´íˆ¬ê°ˆ",
            "br": "Portugal",
            "pt": "Portugal",
            "nl": "Portugal",
            "hr": "Portugal",
            "fa": "Ù¾Ø±ØªØºØ§Ù„",
            "de": "Portugal",
            "es": "Portugal",
            "fr": "Portugal",
            "ja": "ãƒãƒ«ãƒˆã‚¬ãƒ«",
            "it": "Portogallo",
            "cn": "è‘¡è„ç‰™"
        },
        "latitude": "39.50000000",
        "longitude": "-8.00000000",
        "emoji": "ðŸ‡µðŸ‡¹",
        "emojiU": "U+1F1F5 U+1F1F9",
        "states": [
            {
                "id": 2233,
                "name": "AÃ§ores",
                "state_code": "20",
                "latitude": "37.74124880",
                "longitude": "-25.67559440"
            },
            {
                "id": 2235,
                "name": "Aveiro",
                "state_code": "01",
                "latitude": "40.72090230",
                "longitude": "-8.57210160"
            },
            {
                "id": 2230,
                "name": "Beja",
                "state_code": "02",
                "latitude": "37.96877860",
                "longitude": "-7.87216000"
            },
            {
                "id": 2244,
                "name": "Braga",
                "state_code": "03",
                "latitude": "41.55038800",
                "longitude": "-8.42613010"
            },
            {
                "id": 2229,
                "name": "BraganÃ§a",
                "state_code": "04",
                "latitude": "41.80616520",
                "longitude": "-6.75674270"
            },
            {
                "id": 2241,
                "name": "Castelo Branco",
                "state_code": "05",
                "latitude": "39.86313230",
                "longitude": "-7.48141630"
            },
            {
                "id": 2246,
                "name": "Coimbra",
                "state_code": "06",
                "latitude": "40.20579940",
                "longitude": "-8.41369000"
            },
            {
                "id": 2236,
                "name": "Ã‰vora",
                "state_code": "07",
                "latitude": "38.57444680",
                "longitude": "-7.90765530"
            },
            {
                "id": 2239,
                "name": "Faro",
                "state_code": "08",
                "latitude": "37.01935480",
                "longitude": "-7.93043970"
            },
            {
                "id": 4859,
                "name": "Guarda",
                "state_code": "09",
                "latitude": "40.53859720",
                "longitude": "-7.26757720"
            },
            {
                "id": 2240,
                "name": "Leiria",
                "state_code": "10",
                "latitude": "39.77095320",
                "longitude": "-8.79218360"
            },
            {
                "id": 2228,
                "name": "Lisbon",
                "state_code": "11",
                "latitude": "38.72232630",
                "longitude": "-9.13927140"
            },
            {
                "id": 2231,
                "name": "Madeira",
                "state_code": "30",
                "latitude": "32.76070740",
                "longitude": "-16.95947230"
            },
            {
                "id": 2232,
                "name": "Portalegre",
                "state_code": "12",
                "latitude": "39.29670860",
                "longitude": "-7.42847550"
            },
            {
                "id": 2243,
                "name": "Porto",
                "state_code": "13",
                "latitude": "41.14766290",
                "longitude": "-8.60789730"
            },
            {
                "id": 2238,
                "name": "SantarÃ©m",
                "state_code": "14",
                "latitude": "39.23666870",
                "longitude": "-8.68599440"
            },
            {
                "id": 2242,
                "name": "SetÃºbal",
                "state_code": "15",
                "latitude": "38.52409330",
                "longitude": "-8.89258760"
            },
            {
                "id": 2245,
                "name": "Viana do Castelo",
                "state_code": "16",
                "latitude": "41.69180460",
                "longitude": "-8.83445100"
            },
            {
                "id": 2234,
                "name": "Vila Real",
                "state_code": "17",
                "latitude": "41.30035270",
                "longitude": "-7.74572740"
            },
            {
                "id": 2237,
                "name": "Viseu",
                "state_code": "18",
                "latitude": "40.65884240",
                "longitude": "-7.91475600"
            }
        ]
    },
    {
        "name": "Puerto Rico",
        "iso3": "PRI",
        "iso2": "PR",
        "phone_code": "+1-787 and 1-939",
        "capital": "San Juan",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".pr",
        "native": "Puerto Rico",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Puerto_Rico",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "í‘¸ì—ë¥´í† ë¦¬ì½”",
            "br": "Porto Rico",
            "pt": "Porto Rico",
            "nl": "Puerto Rico",
            "hr": "Portoriko",
            "fa": "Ù¾ÙˆØ±ØªÙˆ Ø±ÛŒÚ©Ùˆ",
            "de": "Puerto Rico",
            "es": "Puerto Rico",
            "fr": "Porto Rico",
            "ja": "ãƒ—ã‚¨ãƒ«ãƒˆãƒªã‚³",
            "it": "Porto Rico",
            "cn": "æ³¢å¤šé»Žå„"
        },
        "latitude": "18.25000000",
        "longitude": "-66.50000000",
        "emoji": "ðŸ‡µðŸ‡·",
        "emojiU": "U+1F1F5 U+1F1F7",
        "states": []
    },
    {
        "name": "Qatar",
        "iso3": "QAT",
        "iso2": "QA",
        "phone_code": "974",
        "capital": "Doha",
        "currency": "QAR",
        "currency_symbol": "Ù‚.Ø±",
        "tld": ".qa",
        "native": "Ù‚Ø·Ø±",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Qatar",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì¹´íƒ€ë¥´",
            "br": "Catar",
            "pt": "Catar",
            "nl": "Qatar",
            "hr": "Katar",
            "fa": "Ù‚Ø·Ø±",
            "de": "Katar",
            "es": "Catar",
            "fr": "Qatar",
            "ja": "ã‚«ã‚¿ãƒ¼ãƒ«",
            "it": "Qatar",
            "cn": "å¡å¡”å°”"
        },
        "latitude": "25.50000000",
        "longitude": "51.25000000",
        "emoji": "ðŸ‡¶ðŸ‡¦",
        "emojiU": "U+1F1F6 U+1F1E6",
        "states": [
            {
                "id": 3182,
                "name": "Al Daayen",
                "state_code": "ZA",
                "latitude": "25.57845590",
                "longitude": "51.48213870"
            },
            {
                "id": 3183,
                "name": "Al Khor",
                "state_code": "KH",
                "latitude": "25.68040780",
                "longitude": "51.49685020"
            },
            {
                "id": 3177,
                "name": "Al Rayyan Municipality",
                "state_code": "RA",
                "latitude": "25.25225510",
                "longitude": "51.43887130"
            },
            {
                "id": 3179,
                "name": "Al Wakrah",
                "state_code": "WA",
                "latitude": "25.16593140",
                "longitude": "51.59755240"
            },
            {
                "id": 3178,
                "name": "Al-Shahaniya",
                "state_code": "SH",
                "latitude": "25.41063860",
                "longitude": "51.18460250"
            },
            {
                "id": 3181,
                "name": "Doha",
                "state_code": "DA",
                "latitude": "25.28544730",
                "longitude": "51.53103980"
            },
            {
                "id": 3180,
                "name": "Madinat ash Shamal",
                "state_code": "MS",
                "latitude": "26.11827430",
                "longitude": "51.21572650"
            },
            {
                "id": 3184,
                "name": "Umm Salal Municipality",
                "state_code": "US",
                "latitude": "25.48752420",
                "longitude": "51.39656800"
            }
        ]
    },
    {
        "name": "Reunion",
        "iso3": "REU",
        "iso2": "RE",
        "phone_code": "262",
        "capital": "Saint-Denis",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".re",
        "native": "La RÃ©union",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Reunion",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "RET",
                "tzName": "RÃ©union Time"
            }
        ],
        "translations": {
            "kr": "ë ˆìœ„ë‹ˆì˜¹",
            "br": "ReuniÃ£o",
            "pt": "ReuniÃ£o",
            "nl": "RÃ©union",
            "hr": "RÃ©union",
            "fa": "Ø±Ø¦ÙˆÙ†ÛŒÙˆÙ†",
            "de": "RÃ©union",
            "es": "ReuniÃ³n",
            "fr": "RÃ©union",
            "ja": "ãƒ¬ãƒ¦ãƒ‹ã‚ªãƒ³",
            "it": "Riunione",
            "cn": "ç•™å°¼æ±ªå²›"
        },
        "latitude": "-21.15000000",
        "longitude": "55.50000000",
        "emoji": "ðŸ‡·ðŸ‡ª",
        "emojiU": "U+1F1F7 U+1F1EA",
        "states": []
    },
    {
        "name": "Romania",
        "iso3": "ROU",
        "iso2": "RO",
        "phone_code": "40",
        "capital": "Bucharest",
        "currency": "RON",
        "currency_symbol": "lei",
        "tld": ".ro",
        "native": "RomÃ¢nia",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Bucharest",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ë£¨ë§ˆë‹ˆì•„",
            "br": "RomÃªnia",
            "pt": "RomÃ©nia",
            "nl": "RoemeniÃ«",
            "hr": "Rumunjska",
            "fa": "Ø±ÙˆÙ…Ø§Ù†ÛŒ",
            "de": "RumÃ¤nien",
            "es": "Rumania",
            "fr": "Roumanie",
            "ja": "ãƒ«ãƒ¼ãƒžãƒ‹ã‚¢",
            "it": "Romania",
            "cn": "ç½—é©¬å°¼äºš"
        },
        "latitude": "46.00000000",
        "longitude": "25.00000000",
        "emoji": "ðŸ‡·ðŸ‡´",
        "emojiU": "U+1F1F7 U+1F1F4",
        "states": [
            {
                "id": 4724,
                "name": "Alba",
                "state_code": "AB",
                "latitude": "44.70091530",
                "longitude": "8.03569110"
            },
            {
                "id": 4739,
                "name": "Arad County",
                "state_code": "AR",
                "latitude": "46.22836510",
                "longitude": "21.65978190"
            },
            {
                "id": 4722,
                "name": "Arges",
                "state_code": "AG",
                "latitude": "45.07225270",
                "longitude": "24.81427260"
            },
            {
                "id": 4744,
                "name": "BacÄƒu County",
                "state_code": "BC",
                "latitude": "46.32581840",
                "longitude": "26.66237800"
            },
            {
                "id": 4723,
                "name": "Bihor County",
                "state_code": "BH",
                "latitude": "47.01575160",
                "longitude": "22.17226600"
            },
            {
                "id": 4733,
                "name": "BistriÈ›a-NÄƒsÄƒud County",
                "state_code": "BN",
                "latitude": "47.24861070",
                "longitude": "24.53228140"
            },
            {
                "id": 4740,
                "name": "BotoÈ™ani County",
                "state_code": "BT",
                "latitude": "47.89240420",
                "longitude": "26.75917810"
            },
            {
                "id": 4736,
                "name": "Braila",
                "state_code": "BR",
                "latitude": "45.26524630",
                "longitude": "27.95947140"
            },
            {
                "id": 4759,
                "name": "BraÈ™ov County",
                "state_code": "BV",
                "latitude": "45.77818440",
                "longitude": "25.22258000"
            },
            {
                "id": 4730,
                "name": "Bucharest",
                "state_code": "B",
                "latitude": "44.42676740",
                "longitude": "26.10253840"
            },
            {
                "id": 4756,
                "name": "BuzÄƒu County",
                "state_code": "BZ",
                "latitude": "45.33509120",
                "longitude": "26.71075780"
            },
            {
                "id": 4732,
                "name": "CÄƒlÄƒraÈ™i County",
                "state_code": "CL",
                "latitude": "44.36587150",
                "longitude": "26.75486070"
            },
            {
                "id": 4753,
                "name": "CaraÈ™-Severin County",
                "state_code": "CS",
                "latitude": "45.11396460",
                "longitude": "22.07409930"
            },
            {
                "id": 4734,
                "name": "Cluj County",
                "state_code": "CJ",
                "latitude": "46.79417970",
                "longitude": "23.61214920"
            },
            {
                "id": 4737,
                "name": "ConstanÈ›a County",
                "state_code": "CT",
                "latitude": "44.21298700",
                "longitude": "28.25500550"
            },
            {
                "id": 4754,
                "name": "Covasna County",
                "state_code": "CV",
                "latitude": "45.94263470",
                "longitude": "25.89189840"
            },
            {
                "id": 4745,
                "name": "DÃ¢mboviÈ›a County",
                "state_code": "DB",
                "latitude": "44.92898930",
                "longitude": "25.42538500"
            },
            {
                "id": 4742,
                "name": "Dolj County",
                "state_code": "DJ",
                "latitude": "44.16230220",
                "longitude": "23.63250540"
            },
            {
                "id": 4747,
                "name": "GalaÈ›i County",
                "state_code": "GL",
                "latitude": "45.78005690",
                "longitude": "27.82515760"
            },
            {
                "id": 4726,
                "name": "Giurgiu County",
                "state_code": "GR",
                "latitude": "43.90370760",
                "longitude": "25.96992650"
            },
            {
                "id": 4750,
                "name": "Gorj County",
                "state_code": "GJ",
                "latitude": "44.94855950",
                "longitude": "23.24270790"
            },
            {
                "id": 4749,
                "name": "Harghita County",
                "state_code": "HR",
                "latitude": "46.49285070",
                "longitude": "25.64566960"
            },
            {
                "id": 4721,
                "name": "Hunedoara County",
                "state_code": "HD",
                "latitude": "45.79363800",
                "longitude": "22.99759930"
            },
            {
                "id": 4743,
                "name": "IalomiÈ›a County",
                "state_code": "IL",
                "latitude": "44.60313300",
                "longitude": "27.37899140"
            },
            {
                "id": 4735,
                "name": "IaÈ™i County",
                "state_code": "IS",
                "latitude": "47.26796530",
                "longitude": "27.21856620"
            },
            {
                "id": 4725,
                "name": "Ilfov County",
                "state_code": "IF",
                "latitude": "44.53554800",
                "longitude": "26.23248860"
            },
            {
                "id": 4760,
                "name": "MaramureÈ™ County",
                "state_code": "MM",
                "latitude": "46.55699040",
                "longitude": "24.67232150"
            },
            {
                "id": 4751,
                "name": "MehedinÈ›i County",
                "state_code": "MH",
                "latitude": "44.55150530",
                "longitude": "22.90441570"
            },
            {
                "id": 4915,
                "name": "MureÈ™ County",
                "state_code": "MS",
                "latitude": "46.55699040",
                "longitude": "24.67232150"
            },
            {
                "id": 4731,
                "name": "NeamÈ› County",
                "state_code": "NT",
                "latitude": "46.97586850",
                "longitude": "26.38187640"
            },
            {
                "id": 4738,
                "name": "Olt County",
                "state_code": "OT",
                "latitude": "44.20079700",
                "longitude": "24.50229810"
            },
            {
                "id": 4729,
                "name": "Prahova County",
                "state_code": "PH",
                "latitude": "45.08919060",
                "longitude": "26.08293130"
            },
            {
                "id": 4741,
                "name": "SÄƒlaj County",
                "state_code": "SJ",
                "latitude": "47.20908130",
                "longitude": "23.21219010"
            },
            {
                "id": 4746,
                "name": "Satu Mare County",
                "state_code": "SM",
                "latitude": "47.76689050",
                "longitude": "22.92413770"
            },
            {
                "id": 4755,
                "name": "Sibiu County",
                "state_code": "SB",
                "latitude": "45.92691060",
                "longitude": "24.22548070"
            },
            {
                "id": 4720,
                "name": "Suceava County",
                "state_code": "SV",
                "latitude": "47.55055480",
                "longitude": "25.74106200"
            },
            {
                "id": 4728,
                "name": "Teleorman County",
                "state_code": "TR",
                "latitude": "44.01604910",
                "longitude": "25.29866280"
            },
            {
                "id": 4748,
                "name": "TimiÈ™ County",
                "state_code": "TM",
                "latitude": "45.81389020",
                "longitude": "21.33310550"
            },
            {
                "id": 4727,
                "name": "Tulcea County",
                "state_code": "TL",
                "latitude": "45.04505650",
                "longitude": "29.03249120"
            },
            {
                "id": 4757,
                "name": "VÃ¢lcea County",
                "state_code": "VL",
                "latitude": "45.07980510",
                "longitude": "24.08352830"
            },
            {
                "id": 4752,
                "name": "Vaslui County",
                "state_code": "VS",
                "latitude": "46.46310590",
                "longitude": "27.73980310"
            },
            {
                "id": 4758,
                "name": "Vrancea County",
                "state_code": "VN",
                "latitude": "45.81348760",
                "longitude": "27.06575310"
            }
        ]
    },
    {
        "name": "Russia",
        "iso3": "RUS",
        "iso2": "RU",
        "phone_code": "7",
        "capital": "Moscow",
        "currency": "RUB",
        "currency_symbol": "â‚½",
        "tld": ".ru",
        "native": "Ð Ð¾ÑÑÐ¸Ñ",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Asia\/Anadyr",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "ANAT",
                "tzName": "Anadyr Time[4"
            },
            {
                "zoneName": "Asia\/Barnaul",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Chita",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Irkutsk",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "IRKT",
                "tzName": "Irkutsk Time"
            },
            {
                "zoneName": "Asia\/Kamchatka",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "PETT",
                "tzName": "Kamchatka Time"
            },
            {
                "zoneName": "Asia\/Khandyga",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Krasnoyarsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Magadan",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "MAGT",
                "tzName": "Magadan Time"
            },
            {
                "zoneName": "Asia\/Novokuznetsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "KRAT",
                "tzName": "Krasnoyarsk Time"
            },
            {
                "zoneName": "Asia\/Novosibirsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "NOVT",
                "tzName": "Novosibirsk Time"
            },
            {
                "zoneName": "Asia\/Omsk",
                "gmtOffset": 21600,
                "gmtOffsetName": "UTC+06:00",
                "abbreviation": "OMST",
                "tzName": "Omsk Time"
            },
            {
                "zoneName": "Asia\/Sakhalin",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SAKT",
                "tzName": "Sakhalin Island Time"
            },
            {
                "zoneName": "Asia\/Srednekolymsk",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SRET",
                "tzName": "Srednekolymsk Time"
            },
            {
                "zoneName": "Asia\/Tomsk",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "MSD+3",
                "tzName": "Moscow Daylight Time+3"
            },
            {
                "zoneName": "Asia\/Ust-Nera",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "VLAT",
                "tzName": "Vladivostok Time"
            },
            {
                "zoneName": "Asia\/Vladivostok",
                "gmtOffset": 36000,
                "gmtOffsetName": "UTC+10:00",
                "abbreviation": "VLAT",
                "tzName": "Vladivostok Time"
            },
            {
                "zoneName": "Asia\/Yakutsk",
                "gmtOffset": 32400,
                "gmtOffsetName": "UTC+09:00",
                "abbreviation": "YAKT",
                "tzName": "Yakutsk Time"
            },
            {
                "zoneName": "Asia\/Yekaterinburg",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "YEKT",
                "tzName": "Yekaterinburg Time"
            },
            {
                "zoneName": "Europe\/Astrakhan",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Kaliningrad",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Kirov",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Moscow",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Samara",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Saratov",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MSD",
                "tzName": "Moscow Daylight Time+4"
            },
            {
                "zoneName": "Europe\/Ulyanovsk",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SAMT",
                "tzName": "Samara Time"
            },
            {
                "zoneName": "Europe\/Volgograd",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Standard Time"
            }
        ],
        "translations": {
            "kr": "ëŸ¬ì‹œì•„",
            "br": "RÃºssia",
            "pt": "RÃºssia",
            "nl": "Rusland",
            "hr": "Rusija",
            "fa": "Ø±ÙˆØ³ÛŒÙ‡",
            "de": "Russland",
            "es": "Rusia",
            "fr": "Russie",
            "ja": "ãƒ­ã‚·ã‚¢é€£é‚¦",
            "it": "Russia",
            "cn": "ä¿„ç½—æ–¯è”é‚¦"
        },
        "latitude": "60.00000000",
        "longitude": "100.00000000",
        "emoji": "ðŸ‡·ðŸ‡º",
        "emojiU": "U+1F1F7 U+1F1FA",
        "states": [
            {
                "id": 1911,
                "name": "Altai Krai",
                "state_code": "ALT",
                "latitude": "51.79362980",
                "longitude": "82.67585960"
            },
            {
                "id": 1876,
                "name": "Altai Republic",
                "state_code": "AL",
                "latitude": "50.61819240",
                "longitude": "86.21993080"
            },
            {
                "id": 1858,
                "name": "Amur Oblast",
                "state_code": "AMU",
                "latitude": "54.60350650",
                "longitude": "127.48017210"
            },
            {
                "id": 1849,
                "name": "Arkhangelsk",
                "state_code": "ARK",
                "latitude": "64.54585490",
                "longitude": "40.55057690"
            },
            {
                "id": 1866,
                "name": "Astrakhan Oblast",
                "state_code": "AST",
                "latitude": "46.13211660",
                "longitude": "48.06101150"
            },
            {
                "id": 1903,
                "name": "Belgorod Oblast",
                "state_code": "BEL",
                "latitude": "50.71069260",
                "longitude": "37.75333770"
            },
            {
                "id": 1867,
                "name": "Bryansk Oblast",
                "state_code": "BRY",
                "latitude": "53.04085990",
                "longitude": "33.26909000"
            },
            {
                "id": 1893,
                "name": "Chechen Republic",
                "state_code": "CE",
                "latitude": "43.40233010",
                "longitude": "45.71874680"
            },
            {
                "id": 1845,
                "name": "Chelyabinsk Oblast",
                "state_code": "CHE",
                "latitude": "54.43194220",
                "longitude": "60.87889630"
            },
            {
                "id": 1859,
                "name": "Chukotka Autonomous Okrug",
                "state_code": "CHU",
                "latitude": "65.62983550",
                "longitude": "171.69521590"
            },
            {
                "id": 1914,
                "name": "Chuvash Republic",
                "state_code": "CU",
                "latitude": "55.55959920",
                "longitude": "46.92835350"
            },
            {
                "id": 1880,
                "name": "Irkutsk",
                "state_code": "IRK",
                "latitude": "52.28548340",
                "longitude": "104.28902220"
            },
            {
                "id": 1864,
                "name": "Ivanovo Oblast",
                "state_code": "IVA",
                "latitude": "57.10568540",
                "longitude": "41.48300840"
            },
            {
                "id": 1835,
                "name": "Jewish Autonomous Oblast",
                "state_code": "YEV",
                "latitude": "48.48081470",
                "longitude": "131.76573670"
            },
            {
                "id": 1892,
                "name": "Kabardino-Balkar Republic",
                "state_code": "KB",
                "latitude": "43.39324690",
                "longitude": "43.56284980"
            },
            {
                "id": 1902,
                "name": "Kaliningrad",
                "state_code": "KGD",
                "latitude": "54.71042640",
                "longitude": "20.45221440"
            },
            {
                "id": 1844,
                "name": "Kaluga Oblast",
                "state_code": "KLU",
                "latitude": "54.38726660",
                "longitude": "35.18890940"
            },
            {
                "id": 1865,
                "name": "Kamchatka Krai",
                "state_code": "KAM",
                "latitude": "61.43439810",
                "longitude": "166.78841310"
            },
            {
                "id": 1869,
                "name": "Karachay-Cherkess Republic",
                "state_code": "KC",
                "latitude": "43.88451430",
                "longitude": "41.73039390"
            },
            {
                "id": 1897,
                "name": "Kemerovo Oblast",
                "state_code": "KEM",
                "latitude": "54.75746480",
                "longitude": "87.40552880"
            },
            {
                "id": 1873,
                "name": "Khabarovsk Krai",
                "state_code": "KHA",
                "latitude": "50.58884310",
                "longitude": "135.00000000"
            },
            {
                "id": 1838,
                "name": "Khanty-Mansi Autonomous Okrug",
                "state_code": "KHM",
                "latitude": "62.22870620",
                "longitude": "70.64100570"
            },
            {
                "id": 1890,
                "name": "Kirov Oblast",
                "state_code": "KIR",
                "latitude": "58.41985290",
                "longitude": "50.20972480"
            },
            {
                "id": 1899,
                "name": "Komi Republic",
                "state_code": "KO",
                "latitude": "63.86305390",
                "longitude": "54.83126900"
            },
            {
                "id": 1910,
                "name": "Kostroma Oblast",
                "state_code": "KOS",
                "latitude": "58.55010690",
                "longitude": "43.95411020"
            },
            {
                "id": 1891,
                "name": "Krasnodar Krai",
                "state_code": "KDA",
                "latitude": "45.64152890",
                "longitude": "39.70559770"
            },
            {
                "id": 1840,
                "name": "Krasnoyarsk Krai",
                "state_code": "KYA",
                "latitude": "64.24797580",
                "longitude": "95.11041760"
            },
            {
                "id": 1915,
                "name": "Kurgan Oblast",
                "state_code": "KGN",
                "latitude": "55.44815480",
                "longitude": "65.11809750"
            },
            {
                "id": 1855,
                "name": "Kursk Oblast",
                "state_code": "KRS",
                "latitude": "51.76340260",
                "longitude": "35.38118120"
            },
            {
                "id": 1896,
                "name": "Leningrad Oblast",
                "state_code": "LEN",
                "latitude": "60.07932080",
                "longitude": "31.89266450"
            },
            {
                "id": 1889,
                "name": "Lipetsk Oblast",
                "state_code": "LIP",
                "latitude": "52.52647020",
                "longitude": "39.20322690"
            },
            {
                "id": 1839,
                "name": "Magadan Oblast",
                "state_code": "MAG",
                "latitude": "62.66434170",
                "longitude": "153.91499100"
            },
            {
                "id": 1870,
                "name": "Mari El Republic",
                "state_code": "ME",
                "latitude": "56.43845700",
                "longitude": "47.96077580"
            },
            {
                "id": 1901,
                "name": "Moscow",
                "state_code": "MOW",
                "latitude": "55.75582600",
                "longitude": "37.61729990"
            },
            {
                "id": 1882,
                "name": "Moscow Oblast",
                "state_code": "MOS",
                "latitude": "55.34039600",
                "longitude": "38.29176510"
            },
            {
                "id": 1843,
                "name": "Murmansk Oblast",
                "state_code": "MUR",
                "latitude": "67.84426740",
                "longitude": "35.08841020"
            },
            {
                "id": 1836,
                "name": "Nenets Autonomous Okrug",
                "state_code": "NEN",
                "latitude": "67.60783370",
                "longitude": "57.63383310"
            },
            {
                "id": 1857,
                "name": "Nizhny Novgorod Oblast",
                "state_code": "NIZ",
                "latitude": "55.79951590",
                "longitude": "44.02967690"
            },
            {
                "id": 1834,
                "name": "Novgorod Oblast",
                "state_code": "NGR",
                "latitude": "58.24275520",
                "longitude": "32.56651900"
            },
            {
                "id": 1888,
                "name": "Novosibirsk",
                "state_code": "NVS",
                "latitude": "54.98326930",
                "longitude": "82.89638310"
            },
            {
                "id": 1846,
                "name": "Omsk Oblast",
                "state_code": "OMS",
                "latitude": "55.05546690",
                "longitude": "73.31673420"
            },
            {
                "id": 1886,
                "name": "Orenburg Oblast",
                "state_code": "ORE",
                "latitude": "51.76340260",
                "longitude": "54.61881880"
            },
            {
                "id": 1908,
                "name": "Oryol Oblast",
                "state_code": "ORL",
                "latitude": "52.78564140",
                "longitude": "36.92423440"
            },
            {
                "id": 1909,
                "name": "Penza Oblast",
                "state_code": "PNZ",
                "latitude": "53.14121050",
                "longitude": "44.09400480"
            },
            {
                "id": 1871,
                "name": "Perm Krai",
                "state_code": "PER",
                "latitude": "58.82319290",
                "longitude": "56.58724810"
            },
            {
                "id": 1833,
                "name": "Primorsky Krai",
                "state_code": "PRI",
                "latitude": "45.05256410",
                "longitude": "135.00000000"
            },
            {
                "id": 1863,
                "name": "Pskov Oblast",
                "state_code": "PSK",
                "latitude": "56.77085990",
                "longitude": "29.09400900"
            },
            {
                "id": 1852,
                "name": "Republic of Adygea",
                "state_code": "AD",
                "latitude": "44.82291550",
                "longitude": "40.17544630"
            },
            {
                "id": 1854,
                "name": "Republic of Bashkortostan",
                "state_code": "BA",
                "latitude": "54.23121720",
                "longitude": "56.16452570"
            },
            {
                "id": 1842,
                "name": "Republic of Buryatia",
                "state_code": "BU",
                "latitude": "54.83311460",
                "longitude": "112.40605300"
            },
            {
                "id": 1850,
                "name": "Republic of Dagestan",
                "state_code": "DA",
                "latitude": "42.14318860",
                "longitude": "47.09497990"
            },
            {
                "id": 1884,
                "name": "Republic of Ingushetia",
                "state_code": "IN",
                "latitude": "43.40516980",
                "longitude": "44.82029990"
            },
            {
                "id": 1883,
                "name": "Republic of Kalmykia",
                "state_code": "KL",
                "latitude": "46.18671760",
                "longitude": "45.00000000"
            },
            {
                "id": 1841,
                "name": "Republic of Karelia",
                "state_code": "KR",
                "latitude": "63.15587020",
                "longitude": "32.99055520"
            },
            {
                "id": 1877,
                "name": "Republic of Khakassia",
                "state_code": "KK",
                "latitude": "53.04522810",
                "longitude": "90.39821450"
            },
            {
                "id": 1898,
                "name": "Republic of Mordovia",
                "state_code": "MO",
                "latitude": "54.23694410",
                "longitude": "44.06839700"
            },
            {
                "id": 1853,
                "name": "Republic of North Ossetia-Alania",
                "state_code": "SE",
                "latitude": "43.04513020",
                "longitude": "44.28709720"
            },
            {
                "id": 1861,
                "name": "Republic of Tatarstan",
                "state_code": "TA",
                "latitude": "55.18023640",
                "longitude": "50.72639450"
            },
            {
                "id": 1837,
                "name": "Rostov Oblast",
                "state_code": "ROS",
                "latitude": "47.68532470",
                "longitude": "41.82589520"
            },
            {
                "id": 1905,
                "name": "Ryazan Oblast",
                "state_code": "RYA",
                "latitude": "54.38759640",
                "longitude": "41.25956610"
            },
            {
                "id": 1879,
                "name": "Saint Petersburg",
                "state_code": "SPE",
                "latitude": "59.93105840",
                "longitude": "30.36090960"
            },
            {
                "id": 1848,
                "name": "Sakha Republic",
                "state_code": "SA",
                "latitude": "66.76134510",
                "longitude": "124.12375300"
            },
            {
                "id": 1875,
                "name": "Sakhalin",
                "state_code": "SAK",
                "latitude": "50.69098480",
                "longitude": "142.95056890"
            },
            {
                "id": 1862,
                "name": "Samara Oblast",
                "state_code": "SAM",
                "latitude": "53.41838390",
                "longitude": "50.47255280"
            },
            {
                "id": 1887,
                "name": "Saratov Oblast",
                "state_code": "SAR",
                "latitude": "51.83692630",
                "longitude": "46.75393970"
            },
            {
                "id": 1912,
                "name": "Sevastopol",
                "state_code": "UA-40",
                "latitude": "44.61665000",
                "longitude": "33.52536710"
            },
            {
                "id": 1885,
                "name": "Smolensk Oblast",
                "state_code": "SMO",
                "latitude": "54.98829940",
                "longitude": "32.66773780"
            },
            {
                "id": 1868,
                "name": "Stavropol Krai",
                "state_code": "STA",
                "latitude": "44.66809930",
                "longitude": "43.52021400"
            },
            {
                "id": 1894,
                "name": "Sverdlovsk",
                "state_code": "SVE",
                "latitude": "56.84309930",
                "longitude": "60.64540860"
            },
            {
                "id": 1878,
                "name": "Tambov Oblast",
                "state_code": "TAM",
                "latitude": "52.64165890",
                "longitude": "41.42164510"
            },
            {
                "id": 1872,
                "name": "Tomsk Oblast",
                "state_code": "TOM",
                "latitude": "58.89698820",
                "longitude": "82.67655000"
            },
            {
                "id": 1895,
                "name": "Tula Oblast",
                "state_code": "TUL",
                "latitude": "54.16376800",
                "longitude": "37.56495070"
            },
            {
                "id": 1900,
                "name": "Tuva Republic",
                "state_code": "TY",
                "latitude": "51.88726690",
                "longitude": "95.62601720"
            },
            {
                "id": 1860,
                "name": "Tver Oblast",
                "state_code": "TVE",
                "latitude": "57.00216540",
                "longitude": "33.98531420"
            },
            {
                "id": 1907,
                "name": "Tyumen Oblast",
                "state_code": "TYU",
                "latitude": "56.96343870",
                "longitude": "66.94827800"
            },
            {
                "id": 1913,
                "name": "Udmurt Republic",
                "state_code": "UD",
                "latitude": "57.06702180",
                "longitude": "53.02779480"
            },
            {
                "id": 1856,
                "name": "Ulyanovsk Oblast",
                "state_code": "ULY",
                "latitude": "53.97933570",
                "longitude": "47.77624250"
            },
            {
                "id": 1881,
                "name": "Vladimir Oblast",
                "state_code": "VLA",
                "latitude": "56.15534650",
                "longitude": "40.59266850"
            },
            {
                "id": 4916,
                "name": "Volgograd Oblast",
                "state_code": "VGG",
                "latitude": "49.25873930",
                "longitude": "39.81544630"
            },
            {
                "id": 1874,
                "name": "Vologda Oblast",
                "state_code": "VLG",
                "latitude": "59.87067110",
                "longitude": "40.65554110"
            },
            {
                "id": 1906,
                "name": "Voronezh Oblast",
                "state_code": "VOR",
                "latitude": "50.85897130",
                "longitude": "39.86443740"
            },
            {
                "id": 1847,
                "name": "Yamalo-Nenets Autonomous Okrug",
                "state_code": "YAN",
                "latitude": "66.06530570",
                "longitude": "76.93451930"
            },
            {
                "id": 1851,
                "name": "Yaroslavl Oblast",
                "state_code": "YAR",
                "latitude": "57.89915230",
                "longitude": "38.83886330"
            },
            {
                "id": 1904,
                "name": "Zabaykalsky Krai",
                "state_code": "ZAB",
                "latitude": "53.09287710",
                "longitude": "116.96765610"
            }
        ]
    },
    {
        "name": "Rwanda",
        "iso3": "RWA",
        "iso2": "RW",
        "phone_code": "250",
        "capital": "Kigali",
        "currency": "RWF",
        "currency_symbol": "FRw",
        "tld": ".rw",
        "native": "Rwanda",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Kigali",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ë¥´ì™„ë‹¤",
            "br": "Ruanda",
            "pt": "Ruanda",
            "nl": "Rwanda",
            "hr": "Ruanda",
            "fa": "Ø±ÙˆØ§Ù†Ø¯Ø§",
            "de": "Ruanda",
            "es": "Ruanda",
            "fr": "Rwanda",
            "ja": "ãƒ«ãƒ¯ãƒ³ãƒ€",
            "it": "Ruanda",
            "cn": "å¢æ—ºè¾¾"
        },
        "latitude": "-2.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡·ðŸ‡¼",
        "emojiU": "U+1F1F7 U+1F1FC",
        "states": [
            {
                "id": 261,
                "name": "Eastern Province",
                "state_code": "02",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 262,
                "name": "Kigali district",
                "state_code": "01",
                "latitude": "-1.94407270",
                "longitude": "30.06188510"
            },
            {
                "id": 263,
                "name": "Northern Province",
                "state_code": "03",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 259,
                "name": "Southern Province",
                "state_code": "05",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 260,
                "name": "Western Province",
                "state_code": "04",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Saint Helena",
        "iso3": "SHN",
        "iso2": "SH",
        "phone_code": "290",
        "capital": "Jamestown",
        "currency": "SHP",
        "currency_symbol": "Â£",
        "tld": ".sh",
        "native": "Saint Helena",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Atlantic\/St_Helena",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì¸íŠ¸í—¬ë ˆë‚˜",
            "br": "Santa Helena",
            "pt": "Santa Helena",
            "nl": "Sint-Helena",
            "hr": "Sveta Helena",
            "fa": "Ø³Ù†Øª Ù‡Ù„Ù†Ø§ØŒ Ø§Ø³Ù†Ø´Ù† Ùˆ ØªØ±ÛŒØ³ØªØ§Ù† Ø¯Ø§ Ú©ÙˆÙ†Ø§",
            "de": "Sankt Helena",
            "es": "Santa Helena",
            "fr": "Sainte-HÃ©lÃ¨ne",
            "ja": "ã‚»ãƒ³ãƒˆãƒ˜ãƒ¬ãƒŠãƒ»ã‚¢ã‚»ãƒ³ã‚·ãƒ§ãƒ³ãŠã‚ˆã³ãƒˆãƒªã‚¹ã‚¿ãƒ³ãƒ€ã‚¯ãƒ¼ãƒ‹ãƒ£",
            "it": "Sant'Elena",
            "cn": "åœ£èµ«å‹’æ‹¿"
        },
        "latitude": "-15.95000000",
        "longitude": "-5.70000000",
        "emoji": "ðŸ‡¸ðŸ‡­",
        "emojiU": "U+1F1F8 U+1F1ED",
        "states": []
    },
    {
        "name": "Saint Kitts And Nevis",
        "iso3": "KNA",
        "iso2": "KN",
        "phone_code": "+1-869",
        "capital": "Basseterre",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".kn",
        "native": "Saint Kitts and Nevis",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/St_Kitts",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì¸íŠ¸í‚¤ì¸  ë„¤ë¹„ìŠ¤",
            "br": "SÃ£o CristÃ³vÃ£o e Neves",
            "pt": "SÃ£o CristÃ³vÃ£o e Neves",
            "nl": "Saint Kitts en Nevis",
            "hr": "Sveti Kristof i Nevis",
            "fa": "Ø³Ù†Øª Ú©ÛŒØªØ³ Ùˆ Ù†ÙˆÛŒØ³",
            "de": "St. Kitts und Nevis",
            "es": "San CristÃ³bal y Nieves",
            "fr": "Saint-Christophe-et-NiÃ©vÃ¨s",
            "ja": "ã‚»ãƒ³ãƒˆã‚¯ãƒªã‚¹ãƒˆãƒ•ã‚¡ãƒ¼ãƒ»ãƒã‚¤ãƒ“ã‚¹",
            "it": "Saint Kitts e Nevis",
            "cn": "åœ£åŸºèŒ¨å’Œå°¼ç»´æ–¯"
        },
        "latitude": "17.33333333",
        "longitude": "-62.75000000",
        "emoji": "ðŸ‡°ðŸ‡³",
        "emojiU": "U+1F1F0 U+1F1F3",
        "states": [
            {
                "id": 3833,
                "name": "Christ Church Nichola Town Parish",
                "state_code": "01",
                "latitude": "17.36048120",
                "longitude": "-62.76178370"
            },
            {
                "id": 3832,
                "name": "Nevis",
                "state_code": "N",
                "latitude": "17.15535580",
                "longitude": "-62.57960260"
            },
            {
                "id": 3836,
                "name": "Saint Anne Sandy Point Parish",
                "state_code": "02",
                "latitude": "17.37253330",
                "longitude": "-62.84411330"
            },
            {
                "id": 3837,
                "name": "Saint George Gingerland Parish",
                "state_code": "04",
                "latitude": "17.12577590",
                "longitude": "-62.56198110"
            },
            {
                "id": 3835,
                "name": "Saint James Windward Parish",
                "state_code": "05",
                "latitude": "17.17696330",
                "longitude": "-62.57960260"
            },
            {
                "id": 3845,
                "name": "Saint John Capisterre Parish",
                "state_code": "06",
                "latitude": "17.38103410",
                "longitude": "-62.79118330"
            },
            {
                "id": 3840,
                "name": "Saint John Figtree Parish",
                "state_code": "07",
                "latitude": "17.11557480",
                "longitude": "-62.60310040"
            },
            {
                "id": 3841,
                "name": "Saint Kitts",
                "state_code": "K",
                "latitude": "17.34337960",
                "longitude": "-62.75590430"
            },
            {
                "id": 3844,
                "name": "Saint Mary Cayon Parish",
                "state_code": "08",
                "latitude": "17.34620710",
                "longitude": "-62.73826710"
            },
            {
                "id": 3834,
                "name": "Saint Paul Capisterre Parish",
                "state_code": "09",
                "latitude": "17.40166830",
                "longitude": "-62.82573320"
            },
            {
                "id": 3838,
                "name": "Saint Paul Charlestown Parish",
                "state_code": "10",
                "latitude": "17.13462970",
                "longitude": "-62.61338160"
            },
            {
                "id": 3831,
                "name": "Saint Peter Basseterre Parish",
                "state_code": "11",
                "latitude": "17.31029110",
                "longitude": "-62.71475330"
            },
            {
                "id": 3839,
                "name": "Saint Thomas Lowland Parish",
                "state_code": "12",
                "latitude": "17.16505130",
                "longitude": "-62.60897530"
            },
            {
                "id": 3842,
                "name": "Saint Thomas Middle Island Parish",
                "state_code": "13",
                "latitude": "17.33488130",
                "longitude": "-62.80882510"
            },
            {
                "id": 3843,
                "name": "Trinity Palmetto Point Parish",
                "state_code": "15",
                "latitude": "17.30635190",
                "longitude": "-62.76178370"
            }
        ]
    },
    {
        "name": "Saint Lucia",
        "iso3": "LCA",
        "iso2": "LC",
        "phone_code": "+1-758",
        "capital": "Castries",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".lc",
        "native": "Saint Lucia",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/St_Lucia",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì¸íŠ¸ë£¨ì‹œì•„",
            "br": "Santa LÃºcia",
            "pt": "Santa LÃºcia",
            "nl": "Saint Lucia",
            "hr": "Sveta Lucija",
            "fa": "Ø³Ù†Øª Ù„ÙˆØ³ÛŒØ§",
            "de": "Saint Lucia",
            "es": "Santa LucÃ­a",
            "fr": "Saint-Lucie",
            "ja": "ã‚»ãƒ³ãƒˆãƒ«ã‚·ã‚¢",
            "it": "Santa Lucia",
            "cn": "åœ£å¢è¥¿äºš"
        },
        "latitude": "13.88333333",
        "longitude": "-60.96666666",
        "emoji": "ðŸ‡±ðŸ‡¨",
        "emojiU": "U+1F1F1 U+1F1E8",
        "states": [
            {
                "id": 3757,
                "name": "Anse la Raye Quarter",
                "state_code": "01",
                "latitude": "13.94594240",
                "longitude": "-61.03694680"
            },
            {
                "id": 3761,
                "name": "Canaries",
                "state_code": "12",
                "latitude": "28.29156370",
                "longitude": "-16.62913040"
            },
            {
                "id": 3758,
                "name": "Castries Quarter",
                "state_code": "02",
                "latitude": "14.01010940",
                "longitude": "-60.98746870"
            },
            {
                "id": 3760,
                "name": "Choiseul Quarter",
                "state_code": "03",
                "latitude": "13.77501540",
                "longitude": "-61.04859100"
            },
            {
                "id": 3767,
                "name": "Dauphin Quarter",
                "state_code": "04",
                "latitude": "14.01033960",
                "longitude": "-60.91909880"
            },
            {
                "id": 3756,
                "name": "Dennery Quarter",
                "state_code": "05",
                "latitude": "13.92673930",
                "longitude": "-60.91909880"
            },
            {
                "id": 3766,
                "name": "Gros Islet Quarter",
                "state_code": "06",
                "latitude": "14.08435780",
                "longitude": "-60.94527940"
            },
            {
                "id": 3759,
                "name": "Laborie Quarter",
                "state_code": "07",
                "latitude": "13.75227830",
                "longitude": "-60.99328890"
            },
            {
                "id": 3762,
                "name": "Micoud Quarter",
                "state_code": "08",
                "latitude": "13.82118710",
                "longitude": "-60.90019340"
            },
            {
                "id": 3765,
                "name": "Praslin Quarter",
                "state_code": "09",
                "latitude": "13.87523920",
                "longitude": "-60.89946630"
            },
            {
                "id": 3764,
                "name": "SoufriÃ¨re Quarter",
                "state_code": "10",
                "latitude": "13.85709860",
                "longitude": "-61.05732480"
            },
            {
                "id": 3763,
                "name": "Vieux Fort Quarter",
                "state_code": "11",
                "latitude": "13.72060800",
                "longitude": "-60.94964330"
            }
        ]
    },
    {
        "name": "Saint Pierre and Miquelon",
        "iso3": "SPM",
        "iso2": "PM",
        "phone_code": "508",
        "capital": "Saint-Pierre",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".pm",
        "native": "Saint-Pierre-et-Miquelon",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "America\/Miquelon",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "PMDT",
                "tzName": "Pierre & Miquelon Daylight Time"
            }
        ],
        "translations": {
            "kr": "ìƒí”¼ì—ë¥´ ë¯¸í´ë¡±",
            "br": "Saint-Pierre e Miquelon",
            "pt": "SÃ£o Pedro e Miquelon",
            "nl": "Saint Pierre en Miquelon",
            "hr": "Sveti Petar i Mikelon",
            "fa": "Ø³Ù† Ù¾ÛŒØ± Ùˆ Ù…ÛŒÚ©Ù„Ù†",
            "de": "Saint-Pierre und Miquelon",
            "es": "San Pedro y MiquelÃ³n",
            "fr": "Saint-Pierre-et-Miquelon",
            "ja": "ã‚µãƒ³ãƒ”ã‚¨ãƒ¼ãƒ«å³¶ãƒ»ãƒŸã‚¯ãƒ­ãƒ³å³¶",
            "it": "Saint-Pierre e Miquelon",
            "cn": "åœ£çš®åŸƒå°”å’Œå¯†å…‹éš†"
        },
        "latitude": "46.83333333",
        "longitude": "-56.33333333",
        "emoji": "ðŸ‡µðŸ‡²",
        "emojiU": "U+1F1F5 U+1F1F2",
        "states": []
    },
    {
        "name": "Saint Vincent And The Grenadines",
        "iso3": "VCT",
        "iso2": "VC",
        "phone_code": "+1-784",
        "capital": "Kingstown",
        "currency": "XCD",
        "currency_symbol": "$",
        "tld": ".vc",
        "native": "Saint Vincent and the Grenadines",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/St_Vincent",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì¸íŠ¸ë¹ˆì„¼íŠ¸ ê·¸ë ˆë‚˜ë”˜",
            "br": "SÃ£o Vicente e Granadinas",
            "pt": "SÃ£o Vicente e Granadinas",
            "nl": "Saint Vincent en de Grenadines",
            "hr": "Sveti Vincent i Grenadini",
            "fa": "Ø³Ù†Øª ÙˆÛŒÙ†Ø³Ù†Øª Ùˆ Ú¯Ø±Ù†Ø§Ø¯ÛŒÙ†â€ŒÙ‡Ø§",
            "de": "Saint Vincent und die Grenadinen",
            "es": "San Vicente y Granadinas",
            "fr": "Saint-Vincent-et-les-Grenadines",
            "ja": "ã‚»ãƒ³ãƒˆãƒ“ãƒ³ã‚»ãƒ³ãƒˆãŠã‚ˆã³ã‚°ãƒ¬ãƒŠãƒ‡ã‚£ãƒ¼ãƒ³è«¸å³¶",
            "it": "Saint Vincent e Grenadine",
            "cn": "åœ£æ–‡æ£®ç‰¹å’Œæ ¼æž—çº³ä¸æ–¯"
        },
        "latitude": "13.25000000",
        "longitude": "-61.20000000",
        "emoji": "ðŸ‡»ðŸ‡¨",
        "emojiU": "U+1F1FB U+1F1E8",
        "states": [
            {
                "id": 3389,
                "name": "Charlotte Parish",
                "state_code": "01",
                "latitude": "13.21754510",
                "longitude": "-61.16362440"
            },
            {
                "id": 3388,
                "name": "Grenadines Parish",
                "state_code": "06",
                "latitude": "13.01229650",
                "longitude": "-61.22773010"
            },
            {
                "id": 3386,
                "name": "Saint Andrew Parish",
                "state_code": "02",
                "latitude": "43.02429990",
                "longitude": "-81.20250000"
            },
            {
                "id": 3387,
                "name": "Saint David Parish",
                "state_code": "03",
                "latitude": "43.85230950",
                "longitude": "-79.52366540"
            },
            {
                "id": 3384,
                "name": "Saint George Parish",
                "state_code": "04",
                "latitude": "42.95760900",
                "longitude": "-81.32670500"
            },
            {
                "id": 3385,
                "name": "Saint Patrick Parish",
                "state_code": "05",
                "latitude": "39.75091860",
                "longitude": "-94.84505560"
            }
        ]
    },
    {
        "name": "Saint-Barthelemy",
        "iso3": "BLM",
        "iso2": "BL",
        "phone_code": "590",
        "capital": "Gustavia",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".bl",
        "native": "Saint-BarthÃ©lemy",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/St_Barthelemy",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ìƒë°”ë¥´í…”ë ˆë¯¸",
            "br": "SÃ£o Bartolomeu",
            "pt": "SÃ£o Bartolomeu",
            "nl": "Saint BarthÃ©lemy",
            "hr": "Saint BarthÃ©lemy",
            "fa": "Ø³Ù†-Ø¨Ø§Ø±ØªÙ„Ù…ÛŒ",
            "de": "Saint-BarthÃ©lemy",
            "es": "San BartolomÃ©",
            "fr": "Saint-BarthÃ©lemy",
            "ja": "ã‚µãƒ³ãƒ»ãƒãƒ«ãƒ†ãƒ«ãƒŸãƒ¼",
            "it": "Antille Francesi",
            "cn": "åœ£å·´æ³°å‹’ç±³"
        },
        "latitude": "18.50000000",
        "longitude": "-63.41666666",
        "emoji": "ðŸ‡§ðŸ‡±",
        "emojiU": "U+1F1E7 U+1F1F1",
        "states": []
    },
    {
        "name": "Saint-Martin (French part)",
        "iso3": "MAF",
        "iso2": "MF",
        "phone_code": "590",
        "capital": "Marigot",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".mf",
        "native": "Saint-Martin",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Marigot",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì¸íŠ¸ë§ˆí‹´ ì„¬",
            "br": "Saint Martin",
            "pt": "Ilha SÃ£o Martinho",
            "nl": "Saint-Martin",
            "hr": "Sveti Martin",
            "fa": "Ø³ÛŒÙ†Øª Ù…Ø§Ø±ØªÙ†",
            "de": "Saint Martin",
            "es": "Saint Martin",
            "fr": "Saint-Martin",
            "ja": "ã‚µãƒ³ãƒ»ãƒžãƒ«ã‚¿ãƒ³ï¼ˆãƒ•ãƒ©ãƒ³ã‚¹é ˜ï¼‰",
            "it": "Saint Martin",
            "cn": "å¯†å…‹ç½—å°¼è¥¿äºš"
        },
        "latitude": "18.08333333",
        "longitude": "-63.95000000",
        "emoji": "ðŸ‡²ðŸ‡«",
        "emojiU": "U+1F1F2 U+1F1EB",
        "states": []
    },
    {
        "name": "Samoa",
        "iso3": "WSM",
        "iso2": "WS",
        "phone_code": "685",
        "capital": "Apia",
        "currency": "WST",
        "currency_symbol": "SAT",
        "tld": ".ws",
        "native": "Samoa",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Apia",
                "gmtOffset": 50400,
                "gmtOffsetName": "UTC+14:00",
                "abbreviation": "WST",
                "tzName": "West Samoa Time"
            }
        ],
        "translations": {
            "kr": "ì‚¬ëª¨ì•„",
            "br": "Samoa",
            "pt": "Samoa",
            "nl": "Samoa",
            "hr": "Samoa",
            "fa": "Ø³Ø§Ù…ÙˆØ¢",
            "de": "Samoa",
            "es": "Samoa",
            "fr": "Samoa",
            "ja": "ã‚µãƒ¢ã‚¢",
            "it": "Samoa",
            "cn": "è¨æ‘©äºš"
        },
        "latitude": "-13.58333333",
        "longitude": "-172.33333333",
        "emoji": "ðŸ‡¼ðŸ‡¸",
        "emojiU": "U+1F1FC U+1F1F8",
        "states": [
            {
                "id": 4763,
                "name": "A'ana",
                "state_code": "AA",
                "latitude": "-13.89841800",
                "longitude": "-171.97529950"
            },
            {
                "id": 4761,
                "name": "Aiga-i-le-Tai",
                "state_code": "AL",
                "latitude": "-13.85137910",
                "longitude": "-172.03254010"
            },
            {
                "id": 4765,
                "name": "Atua",
                "state_code": "AT",
                "latitude": "-13.97870530",
                "longitude": "-171.62542830"
            },
            {
                "id": 4764,
                "name": "Fa'asaleleaga",
                "state_code": "FA",
                "latitude": "-13.63076380",
                "longitude": "-172.23659810"
            },
            {
                "id": 4769,
                "name": "Gaga'emauga",
                "state_code": "GE",
                "latitude": "-13.54286660",
                "longitude": "-172.36688700"
            },
            {
                "id": 4771,
                "name": "Gaga'ifomauga",
                "state_code": "GI",
                "latitude": "-13.54680070",
                "longitude": "-172.49693310"
            },
            {
                "id": 4767,
                "name": "Palauli",
                "state_code": "PA",
                "latitude": "-13.72945790",
                "longitude": "-172.45361150"
            },
            {
                "id": 4762,
                "name": "Satupa'itea",
                "state_code": "SA",
                "latitude": "-13.65382140",
                "longitude": "-172.61592710"
            },
            {
                "id": 4770,
                "name": "Tuamasaga",
                "state_code": "TU",
                "latitude": "-13.91635920",
                "longitude": "-171.82243620"
            },
            {
                "id": 4768,
                "name": "Va'a-o-Fonoti",
                "state_code": "VF",
                "latitude": "-13.94709030",
                "longitude": "-171.54318720"
            },
            {
                "id": 4766,
                "name": "Vaisigano",
                "state_code": "VS",
                "latitude": "-13.54138270",
                "longitude": "-172.70233830"
            }
        ]
    },
    {
        "name": "San Marino",
        "iso3": "SMR",
        "iso2": "SM",
        "phone_code": "378",
        "capital": "San Marino",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".sm",
        "native": "San Marino",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/San_Marino",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì‚°ë§ˆë¦¬ë…¸",
            "br": "San Marino",
            "pt": "SÃ£o Marinho",
            "nl": "San Marino",
            "hr": "San Marino",
            "fa": "Ø³Ø§Ù† Ù…Ø§Ø±ÛŒÙ†Ùˆ",
            "de": "San Marino",
            "es": "San Marino",
            "fr": "Saint-Marin",
            "ja": "ã‚µãƒ³ãƒžãƒªãƒŽ",
            "it": "San Marino",
            "cn": "åœ£é©¬åŠ›è¯º"
        },
        "latitude": "43.76666666",
        "longitude": "12.41666666",
        "emoji": "ðŸ‡¸ðŸ‡²",
        "emojiU": "U+1F1F8 U+1F1F2",
        "states": [
            {
                "id": 59,
                "name": "Acquaviva",
                "state_code": "01",
                "latitude": "41.86715970",
                "longitude": "14.74694790"
            },
            {
                "id": 61,
                "name": "Borgo Maggiore",
                "state_code": "06",
                "latitude": "43.95748820",
                "longitude": "12.45525460"
            },
            {
                "id": 60,
                "name": "Chiesanuova",
                "state_code": "02",
                "latitude": "45.42261720",
                "longitude": "7.65038540"
            },
            {
                "id": 64,
                "name": "Domagnano",
                "state_code": "03",
                "latitude": "43.95019290",
                "longitude": "12.46815370"
            },
            {
                "id": 62,
                "name": "Faetano",
                "state_code": "04",
                "latitude": "43.93489670",
                "longitude": "12.48965540"
            },
            {
                "id": 66,
                "name": "Fiorentino",
                "state_code": "05",
                "latitude": "43.90783370",
                "longitude": "12.45812090"
            },
            {
                "id": 63,
                "name": "Montegiardino",
                "state_code": "08",
                "latitude": "43.90529990",
                "longitude": "12.48105420"
            },
            {
                "id": 58,
                "name": "San Marino",
                "state_code": "07",
                "latitude": "43.94236000",
                "longitude": "12.45777700"
            },
            {
                "id": 65,
                "name": "Serravalle",
                "state_code": "09",
                "latitude": "44.72320840",
                "longitude": "8.85740050"
            }
        ]
    },
    {
        "name": "Sao Tome and Principe",
        "iso3": "STP",
        "iso2": "ST",
        "phone_code": "239",
        "capital": "Sao Tome",
        "currency": "STD",
        "currency_symbol": "Db",
        "tld": ".st",
        "native": "SÃ£o TomÃ© e PrÃ­ncipe",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Sao_Tome",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ìƒíˆ¬ë©” í”„ë¦°ì‹œíŽ˜",
            "br": "SÃ£o TomÃ© e PrÃ­ncipe",
            "pt": "SÃ£o TomÃ© e PrÃ­ncipe",
            "nl": "Sao TomÃ© en Principe",
            "hr": "Sveti Toma i Princip",
            "fa": "Ú©ÙˆØ§ØªØ±Ùˆ Ø¯Ùˆ ÙØ±ÙˆÛŒØ±Ùˆ",
            "de": "SÃ£o TomÃ© und PrÃ­ncipe",
            "es": "Santo TomÃ© y PrÃ­ncipe",
            "fr": "Sao TomÃ©-et-Principe",
            "ja": "ã‚µãƒ³ãƒˆãƒ¡ãƒ»ãƒ—ãƒªãƒ³ã‚·ãƒš",
            "it": "SÃ£o TomÃ© e PrÃ­ncipe",
            "cn": "åœ£å¤šç¾Žå’Œæ™®æž—è¥¿æ¯”"
        },
        "latitude": "1.00000000",
        "longitude": "7.00000000",
        "emoji": "ðŸ‡¸ðŸ‡¹",
        "emojiU": "U+1F1F8 U+1F1F9",
        "states": [
            {
                "id": 270,
                "name": "PrÃ­ncipe Province",
                "state_code": "P",
                "latitude": "1.61393810",
                "longitude": "7.40569280"
            },
            {
                "id": 271,
                "name": "SÃ£o TomÃ© Province",
                "state_code": "S",
                "latitude": "0.33019240",
                "longitude": "6.73334300"
            }
        ]
    },
    {
        "name": "Saudi Arabia",
        "iso3": "SAU",
        "iso2": "SA",
        "phone_code": "966",
        "capital": "Riyadh",
        "currency": "SAR",
        "currency_symbol": "ï·¼",
        "tld": ".sa",
        "native": "Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ø³Ø¹ÙˆØ¯ÙŠØ©",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Riyadh",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì‚¬ìš°ë””ì•„ë¼ë¹„ì•„",
            "br": "ArÃ¡bia Saudita",
            "pt": "ArÃ¡bia Saudita",
            "nl": "Saoedi-ArabiÃ«",
            "hr": "Saudijska Arabija",
            "fa": "Ø¹Ø±Ø¨Ø³ØªØ§Ù† Ø³Ø¹ÙˆØ¯ÛŒ",
            "de": "Saudi-Arabien",
            "es": "Arabia SaudÃ­",
            "fr": "Arabie Saoudite",
            "ja": "ã‚µã‚¦ã‚¸ã‚¢ãƒ©ãƒ“ã‚¢",
            "it": "Arabia Saudita",
            "cn": "æ²™ç‰¹é˜¿æ‹‰ä¼¯"
        },
        "latitude": "25.00000000",
        "longitude": "45.00000000",
        "emoji": "ðŸ‡¸ðŸ‡¦",
        "emojiU": "U+1F1F8 U+1F1E6",
        "states": [
            {
                "id": 2853,
                "name": "'Asir Region",
                "state_code": "14",
                "latitude": "19.09690620",
                "longitude": "42.86378750"
            },
            {
                "id": 2859,
                "name": "Al Bahah Region",
                "state_code": "11",
                "latitude": "20.27227390",
                "longitude": "41.44125100"
            },
            {
                "id": 2857,
                "name": "Al Jawf Region",
                "state_code": "12",
                "latitude": "29.88735600",
                "longitude": "39.32062410"
            },
            {
                "id": 2851,
                "name": "Al Madinah Region",
                "state_code": "03",
                "latitude": "24.84039770",
                "longitude": "39.32062410"
            },
            {
                "id": 2861,
                "name": "Al-Qassim Region",
                "state_code": "05",
                "latitude": "26.20782600",
                "longitude": "43.48373800"
            },
            {
                "id": 2856,
                "name": "Eastern Province",
                "state_code": "04",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2855,
                "name": "Ha'il Region",
                "state_code": "06",
                "latitude": "27.70761430",
                "longitude": "41.91964710"
            },
            {
                "id": 2858,
                "name": "Jizan Region",
                "state_code": "09",
                "latitude": "17.17381760",
                "longitude": "42.70761070"
            },
            {
                "id": 2850,
                "name": "Makkah Region",
                "state_code": "02",
                "latitude": "21.52355840",
                "longitude": "41.91964710"
            },
            {
                "id": 2860,
                "name": "Najran Region",
                "state_code": "10",
                "latitude": "18.35146640",
                "longitude": "45.60071080"
            },
            {
                "id": 2854,
                "name": "Northern Borders Region",
                "state_code": "08",
                "latitude": "30.07991620",
                "longitude": "42.86378750"
            },
            {
                "id": 2849,
                "name": "Riyadh Region",
                "state_code": "01",
                "latitude": "22.75543850",
                "longitude": "46.20915470"
            },
            {
                "id": 2852,
                "name": "Tabuk Region",
                "state_code": "07",
                "latitude": "28.24533350",
                "longitude": "37.63866220"
            }
        ]
    },
    {
        "name": "Senegal",
        "iso3": "SEN",
        "iso2": "SN",
        "phone_code": "221",
        "capital": "Dakar",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".sn",
        "native": "SÃ©nÃ©gal",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Dakar",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ë„¤ê°ˆ",
            "br": "Senegal",
            "pt": "Senegal",
            "nl": "Senegal",
            "hr": "Senegal",
            "fa": "Ø³Ù†Ú¯Ø§Ù„",
            "de": "Senegal",
            "es": "Senegal",
            "fr": "SÃ©nÃ©gal",
            "ja": "ã‚»ãƒã‚¬ãƒ«",
            "it": "Senegal",
            "cn": "å¡žå†…åŠ å°”"
        },
        "latitude": "14.00000000",
        "longitude": "-14.00000000",
        "emoji": "ðŸ‡¸ðŸ‡³",
        "emojiU": "U+1F1F8 U+1F1F3",
        "states": [
            {
                "id": 473,
                "name": "Dakar",
                "state_code": "DK",
                "latitude": "14.71667700",
                "longitude": "-17.46768610"
            },
            {
                "id": 480,
                "name": "Diourbel Region",
                "state_code": "DB",
                "latitude": "14.72830850",
                "longitude": "-16.25221430"
            },
            {
                "id": 479,
                "name": "Fatick",
                "state_code": "FK",
                "latitude": "14.33901670",
                "longitude": "-16.41114250"
            },
            {
                "id": 475,
                "name": "Kaffrine",
                "state_code": "KA",
                "latitude": "14.10520200",
                "longitude": "-15.54157550"
            },
            {
                "id": 483,
                "name": "Kaolack",
                "state_code": "KL",
                "latitude": "14.16520830",
                "longitude": "-16.07577490"
            },
            {
                "id": 481,
                "name": "KÃ©dougou",
                "state_code": "KE",
                "latitude": "12.56046070",
                "longitude": "-12.17470770"
            },
            {
                "id": 474,
                "name": "Kolda",
                "state_code": "KD",
                "latitude": "12.91074950",
                "longitude": "-14.95056710"
            },
            {
                "id": 485,
                "name": "Louga",
                "state_code": "LG",
                "latitude": "15.61417680",
                "longitude": "-16.22868000"
            },
            {
                "id": 476,
                "name": "Matam",
                "state_code": "MT",
                "latitude": "15.66002250",
                "longitude": "-13.25769060"
            },
            {
                "id": 477,
                "name": "Saint-Louis",
                "state_code": "SL",
                "latitude": "38.62700250",
                "longitude": "-90.19940420"
            },
            {
                "id": 482,
                "name": "SÃ©dhiou",
                "state_code": "SE",
                "latitude": "12.70460400",
                "longitude": "-15.55623040"
            },
            {
                "id": 486,
                "name": "Tambacounda Region",
                "state_code": "TC",
                "latitude": "13.56190110",
                "longitude": "-13.17403480"
            },
            {
                "id": 484,
                "name": "ThiÃ¨s Region",
                "state_code": "TH",
                "latitude": "14.79100520",
                "longitude": "-16.93586040"
            },
            {
                "id": 478,
                "name": "Ziguinchor",
                "state_code": "ZG",
                "latitude": "12.56414790",
                "longitude": "-16.26398250"
            }
        ]
    },
    {
        "name": "Serbia",
        "iso3": "SRB",
        "iso2": "RS",
        "phone_code": "381",
        "capital": "Belgrade",
        "currency": "RSD",
        "currency_symbol": "din",
        "tld": ".rs",
        "native": "Ð¡Ñ€Ð±Ð¸Ñ˜Ð°",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Belgrade",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ë¥´ë¹„ì•„",
            "br": "SÃ©rvia",
            "pt": "SÃ©rvia",
            "nl": "ServiÃ«",
            "hr": "Srbija",
            "fa": "ØµØ±Ø¨Ø³ØªØ§Ù†",
            "de": "Serbien",
            "es": "Serbia",
            "fr": "Serbie",
            "ja": "ã‚»ãƒ«ãƒ“ã‚¢",
            "it": "Serbia",
            "cn": "å¡žå°”ç»´äºš"
        },
        "latitude": "44.00000000",
        "longitude": "21.00000000",
        "emoji": "ðŸ‡·ðŸ‡¸",
        "emojiU": "U+1F1F7 U+1F1F8",
        "states": [
            {
                "id": 3728,
                "name": "Belgrade",
                "state_code": "00",
                "latitude": "44.78656800",
                "longitude": "20.44892160"
            },
            {
                "id": 3717,
                "name": "Bor District",
                "state_code": "14",
                "latitude": "44.06989180",
                "longitude": "22.09850860"
            },
            {
                "id": 3732,
                "name": "BraniÄevo District",
                "state_code": "11",
                "latitude": "44.69822460",
                "longitude": "21.54467750"
            },
            {
                "id": 3716,
                "name": "Central Banat District",
                "state_code": "02",
                "latitude": "45.47884850",
                "longitude": "20.60825220"
            },
            {
                "id": 3715,
                "name": "Jablanica District",
                "state_code": "23",
                "latitude": "42.94815600",
                "longitude": "21.81293210"
            },
            {
                "id": 3724,
                "name": "Kolubara District",
                "state_code": "09",
                "latitude": "44.35098110",
                "longitude": "20.00043050"
            },
            {
                "id": 3719,
                "name": "MaÄva District",
                "state_code": "08",
                "latitude": "44.59253140",
                "longitude": "19.50822460"
            },
            {
                "id": 3727,
                "name": "Moravica District",
                "state_code": "17",
                "latitude": "43.84147000",
                "longitude": "20.29049870"
            },
            {
                "id": 3722,
                "name": "NiÅ¡ava District",
                "state_code": "20",
                "latitude": "43.37389020",
                "longitude": "21.93223310"
            },
            {
                "id": 3714,
                "name": "North BaÄka District",
                "state_code": "01",
                "latitude": "45.98033940",
                "longitude": "19.59070010"
            },
            {
                "id": 3736,
                "name": "North Banat District",
                "state_code": "03",
                "latitude": "45.90683900",
                "longitude": "19.99934170"
            },
            {
                "id": 3721,
                "name": "PÄinja District",
                "state_code": "24",
                "latitude": "42.58363620",
                "longitude": "22.14302150"
            },
            {
                "id": 3712,
                "name": "Pirot District",
                "state_code": "22",
                "latitude": "43.08740360",
                "longitude": "22.59830440"
            },
            {
                "id": 3741,
                "name": "Podunavlje District",
                "state_code": "10",
                "latitude": "44.47291560",
                "longitude": "20.99014260"
            },
            {
                "id": 3737,
                "name": "Pomoravlje District",
                "state_code": "13",
                "latitude": "43.95913790",
                "longitude": "21.27135300"
            },
            {
                "id": 3720,
                "name": "Rasina District",
                "state_code": "19",
                "latitude": "43.52635250",
                "longitude": "21.15881780"
            },
            {
                "id": 3725,
                "name": "RaÅ¡ka District",
                "state_code": "18",
                "latitude": "43.33734610",
                "longitude": "20.57340050"
            },
            {
                "id": 3711,
                "name": "South BaÄka District",
                "state_code": "06",
                "latitude": "45.48903440",
                "longitude": "19.69761870"
            },
            {
                "id": 3713,
                "name": "South Banat District",
                "state_code": "04",
                "latitude": "45.00274570",
                "longitude": "21.05425090"
            },
            {
                "id": 3740,
                "name": "Srem District",
                "state_code": "07",
                "latitude": "45.00291710",
                "longitude": "19.80137730"
            },
            {
                "id": 3734,
                "name": "Å umadija District",
                "state_code": "12",
                "latitude": "44.20506780",
                "longitude": "20.78565650"
            },
            {
                "id": 3718,
                "name": "Toplica District",
                "state_code": "21",
                "latitude": "43.19065920",
                "longitude": "21.34077620"
            },
            {
                "id": 3733,
                "name": "Vojvodina",
                "state_code": "VO",
                "latitude": "45.26086510",
                "longitude": "19.83193380"
            },
            {
                "id": 3726,
                "name": "West BaÄka District",
                "state_code": "05",
                "latitude": "45.73553850",
                "longitude": "19.18973640"
            },
            {
                "id": 3731,
                "name": "ZajeÄar District",
                "state_code": "15",
                "latitude": "43.90150480",
                "longitude": "22.27380110"
            },
            {
                "id": 3729,
                "name": "Zlatibor District",
                "state_code": "16",
                "latitude": "43.64541700",
                "longitude": "19.71014550"
            }
        ]
    },
    {
        "name": "Seychelles",
        "iso3": "SYC",
        "iso2": "SC",
        "phone_code": "248",
        "capital": "Victoria",
        "currency": "SCR",
        "currency_symbol": "SRe",
        "tld": ".sc",
        "native": "Seychelles",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Indian\/Mahe",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "SCT",
                "tzName": "Seychelles Time"
            }
        ],
        "translations": {
            "kr": "ì„¸ì´ì…¸",
            "br": "Seicheles",
            "pt": "Seicheles",
            "nl": "Seychellen",
            "hr": "SejÅ¡eli",
            "fa": "Ø³ÛŒØ´Ù„",
            "de": "Seychellen",
            "es": "Seychelles",
            "fr": "Seychelles",
            "ja": "ã‚»ãƒ¼ã‚·ã‚§ãƒ«",
            "it": "Seychelles",
            "cn": "å¡žèˆŒå°”"
        },
        "latitude": "-4.58333333",
        "longitude": "55.66666666",
        "emoji": "ðŸ‡¸ðŸ‡¨",
        "emojiU": "U+1F1F8 U+1F1E8",
        "states": [
            {
                "id": 513,
                "name": "Anse Boileau",
                "state_code": "02",
                "latitude": "-4.70472680",
                "longitude": "55.48593630"
            },
            {
                "id": 502,
                "name": "Anse Royale",
                "state_code": "05",
                "latitude": "-4.74079880",
                "longitude": "55.50810120"
            },
            {
                "id": 506,
                "name": "Anse-aux-Pins",
                "state_code": "01",
                "latitude": "-4.69004430",
                "longitude": "55.51502890"
            },
            {
                "id": 508,
                "name": "Au Cap",
                "state_code": "04",
                "latitude": "-4.70597230",
                "longitude": "55.50810120"
            },
            {
                "id": 497,
                "name": "Baie Lazare",
                "state_code": "06",
                "latitude": "-4.74825250",
                "longitude": "55.48593630"
            },
            {
                "id": 514,
                "name": "Baie Sainte Anne",
                "state_code": "07",
                "latitude": "47.05259000",
                "longitude": "-64.95245790"
            },
            {
                "id": 512,
                "name": "Beau Vallon",
                "state_code": "08",
                "latitude": "-4.62109670",
                "longitude": "55.42778020"
            },
            {
                "id": 515,
                "name": "Bel Air",
                "state_code": "09",
                "latitude": "34.10024550",
                "longitude": "-118.45946300"
            },
            {
                "id": 505,
                "name": "Bel Ombre",
                "state_code": "10",
                "latitude": "-20.50100950",
                "longitude": "57.42596240"
            },
            {
                "id": 517,
                "name": "Cascade",
                "state_code": "11",
                "latitude": "44.51628210",
                "longitude": "-116.04179830"
            },
            {
                "id": 503,
                "name": "Glacis",
                "state_code": "12",
                "latitude": "47.11573030",
                "longitude": "-70.30281830"
            },
            {
                "id": 500,
                "name": "Grand'Anse MahÃ©",
                "state_code": "13",
                "latitude": "-4.67739200",
                "longitude": "55.46377700"
            },
            {
                "id": 504,
                "name": "Grand'Anse Praslin",
                "state_code": "14",
                "latitude": "-4.31762190",
                "longitude": "55.70783630"
            },
            {
                "id": 495,
                "name": "La Digue",
                "state_code": "15",
                "latitude": "49.76669220",
                "longitude": "-97.15466290"
            },
            {
                "id": 516,
                "name": "La RiviÃ¨re Anglaise",
                "state_code": "16",
                "latitude": "-4.61061500",
                "longitude": "55.45408410"
            },
            {
                "id": 499,
                "name": "Les Mamelles",
                "state_code": "24",
                "latitude": "38.82505050",
                "longitude": "-90.48345170"
            },
            {
                "id": 494,
                "name": "Mont Buxton",
                "state_code": "17",
                "latitude": "-4.61666670",
                "longitude": "55.44577680"
            },
            {
                "id": 498,
                "name": "Mont Fleuri",
                "state_code": "18",
                "latitude": "-4.63565430",
                "longitude": "55.45546880"
            },
            {
                "id": 511,
                "name": "Plaisance",
                "state_code": "19",
                "latitude": "45.60709500",
                "longitude": "-75.11427450"
            },
            {
                "id": 510,
                "name": "Pointe La Rue",
                "state_code": "20",
                "latitude": "-4.68048900",
                "longitude": "55.51918570"
            },
            {
                "id": 507,
                "name": "Port Glaud",
                "state_code": "21",
                "latitude": "-4.64885230",
                "longitude": "55.41947530"
            },
            {
                "id": 501,
                "name": "Roche Caiman",
                "state_code": "25",
                "latitude": "-4.63960280",
                "longitude": "55.46793150"
            },
            {
                "id": 496,
                "name": "Saint Louis",
                "state_code": "22",
                "latitude": "38.62700250",
                "longitude": "-90.19940420"
            },
            {
                "id": 509,
                "name": "Takamaka",
                "state_code": "23",
                "latitude": "37.96459170",
                "longitude": "-1.22177270"
            }
        ]
    },
    {
        "name": "Sierra Leone",
        "iso3": "SLE",
        "iso2": "SL",
        "phone_code": "232",
        "capital": "Freetown",
        "currency": "SLL",
        "currency_symbol": "Le",
        "tld": ".sl",
        "native": "Sierra Leone",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Freetown",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì‹œì—ë¼ë¦¬ì˜¨",
            "br": "Serra Leoa",
            "pt": "Serra Leoa",
            "nl": "Sierra Leone",
            "hr": "Sijera Leone",
            "fa": "Ø³ÛŒØ±Ø§Ù„Ø¦ÙˆÙ†",
            "de": "Sierra Leone",
            "es": "Sierra Leone",
            "fr": "Sierra Leone",
            "ja": "ã‚·ã‚¨ãƒ©ãƒ¬ã‚ªãƒ",
            "it": "Sierra Leone",
            "cn": "å¡žæ‹‰åˆ©æ˜‚"
        },
        "latitude": "8.50000000",
        "longitude": "-11.50000000",
        "emoji": "ðŸ‡¸ðŸ‡±",
        "emojiU": "U+1F1F8 U+1F1F1",
        "states": [
            {
                "id": 914,
                "name": "Eastern Province",
                "state_code": "E",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 911,
                "name": "Northern Province",
                "state_code": "N",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 912,
                "name": "Southern Province",
                "state_code": "S",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 913,
                "name": "Western Area",
                "state_code": "W",
                "latitude": "40.25459690",
                "longitude": "-80.24554440"
            }
        ]
    },
    {
        "name": "Singapore",
        "iso3": "SGP",
        "iso2": "SG",
        "phone_code": "65",
        "capital": "Singapur",
        "currency": "SGD",
        "currency_symbol": "$",
        "tld": ".sg",
        "native": "Singapore",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Singapore",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "SGT",
                "tzName": "Singapore Time"
            }
        ],
        "translations": {
            "kr": "ì‹±ê°€í¬ë¥´",
            "br": "Singapura",
            "pt": "Singapura",
            "nl": "Singapore",
            "hr": "Singapur",
            "fa": "Ø³Ù†Ú¯Ø§Ù¾ÙˆØ±",
            "de": "Singapur",
            "es": "Singapur",
            "fr": "Singapour",
            "ja": "ã‚·ãƒ³ã‚¬ãƒãƒ¼ãƒ«",
            "it": "Singapore",
            "cn": "æ–°åŠ å¡"
        },
        "latitude": "1.36666666",
        "longitude": "103.80000000",
        "emoji": "ðŸ‡¸ðŸ‡¬",
        "emojiU": "U+1F1F8 U+1F1EC",
        "states": [
            {
                "id": 4651,
                "name": "Central Singapore Community Development Council",
                "state_code": "01",
                "latitude": "1.28951400",
                "longitude": "103.81438790"
            },
            {
                "id": 4649,
                "name": "North East Community Development Council",
                "state_code": "02",
                "latitude": "45.01181130",
                "longitude": "-93.24681070"
            },
            {
                "id": 4653,
                "name": "North West Community Development Council",
                "state_code": "03",
                "latitude": "39.10709300",
                "longitude": "-94.45733600"
            },
            {
                "id": 4650,
                "name": "South East Community Development Council",
                "state_code": "04",
                "latitude": "39.28630700",
                "longitude": "-76.56912370"
            },
            {
                "id": 4652,
                "name": "South West Community Development Council",
                "state_code": "05",
                "latitude": "39.92569100",
                "longitude": "-75.23105800"
            }
        ]
    },
    {
        "name": "Sint Maarten (Dutch part)",
        "iso3": "SXM",
        "iso2": "SX",
        "phone_code": "1721",
        "capital": "Philipsburg",
        "currency": "ANG",
        "currency_symbol": "Æ’",
        "tld": ".sx",
        "native": "Sint Maarten",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Anguilla",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì‹ íŠ¸ë§ˆë¥´í„´",
            "br": "Sint Maarten",
            "pt": "SÃ£o Martinho",
            "nl": "Sint Maarten",
            "fa": "Ø³ÛŒÙ†Øª Ù…Ø§Ø±ØªÙ†",
            "de": "Sint Maarten (niederl. Teil)",
            "fr": "Saint Martin (partie nÃ©erlandaise)",
            "it": "Saint Martin (parte olandese)",
            "cn": "åœ£é©¬ä¸å²›ï¼ˆè·å…°éƒ¨åˆ†ï¼‰"
        },
        "latitude": "18.03333300",
        "longitude": "-63.05000000",
        "emoji": "ðŸ‡¸ðŸ‡½",
        "emojiU": "U+1F1F8 U+1F1FD",
        "states": []
    },
    {
        "name": "Slovakia",
        "iso3": "SVK",
        "iso2": "SK",
        "phone_code": "421",
        "capital": "Bratislava",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".sk",
        "native": "Slovensko",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Bratislava",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¬ë¡œë°”í‚¤ì•„",
            "br": "EslovÃ¡quia",
            "pt": "EslovÃ¡quia",
            "nl": "Slowakije",
            "hr": "SlovaÄka",
            "fa": "Ø§Ø³Ù„ÙˆØ§Ú©ÛŒ",
            "de": "Slowakei",
            "es": "RepÃºblica Eslovaca",
            "fr": "Slovaquie",
            "ja": "ã‚¹ãƒ­ãƒã‚­ã‚¢",
            "it": "Slovacchia",
            "cn": "æ–¯æ´›ä¼å…‹"
        },
        "latitude": "48.66666666",
        "longitude": "19.50000000",
        "emoji": "ðŸ‡¸ðŸ‡°",
        "emojiU": "U+1F1F8 U+1F1F0",
        "states": [
            {
                "id": 4352,
                "name": "BanskÃ¡ Bystrica Region",
                "state_code": "BC",
                "latitude": "48.53124990",
                "longitude": "19.38287400"
            },
            {
                "id": 4356,
                "name": "Bratislava Region",
                "state_code": "BL",
                "latitude": "48.31183040",
                "longitude": "17.19732990"
            },
            {
                "id": 4353,
                "name": "KoÅ¡ice Region",
                "state_code": "KI",
                "latitude": "48.63757370",
                "longitude": "21.08342250"
            },
            {
                "id": 4357,
                "name": "Nitra Region",
                "state_code": "NI",
                "latitude": "48.01437650",
                "longitude": "18.54165040"
            },
            {
                "id": 4354,
                "name": "PreÅ¡ov Region",
                "state_code": "PV",
                "latitude": "49.17167730",
                "longitude": "21.37420010"
            },
            {
                "id": 4358,
                "name": "TrenÄÃ­n Region",
                "state_code": "TC",
                "latitude": "48.80867580",
                "longitude": "18.23240260"
            },
            {
                "id": 4355,
                "name": "Trnava Region",
                "state_code": "TA",
                "latitude": "48.39438980",
                "longitude": "17.72162050"
            },
            {
                "id": 4359,
                "name": "Å½ilina Region",
                "state_code": "ZI",
                "latitude": "49.20314350",
                "longitude": "19.36457330"
            }
        ]
    },
    {
        "name": "Slovenia",
        "iso3": "SVN",
        "iso2": "SI",
        "phone_code": "386",
        "capital": "Ljubljana",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".si",
        "native": "Slovenija",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Ljubljana",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¬ë¡œë² ë‹ˆì•„",
            "br": "EslovÃªnia",
            "pt": "EslovÃ©nia",
            "nl": "SloveniÃ«",
            "hr": "Slovenija",
            "fa": "Ø§Ø³Ù„ÙˆÙˆÙ†ÛŒ",
            "de": "Slowenien",
            "es": "Eslovenia",
            "fr": "SlovÃ©nie",
            "ja": "ã‚¹ãƒ­ãƒ™ãƒ‹ã‚¢",
            "it": "Slovenia",
            "cn": "æ–¯æ´›æ–‡å°¼äºš"
        },
        "latitude": "46.11666666",
        "longitude": "14.81666666",
        "emoji": "ðŸ‡¸ðŸ‡®",
        "emojiU": "U+1F1F8 U+1F1EE",
        "states": [
            {
                "id": 4183,
                "name": "AjdovÅ¡Äina Municipality",
                "state_code": "001",
                "latitude": "45.88707760",
                "longitude": "13.90428180"
            },
            {
                "id": 4326,
                "name": "Ankaran Municipality",
                "state_code": "213",
                "latitude": "45.57845100",
                "longitude": "13.73691740"
            },
            {
                "id": 4301,
                "name": "Beltinci Municipality",
                "state_code": "002",
                "latitude": "46.60791530",
                "longitude": "16.23651270"
            },
            {
                "id": 4166,
                "name": "Benedikt Municipality",
                "state_code": "148",
                "latitude": "46.61558410",
                "longitude": "15.89572810"
            },
            {
                "id": 4179,
                "name": "Bistrica ob Sotli Municipality",
                "state_code": "149",
                "latitude": "46.05655790",
                "longitude": "15.66259470"
            },
            {
                "id": 4202,
                "name": "Bled Municipality",
                "state_code": "003",
                "latitude": "46.36832660",
                "longitude": "14.11457980"
            },
            {
                "id": 4278,
                "name": "Bloke Municipality",
                "state_code": "150",
                "latitude": "45.77281410",
                "longitude": "14.50634590"
            },
            {
                "id": 4282,
                "name": "Bohinj Municipality",
                "state_code": "004",
                "latitude": "46.30056520",
                "longitude": "13.94271950"
            },
            {
                "id": 4200,
                "name": "Borovnica Municipality",
                "state_code": "005",
                "latitude": "45.90445250",
                "longitude": "14.38241890"
            },
            {
                "id": 4181,
                "name": "Bovec Municipality",
                "state_code": "006",
                "latitude": "46.33804950",
                "longitude": "13.55241740"
            },
            {
                "id": 4141,
                "name": "BraslovÄe Municipality",
                "state_code": "151",
                "latitude": "46.28361920",
                "longitude": "15.04183200"
            },
            {
                "id": 4240,
                "name": "Brda Municipality",
                "state_code": "007",
                "latitude": "45.99756520",
                "longitude": "13.52704740"
            },
            {
                "id": 4215,
                "name": "BreÅ¾ice Municipality",
                "state_code": "009",
                "latitude": "45.90410960",
                "longitude": "15.59436390"
            },
            {
                "id": 4165,
                "name": "Brezovica Municipality",
                "state_code": "008",
                "latitude": "45.95593510",
                "longitude": "14.43499520"
            },
            {
                "id": 4147,
                "name": "Cankova Municipality",
                "state_code": "152",
                "latitude": "46.71823700",
                "longitude": "16.01972220"
            },
            {
                "id": 4310,
                "name": "Cerklje na Gorenjskem Municipality",
                "state_code": "012",
                "latitude": "46.25170540",
                "longitude": "14.48579790"
            },
            {
                "id": 4162,
                "name": "Cerknica Municipality",
                "state_code": "013",
                "latitude": "45.79662550",
                "longitude": "14.39217700"
            },
            {
                "id": 4178,
                "name": "Cerkno Municipality",
                "state_code": "014",
                "latitude": "46.12884140",
                "longitude": "13.98940270"
            },
            {
                "id": 4176,
                "name": "Cerkvenjak Municipality",
                "state_code": "153",
                "latitude": "46.56707110",
                "longitude": "15.94297530"
            },
            {
                "id": 4191,
                "name": "City Municipality of Celje",
                "state_code": "011",
                "latitude": "46.23974950",
                "longitude": "15.26770630"
            },
            {
                "id": 4236,
                "name": "City Municipality of Novo Mesto",
                "state_code": "085",
                "latitude": "45.80108240",
                "longitude": "15.17100890"
            },
            {
                "id": 4151,
                "name": "ÄŒrenÅ¡ovci Municipality",
                "state_code": "015",
                "latitude": "46.57200290",
                "longitude": "16.28773460"
            },
            {
                "id": 4232,
                "name": "ÄŒrna na KoroÅ¡kem Municipality",
                "state_code": "016",
                "latitude": "46.47045290",
                "longitude": "14.84999980"
            },
            {
                "id": 4291,
                "name": "ÄŒrnomelj Municipality",
                "state_code": "017",
                "latitude": "45.53612250",
                "longitude": "15.19441430"
            },
            {
                "id": 4304,
                "name": "Destrnik Municipality",
                "state_code": "018",
                "latitude": "46.49223680",
                "longitude": "15.87779560"
            },
            {
                "id": 4167,
                "name": "DivaÄa Municipality",
                "state_code": "019",
                "latitude": "45.68060690",
                "longitude": "13.97203120"
            },
            {
                "id": 4295,
                "name": "Dobje Municipality",
                "state_code": "154",
                "latitude": "46.13700370",
                "longitude": "15.39412900"
            },
            {
                "id": 4216,
                "name": "Dobrepolje Municipality",
                "state_code": "020",
                "latitude": "45.85249510",
                "longitude": "14.70831090"
            },
            {
                "id": 4252,
                "name": "Dobrna Municipality",
                "state_code": "155",
                "latitude": "46.33561410",
                "longitude": "15.22597320"
            },
            {
                "id": 4308,
                "name": "Dobrovaâ€“Polhov Gradec Municipality",
                "state_code": "021",
                "latitude": "46.06488960",
                "longitude": "14.31681950"
            },
            {
                "id": 4189,
                "name": "Dobrovnik Municipality",
                "state_code": "156",
                "latitude": "46.65386620",
                "longitude": "16.35065940"
            },
            {
                "id": 4173,
                "name": "Dol pri Ljubljani Municipality",
                "state_code": "022",
                "latitude": "46.08843860",
                "longitude": "14.64247920"
            },
            {
                "id": 4281,
                "name": "Dolenjske Toplice Municipality",
                "state_code": "157",
                "latitude": "45.73457110",
                "longitude": "15.01294930"
            },
            {
                "id": 4159,
                "name": "DomÅ¾ale Municipality",
                "state_code": "023",
                "latitude": "46.14382690",
                "longitude": "14.63752790"
            },
            {
                "id": 4290,
                "name": "Dornava Municipality",
                "state_code": "024",
                "latitude": "46.44435130",
                "longitude": "15.98891590"
            },
            {
                "id": 4345,
                "name": "Dravograd Municipality",
                "state_code": "025",
                "latitude": "46.58921900",
                "longitude": "15.02460210"
            },
            {
                "id": 4213,
                "name": "Duplek Municipality",
                "state_code": "026",
                "latitude": "46.50100160",
                "longitude": "15.75463070"
            },
            {
                "id": 4293,
                "name": "Gorenja Vasâ€“Poljane Municipality",
                "state_code": "027",
                "latitude": "46.11165820",
                "longitude": "14.11493480"
            },
            {
                "id": 4210,
                "name": "GoriÅ¡nica Municipality",
                "state_code": "028",
                "latitude": "46.41202710",
                "longitude": "16.01330890"
            },
            {
                "id": 4284,
                "name": "Gorje Municipality",
                "state_code": "207",
                "latitude": "46.38024580",
                "longitude": "14.06853390"
            },
            {
                "id": 4343,
                "name": "Gornja Radgona Municipality",
                "state_code": "029",
                "latitude": "46.67670990",
                "longitude": "15.99108470"
            },
            {
                "id": 4339,
                "name": "Gornji Grad Municipality",
                "state_code": "030",
                "latitude": "46.29617120",
                "longitude": "14.80623470"
            },
            {
                "id": 4271,
                "name": "Gornji Petrovci Municipality",
                "state_code": "031",
                "latitude": "46.80371280",
                "longitude": "16.21913790"
            },
            {
                "id": 4217,
                "name": "Grad Municipality",
                "state_code": "158",
                "latitude": "46.80873200",
                "longitude": "16.10920600"
            },
            {
                "id": 4336,
                "name": "Grosuplje Municipality",
                "state_code": "032",
                "latitude": "45.95576450",
                "longitude": "14.65889900"
            },
            {
                "id": 4145,
                "name": "Hajdina Municipality",
                "state_code": "159",
                "latitude": "46.41850140",
                "longitude": "15.82447220"
            },
            {
                "id": 4175,
                "name": "HoÄeâ€“Slivnica Municipality",
                "state_code": "160",
                "latitude": "46.47785800",
                "longitude": "15.64760050"
            },
            {
                "id": 4327,
                "name": "HodoÅ¡ Municipality",
                "state_code": "161",
                "latitude": "46.83141340",
                "longitude": "16.32106800"
            },
            {
                "id": 4193,
                "name": "Horjul Municipality",
                "state_code": "162",
                "latitude": "46.02253780",
                "longitude": "14.29862690"
            },
            {
                "id": 4341,
                "name": "Hrastnik Municipality",
                "state_code": "034",
                "latitude": "46.14172880",
                "longitude": "15.08448940"
            },
            {
                "id": 4321,
                "name": "Hrpeljeâ€“Kozina Municipality",
                "state_code": "035",
                "latitude": "45.60911920",
                "longitude": "13.93791480"
            },
            {
                "id": 4152,
                "name": "Idrija Municipality",
                "state_code": "036",
                "latitude": "46.00409390",
                "longitude": "13.97754930"
            },
            {
                "id": 4286,
                "name": "Ig Municipality",
                "state_code": "037",
                "latitude": "45.95888680",
                "longitude": "14.52705280"
            },
            {
                "id": 4305,
                "name": "IvanÄna Gorica Municipality",
                "state_code": "039",
                "latitude": "45.93958410",
                "longitude": "14.80476260"
            },
            {
                "id": 4322,
                "name": "Izola Municipality",
                "state_code": "040",
                "latitude": "45.53135570",
                "longitude": "13.66646490"
            },
            {
                "id": 4337,
                "name": "Jesenice Municipality",
                "state_code": "041",
                "latitude": "46.43670470",
                "longitude": "14.05260570"
            },
            {
                "id": 4203,
                "name": "Jezersko Municipality",
                "state_code": "163",
                "latitude": "46.39427940",
                "longitude": "14.49855590"
            },
            {
                "id": 4266,
                "name": "JurÅ¡inci Municipality",
                "state_code": "042",
                "latitude": "46.48986510",
                "longitude": "15.98092300"
            },
            {
                "id": 4180,
                "name": "Kamnik Municipality",
                "state_code": "043",
                "latitude": "46.22216660",
                "longitude": "14.60707270"
            },
            {
                "id": 4227,
                "name": "Kanal ob SoÄi Municipality",
                "state_code": "044",
                "latitude": "46.06735300",
                "longitude": "13.62033500"
            },
            {
                "id": 4150,
                "name": "KidriÄevo Municipality",
                "state_code": "045",
                "latitude": "46.39575720",
                "longitude": "15.79259060"
            },
            {
                "id": 4243,
                "name": "Kobarid Municipality",
                "state_code": "046",
                "latitude": "46.24569710",
                "longitude": "13.57869490"
            },
            {
                "id": 4325,
                "name": "Kobilje Municipality",
                "state_code": "047",
                "latitude": "46.68518000",
                "longitude": "16.39367190"
            },
            {
                "id": 4335,
                "name": "KoÄevje Municipality",
                "state_code": "048",
                "latitude": "45.64280000",
                "longitude": "14.86158380"
            },
            {
                "id": 4315,
                "name": "Komen Municipality",
                "state_code": "049",
                "latitude": "45.81752350",
                "longitude": "13.74827110"
            },
            {
                "id": 4283,
                "name": "Komenda Municipality",
                "state_code": "164",
                "latitude": "46.20648800",
                "longitude": "14.53824990"
            },
            {
                "id": 4319,
                "name": "Koper City Municipality",
                "state_code": "050",
                "latitude": "45.54805900",
                "longitude": "13.73018770"
            },
            {
                "id": 4254,
                "name": "Kostanjevica na Krki Municipality",
                "state_code": "197",
                "latitude": "45.83166380",
                "longitude": "15.44119060"
            },
            {
                "id": 4331,
                "name": "Kostel Municipality",
                "state_code": "165",
                "latitude": "45.49282550",
                "longitude": "14.87082350"
            },
            {
                "id": 4186,
                "name": "Kozje Municipality",
                "state_code": "051",
                "latitude": "46.07332110",
                "longitude": "15.55967190"
            },
            {
                "id": 4287,
                "name": "Kranj City Municipality",
                "state_code": "052",
                "latitude": "46.25850210",
                "longitude": "14.35435690"
            },
            {
                "id": 4340,
                "name": "Kranjska Gora Municipality",
                "state_code": "053",
                "latitude": "46.48452930",
                "longitude": "13.78571450"
            },
            {
                "id": 4238,
                "name": "KriÅ¾evci Municipality",
                "state_code": "166",
                "latitude": "46.57018210",
                "longitude": "16.10926530"
            },
            {
                "id": 4197,
                "name": "Kungota",
                "state_code": "055",
                "latitude": "46.64187930",
                "longitude": "15.60362880"
            },
            {
                "id": 4211,
                "name": "Kuzma Municipality",
                "state_code": "056",
                "latitude": "46.83510380",
                "longitude": "16.08071000"
            },
            {
                "id": 4338,
                "name": "LaÅ¡ko Municipality",
                "state_code": "057",
                "latitude": "46.15422360",
                "longitude": "15.23614910"
            },
            {
                "id": 4142,
                "name": "Lenart Municipality",
                "state_code": "058",
                "latitude": "46.58344240",
                "longitude": "15.82621250"
            },
            {
                "id": 4225,
                "name": "Lendava Municipality",
                "state_code": "059",
                "latitude": "46.55134830",
                "longitude": "16.44198390"
            },
            {
                "id": 4347,
                "name": "Litija Municipality",
                "state_code": "060",
                "latitude": "46.05732260",
                "longitude": "14.83096360"
            },
            {
                "id": 4270,
                "name": "Ljubljana City Municipality",
                "state_code": "061",
                "latitude": "46.05694650",
                "longitude": "14.50575150"
            },
            {
                "id": 4294,
                "name": "Ljubno Municipality",
                "state_code": "062",
                "latitude": "46.34431250",
                "longitude": "14.83354920"
            },
            {
                "id": 4351,
                "name": "Ljutomer Municipality",
                "state_code": "063",
                "latitude": "46.51908480",
                "longitude": "16.18932160"
            },
            {
                "id": 4306,
                "name": "Logâ€“Dragomer Municipality",
                "state_code": "208",
                "latitude": "46.01787470",
                "longitude": "14.36877670"
            },
            {
                "id": 4350,
                "name": "Logatec Municipality",
                "state_code": "064",
                "latitude": "45.91761100",
                "longitude": "14.23514510"
            },
            {
                "id": 4174,
                "name": "LoÅ¡ka Dolina Municipality",
                "state_code": "065",
                "latitude": "45.64779080",
                "longitude": "14.49731470"
            },
            {
                "id": 4158,
                "name": "LoÅ¡ki Potok Municipality",
                "state_code": "066",
                "latitude": "45.69096370",
                "longitude": "14.59859700"
            },
            {
                "id": 4156,
                "name": "Lovrenc na Pohorju Municipality",
                "state_code": "167",
                "latitude": "46.54196380",
                "longitude": "15.40004430"
            },
            {
                "id": 4219,
                "name": "LuÄe Municipality",
                "state_code": "067",
                "latitude": "46.35449250",
                "longitude": "14.74715040"
            },
            {
                "id": 4302,
                "name": "Lukovica Municipality",
                "state_code": "068",
                "latitude": "46.16962930",
                "longitude": "14.69072590"
            },
            {
                "id": 4157,
                "name": "MajÅ¡perk Municipality",
                "state_code": "069",
                "latitude": "46.35030190",
                "longitude": "15.73405950"
            },
            {
                "id": 4224,
                "name": "Makole Municipality",
                "state_code": "198",
                "latitude": "46.31686970",
                "longitude": "15.66641260"
            },
            {
                "id": 4242,
                "name": "Maribor City Municipality",
                "state_code": "070",
                "latitude": "46.55064960",
                "longitude": "15.62054390"
            },
            {
                "id": 4244,
                "name": "Markovci Municipality",
                "state_code": "168",
                "latitude": "46.38793090",
                "longitude": "15.95860140"
            },
            {
                "id": 4349,
                "name": "Medvode Municipality",
                "state_code": "071",
                "latitude": "46.14190800",
                "longitude": "14.40325960"
            },
            {
                "id": 4348,
                "name": "MengeÅ¡ Municipality",
                "state_code": "072",
                "latitude": "46.16591220",
                "longitude": "14.57196940"
            },
            {
                "id": 4323,
                "name": "Metlika Municipality",
                "state_code": "073",
                "latitude": "45.64807150",
                "longitude": "15.31778380"
            },
            {
                "id": 4265,
                "name": "MeÅ¾ica Municipality",
                "state_code": "074",
                "latitude": "46.52150270",
                "longitude": "14.85213400"
            },
            {
                "id": 4223,
                "name": "MiklavÅ¾ na Dravskem Polju Municipality",
                "state_code": "169",
                "latitude": "46.50826280",
                "longitude": "15.69520650"
            },
            {
                "id": 4220,
                "name": "Mirenâ€“Kostanjevica Municipality",
                "state_code": "075",
                "latitude": "45.84360290",
                "longitude": "13.62766470"
            },
            {
                "id": 4298,
                "name": "Mirna Municipality",
                "state_code": "212",
                "latitude": "45.95156470",
                "longitude": "15.06209770"
            },
            {
                "id": 4237,
                "name": "Mirna PeÄ Municipality",
                "state_code": "170",
                "latitude": "45.84815740",
                "longitude": "15.08794500"
            },
            {
                "id": 4212,
                "name": "Mislinja Municipality",
                "state_code": "076",
                "latitude": "46.44294030",
                "longitude": "15.19876780"
            },
            {
                "id": 4297,
                "name": "Mokronogâ€“Trebelno Municipality",
                "state_code": "199",
                "latitude": "45.90885290",
                "longitude": "15.15967360"
            },
            {
                "id": 4168,
                "name": "MoravÄe Municipality",
                "state_code": "077",
                "latitude": "46.13627810",
                "longitude": "14.74600100"
            },
            {
                "id": 4218,
                "name": "Moravske Toplice Municipality",
                "state_code": "078",
                "latitude": "46.68569320",
                "longitude": "16.22245820"
            },
            {
                "id": 4190,
                "name": "Mozirje Municipality",
                "state_code": "079",
                "latitude": "46.33943500",
                "longitude": "14.96024130"
            },
            {
                "id": 4318,
                "name": "Municipality of ApaÄe",
                "state_code": "195",
                "latitude": "46.69746790",
                "longitude": "15.91025340"
            },
            {
                "id": 4309,
                "name": "Municipality of Cirkulane",
                "state_code": "196",
                "latitude": "46.32983220",
                "longitude": "15.99806660"
            },
            {
                "id": 4344,
                "name": "Municipality of Ilirska Bistrica",
                "state_code": "038",
                "latitude": "45.57913230",
                "longitude": "14.28097290"
            },
            {
                "id": 4314,
                "name": "Municipality of KrÅ¡ko",
                "state_code": "054",
                "latitude": "45.95896090",
                "longitude": "15.49235550"
            },
            {
                "id": 4187,
                "name": "Municipality of Å kofljica",
                "state_code": "123",
                "latitude": "45.98409620",
                "longitude": "14.57466260"
            },
            {
                "id": 4313,
                "name": "Murska Sobota City Municipality",
                "state_code": "080",
                "latitude": "46.64321470",
                "longitude": "16.15157540"
            },
            {
                "id": 4208,
                "name": "Muta Municipality",
                "state_code": "081",
                "latitude": "46.60973660",
                "longitude": "15.16299950"
            },
            {
                "id": 4177,
                "name": "Naklo Municipality",
                "state_code": "082",
                "latitude": "46.27186630",
                "longitude": "14.31569320"
            },
            {
                "id": 4329,
                "name": "Nazarje Municipality",
                "state_code": "083",
                "latitude": "46.28217410",
                "longitude": "14.92256290"
            },
            {
                "id": 4205,
                "name": "Nova Gorica City Municipality",
                "state_code": "084",
                "latitude": "45.97627600",
                "longitude": "13.73088810"
            },
            {
                "id": 4320,
                "name": "Odranci Municipality",
                "state_code": "086",
                "latitude": "46.59010170",
                "longitude": "16.27881650"
            },
            {
                "id": 4143,
                "name": "Oplotnica",
                "state_code": "171",
                "latitude": "46.38716300",
                "longitude": "15.44581310"
            },
            {
                "id": 4221,
                "name": "OrmoÅ¾ Municipality",
                "state_code": "087",
                "latitude": "46.43533330",
                "longitude": "16.15437400"
            },
            {
                "id": 4199,
                "name": "Osilnica Municipality",
                "state_code": "088",
                "latitude": "45.54184670",
                "longitude": "14.71563030"
            },
            {
                "id": 4172,
                "name": "Pesnica Municipality",
                "state_code": "089",
                "latitude": "46.60887550",
                "longitude": "15.67570510"
            },
            {
                "id": 4201,
                "name": "Piran Municipality",
                "state_code": "090",
                "latitude": "45.52888560",
                "longitude": "13.56807350"
            },
            {
                "id": 4184,
                "name": "Pivka Municipality",
                "state_code": "091",
                "latitude": "45.67892960",
                "longitude": "14.25426890"
            },
            {
                "id": 4146,
                "name": "PodÄetrtek Municipality",
                "state_code": "092",
                "latitude": "46.17395420",
                "longitude": "15.60138160"
            },
            {
                "id": 4161,
                "name": "Podlehnik Municipality",
                "state_code": "172",
                "latitude": "46.33107820",
                "longitude": "15.87858360"
            },
            {
                "id": 4234,
                "name": "Podvelka Municipality",
                "state_code": "093",
                "latitude": "46.62219520",
                "longitude": "15.38899220"
            },
            {
                "id": 4239,
                "name": "PoljÄane Municipality",
                "state_code": "200",
                "latitude": "46.31398530",
                "longitude": "15.57847910"
            },
            {
                "id": 4272,
                "name": "Polzela Municipality",
                "state_code": "173",
                "latitude": "46.28089700",
                "longitude": "15.07373210"
            },
            {
                "id": 4330,
                "name": "Postojna Municipality",
                "state_code": "094",
                "latitude": "45.77493900",
                "longitude": "14.21342630"
            },
            {
                "id": 4188,
                "name": "Prebold Municipality",
                "state_code": "174",
                "latitude": "46.23591360",
                "longitude": "15.09369120"
            },
            {
                "id": 4303,
                "name": "Preddvor Municipality",
                "state_code": "095",
                "latitude": "46.30171390",
                "longitude": "14.42181650"
            },
            {
                "id": 4274,
                "name": "Prevalje Municipality",
                "state_code": "175",
                "latitude": "46.56211460",
                "longitude": "14.88478610"
            },
            {
                "id": 4228,
                "name": "Ptuj City Municipality",
                "state_code": "096",
                "latitude": "46.41995350",
                "longitude": "15.86968840"
            },
            {
                "id": 4288,
                "name": "Puconci Municipality",
                "state_code": "097",
                "latitude": "46.72004180",
                "longitude": "16.09977920"
            },
            {
                "id": 4204,
                "name": "RaÄeâ€“Fram Municipality",
                "state_code": "098",
                "latitude": "46.45420830",
                "longitude": "15.63294670"
            },
            {
                "id": 4195,
                "name": "RadeÄe Municipality",
                "state_code": "099",
                "latitude": "46.06669540",
                "longitude": "15.18204380"
            },
            {
                "id": 4292,
                "name": "Radenci Municipality",
                "state_code": "100",
                "latitude": "46.62311210",
                "longitude": "16.05069030"
            },
            {
                "id": 4275,
                "name": "Radlje ob Dravi Municipality",
                "state_code": "101",
                "latitude": "46.61357320",
                "longitude": "15.23544380"
            },
            {
                "id": 4231,
                "name": "Radovljica Municipality",
                "state_code": "102",
                "latitude": "46.33558270",
                "longitude": "14.20945340"
            },
            {
                "id": 4155,
                "name": "Ravne na KoroÅ¡kem Municipality",
                "state_code": "103",
                "latitude": "46.55211940",
                "longitude": "14.95990840"
            },
            {
                "id": 4206,
                "name": "RazkriÅ¾je Municipality",
                "state_code": "176",
                "latitude": "46.52263390",
                "longitude": "16.26686380"
            },
            {
                "id": 4160,
                "name": "ReÄica ob Savinji Municipality",
                "state_code": "209",
                "latitude": "46.32337900",
                "longitude": "14.92236700"
            },
            {
                "id": 4253,
                "name": "RenÄeâ€“Vogrsko Municipality",
                "state_code": "201",
                "latitude": "45.89546170",
                "longitude": "13.67856730"
            },
            {
                "id": 4235,
                "name": "Ribnica Municipality",
                "state_code": "104",
                "latitude": "45.74003030",
                "longitude": "14.72657820"
            },
            {
                "id": 4207,
                "name": "Ribnica na Pohorju Municipality",
                "state_code": "177",
                "latitude": "46.53561450",
                "longitude": "15.26745380"
            },
            {
                "id": 4233,
                "name": "RogaÅ¡ka Slatina Municipality",
                "state_code": "106",
                "latitude": "46.24539730",
                "longitude": "15.62650140"
            },
            {
                "id": 4264,
                "name": "RogaÅ¡ovci Municipality",
                "state_code": "105",
                "latitude": "46.80557850",
                "longitude": "16.03452370"
            },
            {
                "id": 4209,
                "name": "Rogatec Municipality",
                "state_code": "107",
                "latitude": "46.22866260",
                "longitude": "15.69913380"
            },
            {
                "id": 4280,
                "name": "RuÅ¡e Municipality",
                "state_code": "108",
                "latitude": "46.52062650",
                "longitude": "15.48178690"
            },
            {
                "id": 4222,
                "name": "Å alovci Municipality",
                "state_code": "033",
                "latitude": "46.85335680",
                "longitude": "16.25917910"
            },
            {
                "id": 4230,
                "name": "Selnica ob Dravi Municipality",
                "state_code": "178",
                "latitude": "46.55139180",
                "longitude": "15.49294100"
            },
            {
                "id": 4346,
                "name": "SemiÄ Municipality",
                "state_code": "109",
                "latitude": "45.65205340",
                "longitude": "15.18207010"
            },
            {
                "id": 4317,
                "name": "Å empeterâ€“Vrtojba Municipality",
                "state_code": "183",
                "latitude": "45.92900950",
                "longitude": "13.64155940"
            },
            {
                "id": 4299,
                "name": "Å enÄur Municipality",
                "state_code": "117",
                "latitude": "46.24336990",
                "longitude": "14.41922230"
            },
            {
                "id": 4324,
                "name": "Å entilj Municipality",
                "state_code": "118",
                "latitude": "46.68628390",
                "longitude": "15.71035670"
            },
            {
                "id": 4241,
                "name": "Å entjernej Municipality",
                "state_code": "119",
                "latitude": "45.84341300",
                "longitude": "15.33783120"
            },
            {
                "id": 4171,
                "name": "Å entjur Municipality",
                "state_code": "120",
                "latitude": "46.26543390",
                "longitude": "15.40800000"
            },
            {
                "id": 4311,
                "name": "Å entrupert Municipality",
                "state_code": "211",
                "latitude": "45.98731420",
                "longitude": "15.08297830"
            },
            {
                "id": 4268,
                "name": "Sevnica Municipality",
                "state_code": "110",
                "latitude": "46.00703170",
                "longitude": "15.30456790"
            },
            {
                "id": 4149,
                "name": "SeÅ¾ana Municipality",
                "state_code": "111",
                "latitude": "45.72751090",
                "longitude": "13.86619310"
            },
            {
                "id": 4170,
                "name": "Å kocjan Municipality",
                "state_code": "121",
                "latitude": "45.91754540",
                "longitude": "15.31017360"
            },
            {
                "id": 4316,
                "name": "Å kofja Loka Municipality",
                "state_code": "122",
                "latitude": "46.14098440",
                "longitude": "14.28118730"
            },
            {
                "id": 4169,
                "name": "Slovenj Gradec City Municipality",
                "state_code": "112",
                "latitude": "46.48777180",
                "longitude": "15.07294780"
            },
            {
                "id": 4332,
                "name": "Slovenska Bistrica Municipality",
                "state_code": "113",
                "latitude": "46.39198130",
                "longitude": "15.57278690"
            },
            {
                "id": 4198,
                "name": "Slovenske Konjice Municipality",
                "state_code": "114",
                "latitude": "46.33691910",
                "longitude": "15.42147080"
            },
            {
                "id": 4285,
                "name": "Å marje pri JelÅ¡ah Municipality",
                "state_code": "124",
                "latitude": "46.22870250",
                "longitude": "15.51903530"
            },
            {
                "id": 4289,
                "name": "Å marjeÅ¡ke Toplice Municipality",
                "state_code": "206",
                "latitude": "45.86803770",
                "longitude": "15.23474220"
            },
            {
                "id": 4296,
                "name": "Å martno ob Paki Municipality",
                "state_code": "125",
                "latitude": "46.32903720",
                "longitude": "15.03339370"
            },
            {
                "id": 4279,
                "name": "Å martno pri Litiji Municipality",
                "state_code": "194",
                "latitude": "46.04549710",
                "longitude": "14.84101330"
            },
            {
                "id": 4277,
                "name": "SodraÅ¾ica Municipality",
                "state_code": "179",
                "latitude": "45.76165650",
                "longitude": "14.63528530"
            },
            {
                "id": 4261,
                "name": "SolÄava Municipality",
                "state_code": "180",
                "latitude": "46.40235260",
                "longitude": "14.68023040"
            },
            {
                "id": 4248,
                "name": "Å oÅ¡tanj Municipality",
                "state_code": "126",
                "latitude": "46.37828360",
                "longitude": "15.04613780"
            },
            {
                "id": 4263,
                "name": "SrediÅ¡Äe ob Dravi",
                "state_code": "202",
                "latitude": "46.39592820",
                "longitude": "16.27049150"
            },
            {
                "id": 4259,
                "name": "StarÅ¡e Municipality",
                "state_code": "115",
                "latitude": "46.46743310",
                "longitude": "15.76405460"
            },
            {
                "id": 4185,
                "name": "Å tore Municipality",
                "state_code": "127",
                "latitude": "46.22225140",
                "longitude": "15.31261160"
            },
            {
                "id": 4333,
                "name": "StraÅ¾a Municipality",
                "state_code": "203",
                "latitude": "45.77684280",
                "longitude": "15.09486940"
            },
            {
                "id": 4164,
                "name": "Sveta Ana Municipality",
                "state_code": "181",
                "latitude": "46.65000000",
                "longitude": "15.84527800"
            },
            {
                "id": 4260,
                "name": "Sveta Trojica v Slovenskih Goricah Municipality",
                "state_code": "204",
                "latitude": "46.56808090",
                "longitude": "15.88230640"
            },
            {
                "id": 4229,
                "name": "Sveti AndraÅ¾ v Slovenskih Goricah Municipality",
                "state_code": "182",
                "latitude": "46.51897470",
                "longitude": "15.94982620"
            },
            {
                "id": 4255,
                "name": "Sveti Jurij ob Å Äavnici Municipality",
                "state_code": "116",
                "latitude": "46.56874520",
                "longitude": "16.02225280"
            },
            {
                "id": 4328,
                "name": "Sveti Jurij v Slovenskih Goricah Municipality",
                "state_code": "210",
                "latitude": "46.61707910",
                "longitude": "15.78046770"
            },
            {
                "id": 4273,
                "name": "Sveti TomaÅ¾ Municipality",
                "state_code": "205",
                "latitude": "46.48352830",
                "longitude": "16.07944200"
            },
            {
                "id": 4194,
                "name": "Tabor Municipality",
                "state_code": "184",
                "latitude": "46.21079210",
                "longitude": "15.01742490"
            },
            {
                "id": 4312,
                "name": "TiÅ¡ina Municipality",
                "state_code": "010",
                "latitude": "46.65418840",
                "longitude": "16.07547810"
            },
            {
                "id": 4247,
                "name": "Tolmin Municipality",
                "state_code": "128",
                "latitude": "46.18571880",
                "longitude": "13.73198380"
            },
            {
                "id": 4246,
                "name": "Trbovlje Municipality",
                "state_code": "129",
                "latitude": "46.15035630",
                "longitude": "15.04531370"
            },
            {
                "id": 4214,
                "name": "Trebnje Municipality",
                "state_code": "130",
                "latitude": "45.90801630",
                "longitude": "15.01319050"
            },
            {
                "id": 4153,
                "name": "Trnovska Vas Municipality",
                "state_code": "185",
                "latitude": "46.52940350",
                "longitude": "15.88531180"
            },
            {
                "id": 4250,
                "name": "TrÅ¾iÄ Municipality",
                "state_code": "131",
                "latitude": "46.35935140",
                "longitude": "14.30066230"
            },
            {
                "id": 4334,
                "name": "Trzin Municipality",
                "state_code": "186",
                "latitude": "46.12982410",
                "longitude": "14.55776370"
            },
            {
                "id": 4251,
                "name": "TurniÅ¡Äe Municipality",
                "state_code": "132",
                "latitude": "46.61375040",
                "longitude": "16.32021000"
            },
            {
                "id": 4267,
                "name": "Velika Polana Municipality",
                "state_code": "187",
                "latitude": "46.57317150",
                "longitude": "16.34441260"
            },
            {
                "id": 4144,
                "name": "Velike LaÅ¡Äe Municipality",
                "state_code": "134",
                "latitude": "45.83365910",
                "longitude": "14.63623630"
            },
            {
                "id": 4257,
                "name": "VerÅ¾ej Municipality",
                "state_code": "188",
                "latitude": "46.58411350",
                "longitude": "16.16208000"
            },
            {
                "id": 4300,
                "name": "Videm Municipality",
                "state_code": "135",
                "latitude": "46.36383300",
                "longitude": "15.87812120"
            },
            {
                "id": 4196,
                "name": "Vipava Municipality",
                "state_code": "136",
                "latitude": "45.84126740",
                "longitude": "13.96096130"
            },
            {
                "id": 4148,
                "name": "Vitanje Municipality",
                "state_code": "137",
                "latitude": "46.38153230",
                "longitude": "15.29506870"
            },
            {
                "id": 4154,
                "name": "Vodice Municipality",
                "state_code": "138",
                "latitude": "46.18966430",
                "longitude": "14.49385390"
            },
            {
                "id": 4245,
                "name": "Vojnik Municipality",
                "state_code": "139",
                "latitude": "46.29205810",
                "longitude": "15.30205800"
            },
            {
                "id": 4163,
                "name": "Vransko Municipality",
                "state_code": "189",
                "latitude": "46.23900600",
                "longitude": "14.95272490"
            },
            {
                "id": 4262,
                "name": "Vrhnika Municipality",
                "state_code": "140",
                "latitude": "45.95027190",
                "longitude": "14.32764220"
            },
            {
                "id": 4226,
                "name": "Vuzenica Municipality",
                "state_code": "141",
                "latitude": "46.59808360",
                "longitude": "15.16572370"
            },
            {
                "id": 4269,
                "name": "Zagorje ob Savi Municipality",
                "state_code": "142",
                "latitude": "46.13452020",
                "longitude": "14.99643840"
            },
            {
                "id": 4258,
                "name": "Å½alec Municipality",
                "state_code": "190",
                "latitude": "46.25197120",
                "longitude": "15.16500720"
            },
            {
                "id": 4182,
                "name": "ZavrÄ Municipality",
                "state_code": "143",
                "latitude": "46.35713000",
                "longitude": "16.04777470"
            },
            {
                "id": 4256,
                "name": "Å½elezniki Municipality",
                "state_code": "146",
                "latitude": "46.22563770",
                "longitude": "14.16936170"
            },
            {
                "id": 4249,
                "name": "Å½etale Municipality",
                "state_code": "191",
                "latitude": "46.27428330",
                "longitude": "15.79133590"
            },
            {
                "id": 4192,
                "name": "Å½iri Municipality",
                "state_code": "147",
                "latitude": "46.04724990",
                "longitude": "14.10984510"
            },
            {
                "id": 4276,
                "name": "Å½irovnica Municipality",
                "state_code": "192",
                "latitude": "46.39544030",
                "longitude": "14.15396320"
            },
            {
                "id": 4342,
                "name": "ZreÄe Municipality",
                "state_code": "144",
                "latitude": "46.41777860",
                "longitude": "15.37094310"
            },
            {
                "id": 4307,
                "name": "Å½uÅ¾emberk Municipality",
                "state_code": "193",
                "latitude": "45.82003500",
                "longitude": "14.95359190"
            }
        ]
    },
    {
        "name": "Solomon Islands",
        "iso3": "SLB",
        "iso2": "SB",
        "phone_code": "677",
        "capital": "Honiara",
        "currency": "SBD",
        "currency_symbol": "Si$",
        "tld": ".sb",
        "native": "Solomon Islands",
        "region": "Oceania",
        "subregion": "Melanesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Guadalcanal",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "SBT",
                "tzName": "Solomon Islands Time"
            }
        ],
        "translations": {
            "kr": "ì†”ë¡œëª¬ ì œë„",
            "br": "Ilhas SalomÃ£o",
            "pt": "Ilhas SalomÃ£o",
            "nl": "Salomonseilanden",
            "hr": "Solomonski Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ø³Ù„ÛŒÙ…Ø§Ù†",
            "de": "Salomonen",
            "es": "Islas SalomÃ³n",
            "fr": "ÃŽles Salomon",
            "ja": "ã‚½ãƒ­ãƒ¢ãƒ³è«¸å³¶",
            "it": "Isole Salomone",
            "cn": "æ‰€ç½—é—¨ç¾¤å²›"
        },
        "latitude": "-8.00000000",
        "longitude": "159.00000000",
        "emoji": "ðŸ‡¸ðŸ‡§",
        "emojiU": "U+1F1F8 U+1F1E7",
        "states": [
            {
                "id": 4784,
                "name": "Central Province",
                "state_code": "CE",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 4781,
                "name": "Choiseul Province",
                "state_code": "CH",
                "latitude": "-7.05014940",
                "longitude": "156.95114590"
            },
            {
                "id": 4785,
                "name": "Guadalcanal Province",
                "state_code": "GU",
                "latitude": "-9.57732840",
                "longitude": "160.14558050"
            },
            {
                "id": 4778,
                "name": "Honiara",
                "state_code": "CT",
                "latitude": "-9.44563810",
                "longitude": "159.97289990"
            },
            {
                "id": 4780,
                "name": "Isabel Province",
                "state_code": "IS",
                "latitude": "-8.05923530",
                "longitude": "159.14470810"
            },
            {
                "id": 4782,
                "name": "Makira-Ulawa Province",
                "state_code": "MK",
                "latitude": "-10.57374470",
                "longitude": "161.80969410"
            },
            {
                "id": 4783,
                "name": "Malaita Province",
                "state_code": "ML",
                "latitude": "-8.94461680",
                "longitude": "160.90712360"
            },
            {
                "id": 4787,
                "name": "Rennell and Bellona Province",
                "state_code": "RB",
                "latitude": "-11.61314350",
                "longitude": "160.16939490"
            },
            {
                "id": 4779,
                "name": "Temotu Province",
                "state_code": "TE",
                "latitude": "-10.68692900",
                "longitude": "166.06239790"
            },
            {
                "id": 4786,
                "name": "Western Province",
                "state_code": "WE",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Somalia",
        "iso3": "SOM",
        "iso2": "SO",
        "phone_code": "252",
        "capital": "Mogadishu",
        "currency": "SOS",
        "currency_symbol": "Sh.so.",
        "tld": ".so",
        "native": "Soomaaliya",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Mogadishu",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ì†Œë§ë¦¬ì•„",
            "br": "SomÃ¡lia",
            "pt": "SomÃ¡lia",
            "nl": "SomaliÃ«",
            "hr": "Somalija",
            "fa": "Ø³ÙˆÙ…Ø§Ù„ÛŒ",
            "de": "Somalia",
            "es": "Somalia",
            "fr": "Somalie",
            "ja": "ã‚½ãƒžãƒªã‚¢",
            "it": "Somalia",
            "cn": "ç´¢é©¬é‡Œ"
        },
        "latitude": "10.00000000",
        "longitude": "49.00000000",
        "emoji": "ðŸ‡¸ðŸ‡´",
        "emojiU": "U+1F1F8 U+1F1F4",
        "states": [
            {
                "id": 925,
                "name": "Awdal Region",
                "state_code": "AW",
                "latitude": "10.63342850",
                "longitude": "43.32946600"
            },
            {
                "id": 917,
                "name": "Bakool",
                "state_code": "BK",
                "latitude": "4.36572210",
                "longitude": "44.09603110"
            },
            {
                "id": 927,
                "name": "Banaadir",
                "state_code": "BN",
                "latitude": "2.11873750",
                "longitude": "45.33694590"
            },
            {
                "id": 930,
                "name": "Bari",
                "state_code": "BR",
                "latitude": "41.11714320",
                "longitude": "16.87187150"
            },
            {
                "id": 926,
                "name": "Bay",
                "state_code": "BY",
                "latitude": "37.03655340",
                "longitude": "-95.61747670"
            },
            {
                "id": 918,
                "name": "Galguduud",
                "state_code": "GA",
                "latitude": "5.18501280",
                "longitude": "46.82528380"
            },
            {
                "id": 928,
                "name": "Gedo",
                "state_code": "GE",
                "latitude": "3.50392270",
                "longitude": "42.23624350"
            },
            {
                "id": 915,
                "name": "Hiran",
                "state_code": "HI",
                "latitude": "4.32101500",
                "longitude": "45.29938620"
            },
            {
                "id": 924,
                "name": "Lower Juba",
                "state_code": "JH",
                "latitude": "0.22402100",
                "longitude": "41.60118140"
            },
            {
                "id": 921,
                "name": "Lower Shebelle",
                "state_code": "SH",
                "latitude": "1.87664580",
                "longitude": "44.24790150"
            },
            {
                "id": 922,
                "name": "Middle Juba",
                "state_code": "JD",
                "latitude": "2.07804880",
                "longitude": "41.60118140"
            },
            {
                "id": 923,
                "name": "Middle Shebelle",
                "state_code": "SD",
                "latitude": "2.92502470",
                "longitude": "45.90396890"
            },
            {
                "id": 916,
                "name": "Mudug",
                "state_code": "MU",
                "latitude": "6.56567260",
                "longitude": "47.76375650"
            },
            {
                "id": 920,
                "name": "Nugal",
                "state_code": "NU",
                "latitude": "43.27938610",
                "longitude": "17.03392050"
            },
            {
                "id": 919,
                "name": "Sanaag Region",
                "state_code": "SA",
                "latitude": "10.39382180",
                "longitude": "47.76375650"
            },
            {
                "id": 929,
                "name": "Togdheer Region",
                "state_code": "TO",
                "latitude": "9.44605870",
                "longitude": "45.29938620"
            }
        ]
    },
    {
        "name": "South Africa",
        "iso3": "ZAF",
        "iso2": "ZA",
        "phone_code": "27",
        "capital": "Pretoria",
        "currency": "ZAR",
        "currency_symbol": "R",
        "tld": ".za",
        "native": "South Africa",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Johannesburg",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "kr": "ë‚¨ì•„í”„ë¦¬ì¹´ ê³µí™”êµ­",
            "br": "RepÃºblica Sul-Africana",
            "pt": "RepÃºblica Sul-Africana",
            "nl": "Zuid-Afrika",
            "hr": "JuÅ¾noafriÄka Republika",
            "fa": "Ø¢ÙØ±ÛŒÙ‚Ø§ÛŒ Ø¬Ù†ÙˆØ¨ÛŒ",
            "de": "Republik SÃ¼dafrika",
            "es": "RepÃºblica de SudÃ¡frica",
            "fr": "Afrique du Sud",
            "ja": "å—ã‚¢ãƒ•ãƒªã‚«",
            "it": "Sud Africa",
            "cn": "å—éž"
        },
        "latitude": "-29.00000000",
        "longitude": "24.00000000",
        "emoji": "ðŸ‡¿ðŸ‡¦",
        "emojiU": "U+1F1FF U+1F1E6",
        "states": [
            {
                "id": 938,
                "name": "Eastern Cape",
                "state_code": "EC",
                "latitude": "-32.29684020",
                "longitude": "26.41938900"
            },
            {
                "id": 932,
                "name": "Free State",
                "state_code": "FS",
                "latitude": "37.68585250",
                "longitude": "-97.28112560"
            },
            {
                "id": 936,
                "name": "Gauteng",
                "state_code": "GP",
                "latitude": "-26.27075930",
                "longitude": "28.11226790"
            },
            {
                "id": 935,
                "name": "KwaZulu-Natal",
                "state_code": "KZN",
                "latitude": "-28.53055390",
                "longitude": "30.89582420"
            },
            {
                "id": 933,
                "name": "Limpopo",
                "state_code": "LP",
                "latitude": "-23.40129460",
                "longitude": "29.41793240"
            },
            {
                "id": 937,
                "name": "Mpumalanga",
                "state_code": "MP",
                "latitude": "-25.56533600",
                "longitude": "30.52790960"
            },
            {
                "id": 934,
                "name": "North West",
                "state_code": "NW",
                "latitude": "32.75885200",
                "longitude": "-97.32880600"
            },
            {
                "id": 931,
                "name": "Northern Cape",
                "state_code": "NC",
                "latitude": "-29.04668080",
                "longitude": "21.85685860"
            },
            {
                "id": 939,
                "name": "Western Cape",
                "state_code": "WC",
                "latitude": "-33.22779180",
                "longitude": "21.85685860"
            }
        ]
    },
    {
        "name": "South Georgia",
        "iso3": "SGS",
        "iso2": "GS",
        "phone_code": "",
        "capital": "Grytviken",
        "currency": "GBP",
        "currency_symbol": "Â£",
        "tld": ".gs",
        "native": "South Georgia",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "Atlantic\/South_Georgia",
                "gmtOffset": -7200,
                "gmtOffsetName": "UTC-02:00",
                "abbreviation": "GST",
                "tzName": "South Georgia and the South Sandwich Islands Time"
            }
        ],
        "translations": {
            "kr": "ì‚¬ìš°ìŠ¤ì¡°ì§€ì•„",
            "br": "Ilhas GeÃ³rgias do Sul e Sandwich do Sul",
            "pt": "Ilhas GeÃ³rgia do Sul e SanduÃ­che do Sul",
            "nl": "Zuid-Georgia en Zuidelijke Sandwicheilanden",
            "hr": "JuÅ¾na Georgija i otoÄje JuÅ¾ni Sandwich",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ø¬ÙˆØ±Ø¬ÛŒØ§ÛŒ Ø¬Ù†ÙˆØ¨ÛŒ Ùˆ Ø³Ø§Ù†Ø¯ÙˆÛŒÚ† Ø¬Ù†ÙˆØ¨ÛŒ",
            "de": "SÃ¼dgeorgien und die SÃ¼dlichen Sandwichinseln",
            "es": "Islas Georgias del Sur y Sandwich del Sur",
            "fr": "GÃ©orgie du Sud-et-les ÃŽles Sandwich du Sud",
            "ja": "ã‚µã‚¦ã‚¹ã‚¸ãƒ§ãƒ¼ã‚¸ã‚¢ãƒ»ã‚µã‚¦ã‚¹ã‚µãƒ³ãƒ‰ã‚¦ã‚£ãƒƒãƒè«¸å³¶",
            "it": "Georgia del Sud e Isole Sandwich Meridionali",
            "cn": "å—ä¹”æ²»äºš"
        },
        "latitude": "-54.50000000",
        "longitude": "-37.00000000",
        "emoji": "ðŸ‡¬ðŸ‡¸",
        "emojiU": "U+1F1EC U+1F1F8",
        "states": []
    },
    {
        "name": "South Sudan",
        "iso3": "SSD",
        "iso2": "SS",
        "phone_code": "211",
        "capital": "Juba",
        "currency": "SSP",
        "currency_symbol": "Â£",
        "tld": ".ss",
        "native": "South Sudan",
        "region": "Africa",
        "subregion": "Middle Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Juba",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ë‚¨ìˆ˜ë‹¨",
            "br": "SudÃ£o do Sul",
            "pt": "SudÃ£o do Sul",
            "nl": "Zuid-Soedan",
            "hr": "JuÅ¾ni Sudan",
            "fa": "Ø³ÙˆØ¯Ø§Ù† Ø¬Ù†ÙˆØ¨ÛŒ",
            "de": "SÃ¼dsudan",
            "es": "SudÃ¡n del Sur",
            "fr": "Soudan du Sud",
            "ja": "å—ã‚¹ãƒ¼ãƒ€ãƒ³",
            "it": "Sudan del sud",
            "cn": "å—è‹ä¸¹"
        },
        "latitude": "7.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡¸ðŸ‡¸",
        "emojiU": "U+1F1F8 U+1F1F8",
        "states": [
            {
                "id": 2092,
                "name": "Central Equatoria",
                "state_code": "EC",
                "latitude": "4.61440630",
                "longitude": "31.26263660"
            },
            {
                "id": 2093,
                "name": "Eastern Equatoria",
                "state_code": "EE",
                "latitude": "5.06929950",
                "longitude": "33.43835300"
            },
            {
                "id": 2094,
                "name": "Jonglei State",
                "state_code": "JG",
                "latitude": "7.18196190",
                "longitude": "32.35609520"
            },
            {
                "id": 2090,
                "name": "Lakes",
                "state_code": "LK",
                "latitude": "37.16282550",
                "longitude": "-95.69116230"
            },
            {
                "id": 2088,
                "name": "Northern Bahr el Ghazal",
                "state_code": "BN",
                "latitude": "8.53604490",
                "longitude": "26.79678490"
            },
            {
                "id": 2085,
                "name": "Unity",
                "state_code": "UY",
                "latitude": "37.78712760",
                "longitude": "-122.40340790"
            },
            {
                "id": 2086,
                "name": "Upper Nile",
                "state_code": "NU",
                "latitude": "9.88942020",
                "longitude": "32.71813750"
            },
            {
                "id": 2087,
                "name": "Warrap",
                "state_code": "WR",
                "latitude": "8.08862380",
                "longitude": "28.64106410"
            },
            {
                "id": 2091,
                "name": "Western Bahr el Ghazal",
                "state_code": "BW",
                "latitude": "8.64523990",
                "longitude": "25.28375850"
            },
            {
                "id": 2089,
                "name": "Western Equatoria",
                "state_code": "EW",
                "latitude": "5.34717990",
                "longitude": "28.29943500"
            }
        ]
    },
    {
        "name": "Spain",
        "iso3": "ESP",
        "iso2": "ES",
        "phone_code": "34",
        "capital": "Madrid",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".es",
        "native": "EspaÃ±a",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Africa\/Ceuta",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            },
            {
                "zoneName": "Atlantic\/Canary",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "WET",
                "tzName": "Western European Time"
            },
            {
                "zoneName": "Europe\/Madrid",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¤íŽ˜ì¸",
            "br": "Espanha",
            "pt": "Espanha",
            "nl": "Spanje",
            "hr": "Å panjolska",
            "fa": "Ø§Ø³Ù¾Ø§Ù†ÛŒØ§",
            "de": "Spanien",
            "es": "EspaÃ±a",
            "fr": "Espagne",
            "ja": "ã‚¹ãƒšã‚¤ãƒ³",
            "it": "Spagna",
            "cn": "è¥¿ç­ç‰™"
        },
        "latitude": "40.00000000",
        "longitude": "-4.00000000",
        "emoji": "ðŸ‡ªðŸ‡¸",
        "emojiU": "U+1F1EA U+1F1F8",
        "states": [
            {
                "id": 1193,
                "name": "Andalusia",
                "state_code": "AN",
                "latitude": "37.54427060",
                "longitude": "-4.72775280"
            },
            {
                "id": 1177,
                "name": "Aragon",
                "state_code": "AR",
                "latitude": "41.59762750",
                "longitude": "-0.90566230"
            },
            {
                "id": 1160,
                "name": "Asturias",
                "state_code": "AS",
                "latitude": "43.36139530",
                "longitude": "-5.85932670"
            },
            {
                "id": 1189,
                "name": "Ãvila",
                "state_code": "AV",
                "latitude": "40.69345110",
                "longitude": "-4.89356270"
            },
            {
                "id": 1174,
                "name": "Balearic Islands",
                "state_code": "PM",
                "latitude": "39.35877590",
                "longitude": "2.73563280"
            },
            {
                "id": 1191,
                "name": "Basque Country",
                "state_code": "PV",
                "latitude": "42.98962480",
                "longitude": "-2.61892730"
            },
            {
                "id": 1146,
                "name": "Burgos Province",
                "state_code": "BU",
                "latitude": "42.33807580",
                "longitude": "-3.58126920"
            },
            {
                "id": 1185,
                "name": "Canary Islands",
                "state_code": "CN",
                "latitude": "28.29156370",
                "longitude": "-16.62913040"
            },
            {
                "id": 1170,
                "name": "Cantabria",
                "state_code": "CB",
                "latitude": "43.18283960",
                "longitude": "-3.98784270"
            },
            {
                "id": 1184,
                "name": "Castile and LeÃ³n",
                "state_code": "CL",
                "latitude": "41.83568210",
                "longitude": "-4.39763570"
            },
            {
                "id": 1205,
                "name": "Castilla La Mancha",
                "state_code": "CM",
                "latitude": "39.27956070",
                "longitude": "-3.09770200"
            },
            {
                "id": 1203,
                "name": "Catalonia",
                "state_code": "CT",
                "latitude": "41.59115890",
                "longitude": "1.52086240"
            },
            {
                "id": 1206,
                "name": "Ceuta",
                "state_code": "CE",
                "latitude": "35.88938740",
                "longitude": "-5.32134550"
            },
            {
                "id": 1190,
                "name": "Extremadura",
                "state_code": "EX",
                "latitude": "39.49373920",
                "longitude": "-6.06791940"
            },
            {
                "id": 1167,
                "name": "Galicia",
                "state_code": "GA",
                "latitude": "42.57505540",
                "longitude": "-8.13385580"
            },
            {
                "id": 1171,
                "name": "La Rioja",
                "state_code": "RI",
                "latitude": "42.28707330",
                "longitude": "-2.53960300"
            },
            {
                "id": 1200,
                "name": "LÃ©on",
                "state_code": "LE",
                "latitude": "42.59870410",
                "longitude": "-5.56708390"
            },
            {
                "id": 1158,
                "name": "Madrid",
                "state_code": "MD",
                "latitude": "40.41675150",
                "longitude": "-3.70383220"
            },
            {
                "id": 1159,
                "name": "Melilla",
                "state_code": "ML",
                "latitude": "35.29227750",
                "longitude": "-2.93809730"
            },
            {
                "id": 1176,
                "name": "Murcia",
                "state_code": "MC",
                "latitude": "38.13981410",
                "longitude": "-1.36621600"
            },
            {
                "id": 1204,
                "name": "Navarra",
                "state_code": "NC",
                "latitude": "42.69539090",
                "longitude": "-1.67606910"
            },
            {
                "id": 1157,
                "name": "Palencia Province",
                "state_code": "P",
                "latitude": "42.00968320",
                "longitude": "-4.52879490"
            },
            {
                "id": 1147,
                "name": "Salamanca Province",
                "state_code": "SA",
                "latitude": "40.95152630",
                "longitude": "-6.23759470"
            },
            {
                "id": 1192,
                "name": "Segovia Province",
                "state_code": "SG",
                "latitude": "40.94292960",
                "longitude": "-4.10889420"
            },
            {
                "id": 1208,
                "name": "Soria Province",
                "state_code": "SO",
                "latitude": "41.76654640",
                "longitude": "-2.47903060"
            },
            {
                "id": 1175,
                "name": "Valencia",
                "state_code": "VC",
                "latitude": "39.48401080",
                "longitude": "-0.75328090"
            },
            {
                "id": 1183,
                "name": "Valladolid Province",
                "state_code": "VA",
                "latitude": "41.65173750",
                "longitude": "-4.72449500"
            },
            {
                "id": 1161,
                "name": "Zamora Province",
                "state_code": "ZA",
                "latitude": "41.60957440",
                "longitude": "-5.89871390"
            }
        ]
    },
    {
        "name": "Sri Lanka",
        "iso3": "LKA",
        "iso2": "LK",
        "phone_code": "94",
        "capital": "Colombo",
        "currency": "LKR",
        "currency_symbol": "Rs",
        "tld": ".lk",
        "native": "Å›rÄ« laá¹ƒkÄva",
        "region": "Asia",
        "subregion": "Southern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Colombo",
                "gmtOffset": 19800,
                "gmtOffsetName": "UTC+05:30",
                "abbreviation": "IST",
                "tzName": "Indian Standard Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¤ë¦¬ëž‘ì¹´",
            "br": "Sri Lanka",
            "pt": "Sri Lanka",
            "nl": "Sri Lanka",
            "hr": "Å ri Lanka",
            "fa": "Ø³Ø±ÛŒâ€ŒÙ„Ø§Ù†Ú©Ø§",
            "de": "Sri Lanka",
            "es": "Sri Lanka",
            "fr": "Sri Lanka",
            "ja": "ã‚¹ãƒªãƒ©ãƒ³ã‚«",
            "it": "Sri Lanka",
            "cn": "æ–¯é‡Œå…°å¡"
        },
        "latitude": "7.00000000",
        "longitude": "81.00000000",
        "emoji": "ðŸ‡±ðŸ‡°",
        "emojiU": "U+1F1F1 U+1F1F0",
        "states": [
            {
                "id": 2799,
                "name": "Ampara District",
                "state_code": "52",
                "latitude": "7.29116850",
                "longitude": "81.67237610"
            },
            {
                "id": 2816,
                "name": "Anuradhapura District",
                "state_code": "71",
                "latitude": "8.33183050",
                "longitude": "80.40290170"
            },
            {
                "id": 2790,
                "name": "Badulla District",
                "state_code": "81",
                "latitude": "6.99340090",
                "longitude": "81.05498150"
            },
            {
                "id": 2818,
                "name": "Batticaloa District",
                "state_code": "51",
                "latitude": "7.82927810",
                "longitude": "81.47183870"
            },
            {
                "id": 2798,
                "name": "Central Province",
                "state_code": "2",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2815,
                "name": "Colombo District",
                "state_code": "11",
                "latitude": "6.92695570",
                "longitude": "79.86173060"
            },
            {
                "id": 2808,
                "name": "Eastern Province",
                "state_code": "5",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2792,
                "name": "Galle District",
                "state_code": "31",
                "latitude": "6.05774900",
                "longitude": "80.21755720"
            },
            {
                "id": 2804,
                "name": "Gampaha District",
                "state_code": "12",
                "latitude": "7.07126190",
                "longitude": "80.00877460"
            },
            {
                "id": 2791,
                "name": "Hambantota District",
                "state_code": "33",
                "latitude": "6.15358160",
                "longitude": "81.12714900"
            },
            {
                "id": 2787,
                "name": "Jaffna District",
                "state_code": "41",
                "latitude": "9.69304680",
                "longitude": "80.16518540"
            },
            {
                "id": 2789,
                "name": "Kalutara District",
                "state_code": "13",
                "latitude": "6.60846860",
                "longitude": "80.14285840"
            },
            {
                "id": 2788,
                "name": "Kandy District",
                "state_code": "21",
                "latitude": "7.29315880",
                "longitude": "80.63501070"
            },
            {
                "id": 2797,
                "name": "Kegalle District",
                "state_code": "92",
                "latitude": "7.12040530",
                "longitude": "80.32131060"
            },
            {
                "id": 2793,
                "name": "Kilinochchi District",
                "state_code": "42",
                "latitude": "9.36779710",
                "longitude": "80.32131060"
            },
            {
                "id": 2805,
                "name": "Mannar District",
                "state_code": "43",
                "latitude": "8.98095310",
                "longitude": "79.90439750"
            },
            {
                "id": 2810,
                "name": "Matale District",
                "state_code": "22",
                "latitude": "7.46596460",
                "longitude": "80.62342590"
            },
            {
                "id": 2806,
                "name": "Matara District",
                "state_code": "32",
                "latitude": "5.94493480",
                "longitude": "80.54879970"
            },
            {
                "id": 2819,
                "name": "Monaragala District",
                "state_code": "82",
                "latitude": "6.87277810",
                "longitude": "81.35068320"
            },
            {
                "id": 2814,
                "name": "Mullaitivu District",
                "state_code": "45",
                "latitude": "9.26753880",
                "longitude": "80.81282540"
            },
            {
                "id": 2800,
                "name": "North Central Province",
                "state_code": "7",
                "latitude": "8.19956380",
                "longitude": "80.63269160"
            },
            {
                "id": 2817,
                "name": "North Western Province",
                "state_code": "6",
                "latitude": "7.75840910",
                "longitude": "80.18750650"
            },
            {
                "id": 2813,
                "name": "Northern Province",
                "state_code": "4",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2794,
                "name": "Nuwara Eliya District",
                "state_code": "23",
                "latitude": "6.96065320",
                "longitude": "80.76927580"
            },
            {
                "id": 2812,
                "name": "Polonnaruwa District",
                "state_code": "72",
                "latitude": "7.93955670",
                "longitude": "81.00034030"
            },
            {
                "id": 2796,
                "name": "Puttalam District",
                "state_code": "62",
                "latitude": "8.02599150",
                "longitude": "79.84712720"
            },
            {
                "id": 2807,
                "name": "Ratnapura district",
                "state_code": "91",
                "latitude": "6.70551680",
                "longitude": "80.38483890"
            },
            {
                "id": 2803,
                "name": "Sabaragamuwa Province",
                "state_code": "9",
                "latitude": "6.73959410",
                "longitude": "80.36586500"
            },
            {
                "id": 2801,
                "name": "Southern Province",
                "state_code": "3",
                "latitude": null,
                "longitude": null
            },
            {
                "id": 2795,
                "name": "Trincomalee District",
                "state_code": "53",
                "latitude": "8.60130690",
                "longitude": "81.11960750"
            },
            {
                "id": 2811,
                "name": "Uva Province",
                "state_code": "8",
                "latitude": "6.84276120",
                "longitude": "81.33994140"
            },
            {
                "id": 2809,
                "name": "Vavuniya District",
                "state_code": "44",
                "latitude": "8.75947390",
                "longitude": "80.50003340"
            },
            {
                "id": 2802,
                "name": "Western Province",
                "state_code": "1",
                "latitude": null,
                "longitude": null
            }
        ]
    },
    {
        "name": "Sudan",
        "iso3": "SDN",
        "iso2": "SD",
        "phone_code": "249",
        "capital": "Khartoum",
        "currency": "SDG",
        "currency_symbol": ".Ø³.Ø¬",
        "tld": ".sd",
        "native": "Ø§Ù„Ø³ÙˆØ¯Ø§Ù†",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Khartoum",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EAT",
                "tzName": "Eastern African Time"
            }
        ],
        "translations": {
            "kr": "ìˆ˜ë‹¨",
            "br": "SudÃ£o",
            "pt": "SudÃ£o",
            "nl": "Soedan",
            "hr": "Sudan",
            "fa": "Ø³ÙˆØ¯Ø§Ù†",
            "de": "Sudan",
            "es": "SudÃ¡n",
            "fr": "Soudan",
            "ja": "ã‚¹ãƒ¼ãƒ€ãƒ³",
            "it": "Sudan",
            "cn": "è‹ä¸¹"
        },
        "latitude": "15.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡¸ðŸ‡©",
        "emojiU": "U+1F1F8 U+1F1E9",
        "states": [
            {
                "id": 885,
                "name": "Al Jazirah",
                "state_code": "GZ",
                "latitude": "14.88596110",
                "longitude": "33.43835300"
            },
            {
                "id": 886,
                "name": "Al Qadarif",
                "state_code": "GD",
                "latitude": "14.02430700",
                "longitude": "35.36856790"
            },
            {
                "id": 887,
                "name": "Blue Nile",
                "state_code": "NB",
                "latitude": "47.59867300",
                "longitude": "-122.33441900"
            },
            {
                "id": 896,
                "name": "Central Darfur",
                "state_code": "DC",
                "latitude": "14.37827470",
                "longitude": "24.90422080"
            },
            {
                "id": 892,
                "name": "East Darfur",
                "state_code": "DE",
                "latitude": "14.37827470",
                "longitude": "24.90422080"
            },
            {
                "id": 884,
                "name": "Kassala",
                "state_code": "KA",
                "latitude": "15.45813320",
                "longitude": "36.40396290"
            },
            {
                "id": 881,
                "name": "Khartoum",
                "state_code": "KH",
                "latitude": "15.50065440",
                "longitude": "32.55989940"
            },
            {
                "id": 890,
                "name": "North Darfur",
                "state_code": "DN",
                "latitude": "15.76619690",
                "longitude": "24.90422080"
            },
            {
                "id": 893,
                "name": "North Kordofan",
                "state_code": "KN",
                "latitude": "13.83064410",
                "longitude": "29.41793240"
            },
            {
                "id": 895,
                "name": "Northern",
                "state_code": "NO",
                "latitude": "38.06381700",
                "longitude": "-84.46286480"
            },
            {
                "id": 880,
                "name": "Red Sea",
                "state_code": "RS",
                "latitude": "20.28023200",
                "longitude": "38.51257300"
            },
            {
                "id": 891,
                "name": "River Nile",
                "state_code": "NR",
                "latitude": "23.97275950",
                "longitude": "32.87492060"
            },
            {
                "id": 882,
                "name": "Sennar",
                "state_code": "SI",
                "latitude": "13.56746900",
                "longitude": "33.56720450"
            },
            {
                "id": 894,
                "name": "South Darfur",
                "state_code": "DS",
                "latitude": "11.64886390",
                "longitude": "24.90422080"
            },
            {
                "id": 883,
                "name": "South Kordofan",
                "state_code": "KS",
                "latitude": "11.19901920",
                "longitude": "29.41793240"
            },
            {
                "id": 888,
                "name": "West Darfur",
                "state_code": "DW",
                "latitude": "12.84635610",
                "longitude": "23.00119890"
            },
            {
                "id": 889,
                "name": "West Kordofan",
                "state_code": "GK",
                "latitude": "11.19901920",
                "longitude": "29.41793240"
            },
            {
                "id": 879,
                "name": "White Nile",
                "state_code": "NW",
                "latitude": "9.33215160",
                "longitude": "31.46153000"
            }
        ]
    },
    {
        "name": "Suriname",
        "iso3": "SUR",
        "iso2": "SR",
        "phone_code": "597",
        "capital": "Paramaribo",
        "currency": "SRD",
        "currency_symbol": "$",
        "tld": ".sr",
        "native": "Suriname",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Paramaribo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "SRT",
                "tzName": "Suriname Time"
            }
        ],
        "translations": {
            "kr": "ìˆ˜ë¦¬ë‚¨",
            "br": "Suriname",
            "pt": "Suriname",
            "nl": "Suriname",
            "hr": "Surinam",
            "fa": "Ø³ÙˆØ±ÛŒÙ†Ø§Ù…",
            "de": "Suriname",
            "es": "Surinam",
            "fr": "Surinam",
            "ja": "ã‚¹ãƒªãƒŠãƒ ",
            "it": "Suriname",
            "cn": "è‹é‡Œå—"
        },
        "latitude": "4.00000000",
        "longitude": "-56.00000000",
        "emoji": "ðŸ‡¸ðŸ‡·",
        "emojiU": "U+1F1F8 U+1F1F7",
        "states": [
            {
                "id": 2846,
                "name": "Brokopondo District",
                "state_code": "BR",
                "latitude": "4.77102470",
                "longitude": "-55.04933750"
            },
            {
                "id": 2839,
                "name": "Commewijne District",
                "state_code": "CM",
                "latitude": "5.74021100",
                "longitude": "-54.87312190"
            },
            {
                "id": 2842,
                "name": "Coronie District",
                "state_code": "CR",
                "latitude": "5.69432710",
                "longitude": "-56.29293810"
            },
            {
                "id": 2845,
                "name": "Marowijne District",
                "state_code": "MA",
                "latitude": "5.62681280",
                "longitude": "-54.25931180"
            },
            {
                "id": 2840,
                "name": "Nickerie District",
                "state_code": "NI",
                "latitude": "5.58554690",
                "longitude": "-56.83111170"
            },
            {
                "id": 2841,
                "name": "Para District",
                "state_code": "PR",
                "latitude": "5.48173180",
                "longitude": "-55.22592070"
            },
            {
                "id": 2843,
                "name": "Paramaribo District",
                "state_code": "PM",
                "latitude": "5.85203550",
                "longitude": "-55.20382780"
            },
            {
                "id": 2848,
                "name": "Saramacca District",
                "state_code": "SA",
                "latitude": "5.72408130",
                "longitude": "-55.66896360"
            },
            {
                "id": 2847,
                "name": "Sipaliwini District",
                "state_code": "SI",
                "latitude": "3.65673820",
                "longitude": "-56.20353870"
            },
            {
                "id": 2844,
                "name": "Wanica District",
                "state_code": "WA",
                "latitude": "5.73237620",
                "longitude": "-55.27012350"
            }
        ]
    },
    {
        "name": "Svalbard And Jan Mayen Islands",
        "iso3": "SJM",
        "iso2": "SJ",
        "phone_code": "47",
        "capital": "Longyearbyen",
        "currency": "NOK",
        "currency_symbol": "kr",
        "tld": ".sj",
        "native": "Svalbard og Jan Mayen",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Arctic\/Longyearbyen",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¤ë°œë°”ë¥´ ì–€ë§ˆì˜Œ ì œë„",
            "br": "Svalbard",
            "pt": "Svalbard",
            "nl": "Svalbard en Jan Mayen",
            "hr": "Svalbard i Jan Mayen",
            "fa": "Ø³ÙˆØ§Ù„Ø¨Ø§Ø±Ø¯ Ùˆ ÛŒØ§Ù† Ù…Ø§ÛŒÙ†",
            "de": "Svalbard und Jan Mayen",
            "es": "Islas Svalbard y Jan Mayen",
            "fr": "Svalbard et Jan Mayen",
            "ja": "ã‚¹ãƒ´ã‚¡ãƒ¼ãƒ«ãƒãƒ«è«¸å³¶ãŠã‚ˆã³ãƒ¤ãƒ³ãƒžã‚¤ã‚¨ãƒ³å³¶",
            "it": "Svalbard e Jan Mayen",
            "cn": "æ–¯ç“¦å°”å·´å’Œæ‰¬é©¬å»¶ç¾¤å²›"
        },
        "latitude": "78.00000000",
        "longitude": "20.00000000",
        "emoji": "ðŸ‡¸ðŸ‡¯",
        "emojiU": "U+1F1F8 U+1F1EF",
        "states": []
    },
    {
        "name": "Swaziland",
        "iso3": "SWZ",
        "iso2": "SZ",
        "phone_code": "268",
        "capital": "Mbabane",
        "currency": "SZL",
        "currency_symbol": "E",
        "tld": ".sz",
        "native": "Swaziland",
        "region": "Africa",
        "subregion": "Southern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Mbabane",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "SAST",
                "tzName": "South African Standard Time"
            }
        ],
        "translations": {
            "kr": "ì—ìŠ¤ì™€í‹°ë‹ˆ",
            "br": "SuazilÃ¢ndia",
            "pt": "SuazilÃ¢ndia",
            "nl": "Swaziland",
            "hr": "Svazi",
            "fa": "Ø³ÙˆØ§Ø²ÛŒÙ„Ù†Ø¯",
            "de": "Swasiland",
            "es": "Suazilandia",
            "fr": "Swaziland",
            "ja": "ã‚¹ãƒ¯ã‚¸ãƒ©ãƒ³ãƒ‰",
            "it": "Swaziland",
            "cn": "æ–¯å¨å£«å…°"
        },
        "latitude": "-26.50000000",
        "longitude": "31.50000000",
        "emoji": "ðŸ‡¸ðŸ‡¿",
        "emojiU": "U+1F1F8 U+1F1FF",
        "states": [
            {
                "id": 969,
                "name": "Hhohho District",
                "state_code": "HH",
                "latitude": "-26.13656620",
                "longitude": "31.35416310"
            },
            {
                "id": 970,
                "name": "Lubombo District",
                "state_code": "LU",
                "latitude": "-26.78517730",
                "longitude": "31.81070790"
            },
            {
                "id": 968,
                "name": "Manzini District",
                "state_code": "MA",
                "latitude": "-26.50819990",
                "longitude": "31.37131640"
            },
            {
                "id": 971,
                "name": "Shiselweni District",
                "state_code": "SH",
                "latitude": "-26.98275770",
                "longitude": "31.35416310"
            }
        ]
    },
    {
        "name": "Sweden",
        "iso3": "SWE",
        "iso2": "SE",
        "phone_code": "46",
        "capital": "Stockholm",
        "currency": "SEK",
        "currency_symbol": "kr",
        "tld": ".se",
        "native": "Sverige",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Stockholm",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¤ì›¨ë´",
            "br": "SuÃ©cia",
            "pt": "SuÃ©cia",
            "nl": "Zweden",
            "hr": "Å vedska",
            "fa": "Ø³ÙˆØ¦Ø¯",
            "de": "Schweden",
            "es": "Suecia",
            "fr": "SuÃ¨de",
            "ja": "ã‚¹ã‚¦ã‚§ãƒ¼ãƒ‡ãƒ³",
            "it": "Svezia",
            "cn": "ç‘žå…¸"
        },
        "latitude": "62.00000000",
        "longitude": "15.00000000",
        "emoji": "ðŸ‡¸ðŸ‡ª",
        "emojiU": "U+1F1F8 U+1F1EA",
        "states": [
            {
                "id": 1537,
                "name": "Blekinge",
                "state_code": "K",
                "latitude": "56.27838370",
                "longitude": "15.01800580"
            },
            {
                "id": 1534,
                "name": "Dalarna County",
                "state_code": "W",
                "latitude": "61.09170120",
                "longitude": "14.66636530"
            },
            {
                "id": 1533,
                "name": "GÃ¤vleborg County",
                "state_code": "X",
                "latitude": "61.30119930",
                "longitude": "16.15342140"
            },
            {
                "id": 1546,
                "name": "Gotland County",
                "state_code": "I",
                "latitude": "57.46841210",
                "longitude": "18.48674470"
            },
            {
                "id": 1548,
                "name": "Halland County",
                "state_code": "N",
                "latitude": "56.89668050",
                "longitude": "12.80339930"
            },
            {
                "id": 1550,
                "name": "JÃ¶nkÃ¶ping County",
                "state_code": "F",
                "latitude": "57.37084340",
                "longitude": "14.34391740"
            },
            {
                "id": 1544,
                "name": "Kalmar County",
                "state_code": "H",
                "latitude": "57.23501560",
                "longitude": "16.18493490"
            },
            {
                "id": 1542,
                "name": "Kronoberg County",
                "state_code": "G",
                "latitude": "56.71834030",
                "longitude": "14.41146730"
            },
            {
                "id": 1538,
                "name": "Norrbotten County",
                "state_code": "BD",
                "latitude": "66.83092160",
                "longitude": "20.39919660"
            },
            {
                "id": 1539,
                "name": "Ã–rebro County",
                "state_code": "T",
                "latitude": "59.53503600",
                "longitude": "15.00657310"
            },
            {
                "id": 1536,
                "name": "Ã–stergÃ¶tland County",
                "state_code": "E",
                "latitude": "58.34536350",
                "longitude": "15.51978440"
            },
            {
                "id": 1541,
                "name": "SkÃ¥ne County",
                "state_code": "M",
                "latitude": "55.99025720",
                "longitude": "13.59576920"
            },
            {
                "id": 1540,
                "name": "SÃ¶dermanland County",
                "state_code": "D",
                "latitude": "59.03363490",
                "longitude": "16.75188990"
            },
            {
                "id": 1551,
                "name": "Stockholm County",
                "state_code": "AB",
                "latitude": "59.60249580",
                "longitude": "18.13843830"
            },
            {
                "id": 1545,
                "name": "Uppsala County",
                "state_code": "C",
                "latitude": "60.00922620",
                "longitude": "17.27145880"
            },
            {
                "id": 1535,
                "name": "VÃ¤rmland County",
                "state_code": "S",
                "latitude": "59.72940650",
                "longitude": "13.23540240"
            },
            {
                "id": 1543,
                "name": "VÃ¤sterbotten County",
                "state_code": "AC",
                "latitude": "65.33373110",
                "longitude": "16.51616940"
            },
            {
                "id": 1552,
                "name": "VÃ¤sternorrland County",
                "state_code": "Y",
                "latitude": "63.42764730",
                "longitude": "17.72924440"
            },
            {
                "id": 1549,
                "name": "VÃ¤stmanland County",
                "state_code": "U",
                "latitude": "59.67138790",
                "longitude": "16.21589530"
            },
            {
                "id": 1547,
                "name": "VÃ¤stra GÃ¶taland County",
                "state_code": "O",
                "latitude": "58.25279260",
                "longitude": "13.05964250"
            }
        ]
    },
    {
        "name": "Switzerland",
        "iso3": "CHE",
        "iso2": "CH",
        "phone_code": "41",
        "capital": "Bern",
        "currency": "CHF",
        "currency_symbol": "CHf",
        "tld": ".ch",
        "native": "Schweiz",
        "region": "Europe",
        "subregion": "Western Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Zurich",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ìŠ¤ìœ„ìŠ¤",
            "br": "SuÃ­Ã§a",
            "pt": "SuÃ­Ã§a",
            "nl": "Zwitserland",
            "hr": "Å vicarska",
            "fa": "Ø³ÙˆØ¦ÛŒØ³",
            "de": "Schweiz",
            "es": "Suiza",
            "fr": "Suisse",
            "ja": "ã‚¹ã‚¤ã‚¹",
            "it": "Svizzera",
            "cn": "ç‘žå£«"
        },
        "latitude": "47.00000000",
        "longitude": "8.00000000",
        "emoji": "ðŸ‡¨ðŸ‡­",
        "emojiU": "U+1F1E8 U+1F1ED",
        "states": [
            {
                "id": 1639,
                "name": "Aargau",
                "state_code": "AG",
                "latitude": "47.38766640",
                "longitude": "8.25542950"
            },
            {
                "id": 1655,
                "name": "Appenzell Ausserrhoden",
                "state_code": "AR",
                "latitude": "47.36648100",
                "longitude": "9.30009160"
            },
            {
                "id": 1649,
                "name": "Appenzell Innerrhoden",
                "state_code": "AI",
                "latitude": "47.31619250",
                "longitude": "9.43165730"
            },
            {
                "id": 1641,
                "name": "Basel-Landschaft",
                "state_code": "BL",
                "latitude": "47.44181220",
                "longitude": "7.76440020"
            },
            {
                "id": 1645,
                "name": "canton of Bern",
                "state_code": "BE",
                "latitude": "46.79886210",
                "longitude": "7.70807010"
            },
            {
                "id": 1640,
                "name": "Canton of Fribourg",
                "state_code": "FR",
                "latitude": "46.68167480",
                "longitude": "7.11726350"
            },
            {
                "id": 1647,
                "name": "Canton of Geneva",
                "state_code": "GE",
                "latitude": "46.21800730",
                "longitude": "6.12169250"
            },
            {
                "id": 1658,
                "name": "Canton of Jura",
                "state_code": "JU",
                "latitude": "47.34444740",
                "longitude": "7.14306080"
            },
            {
                "id": 1663,
                "name": "Canton of Lucerne",
                "state_code": "LU",
                "latitude": "47.07956710",
                "longitude": "8.16624450"
            },
            {
                "id": 1659,
                "name": "Canton of NeuchÃ¢tel",
                "state_code": "NE",
                "latitude": "46.98998740",
                "longitude": "6.92927320"
            },
            {
                "id": 1654,
                "name": "Canton of Schaffhausen",
                "state_code": "SH",
                "latitude": "47.70093640",
                "longitude": "8.56800400"
            },
            {
                "id": 1662,
                "name": "Canton of Solothurn",
                "state_code": "SO",
                "latitude": "47.33207170",
                "longitude": "7.63883850"
            },
            {
                "id": 1644,
                "name": "Canton of St. Gallen",
                "state_code": "SG",
                "latitude": "47.14562540",
                "longitude": "9.35043320"
            },
            {
                "id": 1648,
                "name": "Canton of Valais",
                "state_code": "VS",
                "latitude": "46.19046140",
                "longitude": "7.54492260"
            },
            {
                "id": 1651,
                "name": "Canton of Vaud",
                "state_code": "VD",
                "latitude": "46.56131350",
                "longitude": "6.53676500"
            },
            {
                "id": 1646,
                "name": "Canton of Zug",
                "state_code": "ZG",
                "latitude": "47.16615050",
                "longitude": "8.51547490"
            },
            {
                "id": 1656,
                "name": "canton of ZÃ¼rich",
                "state_code": "ZH",
                "latitude": "47.35953600",
                "longitude": "8.63564520"
            },
            {
                "id": 1661,
                "name": "Glarus",
                "state_code": "GL",
                "latitude": "47.04112320",
                "longitude": "9.06790000"
            },
            {
                "id": 1660,
                "name": "GraubÃ¼nden",
                "state_code": "GR",
                "latitude": "46.65698710",
                "longitude": "9.57802570"
            },
            {
                "id": 1652,
                "name": "Nidwalden",
                "state_code": "NW",
                "latitude": "46.92670160",
                "longitude": "8.38499820"
            },
            {
                "id": 1650,
                "name": "Obwalden",
                "state_code": "OW",
                "latitude": "46.87785800",
                "longitude": "8.25124900"
            },
            {
                "id": 1653,
                "name": "Schwyz",
                "state_code": "SZ",
                "latitude": "47.02071380",
                "longitude": "8.65298840"
            },
            {
                "id": 1657,
                "name": "Thurgau",
                "state_code": "TG",
                "latitude": "47.60378560",
                "longitude": "9.05573710"
            },
            {
                "id": 1643,
                "name": "Ticino",
                "state_code": "TI",
                "latitude": "46.33173400",
                "longitude": "8.80045290"
            },
            {
                "id": 1642,
                "name": "Uri",
                "state_code": "UR",
                "latitude": "41.48606470",
                "longitude": "-71.53085370"
            }
        ]
    },
    {
        "name": "Syria",
        "iso3": "SYR",
        "iso2": "SY",
        "phone_code": "963",
        "capital": "Damascus",
        "currency": "SYP",
        "currency_symbol": "LS",
        "tld": ".sy",
        "native": "Ø³ÙˆØ±ÙŠØ§",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Damascus",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ì‹œë¦¬ì•„",
            "br": "SÃ­ria",
            "pt": "SÃ­ria",
            "nl": "SyriÃ«",
            "hr": "Sirija",
            "fa": "Ø³ÙˆØ±ÛŒÙ‡",
            "de": "Syrien",
            "es": "Siria",
            "fr": "Syrie",
            "ja": "ã‚·ãƒªã‚¢ãƒ»ã‚¢ãƒ©ãƒ–å…±å’Œå›½",
            "it": "Siria",
            "cn": "å™åˆ©äºš"
        },
        "latitude": "35.00000000",
        "longitude": "38.00000000",
        "emoji": "ðŸ‡¸ðŸ‡¾",
        "emojiU": "U+1F1F8 U+1F1FE",
        "states": [
            {
                "id": 2941,
                "name": "Al-Hasakah Governorate",
                "state_code": "HA",
                "latitude": "36.40551500",
                "longitude": "40.79691490"
            },
            {
                "id": 2944,
                "name": "Al-Raqqah Governorate",
                "state_code": "RA",
                "latitude": "35.95941060",
                "longitude": "38.99810520"
            },
            {
                "id": 2946,
                "name": "Aleppo Governorate",
                "state_code": "HL",
                "latitude": "36.22623930",
                "longitude": "37.46813960"
            },
            {
                "id": 2936,
                "name": "As-Suwayda Governorate",
                "state_code": "SU",
                "latitude": "32.79891560",
                "longitude": "36.78195050"
            },
            {
                "id": 2939,
                "name": "Damascus Governorate",
                "state_code": "DI",
                "latitude": "33.51514440",
                "longitude": "36.39313540"
            },
            {
                "id": 2945,
                "name": "Daraa Governorate",
                "state_code": "DR",
                "latitude": "32.92488130",
                "longitude": "36.17626150"
            },
            {
                "id": 2937,
                "name": "Deir ez-Zor Governorate",
                "state_code": "DY",
                "latitude": "35.28797980",
                "longitude": "40.30886260"
            },
            {
                "id": 2934,
                "name": "Hama Governorate",
                "state_code": "HM",
                "latitude": "35.18878650",
                "longitude": "37.21158290"
            },
            {
                "id": 2942,
                "name": "Homs Governorate",
                "state_code": "HI",
                "latitude": "34.25671230",
                "longitude": "38.31657250"
            },
            {
                "id": 2940,
                "name": "Idlib Governorate",
                "state_code": "ID",
                "latitude": "35.82687980",
                "longitude": "36.69572160"
            },
            {
                "id": 2938,
                "name": "Latakia Governorate",
                "state_code": "LA",
                "latitude": "35.61297910",
                "longitude": "36.00232250"
            },
            {
                "id": 2943,
                "name": "Quneitra Governorate",
                "state_code": "QU",
                "latitude": "33.07763180",
                "longitude": "35.89341360"
            },
            {
                "id": 2935,
                "name": "Rif Dimashq Governorate",
                "state_code": "RD",
                "latitude": "33.51672890",
                "longitude": "36.95410700"
            },
            {
                "id": 2947,
                "name": "Tartus Governorate",
                "state_code": "TA",
                "latitude": "35.00066520",
                "longitude": "36.00232250"
            }
        ]
    },
    {
        "name": "Taiwan",
        "iso3": "TWN",
        "iso2": "TW",
        "phone_code": "886",
        "capital": "Taipei",
        "currency": "TWD",
        "currency_symbol": "$",
        "tld": ".tw",
        "native": "è‡ºç£",
        "region": "Asia",
        "subregion": "Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Taipei",
                "gmtOffset": 28800,
                "gmtOffsetName": "UTC+08:00",
                "abbreviation": "CST",
                "tzName": "China Standard Time"
            }
        ],
        "translations": {
            "kr": "ëŒ€ë§Œ",
            "br": "Taiwan",
            "pt": "Taiwan",
            "nl": "Taiwan",
            "hr": "Tajvan",
            "fa": "ØªØ§ÛŒÙˆØ§Ù†",
            "de": "Taiwan",
            "es": "TaiwÃ¡n",
            "fr": "TaÃ¯wan",
            "ja": "å°æ¹¾ï¼ˆä¸­è¯æ°‘å›½ï¼‰",
            "it": "Taiwan",
            "cn": "ä¸­å›½å°æ¹¾"
        },
        "latitude": "23.50000000",
        "longitude": "121.00000000",
        "emoji": "ðŸ‡¹ðŸ‡¼",
        "emojiU": "U+1F1F9 U+1F1FC",
        "states": [
            {
                "id": 3404,
                "name": "Changhua County",
                "state_code": "CHA",
                "latitude": "24.05179630",
                "longitude": "120.51613520"
            },
            {
                "id": 3418,
                "name": "Chiayi City",
                "state_code": "CYQ",
                "latitude": "23.48007510",
                "longitude": "120.44911130"
            },
            {
                "id": 3408,
                "name": "Chiayi County",
                "state_code": "CYI",
                "latitude": "23.45184280",
                "longitude": "120.25546150"
            },
            {
                "id": 3417,
                "name": "Hsinchu",
                "state_code": "HSZ",
                "latitude": "24.81382870",
                "longitude": "120.96747980"
            },
            {
                "id": 3423,
                "name": "Hsinchu County",
                "state_code": "HSQ",
                "latitude": "24.83872260",
                "longitude": "121.01772460"
            },
            {
                "id": 3411,
                "name": "Hualien County",
                "state_code": "HUA",
                "latitude": "23.98715890",
                "longitude": "121.60157140"
            },
            {
                "id": 3412,
                "name": "Kaohsiung",
                "state_code": "KHH",
                "latitude": "22.62727840",
                "longitude": "120.30143530"
            },
            {
                "id": 3409,
                "name": "Kaohsiung County",
                "state_code": "KHQ",
                "latitude": "22.62727840",
                "longitude": "120.30143530"
            },
            {
                "id": 3415,
                "name": "Kinmen",
                "state_code": "KIN",
                "latitude": "24.34877920",
                "longitude": "118.32856440"
            },
            {
                "id": 3420,
                "name": "Lienchiang County",
                "state_code": "LIE",
                "latitude": "26.15055560",
                "longitude": "119.92888890"
            },
            {
                "id": 3413,
                "name": "Miaoli County",
                "state_code": "MIA",
                "latitude": "24.56015900",
                "longitude": "120.82142650"
            },
            {
                "id": 3407,
                "name": "Nantou County",
                "state_code": "NAN",
                "latitude": "23.96099810",
                "longitude": "120.97186380"
            },
            {
                "id": 3403,
                "name": "Penghu County",
                "state_code": "PEN",
                "latitude": "23.57118990",
                "longitude": "119.57931570"
            },
            {
                "id": 3405,
                "name": "Pingtung County",
                "state_code": "PIF",
                "latitude": "22.55197590",
                "longitude": "120.54875970"
            },
            {
                "id": 3406,
                "name": "Taichung",
                "state_code": "TXG",
                "latitude": "24.14773580",
                "longitude": "120.67364820"
            },
            {
                "id": 3414,
                "name": "Taichung County",
                "state_code": "TXQ",
                "latitude": "24.14773580",
                "longitude": "120.67364820"
            },
            {
                "id": 3421,
                "name": "Tainan",
                "state_code": "TNN",
                "latitude": "22.99972810",
                "longitude": "120.22702770"
            },
            {
                "id": 3401,
                "name": "Tainan County",
                "state_code": "TNQ",
                "latitude": "22.99972810",
                "longitude": "120.22702770"
            },
            {
                "id": 3422,
                "name": "Taipei",
                "state_code": "TPE",
                "latitude": "25.03296940",
                "longitude": "121.56541770"
            },
            {
                "id": 3410,
                "name": "Taitung County",
                "state_code": "TTT",
                "latitude": "22.79724470",
                "longitude": "121.07137020"
            },
            {
                "id": 3419,
                "name": "Taoyuan City",
                "state_code": "TAO",
                "latitude": "24.99362810",
                "longitude": "121.30097980"
            },
            {
                "id": 3402,
                "name": "Yilan County",
                "state_code": "ILA",
                "latitude": "24.70210730",
                "longitude": "121.73775020"
            },
            {
                "id": 3416,
                "name": "Yunlin County",
                "state_code": "YUN",
                "latitude": "23.70920330",
                "longitude": "120.43133730"
            }
        ]
    },
    {
        "name": "Tajikistan",
        "iso3": "TJK",
        "iso2": "TJ",
        "phone_code": "992",
        "capital": "Dushanbe",
        "currency": "TJS",
        "currency_symbol": "SM",
        "tld": ".tj",
        "native": "Ð¢Ð¾Ò·Ð¸ÐºÐ¸ÑÑ‚Ð¾Ð½",
        "region": "Asia",
        "subregion": "Central Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Dushanbe",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TJT",
                "tzName": "Tajikistan Time"
            }
        ],
        "translations": {
            "kr": "íƒ€ì§€í‚¤ìŠ¤íƒ„",
            "br": "TajiquistÃ£o",
            "pt": "TajiquistÃ£o",
            "nl": "Tadzjikistan",
            "hr": "TaÄ‘ikistan",
            "fa": "ØªØ§Ø¬ÛŒÚ©Ø³ØªØ§Ù†",
            "de": "Tadschikistan",
            "es": "TayikistÃ¡n",
            "fr": "Tadjikistan",
            "ja": "ã‚¿ã‚¸ã‚­ã‚¹ã‚¿ãƒ³",
            "it": "Tagikistan",
            "cn": "å¡”å‰å…‹æ–¯å¦"
        },
        "latitude": "39.00000000",
        "longitude": "71.00000000",
        "emoji": "ðŸ‡¹ðŸ‡¯",
        "emojiU": "U+1F1F9 U+1F1EF",
        "states": [
            {
                "id": 3397,
                "name": "districts of Republican Subordination",
                "state_code": "RA",
                "latitude": "39.08579020",
                "longitude": "70.24083250"
            },
            {
                "id": 3399,
                "name": "Gorno-Badakhshan Autonomous Province",
                "state_code": "GB",
                "latitude": "38.41273200",
                "longitude": "73.08774900"
            },
            {
                "id": 3398,
                "name": "Khatlon Province",
                "state_code": "KT",
                "latitude": "37.91135620",
                "longitude": "69.09702300"
            },
            {
                "id": 3400,
                "name": "Sughd Province",
                "state_code": "SU",
                "latitude": "39.51553260",
                "longitude": "69.09702300"
            }
        ]
    },
    {
        "name": "Tanzania",
        "iso3": "TZA",
        "iso2": "TZ",
        "phone_code": "255",
        "capital": "Dodoma",
        "currency": "TZS",
        "currency_symbol": "TSh",
        "tld": ".tz",
        "native": "Tanzania",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Dar_es_Salaam",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "íƒ„ìžë‹ˆì•„",
            "br": "TanzÃ¢nia",
            "pt": "TanzÃ¢nia",
            "nl": "Tanzania",
            "hr": "Tanzanija",
            "fa": "ØªØ§Ù†Ø²Ø§Ù†ÛŒØ§",
            "de": "Tansania",
            "es": "Tanzania",
            "fr": "Tanzanie",
            "ja": "ã‚¿ãƒ³ã‚¶ãƒ‹ã‚¢",
            "it": "Tanzania",
            "cn": "å¦æ¡‘å°¼äºš"
        },
        "latitude": "-6.00000000",
        "longitude": "35.00000000",
        "emoji": "ðŸ‡¹ðŸ‡¿",
        "emojiU": "U+1F1F9 U+1F1FF",
        "states": [
            {
                "id": 1491,
                "name": "Arusha Region",
                "state_code": "01",
                "latitude": "-3.38692540",
                "longitude": "36.68299270"
            },
            {
                "id": 1490,
                "name": "Dar es Salaam Region",
                "state_code": "02",
                "latitude": "-6.79235400",
                "longitude": "39.20832840"
            },
            {
                "id": 1466,
                "name": "Dodoma Region",
                "state_code": "03",
                "latitude": "-6.57382280",
                "longitude": "36.26308460"
            },
            {
                "id": 1481,
                "name": "Geita Region",
                "state_code": "27",
                "latitude": "-2.82422570",
                "longitude": "32.26538870"
            },
            {
                "id": 1489,
                "name": "Iringa Region",
                "state_code": "04",
                "latitude": "-7.78874420",
                "longitude": "35.56578620"
            },
            {
                "id": 1465,
                "name": "Kagera Region",
                "state_code": "05",
                "latitude": "-1.30011150",
                "longitude": "31.26263660"
            },
            {
                "id": 1482,
                "name": "Katavi Region",
                "state_code": "28",
                "latitude": "-6.36771250",
                "longitude": "31.26263660"
            },
            {
                "id": 1478,
                "name": "Kigoma Region",
                "state_code": "08",
                "latitude": "-4.88240920",
                "longitude": "29.66150550"
            },
            {
                "id": 1467,
                "name": "Kilimanjaro Region",
                "state_code": "09",
                "latitude": "-4.13369270",
                "longitude": "37.80876930"
            },
            {
                "id": 1483,
                "name": "Lindi Region",
                "state_code": "12",
                "latitude": "-9.23433940",
                "longitude": "38.31657250"
            },
            {
                "id": 1484,
                "name": "Manyara Region",
                "state_code": "26",
                "latitude": "-4.31500580",
                "longitude": "36.95410700"
            },
            {
                "id": 1468,
                "name": "Mara Region",
                "state_code": "13",
                "latitude": "-1.77535380",
                "longitude": "34.15319470"
            },
            {
                "id": 1470,
                "name": "Morogoro Region",
                "state_code": "16",
                "latitude": "-8.81371730",
                "longitude": "36.95410700"
            },
            {
                "id": 1476,
                "name": "Mtwara Region",
                "state_code": "17",
                "latitude": "-10.33984550",
                "longitude": "40.16574660"
            },
            {
                "id": 1479,
                "name": "Mwanza Region",
                "state_code": "18",
                "latitude": "-2.46711970",
                "longitude": "32.89868120"
            },
            {
                "id": 1480,
                "name": "Njombe Region",
                "state_code": "29",
                "latitude": "-9.24226320",
                "longitude": "35.12687810"
            },
            {
                "id": 1488,
                "name": "North Pemba Region",
                "state_code": "06",
                "latitude": "-5.03193520",
                "longitude": "39.77555710"
            },
            {
                "id": 1485,
                "name": "Pwani Region",
                "state_code": "19",
                "latitude": "-7.32377140",
                "longitude": "38.82054540"
            },
            {
                "id": 1477,
                "name": "Rukwa Region",
                "state_code": "20",
                "latitude": "-8.01094440",
                "longitude": "31.44561790"
            },
            {
                "id": 1486,
                "name": "Ruvuma Region",
                "state_code": "21",
                "latitude": "-10.68787170",
                "longitude": "36.26308460"
            },
            {
                "id": 1463,
                "name": "Shinyanga Region",
                "state_code": "22",
                "latitude": "-3.68099610",
                "longitude": "33.42714030"
            },
            {
                "id": 1464,
                "name": "Simiyu Region",
                "state_code": "30",
                "latitude": "-2.83087380",
                "longitude": "34.15319470"
            },
            {
                "id": 1474,
                "name": "Singida Region",
                "state_code": "23",
                "latitude": "-6.74533520",
                "longitude": "34.15319470"
            },
            {
                "id": 1472,
                "name": "South Pemba Region",
                "state_code": "10",
                "latitude": "-5.31469610",
                "longitude": "39.75495110"
            },
            {
                "id": 1469,
                "name": "Tabora Region",
                "state_code": "24",
                "latitude": "-5.03421380",
                "longitude": "32.80844960"
            },
            {
                "id": 1487,
                "name": "Tanga Region",
                "state_code": "25",
                "latitude": "-5.30497890",
                "longitude": "38.31657250"
            },
            {
                "id": 1471,
                "name": "Zanzibar Central\/South Region",
                "state_code": "11",
                "latitude": "-6.26428510",
                "longitude": "39.44502810"
            },
            {
                "id": 1473,
                "name": "Zanzibar North Region",
                "state_code": "07",
                "latitude": "-5.93950930",
                "longitude": "39.27910110"
            },
            {
                "id": 1475,
                "name": "Zanzibar Urban\/West Region",
                "state_code": "15",
                "latitude": "-6.22981360",
                "longitude": "39.25832930"
            }
        ]
    },
    {
        "name": "Thailand",
        "iso3": "THA",
        "iso2": "TH",
        "phone_code": "66",
        "capital": "Bangkok",
        "currency": "THB",
        "currency_symbol": "à¸¿",
        "tld": ".th",
        "native": "à¸›à¸£à¸°à¹€à¸—à¸¨à¹„à¸—à¸¢",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Bangkok",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "kr": "íƒœêµ­",
            "br": "TailÃ¢ndia",
            "pt": "TailÃ¢ndia",
            "nl": "Thailand",
            "hr": "Tajland",
            "fa": "ØªØ§ÛŒÙ„Ù†Ø¯",
            "de": "Thailand",
            "es": "Tailandia",
            "fr": "ThaÃ¯lande",
            "ja": "ã‚¿ã‚¤",
            "it": "Tailandia",
            "cn": "æ³°å›½"
        },
        "latitude": "15.00000000",
        "longitude": "100.00000000",
        "emoji": "ðŸ‡¹ðŸ‡­",
        "emojiU": "U+1F1F9 U+1F1ED",
        "states": [
            {
                "id": 3523,
                "name": "Amnat Charoen",
                "state_code": "37",
                "latitude": "15.86567830",
                "longitude": "104.62577740"
            },
            {
                "id": 3519,
                "name": "Ang Thong",
                "state_code": "15",
                "latitude": "14.58960540",
                "longitude": "100.45505200"
            },
            {
                "id": 3554,
                "name": "Bangkok",
                "state_code": "10",
                "latitude": "13.75633090",
                "longitude": "100.50176510"
            },
            {
                "id": 3533,
                "name": "Bueng Kan",
                "state_code": "38",
                "latitude": "18.36091040",
                "longitude": "103.64644630"
            },
            {
                "id": 3534,
                "name": "Buri Ram",
                "state_code": "31",
                "latitude": "14.99510030",
                "longitude": "103.11159150"
            },
            {
                "id": 3552,
                "name": "Chachoengsao",
                "state_code": "24",
                "latitude": "13.69041940",
                "longitude": "101.07795960"
            },
            {
                "id": 3522,
                "name": "Chai Nat",
                "state_code": "18",
                "latitude": "15.18519710",
                "longitude": "100.12512500"
            },
            {
                "id": 3486,
                "name": "Chanthaburi",
                "state_code": "22",
                "latitude": "12.61124850",
                "longitude": "102.10378060"
            },
            {
                "id": 3491,
                "name": "Chiang Mai",
                "state_code": "50",
                "latitude": "18.78834390",
                "longitude": "98.98530080"
            },
            {
                "id": 3498,
                "name": "Chiang Rai",
                "state_code": "57",
                "latitude": "19.91047980",
                "longitude": "99.84057600"
            },
            {
                "id": 3513,
                "name": "Chon Buri",
                "state_code": "20",
                "latitude": "13.36114310",
                "longitude": "100.98467170"
            },
            {
                "id": 3526,
                "name": "Chumphon",
                "state_code": "86",
                "latitude": "10.49304960",
                "longitude": "99.18001990"
            },
            {
                "id": 3550,
                "name": "Kalasin",
                "state_code": "46",
                "latitude": "16.43850800",
                "longitude": "103.50609940"
            },
            {
                "id": 3516,
                "name": "Kamphaeng Phet",
                "state_code": "62",
                "latitude": "16.48277980",
                "longitude": "99.52266180"
            },
            {
                "id": 3511,
                "name": "Kanchanaburi",
                "state_code": "71",
                "latitude": "14.10113930",
                "longitude": "99.41794310"
            },
            {
                "id": 3485,
                "name": "Khon Kaen",
                "state_code": "40",
                "latitude": "16.43219380",
                "longitude": "102.82362140"
            },
            {
                "id": 3478,
                "name": "Krabi",
                "state_code": "81",
                "latitude": "8.08629970",
                "longitude": "98.90628350"
            },
            {
                "id": 3544,
                "name": "Lampang",
                "state_code": "52",
                "latitude": "18.28553950",
                "longitude": "99.51278950"
            },
            {
                "id": 3483,
                "name": "Lamphun",
                "state_code": "51",
                "latitude": "18.57446060",
                "longitude": "99.00872210"
            },
            {
                "id": 3509,
                "name": "Loei",
                "state_code": "42",
                "latitude": "17.48602320",
                "longitude": "101.72230020"
            },
            {
                "id": 3543,
                "name": "Lopburi",
                "state_code": "16",
                "latitude": "14.79950810",
                "longitude": "100.65337060"
            },
            {
                "id": 3505,
                "name": "Mae Hong Son",
                "state_code": "58",
                "latitude": "19.30202960",
                "longitude": "97.96543680"
            },
            {
                "id": 3517,
                "name": "Maha Sarakham",
                "state_code": "44",
                "latitude": "16.01320150",
                "longitude": "103.16151690"
            },
            {
                "id": 3546,
                "name": "Mukdahan",
                "state_code": "49",
                "latitude": "16.54359140",
                "longitude": "104.70241210"
            },
            {
                "id": 3535,
                "name": "Nakhon Nayok",
                "state_code": "26",
                "latitude": "14.20694660",
                "longitude": "101.21305110"
            },
            {
                "id": 3503,
                "name": "Nakhon Pathom",
                "state_code": "73",
                "latitude": "13.81402930",
                "longitude": "100.03729290"
            },
            {
                "id": 3548,
                "name": "Nakhon Phanom",
                "state_code": "48",
                "latitude": "17.39203900",
                "longitude": "104.76955080"
            },
            {
                "id": 3497,
                "name": "Nakhon Ratchasima",
                "state_code": "30",
                "latitude": "14.97384930",
                "longitude": "102.08365200"
            },
            {
                "id": 3492,
                "name": "Nakhon Sawan",
                "state_code": "60",
                "latitude": "15.69873820",
                "longitude": "100.11996000"
            },
            {
                "id": 3520,
                "name": "Nakhon Si Thammarat",
                "state_code": "80",
                "latitude": "8.43248310",
                "longitude": "99.95990330"
            },
            {
                "id": 3530,
                "name": "Nan",
                "state_code": "55",
                "latitude": "45.52220800",
                "longitude": "-122.98632810"
            },
            {
                "id": 3553,
                "name": "Narathiwat",
                "state_code": "96",
                "latitude": "6.42546070",
                "longitude": "101.82531430"
            },
            {
                "id": 3480,
                "name": "Nong Bua Lam Phu",
                "state_code": "39",
                "latitude": "17.22182470",
                "longitude": "102.42603680"
            },
            {
                "id": 3484,
                "name": "Nong Khai",
                "state_code": "43",
                "latitude": "17.87828030",
                "longitude": "102.74126380"
            },
            {
                "id": 3495,
                "name": "Nonthaburi",
                "state_code": "12",
                "latitude": "13.85910840",
                "longitude": "100.52165080"
            },
            {
                "id": 3500,
                "name": "Pathum Thani",
                "state_code": "13",
                "latitude": "14.02083910",
                "longitude": "100.52502760"
            },
            {
                "id": 3540,
                "name": "Pattani",
                "state_code": "94",
                "latitude": "6.76183080",
                "longitude": "101.32325490"
            },
            {
                "id": 3507,
                "name": "Pattaya",
                "state_code": "S",
                "latitude": "12.92355570",
                "longitude": "100.88245510"
            },
            {
                "id": 3549,
                "name": "Phang Nga",
                "state_code": "82",
                "latitude": "8.45014140",
                "longitude": "98.52553170"
            },
            {
                "id": 3488,
                "name": "Phatthalung",
                "state_code": "93",
                "latitude": "7.61668230",
                "longitude": "100.07402310"
            },
            {
                "id": 3538,
                "name": "Phayao",
                "state_code": "56",
                "latitude": "19.21543670",
                "longitude": "100.20236920"
            },
            {
                "id": 3515,
                "name": "Phetchabun",
                "state_code": "67",
                "latitude": "16.30166900",
                "longitude": "101.11928040"
            },
            {
                "id": 3532,
                "name": "Phetchaburi",
                "state_code": "76",
                "latitude": "12.96492150",
                "longitude": "99.64258830"
            },
            {
                "id": 3514,
                "name": "Phichit",
                "state_code": "66",
                "latitude": "16.27408760",
                "longitude": "100.33469910"
            },
            {
                "id": 3506,
                "name": "Phitsanulok",
                "state_code": "65",
                "latitude": "16.82112380",
                "longitude": "100.26585160"
            },
            {
                "id": 3494,
                "name": "Phra Nakhon Si Ayutthaya",
                "state_code": "14",
                "latitude": "14.36923250",
                "longitude": "100.58766340"
            },
            {
                "id": 3528,
                "name": "Phrae",
                "state_code": "54",
                "latitude": "18.14457740",
                "longitude": "100.14028310"
            },
            {
                "id": 3536,
                "name": "Phuket",
                "state_code": "83",
                "latitude": "7.88044790",
                "longitude": "98.39225040"
            },
            {
                "id": 3542,
                "name": "Prachin Buri",
                "state_code": "25",
                "latitude": "14.04206990",
                "longitude": "101.66008740"
            },
            {
                "id": 3508,
                "name": "Prachuap Khiri Khan",
                "state_code": "77",
                "latitude": "11.79383890",
                "longitude": "99.79575640"
            },
            {
                "id": 3479,
                "name": "Ranong",
                "state_code": "85",
                "latitude": "9.95287020",
                "longitude": "98.60846410"
            },
            {
                "id": 3499,
                "name": "Ratchaburi",
                "state_code": "70",
                "latitude": "13.52828930",
                "longitude": "99.81342110"
            },
            {
                "id": 3518,
                "name": "Rayong",
                "state_code": "21",
                "latitude": "12.68139570",
                "longitude": "101.28162610"
            },
            {
                "id": 3510,
                "name": "Roi Et",
                "state_code": "45",
                "latitude": "16.05381960",
                "longitude": "103.65200360"
            },
            {
                "id": 3529,
                "name": "Sa Kaeo",
                "state_code": "27",
                "latitude": "13.82403800",
                "longitude": "102.06458390"
            },
            {
                "id": 3501,
                "name": "Sakon Nakhon",
                "state_code": "47",
                "latitude": "17.16642110",
                "longitude": "104.14860550"
            },
            {
                "id": 3481,
                "name": "Samut Prakan",
                "state_code": "11",
                "latitude": "13.59909610",
                "longitude": "100.59983190"
            },
            {
                "id": 3504,
                "name": "Samut Sakhon",
                "state_code": "74",
                "latitude": "13.54752160",
                "longitude": "100.27439560"
            },
            {
                "id": 3502,
                "name": "Samut Songkhram",
                "state_code": "75",
                "latitude": "13.40982170",
                "longitude": "100.00226450"
            },
            {
                "id": 3487,
                "name": "Saraburi",
                "state_code": "19",
                "latitude": "14.52891540",
                "longitude": "100.91014210"
            },
            {
                "id": 3537,
                "name": "Satun",
                "state_code": "91",
                "latitude": "6.62381580",
                "longitude": "100.06737440"
            },
            {
                "id": 3547,
                "name": "Si Sa Ket",
                "state_code": "33",
                "latitude": "15.11860090",
                "longitude": "104.32200950"
            },
            {
                "id": 3490,
                "name": "Sing Buri",
                "state_code": "17",
                "latitude": "14.89362530",
                "longitude": "100.39673140"
            },
            {
                "id": 3539,
                "name": "Songkhla",
                "state_code": "90",
                "latitude": "7.18976590",
                "longitude": "100.59538130"
            },
            {
                "id": 3545,
                "name": "Sukhothai",
                "state_code": "64",
                "latitude": "43.64855560",
                "longitude": "-79.37466390"
            },
            {
                "id": 3524,
                "name": "Suphanburi",
                "state_code": "72",
                "latitude": "14.47448920",
                "longitude": "100.11771280"
            },
            {
                "id": 3482,
                "name": "Surat Thani",
                "state_code": "84",
                "latitude": "9.13419490",
                "longitude": "99.33341980"
            },
            {
                "id": 3531,
                "name": "Surin",
                "state_code": "32",
                "latitude": "37.03582710",
                "longitude": "-95.62763670"
            },
            {
                "id": 3525,
                "name": "Tak",
                "state_code": "63",
                "latitude": "45.02996460",
                "longitude": "-93.10498150"
            },
            {
                "id": 3541,
                "name": "Trang",
                "state_code": "92",
                "latitude": "7.56448330",
                "longitude": "99.62393340"
            },
            {
                "id": 3496,
                "name": "Trat",
                "state_code": "23",
                "latitude": "12.24275630",
                "longitude": "102.51747340"
            },
            {
                "id": 3512,
                "name": "Ubon Ratchathani",
                "state_code": "34",
                "latitude": "15.24484530",
                "longitude": "104.84729950"
            },
            {
                "id": 3527,
                "name": "Udon Thani",
                "state_code": "41",
                "latitude": "17.36469690",
                "longitude": "102.81589240"
            },
            {
                "id": 3551,
                "name": "Uthai Thani",
                "state_code": "61",
                "latitude": "15.38350010",
                "longitude": "100.02455270"
            },
            {
                "id": 3489,
                "name": "Uttaradit",
                "state_code": "53",
                "latitude": "17.62008860",
                "longitude": "100.09929420"
            },
            {
                "id": 3493,
                "name": "Yala",
                "state_code": "95",
                "latitude": "44.05791170",
                "longitude": "-123.16538480"
            },
            {
                "id": 3521,
                "name": "Yasothon",
                "state_code": "35",
                "latitude": "15.79264100",
                "longitude": "104.14528270"
            }
        ]
    },
    {
        "name": "Togo",
        "iso3": "TGO",
        "iso2": "TG",
        "phone_code": "228",
        "capital": "Lome",
        "currency": "XOF",
        "currency_symbol": "CFA",
        "tld": ".tg",
        "native": "Togo",
        "region": "Africa",
        "subregion": "Western Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Lome",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "í† ê³ ",
            "br": "Togo",
            "pt": "Togo",
            "nl": "Togo",
            "hr": "Togo",
            "fa": "ØªÙˆÚ¯Ùˆ",
            "de": "Togo",
            "es": "Togo",
            "fr": "Togo",
            "ja": "ãƒˆãƒ¼ã‚´",
            "it": "Togo",
            "cn": "å¤šå“¥"
        },
        "latitude": "8.00000000",
        "longitude": "1.16666666",
        "emoji": "ðŸ‡¹ðŸ‡¬",
        "emojiU": "U+1F1F9 U+1F1EC",
        "states": [
            {
                "id": 2575,
                "name": "Centrale Region",
                "state_code": "C",
                "latitude": "8.65860290",
                "longitude": "1.05861350"
            },
            {
                "id": 2579,
                "name": "Kara Region",
                "state_code": "K",
                "latitude": "9.72163930",
                "longitude": "1.05861350"
            },
            {
                "id": 2576,
                "name": "Maritime",
                "state_code": "M",
                "latitude": "41.65514930",
                "longitude": "-83.52784670"
            },
            {
                "id": 2577,
                "name": "Plateaux Region",
                "state_code": "P",
                "latitude": "7.61013780",
                "longitude": "1.05861350"
            },
            {
                "id": 2578,
                "name": "Savanes Region",
                "state_code": "S",
                "latitude": "10.52917810",
                "longitude": "0.52578230"
            }
        ]
    },
    {
        "name": "Tokelau",
        "iso3": "TKL",
        "iso2": "TK",
        "phone_code": "690",
        "capital": "",
        "currency": "NZD",
        "currency_symbol": "$",
        "tld": ".tk",
        "native": "Tokelau",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Fakaofo",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "TKT",
                "tzName": "Tokelau Time"
            }
        ],
        "translations": {
            "kr": "í† ì¼ˆë¼ìš°",
            "br": "Tokelau",
            "pt": "Toquelau",
            "nl": "Tokelau",
            "hr": "Tokelau",
            "fa": "ØªÙˆÚ©Ù„Ø§Ø¦Ùˆ",
            "de": "Tokelau",
            "es": "Islas Tokelau",
            "fr": "Tokelau",
            "ja": "ãƒˆã‚±ãƒ©ã‚¦",
            "it": "Isole Tokelau",
            "cn": "æ‰˜å…‹åŠ³"
        },
        "latitude": "-9.00000000",
        "longitude": "-172.00000000",
        "emoji": "ðŸ‡¹ðŸ‡°",
        "emojiU": "U+1F1F9 U+1F1F0",
        "states": []
    },
    {
        "name": "Tonga",
        "iso3": "TON",
        "iso2": "TO",
        "phone_code": "676",
        "capital": "Nuku'alofa",
        "currency": "TOP",
        "currency_symbol": "$",
        "tld": ".to",
        "native": "Tonga",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Tongatapu",
                "gmtOffset": 46800,
                "gmtOffsetName": "UTC+13:00",
                "abbreviation": "TOT",
                "tzName": "Tonga Time"
            }
        ],
        "translations": {
            "kr": "í†µê°€",
            "br": "Tonga",
            "pt": "Tonga",
            "nl": "Tonga",
            "hr": "Tonga",
            "fa": "ØªÙˆÙ†Ú¯Ø§",
            "de": "Tonga",
            "es": "Tonga",
            "fr": "Tonga",
            "ja": "ãƒˆãƒ³ã‚¬",
            "it": "Tonga",
            "cn": "æ±¤åŠ "
        },
        "latitude": "-20.00000000",
        "longitude": "-175.00000000",
        "emoji": "ðŸ‡¹ðŸ‡´",
        "emojiU": "U+1F1F9 U+1F1F4",
        "states": [
            {
                "id": 3913,
                "name": "HaÊ»apai",
                "state_code": "02",
                "latitude": "-19.75000000",
                "longitude": "-174.36666700"
            },
            {
                "id": 3915,
                "name": "Ê»Eua",
                "state_code": "01",
                "latitude": "37.09024000",
                "longitude": "-95.71289100"
            },
            {
                "id": 3914,
                "name": "Niuas",
                "state_code": "03",
                "latitude": "-15.95940000",
                "longitude": "-173.78300000"
            },
            {
                "id": 3912,
                "name": "Tongatapu",
                "state_code": "04",
                "latitude": "-21.14659680",
                "longitude": "-175.25154820"
            },
            {
                "id": 3911,
                "name": "VavaÊ»u",
                "state_code": "05",
                "latitude": "-18.62275600",
                "longitude": "-173.99029820"
            }
        ]
    },
    {
        "name": "Trinidad And Tobago",
        "iso3": "TTO",
        "iso2": "TT",
        "phone_code": "+1-868",
        "capital": "Port of Spain",
        "currency": "TTD",
        "currency_symbol": "$",
        "tld": ".tt",
        "native": "Trinidad and Tobago",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Port_of_Spain",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "íŠ¸ë¦¬ë‹ˆë‹¤ë“œ í† ë°”ê³ ",
            "br": "Trinidad e Tobago",
            "pt": "Trindade e Tobago",
            "nl": "Trinidad en Tobago",
            "hr": "Trinidad i Tobago",
            "fa": "ØªØ±ÛŒÙ†ÛŒØ¯Ø§Ø¯ Ùˆ ØªÙˆØ¨Ø§Ú¯Ùˆ",
            "de": "Trinidad und Tobago",
            "es": "Trinidad y Tobago",
            "fr": "TrinitÃ© et Tobago",
            "ja": "ãƒˆãƒªãƒ‹ãƒ€ãƒ¼ãƒ‰ãƒ»ãƒˆãƒã‚´",
            "it": "Trinidad e Tobago",
            "cn": "ç‰¹ç«‹å°¼è¾¾å’Œå¤šå·´å“¥"
        },
        "latitude": "11.00000000",
        "longitude": "-61.00000000",
        "emoji": "ðŸ‡¹ðŸ‡¹",
        "emojiU": "U+1F1F9 U+1F1F9",
        "states": [
            {
                "id": 3362,
                "name": "Arima",
                "state_code": "ARI",
                "latitude": "46.79316040",
                "longitude": "-71.25843110"
            },
            {
                "id": 3366,
                "name": "Chaguanas",
                "state_code": "CHA",
                "latitude": "10.51683870",
                "longitude": "-61.41144820"
            },
            {
                "id": 3354,
                "name": "Couva-Tabaquite-Talparo Regional Corporation",
                "state_code": "CTT",
                "latitude": "10.42971450",
                "longitude": "-61.37352100"
            },
            {
                "id": 3367,
                "name": "Diego Martin Regional Corporation",
                "state_code": "DMN",
                "latitude": "10.73622860",
                "longitude": "-61.55448360"
            },
            {
                "id": 3355,
                "name": "Eastern Tobago",
                "state_code": "ETO",
                "latitude": "11.29793480",
                "longitude": "-60.55885240"
            },
            {
                "id": 3365,
                "name": "Penal-Debe Regional Corporation",
                "state_code": "PED",
                "latitude": "10.13374020",
                "longitude": "-61.44354740"
            },
            {
                "id": 3360,
                "name": "Point Fortin",
                "state_code": "PTF",
                "latitude": "10.17027370",
                "longitude": "-61.67133860"
            },
            {
                "id": 3363,
                "name": "Port of Spain",
                "state_code": "POS",
                "latitude": "10.66031960",
                "longitude": "-61.50856250"
            },
            {
                "id": 3368,
                "name": "Princes Town Regional Corporation",
                "state_code": "PRT",
                "latitude": "10.17867460",
                "longitude": "-61.28019960"
            },
            {
                "id": 3356,
                "name": "Rio Claro-Mayaro Regional Corporation",
                "state_code": "MRC",
                "latitude": "10.24128320",
                "longitude": "-61.09372060"
            },
            {
                "id": 3359,
                "name": "San Fernando",
                "state_code": "SFO",
                "latitude": "34.28194610",
                "longitude": "-118.43897190"
            },
            {
                "id": 3357,
                "name": "San Juan-Laventille Regional Corporation",
                "state_code": "SJL",
                "latitude": "10.69085780",
                "longitude": "-61.45522130"
            },
            {
                "id": 3361,
                "name": "Sangre Grande Regional Corporation",
                "state_code": "SGE",
                "latitude": "10.58529390",
                "longitude": "-61.13158130"
            },
            {
                "id": 3364,
                "name": "Siparia Regional Corporation",
                "state_code": "SIP",
                "latitude": "10.12456260",
                "longitude": "-61.56032440"
            },
            {
                "id": 3358,
                "name": "Tunapuna-Piarco Regional Corporation",
                "state_code": "TUP",
                "latitude": "10.68590960",
                "longitude": "-61.30352480"
            },
            {
                "id": 3353,
                "name": "Western Tobago",
                "state_code": "WTO",
                "latitude": "11.18970720",
                "longitude": "-60.77954520"
            }
        ]
    },
    {
        "name": "Tunisia",
        "iso3": "TUN",
        "iso2": "TN",
        "phone_code": "216",
        "capital": "Tunis",
        "currency": "TND",
        "currency_symbol": "Øª.Ø¯",
        "tld": ".tn",
        "native": "ØªÙˆÙ†Ø³",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Tunis",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "íŠ€ë‹ˆì§€",
            "br": "TunÃ­sia",
            "pt": "TunÃ­sia",
            "nl": "TunesiÃ«",
            "hr": "Tunis",
            "fa": "ØªÙˆÙ†Ø³",
            "de": "Tunesien",
            "es": "TÃºnez",
            "fr": "Tunisie",
            "ja": "ãƒãƒ¥ãƒ‹ã‚¸ã‚¢",
            "it": "Tunisia",
            "cn": "çªå°¼æ–¯"
        },
        "latitude": "34.00000000",
        "longitude": "9.00000000",
        "emoji": "ðŸ‡¹ðŸ‡³",
        "emojiU": "U+1F1F9 U+1F1F3",
        "states": [
            {
                "id": 2550,
                "name": "Ariana Governorate",
                "state_code": "12",
                "latitude": "36.99227510",
                "longitude": "10.12551640"
            },
            {
                "id": 2566,
                "name": "Ben Arous Governorate",
                "state_code": "13",
                "latitude": "36.64356060",
                "longitude": "10.21515780"
            },
            {
                "id": 2551,
                "name": "Bizerte Governorate",
                "state_code": "23",
                "latitude": "37.16093970",
                "longitude": "9.63413500"
            },
            {
                "id": 2558,
                "name": "GabÃ¨s Governorate",
                "state_code": "81",
                "latitude": "33.94596480",
                "longitude": "9.72326730"
            },
            {
                "id": 2556,
                "name": "Gafsa Governorate",
                "state_code": "71",
                "latitude": "34.37885050",
                "longitude": "8.66005860"
            },
            {
                "id": 2552,
                "name": "Jendouba Governorate",
                "state_code": "32",
                "latitude": "36.71818620",
                "longitude": "8.74811670"
            },
            {
                "id": 2564,
                "name": "Kairouan Governorate",
                "state_code": "41",
                "latitude": "35.67116630",
                "longitude": "10.10054690"
            },
            {
                "id": 2570,
                "name": "Kasserine Governorate",
                "state_code": "42",
                "latitude": "35.08091480",
                "longitude": "8.66005860"
            },
            {
                "id": 2572,
                "name": "Kassrine",
                "state_code": "31",
                "latitude": "35.17227160",
                "longitude": "8.83076260"
            },
            {
                "id": 2562,
                "name": "Kebili Governorate",
                "state_code": "73",
                "latitude": "33.70715510",
                "longitude": "8.97146230"
            },
            {
                "id": 2561,
                "name": "Kef Governorate",
                "state_code": "33",
                "latitude": "36.12305120",
                "longitude": "8.66005860"
            },
            {
                "id": 2568,
                "name": "Mahdia Governorate",
                "state_code": "53",
                "latitude": "35.33525580",
                "longitude": "10.89030990"
            },
            {
                "id": 2555,
                "name": "Manouba Governorate",
                "state_code": "14",
                "latitude": "36.84465040",
                "longitude": "9.85714160"
            },
            {
                "id": 2560,
                "name": "Medenine Governorate",
                "state_code": "82",
                "latitude": "33.22805650",
                "longitude": "10.89030990"
            },
            {
                "id": 2553,
                "name": "Monastir Governorate",
                "state_code": "52",
                "latitude": "35.76425150",
                "longitude": "10.81128850"
            },
            {
                "id": 2557,
                "name": "Sfax Governorate",
                "state_code": "61",
                "latitude": "34.86065810",
                "longitude": "10.34978950"
            },
            {
                "id": 2567,
                "name": "Sidi Bouzid Governorate",
                "state_code": "43",
                "latitude": "35.03543860",
                "longitude": "9.48393920"
            },
            {
                "id": 2563,
                "name": "Siliana Governorate",
                "state_code": "34",
                "latitude": "36.08872080",
                "longitude": "9.36453350"
            },
            {
                "id": 2571,
                "name": "Sousse Governorate",
                "state_code": "51",
                "latitude": "35.90222670",
                "longitude": "10.34978950"
            },
            {
                "id": 2559,
                "name": "Tataouine Governorate",
                "state_code": "83",
                "latitude": "32.13441220",
                "longitude": "10.08072980"
            },
            {
                "id": 2569,
                "name": "Tozeur Governorate",
                "state_code": "72",
                "latitude": "33.97894910",
                "longitude": "8.04651850"
            },
            {
                "id": 2554,
                "name": "Tunis Governorate",
                "state_code": "11",
                "latitude": "36.83749460",
                "longitude": "10.19273890"
            },
            {
                "id": 2565,
                "name": "Zaghouan Governorate",
                "state_code": "22",
                "latitude": "36.40911880",
                "longitude": "10.14231720"
            }
        ]
    },
    {
        "name": "Turkey",
        "iso3": "TUR",
        "iso2": "TR",
        "phone_code": "90",
        "capital": "Ankara",
        "currency": "TRY",
        "currency_symbol": "â‚º",
        "tld": ".tr",
        "native": "TÃ¼rkiye",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Europe\/Istanbul",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "í„°í‚¤",
            "br": "Turquia",
            "pt": "Turquia",
            "nl": "Turkije",
            "hr": "Turska",
            "fa": "ØªØ±Ú©ÛŒÙ‡",
            "de": "TÃ¼rkei",
            "es": "TurquÃ­a",
            "fr": "Turquie",
            "ja": "ãƒˆãƒ«ã‚³",
            "it": "Turchia",
            "cn": "åœŸè€³å…¶"
        },
        "latitude": "39.00000000",
        "longitude": "35.00000000",
        "emoji": "ðŸ‡¹ðŸ‡·",
        "emojiU": "U+1F1F9 U+1F1F7",
        "states": [
            {
                "id": 2212,
                "name": "Adana Province",
                "state_code": "01",
                "latitude": "37.26123150",
                "longitude": "35.39050460"
            },
            {
                "id": 2155,
                "name": "AdÄ±yaman Province",
                "state_code": "02",
                "latitude": "37.90782910",
                "longitude": "38.48499230"
            },
            {
                "id": 2179,
                "name": "Afyonkarahisar Province",
                "state_code": "03",
                "latitude": "38.73910990",
                "longitude": "30.71200230"
            },
            {
                "id": 2193,
                "name": "AÄŸrÄ± Province",
                "state_code": "04",
                "latitude": "39.62692180",
                "longitude": "43.02159650"
            },
            {
                "id": 2210,
                "name": "Aksaray Province",
                "state_code": "68",
                "latitude": "38.33520430",
                "longitude": "33.97500180"
            },
            {
                "id": 2161,
                "name": "Amasya Province",
                "state_code": "05",
                "latitude": "40.65166080",
                "longitude": "35.90379660"
            },
            {
                "id": 2217,
                "name": "Ankara Province",
                "state_code": "06",
                "latitude": "39.78052450",
                "longitude": "32.71813750"
            },
            {
                "id": 2169,
                "name": "Antalya Province",
                "state_code": "07",
                "latitude": "37.09516720",
                "longitude": "31.07937050"
            },
            {
                "id": 2185,
                "name": "Ardahan Province",
                "state_code": "75",
                "latitude": "41.11129640",
                "longitude": "42.78316740"
            },
            {
                "id": 2191,
                "name": "Artvin Province",
                "state_code": "08",
                "latitude": "41.07866400",
                "longitude": "41.76282230"
            },
            {
                "id": 2187,
                "name": "AydÄ±n Province",
                "state_code": "09",
                "latitude": "37.81170330",
                "longitude": "28.48639630"
            },
            {
                "id": 2175,
                "name": "BalÄ±kesir Province",
                "state_code": "10",
                "latitude": "39.76167820",
                "longitude": "28.11226790"
            },
            {
                "id": 2148,
                "name": "BartÄ±n Province",
                "state_code": "74",
                "latitude": "41.58105090",
                "longitude": "32.46097940"
            },
            {
                "id": 2194,
                "name": "Batman Province",
                "state_code": "72",
                "latitude": "37.83624960",
                "longitude": "41.36057390"
            },
            {
                "id": 2177,
                "name": "Bayburt Province",
                "state_code": "69",
                "latitude": "40.26032000",
                "longitude": "40.22804800"
            },
            {
                "id": 2221,
                "name": "Bilecik Province",
                "state_code": "11",
                "latitude": "40.05665550",
                "longitude": "30.06652360"
            },
            {
                "id": 2153,
                "name": "BingÃ¶l Province",
                "state_code": "12",
                "latitude": "39.06263540",
                "longitude": "40.76960950"
            },
            {
                "id": 2215,
                "name": "Bitlis Province",
                "state_code": "13",
                "latitude": "38.65231330",
                "longitude": "42.42020280"
            },
            {
                "id": 2172,
                "name": "Bolu Province",
                "state_code": "14",
                "latitude": "40.57597660",
                "longitude": "31.57880860"
            },
            {
                "id": 2209,
                "name": "Burdur Province",
                "state_code": "15",
                "latitude": "37.46126690",
                "longitude": "30.06652360"
            },
            {
                "id": 2163,
                "name": "Bursa Province",
                "state_code": "16",
                "latitude": "40.06554590",
                "longitude": "29.23207840"
            },
            {
                "id": 2216,
                "name": "Ã‡anakkale Province",
                "state_code": "17",
                "latitude": "40.05101040",
                "longitude": "26.98524220"
            },
            {
                "id": 2168,
                "name": "Ã‡ankÄ±rÄ± Province",
                "state_code": "18",
                "latitude": "40.53690730",
                "longitude": "33.58838930"
            },
            {
                "id": 2173,
                "name": "Ã‡orum Province",
                "state_code": "19",
                "latitude": "40.49982110",
                "longitude": "34.59862630"
            },
            {
                "id": 2157,
                "name": "Denizli Province",
                "state_code": "20",
                "latitude": "37.61283950",
                "longitude": "29.23207840"
            },
            {
                "id": 2226,
                "name": "DiyarbakÄ±r Province",
                "state_code": "21",
                "latitude": "38.10663720",
                "longitude": "40.54268960"
            },
            {
                "id": 2202,
                "name": "DÃ¼zce Province",
                "state_code": "81",
                "latitude": "40.87705310",
                "longitude": "31.31927130"
            },
            {
                "id": 2151,
                "name": "Edirne Province",
                "state_code": "22",
                "latitude": "41.15172220",
                "longitude": "26.51379640"
            },
            {
                "id": 2159,
                "name": "ElazÄ±ÄŸ Province",
                "state_code": "23",
                "latitude": "38.49648040",
                "longitude": "39.21990290"
            },
            {
                "id": 2160,
                "name": "Erzincan Province",
                "state_code": "24",
                "latitude": "39.76819140",
                "longitude": "39.05013060"
            },
            {
                "id": 2165,
                "name": "Erzurum Province",
                "state_code": "25",
                "latitude": "40.07467990",
                "longitude": "41.66945620"
            },
            {
                "id": 2164,
                "name": "EskiÅŸehir Province",
                "state_code": "26",
                "latitude": "39.63296570",
                "longitude": "31.26263660"
            },
            {
                "id": 2203,
                "name": "Gaziantep Province",
                "state_code": "27",
                "latitude": "37.07638820",
                "longitude": "37.38272340"
            },
            {
                "id": 2186,
                "name": "Giresun Province",
                "state_code": "28",
                "latitude": "40.64616720",
                "longitude": "38.59355110"
            },
            {
                "id": 2204,
                "name": "GÃ¼mÃ¼ÅŸhane Province",
                "state_code": "29",
                "latitude": "40.28036730",
                "longitude": "39.31432530"
            },
            {
                "id": 2190,
                "name": "HakkÃ¢ri Province",
                "state_code": "30",
                "latitude": "37.44593190",
                "longitude": "43.74498410"
            },
            {
                "id": 2211,
                "name": "Hatay Province",
                "state_code": "31",
                "latitude": "36.40184880",
                "longitude": "36.34980970"
            },
            {
                "id": 2166,
                "name": "IÄŸdÄ±r Province",
                "state_code": "76",
                "latitude": "39.88798410",
                "longitude": "44.00483650"
            },
            {
                "id": 2222,
                "name": "Isparta Province",
                "state_code": "32",
                "latitude": "38.02114640",
                "longitude": "31.07937050"
            },
            {
                "id": 2170,
                "name": "Istanbul Province",
                "state_code": "34",
                "latitude": "41.16343020",
                "longitude": "28.76644080"
            },
            {
                "id": 2205,
                "name": "Ä°zmir Province",
                "state_code": "35",
                "latitude": "38.35916930",
                "longitude": "27.26761160"
            },
            {
                "id": 2227,
                "name": "KahramanmaraÅŸ Province",
                "state_code": "46",
                "latitude": "37.75030360",
                "longitude": "36.95410700"
            },
            {
                "id": 2223,
                "name": "KarabÃ¼k Province",
                "state_code": "78",
                "latitude": "41.18748900",
                "longitude": "32.74174190"
            },
            {
                "id": 2184,
                "name": "Karaman Province",
                "state_code": "70",
                "latitude": "37.24363360",
                "longitude": "33.61757700"
            },
            {
                "id": 2208,
                "name": "Kars Province",
                "state_code": "36",
                "latitude": "40.28076360",
                "longitude": "42.99195270"
            },
            {
                "id": 2197,
                "name": "Kastamonu Province",
                "state_code": "37",
                "latitude": "41.41038630",
                "longitude": "33.69983340"
            },
            {
                "id": 2200,
                "name": "Kayseri Province",
                "state_code": "38",
                "latitude": "38.62568540",
                "longitude": "35.74068820"
            },
            {
                "id": 2154,
                "name": "Kilis Province",
                "state_code": "79",
                "latitude": "36.82047750",
                "longitude": "37.16873390"
            },
            {
                "id": 2178,
                "name": "KÄ±rÄ±kkale Province",
                "state_code": "71",
                "latitude": "39.88768780",
                "longitude": "33.75552480"
            },
            {
                "id": 2176,
                "name": "KÄ±rklareli Province",
                "state_code": "39",
                "latitude": "41.72597950",
                "longitude": "27.48383900"
            },
            {
                "id": 2180,
                "name": "KÄ±rÅŸehir Province",
                "state_code": "40",
                "latitude": "39.22689050",
                "longitude": "33.97500180"
            },
            {
                "id": 2195,
                "name": "Kocaeli Province",
                "state_code": "41",
                "latitude": "40.85327040",
                "longitude": "29.88152030"
            },
            {
                "id": 2171,
                "name": "Konya Province",
                "state_code": "42",
                "latitude": "37.98381340",
                "longitude": "32.71813750"
            },
            {
                "id": 2149,
                "name": "KÃ¼tahya Province",
                "state_code": "43",
                "latitude": "39.35813700",
                "longitude": "29.60354950"
            },
            {
                "id": 2158,
                "name": "Malatya Province",
                "state_code": "44",
                "latitude": "38.40150570",
                "longitude": "37.95362980"
            },
            {
                "id": 2198,
                "name": "Manisa Province",
                "state_code": "45",
                "latitude": "38.84193730",
                "longitude": "28.11226790"
            },
            {
                "id": 2224,
                "name": "Mardin Province",
                "state_code": "47",
                "latitude": "37.34429290",
                "longitude": "40.61964870"
            },
            {
                "id": 2156,
                "name": "Mersin Province",
                "state_code": "33",
                "latitude": "36.81208580",
                "longitude": "34.64147500"
            },
            {
                "id": 2182,
                "name": "MuÄŸla Province",
                "state_code": "48",
                "latitude": "37.18358190",
                "longitude": "28.48639630"
            },
            {
                "id": 2162,
                "name": "MuÅŸ Province",
                "state_code": "49",
                "latitude": "38.94618880",
                "longitude": "41.75389310"
            },
            {
                "id": 2196,
                "name": "NevÅŸehir Province",
                "state_code": "50",
                "latitude": "38.69393990",
                "longitude": "34.68565090"
            },
            {
                "id": 2189,
                "name": "NiÄŸde Province",
                "state_code": "51",
                "latitude": "38.09930860",
                "longitude": "34.68565090"
            },
            {
                "id": 2174,
                "name": "Ordu Province",
                "state_code": "52",
                "latitude": "40.79905800",
                "longitude": "37.38990050"
            },
            {
                "id": 2214,
                "name": "Osmaniye Province",
                "state_code": "80",
                "latitude": "37.21302580",
                "longitude": "36.17626150"
            },
            {
                "id": 2219,
                "name": "Rize Province",
                "state_code": "53",
                "latitude": "40.95814970",
                "longitude": "40.92269850"
            },
            {
                "id": 2150,
                "name": "Sakarya Province",
                "state_code": "54",
                "latitude": "40.78885500",
                "longitude": "30.40595400"
            },
            {
                "id": 2220,
                "name": "Samsun Province",
                "state_code": "55",
                "latitude": "41.18648590",
                "longitude": "36.13226780"
            },
            {
                "id": 2183,
                "name": "ÅžanlÄ±urfa Province",
                "state_code": "63",
                "latitude": "37.35691020",
                "longitude": "39.15436770"
            },
            {
                "id": 2207,
                "name": "Siirt Province",
                "state_code": "56",
                "latitude": "37.86588620",
                "longitude": "42.14945230"
            },
            {
                "id": 4854,
                "name": "Sinop Province",
                "state_code": "57",
                "latitude": "41.55947490",
                "longitude": "34.85805320"
            },
            {
                "id": 2181,
                "name": "Sivas Province",
                "state_code": "58",
                "latitude": "39.44880390",
                "longitude": "37.12944970"
            },
            {
                "id": 2225,
                "name": "ÅžÄ±rnak Province",
                "state_code": "73",
                "latitude": "37.41874810",
                "longitude": "42.49183380"
            },
            {
                "id": 2167,
                "name": "TekirdaÄŸ Province",
                "state_code": "59",
                "latitude": "41.11212270",
                "longitude": "27.26761160"
            },
            {
                "id": 2199,
                "name": "Tokat Province",
                "state_code": "60",
                "latitude": "40.39027130",
                "longitude": "36.62518630"
            },
            {
                "id": 2206,
                "name": "Trabzon Province",
                "state_code": "61",
                "latitude": "40.79924100",
                "longitude": "39.58479440"
            },
            {
                "id": 2192,
                "name": "Tunceli Province",
                "state_code": "62",
                "latitude": "39.30735540",
                "longitude": "39.43877780"
            },
            {
                "id": 2201,
                "name": "UÅŸak Province",
                "state_code": "64",
                "latitude": "38.54313190",
                "longitude": "29.23207840"
            },
            {
                "id": 2152,
                "name": "Van Province",
                "state_code": "65",
                "latitude": "38.36794170",
                "longitude": "43.71827870"
            },
            {
                "id": 2218,
                "name": "Yalova Province",
                "state_code": "77",
                "latitude": "40.57759860",
                "longitude": "29.20883030"
            },
            {
                "id": 2188,
                "name": "Yozgat Province",
                "state_code": "66",
                "latitude": "39.72719790",
                "longitude": "35.10778580"
            },
            {
                "id": 2213,
                "name": "Zonguldak Province",
                "state_code": "67",
                "latitude": "41.31249170",
                "longitude": "31.85982510"
            }
        ]
    },
    {
        "name": "Turkmenistan",
        "iso3": "TKM",
        "iso2": "TM",
        "phone_code": "993",
        "capital": "Ashgabat",
        "currency": "TMT",
        "currency_symbol": "T",
        "tld": ".tm",
        "native": "TÃ¼rkmenistan",
        "region": "Asia",
        "subregion": "Central Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Ashgabat",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "TMT",
                "tzName": "Turkmenistan Time"
            }
        ],
        "translations": {
            "kr": "íˆ¬ë¥´í¬ë©”ë‹ˆìŠ¤íƒ„",
            "br": "TurcomenistÃ£o",
            "pt": "TurquemenistÃ£o",
            "nl": "Turkmenistan",
            "hr": "Turkmenistan",
            "fa": "ØªØ±Ú©Ù…Ù†Ø³ØªØ§Ù†",
            "de": "Turkmenistan",
            "es": "TurkmenistÃ¡n",
            "fr": "TurkmÃ©nistan",
            "ja": "ãƒˆãƒ«ã‚¯ãƒ¡ãƒ‹ã‚¹ã‚¿ãƒ³",
            "it": "Turkmenistan",
            "cn": "åœŸåº“æ›¼æ–¯å¦"
        },
        "latitude": "40.00000000",
        "longitude": "60.00000000",
        "emoji": "ðŸ‡¹ðŸ‡²",
        "emojiU": "U+1F1F9 U+1F1F2",
        "states": [
            {
                "id": 3374,
                "name": "Ahal Region",
                "state_code": "A",
                "latitude": "38.63993980",
                "longitude": "59.47209040"
            },
            {
                "id": 3371,
                "name": "Ashgabat",
                "state_code": "S",
                "latitude": "37.96007660",
                "longitude": "58.32606290"
            },
            {
                "id": 3372,
                "name": "Balkan Region",
                "state_code": "B",
                "latitude": "41.81014720",
                "longitude": "21.09373110"
            },
            {
                "id": 3373,
                "name": "DaÅŸoguz Region",
                "state_code": "D",
                "latitude": "41.83687370",
                "longitude": "59.96519040"
            },
            {
                "id": 3370,
                "name": "Lebap Region",
                "state_code": "L",
                "latitude": "38.12724620",
                "longitude": "64.71624150"
            },
            {
                "id": 3369,
                "name": "Mary Region",
                "state_code": "M",
                "latitude": "36.94816230",
                "longitude": "62.45041540"
            }
        ]
    },
    {
        "name": "Turks And Caicos Islands",
        "iso3": "TCA",
        "iso2": "TC",
        "phone_code": "+1-649",
        "capital": "Cockburn Town",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".tc",
        "native": "Turks and Caicos Islands",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Grand_Turk",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            }
        ],
        "translations": {
            "kr": "í„°í¬ìŠ¤ ì¼€ì´ì»¤ìŠ¤ ì œë„",
            "br": "Ilhas Turcas e Caicos",
            "pt": "Ilhas Turcas e Caicos",
            "nl": "Turks- en Caicoseilanden",
            "hr": "Otoci Turks i Caicos",
            "fa": "Ø¬Ø²Ø§ÛŒØ± ØªÙˆØ±Ú©Ø³ Ùˆ Ú©Ø§ÛŒÚ©ÙˆØ³",
            "de": "Turks- und Caicosinseln",
            "es": "Islas Turks y Caicos",
            "fr": "ÃŽles Turques-et-CaÃ¯ques",
            "ja": "ã‚¿ãƒ¼ã‚¯ã‚¹ãƒ»ã‚«ã‚¤ã‚³ã‚¹è«¸å³¶",
            "it": "Isole Turks e Caicos",
            "cn": "ç‰¹å…‹æ–¯å’Œå‡¯ç§‘æ–¯ç¾¤å²›"
        },
        "latitude": "21.75000000",
        "longitude": "-71.58333333",
        "emoji": "ðŸ‡¹ðŸ‡¨",
        "emojiU": "U+1F1F9 U+1F1E8",
        "states": []
    },
    {
        "name": "Tuvalu",
        "iso3": "TUV",
        "iso2": "TV",
        "phone_code": "688",
        "capital": "Funafuti",
        "currency": "AUD",
        "currency_symbol": "$",
        "tld": ".tv",
        "native": "Tuvalu",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Funafuti",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "TVT",
                "tzName": "Tuvalu Time"
            }
        ],
        "translations": {
            "kr": "íˆ¬ë°œë£¨",
            "br": "Tuvalu",
            "pt": "Tuvalu",
            "nl": "Tuvalu",
            "hr": "Tuvalu",
            "fa": "ØªÙˆÙˆØ§Ù„Ùˆ",
            "de": "Tuvalu",
            "es": "Tuvalu",
            "fr": "Tuvalu",
            "ja": "ãƒ„ãƒãƒ«",
            "it": "Tuvalu",
            "cn": "å›¾ç“¦å¢"
        },
        "latitude": "-8.00000000",
        "longitude": "178.00000000",
        "emoji": "ðŸ‡¹ðŸ‡»",
        "emojiU": "U+1F1F9 U+1F1FB",
        "states": [
            {
                "id": 3951,
                "name": "Funafuti",
                "state_code": "FUN",
                "latitude": "-8.52114710",
                "longitude": "179.19619260"
            },
            {
                "id": 3947,
                "name": "Nanumanga",
                "state_code": "NMG",
                "latitude": "-6.28580190",
                "longitude": "176.31992800"
            },
            {
                "id": 3949,
                "name": "Nanumea",
                "state_code": "NMA",
                "latitude": "-5.68816170",
                "longitude": "176.13701480"
            },
            {
                "id": 3946,
                "name": "Niutao Island Council",
                "state_code": "NIT",
                "latitude": "-6.10642580",
                "longitude": "177.34384290"
            },
            {
                "id": 3948,
                "name": "Nui",
                "state_code": "NUI",
                "latitude": "-7.23887680",
                "longitude": "177.14852320"
            },
            {
                "id": 3952,
                "name": "Nukufetau",
                "state_code": "NKF",
                "latitude": "-8.00000000",
                "longitude": "178.50000000"
            },
            {
                "id": 3953,
                "name": "Nukulaelae",
                "state_code": "NKL",
                "latitude": "-9.38111100",
                "longitude": "179.85222200"
            },
            {
                "id": 3950,
                "name": "Vaitupu",
                "state_code": "VAI",
                "latitude": "-7.47673270",
                "longitude": "178.67476750"
            }
        ]
    },
    {
        "name": "Uganda",
        "iso3": "UGA",
        "iso2": "UG",
        "phone_code": "256",
        "capital": "Kampala",
        "currency": "UGX",
        "currency_symbol": "USh",
        "tld": ".ug",
        "native": "Uganda",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Kampala",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "EAT",
                "tzName": "East Africa Time"
            }
        ],
        "translations": {
            "kr": "ìš°ê°„ë‹¤",
            "br": "Uganda",
            "pt": "Uganda",
            "nl": "Oeganda",
            "hr": "Uganda",
            "fa": "Ø§ÙˆÚ¯Ø§Ù†Ø¯Ø§",
            "de": "Uganda",
            "es": "Uganda",
            "fr": "Uganda",
            "ja": "ã‚¦ã‚¬ãƒ³ãƒ€",
            "it": "Uganda",
            "cn": "ä¹Œå¹²è¾¾"
        },
        "latitude": "1.00000000",
        "longitude": "32.00000000",
        "emoji": "ðŸ‡ºðŸ‡¬",
        "emojiU": "U+1F1FA U+1F1EC",
        "states": [
            {
                "id": 329,
                "name": "Abim District",
                "state_code": "314",
                "latitude": "2.70669800",
                "longitude": "33.65953370"
            },
            {
                "id": 361,
                "name": "Adjumani District",
                "state_code": "301",
                "latitude": "3.25485270",
                "longitude": "31.71954590"
            },
            {
                "id": 392,
                "name": "Agago District",
                "state_code": "322",
                "latitude": "2.92508200",
                "longitude": "33.34861470"
            },
            {
                "id": 344,
                "name": "Alebtong District",
                "state_code": "323",
                "latitude": "2.25457730",
                "longitude": "33.34861470"
            },
            {
                "id": 416,
                "name": "Amolatar District",
                "state_code": "315",
                "latitude": "1.60544020",
                "longitude": "32.80844960"
            },
            {
                "id": 353,
                "name": "Amudat District",
                "state_code": "324",
                "latitude": "1.79162240",
                "longitude": "34.90655100"
            },
            {
                "id": 352,
                "name": "Amuria District",
                "state_code": "216",
                "latitude": "2.03017000",
                "longitude": "33.64275330"
            },
            {
                "id": 335,
                "name": "Amuru District",
                "state_code": "316",
                "latitude": "2.96678780",
                "longitude": "32.08374450"
            },
            {
                "id": 328,
                "name": "Apac District",
                "state_code": "302",
                "latitude": "1.87302630",
                "longitude": "32.62774550"
            },
            {
                "id": 447,
                "name": "Arua District",
                "state_code": "303",
                "latitude": "2.99598460",
                "longitude": "31.17103890"
            },
            {
                "id": 441,
                "name": "Budaka District",
                "state_code": "217",
                "latitude": "1.10162770",
                "longitude": "33.93039910"
            },
            {
                "id": 349,
                "name": "Bududa District",
                "state_code": "218",
                "latitude": "1.00296930",
                "longitude": "34.33381230"
            },
            {
                "id": 387,
                "name": "Bugiri District",
                "state_code": "201",
                "latitude": "0.53161270",
                "longitude": "33.75177230"
            },
            {
                "id": 391,
                "name": "Buhweju District",
                "state_code": "420",
                "latitude": "-0.29113590",
                "longitude": "30.29741990"
            },
            {
                "id": 377,
                "name": "Buikwe District",
                "state_code": "117",
                "latitude": "0.31440460",
                "longitude": "32.98883190"
            },
            {
                "id": 343,
                "name": "Bukedea District",
                "state_code": "219",
                "latitude": "1.35568980",
                "longitude": "34.10867930"
            },
            {
                "id": 375,
                "name": "Bukomansimbi District",
                "state_code": "118",
                "latitude": "-0.14327520",
                "longitude": "31.60548930"
            },
            {
                "id": 385,
                "name": "Bukwo District",
                "state_code": "220",
                "latitude": "1.28186510",
                "longitude": "34.72987650"
            },
            {
                "id": 428,
                "name": "Bulambuli District",
                "state_code": "225",
                "latitude": "1.47988460",
                "longitude": "34.37544140"
            },
            {
                "id": 389,
                "name": "Buliisa District",
                "state_code": "416",
                "latitude": "2.02996070",
                "longitude": "31.53700030"
            },
            {
                "id": 419,
                "name": "Bundibugyo District",
                "state_code": "401",
                "latitude": "0.68517630",
                "longitude": "30.02029640"
            },
            {
                "id": 381,
                "name": "Bunyangabu District",
                "state_code": "430",
                "latitude": "0.48709180",
                "longitude": "30.20510960"
            },
            {
                "id": 386,
                "name": "Bushenyi District",
                "state_code": "402",
                "latitude": "-0.48709180",
                "longitude": "30.20510960"
            },
            {
                "id": 431,
                "name": "Busia District",
                "state_code": "202",
                "latitude": "0.40447310",
                "longitude": "34.01958270"
            },
            {
                "id": 365,
                "name": "Butaleja District",
                "state_code": "221",
                "latitude": "0.84749220",
                "longitude": "33.84112880"
            },
            {
                "id": 384,
                "name": "Butambala District",
                "state_code": "119",
                "latitude": "0.17425000",
                "longitude": "32.10646680"
            },
            {
                "id": 388,
                "name": "Butebo District",
                "state_code": "233",
                "latitude": "1.21411240",
                "longitude": "33.90808960"
            },
            {
                "id": 414,
                "name": "Buvuma District",
                "state_code": "120",
                "latitude": "-0.37649120",
                "longitude": "33.25879300"
            },
            {
                "id": 380,
                "name": "Buyende District",
                "state_code": "226",
                "latitude": "1.24136820",
                "longitude": "33.12390490"
            },
            {
                "id": 396,
                "name": "Central Region",
                "state_code": "C",
                "latitude": "44.29687500",
                "longitude": "-94.74017330"
            },
            {
                "id": 341,
                "name": "Dokolo District",
                "state_code": "317",
                "latitude": "1.96364210",
                "longitude": "33.03387670"
            },
            {
                "id": 372,
                "name": "Eastern Region",
                "state_code": "E",
                "latitude": "6.23740360",
                "longitude": "-0.45023680"
            },
            {
                "id": 366,
                "name": "Gomba District",
                "state_code": "121",
                "latitude": "0.22297910",
                "longitude": "31.67393710"
            },
            {
                "id": 413,
                "name": "Gulu District",
                "state_code": "304",
                "latitude": "2.81857760",
                "longitude": "32.44672380"
            },
            {
                "id": 339,
                "name": "Ibanda District",
                "state_code": "417",
                "latitude": "-0.09648900",
                "longitude": "30.57395790"
            },
            {
                "id": 340,
                "name": "Iganga District",
                "state_code": "203",
                "latitude": "0.66001370",
                "longitude": "33.48319060"
            },
            {
                "id": 383,
                "name": "Isingiro District",
                "state_code": "418",
                "latitude": "-0.84354300",
                "longitude": "30.80394740"
            },
            {
                "id": 367,
                "name": "Jinja District",
                "state_code": "204",
                "latitude": "0.53437430",
                "longitude": "33.30371430"
            },
            {
                "id": 434,
                "name": "Kaabong District",
                "state_code": "318",
                "latitude": "3.51262150",
                "longitude": "33.97500180"
            },
            {
                "id": 426,
                "name": "Kabale District",
                "state_code": "404",
                "latitude": "-1.24930840",
                "longitude": "30.06652360"
            },
            {
                "id": 326,
                "name": "Kabarole District",
                "state_code": "405",
                "latitude": "0.58507910",
                "longitude": "30.25127280"
            },
            {
                "id": 336,
                "name": "Kaberamaido District",
                "state_code": "213",
                "latitude": "1.69633220",
                "longitude": "33.21385100"
            },
            {
                "id": 403,
                "name": "Kagadi District",
                "state_code": "427",
                "latitude": "0.94007610",
                "longitude": "30.81256380"
            },
            {
                "id": 399,
                "name": "Kakumiro District",
                "state_code": "428",
                "latitude": "0.78080350",
                "longitude": "31.32413890"
            },
            {
                "id": 405,
                "name": "Kalangala District",
                "state_code": "101",
                "latitude": "-0.63505780",
                "longitude": "32.53727410"
            },
            {
                "id": 398,
                "name": "Kaliro District",
                "state_code": "222",
                "latitude": "1.04311070",
                "longitude": "33.48319060"
            },
            {
                "id": 394,
                "name": "Kalungu District",
                "state_code": "122",
                "latitude": "-0.09528310",
                "longitude": "31.76513620"
            },
            {
                "id": 382,
                "name": "Kampala District",
                "state_code": "102",
                "latitude": "0.34759640",
                "longitude": "32.58251970"
            },
            {
                "id": 334,
                "name": "Kamuli District",
                "state_code": "205",
                "latitude": "0.91871070",
                "longitude": "33.12390490"
            },
            {
                "id": 360,
                "name": "Kamwenge District",
                "state_code": "413",
                "latitude": "0.22579300",
                "longitude": "30.48184460"
            },
            {
                "id": 373,
                "name": "Kanungu District",
                "state_code": "414",
                "latitude": "-0.81952530",
                "longitude": "29.74260400"
            },
            {
                "id": 432,
                "name": "Kapchorwa District",
                "state_code": "206",
                "latitude": "1.33502050",
                "longitude": "34.39763560"
            },
            {
                "id": 440,
                "name": "Kasese District",
                "state_code": "406",
                "latitude": "0.06462850",
                "longitude": "30.06652360"
            },
            {
                "id": 420,
                "name": "Katakwi District",
                "state_code": "207",
                "latitude": "1.97310300",
                "longitude": "34.06414190"
            },
            {
                "id": 368,
                "name": "Kayunga District",
                "state_code": "112",
                "latitude": "0.98601820",
                "longitude": "32.85357550"
            },
            {
                "id": 436,
                "name": "Kibaale District",
                "state_code": "407",
                "latitude": "0.90668020",
                "longitude": "31.07937050"
            },
            {
                "id": 347,
                "name": "Kiboga District",
                "state_code": "103",
                "latitude": "0.96575900",
                "longitude": "31.71954590"
            },
            {
                "id": 338,
                "name": "Kibuku District",
                "state_code": "227",
                "latitude": "1.04528740",
                "longitude": "33.79925360"
            },
            {
                "id": 355,
                "name": "Kiruhura District",
                "state_code": "419",
                "latitude": "-0.19279980",
                "longitude": "30.80394740"
            },
            {
                "id": 346,
                "name": "Kiryandongo District",
                "state_code": "421",
                "latitude": "2.01799070",
                "longitude": "32.08374450"
            },
            {
                "id": 409,
                "name": "Kisoro District",
                "state_code": "408",
                "latitude": "-1.22094300",
                "longitude": "29.64991620"
            },
            {
                "id": 348,
                "name": "Kitgum District",
                "state_code": "305",
                "latitude": "3.33968290",
                "longitude": "33.16888830"
            },
            {
                "id": 345,
                "name": "Koboko District",
                "state_code": "319",
                "latitude": "3.52370580",
                "longitude": "31.03351000"
            },
            {
                "id": 401,
                "name": "Kole District",
                "state_code": "325",
                "latitude": "2.37010970",
                "longitude": "32.76330360"
            },
            {
                "id": 443,
                "name": "Kotido District",
                "state_code": "306",
                "latitude": "3.04156790",
                "longitude": "33.88577470"
            },
            {
                "id": 425,
                "name": "Kumi District",
                "state_code": "208",
                "latitude": "1.48769990",
                "longitude": "33.93039910"
            },
            {
                "id": 369,
                "name": "Kween District",
                "state_code": "228",
                "latitude": "1.44387900",
                "longitude": "34.59713200"
            },
            {
                "id": 325,
                "name": "Kyankwanzi District",
                "state_code": "123",
                "latitude": "1.09660370",
                "longitude": "31.71954590"
            },
            {
                "id": 437,
                "name": "Kyegegwa District",
                "state_code": "422",
                "latitude": "0.48181930",
                "longitude": "31.05500930"
            },
            {
                "id": 402,
                "name": "Kyenjojo District",
                "state_code": "415",
                "latitude": "0.60929230",
                "longitude": "30.64012310"
            },
            {
                "id": 448,
                "name": "Kyotera District",
                "state_code": "125",
                "latitude": "-0.63589880",
                "longitude": "31.54556370"
            },
            {
                "id": 411,
                "name": "Lamwo District",
                "state_code": "326",
                "latitude": "3.57075680",
                "longitude": "32.53727410"
            },
            {
                "id": 342,
                "name": "Lira District",
                "state_code": "307",
                "latitude": "2.23161690",
                "longitude": "32.94376670"
            },
            {
                "id": 445,
                "name": "Luuka District",
                "state_code": "229",
                "latitude": "0.72505990",
                "longitude": "33.30371430"
            },
            {
                "id": 433,
                "name": "Luwero District",
                "state_code": "104",
                "latitude": "0.82711180",
                "longitude": "32.62774550"
            },
            {
                "id": 417,
                "name": "Lwengo District",
                "state_code": "124",
                "latitude": "-0.41652880",
                "longitude": "31.39989950"
            },
            {
                "id": 376,
                "name": "Lyantonde District",
                "state_code": "114",
                "latitude": "-0.22406960",
                "longitude": "31.21684660"
            },
            {
                "id": 438,
                "name": "Manafwa District",
                "state_code": "223",
                "latitude": "0.90635990",
                "longitude": "34.28660910"
            },
            {
                "id": 421,
                "name": "Maracha District",
                "state_code": "320",
                "latitude": "3.28731270",
                "longitude": "30.94030230"
            },
            {
                "id": 356,
                "name": "Masaka District",
                "state_code": "105",
                "latitude": "-0.44636910",
                "longitude": "31.90179540"
            },
            {
                "id": 354,
                "name": "Masindi District",
                "state_code": "409",
                "latitude": "1.49203630",
                "longitude": "31.71954590"
            },
            {
                "id": 418,
                "name": "Mayuge District",
                "state_code": "214",
                "latitude": "-0.21829820",
                "longitude": "33.57280270"
            },
            {
                "id": 350,
                "name": "Mbale District",
                "state_code": "209",
                "latitude": "1.03442740",
                "longitude": "34.19768820"
            },
            {
                "id": 415,
                "name": "Mbarara District",
                "state_code": "410",
                "latitude": "-0.60715960",
                "longitude": "30.65450220"
            },
            {
                "id": 435,
                "name": "Mitooma District",
                "state_code": "423",
                "latitude": "-0.61932760",
                "longitude": "30.02029640"
            },
            {
                "id": 364,
                "name": "Mityana District",
                "state_code": "115",
                "latitude": "0.44548450",
                "longitude": "32.08374450"
            },
            {
                "id": 395,
                "name": "Moroto District",
                "state_code": "308",
                "latitude": "2.61685450",
                "longitude": "34.59713200"
            },
            {
                "id": 363,
                "name": "Moyo District",
                "state_code": "309",
                "latitude": "3.56964640",
                "longitude": "31.67393710"
            },
            {
                "id": 327,
                "name": "Mpigi District",
                "state_code": "106",
                "latitude": "0.22735280",
                "longitude": "32.32492360"
            },
            {
                "id": 371,
                "name": "Mubende District",
                "state_code": "107",
                "latitude": "0.57727580",
                "longitude": "31.53700030"
            },
            {
                "id": 410,
                "name": "Mukono District",
                "state_code": "108",
                "latitude": "0.28354760",
                "longitude": "32.76330360"
            },
            {
                "id": 393,
                "name": "Nakapiripirit District",
                "state_code": "311",
                "latitude": "1.96061730",
                "longitude": "34.59713200"
            },
            {
                "id": 423,
                "name": "Nakaseke District",
                "state_code": "116",
                "latitude": "1.22308480",
                "longitude": "32.08374450"
            },
            {
                "id": 406,
                "name": "Nakasongola District",
                "state_code": "109",
                "latitude": "1.34897210",
                "longitude": "32.44672380"
            },
            {
                "id": 351,
                "name": "Namayingo District",
                "state_code": "230",
                "latitude": "-0.28035750",
                "longitude": "33.75177230"
            },
            {
                "id": 400,
                "name": "Namisindwa District",
                "state_code": "234",
                "latitude": "0.90710100",
                "longitude": "34.35740370"
            },
            {
                "id": 337,
                "name": "Namutumba District",
                "state_code": "224",
                "latitude": "0.84926100",
                "longitude": "33.66233010"
            },
            {
                "id": 430,
                "name": "Napak District",
                "state_code": "327",
                "latitude": "2.36299450",
                "longitude": "34.24215970"
            },
            {
                "id": 446,
                "name": "Nebbi District",
                "state_code": "310",
                "latitude": "2.44093920",
                "longitude": "31.35416310"
            },
            {
                "id": 424,
                "name": "Ngora District",
                "state_code": "231",
                "latitude": "1.49081150",
                "longitude": "33.75177230"
            },
            {
                "id": 332,
                "name": "Northern Region",
                "state_code": "N",
                "latitude": "9.54392690",
                "longitude": "-0.90566230"
            },
            {
                "id": 422,
                "name": "Ntoroko District",
                "state_code": "424",
                "latitude": "1.07881780",
                "longitude": "30.38966510"
            },
            {
                "id": 404,
                "name": "Ntungamo District",
                "state_code": "411",
                "latitude": "-0.98073410",
                "longitude": "30.25127280"
            },
            {
                "id": 378,
                "name": "Nwoya District",
                "state_code": "328",
                "latitude": "2.56244400",
                "longitude": "31.90179540"
            },
            {
                "id": 374,
                "name": "Omoro District",
                "state_code": "331",
                "latitude": "2.71522300",
                "longitude": "32.49200880"
            },
            {
                "id": 390,
                "name": "Otuke District",
                "state_code": "329",
                "latitude": "2.52140590",
                "longitude": "33.34861470"
            },
            {
                "id": 397,
                "name": "Oyam District",
                "state_code": "321",
                "latitude": "2.27762810",
                "longitude": "32.44672380"
            },
            {
                "id": 408,
                "name": "Pader District",
                "state_code": "312",
                "latitude": "2.94306820",
                "longitude": "32.80844960"
            },
            {
                "id": 357,
                "name": "Pakwach District",
                "state_code": "332",
                "latitude": "2.46071410",
                "longitude": "31.49417380"
            },
            {
                "id": 412,
                "name": "Pallisa District",
                "state_code": "210",
                "latitude": "1.23242060",
                "longitude": "33.75177230"
            },
            {
                "id": 439,
                "name": "Rakai District",
                "state_code": "110",
                "latitude": "-0.70691350",
                "longitude": "31.53700030"
            },
            {
                "id": 358,
                "name": "Rubanda District",
                "state_code": "429",
                "latitude": "-1.18611900",
                "longitude": "29.84535760"
            },
            {
                "id": 442,
                "name": "Rubirizi District",
                "state_code": "425",
                "latitude": "-0.26424100",
                "longitude": "30.10840330"
            },
            {
                "id": 331,
                "name": "Rukiga District",
                "state_code": "431",
                "latitude": "-1.13263370",
                "longitude": "30.04341200"
            },
            {
                "id": 324,
                "name": "Rukungiri District",
                "state_code": "412",
                "latitude": "-0.75184900",
                "longitude": "29.92779470"
            },
            {
                "id": 427,
                "name": "Sembabule District",
                "state_code": "111",
                "latitude": "0.06377150",
                "longitude": "31.35416310"
            },
            {
                "id": 333,
                "name": "Serere District",
                "state_code": "232",
                "latitude": "1.49940330",
                "longitude": "33.54900780"
            },
            {
                "id": 407,
                "name": "Sheema District",
                "state_code": "426",
                "latitude": "-0.55152980",
                "longitude": "30.38966510"
            },
            {
                "id": 429,
                "name": "Sironko District",
                "state_code": "215",
                "latitude": "1.23022740",
                "longitude": "34.24910640"
            },
            {
                "id": 444,
                "name": "Soroti District",
                "state_code": "211",
                "latitude": "1.72291170",
                "longitude": "33.52800720"
            },
            {
                "id": 359,
                "name": "Tororo District",
                "state_code": "212",
                "latitude": "0.68709940",
                "longitude": "34.06414190"
            },
            {
                "id": 362,
                "name": "Wakiso District",
                "state_code": "113",
                "latitude": "0.06301900",
                "longitude": "32.44672380"
            },
            {
                "id": 370,
                "name": "Western Region",
                "state_code": "W",
                "latitude": "40.76672150",
                "longitude": "-111.88772030"
            },
            {
                "id": 330,
                "name": "Yumbe District",
                "state_code": "313",
                "latitude": "3.46980230",
                "longitude": "31.24832910"
            },
            {
                "id": 379,
                "name": "Zombo District",
                "state_code": "330",
                "latitude": "2.55442930",
                "longitude": "30.94173680"
            }
        ]
    },
    {
        "name": "Ukraine",
        "iso3": "UKR",
        "iso2": "UA",
        "phone_code": "380",
        "capital": "Kiev",
        "currency": "UAH",
        "currency_symbol": "â‚´",
        "tld": ".ua",
        "native": "Ð£ÐºÑ€Ð°Ñ—Ð½Ð°",
        "region": "Europe",
        "subregion": "Eastern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Kiev",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Simferopol",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "MSK",
                "tzName": "Moscow Time"
            },
            {
                "zoneName": "Europe\/Uzhgorod",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            },
            {
                "zoneName": "Europe\/Zaporozhye",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "EET",
                "tzName": "Eastern European Time"
            }
        ],
        "translations": {
            "kr": "ìš°í¬ë¼ì´ë‚˜",
            "br": "UcrÃ¢nia",
            "pt": "UcrÃ¢nia",
            "nl": "OekraÃ¯ne",
            "hr": "Ukrajina",
            "fa": "ÙˆÚ©Ø±Ø§ÛŒÙ†",
            "de": "Ukraine",
            "es": "Ucrania",
            "fr": "Ukraine",
            "ja": "ã‚¦ã‚¯ãƒ©ã‚¤ãƒŠ",
            "it": "Ucraina",
            "cn": "ä¹Œå…‹å…°"
        },
        "latitude": "49.00000000",
        "longitude": "32.00000000",
        "emoji": "ðŸ‡ºðŸ‡¦",
        "emojiU": "U+1F1FA U+1F1E6",
        "states": [
            {
                "id": 4689,
                "name": "Autonomous Republic of Crimea",
                "state_code": "43",
                "latitude": "44.95211700",
                "longitude": "34.10241700"
            },
            {
                "id": 4680,
                "name": "Cherkasy Oblast",
                "state_code": "71",
                "latitude": "49.44443300",
                "longitude": "32.05976700"
            },
            {
                "id": 4692,
                "name": "Chernihiv Oblast",
                "state_code": "74",
                "latitude": "51.49820000",
                "longitude": "31.28934990"
            },
            {
                "id": 4678,
                "name": "Chernivtsi Oblast",
                "state_code": "77",
                "latitude": "48.29168300",
                "longitude": "25.93521700"
            },
            {
                "id": 4675,
                "name": "Dnipropetrovsk Oblast",
                "state_code": "12",
                "latitude": "48.46471700",
                "longitude": "35.04618300"
            },
            {
                "id": 4691,
                "name": "Donetsk Oblast",
                "state_code": "14",
                "latitude": "48.01588300",
                "longitude": "37.80285000"
            },
            {
                "id": 4682,
                "name": "Ivano-Frankivsk Oblast",
                "state_code": "26",
                "latitude": "48.92263300",
                "longitude": "24.71111700"
            },
            {
                "id": 4686,
                "name": "Kharkiv Oblast",
                "state_code": "63",
                "latitude": "49.99350000",
                "longitude": "36.23038300"
            },
            {
                "id": 4684,
                "name": "Kherson Oblast",
                "state_code": "65",
                "latitude": "46.63541700",
                "longitude": "32.61686700"
            },
            {
                "id": 4681,
                "name": "Khmelnytsky Oblast",
                "state_code": "68",
                "latitude": "49.42298300",
                "longitude": "26.98713310"
            },
            {
                "id": 4676,
                "name": "Kiev",
                "state_code": "30",
                "latitude": "50.45010000",
                "longitude": "30.52340000"
            },
            {
                "id": 4677,
                "name": "Kirovohrad Oblast",
                "state_code": "35",
                "latitude": "48.50793300",
                "longitude": "32.26231700"
            },
            {
                "id": 4671,
                "name": "Kyiv Oblast",
                "state_code": "32",
                "latitude": "50.05295060",
                "longitude": "30.76671340"
            },
            {
                "id": 4673,
                "name": "Luhansk Oblast",
                "state_code": "09",
                "latitude": "48.57404100",
                "longitude": "39.30781500"
            },
            {
                "id": 4672,
                "name": "Lviv Oblast",
                "state_code": "46",
                "latitude": "49.83968300",
                "longitude": "24.02971700"
            },
            {
                "id": 4679,
                "name": "Mykolaiv Oblast",
                "state_code": "48",
                "latitude": "46.97503300",
                "longitude": "31.99458290"
            },
            {
                "id": 4688,
                "name": "Odessa Oblast",
                "state_code": "51",
                "latitude": "46.48458300",
                "longitude": "30.73260000"
            },
            {
                "id": 4683,
                "name": "Rivne Oblast",
                "state_code": "56",
                "latitude": "50.61990000",
                "longitude": "26.25161700"
            },
            {
                "id": 4685,
                "name": "Sumy Oblast",
                "state_code": "59",
                "latitude": "50.90770000",
                "longitude": "34.79810000"
            },
            {
                "id": 4674,
                "name": "Ternopil Oblast",
                "state_code": "61",
                "latitude": "49.55351700",
                "longitude": "25.59476700"
            },
            {
                "id": 4669,
                "name": "Vinnytsia Oblast",
                "state_code": "05",
                "latitude": "49.23308300",
                "longitude": "28.46821690"
            },
            {
                "id": 4690,
                "name": "Volyn Oblast",
                "state_code": "07",
                "latitude": "50.74723300",
                "longitude": "25.32538300"
            },
            {
                "id": 4670,
                "name": "Zakarpattia Oblast",
                "state_code": "21",
                "latitude": "48.62080000",
                "longitude": "22.28788300"
            },
            {
                "id": 4687,
                "name": "Zaporizhzhya Oblast",
                "state_code": "23",
                "latitude": "47.83880000",
                "longitude": "35.13956700"
            },
            {
                "id": 4668,
                "name": "Zhytomyr Oblast",
                "state_code": "18",
                "latitude": "50.25465000",
                "longitude": "28.65866690"
            }
        ]
    },
    {
        "name": "United Arab Emirates",
        "iso3": "ARE",
        "iso2": "AE",
        "phone_code": "971",
        "capital": "Abu Dhabi",
        "currency": "AED",
        "currency_symbol": "Ø¥.Ø¯",
        "tld": ".ae",
        "native": "Ø¯ÙˆÙ„Ø© Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Dubai",
                "gmtOffset": 14400,
                "gmtOffsetName": "UTC+04:00",
                "abbreviation": "GST",
                "tzName": "Gulf Standard Time"
            }
        ],
        "translations": {
            "kr": "ì•„ëžì—ë¯¸ë¦¬íŠ¸",
            "br": "Emirados Ã¡rabes Unidos",
            "pt": "Emirados Ã¡rabes Unidos",
            "nl": "Verenigde Arabische Emiraten",
            "hr": "Ujedinjeni Arapski Emirati",
            "fa": "Ø§Ù…Ø§Ø±Ø§Øª Ù…ØªØ­Ø¯Ù‡ Ø¹Ø±Ø¨ÛŒ",
            "de": "Vereinigte Arabische Emirate",
            "es": "Emiratos Ãrabes Unidos",
            "fr": "Ã‰mirats arabes unis",
            "ja": "ã‚¢ãƒ©ãƒ–é¦–é•·å›½é€£é‚¦",
            "it": "Emirati Arabi Uniti",
            "cn": "é˜¿æ‹‰ä¼¯è”åˆé…‹é•¿å›½"
        },
        "latitude": "24.00000000",
        "longitude": "54.00000000",
        "emoji": "ðŸ‡¦ðŸ‡ª",
        "emojiU": "U+1F1E6 U+1F1EA",
        "states": [
            {
                "id": 3396,
                "name": "Abu Dhabi Emirate",
                "state_code": "AZ",
                "latitude": "24.45388400",
                "longitude": "54.37734380"
            },
            {
                "id": 3395,
                "name": "Ajman Emirate",
                "state_code": "AJ",
                "latitude": "25.40521650",
                "longitude": "55.51364330"
            },
            {
                "id": 3391,
                "name": "Dubai",
                "state_code": "DU",
                "latitude": "25.20484930",
                "longitude": "55.27078280"
            },
            {
                "id": 3393,
                "name": "Fujairah",
                "state_code": "FU",
                "latitude": "25.12880990",
                "longitude": "56.32648490"
            },
            {
                "id": 3394,
                "name": "Ras al-Khaimah",
                "state_code": "RK",
                "latitude": "25.67413430",
                "longitude": "55.98041730"
            },
            {
                "id": 3390,
                "name": "Sharjah Emirate",
                "state_code": "SH",
                "latitude": "25.07539740",
                "longitude": "55.75784030"
            },
            {
                "id": 3392,
                "name": "Umm al-Quwain",
                "state_code": "UQ",
                "latitude": "25.54263240",
                "longitude": "55.54753480"
            }
        ]
    },
    {
        "name": "United Kingdom",
        "iso3": "GBR",
        "iso2": "GB",
        "phone_code": "44",
        "capital": "London",
        "currency": "GBP",
        "currency_symbol": "Â£",
        "tld": ".uk",
        "native": "United Kingdom",
        "region": "Europe",
        "subregion": "Northern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/London",
                "gmtOffset": 0,
                "gmtOffsetName": "UTCÂ±00",
                "abbreviation": "GMT",
                "tzName": "Greenwich Mean Time"
            }
        ],
        "translations": {
            "kr": "ì˜êµ­",
            "br": "Reino Unido",
            "pt": "Reino Unido",
            "nl": "Verenigd Koninkrijk",
            "hr": "Ujedinjeno Kraljevstvo",
            "fa": "Ø¨Ø±ÛŒØªØ§Ù†ÛŒØ§ÛŒ Ú©Ø¨ÛŒØ± Ùˆ Ø§ÛŒØ±Ù„Ù†Ø¯ Ø´Ù…Ø§Ù„ÛŒ",
            "de": "Vereinigtes KÃ¶nigreich",
            "es": "Reino Unido",
            "fr": "Royaume-Uni",
            "ja": "ã‚¤ã‚®ãƒªã‚¹",
            "it": "Regno Unito",
            "cn": "è‹±å›½"
        },
        "latitude": "54.00000000",
        "longitude": "-2.00000000",
        "emoji": "ðŸ‡¬ðŸ‡§",
        "emojiU": "U+1F1EC U+1F1E7",
        "states": [
            {
                "id": 2463,
                "name": "Aberdeen",
                "state_code": "ABE",
                "latitude": "57.14971700",
                "longitude": "-2.09427800"
            },
            {
                "id": 2401,
                "name": "Aberdeenshire",
                "state_code": "ABD",
                "latitude": "57.28687230",
                "longitude": "-2.38156840"
            },
            {
                "id": 2387,
                "name": "Angus",
                "state_code": "ANS",
                "latitude": "37.27578860",
                "longitude": "-95.65010330"
            },
            {
                "id": 2533,
                "name": "Antrim",
                "state_code": "ANT",
                "latitude": "54.71953380",
                "longitude": "-6.20724980"
            },
            {
                "id": 2412,
                "name": "Antrim and Newtownabbey",
                "state_code": "ANN",
                "latitude": "54.69568870",
                "longitude": "-5.94810690"
            },
            {
                "id": 2498,
                "name": "Ards",
                "state_code": "ARD",
                "latitude": "42.13918510",
                "longitude": "-87.86149720"
            },
            {
                "id": 2523,
                "name": "Ards and North Down",
                "state_code": "AND",
                "latitude": "54.58996450",
                "longitude": "-5.59849720"
            },
            {
                "id": 2392,
                "name": "Argyll and Bute",
                "state_code": "AGB",
                "latitude": "56.40062140",
                "longitude": "-5.48074800"
            },
            {
                "id": 2331,
                "name": "Armagh City and District Council",
                "state_code": "ARM",
                "latitude": "54.39325920",
                "longitude": "-6.45634010"
            },
            {
                "id": 2324,
                "name": "Armagh, Banbridge and Craigavon",
                "state_code": "ABC",
                "latitude": "54.39325920",
                "longitude": "-6.45634010"
            },
            {
                "id": 2378,
                "name": "Ascension Island",
                "state_code": "SH-AC",
                "latitude": "-7.94671660",
                "longitude": "-14.35591580"
            },
            {
                "id": 2363,
                "name": "Ballymena Borough",
                "state_code": "BLA",
                "latitude": "54.86426000",
                "longitude": "-6.27910740"
            },
            {
                "id": 2361,
                "name": "Ballymoney",
                "state_code": "BLY",
                "latitude": "55.07048880",
                "longitude": "-6.51737080"
            },
            {
                "id": 2315,
                "name": "Banbridge",
                "state_code": "BNB",
                "latitude": "54.34872900",
                "longitude": "-6.27048030"
            },
            {
                "id": 2499,
                "name": "Barnsley",
                "state_code": "BNS",
                "latitude": "34.29949560",
                "longitude": "-84.98458090"
            },
            {
                "id": 2339,
                "name": "Bath and North East Somerset",
                "state_code": "BAS",
                "latitude": "51.32501020",
                "longitude": "-2.47662410"
            },
            {
                "id": 2507,
                "name": "Bedford",
                "state_code": "BDF",
                "latitude": "32.84401700",
                "longitude": "-97.14306710"
            },
            {
                "id": 2311,
                "name": "Belfast district",
                "state_code": "BFS",
                "latitude": "54.61703660",
                "longitude": "-5.95318610"
            },
            {
                "id": 2425,
                "name": "Birmingham",
                "state_code": "BIR",
                "latitude": "33.51858920",
                "longitude": "-86.81035670"
            },
            {
                "id": 2329,
                "name": "Blackburn with Darwen",
                "state_code": "BBD",
                "latitude": "53.69575220",
                "longitude": "-2.46829850"
            },
            {
                "id": 2451,
                "name": "Blackpool",
                "state_code": "BPL",
                "latitude": "53.81750530",
                "longitude": "-3.03567480"
            },
            {
                "id": 2530,
                "name": "Blaenau Gwent County Borough",
                "state_code": "BGW",
                "latitude": "51.78757790",
                "longitude": "-3.20439310"
            },
            {
                "id": 2504,
                "name": "Bolton",
                "state_code": "BOL",
                "latitude": "44.37264760",
                "longitude": "-72.87876250"
            },
            {
                "id": 2342,
                "name": "Bournemouth",
                "state_code": "BMH",
                "latitude": "50.71916400",
                "longitude": "-1.88076900"
            },
            {
                "id": 2470,
                "name": "Bracknell Forest",
                "state_code": "BRC",
                "latitude": "51.41538280",
                "longitude": "-0.75364950"
            },
            {
                "id": 2529,
                "name": "Bradford",
                "state_code": "BRD",
                "latitude": "53.79598400",
                "longitude": "-1.75939800"
            },
            {
                "id": 2452,
                "name": "Bridgend County Borough",
                "state_code": "BGE",
                "latitude": "51.50831990",
                "longitude": "-3.58120750"
            },
            {
                "id": 2395,
                "name": "Brighton and Hove",
                "state_code": "BNH",
                "latitude": "50.82262880",
                "longitude": "-0.13704700"
            },
            {
                "id": 2405,
                "name": "Buckinghamshire",
                "state_code": "BKM",
                "latitude": "51.80722040",
                "longitude": "-0.81276640"
            },
            {
                "id": 2459,
                "name": "Bury",
                "state_code": "BUR",
                "latitude": "53.59334980",
                "longitude": "-2.29660540"
            },
            {
                "id": 2298,
                "name": "Caerphilly County Borough",
                "state_code": "CAY",
                "latitude": "51.66044650",
                "longitude": "-3.21787240"
            },
            {
                "id": 2517,
                "name": "Calderdale",
                "state_code": "CLD",
                "latitude": "53.72478450",
                "longitude": "-1.86583570"
            },
            {
                "id": 2423,
                "name": "Cambridgeshire",
                "state_code": "CAM",
                "latitude": "52.20529730",
                "longitude": "0.12181950"
            },
            {
                "id": 2484,
                "name": "Carmarthenshire",
                "state_code": "CMN",
                "latitude": "51.85723090",
                "longitude": "-4.31159590"
            },
            {
                "id": 2439,
                "name": "Carrickfergus Borough Council",
                "state_code": "CKF",
                "latitude": "54.72568430",
                "longitude": "-5.80937190"
            },
            {
                "id": 2525,
                "name": "Castlereagh",
                "state_code": "CSR",
                "latitude": "54.57567900",
                "longitude": "-5.88840280"
            },
            {
                "id": 2316,
                "name": "Causeway Coast and Glens",
                "state_code": "CCG",
                "latitude": "55.04318300",
                "longitude": "-6.67412880"
            },
            {
                "id": 2303,
                "name": "Central Bedfordshire",
                "state_code": "CBF",
                "latitude": "52.00297440",
                "longitude": "-0.46513890"
            },
            {
                "id": 2509,
                "name": "Ceredigion",
                "state_code": "CGN",
                "latitude": "52.21914290",
                "longitude": "-3.93212560"
            },
            {
                "id": 2444,
                "name": "Cheshire East",
                "state_code": "CHE",
                "latitude": "53.16104460",
                "longitude": "-2.21859320"
            },
            {
                "id": 2442,
                "name": "Cheshire West and Chester",
                "state_code": "CHW",
                "latitude": "53.23029740",
                "longitude": "-2.71511170"
            },
            {
                "id": 2528,
                "name": "City and County of Cardiff",
                "state_code": "CRF",
                "latitude": "51.48158100",
                "longitude": "-3.17909000"
            },
            {
                "id": 2433,
                "name": "City and County of Swansea",
                "state_code": "SWA",
                "latitude": "51.62144000",
                "longitude": "-3.94364600"
            },
            {
                "id": 2413,
                "name": "City of Bristol",
                "state_code": "BST",
                "latitude": "41.67352200",
                "longitude": "-72.94653750"
            },
            {
                "id": 2485,
                "name": "City of Derby",
                "state_code": "DER",
                "latitude": "37.54837550",
                "longitude": "-97.24851910"
            },
            {
                "id": 2475,
                "name": "City of Kingston upon Hull",
                "state_code": "KHL",
                "latitude": "53.76762360",
                "longitude": "-0.32741980"
            },
            {
                "id": 2318,
                "name": "City of Leicester",
                "state_code": "LCE",
                "latitude": "52.63687780",
                "longitude": "-1.13975920"
            },
            {
                "id": 2424,
                "name": "City of London",
                "state_code": "LND",
                "latitude": "51.51234430",
                "longitude": "-0.09098520"
            },
            {
                "id": 2359,
                "name": "City of Nottingham",
                "state_code": "NGM",
                "latitude": "52.95478320",
                "longitude": "-1.15810860"
            },
            {
                "id": 2297,
                "name": "City of Peterborough",
                "state_code": "PTE",
                "latitude": "44.30936360",
                "longitude": "-78.32015300"
            },
            {
                "id": 2514,
                "name": "City of Plymouth",
                "state_code": "PLY",
                "latitude": "42.37089410",
                "longitude": "-83.46971410"
            },
            {
                "id": 2305,
                "name": "City of Portsmouth",
                "state_code": "POR",
                "latitude": "36.83291500",
                "longitude": "-76.29755490"
            },
            {
                "id": 2294,
                "name": "City of Southampton",
                "state_code": "STH",
                "latitude": "50.90970040",
                "longitude": "-1.40435090"
            },
            {
                "id": 2506,
                "name": "City of Stoke-on-Trent",
                "state_code": "STE",
                "latitude": "53.00266800",
                "longitude": "-2.17940400"
            },
            {
                "id": 2372,
                "name": "City of Sunderland",
                "state_code": "SND",
                "latitude": "54.88614890",
                "longitude": "-1.47857970"
            },
            {
                "id": 2357,
                "name": "City of Westminster",
                "state_code": "WSM",
                "latitude": "39.57659770",
                "longitude": "-76.99721260"
            },
            {
                "id": 2489,
                "name": "City of Wolverhampton",
                "state_code": "WLV",
                "latitude": "52.58891200",
                "longitude": "-2.15646300"
            },
            {
                "id": 2426,
                "name": "City of York",
                "state_code": "YOR",
                "latitude": "53.95996510",
                "longitude": "-1.08729790"
            },
            {
                "id": 2450,
                "name": "Clackmannanshire",
                "state_code": "CLK",
                "latitude": "56.10753510",
                "longitude": "-3.75294090"
            },
            {
                "id": 2461,
                "name": "Coleraine Borough Council",
                "state_code": "CLR",
                "latitude": "55.14515700",
                "longitude": "-6.67598140"
            },
            {
                "id": 2352,
                "name": "Conwy County Borough",
                "state_code": "CWY",
                "latitude": "53.29350130",
                "longitude": "-3.72651610"
            },
            {
                "id": 2445,
                "name": "Cookstown District Council",
                "state_code": "CKT",
                "latitude": "54.64181580",
                "longitude": "-6.74438950"
            },
            {
                "id": 2312,
                "name": "Cornwall",
                "state_code": "CON",
                "latitude": "50.26604710",
                "longitude": "-5.05271250"
            },
            {
                "id": 2406,
                "name": "County Durham",
                "state_code": "DUR",
                "latitude": "54.72940990",
                "longitude": "-1.88115980"
            },
            {
                "id": 2438,
                "name": "Coventry",
                "state_code": "COV",
                "latitude": "52.40682200",
                "longitude": "-1.51969300"
            },
            {
                "id": 2449,
                "name": "Craigavon Borough Council",
                "state_code": "CGV",
                "latitude": "54.39325920",
                "longitude": "-6.45634010"
            },
            {
                "id": 2334,
                "name": "Cumbria",
                "state_code": "CMA",
                "latitude": "54.57723230",
                "longitude": "-2.79748350"
            },
            {
                "id": 2389,
                "name": "Darlington",
                "state_code": "DAL",
                "latitude": "34.29987620",
                "longitude": "-79.87617410"
            },
            {
                "id": 2497,
                "name": "Denbighshire",
                "state_code": "DEN",
                "latitude": "53.18422880",
                "longitude": "-3.42249850"
            },
            {
                "id": 2403,
                "name": "Derbyshire",
                "state_code": "DBY",
                "latitude": "53.10467820",
                "longitude": "-1.56238850"
            },
            {
                "id": 2446,
                "name": "Derry City and Strabane",
                "state_code": "DRS",
                "latitude": "55.00474430",
                "longitude": "-7.32092220"
            },
            {
                "id": 2417,
                "name": "Derry City Council",
                "state_code": "DRY",
                "latitude": "54.96907780",
                "longitude": "-7.19583510"
            },
            {
                "id": 2491,
                "name": "Devon",
                "state_code": "DEV",
                "latitude": "50.71555910",
                "longitude": "-3.53087500"
            },
            {
                "id": 2364,
                "name": "Doncaster",
                "state_code": "DNC",
                "latitude": "53.52282000",
                "longitude": "-1.12846200"
            },
            {
                "id": 2345,
                "name": "Dorset",
                "state_code": "DOR",
                "latitude": "50.74876350",
                "longitude": "-2.34447860"
            },
            {
                "id": 2304,
                "name": "Down District Council",
                "state_code": "DOW",
                "latitude": "54.24342870",
                "longitude": "-5.95779590"
            },
            {
                "id": 2457,
                "name": "Dudley",
                "state_code": "DUD",
                "latitude": "42.04336610",
                "longitude": "-71.92760330"
            },
            {
                "id": 2415,
                "name": "Dumfries and Galloway",
                "state_code": "DGY",
                "latitude": "55.07010730",
                "longitude": "-3.60525810"
            },
            {
                "id": 2511,
                "name": "Dundee",
                "state_code": "DND",
                "latitude": "56.46201800",
                "longitude": "-2.97072100"
            },
            {
                "id": 2508,
                "name": "Dungannon and South Tyrone Borough Council",
                "state_code": "DGN",
                "latitude": "54.50826840",
                "longitude": "-6.76658910"
            },
            {
                "id": 2374,
                "name": "East Ayrshire",
                "state_code": "EAY",
                "latitude": "55.45184960",
                "longitude": "-4.26444780"
            },
            {
                "id": 2454,
                "name": "East Dunbartonshire",
                "state_code": "EDU",
                "latitude": "55.97431620",
                "longitude": "-4.20229800"
            },
            {
                "id": 2462,
                "name": "East Lothian",
                "state_code": "ELN",
                "latitude": "55.94933830",
                "longitude": "-2.77044640"
            },
            {
                "id": 2333,
                "name": "East Renfrewshire",
                "state_code": "ERW",
                "latitude": "55.77047350",
                "longitude": "-4.33598210"
            },
            {
                "id": 2370,
                "name": "East Riding of Yorkshire",
                "state_code": "ERY",
                "latitude": "53.84161680",
                "longitude": "-0.43441060"
            },
            {
                "id": 2414,
                "name": "East Sussex",
                "state_code": "ESX",
                "latitude": "50.90859550",
                "longitude": "0.24941660"
            },
            {
                "id": 2428,
                "name": "Edinburgh",
                "state_code": "EDH",
                "latitude": "55.95325200",
                "longitude": "-3.18826700"
            },
            {
                "id": 2336,
                "name": "England",
                "state_code": "ENG",
                "latitude": "52.35551770",
                "longitude": "-1.17431970"
            },
            {
                "id": 2410,
                "name": "Essex",
                "state_code": "ESS",
                "latitude": "51.57424470",
                "longitude": "0.48567810"
            },
            {
                "id": 2344,
                "name": "Falkirk",
                "state_code": "FAL",
                "latitude": "56.00187750",
                "longitude": "-3.78391310"
            },
            {
                "id": 2366,
                "name": "Fermanagh and Omagh",
                "state_code": "FMO",
                "latitude": "54.45135240",
                "longitude": "-7.71250180"
            },
            {
                "id": 2531,
                "name": "Fermanagh District Council",
                "state_code": "FER",
                "latitude": "54.34479780",
                "longitude": "-7.63842180"
            },
            {
                "id": 2479,
                "name": "Fife",
                "state_code": "FIF",
                "latitude": "56.20820780",
                "longitude": "-3.14951750"
            },
            {
                "id": 2437,
                "name": "Flintshire",
                "state_code": "FLN",
                "latitude": "53.16686580",
                "longitude": "-3.14189080"
            },
            {
                "id": 2431,
                "name": "Gateshead",
                "state_code": "GAT",
                "latitude": "54.95268000",
                "longitude": "-1.60341100"
            },
            {
                "id": 2404,
                "name": "Glasgow",
                "state_code": "GLG",
                "latitude": "55.86423700",
                "longitude": "-4.25180600"
            },
            {
                "id": 2373,
                "name": "Gloucestershire",
                "state_code": "GLS",
                "latitude": "51.86421120",
                "longitude": "-2.23803350"
            },
            {
                "id": 2379,
                "name": "Gwynedd",
                "state_code": "GWN",
                "latitude": "52.92772660",
                "longitude": "-4.13348360"
            },
            {
                "id": 2466,
                "name": "Halton",
                "state_code": "HAL",
                "latitude": "43.53253720",
                "longitude": "-79.87448360"
            },
            {
                "id": 2435,
                "name": "Hampshire",
                "state_code": "HAM",
                "latitude": "51.05769480",
                "longitude": "-1.30806290"
            },
            {
                "id": 2309,
                "name": "Hartlepool",
                "state_code": "HPL",
                "latitude": "54.69174500",
                "longitude": "-1.21292600"
            },
            {
                "id": 2500,
                "name": "Herefordshire",
                "state_code": "HEF",
                "latitude": "52.07651640",
                "longitude": "-2.65441820"
            },
            {
                "id": 2369,
                "name": "Hertfordshire",
                "state_code": "HRT",
                "latitude": "51.80978230",
                "longitude": "-0.23767440"
            },
            {
                "id": 2383,
                "name": "Highland",
                "state_code": "HLD",
                "latitude": "36.29675080",
                "longitude": "-95.83803660"
            },
            {
                "id": 2388,
                "name": "Inverclyde",
                "state_code": "IVC",
                "latitude": "55.93165690",
                "longitude": "-4.68001580"
            },
            {
                "id": 2289,
                "name": "Isle of Wight",
                "state_code": "IOW",
                "latitude": "50.69384790",
                "longitude": "-1.30473400"
            },
            {
                "id": 2343,
                "name": "Isles of Scilly",
                "state_code": "IOS",
                "latitude": "49.92772610",
                "longitude": "-6.32749660"
            },
            {
                "id": 2464,
                "name": "Kent",
                "state_code": "KEN",
                "latitude": "41.15366740",
                "longitude": "-81.35788590"
            },
            {
                "id": 2371,
                "name": "Kirklees",
                "state_code": "KIR",
                "latitude": "53.59334320",
                "longitude": "-1.80095090"
            },
            {
                "id": 2330,
                "name": "Knowsley",
                "state_code": "KWL",
                "latitude": "53.45459400",
                "longitude": "-2.85290700"
            },
            {
                "id": 2495,
                "name": "Lancashire",
                "state_code": "LAN",
                "latitude": "53.76322540",
                "longitude": "-2.70440520"
            },
            {
                "id": 2515,
                "name": "Larne Borough Council",
                "state_code": "LRN",
                "latitude": "54.85780030",
                "longitude": "-5.82362240"
            },
            {
                "id": 2503,
                "name": "Leeds",
                "state_code": "LDS",
                "latitude": "53.80075540",
                "longitude": "-1.54907740"
            },
            {
                "id": 2516,
                "name": "Leicestershire",
                "state_code": "LEC",
                "latitude": "52.77257100",
                "longitude": "-1.20521260"
            },
            {
                "id": 2382,
                "name": "Limavady Borough Council",
                "state_code": "LMV",
                "latitude": "55.05168200",
                "longitude": "-6.94919440"
            },
            {
                "id": 2355,
                "name": "Lincolnshire",
                "state_code": "LIN",
                "latitude": "52.94518890",
                "longitude": "-0.16012460"
            },
            {
                "id": 2460,
                "name": "Lisburn and Castlereagh",
                "state_code": "LBC",
                "latitude": "54.49815840",
                "longitude": "-6.13067910"
            },
            {
                "id": 2494,
                "name": "Lisburn City Council",
                "state_code": "LSB",
                "latitude": "54.49815840",
                "longitude": "-6.13067910"
            },
            {
                "id": 2340,
                "name": "Liverpool",
                "state_code": "LIV",
                "latitude": "32.65649810",
                "longitude": "-115.47632410"
            },
            {
                "id": 2356,
                "name": "London Borough of Barking and Dagenham",
                "state_code": "BDG",
                "latitude": "51.55406660",
                "longitude": "0.13401700"
            },
            {
                "id": 2520,
                "name": "London Borough of Barnet",
                "state_code": "BNE",
                "latitude": "51.60496730",
                "longitude": "-0.20762950"
            },
            {
                "id": 2307,
                "name": "London Borough of Bexley",
                "state_code": "BEX",
                "latitude": "51.45190210",
                "longitude": "0.11717860"
            },
            {
                "id": 2291,
                "name": "London Borough of Brent",
                "state_code": "BEN",
                "latitude": "51.56728080",
                "longitude": "-0.27105680"
            },
            {
                "id": 2490,
                "name": "London Borough of Bromley",
                "state_code": "BRY",
                "latitude": "51.36797050",
                "longitude": "0.07006200"
            },
            {
                "id": 2349,
                "name": "London Borough of Camden",
                "state_code": "CMD",
                "latitude": "51.54547360",
                "longitude": "-0.16279020"
            },
            {
                "id": 2512,
                "name": "London Borough of Croydon",
                "state_code": "CRY",
                "latitude": "51.38274460",
                "longitude": "-0.09851630"
            },
            {
                "id": 2532,
                "name": "London Borough of Ealing",
                "state_code": "EAL",
                "latitude": "51.52503660",
                "longitude": "-0.34139650"
            },
            {
                "id": 2476,
                "name": "London Borough of Enfield",
                "state_code": "ENF",
                "latitude": "51.66229090",
                "longitude": "-0.11806510"
            },
            {
                "id": 2411,
                "name": "London Borough of Hackney",
                "state_code": "HCK",
                "latitude": "51.57344500",
                "longitude": "-0.07243760"
            },
            {
                "id": 2448,
                "name": "London Borough of Hammersmith and Fulham",
                "state_code": "HMF",
                "latitude": "51.49901560",
                "longitude": "-0.22915000"
            },
            {
                "id": 2306,
                "name": "London Borough of Haringey",
                "state_code": "HRY",
                "latitude": "51.59061130",
                "longitude": "-0.11097090"
            },
            {
                "id": 2385,
                "name": "London Borough of Harrow",
                "state_code": "HRW",
                "latitude": "51.58816270",
                "longitude": "-0.34228510"
            },
            {
                "id": 2347,
                "name": "London Borough of Havering",
                "state_code": "HAV",
                "latitude": "51.57792400",
                "longitude": "0.21208290"
            },
            {
                "id": 2376,
                "name": "London Borough of Hillingdon",
                "state_code": "HIL",
                "latitude": "51.53518320",
                "longitude": "-0.44813780"
            },
            {
                "id": 2380,
                "name": "London Borough of Hounslow",
                "state_code": "HNS",
                "latitude": "51.48283580",
                "longitude": "-0.38820620"
            },
            {
                "id": 2319,
                "name": "London Borough of Islington",
                "state_code": "ISL",
                "latitude": "51.54650630",
                "longitude": "-0.10580580"
            },
            {
                "id": 2396,
                "name": "London Borough of Lambeth",
                "state_code": "LBH",
                "latitude": "51.45714770",
                "longitude": "-0.12306810"
            },
            {
                "id": 2358,
                "name": "London Borough of Lewisham",
                "state_code": "LEW",
                "latitude": "51.44145790",
                "longitude": "-0.01170060"
            },
            {
                "id": 2483,
                "name": "London Borough of Merton",
                "state_code": "MRT",
                "latitude": "51.40977420",
                "longitude": "-0.21080840"
            },
            {
                "id": 2418,
                "name": "London Borough of Newham",
                "state_code": "NWM",
                "latitude": "51.52551620",
                "longitude": "0.03521630"
            },
            {
                "id": 2397,
                "name": "London Borough of Redbridge",
                "state_code": "RDB",
                "latitude": "51.58861210",
                "longitude": "0.08239820"
            },
            {
                "id": 2501,
                "name": "London Borough of Richmond upon Thames",
                "state_code": "RIC",
                "latitude": "51.46130540",
                "longitude": "-0.30377090"
            },
            {
                "id": 2432,
                "name": "London Borough of Southwark",
                "state_code": "SWK",
                "latitude": "51.48805720",
                "longitude": "-0.07628380"
            },
            {
                "id": 2313,
                "name": "London Borough of Sutton",
                "state_code": "STN",
                "latitude": "51.35737620",
                "longitude": "-0.17527960"
            },
            {
                "id": 2390,
                "name": "London Borough of Tower Hamlets",
                "state_code": "TWH",
                "latitude": "51.52026070",
                "longitude": "-0.02933960"
            },
            {
                "id": 2326,
                "name": "London Borough of Waltham Forest",
                "state_code": "WFT",
                "latitude": "51.58863830",
                "longitude": "-0.01176250"
            },
            {
                "id": 2434,
                "name": "London Borough of Wandsworth",
                "state_code": "WND",
                "latitude": "51.45682740",
                "longitude": "-0.18966380"
            },
            {
                "id": 2322,
                "name": "Magherafelt District Council",
                "state_code": "MFT",
                "latitude": "54.75532790",
                "longitude": "-6.60774870"
            },
            {
                "id": 2398,
                "name": "Manchester",
                "state_code": "MAN",
                "latitude": "53.48075930",
                "longitude": "-2.24263050"
            },
            {
                "id": 2381,
                "name": "Medway",
                "state_code": "MDW",
                "latitude": "42.14176410",
                "longitude": "-71.39672560"
            },
            {
                "id": 2328,
                "name": "Merthyr Tydfil County Borough",
                "state_code": "MTY",
                "latitude": "51.74674740",
                "longitude": "-3.38132750"
            },
            {
                "id": 2320,
                "name": "Metropolitan Borough of Wigan",
                "state_code": "WGN",
                "latitude": "53.51348120",
                "longitude": "-2.61069990"
            },
            {
                "id": 2429,
                "name": "Mid and East Antrim",
                "state_code": "MEA",
                "latitude": "54.93993410",
                "longitude": "-6.11374230"
            },
            {
                "id": 2399,
                "name": "Mid Ulster",
                "state_code": "MUL",
                "latitude": "54.64113010",
                "longitude": "-6.75225490"
            },
            {
                "id": 2332,
                "name": "Middlesbrough",
                "state_code": "MDB",
                "latitude": "54.57422700",
                "longitude": "-1.23495600"
            },
            {
                "id": 2519,
                "name": "Midlothian",
                "state_code": "MLN",
                "latitude": "32.47533500",
                "longitude": "-97.01031810"
            },
            {
                "id": 2416,
                "name": "Milton Keynes",
                "state_code": "MIK",
                "latitude": "52.08520380",
                "longitude": "-0.73331330"
            },
            {
                "id": 2402,
                "name": "Monmouthshire",
                "state_code": "MON",
                "latitude": "51.81161000",
                "longitude": "-2.71634170"
            },
            {
                "id": 2360,
                "name": "Moray",
                "state_code": "MRY",
                "latitude": "57.64984760",
                "longitude": "-3.31680390"
            },
            {
                "id": 2348,
                "name": "Moyle District Council",
                "state_code": "MYL",
                "latitude": "55.20473270",
                "longitude": "-6.25317400"
            },
            {
                "id": 2351,
                "name": "Neath Port Talbot County Borough",
                "state_code": "NTL",
                "latitude": "51.59785190",
                "longitude": "-3.78396680"
            },
            {
                "id": 2458,
                "name": "Newcastle upon Tyne",
                "state_code": "NET",
                "latitude": "54.97825200",
                "longitude": "-1.61778000"
            },
            {
                "id": 2524,
                "name": "Newport",
                "state_code": "NWP",
                "latitude": "37.52782340",
                "longitude": "-94.10438760"
            },
            {
                "id": 2350,
                "name": "Newry and Mourne District Council",
                "state_code": "NYM",
                "latitude": "54.17425050",
                "longitude": "-6.33919920"
            },
            {
                "id": 2534,
                "name": "Newry, Mourne and Down",
                "state_code": "NMD",
                "latitude": "54.24342870",
                "longitude": "-5.95779590"
            },
            {
                "id": 2317,
                "name": "Newtownabbey Borough Council",
                "state_code": "NTA",
                "latitude": "54.67924220",
                "longitude": "-5.95911020"
            },
            {
                "id": 2473,
                "name": "Norfolk",
                "state_code": "NFK",
                "latitude": "36.85076890",
                "longitude": "-76.28587260"
            },
            {
                "id": 2535,
                "name": "North Ayrshire",
                "state_code": "NAY",
                "latitude": "55.64167310",
                "longitude": "-4.75946000"
            },
            {
                "id": 2513,
                "name": "North Down Borough Council",
                "state_code": "NDN",
                "latitude": "54.65362970",
                "longitude": "-5.67249250"
            },
            {
                "id": 2384,
                "name": "North East Lincolnshire",
                "state_code": "NEL",
                "latitude": "53.56682010",
                "longitude": "-0.08150660"
            },
            {
                "id": 2487,
                "name": "North Lanarkshire",
                "state_code": "NLK",
                "latitude": "55.86624320",
                "longitude": "-3.96131440"
            },
            {
                "id": 2453,
                "name": "North Lincolnshire",
                "state_code": "NLN",
                "latitude": "53.60555920",
                "longitude": "-0.55965820"
            },
            {
                "id": 2430,
                "name": "North Somerset",
                "state_code": "NSM",
                "latitude": "51.38790280",
                "longitude": "-2.77810910"
            },
            {
                "id": 2521,
                "name": "North Tyneside",
                "state_code": "NTY",
                "latitude": "55.01823990",
                "longitude": "-1.48584360"
            },
            {
                "id": 2522,
                "name": "North Yorkshire",
                "state_code": "NYK",
                "latitude": "53.99150280",
                "longitude": "-1.54120150"
            },
            {
                "id": 2480,
                "name": "Northamptonshire",
                "state_code": "NTH",
                "latitude": "52.27299440",
                "longitude": "-0.87555150"
            },
            {
                "id": 2337,
                "name": "Northern Ireland",
                "state_code": "NIR",
                "latitude": "54.78771490",
                "longitude": "-6.49231450"
            },
            {
                "id": 2365,
                "name": "Northumberland",
                "state_code": "NBL",
                "latitude": "55.20825420",
                "longitude": "-2.07841380"
            },
            {
                "id": 2456,
                "name": "Nottinghamshire",
                "state_code": "NTT",
                "latitude": "53.10031900",
                "longitude": "-0.99363060"
            },
            {
                "id": 2477,
                "name": "Oldham",
                "state_code": "OLD",
                "latitude": "42.20405980",
                "longitude": "-71.20481190"
            },
            {
                "id": 2314,
                "name": "Omagh District Council",
                "state_code": "OMH",
                "latitude": "54.45135240",
                "longitude": "-7.71250180"
            },
            {
                "id": 2474,
                "name": "Orkney Islands",
                "state_code": "ORK",
                "latitude": "58.98094010",
                "longitude": "-2.96052060"
            },
            {
                "id": 2353,
                "name": "Outer Hebrides",
                "state_code": "ELS",
                "latitude": "57.75989180",
                "longitude": "-7.01940340"
            },
            {
                "id": 2321,
                "name": "Oxfordshire",
                "state_code": "OXF",
                "latitude": "51.76120560",
                "longitude": "-1.24646740"
            },
            {
                "id": 2486,
                "name": "Pembrokeshire",
                "state_code": "PEM",
                "latitude": "51.67407800",
                "longitude": "-4.90887850"
            },
            {
                "id": 2325,
                "name": "Perth and Kinross",
                "state_code": "PKN",
                "latitude": "56.39538170",
                "longitude": "-3.42835470"
            },
            {
                "id": 2302,
                "name": "Poole",
                "state_code": "POL",
                "latitude": "50.71505000",
                "longitude": "-1.98724800"
            },
            {
                "id": 2441,
                "name": "Powys",
                "state_code": "POW",
                "latitude": "52.64642490",
                "longitude": "-3.32609040"
            },
            {
                "id": 2455,
                "name": "Reading",
                "state_code": "RDG",
                "latitude": "36.14866590",
                "longitude": "-95.98400120"
            },
            {
                "id": 2527,
                "name": "Redcar and Cleveland",
                "state_code": "RCC",
                "latitude": "54.59713440",
                "longitude": "-1.07759970"
            },
            {
                "id": 2443,
                "name": "Renfrewshire",
                "state_code": "RFW",
                "latitude": "55.84665400",
                "longitude": "-4.53312590"
            },
            {
                "id": 2301,
                "name": "Rhondda Cynon Taf",
                "state_code": "RCT",
                "latitude": "51.64902070",
                "longitude": "-3.42886920"
            },
            {
                "id": 2327,
                "name": "Rochdale",
                "state_code": "RCH",
                "latitude": "53.60971360",
                "longitude": "-2.15610000"
            },
            {
                "id": 2308,
                "name": "Rotherham",
                "state_code": "ROT",
                "latitude": "53.43260350",
                "longitude": "-1.36350090"
            },
            {
                "id": 2492,
                "name": "Royal Borough of Greenwich",
                "state_code": "GRE",
                "latitude": "51.48346270",
                "longitude": "0.05862020"
            },
            {
                "id": 2368,
                "name": "Royal Borough of Kensington and Chelsea",
                "state_code": "KEC",
                "latitude": "51.49908050",
                "longitude": "-0.19382530"
            },
            {
                "id": 2481,
                "name": "Royal Borough of Kingston upon Thames",
                "state_code": "KTT",
                "latitude": "51.37811700",
                "longitude": "-0.29270900"
            },
            {
                "id": 2472,
                "name": "Rutland",
                "state_code": "RUT",
                "latitude": "43.61062370",
                "longitude": "-72.97260650"
            },
            {
                "id": 2502,
                "name": "Saint Helena",
                "state_code": "SH-HL",
                "latitude": "-15.96501040",
                "longitude": "-5.70892410"
            },
            {
                "id": 2493,
                "name": "Salford",
                "state_code": "SLF",
                "latitude": "53.48752350",
                "longitude": "-2.29012640"
            },
            {
                "id": 2341,
                "name": "Sandwell",
                "state_code": "SAW",
                "latitude": "52.53616740",
                "longitude": "-2.01079300"
            },
            {
                "id": 2335,
                "name": "Scotland",
                "state_code": "SCT",
                "latitude": "56.49067120",
                "longitude": "-4.20264580"
            },
            {
                "id": 2346,
                "name": "Scottish Borders",
                "state_code": "SCB",
                "latitude": "55.54856970",
                "longitude": "-2.78613880"
            },
            {
                "id": 2518,
                "name": "Sefton",
                "state_code": "SFT",
                "latitude": "53.50344490",
                "longitude": "-2.97035900"
            },
            {
                "id": 2295,
                "name": "Sheffield",
                "state_code": "SHF",
                "latitude": "36.09507430",
                "longitude": "-80.27884660"
            },
            {
                "id": 2300,
                "name": "Shetland Islands",
                "state_code": "ZET",
                "latitude": "60.52965070",
                "longitude": "-1.26594090"
            },
            {
                "id": 2407,
                "name": "Shropshire",
                "state_code": "SHR",
                "latitude": "52.70636570",
                "longitude": "-2.74178490"
            },
            {
                "id": 2427,
                "name": "Slough",
                "state_code": "SLG",
                "latitude": "51.51053840",
                "longitude": "-0.59504060"
            },
            {
                "id": 2469,
                "name": "Solihull",
                "state_code": "SOL",
                "latitude": "52.41181100",
                "longitude": "-1.77761000"
            },
            {
                "id": 2386,
                "name": "Somerset",
                "state_code": "SOM",
                "latitude": "51.10509700",
                "longitude": "-2.92623070"
            },
            {
                "id": 2377,
                "name": "South Ayrshire",
                "state_code": "SAY",
                "latitude": "55.45889880",
                "longitude": "-4.62919940"
            },
            {
                "id": 2400,
                "name": "South Gloucestershire",
                "state_code": "SGC",
                "latitude": "51.52643610",
                "longitude": "-2.47284870"
            },
            {
                "id": 2362,
                "name": "South Lanarkshire",
                "state_code": "SLK",
                "latitude": "55.67359090",
                "longitude": "-3.78196610"
            },
            {
                "id": 2409,
                "name": "South Tyneside",
                "state_code": "STY",
                "latitude": "54.96366930",
                "longitude": "-1.44186340"
            },
            {
                "id": 2323,
                "name": "Southend-on-Sea",
                "state_code": "SOS",
                "latitude": "51.54592690",
                "longitude": "0.70771230"
            },
            {
                "id": 2290,
                "name": "St Helens",
                "state_code": "SHN",
                "latitude": "45.85896100",
                "longitude": "-122.82123560"
            },
            {
                "id": 2447,
                "name": "Staffordshire",
                "state_code": "STS",
                "latitude": "52.87927450",
                "longitude": "-2.05718680"
            },
            {
                "id": 2488,
                "name": "Stirling",
                "state_code": "STG",
                "latitude": "56.11652270",
                "longitude": "-3.93690290"
            },
            {
                "id": 2394,
                "name": "Stockport",
                "state_code": "SKP",
                "latitude": "53.41063160",
                "longitude": "-2.15753320"
            },
            {
                "id": 2421,
                "name": "Stockton-on-Tees",
                "state_code": "STT",
                "latitude": "54.57045510",
                "longitude": "-1.32898210"
            },
            {
                "id": 2393,
                "name": "Strabane District Council",
                "state_code": "STB",
                "latitude": "54.82738650",
                "longitude": "-7.46331030"
            },
            {
                "id": 2467,
                "name": "Suffolk",
                "state_code": "SFK",
                "latitude": "52.18724720",
                "longitude": "0.97078010"
            },
            {
                "id": 2526,
                "name": "Surrey",
                "state_code": "SRY",
                "latitude": "51.31475930",
                "longitude": "-0.55995010"
            },
            {
                "id": 2422,
                "name": "Swindon",
                "state_code": "SWD",
                "latitude": "51.55577390",
                "longitude": "-1.77971760"
            },
            {
                "id": 2367,
                "name": "Tameside",
                "state_code": "TAM",
                "latitude": "53.48058280",
                "longitude": "-2.08098910"
            },
            {
                "id": 2310,
                "name": "Telford and Wrekin",
                "state_code": "TFW",
                "latitude": "52.74099160",
                "longitude": "-2.48685860"
            },
            {
                "id": 2468,
                "name": "Thurrock",
                "state_code": "THR",
                "latitude": "51.49345570",
                "longitude": "0.35291970"
            },
            {
                "id": 2478,
                "name": "Torbay",
                "state_code": "TOB",
                "latitude": "50.43923290",
                "longitude": "-3.53698990"
            },
            {
                "id": 2496,
                "name": "Torfaen",
                "state_code": "TOF",
                "latitude": "51.70022530",
                "longitude": "-3.04460150"
            },
            {
                "id": 2293,
                "name": "Trafford",
                "state_code": "TRF",
                "latitude": "40.38562460",
                "longitude": "-79.75893470"
            },
            {
                "id": 2375,
                "name": "United Kingdom",
                "state_code": "UKM",
                "latitude": "55.37805100",
                "longitude": "-3.43597300"
            },
            {
                "id": 2299,
                "name": "Vale of Glamorgan",
                "state_code": "VGL",
                "latitude": "51.40959580",
                "longitude": "-3.48481670"
            },
            {
                "id": 2465,
                "name": "Wakefield",
                "state_code": "WKF",
                "latitude": "42.50393950",
                "longitude": "-71.07233910"
            },
            {
                "id": 2338,
                "name": "Wales",
                "state_code": "WLS",
                "latitude": "52.13066070",
                "longitude": "-3.78371170"
            },
            {
                "id": 2292,
                "name": "Walsall",
                "state_code": "WLL",
                "latitude": "52.58621400",
                "longitude": "-1.98291900"
            },
            {
                "id": 2420,
                "name": "Warrington",
                "state_code": "WRT",
                "latitude": "40.24927410",
                "longitude": "-75.13406040"
            },
            {
                "id": 2505,
                "name": "Warwickshire",
                "state_code": "WAR",
                "latitude": "52.26713530",
                "longitude": "-1.46752160"
            },
            {
                "id": 2471,
                "name": "West Berkshire",
                "state_code": "WBK",
                "latitude": "51.43082550",
                "longitude": "-1.14449270"
            },
            {
                "id": 2440,
                "name": "West Dunbartonshire",
                "state_code": "WDU",
                "latitude": "55.94509250",
                "longitude": "-4.56462590"
            },
            {
                "id": 2354,
                "name": "West Lothian",
                "state_code": "WLN",
                "latitude": "55.90701980",
                "longitude": "-3.55171670"
            },
            {
                "id": 2296,
                "name": "West Sussex",
                "state_code": "WSX",
                "latitude": "50.92801430",
                "longitude": "-0.46170750"
            },
            {
                "id": 2391,
                "name": "Wiltshire",
                "state_code": "WIL",
                "latitude": "51.34919960",
                "longitude": "-1.99271050"
            },
            {
                "id": 2482,
                "name": "Windsor and Maidenhead",
                "state_code": "WNM",
                "latitude": "51.47997120",
                "longitude": "-0.62425650"
            },
            {
                "id": 2408,
                "name": "Wirral",
                "state_code": "WRL",
                "latitude": "53.37271810",
                "longitude": "-3.07375400"
            },
            {
                "id": 2419,
                "name": "Wokingham",
                "state_code": "WOK",
                "latitude": "51.41045700",
                "longitude": "-0.83386100"
            },
            {
                "id": 2510,
                "name": "Worcestershire",
                "state_code": "WOR",
                "latitude": "52.25452250",
                "longitude": "-2.26683820"
            },
            {
                "id": 2436,
                "name": "Wrexham County Borough",
                "state_code": "WRX",
                "latitude": "53.03013780",
                "longitude": "-3.02614870"
            }
        ]
    },
    {
        "name": "United States",
        "iso3": "USA",
        "iso2": "US",
        "phone_code": "1",
        "capital": "Washington",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".us",
        "native": "United States",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "America\/Adak",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "HST",
                "tzName": "Hawaiiâ€“Aleutian Standard Time"
            },
            {
                "zoneName": "America\/Anchorage",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Boise",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Chicago",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Denver",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Detroit",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Indianapolis",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Knox",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Marengo",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Petersburg",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Tell_City",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Vevay",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Vincennes",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Indiana\/Winamac",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Juneau",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Kentucky\/Louisville",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Kentucky\/Monticello",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Los_Angeles",
                "gmtOffset": -28800,
                "gmtOffsetName": "UTC-08:00",
                "abbreviation": "PST",
                "tzName": "Pacific Standard Time (North America"
            },
            {
                "zoneName": "America\/Menominee",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Metlakatla",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/New_York",
                "gmtOffset": -18000,
                "gmtOffsetName": "UTC-05:00",
                "abbreviation": "EST",
                "tzName": "Eastern Standard Time (North America"
            },
            {
                "zoneName": "America\/Nome",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/North_Dakota\/Beulah",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/North_Dakota\/Center",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/North_Dakota\/New_Salem",
                "gmtOffset": -21600,
                "gmtOffsetName": "UTC-06:00",
                "abbreviation": "CST",
                "tzName": "Central Standard Time (North America"
            },
            {
                "zoneName": "America\/Phoenix",
                "gmtOffset": -25200,
                "gmtOffsetName": "UTC-07:00",
                "abbreviation": "MST",
                "tzName": "Mountain Standard Time (North America"
            },
            {
                "zoneName": "America\/Sitka",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "America\/Yakutat",
                "gmtOffset": -32400,
                "gmtOffsetName": "UTC-09:00",
                "abbreviation": "AKST",
                "tzName": "Alaska Standard Time"
            },
            {
                "zoneName": "Pacific\/Honolulu",
                "gmtOffset": -36000,
                "gmtOffsetName": "UTC-10:00",
                "abbreviation": "HST",
                "tzName": "Hawaiiâ€“Aleutian Standard Time"
            }
        ],
        "translations": {
            "kr": "ë¯¸êµ­",
            "br": "Estados Unidos",
            "pt": "Estados Unidos",
            "nl": "Verenigde Staten",
            "hr": "Sjedinjene AmeriÄke DrÅ¾ave",
            "fa": "Ø§ÛŒØ§Ù„Ø§Øª Ù…ØªØ­Ø¯Ù‡ Ø¢Ù…Ø±ÛŒÚ©Ø§",
            "de": "Vereinigte Staaten von Amerika",
            "es": "Estados Unidos",
            "fr": "Ã‰tats-Unis",
            "ja": "ã‚¢ãƒ¡ãƒªã‚«åˆè¡†å›½",
            "it": "Stati Uniti D'America",
            "cn": "ç¾Žå›½"
        },
        "latitude": "38.00000000",
        "longitude": "-97.00000000",
        "emoji": "ðŸ‡ºðŸ‡¸",
        "emojiU": "U+1F1FA U+1F1F8",
        "states": [
            {
                "id": 1456,
                "name": "Alabama",
                "state_code": "AL",
                "latitude": "32.31823140",
                "longitude": "-86.90229800"
            },
            {
                "id": 1400,
                "name": "Alaska",
                "state_code": "AK",
                "latitude": "64.20084130",
                "longitude": "-149.49367330"
            },
            {
                "id": 1424,
                "name": "American Samoa",
                "state_code": "AS",
                "latitude": "-14.27097200",
                "longitude": "-170.13221700"
            },
            {
                "id": 1434,
                "name": "Arizona",
                "state_code": "AZ",
                "latitude": "34.04892810",
                "longitude": "-111.09373110"
            },
            {
                "id": 1444,
                "name": "Arkansas",
                "state_code": "AR",
                "latitude": "35.20105000",
                "longitude": "-91.83183340"
            },
            {
                "id": 1402,
                "name": "Baker Island",
                "state_code": "UM-81",
                "latitude": "0.19362660",
                "longitude": "-176.47690800"
            },
            {
                "id": 1416,
                "name": "California",
                "state_code": "CA",
                "latitude": "36.77826100",
                "longitude": "-119.41793240"
            },
            {
                "id": 1450,
                "name": "Colorado",
                "state_code": "CO",
                "latitude": "39.55005070",
                "longitude": "-105.78206740"
            },
            {
                "id": 1435,
                "name": "Connecticut",
                "state_code": "CT",
                "latitude": "41.60322070",
                "longitude": "-73.08774900"
            },
            {
                "id": 1399,
                "name": "Delaware",
                "state_code": "DE",
                "latitude": "38.91083250",
                "longitude": "-75.52766990"
            },
            {
                "id": 1437,
                "name": "District of Columbia",
                "state_code": "DC",
                "latitude": "38.90719230",
                "longitude": "-77.03687070"
            },
            {
                "id": 1436,
                "name": "Florida",
                "state_code": "FL",
                "latitude": "27.66482740",
                "longitude": "-81.51575350"
            },
            {
                "id": 1455,
                "name": "Georgia",
                "state_code": "GA",
                "latitude": "32.16562210",
                "longitude": "-82.90007510"
            },
            {
                "id": 1412,
                "name": "Guam",
                "state_code": "GU",
                "latitude": "13.44430400",
                "longitude": "144.79373100"
            },
            {
                "id": 1411,
                "name": "Hawaii",
                "state_code": "HI",
                "latitude": "19.89676620",
                "longitude": "-155.58278180"
            },
            {
                "id": 1398,
                "name": "Howland Island",
                "state_code": "UM-84",
                "latitude": "0.81132190",
                "longitude": "-176.61827360"
            },
            {
                "id": 1460,
                "name": "Idaho",
                "state_code": "ID",
                "latitude": "44.06820190",
                "longitude": "-114.74204080"
            },
            {
                "id": 1425,
                "name": "Illinois",
                "state_code": "IL",
                "latitude": "40.63312490",
                "longitude": "-89.39852830"
            },
            {
                "id": 1440,
                "name": "Indiana",
                "state_code": "IN",
                "latitude": "40.26719410",
                "longitude": "-86.13490190"
            },
            {
                "id": 1459,
                "name": "Iowa",
                "state_code": "IA",
                "latitude": "41.87800250",
                "longitude": "-93.09770200"
            },
            {
                "id": 1410,
                "name": "Jarvis Island",
                "state_code": "UM-86",
                "latitude": "-0.37435030",
                "longitude": "-159.99672060"
            },
            {
                "id": 1428,
                "name": "Johnston Atoll",
                "state_code": "UM-67",
                "latitude": "16.72950350",
                "longitude": "-169.53364770"
            },
            {
                "id": 1406,
                "name": "Kansas",
                "state_code": "KS",
                "latitude": "39.01190200",
                "longitude": "-98.48424650"
            },
            {
                "id": 1419,
                "name": "Kentucky",
                "state_code": "KY",
                "latitude": "37.83933320",
                "longitude": "-84.27001790"
            },
            {
                "id": 1403,
                "name": "Kingman Reef",
                "state_code": "UM-89",
                "latitude": "6.38333300",
                "longitude": "-162.41666700"
            },
            {
                "id": 1457,
                "name": "Louisiana",
                "state_code": "LA",
                "latitude": "30.98429770",
                "longitude": "-91.96233270"
            },
            {
                "id": 1453,
                "name": "Maine",
                "state_code": "ME",
                "latitude": "45.25378300",
                "longitude": "-69.44546890"
            },
            {
                "id": 1401,
                "name": "Maryland",
                "state_code": "MD",
                "latitude": "39.04575490",
                "longitude": "-76.64127120"
            },
            {
                "id": 1433,
                "name": "Massachusetts",
                "state_code": "MA",
                "latitude": "42.40721070",
                "longitude": "-71.38243740"
            },
            {
                "id": 1426,
                "name": "Michigan",
                "state_code": "MI",
                "latitude": "44.31484430",
                "longitude": "-85.60236430"
            },
            {
                "id": 1438,
                "name": "Midway Atoll",
                "state_code": "UM-71",
                "latitude": "28.20721680",
                "longitude": "-177.37349260"
            },
            {
                "id": 1420,
                "name": "Minnesota",
                "state_code": "MN",
                "latitude": "46.72955300",
                "longitude": "-94.68589980"
            },
            {
                "id": 1430,
                "name": "Mississippi",
                "state_code": "MS",
                "latitude": "32.35466790",
                "longitude": "-89.39852830"
            },
            {
                "id": 1451,
                "name": "Missouri",
                "state_code": "MO",
                "latitude": "37.96425290",
                "longitude": "-91.83183340"
            },
            {
                "id": 1446,
                "name": "Montana",
                "state_code": "MT",
                "latitude": "46.87968220",
                "longitude": "-110.36256580"
            },
            {
                "id": 1439,
                "name": "Navassa Island",
                "state_code": "UM-76",
                "latitude": "18.41006890",
                "longitude": "-75.01146120"
            },
            {
                "id": 1408,
                "name": "Nebraska",
                "state_code": "NE",
                "latitude": "41.49253740",
                "longitude": "-99.90181310"
            },
            {
                "id": 1458,
                "name": "Nevada",
                "state_code": "NV",
                "latitude": "38.80260970",
                "longitude": "-116.41938900"
            },
            {
                "id": 1404,
                "name": "New Hampshire",
                "state_code": "NH",
                "latitude": "43.19385160",
                "longitude": "-71.57239530"
            },
            {
                "id": 1417,
                "name": "New Jersey",
                "state_code": "NJ",
                "latitude": "40.05832380",
                "longitude": "-74.40566120"
            },
            {
                "id": 1423,
                "name": "New Mexico",
                "state_code": "NM",
                "latitude": "34.51994020",
                "longitude": "-105.87009010"
            },
            {
                "id": 1452,
                "name": "New York",
                "state_code": "NY",
                "latitude": "40.71277530",
                "longitude": "-74.00597280"
            },
            {
                "id": 1447,
                "name": "North Carolina",
                "state_code": "NC",
                "latitude": "35.75957310",
                "longitude": "-79.01929970"
            },
            {
                "id": 1418,
                "name": "North Dakota",
                "state_code": "ND",
                "latitude": "47.55149260",
                "longitude": "-101.00201190"
            },
            {
                "id": 1431,
                "name": "Northern Mariana Islands",
                "state_code": "MP",
                "latitude": "15.09790000",
                "longitude": "145.67390000"
            },
            {
                "id": 4851,
                "name": "Ohio",
                "state_code": "OH",
                "latitude": "40.41728710",
                "longitude": "-82.90712300"
            },
            {
                "id": 1421,
                "name": "Oklahoma",
                "state_code": "OK",
                "latitude": "35.46756020",
                "longitude": "-97.51642760"
            },
            {
                "id": 1415,
                "name": "Oregon",
                "state_code": "OR",
                "latitude": "43.80413340",
                "longitude": "-120.55420120"
            },
            {
                "id": 1448,
                "name": "Palmyra Atoll",
                "state_code": "UM-95",
                "latitude": "5.88850260",
                "longitude": "-162.07866560"
            },
            {
                "id": 1422,
                "name": "Pennsylvania",
                "state_code": "PA",
                "latitude": "41.20332160",
                "longitude": "-77.19452470"
            },
            {
                "id": 1449,
                "name": "Puerto Rico",
                "state_code": "PR",
                "latitude": "18.22083300",
                "longitude": "-66.59014900"
            },
            {
                "id": 1461,
                "name": "Rhode Island",
                "state_code": "RI",
                "latitude": "41.58009450",
                "longitude": "-71.47742910"
            },
            {
                "id": 1443,
                "name": "South Carolina",
                "state_code": "SC",
                "latitude": "33.83608100",
                "longitude": "-81.16372450"
            },
            {
                "id": 1445,
                "name": "South Dakota",
                "state_code": "SD",
                "latitude": "43.96951480",
                "longitude": "-99.90181310"
            },
            {
                "id": 1454,
                "name": "Tennessee",
                "state_code": "TN",
                "latitude": "35.51749130",
                "longitude": "-86.58044730"
            },
            {
                "id": 1407,
                "name": "Texas",
                "state_code": "TX",
                "latitude": "31.96859880",
                "longitude": "-99.90181310"
            },
            {
                "id": 1432,
                "name": "United States Minor Outlying Islands",
                "state_code": "UM",
                "latitude": "19.28231920",
                "longitude": "166.64704700"
            },
            {
                "id": 1413,
                "name": "United States Virgin Islands",
                "state_code": "VI",
                "latitude": "18.33576500",
                "longitude": "-64.89633500"
            },
            {
                "id": 1414,
                "name": "Utah",
                "state_code": "UT",
                "latitude": "39.32098010",
                "longitude": "-111.09373110"
            },
            {
                "id": 1409,
                "name": "Vermont",
                "state_code": "VT",
                "latitude": "44.55880280",
                "longitude": "-72.57784150"
            },
            {
                "id": 1427,
                "name": "Virginia",
                "state_code": "VA",
                "latitude": "37.43157340",
                "longitude": "-78.65689420"
            },
            {
                "id": 1405,
                "name": "Wake Island",
                "state_code": "UM-79",
                "latitude": "19.27961900",
                "longitude": "166.64993480"
            },
            {
                "id": 1462,
                "name": "Washington",
                "state_code": "WA",
                "latitude": "47.75107410",
                "longitude": "-120.74013850"
            },
            {
                "id": 1429,
                "name": "West Virginia",
                "state_code": "WV",
                "latitude": "38.59762620",
                "longitude": "-80.45490260"
            },
            {
                "id": 1441,
                "name": "Wisconsin",
                "state_code": "WI",
                "latitude": "43.78443970",
                "longitude": "-88.78786780"
            },
            {
                "id": 1442,
                "name": "Wyoming",
                "state_code": "WY",
                "latitude": "43.07596780",
                "longitude": "-107.29028390"
            }
        ]
    },
    {
        "name": "United States Minor Outlying Islands",
        "iso3": "UMI",
        "iso2": "UM",
        "phone_code": "1",
        "capital": "",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".us",
        "native": "United States Minor Outlying Islands",
        "region": "Americas",
        "subregion": "Northern America",
        "timezones": [
            {
                "zoneName": "Pacific\/Midway",
                "gmtOffset": -39600,
                "gmtOffsetName": "UTC-11:00",
                "abbreviation": "SST",
                "tzName": "Samoa Standard Time"
            },
            {
                "zoneName": "Pacific\/Wake",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "WAKT",
                "tzName": "Wake Island Time"
            }
        ],
        "translations": {
            "kr": "ë¯¸êµ­ë ¹ êµ°ì†Œ ì œë„",
            "br": "Ilhas Menores Distantes dos Estados Unidos",
            "pt": "Ilhas Menores Distantes dos Estados Unidos",
            "nl": "Kleine afgelegen eilanden van de Verenigde Staten",
            "hr": "Mali udaljeni otoci SAD-a",
            "fa": "Ø¬Ø²Ø§ÛŒØ± Ú©ÙˆÚ†Ú© Ø­Ø§Ø´ÛŒÙ‡â€ŒØ§ÛŒ Ø§ÛŒØ§Ù„Ø§Øª Ù…ØªØ­Ø¯Ù‡ Ø¢Ù…Ø±ÛŒÚ©Ø§",
            "de": "Kleinere Inselbesitzungen der Vereinigten Staaten",
            "es": "Islas Ultramarinas Menores de Estados Unidos",
            "fr": "ÃŽles mineures Ã©loignÃ©es des Ã‰tats-Unis",
            "ja": "åˆè¡†å›½é ˜æœ‰å°é›¢å³¶",
            "it": "Isole minori esterne degli Stati Uniti d'America",
            "cn": "ç¾Žå›½æœ¬åœŸå¤–å°å²›å±¿"
        },
        "latitude": "0.00000000",
        "longitude": "0.00000000",
        "emoji": "ðŸ‡ºðŸ‡²",
        "emojiU": "U+1F1FA U+1F1F2",
        "states": []
    },
    {
        "name": "Uruguay",
        "iso3": "URY",
        "iso2": "UY",
        "phone_code": "598",
        "capital": "Montevideo",
        "currency": "UYU",
        "currency_symbol": "$",
        "tld": ".uy",
        "native": "Uruguay",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Montevideo",
                "gmtOffset": -10800,
                "gmtOffsetName": "UTC-03:00",
                "abbreviation": "UYT",
                "tzName": "Uruguay Standard Time"
            }
        ],
        "translations": {
            "kr": "ìš°ë£¨ê³¼ì´",
            "br": "Uruguai",
            "pt": "Uruguai",
            "nl": "Uruguay",
            "hr": "Urugvaj",
            "fa": "Ø§Ø±ÙˆÚ¯ÙˆØ¦Ù‡",
            "de": "Uruguay",
            "es": "Uruguay",
            "fr": "Uruguay",
            "ja": "ã‚¦ãƒ«ã‚°ã‚¢ã‚¤",
            "it": "Uruguay",
            "cn": "ä¹Œæ‹‰åœ­"
        },
        "latitude": "-33.00000000",
        "longitude": "-56.00000000",
        "emoji": "ðŸ‡ºðŸ‡¾",
        "emojiU": "U+1F1FA U+1F1FE",
        "states": [
            {
                "id": 3205,
                "name": "Artigas Department",
                "state_code": "AR",
                "latitude": "-30.61751120",
                "longitude": "-56.95945590"
            },
            {
                "id": 3213,
                "name": "Canelones Department",
                "state_code": "CA",
                "latitude": "-34.54087170",
                "longitude": "-55.93076000"
            },
            {
                "id": 3211,
                "name": "Cerro Largo Department",
                "state_code": "CL",
                "latitude": "-32.44110320",
                "longitude": "-54.35217530"
            },
            {
                "id": 3208,
                "name": "Colonia Department",
                "state_code": "CO",
                "latitude": "-34.12946780",
                "longitude": "-57.66051840"
            },
            {
                "id": 3209,
                "name": "Durazno Department",
                "state_code": "DU",
                "latitude": "-33.02324540",
                "longitude": "-56.02846440"
            },
            {
                "id": 3203,
                "name": "Flores Department",
                "state_code": "FS",
                "latitude": "-33.57337530",
                "longitude": "-56.89450280"
            },
            {
                "id": 3217,
                "name": "Florida Department",
                "state_code": "FD",
                "latitude": "28.03594950",
                "longitude": "-82.45792890"
            },
            {
                "id": 3215,
                "name": "Lavalleja Department",
                "state_code": "LA",
                "latitude": "-33.92261750",
                "longitude": "-54.97657940"
            },
            {
                "id": 3206,
                "name": "Maldonado Department",
                "state_code": "MA",
                "latitude": "-34.55979320",
                "longitude": "-54.86285520"
            },
            {
                "id": 3218,
                "name": "Montevideo Department",
                "state_code": "MO",
                "latitude": "-34.81815870",
                "longitude": "-56.21382560"
            },
            {
                "id": 3212,
                "name": "PaysandÃº Department",
                "state_code": "PA",
                "latitude": "-32.06673660",
                "longitude": "-57.33647890"
            },
            {
                "id": 3210,
                "name": "RÃ­o Negro Department",
                "state_code": "RN",
                "latitude": "-32.76763560",
                "longitude": "-57.42952070"
            },
            {
                "id": 3207,
                "name": "Rivera Department",
                "state_code": "RV",
                "latitude": "-31.48174210",
                "longitude": "-55.24357590"
            },
            {
                "id": 3216,
                "name": "Rocha Department",
                "state_code": "RO",
                "latitude": "-33.96900810",
                "longitude": "-54.02148500"
            },
            {
                "id": 3220,
                "name": "Salto Department",
                "state_code": "SA",
                "latitude": "-31.38802800",
                "longitude": "-57.96124550"
            },
            {
                "id": 3204,
                "name": "San JosÃ© Department",
                "state_code": "SJ",
                "latitude": "37.34929680",
                "longitude": "-121.90560490"
            },
            {
                "id": 3219,
                "name": "Soriano Department",
                "state_code": "SO",
                "latitude": "-33.51027920",
                "longitude": "-57.74981030"
            },
            {
                "id": 3221,
                "name": "TacuarembÃ³ Department",
                "state_code": "TA",
                "latitude": "-31.72068370",
                "longitude": "-55.98598870"
            },
            {
                "id": 3214,
                "name": "Treinta y Tres Department",
                "state_code": "TT",
                "latitude": "-33.06850860",
                "longitude": "-54.28586270"
            }
        ]
    },
    {
        "name": "Uzbekistan",
        "iso3": "UZB",
        "iso2": "UZ",
        "phone_code": "998",
        "capital": "Tashkent",
        "currency": "UZS",
        "currency_symbol": "Ð»Ð²",
        "tld": ".uz",
        "native": "Oâ€˜zbekiston",
        "region": "Asia",
        "subregion": "Central Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Samarkand",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "UZT",
                "tzName": "Uzbekistan Time"
            },
            {
                "zoneName": "Asia\/Tashkent",
                "gmtOffset": 18000,
                "gmtOffsetName": "UTC+05:00",
                "abbreviation": "UZT",
                "tzName": "Uzbekistan Time"
            }
        ],
        "translations": {
            "kr": "ìš°ì¦ˆë² í‚¤ìŠ¤íƒ„",
            "br": "UzbequistÃ£o",
            "pt": "UsbequistÃ£o",
            "nl": "Oezbekistan",
            "hr": "Uzbekistan",
            "fa": "Ø§Ø²Ø¨Ú©Ø³ØªØ§Ù†",
            "de": "Usbekistan",
            "es": "UzbekistÃ¡n",
            "fr": "OuzbÃ©kistan",
            "ja": "ã‚¦ã‚ºãƒ™ã‚­ã‚¹ã‚¿ãƒ³",
            "it": "Uzbekistan",
            "cn": "ä¹Œå…¹åˆ«å…‹æ–¯å¦"
        },
        "latitude": "41.00000000",
        "longitude": "64.00000000",
        "emoji": "ðŸ‡ºðŸ‡¿",
        "emojiU": "U+1F1FA U+1F1FF",
        "states": [
            {
                "id": 2540,
                "name": "Andijan Region",
                "state_code": "AN",
                "latitude": "40.76859410",
                "longitude": "72.23637900"
            },
            {
                "id": 2541,
                "name": "Bukhara Region",
                "state_code": "BU",
                "latitude": "40.25041620",
                "longitude": "63.20321510"
            },
            {
                "id": 2538,
                "name": "Fergana Region",
                "state_code": "FA",
                "latitude": "40.45680810",
                "longitude": "71.28742090"
            },
            {
                "id": 2545,
                "name": "Jizzakh Region",
                "state_code": "JI",
                "latitude": "40.47064150",
                "longitude": "67.57085360"
            },
            {
                "id": 2548,
                "name": "Karakalpakstan",
                "state_code": "QR",
                "latitude": "43.80413340",
                "longitude": "59.44579880"
            },
            {
                "id": 2537,
                "name": "Namangan Region",
                "state_code": "NG",
                "latitude": "41.05100370",
                "longitude": "71.09731700"
            },
            {
                "id": 2542,
                "name": "Navoiy Region",
                "state_code": "NW",
                "latitude": "42.69885750",
                "longitude": "64.63376850"
            },
            {
                "id": 2543,
                "name": "Qashqadaryo Region",
                "state_code": "QA",
                "latitude": "38.89862310",
                "longitude": "66.04635340"
            },
            {
                "id": 2544,
                "name": "Samarqand Region",
                "state_code": "SA",
                "latitude": "39.62701200",
                "longitude": "66.97497310"
            },
            {
                "id": 2547,
                "name": "Sirdaryo Region",
                "state_code": "SI",
                "latitude": "40.38638080",
                "longitude": "68.71549750"
            },
            {
                "id": 2546,
                "name": "Surxondaryo Region",
                "state_code": "SU",
                "latitude": "37.94090050",
                "longitude": "67.57085360"
            },
            {
                "id": 2536,
                "name": "Tashkent",
                "state_code": "TK",
                "latitude": "41.29949580",
                "longitude": "69.24007340"
            },
            {
                "id": 2549,
                "name": "Tashkent Region",
                "state_code": "TO",
                "latitude": "41.22132340",
                "longitude": "69.85974060"
            },
            {
                "id": 2539,
                "name": "Xorazm Region",
                "state_code": "XO",
                "latitude": "41.35653360",
                "longitude": "60.85666860"
            }
        ]
    },
    {
        "name": "Vanuatu",
        "iso3": "VUT",
        "iso2": "VU",
        "phone_code": "678",
        "capital": "Port Vila",
        "currency": "VUV",
        "currency_symbol": "VT",
        "tld": ".vu",
        "native": "Vanuatu",
        "region": "Oceania",
        "subregion": "Melanesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Efate",
                "gmtOffset": 39600,
                "gmtOffsetName": "UTC+11:00",
                "abbreviation": "VUT",
                "tzName": "Vanuatu Time"
            }
        ],
        "translations": {
            "kr": "ë°”ëˆ„ì•„íˆ¬",
            "br": "Vanuatu",
            "pt": "Vanuatu",
            "nl": "Vanuatu",
            "hr": "Vanuatu",
            "fa": "ÙˆØ§Ù†ÙˆØ§ØªÙˆ",
            "de": "Vanuatu",
            "es": "Vanuatu",
            "fr": "Vanuatu",
            "ja": "ãƒãƒŒã‚¢ãƒ„",
            "it": "Vanuatu",
            "cn": "ç“¦åŠªé˜¿å›¾"
        },
        "latitude": "-16.00000000",
        "longitude": "167.00000000",
        "emoji": "ðŸ‡»ðŸ‡º",
        "emojiU": "U+1F1FB U+1F1FA",
        "states": [
            {
                "id": 4775,
                "name": "Malampa",
                "state_code": "MAP",
                "latitude": "-16.40114050",
                "longitude": "167.60778650"
            },
            {
                "id": 4773,
                "name": "Penama",
                "state_code": "PAM",
                "latitude": "-15.37957580",
                "longitude": "167.90531820"
            },
            {
                "id": 4776,
                "name": "Sanma",
                "state_code": "SAM",
                "latitude": "-15.48400170",
                "longitude": "166.91820970"
            },
            {
                "id": 4774,
                "name": "Shefa",
                "state_code": "SEE",
                "latitude": "32.80576500",
                "longitude": "35.16997100"
            },
            {
                "id": 4777,
                "name": "Tafea",
                "state_code": "TAE",
                "latitude": "-18.72378270",
                "longitude": "169.06450560"
            },
            {
                "id": 4772,
                "name": "Torba",
                "state_code": "TOB",
                "latitude": "37.07653000",
                "longitude": "27.45657300"
            }
        ]
    },
    {
        "name": "Vatican City State (Holy See)",
        "iso3": "VAT",
        "iso2": "VA",
        "phone_code": "379",
        "capital": "Vatican City",
        "currency": "EUR",
        "currency_symbol": "â‚¬",
        "tld": ".va",
        "native": "Vaticano",
        "region": "Europe",
        "subregion": "Southern Europe",
        "timezones": [
            {
                "zoneName": "Europe\/Vatican",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "CET",
                "tzName": "Central European Time"
            }
        ],
        "translations": {
            "kr": "ë°”í‹°ì¹¸ ì‹œêµ­",
            "br": "Vaticano",
            "pt": "Vaticano",
            "nl": "Heilige Stoel",
            "hr": "Sveta Stolica",
            "fa": "Ø³Ø±ÛŒØ± Ù…Ù‚Ø¯Ø³",
            "de": "Heiliger Stuhl",
            "es": "Santa Sede",
            "fr": "voir Saint",
            "ja": "è–åº§",
            "it": "Santa Sede",
            "cn": "æ¢µè’‚å†ˆ"
        },
        "latitude": "41.90000000",
        "longitude": "12.45000000",
        "emoji": "ðŸ‡»ðŸ‡¦",
        "emojiU": "U+1F1FB U+1F1E6",
        "states": []
    },
    {
        "name": "Venezuela",
        "iso3": "VEN",
        "iso2": "VE",
        "phone_code": "58",
        "capital": "Caracas",
        "currency": "VEF",
        "currency_symbol": "Bs",
        "tld": ".ve",
        "native": "Venezuela",
        "region": "Americas",
        "subregion": "South America",
        "timezones": [
            {
                "zoneName": "America\/Caracas",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "VET",
                "tzName": "Venezuelan Standard Time"
            }
        ],
        "translations": {
            "kr": "ë² ë„¤ìˆ˜ì—˜ë¼",
            "br": "Venezuela",
            "pt": "Venezuela",
            "nl": "Venezuela",
            "hr": "Venezuela",
            "fa": "ÙˆÙ†Ø²ÙˆØ¦Ù„Ø§",
            "de": "Venezuela",
            "es": "Venezuela",
            "fr": "Venezuela",
            "ja": "ãƒ™ãƒã‚ºã‚¨ãƒ©ãƒ»ãƒœãƒªãƒãƒ«å…±å’Œå›½",
            "it": "Venezuela",
            "cn": "å§”å†…ç‘žæ‹‰"
        },
        "latitude": "8.00000000",
        "longitude": "-66.00000000",
        "emoji": "ðŸ‡»ðŸ‡ª",
        "emojiU": "U+1F1FB U+1F1EA",
        "states": [
            {
                "id": 2044,
                "name": "Amazonas",
                "state_code": "Z",
                "latitude": "-3.41684270",
                "longitude": "-65.85606460"
            },
            {
                "id": 2050,
                "name": "AnzoÃ¡tegui",
                "state_code": "B",
                "latitude": "8.59130730",
                "longitude": "-63.95861110"
            },
            {
                "id": 4856,
                "name": "Apure",
                "state_code": "C",
                "latitude": "6.92694830",
                "longitude": "-68.52471490"
            },
            {
                "id": 2047,
                "name": "Aragua",
                "state_code": "D",
                "latitude": "10.06357580",
                "longitude": "-67.28478750"
            },
            {
                "id": 2049,
                "name": "Barinas",
                "state_code": "E",
                "latitude": "8.62314980",
                "longitude": "-70.23710450"
            },
            {
                "id": 2039,
                "name": "BolÃ­var",
                "state_code": "F",
                "latitude": "37.61448380",
                "longitude": "-93.41047490"
            },
            {
                "id": 4855,
                "name": "Capital District",
                "state_code": "A",
                "latitude": "41.26148460",
                "longitude": "-95.93108070"
            },
            {
                "id": 2040,
                "name": "Carabobo",
                "state_code": "G",
                "latitude": "10.11764330",
                "longitude": "-68.04775090"
            },
            {
                "id": 2034,
                "name": "Cojedes",
                "state_code": "H",
                "latitude": "9.38166820",
                "longitude": "-68.33392750"
            },
            {
                "id": 2051,
                "name": "Delta Amacuro",
                "state_code": "Y",
                "latitude": "8.84993070",
                "longitude": "-61.14031960"
            },
            {
                "id": 2035,
                "name": "FalcÃ³n",
                "state_code": "I",
                "latitude": "11.18106740",
                "longitude": "-69.85974060"
            },
            {
                "id": 2046,
                "name": "Federal Dependencies of Venezuela",
                "state_code": "W",
                "latitude": "10.93770530",
                "longitude": "-65.35695730"
            },
            {
                "id": 2045,
                "name": "GuÃ¡rico",
                "state_code": "J",
                "latitude": "8.74893090",
                "longitude": "-66.23671720"
            },
            {
                "id": 2038,
                "name": "Lara",
                "state_code": "K",
                "latitude": "33.98221650",
                "longitude": "-118.13227470"
            },
            {
                "id": 2053,
                "name": "MÃ©rida",
                "state_code": "L",
                "latitude": "20.96737020",
                "longitude": "-89.59258570"
            },
            {
                "id": 2037,
                "name": "Miranda",
                "state_code": "M",
                "latitude": "42.35193830",
                "longitude": "-71.52907660"
            },
            {
                "id": 2054,
                "name": "Monagas",
                "state_code": "N",
                "latitude": "9.32416520",
                "longitude": "-63.01475780"
            },
            {
                "id": 2052,
                "name": "Nueva Esparta",
                "state_code": "O",
                "latitude": "10.99707230",
                "longitude": "-63.91132960"
            },
            {
                "id": 2036,
                "name": "Portuguesa",
                "state_code": "P",
                "latitude": "9.09439990",
                "longitude": "-69.09702300"
            },
            {
                "id": 2056,
                "name": "Sucre",
                "state_code": "R",
                "latitude": "-19.03534500",
                "longitude": "-65.25921280"
            },
            {
                "id": 2048,
                "name": "TÃ¡chira",
                "state_code": "S",
                "latitude": "7.91370010",
                "longitude": "-72.14161320"
            },
            {
                "id": 2043,
                "name": "Trujillo",
                "state_code": "T",
                "latitude": "36.67343430",
                "longitude": "-121.62875880"
            },
            {
                "id": 2055,
                "name": "Vargas",
                "state_code": "X",
                "latitude": "29.30522680",
                "longitude": "-94.79138540"
            },
            {
                "id": 2041,
                "name": "Yaracuy",
                "state_code": "U",
                "latitude": "10.33938900",
                "longitude": "-68.81088490"
            },
            {
                "id": 2042,
                "name": "Zulia",
                "state_code": "V",
                "latitude": "10.29102370",
                "longitude": "-72.14161320"
            }
        ]
    },
    {
        "name": "Vietnam",
        "iso3": "VNM",
        "iso2": "VN",
        "phone_code": "84",
        "capital": "Hanoi",
        "currency": "VND",
        "currency_symbol": "â‚«",
        "tld": ".vn",
        "native": "Viá»‡t Nam",
        "region": "Asia",
        "subregion": "South-Eastern Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Ho_Chi_Minh",
                "gmtOffset": 25200,
                "gmtOffsetName": "UTC+07:00",
                "abbreviation": "ICT",
                "tzName": "Indochina Time"
            }
        ],
        "translations": {
            "kr": "ë² íŠ¸ë‚¨",
            "br": "VietnÃ£",
            "pt": "Vietname",
            "nl": "Vietnam",
            "hr": "Vijetnam",
            "fa": "ÙˆÛŒØªÙ†Ø§Ù…",
            "de": "Vietnam",
            "es": "Vietnam",
            "fr": "ViÃªt Nam",
            "ja": "ãƒ™ãƒˆãƒŠãƒ ",
            "it": "Vietnam",
            "cn": "è¶Šå—"
        },
        "latitude": "16.16666666",
        "longitude": "107.83333333",
        "emoji": "ðŸ‡»ðŸ‡³",
        "emojiU": "U+1F1FB U+1F1F3",
        "states": [
            {
                "id": 3794,
                "name": "An Giang",
                "state_code": "44",
                "latitude": "10.52158360",
                "longitude": "105.12589550"
            },
            {
                "id": 3770,
                "name": "BÃ  Rá»‹a-VÅ©ng TÃ u",
                "state_code": "43",
                "latitude": "10.54173970",
                "longitude": "107.24299760"
            },
            {
                "id": 3815,
                "name": "Báº¯c Giang",
                "state_code": "54",
                "latitude": "21.28199210",
                "longitude": "106.19747690"
            },
            {
                "id": 3822,
                "name": "Báº¯c Káº¡n",
                "state_code": "53",
                "latitude": "22.30329230",
                "longitude": "105.87600400"
            },
            {
                "id": 3804,
                "name": "Báº¡c LiÃªu",
                "state_code": "55",
                "latitude": "9.29400270",
                "longitude": "105.72156630"
            },
            {
                "id": 3791,
                "name": "Báº¯c Ninh",
                "state_code": "56",
                "latitude": "21.12144400",
                "longitude": "106.11105010"
            },
            {
                "id": 3796,
                "name": "Báº¿n Tre",
                "state_code": "50",
                "latitude": "10.24335560",
                "longitude": "106.37555100"
            },
            {
                "id": 3785,
                "name": "BÃ¬nh DÆ°Æ¡ng",
                "state_code": "57",
                "latitude": "11.32540240",
                "longitude": "106.47701700"
            },
            {
                "id": 3830,
                "name": "BÃ¬nh Äá»‹nh",
                "state_code": "31",
                "latitude": "14.16653240",
                "longitude": "108.90268300"
            },
            {
                "id": 3797,
                "name": "BÃ¬nh PhÆ°á»›c",
                "state_code": "58",
                "latitude": "11.75118940",
                "longitude": "106.72346390"
            },
            {
                "id": 3787,
                "name": "BÃ¬nh Thuáº­n",
                "state_code": "40",
                "latitude": "11.09037030",
                "longitude": "108.07207810"
            },
            {
                "id": 3778,
                "name": "CÃ  Mau",
                "state_code": "59",
                "latitude": "9.15267280",
                "longitude": "105.19607950"
            },
            {
                "id": 4925,
                "name": "Cáº§n ThÆ¡",
                "state_code": "CT",
                "latitude": "10.03418510",
                "longitude": "105.72255070"
            },
            {
                "id": 3782,
                "name": "Cao Báº±ng",
                "state_code": "04",
                "latitude": "22.63568900",
                "longitude": "106.25221430"
            },
            {
                "id": 3806,
                "name": "ÄÃ  Náºµng",
                "state_code": "DN",
                "latitude": "16.05440680",
                "longitude": "108.20216670"
            },
            {
                "id": 3829,
                "name": "Äáº¯k Láº¯k",
                "state_code": "33",
                "latitude": "12.71001160",
                "longitude": "108.23775190"
            },
            {
                "id": 3823,
                "name": "Äáº¯k NÃ´ng",
                "state_code": "72",
                "latitude": "12.26464760",
                "longitude": "107.60980600"
            },
            {
                "id": 3773,
                "name": "Äiá»‡n BiÃªn",
                "state_code": "71",
                "latitude": "21.80423090",
                "longitude": "103.10765250"
            },
            {
                "id": 3821,
                "name": "Äá»“ng Nai",
                "state_code": "39",
                "latitude": "11.06863050",
                "longitude": "107.16759760"
            },
            {
                "id": 3769,
                "name": "Äá»“ng ThÃ¡p",
                "state_code": "45",
                "latitude": "10.49379890",
                "longitude": "105.68817880"
            },
            {
                "id": 3813,
                "name": "Gia Lai",
                "state_code": "30",
                "latitude": "13.80789430",
                "longitude": "108.10937500"
            },
            {
                "id": 3779,
                "name": "HÃ  Giang",
                "state_code": "03",
                "latitude": "22.80255880",
                "longitude": "104.97844940"
            },
            {
                "id": 3802,
                "name": "HÃ  Nam",
                "state_code": "63",
                "latitude": "20.58351960",
                "longitude": "105.92299000"
            },
            {
                "id": 3810,
                "name": "HÃ  Ná»™i",
                "state_code": "HN",
                "latitude": "21.02776440",
                "longitude": "105.83415980"
            },
            {
                "id": 3816,
                "name": "HÃ  TÄ©nh",
                "state_code": "23",
                "latitude": "18.35595370",
                "longitude": "105.88774940"
            },
            {
                "id": 3827,
                "name": "Háº£i DÆ°Æ¡ng",
                "state_code": "61",
                "latitude": "20.93734130",
                "longitude": "106.31455420"
            },
            {
                "id": 3783,
                "name": "Háº£i PhÃ²ng",
                "state_code": "HP",
                "latitude": "20.84491150",
                "longitude": "106.68808410"
            },
            {
                "id": 3777,
                "name": "Háº­u Giang",
                "state_code": "73",
                "latitude": "9.75789800",
                "longitude": "105.64125270"
            },
            {
                "id": 3811,
                "name": "Há»“ ChÃ­ Minh",
                "state_code": "SG",
                "latitude": "10.82309890",
                "longitude": "106.62966380"
            },
            {
                "id": 3799,
                "name": "HÃ²a BÃ¬nh",
                "state_code": "14",
                "latitude": "20.68612650",
                "longitude": "105.31311850"
            },
            {
                "id": 3768,
                "name": "HÆ°ng YÃªn",
                "state_code": "66",
                "latitude": "20.85257110",
                "longitude": "106.01699710"
            },
            {
                "id": 3793,
                "name": "KhÃ¡nh HÃ²a",
                "state_code": "34",
                "latitude": "12.25850980",
                "longitude": "109.05260760"
            },
            {
                "id": 3800,
                "name": "KiÃªn Giang",
                "state_code": "47",
                "latitude": "9.82495870",
                "longitude": "105.12589550"
            },
            {
                "id": 3772,
                "name": "Kon Tum",
                "state_code": "28",
                "latitude": "14.34974030",
                "longitude": "108.00046060"
            },
            {
                "id": 3825,
                "name": "Lai ChÃ¢u",
                "state_code": "01",
                "latitude": "22.38622270",
                "longitude": "103.47026310"
            },
            {
                "id": 3818,
                "name": "LÃ¢m Äá»“ng",
                "state_code": "35",
                "latitude": "11.57527910",
                "longitude": "108.14286690"
            },
            {
                "id": 3792,
                "name": "Láº¡ng SÆ¡n",
                "state_code": "09",
                "latitude": "21.85370800",
                "longitude": "106.76151900"
            },
            {
                "id": 3817,
                "name": "LÃ o Cai",
                "state_code": "02",
                "latitude": "22.48094310",
                "longitude": "103.97549590"
            },
            {
                "id": 3808,
                "name": "Long An",
                "state_code": "41",
                "latitude": "10.56071680",
                "longitude": "106.64976230"
            },
            {
                "id": 3789,
                "name": "Nam Äá»‹nh",
                "state_code": "67",
                "latitude": "20.43882250",
                "longitude": "106.16210530"
            },
            {
                "id": 3780,
                "name": "Nghá»‡ An",
                "state_code": "22",
                "latitude": "19.23424890",
                "longitude": "104.92003650"
            },
            {
                "id": 3786,
                "name": "Ninh BÃ¬nh",
                "state_code": "18",
                "latitude": "20.25061490",
                "longitude": "105.97445360"
            },
            {
                "id": 3788,
                "name": "Ninh Thuáº­n",
                "state_code": "36",
                "latitude": "11.67387670",
                "longitude": "108.86295720"
            },
            {
                "id": 3801,
                "name": "PhÃº Thá»",
                "state_code": "68",
                "latitude": "21.26844300",
                "longitude": "105.20455730"
            },
            {
                "id": 3824,
                "name": "PhÃº YÃªn",
                "state_code": "32",
                "latitude": "13.08818610",
                "longitude": "109.09287640"
            },
            {
                "id": 3809,
                "name": "Quáº£ng BÃ¬nh",
                "state_code": "24",
                "latitude": "17.61027150",
                "longitude": "106.34874740"
            },
            {
                "id": 3776,
                "name": "Quáº£ng Nam",
                "state_code": "27",
                "latitude": "15.53935380",
                "longitude": "108.01910200"
            },
            {
                "id": 3828,
                "name": "Quáº£ng NgÃ£i",
                "state_code": "29",
                "latitude": "15.12138730",
                "longitude": "108.80441450"
            },
            {
                "id": 3814,
                "name": "Quáº£ng Ninh",
                "state_code": "13",
                "latitude": "21.00638200",
                "longitude": "107.29251440"
            },
            {
                "id": 3803,
                "name": "Quáº£ng Trá»‹",
                "state_code": "25",
                "latitude": "16.74030740",
                "longitude": "107.18546790"
            },
            {
                "id": 3819,
                "name": "SÃ³c TrÄƒng",
                "state_code": "52",
                "latitude": "9.60252100",
                "longitude": "105.97390490"
            },
            {
                "id": 3812,
                "name": "SÆ¡n La",
                "state_code": "05",
                "latitude": "21.10222840",
                "longitude": "103.72891670"
            },
            {
                "id": 3826,
                "name": "TÃ¢y Ninh",
                "state_code": "37",
                "latitude": "11.33515540",
                "longitude": "106.10988540"
            },
            {
                "id": 3775,
                "name": "ThÃ¡i BÃ¬nh",
                "state_code": "20",
                "latitude": "20.44634710",
                "longitude": "106.33658280"
            },
            {
                "id": 3807,
                "name": "ThÃ¡i NguyÃªn",
                "state_code": "69",
                "latitude": "21.56715590",
                "longitude": "105.82520380"
            },
            {
                "id": 3771,
                "name": "Thanh HÃ³a",
                "state_code": "21",
                "latitude": "19.80669200",
                "longitude": "105.78518160"
            },
            {
                "id": 3798,
                "name": "Thá»«a ThiÃªn-Huáº¿",
                "state_code": "26",
                "latitude": "16.46739700",
                "longitude": "107.59053260"
            },
            {
                "id": 3781,
                "name": "Tiá»n Giang",
                "state_code": "46",
                "latitude": "10.44933240",
                "longitude": "106.34205040"
            },
            {
                "id": 3805,
                "name": "TrÃ  Vinh",
                "state_code": "51",
                "latitude": "9.81274100",
                "longitude": "106.29929120"
            },
            {
                "id": 3795,
                "name": "TuyÃªn Quang",
                "state_code": "07",
                "latitude": "21.77672460",
                "longitude": "105.22801960"
            },
            {
                "id": 3790,
                "name": "VÄ©nh Long",
                "state_code": "49",
                "latitude": "10.23957400",
                "longitude": "105.95719280"
            },
            {
                "id": 3774,
                "name": "VÄ©nh PhÃºc",
                "state_code": "70",
                "latitude": "21.36088050",
                "longitude": "105.54743730"
            },
            {
                "id": 3784,
                "name": "YÃªn BÃ¡i",
                "state_code": "06",
                "latitude": "21.71676890",
                "longitude": "104.89858780"
            }
        ]
    },
    {
        "name": "Virgin Islands (British)",
        "iso3": "VGB",
        "iso2": "VG",
        "phone_code": "+1-284",
        "capital": "Road Town",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".vg",
        "native": "British Virgin Islands",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/Tortola",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ì˜êµ­ë ¹ ë²„ì§„ì•„ì¼ëžœë“œ",
            "br": "Ilhas Virgens BritÃ¢nicas",
            "pt": "Ilhas Virgens BritÃ¢nicas",
            "nl": "Britse Maagdeneilanden",
            "hr": "Britanski DjeviÄanski Otoci",
            "fa": "Ø¬Ø²Ø§ÛŒØ± ÙˆÛŒØ±Ø¬ÛŒÙ† Ø¨Ø±ÛŒØªØ§Ù†ÛŒØ§",
            "de": "Britische Jungferninseln",
            "es": "Islas VÃ­rgenes del Reino Unido",
            "fr": "ÃŽles Vierges britanniques",
            "ja": "ã‚¤ã‚®ãƒªã‚¹é ˜ãƒ´ã‚¡ãƒ¼ã‚¸ãƒ³è«¸å³¶",
            "it": "Isole Vergini Britanniche",
            "cn": "åœ£æ–‡æ£®ç‰¹å’Œæ ¼æž—çº³ä¸æ–¯"
        },
        "latitude": "18.43138300",
        "longitude": "-64.62305000",
        "emoji": "ðŸ‡»ðŸ‡¬",
        "emojiU": "U+1F1FB U+1F1EC",
        "states": []
    },
    {
        "name": "Virgin Islands (US)",
        "iso3": "VIR",
        "iso2": "VI",
        "phone_code": "+1-340",
        "capital": "Charlotte Amalie",
        "currency": "USD",
        "currency_symbol": "$",
        "tld": ".vi",
        "native": "United States Virgin Islands",
        "region": "Americas",
        "subregion": "Caribbean",
        "timezones": [
            {
                "zoneName": "America\/St_Thomas",
                "gmtOffset": -14400,
                "gmtOffsetName": "UTC-04:00",
                "abbreviation": "AST",
                "tzName": "Atlantic Standard Time"
            }
        ],
        "translations": {
            "kr": "ë¯¸êµ­ë ¹ ë²„ì§„ì•„ì¼ëžœë“œ",
            "br": "Ilhas Virgens Americanas",
            "pt": "Ilhas Virgens Americanas",
            "nl": "Verenigde Staten Maagdeneilanden",
            "fa": "Ø¬Ø²Ø§ÛŒØ± ÙˆÛŒØ±Ø¬ÛŒÙ† Ø¢Ù…Ø±ÛŒÚ©Ø§",
            "de": "Amerikanische Jungferninseln",
            "es": "Islas VÃ­rgenes de los Estados Unidos",
            "fr": "ÃŽles Vierges des Ã‰tats-Unis",
            "ja": "ã‚¢ãƒ¡ãƒªã‚«é ˜ãƒ´ã‚¡ãƒ¼ã‚¸ãƒ³è«¸å³¶",
            "it": "Isole Vergini americane",
            "cn": "ç»´å°”äº¬ç¾¤å²›ï¼ˆç¾Žå›½ï¼‰"
        },
        "latitude": "18.34000000",
        "longitude": "-64.93000000",
        "emoji": "ðŸ‡»ðŸ‡®",
        "emojiU": "U+1F1FB U+1F1EE",
        "states": []
    },
    {
        "name": "Wallis And Futuna Islands",
        "iso3": "WLF",
        "iso2": "WF",
        "phone_code": "681",
        "capital": "Mata Utu",
        "currency": "XPF",
        "currency_symbol": "â‚£",
        "tld": ".wf",
        "native": "Wallis et Futuna",
        "region": "Oceania",
        "subregion": "Polynesia",
        "timezones": [
            {
                "zoneName": "Pacific\/Wallis",
                "gmtOffset": 43200,
                "gmtOffsetName": "UTC+12:00",
                "abbreviation": "WFT",
                "tzName": "Wallis & Futuna Time"
            }
        ],
        "translations": {
            "kr": "ì™ˆë¦¬ìŠ¤ í‘¸íˆ¬ë‚˜",
            "br": "Wallis e Futuna",
            "pt": "Wallis e Futuna",
            "nl": "Wallis en Futuna",
            "hr": "Wallis i Fortuna",
            "fa": "ÙˆØ§Ù„ÛŒØ³ Ùˆ ÙÙˆØªÙˆÙ†Ø§",
            "de": "Wallis und Futuna",
            "es": "Wallis y Futuna",
            "fr": "Wallis-et-Futuna",
            "ja": "ã‚¦ã‚©ãƒªã‚¹ãƒ»ãƒ•ãƒ„ãƒŠ",
            "it": "Wallis e Futuna",
            "cn": "ç“¦åˆ©æ–¯ç¾¤å²›å’Œå¯Œå›¾çº³ç¾¤å²›"
        },
        "latitude": "-13.30000000",
        "longitude": "-176.20000000",
        "emoji": "ðŸ‡¼ðŸ‡«",
        "emojiU": "U+1F1FC U+1F1EB",
        "states": []
    },
    {
        "name": "Western Sahara",
        "iso3": "ESH",
        "iso2": "EH",
        "phone_code": "212",
        "capital": "El-Aaiun",
        "currency": "MAD",
        "currency_symbol": "MAD",
        "tld": ".eh",
        "native": "Ø§Ù„ØµØ­Ø±Ø§Ø¡ Ø§Ù„ØºØ±Ø¨ÙŠØ©",
        "region": "Africa",
        "subregion": "Northern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/El_Aaiun",
                "gmtOffset": 3600,
                "gmtOffsetName": "UTC+01:00",
                "abbreviation": "WEST",
                "tzName": "Western European Summer Time"
            }
        ],
        "translations": {
            "kr": "ì„œì‚¬í•˜ë¼",
            "br": "Saara Ocidental",
            "pt": "Saara Ocidental",
            "nl": "Westelijke Sahara",
            "hr": "Zapadna Sahara",
            "fa": "Ø¬Ù…Ù‡ÙˆØ±ÛŒ Ø¯Ù…ÙˆÚ©Ø±Ø§ØªÛŒÚ© Ø¹Ø±Ø¨ÛŒ ØµØ­Ø±Ø§",
            "de": "Westsahara",
            "es": "Sahara Occidental",
            "fr": "Sahara Occidental",
            "ja": "è¥¿ã‚µãƒãƒ©",
            "it": "Sahara Occidentale",
            "cn": "è¥¿æ’’å“ˆæ‹‰"
        },
        "latitude": "24.50000000",
        "longitude": "-13.00000000",
        "emoji": "ðŸ‡ªðŸ‡­",
        "emojiU": "U+1F1EA U+1F1ED",
        "states": []
    },
    {
        "name": "Yemen",
        "iso3": "YEM",
        "iso2": "YE",
        "phone_code": "967",
        "capital": "Sanaa",
        "currency": "YER",
        "currency_symbol": "ï·¼",
        "tld": ".ye",
        "native": "Ø§Ù„ÙŠÙŽÙ…ÙŽÙ†",
        "region": "Asia",
        "subregion": "Western Asia",
        "timezones": [
            {
                "zoneName": "Asia\/Aden",
                "gmtOffset": 10800,
                "gmtOffsetName": "UTC+03:00",
                "abbreviation": "AST",
                "tzName": "Arabia Standard Time"
            }
        ],
        "translations": {
            "kr": "ì˜ˆë©˜",
            "br": "IÃªmen",
            "pt": "IÃ©men",
            "nl": "Jemen",
            "hr": "Jemen",
            "fa": "ÛŒÙ…Ù†",
            "de": "Jemen",
            "es": "Yemen",
            "fr": "YÃ©men",
            "ja": "ã‚¤ã‚¨ãƒ¡ãƒ³",
            "it": "Yemen",
            "cn": "ä¹Ÿé—¨"
        },
        "latitude": "15.00000000",
        "longitude": "48.00000000",
        "emoji": "ðŸ‡¾ðŸ‡ª",
        "emojiU": "U+1F1FE U+1F1EA",
        "states": [
            {
                "id": 1242,
                "name": "'Adan Governorate",
                "state_code": "AD",
                "latitude": "12.82574810",
                "longitude": "44.79438040"
            },
            {
                "id": 1250,
                "name": "'Amran Governorate",
                "state_code": "AM",
                "latitude": "16.25692140",
                "longitude": "43.94367880"
            },
            {
                "id": 1237,
                "name": "Abyan Governorate",
                "state_code": "AB",
                "latitude": "13.63434130",
                "longitude": "46.05632120"
            },
            {
                "id": 1240,
                "name": "Al Bayda' Governorate",
                "state_code": "BA",
                "latitude": "14.35886620",
                "longitude": "45.44980650"
            },
            {
                "id": 1241,
                "name": "Al Hudaydah Governorate",
                "state_code": "HU",
                "latitude": "15.30530720",
                "longitude": "43.01948970"
            },
            {
                "id": 1243,
                "name": "Al Jawf Governorate",
                "state_code": "JA",
                "latitude": "16.79018190",
                "longitude": "45.29938620"
            },
            {
                "id": 1251,
                "name": "Al Mahrah Governorate",
                "state_code": "MR",
                "latitude": "16.52384230",
                "longitude": "51.68342750"
            },
            {
                "id": 1235,
                "name": "Al Mahwit Governorate",
                "state_code": "MW",
                "latitude": "15.39632290",
                "longitude": "43.56069460"
            },
            {
                "id": 1246,
                "name": "Dhamar Governorate",
                "state_code": "DH",
                "latitude": "14.71953440",
                "longitude": "44.24790150"
            },
            {
                "id": 1238,
                "name": "Hadhramaut Governorate",
                "state_code": "HD",
                "latitude": "16.93041350",
                "longitude": "49.36531490"
            },
            {
                "id": 1244,
                "name": "Hajjah Governorate",
                "state_code": "HJ",
                "latitude": "16.11806310",
                "longitude": "43.32946600"
            },
            {
                "id": 1233,
                "name": "Ibb Governorate",
                "state_code": "IB",
                "latitude": "14.14157170",
                "longitude": "44.24790150"
            },
            {
                "id": 1245,
                "name": "Lahij Governorate",
                "state_code": "LA",
                "latitude": "13.14895880",
                "longitude": "44.85054950"
            },
            {
                "id": 1234,
                "name": "Ma'rib Governorate",
                "state_code": "MA",
                "latitude": "15.51588800",
                "longitude": "45.44980650"
            },
            {
                "id": 1248,
                "name": "Raymah Governorate",
                "state_code": "RA",
                "latitude": "14.62776820",
                "longitude": "43.71424840"
            },
            {
                "id": 1249,
                "name": "Saada Governorate",
                "state_code": "SD",
                "latitude": "16.84765280",
                "longitude": "43.94367880"
            },
            {
                "id": 1232,
                "name": "Sana'a",
                "state_code": "SA",
                "latitude": "15.36944510",
                "longitude": "44.19100660"
            },
            {
                "id": 1236,
                "name": "Sana'a Governorate",
                "state_code": "SN",
                "latitude": "15.31689130",
                "longitude": "44.47480180"
            },
            {
                "id": 1247,
                "name": "Shabwah Governorate",
                "state_code": "SH",
                "latitude": "14.75463030",
                "longitude": "46.51626200"
            },
            {
                "id": 1239,
                "name": "Socotra Governorate",
                "state_code": "SU",
                "latitude": "12.46342050",
                "longitude": "53.82373850"
            },
            {
                "id": 1231,
                "name": "Ta'izz Governorate",
                "state_code": "TA",
                "latitude": "13.57758860",
                "longitude": "44.01779890"
            }
        ]
    },
    {
        "name": "Zambia",
        "iso3": "ZMB",
        "iso2": "ZM",
        "phone_code": "260",
        "capital": "Lusaka",
        "currency": "ZMW",
        "currency_symbol": "ZK",
        "tld": ".zm",
        "native": "Zambia",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Lusaka",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ìž ë¹„ì•„",
            "br": "ZÃ¢mbia",
            "pt": "ZÃ¢mbia",
            "nl": "Zambia",
            "hr": "Zambija",
            "fa": "Ø²Ø§Ù…Ø¨ÛŒØ§",
            "de": "Sambia",
            "es": "Zambia",
            "fr": "Zambie",
            "ja": "ã‚¶ãƒ³ãƒ“ã‚¢",
            "it": "Zambia",
            "cn": "èµžæ¯”äºš"
        },
        "latitude": "-15.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡¿ðŸ‡²",
        "emojiU": "U+1F1FF U+1F1F2",
        "states": [
            {
                "id": 1986,
                "name": "Central Province",
                "state_code": "02",
                "latitude": "7.25649960",
                "longitude": "80.72144170"
            },
            {
                "id": 1984,
                "name": "Copperbelt Province",
                "state_code": "08",
                "latitude": "-13.05700730",
                "longitude": "27.54958460"
            },
            {
                "id": 1991,
                "name": "Eastern Province",
                "state_code": "03",
                "latitude": "23.16696880",
                "longitude": "49.36531490"
            },
            {
                "id": 1987,
                "name": "Luapula Province",
                "state_code": "04",
                "latitude": "-11.56483100",
                "longitude": "29.04599270"
            },
            {
                "id": 1988,
                "name": "Lusaka Province",
                "state_code": "09",
                "latitude": "-15.36571290",
                "longitude": "29.23207840"
            },
            {
                "id": 1989,
                "name": "Muchinga Province",
                "state_code": "10",
                "latitude": "-15.38219300",
                "longitude": "28.26158000"
            },
            {
                "id": 1982,
                "name": "Northern Province",
                "state_code": "05",
                "latitude": "8.88550270",
                "longitude": "80.27673270"
            },
            {
                "id": 1985,
                "name": "Northwestern Province",
                "state_code": "06",
                "latitude": "-13.00502580",
                "longitude": "24.90422080"
            },
            {
                "id": 1990,
                "name": "Southern Province",
                "state_code": "07",
                "latitude": "6.23737500",
                "longitude": "80.54384500"
            },
            {
                "id": 1983,
                "name": "Western Province",
                "state_code": "01",
                "latitude": "6.90160860",
                "longitude": "80.00877460"
            }
        ]
    },
    {
        "name": "Zimbabwe",
        "iso3": "ZWE",
        "iso2": "ZW",
        "phone_code": "263",
        "capital": "Harare",
        "currency": "ZWL",
        "currency_symbol": "$",
        "tld": ".zw",
        "native": "Zimbabwe",
        "region": "Africa",
        "subregion": "Eastern Africa",
        "timezones": [
            {
                "zoneName": "Africa\/Harare",
                "gmtOffset": 7200,
                "gmtOffsetName": "UTC+02:00",
                "abbreviation": "CAT",
                "tzName": "Central Africa Time"
            }
        ],
        "translations": {
            "kr": "ì§ë°”ë¸Œì›¨",
            "br": "Zimbabwe",
            "pt": "ZimbabuÃ©",
            "nl": "Zimbabwe",
            "hr": "Zimbabve",
            "fa": "Ø²ÛŒÙ…Ø¨Ø§ÙˆÙ‡",
            "de": "Simbabwe",
            "es": "Zimbabue",
            "fr": "Zimbabwe",
            "ja": "ã‚¸ãƒ³ãƒãƒ–ã‚¨",
            "it": "Zimbabwe",
            "cn": "æ´¥å·´å¸ƒéŸ¦"
        },
        "latitude": "-20.00000000",
        "longitude": "30.00000000",
        "emoji": "ðŸ‡¿ðŸ‡¼",
        "emojiU": "U+1F1FF U+1F1FC",
        "states": [
            {
                "id": 1956,
                "name": "Bulawayo Province",
                "state_code": "BU",
                "latitude": "-20.14895050",
                "longitude": "28.53310380"
            },
            {
                "id": 1958,
                "name": "Harare Province",
                "state_code": "HA",
                "latitude": "-17.82162880",
                "longitude": "31.04922590"
            },
            {
                "id": 1959,
                "name": "Manicaland",
                "state_code": "MA",
                "latitude": "-18.92163860",
                "longitude": "32.17460500"
            },
            {
                "id": 1955,
                "name": "Mashonaland Central Province",
                "state_code": "MC",
                "latitude": "-16.76442950",
                "longitude": "31.07937050"
            },
            {
                "id": 1951,
                "name": "Mashonaland East Province",
                "state_code": "ME",
                "latitude": "-18.58716420",
                "longitude": "31.26263660"
            },
            {
                "id": 1953,
                "name": "Mashonaland West Province",
                "state_code": "MW",
                "latitude": "-17.48510290",
                "longitude": "29.78892480"
            },
            {
                "id": 1960,
                "name": "Masvingo Province",
                "state_code": "MV",
                "latitude": "-20.62415090",
                "longitude": "31.26263660"
            },
            {
                "id": 1954,
                "name": "Matabeleland North Province",
                "state_code": "MN",
                "latitude": "-18.53315660",
                "longitude": "27.54958460"
            },
            {
                "id": 1952,
                "name": "Matabeleland South Province",
                "state_code": "MS",
                "latitude": "-21.05233700",
                "longitude": "29.04599270"
            },
            {
                "id": 1957,
                "name": "Midlands Province",
                "state_code": "MI",
                "latitude": "-19.05520090",
                "longitude": "29.60354950"
            }
        ]
    }
]